var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    "use strict";
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        [
          "ary",
          WRAP_ARY_FLAG
        ],
        [
          "bind",
          WRAP_BIND_FLAG
        ],
        [
          "bindKey",
          WRAP_BIND_KEY_FLAG
        ],
        [
          "curry",
          WRAP_CURRY_FLAG
        ],
        [
          "curryRight",
          WRAP_CURRY_RIGHT_FLAG
        ],
        [
          "flip",
          WRAP_FLIP_FLAG
        ],
        [
          "partial",
          WRAP_PARTIAL_FLAG
        ],
        [
          "partialRight",
          WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
          "rearg",
          WRAP_REARG_FLAG
        ]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
      ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
      ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
      ].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
          rsBreak,
          rsUpper,
          "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
          rsBreak,
          rsUpper + rsMiscLower,
          "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values2) {
        var index = -1, length = values2.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values2[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string9) {
        return string9.split("");
      }
      function asciiWords(string9) {
        return string9.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object9) {
          return object9 == null ? undefined2 : object9[key];
        };
      }
      function basePropertyOf(object9) {
        return function(key) {
          return object9 == null ? undefined2 : object9[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object9, props) {
        return arrayMap(props, function(key) {
          return [
            key,
            object9[key]
          ];
        });
      }
      function baseTrim(string9) {
        return string9 ? string9.slice(0, trimmedEndIndex(string9) + 1).replace(reTrimStart, "") : string9;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object9, props) {
        return arrayMap(props, function(key) {
          return object9[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue2(object9, key) {
        return object9 == null ? undefined2 : object9[key];
      }
      function hasUnicode(string9) {
        return reHasUnicode.test(string9);
      }
      function hasUnicodeWord(string9) {
        return reHasUnicodeWord.test(string9);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [
            key,
            value
          ];
        });
        return result;
      }
      function overArg(func, transform3) {
        return function(arg) {
          return func(transform3(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [
            value,
            value
          ];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string9) {
        return hasUnicode(string9) ? unicodeSize(string9) : asciiSize(string9);
      }
      function stringToArray(string9) {
        return hasUnicode(string9) ? unicodeToArray(string9) : asciiToArray(string9);
      }
      function trimmedEndIndex(string9) {
        var index = string9.length;
        while (index-- && reWhitespace.test(string9.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string9) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string9)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string9) {
        return string9.match(reUnicode) || [];
      }
      function unicodeWords(string9) {
        return string9.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _5.defaults(root.Object(), context, _5.pick(root, contextProps));
        var Array1 = context.Array, Date2 = context.Date, Error3 = context.Error, Function1 = context.Function, Math2 = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object1);
        var oldDash = root._;
        var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object1, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object9() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object9.prototype = proto;
            var result2 = new object9();
            object9.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
          * Used to detect `data` property values to be HTML-escaped.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          "escape": reEscape,
          /**
          * Used to detect code to be evaluated.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          "evaluate": reEvaluate,
          /**
          * Used to detect `data` property values to inject.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          "interpolate": reInterpolate,
          /**
          * Used to reference the data object in the template text.
          *
          * @memberOf _.templateSettings
          * @type {string}
          */
          "variable": "",
          /**
          * Used to import variables into the compiled template.
          *
          * @memberOf _.templateSettings
          * @type {Object}
          */
          "imports": {
            /**
            * A reference to the `lodash` function.
            *
            * @memberOf _.templateSettings.imports
            * @type {Function}
            */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([
              key,
              value
            ]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values3) {
          var index = -1, length = values3 == null ? 0 : values3.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values3[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack18(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([
                key,
                value
              ]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack18.prototype.clear = stackClear;
        Stack18.prototype["delete"] = stackDelete;
        Stack18.prototype.get = stackGet;
        Stack18.prototype.has = stackHas;
        Stack18.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object9, key, value) {
          if (value !== undefined2 && !eq(object9[key], value) || value === undefined2 && !(key in object9)) {
            baseAssignValue(object9, key, value);
          }
        }
        function assignValue(object9, key, value) {
          var objValue = object9[key];
          if (!(hasOwnProperty.call(object9, key) && eq(objValue, value)) || value === undefined2 && !(key in object9)) {
            baseAssignValue(object9, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object9, source) {
          return object9 && copyObject(source, keys(source), object9);
        }
        function baseAssignIn(object9, source) {
          return object9 && copyObject(source, keysIn(source), object9);
        }
        function baseAssignValue(object9, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object9, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object9[key] = value;
          }
        }
        function baseAt(object9, paths) {
          var index = -1, length = paths.length, result2 = Array1(length), skip = object9 == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get3(object9, paths[index]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object9, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object9 ? customizer(value, key, object9, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object9) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object9 ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack18());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object9) {
            return baseConformsTo(object9, source, props);
          };
        }
        function baseConformsTo(object9, source, props) {
          var length = props.length;
          if (object9 == null) {
            return !length;
          }
          object9 = Object1(object9);
          while (length--) {
            var key = props[length], predicate = source[key], value = object9[key];
            if (value === undefined2 && !(key in object9) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values3, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values3.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values3 = arrayMap(values3, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values3.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values3 = new SetCache(values3);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values3[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values3, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object9, iteratee2) {
          return object9 && baseFor(object9, iteratee2, keys);
        }
        function baseForOwnRight(object9, iteratee2) {
          return object9 && baseForRight(object9, iteratee2, keys);
        }
        function baseFunctions(object9, props) {
          return arrayFilter(props, function(key) {
            return isFunction4(object9[key]);
          });
        }
        function baseGet(object9, path) {
          path = castPath(path, object9);
          var index = 0, length = path.length;
          while (object9 != null && index < length) {
            object9 = object9[toKey(path[index++])];
          }
          return index && index == length ? object9 : undefined2;
        }
        function baseGetAllKeys(object9, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object9);
          return isArray(object9) ? result2 : arrayPush(result2, symbolsFunc(object9));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object9, key) {
          return object9 != null && hasOwnProperty.call(object9, key);
        }
        function baseHasIn(object9, key) {
          return object9 != null && key in Object1(object9);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object9, setter, iteratee2, accumulator) {
          baseForOwn(object9, function(value, key, object10) {
            setter(accumulator, iteratee2(value), key, object10);
          });
          return accumulator;
        }
        function baseInvoke(object9, path, args) {
          path = castPath(path, object9);
          object9 = parent(object9, path);
          var func = object9 == null ? object9 : object9[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object9, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object9, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object9), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object9), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object9)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack18());
            return objIsArr || isTypedArray(object9) ? equalArrays(object9, other, bitmask, customizer, equalFunc, stack) : equalByTag(object9, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object9, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object9.value() : object9, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack18());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack18());
          return equalObjects(object9, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object9, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object9 == null) {
            return !length;
          }
          object9 = Object1(object9);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object9[data[0]] : !(data[0] in object9)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object9[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object9)) {
                return false;
              }
            } else {
              var stack = new Stack18();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object9, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction4(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object9) {
          if (!isPrototype(object9)) {
            return nativeKeys(object9);
          }
          var result2 = [];
          for (var key in Object1(object9)) {
            if (hasOwnProperty.call(object9, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object9) {
          if (!isObject(object9)) {
            return nativeKeysIn(object9);
          }
          var isProto = isPrototype(object9), result2 = [];
          for (var key in object9) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object9, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array1(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object9) {
            return object9 === source || baseIsMatch(object9, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object9) {
            var objValue = get3(object9, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object9, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object9, source, srcIndex, customizer, stack) {
          if (object9 === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack18());
            if (isObject(srcValue)) {
              baseMergeDeep(object9, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object9, key), srcValue, key + "", object9, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object9, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object9, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object9, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object9, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object9, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction4(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object9, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [
              identity
            ];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return {
              "criteria": criteria,
              "index": ++index,
              "value": value
            };
          });
          return baseSortBy(result2, function(object9, other) {
            return compareMultiple(object9, other, orders);
          });
        }
        function basePick(object9, paths) {
          return basePickBy(object9, paths, function(value, path) {
            return hasIn(object9, path);
          });
        }
        function basePickBy(object9, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object9, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object9), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object9) {
            return baseGet(object9, path);
          };
        }
        function basePullAll(array, values3, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values3.length, seen = array;
          if (array === values3) {
            values3 = copyArray(values3);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values3[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array1(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string9, n) {
          var result2 = "";
          if (!string9 || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string9;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string9 += string9;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values2(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values2(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object9, path, value, customizer) {
          if (!isObject(object9)) {
            return object9;
          }
          path = castPath(path, object9);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object9;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object9;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object9;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string9) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string9),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values2(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array1(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object9, path) {
          path = castPath(path, object9);
          object9 = parent(object9, path);
          return object9 == null || delete object9[toKey(last(path))];
        }
        function baseUpdate(object9, path, updater, customizer) {
          return baseSet(object9, path, updater(baseGet(object9, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([
              result3
            ], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array1(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values3, assignFunc) {
          var index = -1, length = props.length, valsLength = values3.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values3[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object9) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object9) ? [
            value
          ] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object9, other, orders) {
          var index = -1, objCriteria = object9.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object9.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array1(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array1(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array1(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object9, customizer) {
          var isNew = !object9;
          object9 || (object9 = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object9[key], source[key], key, object9, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object9, key, newValue);
            } else {
              assignValue(object9, key, newValue);
            }
          }
          return object9;
        }
        function copySymbols(source, object9) {
          return copyObject(source, getSymbols(source), object9);
        }
        function copySymbolsIn(source, object9) {
          return copyObject(source, getSymbolsIn(source), object9);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object9, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object9 = Object1(object9);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object9, source, index, customizer);
              }
            }
            return object9;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object9, iteratee2, keysFunc) {
            var index = -1, iterable = Object1(object9), props = keysFunc(object9), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object9;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string9) {
            string9 = toString(string9);
            var strSymbols = hasUnicode(string9) ? stringToArray(string9) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string9.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string9.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string9) {
            return arrayReduce(words(deburr(string9).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined2, args, holders, undefined2, undefined2, arity - length);
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object1(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array1(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length);
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object9, iteratee2) {
            return baseInverter(object9, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([
          ,
          -0
        ]))[1] == INFINITY) ? noop2 : function(values3) {
          return new Set2(values3);
        };
        function createToPairs(keysFunc) {
          return function(object9) {
            var tag = getTag(object9);
            if (tag == mapTag) {
              return mapToArray(object9);
            }
            if (tag == setTag) {
              return setToPairs(object9);
            }
            return baseToPairs(object9, keysFunc(object9));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object9) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object9, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object9, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject2(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object9, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object9.byteLength != other.byteLength || object9.byteOffset != other.byteOffset) {
                return false;
              }
              object9 = object9.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object9.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object9), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object9, +other);
            case errorTag:
              return object9.name == other.name && object9.message == other.message;
            case regexpTag:
            case stringTag:
              return object9 == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object9.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object9);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object9, other);
              var result2 = equalArrays(convert(object9), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object9);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object9) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object9, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object9), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object9);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object9;
          }
          var result2 = true;
          stack.set(object9, other);
          stack.set(other, object9);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object9[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object9, stack) : customizer(objValue, othValue, key, object9, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object9.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && "constructor" in object9 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object9);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object9) {
          return baseGetAllKeys(object9, keys, getSymbols);
        }
        function getAllKeysIn(object9) {
          return baseGetAllKeys(object9, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop2 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object9 = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object9.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object9) {
          var result2 = keys(object9), length = result2.length;
          while (length--) {
            var key = result2[length], value = object9[key];
            result2[length] = [
              key,
              value,
              isStrictComparable(value)
            ];
          }
          return result2;
        }
        function getNative(object9, key) {
          var value = getValue2(object9, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object9) {
          if (object9 == null) {
            return [];
          }
          object9 = Object1(object9);
          return arrayFilter(nativeGetSymbols(object9), function(symbol) {
            return propertyIsEnumerable.call(object9, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object9) {
          var result2 = [];
          while (object9) {
            arrayPush(result2, getSymbols(object9));
            object9 = getPrototype(object9);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return {
            "start": start,
            "end": end
          };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object9, path, hasFunc) {
          path = castPath(path, object9);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object9 != null && hasFunc(object9, key))) {
              break;
            }
            object9 = object9[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object9 == null ? 0 : object9.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object9) || isArguments(object9));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object9) {
          return typeof object9.constructor == "function" && !isPrototype(object9) ? baseCreate(getPrototype(object9)) : {};
        }
        function initCloneByTag(object9, tag, isDeep) {
          var Ctor = object9.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object9);
            case boolTag:
            case dateTag:
              return new Ctor(+object9);
            case dataViewTag:
              return cloneDataView(object9, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object9, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object9);
            case regexpTag:
              return cloneRegExp(object9);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object9);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        function isIterateeCall(value, index, object9) {
          if (!isObject(object9)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object9) && isIndex(index, object9.length) : type == "string" && index in object9) {
            return eq(object9[index], value);
          }
          return false;
        }
        function isKey(value, object9) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object9 != null && value in Object1(object9);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction4 : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object9) {
            if (object9 == null) {
              return false;
            }
            return object9[key] === srcValue && (srcValue !== undefined2 || key in Object1(object9));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize2(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object9) {
          var result2 = [];
          if (object9 != null) {
            for (var key in Object1(object9)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform4) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array1(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform4(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object9, path) {
          return path.length < 2 ? object9 : baseGet(object9, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object9, key) {
          if (key === "constructor" && typeof object9[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object9[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string9) {
          var result2 = [];
          if (string9.charCodeAt(0) === 46) {
            result2.push("");
          }
          string9.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array1(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array1(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [
            array
          ], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values3) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values3) {
          var iteratee2 = last(values3);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values3) {
          var comparator = last(values3);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join2(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values3) {
          return array && array.length && values3 && values3.length ? basePullAll(array, values3) : array;
        }
        function pullAllBy(array, values3, iteratee2) {
          return array && array.length && values3 && values3.length ? basePullAll(array, values3, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values3, comparator) {
          return array && array.length && values3 && values3.length ? basePullAll(array, values3, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values3) {
          return isArrayLikeObject(array) ? baseDifference(array, values3) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values3) {
          return baseZipObject(props || [], values3 || [], assignValue);
        }
        function zipObjectDeep(props, values3) {
          return baseZipObject(props || [], values3 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object9) {
            return baseAt(object9, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [
              interceptor
            ],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return {
            "done": done,
            "value": value
          };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [
                reverse
              ],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [
              value
            ]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values2(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array1(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [
              iteratees
            ];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [
              orders
            ];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [
            [],
            []
          ];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [
              iteratees[0]
            ];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object9, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object9, partials, holders);
        });
        function curry2(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry2.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize2(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize2.Cache || MapCache)();
          return memoized;
        }
        memoize2.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [
            value
          ];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep2(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object9, source) {
          return source == null || baseConformsTo(object9, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array1.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction4(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
        }
        function isEmpty5(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction4(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger2(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object9, source) {
          return object9 === source || baseIsMatch(object9, source, getMatchData(source));
        }
        function isMatchWith(object9, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object9, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error3(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil2(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject2(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger2(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values2;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object9, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object9);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object9, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object9, source) {
          copyObject(source, keysIn(source), object9);
        });
        var assignInWith = createAssigner(function(object9, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object9, customizer);
        });
        var assignWith = createAssigner(function(object9, source, srcIndex, customizer) {
          copyObject(source, keys(source), object9, customizer);
        });
        var at = flatRest(baseAt);
        function create6(prototype, properties2) {
          var result2 = baseCreate(prototype);
          return properties2 == null ? result2 : baseAssign(result2, properties2);
        }
        var defaults = baseRest(function(object9, sources) {
          object9 = Object1(object9);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object9[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object9, key)) {
                object9[key] = source[key];
              }
            }
          }
          return object9;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object9, predicate) {
          return baseFindKey(object9, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object9, predicate) {
          return baseFindKey(object9, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object9, iteratee2) {
          return object9 == null ? object9 : baseFor(object9, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object9, iteratee2) {
          return object9 == null ? object9 : baseForRight(object9, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object9, iteratee2) {
          return object9 && baseForOwn(object9, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object9, iteratee2) {
          return object9 && baseForOwnRight(object9, getIteratee(iteratee2, 3));
        }
        function functions(object9) {
          return object9 == null ? [] : baseFunctions(object9, keys(object9));
        }
        function functionsIn(object9) {
          return object9 == null ? [] : baseFunctions(object9, keysIn(object9));
        }
        function get3(object9, path, defaultValue) {
          var result2 = object9 == null ? undefined2 : baseGet(object9, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object9, path) {
          return object9 != null && hasPath(object9, path, baseHas);
        }
        function hasIn(object9, path) {
          return object9 != null && hasPath(object9, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [
              key
            ];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object9) {
          return isArrayLike(object9) ? arrayLikeKeys(object9) : baseKeys(object9);
        }
        function keysIn(object9) {
          return isArrayLike(object9) ? arrayLikeKeys(object9, true) : baseKeysIn(object9);
        }
        function mapKeys(object9, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object9, function(value, key, object10) {
            baseAssignValue(result2, iteratee2(value, key, object10), value);
          });
          return result2;
        }
        function mapValues(object9, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object9, function(value, key, object10) {
            baseAssignValue(result2, key, iteratee2(value, key, object10));
          });
          return result2;
        }
        var merge2 = createAssigner(function(object9, source, srcIndex) {
          baseMerge(object9, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object9, source, srcIndex, customizer) {
          baseMerge(object9, source, srcIndex, customizer);
        });
        var omit2 = flatRest(function(object9, paths) {
          var result2 = {};
          if (object9 == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object9);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object9, getAllKeysIn(object9), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object9, predicate) {
          return pickBy(object9, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object9, paths) {
          return object9 == null ? {} : basePick(object9, paths);
        });
        function pickBy(object9, predicate) {
          if (object9 == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object9), function(prop) {
            return [
              prop
            ];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object9, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object9, path, defaultValue) {
          path = castPath(path, object9);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object9 = undefined2;
          }
          while (++index < length) {
            var value = object9 == null ? undefined2 : object9[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object9 = isFunction4(value) ? value.call(object9) : value;
          }
          return object9;
        }
        function set(object9, path, value) {
          return object9 == null ? object9 : baseSet(object9, path, value);
        }
        function setWith(object9, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object9 == null ? object9 : baseSet(object9, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform3(object9, iteratee2, accumulator) {
          var isArr = isArray(object9), isArrLike = isArr || isBuffer(object9) || isTypedArray(object9);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object9 && object9.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object9)) {
              accumulator = isFunction4(Ctor) ? baseCreate(getPrototype(object9)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object9, function(value, index, object10) {
            return iteratee2(accumulator, value, index, object10);
          });
          return accumulator;
        }
        function unset(object9, path) {
          return object9 == null ? true : baseUnset(object9, path);
        }
        function update(object9, path, updater) {
          return object9 == null ? object9 : baseUpdate(object9, path, castFunction(updater));
        }
        function updateWith(object9, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object9 == null ? object9 : baseUpdate(object9, path, castFunction(updater), customizer);
        }
        function values2(object9) {
          return object9 == null ? [] : baseValues(object9, keys(object9));
        }
        function valuesIn(object9) {
          return object9 == null ? [] : baseValues(object9, keysIn(object9));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase2 = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize2(word) : word);
        });
        function capitalize2(string9) {
          return upperFirst(toString(string9).toLowerCase());
        }
        function deburr(string9) {
          string9 = toString(string9);
          return string9 && string9.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string9, target, position) {
          string9 = toString(string9);
          target = baseToString(target);
          var length = string9.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string9.slice(position, end) == target;
        }
        function escape(string9) {
          string9 = toString(string9);
          return string9 && reHasUnescapedHtml.test(string9) ? string9.replace(reUnescapedHtml, escapeHtmlChar) : string9;
        }
        function escapeRegExp(string9) {
          string9 = toString(string9);
          return string9 && reHasRegExpChar.test(string9) ? string9.replace(reRegExpChar, "\\$&") : string9;
        }
        var kebabCase2 = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string9, length, chars) {
          string9 = toString(string9);
          length = toInteger(length);
          var strLength = length ? stringSize(string9) : 0;
          if (!length || strLength >= length) {
            return string9;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string9 + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string9, length, chars) {
          string9 = toString(string9);
          length = toInteger(length);
          var strLength = length ? stringSize(string9) : 0;
          return length && strLength < length ? string9 + createPadding(length - strLength, chars) : string9;
        }
        function padStart(string9, length, chars) {
          string9 = toString(string9);
          length = toInteger(length);
          var strLength = length ? stringSize(string9) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string9 : string9;
        }
        function parseInt1(string9, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string9).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string9, n, guard) {
          if (guard ? isIterateeCall(string9, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string9), n);
        }
        function replace() {
          var args = arguments, string9 = toString(args[0]);
          return args.length < 3 ? string9 : string9.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string9, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string9, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string9 = toString(string9);
          if (string9 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string9)) {
              return castSlice(stringToArray(string9), 0, limit);
            }
          }
          return string9.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string9, target, position) {
          string9 = toString(string9);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string9.length);
          target = baseToString(target);
          return string9.slice(position, position + target.length) == target;
        }
        function template(string9, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string9, options, guard)) {
            options = undefined2;
          }
          string9 = toString(string9);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string9.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string9.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error3(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function1(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string9, chars, guard) {
          string9 = toString(string9);
          if (string9 && (guard || chars === undefined2)) {
            return baseTrim(string9);
          }
          if (!string9 || !(chars = baseToString(chars))) {
            return string9;
          }
          var strSymbols = stringToArray(string9), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string9, chars, guard) {
          string9 = toString(string9);
          if (string9 && (guard || chars === undefined2)) {
            return string9.slice(0, trimmedEndIndex(string9) + 1);
          }
          if (!string9 || !(chars = baseToString(chars))) {
            return string9;
          }
          var strSymbols = stringToArray(string9), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string9, chars, guard) {
          string9 = toString(string9);
          if (string9 && (guard || chars === undefined2)) {
            return string9.replace(reTrimStart, "");
          }
          if (!string9 || !(chars = baseToString(chars))) {
            return string9;
          }
          var strSymbols = stringToArray(string9), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string9, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string9 = toString(string9);
          var strLength = string9.length;
          if (hasUnicode(string9)) {
            var strSymbols = stringToArray(string9);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string9;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string9.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string9.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string9.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape(string9) {
          string9 = toString(string9);
          return string9 && reHasEscapedHtml.test(string9) ? string9.replace(reEscapedHtml, unescapeHtmlChar) : string9;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string9, pattern, guard) {
          string9 = toString(string9);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string9) ? unicodeWords(string9) : asciiWords(string9);
          }
          return string9.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error3(e);
          }
        });
        var bindAll = flatRest(function(object9, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object9, key, bind(object9[key], object9));
          });
          return object9;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [
              toIteratee(pair[0]),
              pair[1]
            ];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object9) {
            return baseInvoke(object9, path, args);
          };
        });
        var methodOf = baseRest(function(object9, args) {
          return function(path) {
            return baseInvoke(object9, path, args);
          };
        });
        function mixin(object9, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object9;
            object9 = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction4(object9);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object9[methodName] = func;
            if (isFunc) {
              object9.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object9(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({
                    "func": func,
                    "args": arguments,
                    "thisArg": object9
                  });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object9, arrayPush([
                  this.value()
                ], arguments));
              };
            }
          });
          return object9;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop2() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object9) {
          return function(path) {
            return object9 == null ? undefined2 : baseGet(object9, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [
            value
          ] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max2(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min2(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create6;
        lodash.curry = curry2;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize2;
        lodash.merge = merge2;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit2;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform3;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values2;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase2;
        lodash.capitalize = capitalize2;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep2;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get3;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty5;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction4;
        lodash.isInteger = isInteger2;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil2;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject2;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join2;
        lodash.kebabCase = kebabCase2;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max2;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min2;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop2;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), {
          "chain": false
        });
        lodash.VERSION = VERSION;
        arrayEach([
          "bind",
          "bindKey",
          "curry",
          "curryRight",
          "partial",
          "partialRight"
        ], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach([
          "drop",
          "take"
        ], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach([
          "filter",
          "map",
          "takeWhile"
        ], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach([
          "head",
          "last"
        ], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach([
          "initial",
          "tail"
        ], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [
              1
            ] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([
                value2
              ], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({
                "func": thru,
                "args": [
                  interceptor
                ],
                "thisArg": undefined2
              });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach([
          "pop",
          "push",
          "shift",
          "sort",
          "splice",
          "unshift"
        ], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({
              "name": methodName,
              "func": lodashFunc
            });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [
          {
            "name": "wrapper",
            "func": undefined2
          }
        ];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _5 = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _5;
        define(function() {
          return _5;
        });
      } else if (freeModule) {
        (freeModule.exports = _5)._ = _5;
        freeExports._ = _5;
      } else {
        root._ = _5;
      }
    }).call(exports);
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b = "function" === typeof Symbol && Symbol.for;
    var c = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r2 = b ? Symbol.for("react.memo") : 60115;
    var t = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x = b ? Symbol.for("react.responder") : 60118;
    var y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r2:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r2;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a) {
      return z(a) === k;
    };
    exports.isContextProvider = function(a) {
      return z(a) === h;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function(a) {
      return z(a) === n;
    };
    exports.isFragment = function(a) {
      return z(a) === e;
    };
    exports.isLazy = function(a) {
      return z(a) === t;
    };
    exports.isMemo = function(a) {
      return z(a) === r2;
    };
    exports.isPortal = function(a) {
      return z(a) === d;
    };
    exports.isProfiler = function(a) {
      return z(a) === g;
    };
    exports.isStrictMode = function(a) {
      return z(a) === f;
    };
    exports.isSuspense = function(a) {
      return z(a) === p;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object9) {
          if (typeof object9 === "object" && object9 !== null) {
            var $$typeof = object9.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object9.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef2 = REACT_FORWARD_REF_TYPE;
        var Fragment3 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo2 = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object9) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object9) || typeOf(object9) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object9) {
          return typeOf(object9) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object9) {
          return typeOf(object9) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object9) {
          return typeOf(object9) === REACT_PROVIDER_TYPE;
        }
        function isElement(object9) {
          return typeof object9 === "object" && object9 !== null && object9.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object9) {
          return typeOf(object9) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object9) {
          return typeOf(object9) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object9) {
          return typeOf(object9) === REACT_LAZY_TYPE;
        }
        function isMemo(object9) {
          return typeOf(object9) === REACT_MEMO_TYPE;
        }
        function isPortal(object9) {
          return typeOf(object9) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object9) {
          return typeOf(object9) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object9) {
          return typeOf(object9) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object9) {
          return typeOf(object9) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef2;
        exports.Fragment = Fragment3;
        exports.Lazy = Lazy;
        exports.Memo = Memo2;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    "use strict";
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
              expectedType
            });
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/react-is/cjs/react-is.production.js
var require_react_is_production = __commonJS({
  "../../node_modules/react-is/cjs/react-is.production.js"(exports) {
    "use strict";
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    Symbol.for("react.provider");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    function typeOf(object9) {
      if ("object" === typeof object9 && null !== object9) {
        var $$typeof = object9.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object9 = object9.type, object9) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
                return object9;
              default:
                switch (object9 = object9 && object9.$$typeof, object9) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object9;
                  case REACT_CONSUMER_TYPE:
                    return object9;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    exports.ContextConsumer = REACT_CONSUMER_TYPE;
    exports.ContextProvider = REACT_CONTEXT_TYPE;
    exports.Element = REACT_ELEMENT_TYPE;
    exports.ForwardRef = REACT_FORWARD_REF_TYPE;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Lazy = REACT_LAZY_TYPE;
    exports.Memo = REACT_MEMO_TYPE;
    exports.Portal = REACT_PORTAL_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    exports.isContextConsumer = function(object9) {
      return typeOf(object9) === REACT_CONSUMER_TYPE;
    };
    exports.isContextProvider = function(object9) {
      return typeOf(object9) === REACT_CONTEXT_TYPE;
    };
    exports.isElement = function(object9) {
      return "object" === typeof object9 && null !== object9 && object9.$$typeof === REACT_ELEMENT_TYPE;
    };
    exports.isForwardRef = function(object9) {
      return typeOf(object9) === REACT_FORWARD_REF_TYPE;
    };
    exports.isFragment = function(object9) {
      return typeOf(object9) === REACT_FRAGMENT_TYPE;
    };
    exports.isLazy = function(object9) {
      return typeOf(object9) === REACT_LAZY_TYPE;
    };
    exports.isMemo = function(object9) {
      return typeOf(object9) === REACT_MEMO_TYPE;
    };
    exports.isPortal = function(object9) {
      return typeOf(object9) === REACT_PORTAL_TYPE;
    };
    exports.isProfiler = function(object9) {
      return typeOf(object9) === REACT_PROFILER_TYPE;
    };
    exports.isStrictMode = function(object9) {
      return typeOf(object9) === REACT_STRICT_MODE_TYPE;
    };
    exports.isSuspense = function(object9) {
      return typeOf(object9) === REACT_SUSPENSE_TYPE;
    };
    exports.isSuspenseList = function(object9) {
      return typeOf(object9) === REACT_SUSPENSE_LIST_TYPE;
    };
    exports.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    exports.typeOf = typeOf;
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development2 = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    "production" !== process.env.NODE_ENV && function() {
      function typeOf(object9) {
        if ("object" === typeof object9 && null !== object9) {
          var $$typeof = object9.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              switch (object9 = object9.type, object9) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return object9;
                default:
                  switch (object9 = object9 && object9.$$typeof, object9) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                      return object9;
                    case REACT_CONSUMER_TYPE:
                      return object9;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
      }
      var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      Symbol.for("react.provider");
      var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
      exports.ContextConsumer = REACT_CONSUMER_TYPE;
      exports.ContextProvider = REACT_CONTEXT_TYPE;
      exports.Element = REACT_ELEMENT_TYPE;
      exports.ForwardRef = REACT_FORWARD_REF_TYPE;
      exports.Fragment = REACT_FRAGMENT_TYPE;
      exports.Lazy = REACT_LAZY_TYPE;
      exports.Memo = REACT_MEMO_TYPE;
      exports.Portal = REACT_PORTAL_TYPE;
      exports.Profiler = REACT_PROFILER_TYPE;
      exports.StrictMode = REACT_STRICT_MODE_TYPE;
      exports.Suspense = REACT_SUSPENSE_TYPE;
      exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      exports.isContextConsumer = function(object9) {
        return typeOf(object9) === REACT_CONSUMER_TYPE;
      };
      exports.isContextProvider = function(object9) {
        return typeOf(object9) === REACT_CONTEXT_TYPE;
      };
      exports.isElement = function(object9) {
        return "object" === typeof object9 && null !== object9 && object9.$$typeof === REACT_ELEMENT_TYPE;
      };
      exports.isForwardRef = function(object9) {
        return typeOf(object9) === REACT_FORWARD_REF_TYPE;
      };
      exports.isFragment = function(object9) {
        return typeOf(object9) === REACT_FRAGMENT_TYPE;
      };
      exports.isLazy = function(object9) {
        return typeOf(object9) === REACT_LAZY_TYPE;
      };
      exports.isMemo = function(object9) {
        return typeOf(object9) === REACT_MEMO_TYPE;
      };
      exports.isPortal = function(object9) {
        return typeOf(object9) === REACT_PORTAL_TYPE;
      };
      exports.isProfiler = function(object9) {
        return typeOf(object9) === REACT_PROFILER_TYPE;
      };
      exports.isStrictMode = function(object9) {
        return typeOf(object9) === REACT_STRICT_MODE_TYPE;
      };
      exports.isSuspense = function(object9) {
        return typeOf(object9) === REACT_SUSPENSE_TYPE;
      };
      exports.isSuspenseList = function(object9) {
        return typeOf(object9) === REACT_SUSPENSE_LIST_TYPE;
      };
      exports.isValidElementType = function(type) {
        return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
      };
      exports.typeOf = typeOf;
    }();
  }
});

// ../../node_modules/react-is/index.js
var require_react_is2 = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production();
    } else {
      module.exports = require_react_is_development2();
    }
  }
});

// src/entities/settings/ui/toggle-setting/index.tsx
import { jsx as _jsx3, jsxs as _jsxs } from "react/jsx-runtime";
import { ClickAwayListener, Fade, Stack as Stack2, Typography } from "@mui/material";
import React2, { useState } from "react";

// src/entities/settings/ui/toggle-setting/ui.tsx
import { jsx as _jsx } from "react/jsx-runtime";
import { styled as styledMui, Stack } from "@mui/material";
import styled from "styled-components";
import TooltipMui, { tooltipClasses } from "@mui/material/Tooltip";

// src/lib/styles/helpers.ts
var import_lodash = __toESM(require_lodash());
var map2CssVars = (vocabulary, prefix) => `${(0, import_lodash.join)((0, import_lodash.transform)(vocabulary, (r2, value, key) => r2.push(`--dion-${prefix}-${/([0-9]+)/.test(key) && key || (0, import_lodash.kebabCase)(key)}: ${(0, import_lodash.get)(vocabulary, key)}`), []), ";\r\n")};`;
var getCssVar = (prefix, key) => `var(--dion-${prefix}-${key})`;

// src/entities/settings/ui/toggle-setting/ui.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Tooltip = styledMui((_param) => {
  var { className } = _param, props = _object_without_properties(_param, [
    "className"
  ]);
  return /* @__PURE__ */ _jsx(TooltipMui, _object_spread_props(_object_spread({}, props), {
    classes: {
      popper: className
    }
  }));
})({
  [`& .${tooltipClasses.tooltip}`]: {
    background: getCssVar("grey", 100),
    color: getCssVar("black", 100),
    fontSize: getCssVar("font", "small"),
    lineHeight: getCssVar("font", "lineHeight"),
    textAlign: "center",
    maxWidth: 327,
    // width: 309,
    padding: "12px 8px",
    position: "relative",
    left: "-18px"
  }
});
var TooltipTitle = styled.div({
  textAlign: "left"
});
var TooltipWrap = styled.div({
  display: "flex"
});
var TooltipIconWrap = styled.div({
  cursor: "pointer"
});
var DescriptionWrap = styledMui(Stack)({
  flexGrow: 1
});
var ButtonWrap = styled.div({
  flexShrink: 0
});
var MainWrap = styled.div({
  display: "flex",
  alignItems: "center"
});

// src/shared/ui/icons/shared/InfoFill.tsx
import { jsx as _jsx2 } from "react/jsx-runtime";
import React from "react";
function _define_property2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property2(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys2(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props2(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var InfoFill = (props) => /* @__PURE__ */ _jsx2("svg", _object_spread_props2(_object_spread2({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ _jsx2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM7.99999 3.77778C7.58271 3.77778 7.24444 4.11605 7.24444 4.53333C7.24444 4.95061 7.58271 5.28889 7.99999 5.28889C8.41728 5.28889 8.75555 4.95061 8.75555 4.53333C8.75555 4.11605 8.41728 3.77778 7.99999 3.77778ZM9.86666 11.5556C9.86666 11.9237 9.56818 12.2222 9.19999 12.2222H9.15555C8.14917 12.2222 7.33333 11.4064 7.33333 10.4V7.06668C7.33333 6.69849 7.6318 6.40001 7.99999 6.40001C8.36818 6.40001 8.66666 6.69849 8.66666 7.06668V10.4C8.66666 10.67 8.88554 10.8889 9.15555 10.8889H9.19999C9.56818 10.8889 9.86666 11.1874 9.86666 11.5556Z"
  })
}));
var InfoFill_default = /* @__PURE__ */ React.memo(InfoFill);

// src/entities/settings/ui/toggle-setting/index.tsx
var ToggleSetting = ({ label, description, id, buttonSwitch, isTooltip = false, children }) => {
  const [open, setOpen] = useState(false);
  const onTooltipClose = () => {
    setOpen(false);
  };
  if (isTooltip) {
    return /* @__PURE__ */ _jsxs(Stack2, {
      children: [
        /* @__PURE__ */ _jsxs(MainWrap, {
          className: "flex items-center",
          id,
          children: [
            /* @__PURE__ */ _jsx3(ClickAwayListener, {
              onClickAway: onTooltipClose,
              children: /* @__PURE__ */ _jsx3(TooltipWrap, {
                children: /* @__PURE__ */ _jsx3(Tooltip, {
                  PopperProps: {
                    disablePortal: true
                  },
                  title: /* @__PURE__ */ _jsx3(TooltipTitle, {
                    children: description
                  }),
                  TransitionComponent: Fade,
                  TransitionProps: {
                    timeout: 0
                  },
                  placement: "bottom",
                  children: /* @__PURE__ */ _jsx3(TooltipIconWrap, {
                    onClick: () => setOpen(!open),
                    children: /* @__PURE__ */ _jsx3(InfoFill_default, {
                      fill: getCssVar("grey", 100)
                    })
                  })
                })
              })
            }),
            /* @__PURE__ */ _jsx3(Typography, {
              ml: "8px",
              children: label
            }),
            buttonSwitch
          ]
        }),
        children
      ]
    });
  }
  return /* @__PURE__ */ _jsxs(Stack2, {
    children: [
      /* @__PURE__ */ _jsxs(Stack2, {
        direction: "row",
        id,
        children: [
          /* @__PURE__ */ _jsxs(DescriptionWrap, {
            spacing: "4px",
            children: [
              /* @__PURE__ */ _jsx3(Typography, {
                variant: "body2",
                children: label
              }),
              /* @__PURE__ */ _jsx3(Typography, {
                sx: {
                  fontSize: getCssVar("font", "small"),
                  lineHeight: getCssVar("font", "lineHeight")
                },
                color: getCssVar("grey", 500),
                children: description
              })
            ]
          }),
          /* @__PURE__ */ _jsx3(ButtonWrap, {
            children: buttonSwitch
          })
        ]
      }),
      children
    ]
  });
};
var toggle_setting_default = /* @__PURE__ */ React2.memo(ToggleSetting);

// src/lib/domains/Dayjs/index.ts
import defaultDayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ru";
import "dayjs/locale/en";
import "dayjs/locale/fr";
var dayjs = defaultDayjs;
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(updateLocale);
dayjs.locale("ru");
dayjs.updateLocale("en", {
  // Sunday = 0, Monday = 1.
  weekStart: 1
});

// src/lib/domains/detect-browser/index.ts
import { BotInfo, BrowserInfo, NodeInfo, ReactNativeInfo, SearchBotDeviceInfo } from "detect-browser";
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
  [
    "aurora",
    /AuroraBrowser\/([0-9\._]+)/
  ],
  [
    "aol",
    /AOLShield\/([0-9\._]+)/
  ],
  [
    "edge",
    /Edge\/([0-9\._]+)/
  ],
  [
    "edge-ios",
    /EdgiOS\/([0-9\._]+)/
  ],
  [
    "yandexbrowser",
    /YaBrowser\/([0-9\._]+)/
  ],
  [
    "kakaotalk",
    /KAKAOTALK\s([0-9\.]+)/
  ],
  [
    "samsung",
    /SamsungBrowser\/([0-9\.]+)/
  ],
  [
    "silk",
    /\bSilk\/([0-9._-]+)\b/
  ],
  [
    "miui",
    /MiuiBrowser\/([0-9\.]+)$/
  ],
  [
    "beaker",
    /BeakerBrowser\/([0-9\.]+)/
  ],
  [
    "edge-chromium",
    /EdgA?\/([0-9\.]+)/
  ],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  [
    "chrome",
    /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  [
    "phantomjs",
    /PhantomJS\/([0-9\.]+)(:?\s|$)/
  ],
  [
    "crios",
    /CriOS\/([0-9\.]+)(:?\s|$)/
  ],
  [
    "firefox",
    /Firefox\/([0-9\.]+)(?:\s|$)/
  ],
  [
    "fxios",
    /FxiOS\/([0-9\.]+)/
  ],
  [
    "opera-mini",
    /Opera Mini.*Version\/([0-9\.]+)/
  ],
  [
    "opera",
    /Opera\/([0-9\.]+)(?:\s|$)/
  ],
  [
    "opera",
    /OPR\/([0-9\.]+)(:?\s|$)/
  ],
  [
    "pie",
    /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
  ],
  [
    "pie",
    /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
  ],
  [
    "netfront",
    /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
  ],
  [
    "ie",
    /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
  ],
  [
    "ie",
    /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
  ],
  [
    "ie",
    /MSIE\s(7\.0)/
  ],
  [
    "bb10",
    /BB10;\sTouch.*Version\/([0-9\.]+)/
  ],
  [
    "android",
    /Android\s([0-9\.]+)/
  ],
  [
    "ios",
    /Version\/([0-9\._]+).*Mobile.*Safari.*/
  ],
  [
    "safari",
    /Version\/([0-9\._]+).*Safari/
  ],
  [
    "facebook",
    /FB[AS]V\/([0-9\.]+)/
  ],
  [
    "instagram",
    /Instagram\s([0-9\.]+)/
  ],
  [
    "ios-webview",
    /AppleWebKit\/([0-9\.]+).*Mobile/
  ],
  [
    "ios-webview",
    /AppleWebKit\/([0-9\.]+).*Gecko\)$/
  ],
  [
    "curl",
    /^curl\/([0-9\.]+)$/
  ],
  [
    "searchbot",
    SEARCHBOX_UA_REGEX
  ]
];
var operatingSystemRules = [
  [
    "Aurora OS",
    /AuOS/
  ],
  [
    "iOS",
    /iP(hone|od|ad)/
  ],
  [
    "Android OS",
    /Android/
  ],
  [
    "BlackBerry OS",
    /BlackBerry|BB10/
  ],
  [
    "Windows Mobile",
    /IEMobile/
  ],
  [
    "Amazon OS",
    /Kindle/
  ],
  [
    "Windows 3.11",
    /Win16/
  ],
  [
    "Windows 95",
    /(Windows 95)|(Win95)|(Windows_95)/
  ],
  [
    "Windows 98",
    /(Windows 98)|(Win98)/
  ],
  [
    "Windows 2000",
    /(Windows NT 5.0)|(Windows 2000)/
  ],
  [
    "Windows XP",
    /(Windows NT 5.1)|(Windows XP)/
  ],
  [
    "Windows Server 2003",
    /(Windows NT 5.2)/
  ],
  [
    "Windows Vista",
    /(Windows NT 6.0)/
  ],
  [
    "Windows 7",
    /(Windows NT 6.1)/
  ],
  [
    "Windows 8",
    /(Windows NT 6.2)/
  ],
  [
    "Windows 8.1",
    /(Windows NT 6.3)/
  ],
  [
    "Windows 10",
    /(Windows NT 10.0)/
  ],
  [
    "Windows ME",
    /Windows ME/
  ],
  [
    "Windows CE",
    /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
  ],
  [
    "Open BSD",
    /OpenBSD/
  ],
  [
    "Sun OS",
    /SunOS/
  ],
  [
    "Chrome OS",
    /CrOS/
  ],
  [
    "Linux",
    /(Linux)|(X11)/
  ],
  [
    "Mac OS",
    /(Mac_PowerPC)|(Macintosh)/
  ],
  [
    "QNX",
    /QNX/
  ],
  [
    "BeOS",
    /BeOS/
  ],
  [
    "OS/2",
    /OS\/2/
  ]
];
function detect(userAgent) {
  if (userAgent) {
    return parseUserAgent(userAgent);
  }
  if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") {
    return new ReactNativeInfo();
  }
  if (typeof navigator !== "undefined") {
    return parseUserAgent(navigator.userAgent);
  }
  return getNodeVersion();
}
function matchUserAgent(ua) {
  return ua !== "" && userAgentRules.reduce((matched, [browser, regex]) => {
    if (matched) {
      return matched;
    }
    const uaMatch = regex.exec(ua);
    return !!uaMatch && [
      browser,
      uaMatch
    ];
  }, false);
}
function browserName(ua) {
  const data = matchUserAgent(ua);
  return data ? data[0] : null;
}
function parseUserAgent(ua) {
  const matchedRule = matchUserAgent(ua);
  if (!matchedRule) {
    return null;
  }
  const [name, match] = matchedRule;
  console.log("DDD", name, match);
  if (name === "searchbot") {
    return new BotInfo();
  }
  let versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
  if (versionParts) {
    if (versionParts.length < REQUIRED_VERSION_PARTS) {
      versionParts = [
        ...versionParts,
        ...createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length)
      ];
    }
  } else {
    versionParts = [];
  }
  const version = versionParts.join(".");
  const os = detectOS(ua);
  const searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
  if (searchBotMatch && searchBotMatch[1]) {
    return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
  }
  return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
  for (let ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
    const [os, regex] = operatingSystemRules[ii];
    const match = regex.exec(ua);
    if (match) {
      return os;
    }
  }
  return null;
}
function getNodeVersion() {
  const isNode = typeof process !== "undefined" && process.version;
  return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
  const output = [];
  for (let ii = 0; ii < count; ii++) {
    output.push("0");
  }
  return output;
}

// src/lib/domains/Fetch/index.ts
import axios from "axios";

// src/lib/domains/Fetch/shared/constants.ts
var DEFAULT_OPTIONS = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  },
  validateStatus: (status) => status < 500
};

// src/lib/domains/Fetch/index.ts
var Fetch = class {
  constructor(options = DEFAULT_OPTIONS) {
    this.options = options;
    this.get = (url, config) => this.axios.get(url, config);
    this.post = (url, data, config) => this.axios.post(url, data, config);
    this.put = (url, data, config) => this.axios.put(url, data, config);
    this.delete = (url, config) => this.axios.delete(url, config);
    axios.defaults.withCredentials = true;
    this.axios = axios.create(this.options);
  }
};
var Fetch_default = Fetch;

// src/lib/domains/LocalStorage/index.ts
var import_lodash2 = __toESM(require_lodash());
var LocalStorage = class {
  get(key) {
    return this.localStorage.getItem(key);
  }
  set(key, value) {
    this.localStorage.setItem(key, value);
    return true;
  }
  remove(key) {
    return this.localStorage.removeItem(key);
  }
  constructor() {
    this.localStorage = typeof window !== "undefined" ? window.localStorage : {
      getItem: import_lodash2.noop,
      setItem: import_lodash2.noop,
      removeItem: import_lodash2.noop
    };
  }
};
var LocalStorage_default = LocalStorage;

// src/lib/domains/Metrics/utils/index.ts
function _define_property3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property3(target, key, source[key]);
    });
  }
  return target;
}
var upgradeEvents = (events, userId) => events.map((event) => _object_spread3({
  user_id: userId,
  date_time: (/* @__PURE__ */ new Date()).toISOString()
}, event));

// src/lib/domains/Metrics/index.ts
var Metrics = class {
  get userId() {
    return this._userId || "";
  }
  set userId(userId) {
    this._userId = userId;
  }
  constructor(fetch2) {
    this.fetch = fetch2;
    this.getPlatform = () => ({
      type: "Web",
      version: "local",
      description: ""
    });
    this.sendEvent = (event, payload) => {
      if (!this.userId) {
        return;
      }
      this.fetch.post("/v1/events", {
        events: upgradeEvents([
          {
            event,
            payload
          }
        ], this.userId),
        platform: this.getPlatform()
      });
    };
    this.sendEvents = (events) => {
      if (!this.userId) {
        return;
      }
      this.fetch.post("/v1/events", {
        events: upgradeEvents(events, this.userId),
        platform: this.getPlatform()
      });
    };
  }
};
var Metrics_default = Metrics;

// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
var init_i18n = (HOST, langsArray) => {
  let LANG = "en";
  const defaultLangsArray = [
    "ru",
    "en"
  ];
  const availableLangs = langsArray ? [
    ...defaultLangsArray,
    ...langsArray
  ] : defaultLangsArray;
  if (typeof window !== "undefined") {
    const browserLang = navigator.language.substring(0, 2);
    if (availableLangs.includes(browserLang)) {
      LANG = browserLang;
    }
  }
  i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    lng: LANG,
    // debug: process.env.NODE_ENV !== 'production', - при сборке засоряет консоль
    debug: false,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: [
        HOST ? `${HOST}/locales/${LANG}/translation.json` : `/locales/${LANG}/translation.json`,
        `t=${+/* @__PURE__ */ new Date()}`
      ].join("?")
    },
    fallbackLng: "ru",
    interpolation: {
      escapeValue: false
    }
    // not needed for react as it escapes by default
  });
};
var i18n_default = i18n;

// src/lib/domains/Translate/index.ts
var Translate = class _Translate {
  // for translate in uikit
  static get(key, opt = {}) {
    const value = i18n_default.t(key, opt);
    if (!value) {
      return key;
    }
    return `${value}`;
  }
  static currentLang() {
    if (typeof window !== "undefined") {
      return navigator.language.substring(0, 2);
    }
    return "ru";
  }
  init(callback) {
    if (this.i18n.isInitialized) {
      callback(true);
      dayjs.locale(this.currentLang());
    }
    this.i18n.on("initialized", () => {
      callback(true);
      dayjs.locale(this.currentLang());
    });
  }
  changeLang(lang) {
    this.i18n.changeLanguage(lang);
    dayjs.locale(lang);
  }
  constructor(host, langsArray) {
    this.get = (key, opt = {}) => _Translate.get(key, opt);
    this.currentLang = () => _Translate.currentLang();
    this.i18n = i18n_default;
    init_i18n(host, langsArray);
  }
};
var Translate_default = Translate;

// src/lib/domains/Socket/BaseSocketController.ts
var import_lodash5 = __toESM(require_lodash());

// src/lib/domains/Socket/BaseEventListener.ts
var BaseEventListener = class {
  addEventListener(name, callback, options) {
    var _this_listeners_name;
    if (!this.listeners[name]) {
      this.listeners[name] = /* @__PURE__ */ new Set([]);
    }
    const newCallback = {
      callback,
      options
    };
    if (!((_this_listeners_name = this.listeners[name]) === null || _this_listeners_name === void 0 ? void 0 : _this_listeners_name.has(newCallback))) {
      var _this_listeners_name1;
      (_this_listeners_name1 = this.listeners[name]) === null || _this_listeners_name1 === void 0 ? void 0 : _this_listeners_name1.add(newCallback);
    }
    return this;
  }
  addMultipleEventsListeners(obj) {
    for (const i in obj) {
      this.addEventListener(i, obj[i]);
    }
  }
  /* eslint-disable-next-line */
  removeEventListener(name, callback) {
    const listeners = this.listeners[name];
    if (listeners) {
      const foundListeners = Array.from(listeners);
      const foundListener = foundListeners.find(({ callback: foundCallback }) => foundCallback === callback);
      if (foundListener) {
        listeners.delete(foundListener);
      }
    }
  }
  removeMultipleEventsListeners(obj) {
    for (const i in obj) {
      this.removeEventListener(i, obj[i]);
    }
  }
  dispatchEvent(name, ...args) {
    this._dispatchEvent(name, ...args);
  }
  dispatchResultableEvent(name, ...args) {
    return this._dispatchEvent(name, ...args);
  }
  cleanup() {
    this.listeners = {};
  }
  invokeListenerCallback(name, listener, ...args) {
    var _listener_options;
    if ((_listener_options = listener.options) === null || _listener_options === void 0 ? void 0 : _listener_options.once) {
      this.removeEventListener(name, listener.callback);
    }
    return listener.callback(...args);
  }
  _dispatchEvent(name, ...args) {
    const arr = [];
    const listeners = this.listeners[name];
    if (listeners) {
      const listenersLeft = Array.from(listeners);
      listenersLeft.forEach((listener) => {
        const result = this.invokeListenerCallback(name, listener, ...args);
        if (arr) {
          arr.push(result);
        }
      });
    }
    return arr;
  }
  constructor() {
    this.listeners = {};
    this.listeners = {};
  }
};

// src/shared/helpers/transform2CamelCase.ts
var import_lodash3 = __toESM(require_lodash());
var transform2CamelCase = (struct) => {
  if (Array.isArray(struct)) {
    return struct.map((item) => {
      if (typeof item !== "string") {
        return transform2CamelCase(item);
      }
      return item;
    });
  }
  return (0, import_lodash3.transform)(struct, (acc, item, key) => {
    if ((0, import_lodash3.isNil)(item)) {
      acc[(0, import_lodash3.camelCase)(key)] = item;
      return;
    }
    if (typeof item !== "object") {
      acc[(0, import_lodash3.camelCase)(key)] = item;
      return;
    }
    acc[(0, import_lodash3.camelCase)(key)] = transform2CamelCase(item);
  });
};

// src/shared/helpers/toSnakeCase.ts
var import_lodash4 = __toESM(require_lodash());
var toSnakeCase = (data) => import_lodash4.default.mapKeys(data, (v, k) => import_lodash4.default.snakeCase(k));

// src/shared/helpers/genUUID.ts
var genUUID = () => {
  let d = (/* @__PURE__ */ new Date()).getTime();
  let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1e3 || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    let r2 = Math.random() * 16;
    if (d > 0) {
      r2 = (d + r2) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r2 = (d2 + r2) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r2 : r2 & 3 | 8).toString(16);
  });
};

// src/lib/domains/Socket/BaseSocketController.ts
import pako from "pako";
function _define_property4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property4(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys3(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props3(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var SOCKETS_MAX_RECONNECT_COUNT = 50;
var BaseSocketController = class extends BaseEventListener {
  use(regexp, callback) {
    const condition = (event) => this._condition(regexp, event);
    if (!this.listeners.onMessage) {
      this.listeners.onMessage = /* @__PURE__ */ new Set([]);
    }
    const newCallback = {
      callback,
      condition
    };
    if (!this.listeners.onMessage.has(newCallback)) {
      this.listeners.onMessage.add(newCallback);
    }
    return this;
  }
  connect(accessToken = this.accessToken, socketUrl = this.socketUrl) {
    this.accessToken = accessToken;
    this.socketUrl = socketUrl;
    const { timePing, reconnectCount, maxReconnectCount } = this;
    let { timeOutReconnect } = this;
    if (reconnectCount === maxReconnectCount) {
      this.dispatchEvent("onReconnectionLimitOver");
      return;
    }
    ;
    if (timePing)
      clearTimeout(timePing);
    if (timeOutReconnect)
      clearTimeout(timeOutReconnect);
    if (!this.sessionId) {
      this.setSessionId();
    }
    const socket = new WebSocket(`${socketUrl}&socket_version=2.0`);
    socket.onopen = () => {
      const hasReconnect = this.reconnectCount > 0;
      const reconnectAfterExpired = this.isTicketExpired;
      this.reconnectCount = 0;
      this.connectionFailed = false;
      if (timePing)
        clearTimeout(timePing);
      this.dispatchEvent("onConnected", this.socket);
      if (hasReconnect) {
        this.dispatchEvent("onReconnected");
      }
      if (reconnectAfterExpired) {
        this.dispatchEvent("onReconnected");
        this.isTicketExpired = false;
      }
    };
    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const zipped = data.method.slice(-3) === "zip";
      const params = (0, import_lodash5.get)(data, "params", null);
      const adaptedData = _object_spread_props3(_object_spread4({}, (0, import_lodash5.omit)(data, "params")), {
        // @ts-ignore
        params: transform2CamelCase(zipped && params ? JSON.parse(pako.ungzip(atob(params), {
          to: "string"
        })) : params)
      });
      this.dispatchEvent("onMessage", adaptedData, this);
    };
    this.socket = socket;
    this.updatePing();
  }
  onClose(event) {
    const { maxReconnectCount, reconnectCount } = this;
    let { timePing, timeOutReconnect } = this;
    if (timePing)
      clearTimeout(timePing);
    timePing = null;
    this.reconnectCount = reconnectCount + 1;
    if (![
      4003,
      4004,
      4005,
      4006,
      1e3,
      1001
    ].includes(event["code"]) && reconnectCount !== maxReconnectCount) {
      if (!timeOutReconnect) {
        this.connect();
      } else {
        clearTimeout(timeOutReconnect);
        timeOutReconnect = null;
        timeOutReconnect = setTimeout(() => {
          this.connect();
        }, 1e3);
      }
    } else {
      if (timeOutReconnect) {
        clearTimeout(timeOutReconnect);
        timeOutReconnect = null;
      }
      if (![
        1e3,
        1001
      ].includes(event["code"])) {
        if (event["code"] === 4006) {
          this.dispatchEvent("onCloseConnection");
        } else {
          if (event["reason"] !== "you_kicked") {
            this.dispatchEvent("onKicked", event);
          }
          this.connectionFailed = true;
          this.dispatchEvent("onConferenceEnded");
        }
      }
    }
  }
  _dispatchEvent(name, ...args) {
    const arr = [];
    const listeners = this.listeners[name];
    if (listeners) {
      const listenersLeft = Array.from(listeners);
      listenersLeft.forEach((listener) => {
        const { condition } = listener;
        if (condition && condition(...args)) {
          const result = this.invokeListenerCallback(name, listener, ...args);
          if (arr) {
            arr.push(result);
          }
          return;
        }
        if (!condition) {
          const result = this.invokeListenerCallback(name, listener, ...args);
          if (arr) {
            arr.push(result);
          }
        }
      });
    }
    return arr;
  }
  constructor(options) {
    super(), this.options = options, this.socketUrl = "", this.accessToken = "", this.sessionId = "", this.connectionFailed = false, this.timePing = null, this.timeOutReconnect = null, this.updatePing = () => {
      const { socket } = this;
      if (this.timePing)
        clearTimeout(this.timePing);
      this.timePing = setTimeout(() => {
        if (socket) {
          socket.removeEventListener("close", this.onClose);
          socket.close(4300, "no ping");
          this.onClose({
            code: 4300
          });
        }
      }, 6e3);
    }, this.setSessionId = () => {
      const newSessionId = genUUID();
      this.sessionId = newSessionId;
    }, this.closeSocket = (code) => {
      const { socket } = this;
      if (!socket) {
        return;
      }
      if (code === 3e3) {
        clearTimeout(this.timePing);
        this.timePing = null;
        socket.removeEventListener("close", this.onClose);
      }
      socket.close(1e3, "gone away");
    }, this.send = (method, params) => {
      if (!this.socket)
        return;
      if (this.socket.readyState !== this.socket.OPEN) {
        console.error("Socket not connected or not exist", method);
        return;
      }
      const zipped = method.slice(-3) === "zip";
      try {
        this.socket.send(JSON.stringify({
          id: 2128506,
          jsonrpc: "2.0",
          method,
          // @ts-ignore
          params: zipped ? btoa(pako.gzip(JSON.stringify(params), {
            to: "string"
          })) : toSnakeCase(params)
        }));
      } catch (e) {
        console.error(e);
      }
    }, this._condition = (regexp, data) => regexp.test(data === null || data === void 0 ? void 0 : data.method);
    const { reconnectCount = 0, maxReconnectCount = +SOCKETS_MAX_RECONNECT_COUNT, isTicketExpired = false } = options || {};
    this.reconnectCount = reconnectCount;
    this.maxReconnectCount = maxReconnectCount;
    this.isTicketExpired = isTicketExpired;
  }
};

// src/lib/domains/Socket/InitSocket.ts
function _define_property5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property5(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys4(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props4(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var InitSocket_default = (socket, { callsStore }) => {
  socket.use(/(server:notify:main:connected)/i, (data) => {
    console.log("CONNECTED", data === null || data === void 0 ? void 0 : data.params);
  }).use(/(server:notify:main:heartbeat)/i, () => {
    socket.updatePing();
  }).use(/server:notify:calls:incoming_close/, (data) => {
    const callData = data === null || data === void 0 ? void 0 : data.params;
    if (!callData)
      return;
    const { setIncomingCallStatus, incomingCallData } = callsStore.getState();
    if (!incomingCallData)
      return;
    setIncomingCallStatus({
      status: "declinedByTarget",
      declineReason: callData === null || callData === void 0 ? void 0 : callData.reason
    });
  }).use(/server:notify:calls:confirmed/, (data) => {
    const callData = data === null || data === void 0 ? void 0 : data.params;
    if (!callData)
      return;
    const { incomingCallData, outgoingCalls } = callsStore.getState();
    if (!(incomingCallData || outgoingCalls))
      return;
    if (outgoingCalls) {
      callsStore.getState().setOutgoingCallData(_object_spread_props4(_object_spread5({}, callData), {
        callStatus: "accepted"
      }));
    }
  }).use(/server:notify:calls:timeout/, (data) => {
    var _data_params;
    callsStore.getState().setOutgoingCallStatus({
      callId: data === null || data === void 0 ? void 0 : (_data_params = data.params) === null || _data_params === void 0 ? void 0 : _data_params.callId,
      status: "declinedByCaller"
    });
  }).use(/server:notify:calls:incoming_declined/, () => {
    callsStore.getState().setIncomingCallStatus({
      status: "declinedByCaller"
    });
  }).use(/server:notify:calls:declined/, (data) => {
    var _data_params;
    callsStore.getState().setOutgoingCallStatus({
      callId: data === null || data === void 0 ? void 0 : (_data_params = data.params) === null || _data_params === void 0 ? void 0 : _data_params.callId,
      status: "declinedByTarget"
    });
  }).use(/server:notify:calls:incoming_call/, (data) => {
    const callData = data === null || data === void 0 ? void 0 : data.params;
    if (!callData)
      return;
    callsStore.getState().setIncomingCallData(_object_spread_props4(_object_spread5({}, callData), {
      callStatus: "active"
    }));
  });
};

// src/lib/styles/global.tsx
import { createGlobalStyle } from "styled-components";

// src/lib/theme/shared/config/dark.ts
import { createTheme } from "@mui/material/styles";

// src/lib/theme/types.ts
var Unit;
(function(Unit2) {
  Unit2["Pixel"] = "px";
  Unit2["RootElement"] = "rem";
  Unit2["Emphasized"] = "em";
  Unit2["Percent"] = "%";
})(Unit || (Unit = {}));
var Colors;
(function(Colors2) {
  Colors2["Blue"] = "blue";
  Colors2["Green"] = "green";
  Colors2["Red"] = "red";
  Colors2["Yellow"] = "yellow";
  Colors2["Grey"] = "grey";
  Colors2["White"] = "white";
  Colors2["Black"] = "black";
})(Colors || (Colors = {}));
var Fonts;
(function(Fonts2) {
  Fonts2["Common"] = "common";
  Fonts2["Small"] = "small";
  Fonts2["Medium"] = "medium";
  Fonts2["Large"] = "large";
  Fonts2["H1"] = "h1";
  Fonts2["H2"] = "h2";
  Fonts2["H3"] = "h3";
  Fonts2["H4"] = "h4";
  Fonts2["H5"] = "h5";
  Fonts2["H6"] = "h6";
  Fonts2["LineHeight"] = "lineHeight";
  Fonts2["Regular"] = "regular";
  Fonts2["SemiBold"] = "semiBold";
  Fonts2["Bold"] = "bold";
})(Fonts || (Fonts = {}));
var Breakpoints;
(function(Breakpoints2) {
  Breakpoints2["XXS"] = "xxs";
  Breakpoints2["Mobile"] = "mobile";
  Breakpoints2["XS"] = "xs";
  Breakpoints2["SM"] = "sm";
  Breakpoints2["MD"] = "md";
  Breakpoints2["Tablet"] = "tablet";
  Breakpoints2["Desktop"] = "desktop";
  Breakpoints2["LG"] = "lg";
  Breakpoints2["XL"] = "xl";
  Breakpoints2["XXL"] = "xxl";
})(Breakpoints || (Breakpoints = {}));

// src/lib/theme/shared/constants/breakpoints.ts
var BREAKPOINTS = {
  xxs: 270,
  mobile: 390,
  xs: 480,
  sm: 576,
  md: 768,
  tablet: 768,
  desktop: 1024,
  lg: 1024,
  xl: 1440,
  xxl: 2560
};
var breakpoints_default = BREAKPOINTS;

// src/lib/theme/shared/utils.ts
var hexToRgb = (hex, alpha = 1, isRgbOnly = false) => {
  const channels = parseInt(hex.slice(1, 7), 16);
  const r2 = channels >> 16 & 255;
  const g = channels >> 8 & 255;
  const b = channels & 255;
  const type = isRgbOnly ? "rgb" : "rgba";
  const rgb = [
    r2,
    g,
    b
  ];
  if (!isRgbOnly) {
    rgb.push(alpha);
  }
  return `${type}(${rgb.join(",")})`;
};

// src/lib/theme/shared/constants/colors/black.ts
var black = {
  20: hexToRgb("#111314", 0.2),
  40: hexToRgb("#111314", 0.4),
  60: hexToRgb("#111314", 0.6),
  80: hexToRgb("#111314", 0.8),
  100: "#111314"
};

// src/lib/theme/shared/constants/colors/blue.ts
var blue = {
  25: "#F5F9FF",
  50: "#E5EFFF",
  100: "#CCDFFF",
  200: "#99C0FF",
  300: "#68A2FF",
  400: "#3381FF",
  500: "#0062FF",
  600: "#004ECC",
  700: "#0044B2",
  800: "#003B99",
  900: "#003180",
  950: "#002766",
  975: "#001D4C",
  // camelCase will transformed to cebab-case
  "post-quant": "#689FFF"
};

// src/lib/theme/shared/constants/colors/green.ts
var green = {
  25: "#F7FDF9",
  50: "#EAFAF0",
  100: "#D6F5E1",
  200: "#ADEBC4",
  300: "#84E1A6",
  400: "#46D27A",
  500: "#2FC063",
  600: "#28A455",
  700: "#23904B",
  800: "#1E7B40",
  900: "#196735",
  950: "#14522B",
  975: "#0F3E20"
};

// src/lib/theme/shared/constants/colors/grey.ts
var grey = {
  25: "#FAFCFF",
  50: "#F5F7F9",
  100: "#EBEDF0",
  200: "#D6DBE4",
  300: "#C4CBD6",
  400: "#A9B0BC",
  500: "#898E96",
  600: "#666A73",
  700: "#4E5158",
  800: "#43464B",
  900: "#3A3C41",
  950: "#292A2E",
  975: "#202124"
};

// src/lib/theme/shared/constants/colors/red.ts
var red = {
  25: "#FFF7F7",
  50: "#FEE6E6",
  100: "#FDCECE",
  200: "#FB9D9D",
  300: "#FA7979",
  400: "#F94C4C",
  500: "#F60909",
  600: "#DB0808",
  700: "#AC0606",
  800: "#940505",
  900: "#7B0404",
  950: "#620404",
  975: "#4A0303"
};

// src/lib/theme/shared/constants/colors/white.ts
var white = {
  20: hexToRgb("#ffffff", 0.2),
  40: hexToRgb("#ffffff", 0.4),
  60: hexToRgb("#ffffff", 0.6),
  80: hexToRgb("#ffffff", 0.8),
  100: "#ffffff"
};

// src/lib/theme/shared/constants/colors/yellow.ts
var yellow = {
  25: "#FFFCF5",
  50: "#FFF8E6",
  100: "#FEF2CC",
  200: "#FEE59A",
  300: "#FDD868",
  500: "#FDAE1C",
  400: "#FCC51C",
  600: "#F79008",
  700: "#E26B03",
  800: "#C44D08",
  900: "#8D350C",
  950: "#732C0C",
  975: "#5F2207"
};

// src/lib/theme/shared/helpers.ts
var getSizeUnit = (size, unit = Unit.RootElement) => {
  if (typeof size === "string") {
    return size;
  }
  switch (unit) {
    case "px":
      return `${size}px`;
    case "%":
      return `${size}%`;
    case "em":
      return `${+size / 10}em`;
    case "rem":
    default:
      return `${+size / 10}rem`;
  }
};

// src/lib/theme/shared/constants/fonts.ts
var FONT_FAMILY = "VTBGroupUIWebBook, sans-serif";
var FONTS = {
  common: getSizeUnit(14),
  small: getSizeUnit(12),
  medium: getSizeUnit(14),
  large: getSizeUnit(16),
  h1: getSizeUnit(60),
  h2: getSizeUnit(32),
  h3: getSizeUnit(28),
  h4: getSizeUnit(24),
  h5: getSizeUnit(20),
  h6: getSizeUnit(18),
  lineHeight: 1.215,
  regular: 300,
  semiBold: 400,
  bold: 500
};
var fonts_default = FONTS;

// src/lib/theme/shared/config/dark.ts
function _define_property6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property6(target, key, source[key]);
    });
  }
  return target;
}
var PALETTE = {
  primary: blue[500],
  secondary: grey[100],
  info: grey[900],
  success: green[500],
  error: red[300],
  text: {
    primary: grey[100],
    secondary: grey[500]
  }
};
var DARK_THEME = (theme) => {
  const { fontFamily = FONT_FAMILY } = theme.typography || {};
  return createTheme({
    breakpoints: {
      step: 4,
      keys: Object.values(Breakpoints),
      values: breakpoints_default
    },
    palette: {
      mode: "dark",
      primary: {
        main: PALETTE.primary
      },
      secondary: {
        // Buttons
        main: PALETTE.secondary
      },
      info: {
        // Buttons
        main: PALETTE.info
      },
      success: {
        main: PALETTE.success
      },
      error: {
        // Buttons
        main: PALETTE.error
      },
      text: PALETTE.text,
      background: {
        default: black[100]
      },
      tonalOffset: 0.115
    },
    typography: {
      button: {
        fontFamily,
        fontSize: getCssVar("font", "common"),
        fontWeight: getCssVar("font", "semi-bold"),
        lineHeight: getSizeUnit(18),
        textAlign: "center",
        textTransform: "none"
      },
      h1: {
        fontFamily,
        fontSize: getCssVar("font", "h1"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(70)
      },
      h2: {
        fontFamily,
        fontSize: getCssVar("font", "h2"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(36)
      },
      h3: {
        fontFamily,
        fontSize: getCssVar("font", "h3"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(38)
      },
      h4: {
        fontFamily,
        fontSize: getCssVar("font", "h4"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(30)
      },
      h5: {
        fontFamily,
        fontSize: getCssVar("font", "h5"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(24)
      },
      h6: {
        fontFamily,
        fontSize: getCssVar("font", "h6"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(22)
      },
      body1: {
        fontFamily,
        color: grey[100],
        fontSize: getCssVar("font", "common"),
        lineHeight: getSizeUnit(18)
      },
      body2: {
        fontFamily,
        color: grey[100],
        fontSize: getCssVar("font", "large"),
        fontWeight: getCssVar("font", "bold"),
        lineHeight: getSizeUnit(22)
      },
      caption: {
        fontFamily,
        fontSize: getCssVar("font", "small"),
        lineHeight: getSizeUnit(14),
        color: grey[500],
        letterSpacing: "0.2px"
      }
    },
    components: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      MuiListItem: {
        styleOverrides: {
          root: {
            width: "auto"
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          sizeLarge: {
            height: getSizeUnit(48),
            padding: "0 1.6rem",
            borderRadius: ".6rem",
            fontSize: getCssVar("font", "large"),
            fontWeight: getCssVar("font", "bold"),
            lineHeight: getSizeUnit(20),
            letterSpacing: "0.1px"
          },
          sizeMedium: {
            height: getSizeUnit(38),
            padding: "0 1.6rem",
            fontSize: getCssVar("font", "common"),
            fontWeight: getCssVar("font", "bold")
          },
          sizeSmall: {
            height: getSizeUnit(32),
            padding: "0 1.2rem",
            fontSize: getCssVar("font", "common"),
            fontWeight: getCssVar("font", "bold"),
            lineHeight: getSizeUnit(18)
          },
          containedPrimary: {
            background: getCssVar("blue", 500),
            color: getCssVar("grey", 100),
            "&:hover": {
              background: getCssVar("blue", 700)
            },
            "&:active": {
              background: getCssVar("blue", 900)
            }
          },
          containedSecondary: {
            background: getCssVar("grey", 900),
            color: getCssVar("grey", 100),
            "&:hover": {
              background: getCssVar("grey", 950)
            },
            "&:active": {
              background: getCssVar("grey", 975)
            }
          },
          textPrimary: {
            color: getCssVar("blue", 300),
            "&:hover": {
              background: "transparent",
              color: getCssVar("blue", 400)
            },
            "&:active": {
              background: "transparent",
              color: getCssVar("blue", 500)
            }
          },
          textSecondary: {
            color: getCssVar("grey", 100),
            "&:hover": {
              background: getCssVar("grey", 950)
            },
            "&:active": {
              background: getCssVar("grey", 975)
            }
          },
          textError: {
            background: getCssVar("grey", 900),
            color: getCssVar("red", 300),
            "&:hover": {
              background: getCssVar("grey", 900),
              color: getCssVar("red", 400)
            },
            "&:active": {
              background: getCssVar("grey", 975),
              color: getCssVar("red", 400)
            }
          }
        }
      },
      MuiLink: {
        styleOverrides: {
          root: ({ color: color2 = "primary" }) => {
            const linkState = color2 === "primary" && {
              color: getCssVar("blue", 300),
              "&:hover": {
                color: getCssVar("blue", 500)
              },
              "&:active": {
                color: getCssVar("blue", 700)
              }
            } || {};
            return _object_spread6({
              fontSize: getCssVar("font", "common"),
              fontWeight: getCssVar("font", "semi-bold"),
              textDecoration: "none",
              transition: "all .27s",
              cursor: "pointer"
            }, linkState);
          }
        }
      },
      MuiSlider: {
        styleOverrides: {
          thumbSizeSmall: {
            width: "auto",
            height: "inherit"
          }
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: () => ({
            fontFamily,
            fontWeight: getCssVar("font", "semi-bold")
          })
        }
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: getCssVar("font", "common")
          }
        }
      },
      // @ts-ignore
      MuiPickersLayout: {
        styleOverrides: {
          root: {
            marginTop: 8
          }
        }
      },
      MuiDateCalendar: {
        styleOverrides: {
          root: {
            minHeight: "356px",
            backgroundColor: getCssVar("grey", 900),
            borderRadius: 6,
            border: "0",
            padding: "24px 0px"
          }
        }
      },
      MuiDayCalendar: {
        styleOverrides: {
          root: {},
          weekDayLabel: {
            fontSize: getCssVar("font", "common"),
            color: getCssVar("grey", 100),
            margin: 0
          },
          weekContainer: {
            ".MuiPickersDay-root": {
              fontSize: getCssVar("font", "common"),
              color: getCssVar("grey", 100),
              margin: 0,
              "&.MuiPickersDay-today": {
                border: 0,
                borderRadius: "50%",
                outline: `1px solid ${getCssVar("grey", 100)}`,
                backgroundColor: "transparent"
              },
              "&:hover": {
                backgroundColor: getCssVar("blue", 700)
              }
            }
          }
        }
      },
      MuiMonthCalendar: {
        styleOverrides: {
          root: {
            marginTop: 28,
            ".MuiPickersMonth-monthButton": {
              fontSize: getCssVar("font", "large"),
              color: getCssVar("grey", 100),
              border: 0,
              outline: "1px solid transparent",
              "&.Mui-selected": {
                border: 0,
                outlineColor: `${getCssVar("grey", 100)}`,
                backgroundColor: "transparent"
              },
              "&:hover": {
                backgroundColor: "transparent",
                borderColor: `${getCssVar("blue", 300)}`
              }
            }
          }
        }
      },
      MuiYearCalendar: {
        styleOverrides: {
          root: {
            "::-webkit-scrollbar-thumb": {
              background: " #898E9600",
              " border-radius": "4px",
              transition: "background 0.4s"
            },
            "::-webkit-scrollbar": {
              background: "#00000000",
              width: "4px",
              opacity: "0"
            },
            "&:hover::-webkit-scrollbar-thumb": {
              background: "#898E96 "
            },
            "&::-webkit-scrollbar-track-piece:end": {
              background: "transparent"
            },
            "&::-webkit-scrollbar-track-piece:start": {
              background: "transparent"
            },
            ".MuiPickersYear-yearButton": {
              fontSize: getCssVar("font", "common"),
              color: getCssVar("grey", 100),
              border: 0,
              outline: "1px solid transparent",
              "&.Mui-selected": {
                border: 0,
                outlineColor: `${getCssVar("grey", 100)}`,
                backgroundColor: "transparent"
              },
              "&:hover": {
                backgroundColor: "transparent",
                borderColor: `${getCssVar("blue", 300)}`
              }
            }
          }
        }
      },
      MuiSkeleton: {
        styleOverrides: {
          root: {
            "background-color": "rgba(224,224,224,0.05)"
          }
        }
      }
    }
  });
};
var dark_default = DARK_THEME;

// src/lib/theme/shared/config/light.ts
import { createTheme as createTheme2 } from "@mui/material/styles";
var LIGHT_THEME = (theme) => {
  const { fontFamily = "Roboto, Helvetica, Arial, sans-serif" } = theme.typography || {};
  return createTheme2({
    palette: {
      mode: "light"
    },
    typography: {
      fontFamily
    }
  });
};
var light_default = LIGHT_THEME;

// src/lib/theme/index.ts
var getTheme = (mode = "dark", theme) => mode === "light" ? light_default(theme) : dark_default(theme);

// src/lib/styles/global.tsx
var GlobalStyle = createGlobalStyle`
  :root {
    ${map2CssVars(fonts_default, "font")}
    ${map2CssVars(breakpoints_default, "bp")}
    --font-family: ${FONT_FAMILY};
    --smooth-transition: .27s;
    --color-light-transparent: rgba(255, 255, 255, 0.2);

    ${map2CssVars(red, "red")}
    ${map2CssVars(green, "green")}
    ${map2CssVars(blue, "blue")}
    ${map2CssVars(grey, "grey")}
    ${map2CssVars(yellow, "yellow")}
    ${map2CssVars(black, "black")}
    ${map2CssVars(white, "white")}
  }

  html {
    font-family: var(--font-family);
    font-weight: ${getCssVar("font", "semi-bold")};
    color: ${getCssVar("grey", 100)};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: auto;
  }
`;
var global_default = GlobalStyle;

// src/shared/constants/calls.ts
var CALL_STATUS = {
  active: "active",
  ignored: "ignored",
  success: "success",
  declinedByCaller: "declined_by_caller",
  declinedByTarget: "declined_by_target",
  accepted: "accepted",
  notAnswered: "not_answered",
  busy: "busy",
  declined: "declined",
  closed: "closed",
  notAvailable: "not_available",
  notExist: "not_exist",
  cancelled: "cancelled",
  completed: "completed",
  invited: "invited",
  error: "error"
};
var CALL_DIRECTION = {
  in: "in",
  out: "out"
};
var CallStatusText = {
  accepted: () => Translate_default.get("calls.callStatus.accepted"),
  active: () => Translate_default.get("calls.callStatus.active"),
  declinedByCaller: () => Translate_default.get("calls.callStatus.declinedByCaller"),
  declinedByTarget: () => Translate_default.get("calls.callStatus.declinedByTarget"),
  succeeded: () => Translate_default.get("calls.callStatus.succeeded"),
  notAnswered: () => Translate_default.get("calls.callStatus.notAnswered"),
  busy: () => Translate_default.get("calls.callStatus.busy"),
  declined: () => Translate_default.get("calls.callStatus.declined"),
  closed: () => Translate_default.get("calls.callStatus.closed"),
  ignored: () => Translate_default.get("calls.callStatus.ignored"),
  notAvailable: () => Translate_default.get("calls.callStatus.notAvailable"),
  notExist: () => Translate_default.get("calls.callStatus.notExist"),
  cancelled: () => Translate_default.get("calls.callStatus.cancelled"),
  completed: () => Translate_default.get("calls.callStatus.completed"),
  invited: () => Translate_default.get("calls.callStatus.invited")
};

// src/shared/constants/cookienames.ts
var BACKGROUND_DELETE_IMMEDIATELY = "background-delete-immediately";
var BACKGROUND_POPUP_CLOSED = "background-popup-closed";
var BACKGROUND_SETTINGS_VISITED = "background-settings-visited";
var VIRTUAL_BACKGROUND = "virtual-background";
var MIC_ITEM = "audioinput_id_selected";
var CAMERA_ITEM = "videoinput_selected";
var DYNAMIC_ITEM = "audiooutput_selected";
var CALLS_ICON_POPPER_SHOW = "calls_icon_popper_show";
var VIDEO_QUALITY = "video_quality";
var SCREENSHARING_QUALITY = "screensharing_quality";
var NOISE_SUPRESSION = "noise_suppression_enabled";
var INPUT_VIDEO_QUALITY = "input_video_quality";

// src/shared/constants/support.ts
var SUPPORT_MAIL = "support@diongo.ru";
var SUPPORT_PHONE = "8(800)600-83-57";
var SUPPORT_PHONE_WITH_SPACES = "8 (800) 600-83-57";

// src/shared/constants/ui.ts
var TINY_SCROLLBAR_STYLES = `
  &::-webkit-scrollbar {
    width: ${getSizeUnit(6)};
    height: ${getSizeUnit(6)};
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: ${getSizeUnit(6)};
  }

  &::-webkit-scrollbar-thumb:vertical {
    min-height: ${getSizeUnit(18)};
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: ${getCssVar("grey", 900)};
    }
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${getCssVar("grey", 500)};
  }
  `;

// src/shared/constants/desktop.ts
var CompareVersion;
(function(CompareVersion2) {
  CompareVersion2["Above"] = "above";
  CompareVersion2["Less"] = "less";
  CompareVersion2["Equal"] = "equal";
  CompareVersion2["Error"] = "error";
  CompareVersion2["Default"] = "default";
})(CompareVersion || (CompareVersion = {}));

// src/shared/formatters/compareDates.ts
var sortDatesAscending = (date1, date2) => {
  if (dayjs(date1).isBefore(dayjs(date2))) {
    return -1;
  }
  if (dayjs(date2).isBefore(dayjs(date1))) {
    return 1;
  }
  return 0;
};
var sortDateDescending = (date1, date2) => {
  if (dayjs(date1).isBefore(dayjs(date2))) {
    return -1;
  }
  if (dayjs(date2).isBefore(dayjs(date1))) {
    return 1;
  }
  return 0;
};

// src/shared/formatters/dayTime.ts
var formatDayTime = (_date) => {
  const date = dayjs(_date);
  return date.format("H:mm");
};
var formatDate = (_date, template) => {
  const date = dayjs(_date);
  return date.isValid() ? date.format(template) : "";
};

// src/shared/formatters/constants.ts
var DAYS_LABELS = [
  "formatters.daysLabel.today",
  "formatters.daysLabel.yesterday"
];

// src/shared/formatters/humanDayTimeline.ts
var formatHumanDayTimeline = (_date, [_5, yesterdayLabel] = DAYS_LABELS) => {
  const date = dayjs(_date);
  const today = dayjs().startOf("day").toDate();
  const yesterday = dayjs().add(-1, "day").startOf("day").toDate();
  const thisYear = dayjs().startOf("year").toDate();
  const isToday = date.isAfter(today);
  const isYesterday = date.isBefore(today) && date.isAfter(yesterday);
  const isThisYear = date.isAfter(thisYear);
  if (isToday) {
    return date.format("H:mm");
  }
  if (isYesterday) {
    return Translate_default.get(yesterdayLabel);
  }
  if (isThisYear) {
    return date.format("DD.MM");
  }
  return date.format("DD.MM.YY");
};

// src/shared/formatters/humanTime.ts
var getHumanTime = (ms) => {
  const hours = Math.floor(ms / 3600);
  const minutes = Math.floor(ms % 3600 / 60);
  const seconds = Math.floor(ms % 3600 % 60);
  const formattedHours = `0${hours}`.slice(-2);
  const formattedMinutes = `0${minutes}`.slice(-2);
  const formattedSeconds = `0${seconds}`.slice(-2);
  return [
    formattedHours,
    formattedMinutes,
    formattedSeconds
  ];
};
var formatHumanTime = (msOrDigits) => Array.isArray(msOrDigits) ? msOrDigits.join(":") : getHumanTime(msOrDigits);

// src/shared/formatters/humanTimeline.ts
var formatHumanTimeline = (_date, [todayLabel, yesterdayLabel] = DAYS_LABELS) => {
  const date = dayjs(_date);
  const today = dayjs().startOf("day").toDate();
  const yesterday = dayjs().add(-1, "day").startOf("day").toDate();
  const isToday = date.isAfter(today);
  const isYesterday = date.isBefore(today) && date.isAfter(yesterday);
  if (isToday) {
    return Translate_default.get(todayLabel);
  }
  if (isYesterday) {
    return Translate_default.get(yesterdayLabel);
  }
  return date.format("D MMM");
};

// src/shared/formatters/monthNameAndDate.ts
var formatMonthNameAndDate = (date) => dayjs(date).format("D MMMM YYYY");

// src/shared/formatters/recordTimeDuration.ts
import duration2 from "dayjs/plugin/duration";
dayjs.extend(duration2);
var formatRecordTime = (value) => dayjs.duration(value, "seconds").format("HH:mm:ss");

// src/shared/formatters/userPresense.ts
var formatUserPresense = (_date) => {
  if (!_date)
    return "";
  const date = dayjs(_date);
  const getText = (type, date2) => Translate_default.get(`formatters.userPresense.${type || "date"}`, {
    prefix: Translate_default.get("formatters.userPresense.prefix"),
    date: date2 || ""
  });
  const recently = dayjs().add(-5, "minute").toDate();
  const wasRecently = date.isAfter(recently);
  if (wasRecently) {
    return getText("recently");
  }
  const today = dayjs().startOf("day").toDate();
  const wasToday = date.isAfter(today);
  if (wasToday) {
    return getText("today", date.format("H:mm"));
  }
  const yesterday = dayjs().add(-1, "day").startOf("day").toDate();
  const wasYesterday = date.isBefore(today) && date.isAfter(yesterday);
  if (wasYesterday) {
    return getText("yesterday");
  }
  const thisYear = dayjs().startOf("year").toDate();
  const wasThisYear = date.isAfter(thisYear);
  if (wasThisYear) {
    return getText("thisYear", date.format("D MMMM"));
  }
  const thisDecade = dayjs().year(2020).startOf("year");
  const wasThisDecade = date.isAfter(thisDecade);
  if (wasThisDecade) {
    return getText("date", date.format("D MMMM YYYY"));
  }
  return getText("yearsAgo");
};

// src/shared/formatters/formatFileSize.ts
var formatFileSize = (size, locale = "ru", fix = 1) => {
  if (size <= 0)
    return `0 ${locale === "ru" ? "Б" : "B"}`;
  const units = locale === "ru" ? [
    "Б",
    "Кб",
    "Мб",
    "Гб",
    "Тб"
  ] : [
    "B",
    "KB",
    "MB",
    "GB",
    "TB"
  ];
  const base = 1024;
  const exponent = Math.floor(Math.log(size) / Math.log(base));
  return `${(size / Math.pow(base, exponent)).toFixed(fix)} ${units[exponent]}`;
};

// src/shared/helpers/copy2Clipboard.ts
var copy2Clipboard = (text, callback) => {
  navigator.clipboard.writeText(text).then(() => {
    if (callback) {
      callback(true);
    }
    setTimeout(() => {
      if (callback) {
        callback(false);
      }
    }, 5e3);
  }).catch(console.error);
};

// src/shared/helpers/PascalCase.ts
var import_lodash6 = __toESM(require_lodash());
var PascalCase = (str) => {
  const camelCased = import_lodash6.default.camelCase(str);
  return [
    import_lodash6.default.upperCase(camelCased.substring(0, 1)),
    camelCased.substring(1)
  ].join("");
};

// src/shared/helpers/pluralize.ts
var pluralize = (number, [one, two, five]) => {
  const n = Math.abs(number);
  return n % 100 >= 5 && n % 100 <= 20 ? five : n % 10 === 1 ? one : n >= 2 && n <= 4 ? two : five;
};

// src/shared/helpers/toCamelCase.ts
var import_lodash7 = __toESM(require_lodash());
var toCamelCase = (data) => import_lodash7.default.mapKeys(data, (v, k) => import_lodash7.default.camelCase(k));
var transform2CamelCase2 = (struct) => {
  if (Array.isArray(struct)) {
    return struct.map((item) => {
      if (typeof item === "string") {
        return item;
      }
      return transform2CamelCase2(item);
    });
  }
  return import_lodash7.default.transform(struct, (acc, item, key) => {
    if (import_lodash7.default.isNil(item)) {
      acc[import_lodash7.default.camelCase(key)] = item;
      return;
    }
    if (typeof item !== "object") {
      acc[import_lodash7.default.camelCase(key)] = item;
      return;
    }
    acc[import_lodash7.default.camelCase(key)] = transform2CamelCase2(item);
  });
};

// src/shared/helpers/toKebabCase.ts
var import_lodash8 = __toESM(require_lodash());
var toKebabCase = (data) => import_lodash8.default.mapKeys(data, (v, k) => import_lodash8.default.kebabCase(k));

// src/shared/helpers/parseApiError.ts
var parseApiError = (err) => {
  var _err_response_data, _err_response, _err_response_data1, _err_response1, _data_additional_fields;
  const { data } = (err === null || err === void 0 ? void 0 : err.response) || {};
  let message = (err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message) || "";
  const code = (err === null || err === void 0 ? void 0 : (_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : (_err_response_data1 = _err_response1.data) === null || _err_response_data1 === void 0 ? void 0 : _err_response_data1.code) || "";
  const validation_errors = data === null || data === void 0 ? void 0 : data.validation_errors;
  const lock_expires_at = data === null || data === void 0 ? void 0 : (_data_additional_fields = data.additional_fields) === null || _data_additional_fields === void 0 ? void 0 : _data_additional_fields.lock_expires_at;
  if (validation_errors) {
    message = validation_errors.map(({ message: message2 }) => `${message2}`);
  }
  if (lock_expires_at) {
    message = `${message} ${dayjs(lock_expires_at).format("HH:mm DD.MM.YYYY")}`;
  }
  return {
    message,
    code
  };
};

// src/shared/helpers/checkIsDesktopActive.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var checkIsDesktopActive = function() {
  var _ref = _async_to_generator(function* () {
    return fetch("https://localdaemon.dion.vc:44951/dion/desktop/open-url").then((res) => res.json()).then((res) => res.opened).catch(() => false);
  });
  return function checkIsDesktopActive2() {
    return _ref.apply(this, arguments);
  };
}();

// src/shared/helpers/typescript.ts
function notReachable(_5) {
  throw new Error(`Should never be reached ${_5}`);
}

// src/shared/helpers/image.ts
var getImageUrl = (url, accessToken) => url ? `${url}?authorization=${accessToken}` : "";

// src/shared/helpers/checkURLisValid.ts
function validURL(str) {
  const pattern = new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i");
  return !!pattern.test(str.split("@")[0]);
}

// src/shared/model/useDebounce/index.tsx
import { useCallback, useRef } from "react";
var useDebounce = (fn, wait) => {
  const timeoutPointer = useRef();
  const clear = useCallback(() => clearTimeout(timeoutPointer.current), [
    timeoutPointer
  ]);
  const debounce = useCallback((...args) => {
    clear();
    timeoutPointer.current = setTimeout(() => {
      fn(...args);
      clear();
    }, wait);
  }, [
    wait,
    fn,
    clear
  ]);
  return {
    debounce,
    clear
  };
};
var useDebounce_default = useDebounce;

// src/shared/model/useMenu/index.tsx
import { jsx as _jsx227 } from "react/jsx-runtime";
import { useCallback as useCallback12, useMemo as useMemo12, useState as useState18 } from "react";

// src/shared/ui/avatar/index.tsx
import { jsx as _jsx4 } from "react/jsx-runtime";

// src/shared/ui/avatar/shared/ui.tsx
import { Avatar as MuiAvatar } from "@mui/material";
import styled2 from "styled-components";
var StyledAvatar = styled2(MuiAvatar)``;
var AvatarWrapper = styled2.div`
  display: flex;
  flex: ${({ size = 40 }) => `0 0 ${getSizeUnit(size)}`};
  align-items: center;
  justify-content: center;
  width: ${({ size = 40 }) => getSizeUnit(size)};
  height: ${({ size = 40 }) => getSizeUnit(size)};
  background: ${getCssVar("grey", 900)};
  border: 0 solid transparent;
  border-radius: 50%;
  font-size: ${getCssVar("font", "common")};
  font-weight: ${getCssVar("font", "bold")};
  text-transform: uppercase;
  overflow: hidden;

  ${StyledAvatar} {
    display: flex;
    width: 100%;
    height: 100%;
    border: 0;
    background: inherit;
    font-size: inherit;
    font-weight: inherit;
    color: currentColor;
  }
`;
var AvatarImage = styled2.img``;

// src/shared/ui/avatar/index.tsx
function _define_property7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property7(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties2(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Avatar = (_param) => {
  var { size = 40, className, style: style4, src, alt = "avatar" } = _param, props = _object_without_properties2(_param, [
    "size",
    "className",
    "style",
    "src",
    "alt"
  ]);
  return /* @__PURE__ */ _jsx4(AvatarWrapper, {
    className,
    size,
    style: style4,
    children: /* @__PURE__ */ _jsx4(StyledAvatar, _object_spread7({
      src,
      alt
    }, props))
  });
};
var avatar_default = Avatar;

// src/shared/ui/bottom-navigation/index.tsx
import { jsx as _jsx5 } from "react/jsx-runtime";

// src/shared/ui/bottom-navigation/shared/ui.tsx
import styled3 from "styled-components";
import { BottomNavigation as MuiBottomNavigation, BottomNavigationAction as MuiBottomNavigationAction } from "@mui/material";
var StyledBottomNavigation = styled3(MuiBottomNavigation)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 8.2rem;
  background: ${getCssVar("grey", 950)};
  border: 0 transparent solid;
  border-radius: 1.2rem 1.2rem 0 0;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.45);
  z-index: 10;
`;
var StyledBottomNavigationAction = styled3(MuiBottomNavigationAction)`
  &[class*=selected] {
    color: ${getCssVar("grey", 200)};
  }

  span:first-of-type {
    margin-top: .4rem;
    font-size: 1rem;
  }
`;

// src/shared/ui/bottom-navigation/index.tsx
function _define_property8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property8(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties3(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BottomNavigation = (_param) => {
  var { sx } = _param, props = _object_without_properties3(_param, [
    "sx"
  ]);
  return /* @__PURE__ */ _jsx5(StyledBottomNavigation, _object_spread8({}, props));
};
var bottom_navigation_default = BottomNavigation;

// src/shared/ui/box/index.tsx
import { jsx as _jsx6 } from "react/jsx-runtime";
import { Box as MuiBox } from "@mui/material";
function _define_property9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property9(target, key, source[key]);
    });
  }
  return target;
}
var Box = (props) => /* @__PURE__ */ _jsx6(MuiBox, _object_spread9({}, props));
var box_default = Box;

// src/shared/ui/breadcrumbs/index.tsx
import { jsx as _jsx7 } from "react/jsx-runtime";

// src/shared/ui/breadcrumbs/shared/ui.ts
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import styled4 from "styled-components";
var StyledBreadcrumbs = styled4(MuiBreadcrumbs)`
  margin: 2.4rem 0;
  color: inherit;

  a {
    color: inherit;

    &:hover {
      font-weight: ${getCssVar("font", "bold")};
      color: ${getCssVar("grey", 500)};
    }
  }

  @media screen and (min-width: ${breakpoints_default.md}px) {
    margin: 1.6rem 0;
  }
`;

// src/shared/ui/breadcrumbs/index.tsx
function _define_property10(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread10(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property10(target, key, source[key]);
    });
  }
  return target;
}
var Breadcrumbs = (props) => /* @__PURE__ */ _jsx7(StyledBreadcrumbs, _object_spread10({}, props));
var breadcrumbs_default = Breadcrumbs;

// src/shared/ui/button/index.tsx
import { jsx as _jsx9, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";

// src/shared/ui/button/shared/ui.ts
import styled5 from "styled-components";
import { Button as MuiButton } from "@mui/material";
var StyledButton = styled5(MuiButton)`
  min-width: auto;
  max-width: none;
`;

// src/shared/ui/button/shared/IconButton.tsx
import { jsx as _jsx8 } from "react/jsx-runtime";
import { IconButton as MuiIconButton } from "@mui/material";
function _define_property11(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread11(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property11(target, key, source[key]);
    });
  }
  return target;
}
var IconButton = (props) => /* @__PURE__ */ _jsx8(MuiIconButton, _object_spread11({}, props));
var IconButton_default = IconButton;

// src/shared/ui/button/index.tsx
function _define_property12(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread12(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property12(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties4(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Button = (_param) => {
  var { component: Component, to } = _param, props = _object_without_properties4(_param, [
    "component",
    "to"
  ]);
  const Wrapper4 = useMemo(() => ({ children }) => {
    if (Component) {
      return /* @__PURE__ */ _jsx9(Component, {
        href: to,
        children
      });
    }
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      /* @__PURE__ */ _jsx9(_Fragment, {
        children
      })
    );
  }, [
    Component,
    to
  ]);
  return /* @__PURE__ */ _jsx9(Wrapper4, {
    children: /* @__PURE__ */ _jsx9(StyledButton, _object_spread12({
      disableRipple: true
    }, props))
  });
};
var button_default = Button;

// src/shared/ui/card/index.tsx
import { jsx as _jsx11, jsxs as _jsxs2, Fragment as _Fragment2 } from "react/jsx-runtime";
import { useMemo as useMemo2 } from "react";

// src/shared/ui/divider/index.tsx
import { jsx as _jsx10 } from "react/jsx-runtime";

// src/shared/ui/divider/shared/ui.tsx
import { Divider as MuiDivider } from "@mui/material";
import styled6 from "styled-components";
var StyledDivider = styled6(MuiDivider)`
  background: ${getCssVar("grey", 900)};
`;

// src/shared/ui/divider/index.tsx
function _define_property13(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread13(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property13(target, key, source[key]);
    });
  }
  return target;
}
var Divider = (props) => /* @__PURE__ */ _jsx10(StyledDivider, _object_spread13({}, props));
var divider_default = Divider;

// src/shared/ui/card/shared/ui.ts
import { Card as MuiCard } from "@mui/material";
import styled7 from "styled-components";
var StyledCard = styled7(MuiCard)`
  display: flex;
  flex: ${({ isFullHeight = false }) => isFullHeight ? "1 0 100%" : 1};
  flex-direction: column;
  width: ${({ isFullWidth = false }) => isFullWidth ? "100%" : "auto"};
  height: ${({ isFullHeight = false }) => isFullHeight ? "100%" : "auto"};
  background: ${getCssVar("grey", 950)};
  border: 0 solid ${getCssVar("grey", 900)};
  border-radius: ${({ footer }) => footer ? ".8rem .8rem 0 0" : ".8rem"};
`;
var CardTitleWrapper = styled7.div`
  display: flex;
  justify-content: space-between;
  padding: 2.4rem;
  font-size: ${getCssVar("font", "h5")};
  font-weight: ${getCssVar("font", "bold")};

  @media screen and (max-width: ${breakpoints_default.mobile}px) {
    padding: 1.6rem 1.6rem;

    .ml-auto > button {
      padding: 0 0.5rem;
      width: 120px;
    }
  }
`;
var CardContainer = styled7.div`
  display: flex;
  flex: 1;
  padding: 3.2rem 4rem;

  @media screen and (max-width: ${breakpoints_default.xs}px) {
    padding: 1.6rem;
    max-width: 100%;
  }

  @media screen and (max-width: ${breakpoints_default.mobile - 40}px) {
    flex-direction: column;
  }
`;
var CardFooter = styled7.div`
  display: flex;
  gap: 1.6rem;
  padding: 1.6rem 4rem;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.25);

  @media screen and (max-width: ${breakpoints_default.sm}px) {
    padding: 1.6rem;

    button {
      width: auto;
    }
  }

  @media screen and (max-width: ${breakpoints_default.xs}px) {
    flex-wrap: wrap;
    padding: 1.6rem 0.6rem;
  }
`;

// src/shared/ui/card/index.tsx
function _define_property14(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread14(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property14(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys5(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props5(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties5(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Card = (_param) => {
  var { isFullWidth = false, isFullHeight = false, title, children, footer, style: style4, titleStyle: titleStyle2, footerStyle, contentRef } = _param, props = _object_without_properties5(_param, [
    "isFullWidth",
    "isFullHeight",
    "title",
    "children",
    "footer",
    "style",
    "titleStyle",
    "footerStyle",
    "contentRef"
  ]);
  const titleComponent = useMemo2(() => {
    if (title) {
      return /* @__PURE__ */ _jsxs2(_Fragment2, {
        children: [
          /* @__PURE__ */ _jsx11(CardTitleWrapper, {
            style: titleStyle2,
            children: title
          }),
          /* @__PURE__ */ _jsx11(divider_default, {})
        ]
      });
    }
    return null;
  }, [
    title,
    titleStyle2
  ]);
  const content = useMemo2(() => {
    if (title) {
      return /* @__PURE__ */ _jsx11(CardContainer, {
        ref: contentRef,
        style: _object_spread_props5(_object_spread14({}, style4), {
          flexDirection: footer ? "column" : "row"
        }),
        children
      });
    }
    return children;
  }, [
    contentRef,
    children,
    title,
    footer,
    style4
  ]);
  const footerContent = useMemo2(() => {
    if (footer) {
      return /* @__PURE__ */ _jsx11(CardFooter, {
        style: footerStyle,
        children: footer
      });
    }
    return null;
  }, [
    footer,
    footerStyle
  ]);
  return /* @__PURE__ */ _jsxs2(StyledCard, _object_spread_props5(_object_spread14({
    isFullWidth,
    isFullHeight,
    footer
  }, props), {
    children: [
      titleComponent,
      content,
      footerContent
    ]
  }));
};
var card_default = Card;

// src/shared/ui/center-layout/index.tsx
import styled8 from "styled-components";
var CenterLayout = styled8.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 68px);
  overflow: hidden;
`;
var center_layout_default = CenterLayout;

// src/shared/ui/checkbox/index.tsx
import { jsx as _jsx154, jsxs as _jsxs67 } from "react/jsx-runtime";
import { useMemo as useMemo3 } from "react";

// src/shared/ui/icons/shared/AddGroup.tsx
import { jsx as _jsx12, jsxs as _jsxs3 } from "react/jsx-runtime";
import React5 from "react";
function _define_property15(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread15(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property15(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys6(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props6(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties6(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var AddGroup = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 200) } = _param, props = _object_without_properties6(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs3("svg", _object_spread_props6(_object_spread15({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx12("path", {
        d: "M13.2943 9.61474C13.2032 9.61474 13.114 9.61247 13.0267 9.60789C13.1116 9.13687 13.1679 8.64825 13.2027 8.1483C13.4489 5.84091 12.1576 3.97875 10.3712 3.01633C10.9928 2.09999 12.0731 1.5 13.2943 1.5C15.2947 1.5 17.0447 3.11725 16.8148 5.08293C16.5968 8.34534 15.4359 9.61474 13.2943 9.61474Z",
        fill
      }),
      /* @__PURE__ */ _jsx12("path", {
        d: "M7.58823 12.4963C5.44659 12.4963 4.37115 11.2468 4.11786 7.96452C3.9656 5.99146 5.58781 4.38159 7.58823 4.38159C9.58865 4.38159 11.3387 5.99883 11.1087 7.96452C10.8908 11.2269 9.72986 12.4963 7.58823 12.4963Z",
        fill
      }),
      /* @__PURE__ */ _jsx12("path", {
        d: "M9.48032 13.6302C8.8315 13.5088 8.1889 13.4293 7.61854 13.4293C6.53524 13.4293 5.19132 13.716 4.03918 14.0319C3.09939 14.2896 2.36687 14.9204 1.9351 15.7317L1.93322 15.7353C1.89256 15.8119 1.85457 15.8901 1.81935 15.9698C1.6118 16.4391 1.5 16.9585 1.5 17.4949C1.5 17.6693 1.64298 17.8108 1.81935 17.8108H8.88492C8.83919 17.4707 8.81558 17.1237 8.81558 16.7712C8.81558 15.6539 9.05287 14.5913 9.48032 13.6302Z",
        fill
      }),
      /* @__PURE__ */ _jsx12("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.5 16.7712C22.5 19.9352 19.9071 22.5 16.7087 22.5C13.5102 22.5 10.9173 19.9352 10.9173 16.7712C10.9173 13.6073 13.5102 11.0425 16.7087 11.0425C19.9071 11.0425 22.5 13.6073 22.5 16.7712ZM17.7595 13.7197C17.7595 13.4244 17.5175 13.1851 17.2191 13.1851H16.1982C15.8998 13.1851 15.6578 13.4244 15.6578 13.7197V15.7317H13.6237C13.3252 15.7317 13.0833 15.9711 13.0833 16.2663V17.2761C13.0833 17.5714 13.3252 17.8107 13.6237 17.8107H15.6578V19.8228C15.6578 20.1181 15.8998 20.3574 16.1982 20.3574H17.2191C17.5175 20.3574 17.7595 20.1181 17.7595 19.8228V17.8107H19.7936C20.0921 17.8107 20.334 17.5714 20.334 17.2761V16.2663C20.334 15.9711 20.0921 15.7317 19.7936 15.7317H17.7595V13.7197Z",
        fill
      })
    ]
  }));
};
var AddGroup_default = /* @__PURE__ */ React5.memo(AddGroup);

// src/shared/ui/icons/shared/AddRound.tsx
import { jsx as _jsx13 } from "react/jsx-runtime";
import React6 from "react";
function _define_property16(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread16(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property16(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys7(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props7(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys7(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties7(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var AddRound = (_param) => {
  var { width: width2 = 24, height: height2 = 23, fill = getCssVar("grey", 200) } = _param, props = _object_without_properties7(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx13("svg", _object_spread_props7(_object_spread16({
    width: width2,
    height: height2,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx13("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9025 19.9501C16.6246 19.9501 20.4525 16.1221 20.4525 11.4001C20.4525 6.67806 16.6246 2.8501 11.9025 2.8501C7.1805 2.8501 3.35254 6.67806 3.35254 11.4001C3.35254 16.1221 7.1805 19.9501 11.9025 19.9501ZM11.534 16.1189C11.2749 16.1189 11.0649 15.9089 11.0649 15.6499V12.2377H7.6527C7.39365 12.2377 7.18366 12.0277 7.18366 11.7686V11.0316C7.18366 10.7725 7.39366 10.5625 7.6527 10.5625H11.0649V7.15032C11.0649 6.89127 11.2749 6.68128 11.534 6.68128H12.271C12.5301 6.68128 12.7401 6.89128 12.7401 7.15032V10.5625H16.1523C16.4113 10.5625 16.6213 10.7725 16.6213 11.0316V11.7686C16.6213 12.0277 16.4113 12.2377 16.1523 12.2377H12.7401V15.6499C12.7401 15.9089 12.5301 16.1189 12.271 16.1189H11.534Z",
      fill
    })
  }));
};
var AddRound_default = /* @__PURE__ */ React6.memo(AddRound);

// src/shared/ui/icons/shared/Apk.tsx
import { jsx as _jsx14 } from "react/jsx-runtime";
import React7 from "react";
function _define_property17(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread17(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property17(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys8(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props8(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys8(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties8(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose8(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose8(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Apk = (_param) => {
  var { width: width2 = 20, height: height2 = 20, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties8(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx14("svg", _object_spread_props8(_object_spread17({
    width: width2,
    height: height2,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx14("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.31862 8.11666V3.23821C3.31862 1.64653 4.60894 0.356211 6.20062 0.356208L10.4658 0.356201C11.2446 0.356201 11.9903 0.671378 12.5329 1.22996L15.8665 4.66125C16.3891 5.19914 16.6814 5.91955 16.6814 6.6695V8.11666H16.9796C18.2222 8.11666 19.2296 9.12402 19.2296 10.3667V16.8606C19.2296 18.1032 18.2222 19.1106 16.9796 19.1106H3.02051C1.77787 19.1106 0.770508 18.1032 0.770508 16.8606V10.3667C0.770508 9.12401 1.77787 8.11666 3.02051 8.11666H3.31862ZM5.19362 8.11666L14.8064 8.11666V6.6695C14.8064 6.40746 14.7043 6.15574 14.5217 5.96779L11.1881 2.5365C10.9985 2.34133 10.7379 2.2312 10.4658 2.2312L6.20062 2.23121C5.64447 2.23121 5.19362 2.68206 5.19362 3.23821V8.11666ZM2.95828 16C2.84301 16 2.76116 15.8877 2.79643 15.778L4.37465 10.868C4.39724 10.7977 4.46264 10.75 4.53649 10.75H6.01364C6.08749 10.75 6.15289 10.7977 6.17549 10.868L7.7537 15.778C7.78898 15.8877 7.70713 16 7.59186 16H6.38647C6.31025 16 6.24335 15.9493 6.22278 15.8759L6.01486 15.1341C5.99429 15.0607 5.92738 15.01 5.85117 15.01H4.61741C4.54075 15.01 4.47357 15.0613 4.4534 15.1353L4.25173 15.8747C4.23156 15.9487 4.16438 16 4.08772 16H2.95828ZM5.4013 12.9188C5.35503 12.7531 5.12011 12.7531 5.07383 12.9188L4.83282 13.7818C4.80255 13.8901 4.88403 13.9975 4.99655 13.9975H5.47858C5.59111 13.9975 5.67259 13.8901 5.64232 13.7818L5.4013 12.9188ZM8.50829 16C8.4144 16 8.33829 15.9239 8.33829 15.83V10.92C8.33829 10.8261 8.4144 10.75 8.50829 10.75H10.1608C11.5558 10.75 12.1933 11.425 12.1933 12.4975C12.1933 13.5775 11.6233 14.305 10.1608 14.305H9.96329C9.8694 14.305 9.79329 14.3811 9.79329 14.475V15.83C9.79329 15.9239 9.71718 16 9.62329 16H8.50829ZM9.79329 13.085C9.79329 13.1789 9.8694 13.255 9.96329 13.255H10.1083C10.5508 13.255 10.7383 12.97 10.7383 12.5125C10.7383 12.055 10.5508 11.8 10.1083 11.8H9.96329C9.8694 11.8 9.79329 11.8761 9.79329 11.97V13.085ZM12.8354 15.83C12.8354 15.9239 12.9115 16 13.0054 16H14.1204C14.2142 16 14.2904 15.9239 14.2904 15.83V13.6296C14.2904 13.6091 14.307 13.5925 14.3274 13.5925C14.3415 13.5925 14.3543 13.6005 14.3606 13.613L15.5034 15.9058C15.5322 15.9635 15.5911 16 15.6556 16H16.9131C17.0424 16 17.1243 15.8615 17.0621 15.7482L15.7321 13.3251C15.7031 13.2724 15.7042 13.2083 15.7349 13.1565L17.0105 11.0068C17.0778 10.8934 16.9961 10.75 16.8643 10.75H15.6796C15.6183 10.75 15.5617 10.783 15.5316 10.8364L14.3524 12.9232C14.3465 12.9336 14.3355 12.94 14.3235 12.94C14.3052 12.94 14.2904 12.9252 14.2904 12.9068V10.92C14.2904 10.8261 14.2142 10.75 14.1204 10.75H13.0054C12.9115 10.75 12.8354 10.8261 12.8354 10.92V15.83Z",
      fill
    })
  }));
};
var Apk_default = /* @__PURE__ */ React7.memo(Apk);

// src/shared/ui/icons/shared/CloseRound.tsx
import { jsx as _jsx15 } from "react/jsx-runtime";
import React8 from "react";
function _define_property18(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread18(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property18(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys9(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props9(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys9(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties9(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose9(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose9(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CloseRound = (_param) => {
  var { width: width2 = 24, height: height2 = 23, fill = getCssVar("grey", 200) } = _param, props = _object_without_properties9(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx15("svg", _object_spread_props9(_object_spread18({
    width: width2,
    height: height2,
    viewBox: "0 0 25 24"
  }, props), {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ _jsx15("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5024 21C17.473 21 21.5024 16.9706 21.5024 12C21.5024 7.02944 17.473 3 12.5024 3C7.53188 3 3.50244 7.02944 3.50244 12C3.50244 16.9706 7.53188 21 12.5024 21ZM16.7667 8.28438C16.9595 8.47719 16.9595 8.7898 16.7667 8.98261L13.7493 12L16.7667 15.0174C16.9595 15.2102 16.9595 15.5228 16.7667 15.7156L16.218 16.2642C16.0252 16.457 15.7126 16.457 15.5198 16.2642L12.5024 13.2469L9.48509 16.2642C9.29228 16.457 8.97967 16.457 8.78685 16.2642L8.23824 15.7156C8.04543 15.5228 8.04543 15.2102 8.23824 15.0174L11.2556 12L8.23821 8.98262C8.04539 8.7898 8.04539 8.47719 8.23821 8.28438L8.78682 7.73577C8.97963 7.54295 9.29224 7.54295 9.48505 7.73577L12.5024 10.7532L15.5198 7.73576C15.7127 7.54295 16.0253 7.54295 16.2181 7.73576L16.7667 8.28438Z",
      fill
    })
  }));
};
var CloseRound_default = /* @__PURE__ */ React8.memo(CloseRound);

// src/shared/ui/icons/shared/ArrowBack.tsx
import { jsx as _jsx16 } from "react/jsx-runtime";
import React9 from "react";
function _define_property19(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread19(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property19(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys10(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props10(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys10(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties10(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose10(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose10(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ArrowBack = (_param) => {
  var { width: width2 = 15, height: height2 = 13, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties10(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx16("svg", _object_spread_props10(_object_spread19({
    width: width2,
    height: height2,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx16("path", {
      d: "M7.5426 12.1482C7.4126 12.2882 7.2426 12.3582 7.0626 12.3582C6.9026 12.3582 6.7526 12.3082 6.6226 12.1882L0.582597 6.69817C0.272598 6.41817 0.272598 5.93817 0.582597 5.65817L6.6226 0.168174C6.8926 -0.0718255 7.3026 -0.0518256 7.5426 0.208174C7.7826 0.478174 7.7726 0.888175 7.5026 1.12817L2.66695 5.52817H13.5626C13.9216 5.52817 14.2126 5.81919 14.2126 6.17817C14.2126 6.53716 13.9216 6.82817 13.5626 6.82817H2.66695L7.5026 11.2282C7.7626 11.4682 7.7826 11.8782 7.5426 12.1482Z",
      fill
    })
  }));
};
var ArrowBack_default = /* @__PURE__ */ React9.memo(ArrowBack);

// src/shared/ui/icons/shared/Attention.tsx
import { jsx as _jsx17 } from "react/jsx-runtime";
import React10 from "react";
function _define_property20(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread20(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property20(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys11(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props11(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys11(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties11(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose11(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose11(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Attention = (_param) => {
  var { width: width2 = 96, height: height2 = 97, fill = getCssVar("grey", 700) } = _param, props = _object_without_properties11(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx17("svg", _object_spread_props11(_object_spread20({
    width: width2,
    height: height2,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx17("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.48 19.9318C43.8222 14.0227 52.1778 14.0227 55.52 19.9318L82.8237 68.2047C86.1659 74.1137 81.9881 81.5 75.3037 81.5H20.6963C14.0118 81.5 9.83409 74.1137 13.1763 68.2047L40.48 19.9318ZM46.6342 57.0769C45.5152 57.0769 44.6081 56.1509 44.6081 55.0087L44.6081 36.5077C44.6081 35.3655 45.5152 34.4396 46.6342 34.4396H49.8181C50.9371 34.4396 51.8442 35.3655 51.8442 36.5077V55.0087C51.8442 56.1509 50.9371 57.0769 49.8181 57.0769H46.6342ZM50.529 71.3282C51.648 71.3282 52.5551 70.4023 52.5551 69.2601V65.6595C52.5551 64.5173 51.648 63.5914 50.529 63.5914H45.9233C44.8043 63.5914 43.8972 64.5173 43.8972 65.6595V69.2601C43.8972 70.4023 44.8043 71.3282 45.9233 71.3282H50.529Z",
      fill
    })
  }));
};
var Attention_default = /* @__PURE__ */ React10.memo(Attention);

// src/shared/ui/icons/shared/BreakoutRoomMain.tsx
import { jsx as _jsx18 } from "react/jsx-runtime";
import React11 from "react";
function _define_property21(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread21(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property21(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys12(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props12(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys12(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties12(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose12(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose12(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BreakoutRoomMain = (_param) => {
  var { width: width2 = 20, height: height2 = 18, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties12(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx18("svg", _object_spread_props12(_object_spread21({
    width: width2,
    height: height2,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx18("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.7744 9.9204L18.8692 9.17032L18.8692 14.7727C18.8692 16.7609 17.2575 18.3727 15.2692 18.3727L6.73084 18.3727C4.74262 18.3727 3.13084 16.7609 3.13084 14.7727L3.13084 9.17037L2.22575 9.92039C2.0025 10.1054 1.67154 10.0744 1.48653 9.85113L0.960127 9.21589C0.775122 8.99264 0.80613 8.66168 1.02939 8.47667L10.6651 0.491852C10.8594 0.330841 11.1408 0.330841 11.3351 0.491852L20.9708 8.47668C21.194 8.66169 21.225 8.99265 21.04 9.21591L20.5136 9.85114C20.3286 10.0744 19.9977 10.1054 19.7744 9.9204ZM7.71585 8.43153C6.64747 8.43153 5.78137 9.29763 5.78137 10.366V12.9351C5.78137 14.0035 6.64747 14.8696 7.71585 14.8696H11.2775C12.3458 14.8696 13.2119 14.0035 13.2119 12.9351V10.366C13.2119 9.29763 12.3458 8.43153 11.2775 8.43153H7.71585ZM16.2187 14.2253C16.2187 14.4734 15.9042 14.5804 15.7529 14.3838L14.2966 12.4908C14.2617 12.4454 14.2427 12.3897 14.2427 12.3323V10.9521C14.2427 10.8951 14.2615 10.8396 14.2961 10.7943L15.7524 8.88962C15.9034 8.6922 16.2187 8.79895 16.2187 9.04745V14.2253Z",
      fill
    })
  }));
};
var BreakoutRoomMain_default = /* @__PURE__ */ React11.memo(BreakoutRoomMain);

// src/shared/ui/icons/shared/BreakoutRooms.tsx
import { jsx as _jsx19 } from "react/jsx-runtime";
import React12 from "react";
function _define_property22(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread22(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property22(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys13(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props13(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys13(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties13(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose13(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose13(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BreakoutRooms = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties13(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx19("svg", _object_spread_props13(_object_spread22({
    width: width2,
    height: height2,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx19("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.48837 15.9154L11.7499 15.9154L11.7499 22.5411L5.78838 22.5411C4.51812 22.5411 3.48837 21.5113 3.48837 20.2411L3.48837 15.9154ZM14.2499 22.5411L14.2499 15.9154L22.5115 15.9154L22.5115 20.2411C22.5115 21.5113 21.4817 22.5411 20.2115 22.5411L14.2499 22.5411ZM0.988371 5.75703L0.988373 5.7571L0.98837 15.9154L0.988372 20.2411C0.988372 22.8921 3.13741 25.0411 5.78837 25.0411L20.2115 25.0411C22.8624 25.0411 25.0115 22.8921 25.0115 20.2411L25.0115 15.9154L25.0115 5.75711L25.0115 5.75703C25.0115 3.10607 22.8624 0.957031 20.2115 0.957031L5.78837 0.95703C3.13741 0.95703 0.988373 3.10606 0.988371 5.75703ZM19.0851 11.4384C19.0851 11.7278 18.7183 11.8525 18.5419 11.6232L16.8438 9.41591C16.8031 9.36294 16.781 9.29798 16.781 9.23115L16.781 7.62175C16.781 7.55523 16.8029 7.49055 16.8433 7.43771L18.5414 5.21678C18.7174 4.98658 19.0851 5.11105 19.0851 5.40082L19.0851 11.4384ZM9.17036 4.68263C7.92458 4.68263 6.91467 5.69254 6.91467 6.93832L6.91467 9.93402C6.91467 11.1798 7.92458 12.1897 9.17036 12.1897L13.3234 12.1897C14.5691 12.1897 15.5791 11.1798 15.5791 9.93402L15.5791 6.93832C15.5791 5.69254 14.5691 4.68263 13.3234 4.68263L9.17036 4.68263Z",
      fill
    })
  }));
};
var BreakoutRooms_default = /* @__PURE__ */ React12.memo(BreakoutRooms);

// src/shared/ui/icons/shared/BrowserChrome.tsx
import { jsx as _jsx20, jsxs as _jsxs4 } from "react/jsx-runtime";
import React13 from "react";
function _define_property23(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread23(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property23(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys14(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props14(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys14(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties14(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose14(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose14(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BrowserChrome = (_param) => {
  var { width: width2 = 25, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties14(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs4("svg", _object_spread_props14(_object_spread23({
    width: width2,
    height: height2,
    viewBox: "0 0 25 24",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsxs4("g", {
        clipPath: "url(#clip0_6558_73572)",
        children: [
          /* @__PURE__ */ _jsx20("path", {
            d: "M22.8895 6.00045C21.8362 4.17636 20.3214 2.66164 18.4972 1.60852C16.673 0.555397 14.6038 0.000976562 12.4975 0.000976562C10.3911 0.000976562 8.3219 0.555397 6.49773 1.60852C4.67357 2.66164 3.15873 4.17636 2.10547 6.00045L2.82547 18.9605L22.8895 6.00045Z",
            fill: "url(#paint0_linear_6558_73572)"
          }),
          /* @__PURE__ */ _jsx20("path", {
            d: "M7.3037 15L2.1077 6C1.05449 7.82421 0.500013 9.89351 0.5 11.9999C0.499987 14.1063 1.05444 16.1756 2.10762 17.9999C3.1608 19.8241 4.67561 21.3389 6.4998 22.3922C8.32399 23.4454 10.3933 23.9999 12.4997 24L24.2597 12L7.3037 15Z",
            fill: "url(#paint1_linear_6558_73572)"
          }),
          /* @__PURE__ */ _jsx20("path", {
            d: "M17.696 15L12.5 24C14.6062 23.9995 16.6752 23.4447 18.4991 22.3913C20.3229 21.3379 21.8374 19.823 22.8903 17.9988C23.9432 16.1747 24.4974 14.1055 24.4973 11.9993C24.4972 9.89311 23.9427 7.82403 22.8896 6H12.5L17.696 15Z",
            fill: "url(#paint2_linear_6558_73572)"
          }),
          /* @__PURE__ */ _jsx20("path", {
            d: "M12.5 18C13.2879 18 14.0681 17.8448 14.7961 17.5433C15.5241 17.2417 16.1855 16.7998 16.7426 16.2426C17.2998 15.6855 17.7417 15.0241 18.0433 14.2961C18.3448 13.5681 18.5 12.7879 18.5 12C18.5 11.2121 18.3448 10.4319 18.0433 9.7039C17.7417 8.97595 17.2998 8.31451 16.7426 7.75736C16.1855 7.20021 15.5241 6.75825 14.7961 6.45672C14.0681 6.15519 13.2879 6 12.5 6C10.9087 6 9.38258 6.63214 8.25736 7.75736C7.13214 8.88258 6.5 10.4087 6.5 12C6.5 13.5913 7.13214 15.1174 8.25736 16.2426C9.38258 17.3679 10.9087 18 12.5 18Z",
            fill: "white"
          }),
          /* @__PURE__ */ _jsx20("path", {
            d: "M12.5 16.752C13.1241 16.752 13.742 16.6291 14.3186 16.3903C14.8951 16.1515 15.419 15.8014 15.8602 15.3602C16.3015 14.9189 16.6515 14.3951 16.8903 13.8185C17.1291 13.242 17.252 12.624 17.252 12C17.252 11.376 17.1291 10.758 16.8903 10.1815C16.6515 9.60495 16.3015 9.08109 15.8602 8.63983C15.419 8.19857 14.8951 7.84854 14.3186 7.60973C13.742 7.37092 13.1241 7.248 12.5 7.248C11.2397 7.248 10.031 7.74866 9.13988 8.63983C8.2487 9.531 7.74805 10.7397 7.74805 12C7.74805 13.2603 8.2487 14.469 9.13988 15.3602C10.031 16.2513 11.2397 16.752 12.5 16.752Z",
            fill: "#1A73E8"
          })
        ]
      }),
      /* @__PURE__ */ _jsxs4("defs", {
        children: [
          /* @__PURE__ */ _jsxs4("linearGradient", {
            id: "paint0_linear_6558_73572",
            x1: "2.10787",
            y1: "7.50045",
            x2: "22.8895",
            y2: "7.50045",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx20("stop", {
                stopColor: "#D93025"
              }),
              /* @__PURE__ */ _jsx20("stop", {
                offset: "1",
                stopColor: "#EA4335"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs4("linearGradient", {
            id: "paint1_linear_6558_73572",
            x1: "13.7981",
            y1: "23.2488",
            x2: "3.4061",
            y2: "5.2488",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx20("stop", {
                stopColor: "#1E8E3E"
              }),
              /* @__PURE__ */ _jsx20("stop", {
                offset: "1",
                stopColor: "#34A853"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs4("linearGradient", {
            id: "paint2_linear_6558_73572",
            x1: "10.748",
            y1: "24",
            x2: "21.14",
            y2: "6.0312",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx20("stop", {
                stopColor: "#FCC934"
              }),
              /* @__PURE__ */ _jsx20("stop", {
                offset: "1",
                stopColor: "#FBBC04"
              })
            ]
          }),
          /* @__PURE__ */ _jsx20("clipPath", {
            id: "clip0_6558_73572",
            children: /* @__PURE__ */ _jsx20("rect", {
              width: "24",
              height: "24",
              fill: "white",
              transform: "translate(0.5)"
            })
          })
        ]
      })
    ]
  }));
};
var BrowserChrome_default = /* @__PURE__ */ React13.memo(BrowserChrome);

// src/shared/ui/icons/shared/BrowserSafari.tsx
import { jsx as _jsx21, jsxs as _jsxs5 } from "react/jsx-runtime";
import React14 from "react";
function _define_property24(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread24(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property24(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys15(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props15(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys15(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties15(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose15(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose15(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BrowserSafari = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties15(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs5("svg", _object_spread_props15(_object_spread24({
    width: width2,
    height: height2,
    viewBox: "0 0 33 32",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx21("g", {
        filter: "url(#filter0_d_6886_72578)",
        children: /* @__PURE__ */ _jsxs5("g", {
          clipPath: "url(#clip0_6886_72578)",
          children: [
            /* @__PURE__ */ _jsx21("mask", {
              id: "mask0_6886_72578",
              style: {
                maskType: "alpha"
              },
              maskUnits: "userSpaceOnUse",
              x: "4",
              y: "2",
              width: "25",
              height: "24",
              children: /* @__PURE__ */ _jsx21("path", {
                d: "M28.4984 8.61978C28.4969 8.37975 28.4942 8.13978 28.4876 7.89987C28.4736 7.37697 28.4427 6.84958 28.3497 6.33251C28.2554 5.80798 28.1014 5.31979 27.8587 4.8432C27.6201 4.37477 27.3084 3.94612 26.9365 3.5745C26.5647 3.20288 26.136 2.8914 25.6673 2.65295C25.1903 2.41018 24.7016 2.25622 24.1764 2.16194C23.6593 2.06909 23.1318 2.0383 22.6089 2.02417C22.3688 2.01768 22.1287 2.01494 21.8886 2.01346C21.6035 2.01171 21.3184 2.01185 21.0333 2.01185L17.7232 2H15.2475L11.996 2.01185C11.7103 2.01185 11.4247 2.01171 11.139 2.01346C10.8984 2.01494 10.6579 2.01768 10.4173 2.02417C9.8932 2.0383 9.36448 2.06912 8.84612 2.16209C8.32031 2.25634 7.83088 2.41024 7.35315 2.65283C6.88356 2.89132 6.45386 3.20282 6.08128 3.5745C5.70876 3.94609 5.3965 4.37465 5.15746 4.843C4.91408 5.31982 4.75977 5.8083 4.66523 6.33312C4.57215 6.84999 4.5413 7.3772 4.52712 7.89987C4.52065 8.13981 4.51785 8.37978 4.5164 8.61978C4.51465 8.90475 4.5 9.25872 4.5 9.54366V12.7502V15.2524L4.5148 18.527C4.5148 18.8123 4.51468 19.0976 4.5164 19.383C4.51785 19.6233 4.52065 19.8636 4.52715 20.1039C4.5413 20.6274 4.5722 21.1556 4.66538 21.6733C4.75989 22.1986 4.91417 22.6875 5.15734 23.1647C5.39641 23.6338 5.70873 24.063 6.08128 24.4351C6.45383 24.8073 6.88341 25.1191 7.35292 25.3579C7.83094 25.601 8.3206 25.7552 8.84674 25.8496C9.36486 25.9426 9.89341 25.9734 10.4173 25.9876C10.6579 25.9941 10.8984 25.9968 11.1391 25.9983C11.4247 26 11.7103 26 11.996 26H15.2769H17.7587H21.0333C21.3184 26 21.6035 26 21.8886 25.9983C22.1287 25.9968 22.3688 25.9941 22.6089 25.9876C23.132 25.9734 23.6597 25.9425 24.1771 25.8495C24.7019 25.7551 25.1903 25.601 25.6671 25.358C26.1358 25.1193 26.5647 24.8073 26.9365 24.4351C27.3083 24.063 27.62 23.6339 27.8586 23.1649C28.1014 22.6874 28.2555 22.1983 28.3498 21.6727C28.4427 21.1552 28.4736 20.6272 28.4877 20.1039C28.4942 19.8636 28.4969 19.6233 28.4984 19.383C28.5 19.0976 28.5 18.8123 28.5 18.527C28.5 18.527 28.5 18.527 28.5 18.527C28.5 18.527 28.5 15.3102 28.5 15.2524V12.7475C28.5 12.7048 28.5 9.47457 28.5 9.47457C28.5 9.47457 28.5 9.47457 28.5 9.47457C28.5 9.18966 28.5 8.90472 28.4984 8.61978Z",
                fill: "#8E8E93"
              })
            }),
            /* @__PURE__ */ _jsxs5("g", {
              mask: "url(#mask0_6886_72578)",
              children: [
                /* @__PURE__ */ _jsx21("path", {
                  d: "M28.4984 8.61978C28.4969 8.37975 28.4942 8.13978 28.4876 7.89987C28.4736 7.37697 28.4427 6.84958 28.3497 6.33251C28.2554 5.80798 28.1014 5.31979 27.8587 4.8432C27.6201 4.37477 27.3084 3.94612 26.9365 3.5745C26.5647 3.20288 26.136 2.8914 25.6673 2.65295C25.1903 2.41018 24.7016 2.25622 24.1764 2.16194C23.6593 2.06909 23.1318 2.0383 22.6089 2.02417C22.3688 2.01768 22.1287 2.01494 21.8886 2.01346C21.6035 2.01171 21.3184 2.01185 21.0333 2.01185L17.7232 2H15.2475L11.996 2.01185C11.7103 2.01185 11.4247 2.01171 11.139 2.01346C10.8984 2.01494 10.6579 2.01768 10.4173 2.02417C9.8932 2.0383 9.36448 2.06912 8.84612 2.16209C8.32031 2.25634 7.83088 2.41024 7.35315 2.65283C6.88356 2.89132 6.45386 3.20282 6.08128 3.5745C5.70876 3.94609 5.3965 4.37465 5.15746 4.843C4.91408 5.31982 4.75977 5.8083 4.66523 6.33312C4.57215 6.84999 4.5413 7.3772 4.52712 7.89987C4.52065 8.13981 4.51785 8.37978 4.5164 8.61978C4.51465 8.90475 4.5 9.25872 4.5 9.54366V12.7502V15.2524L4.5148 18.527C4.5148 18.8123 4.51468 19.0976 4.5164 19.383C4.51785 19.6233 4.52065 19.8636 4.52715 20.1039C4.5413 20.6274 4.5722 21.1556 4.66538 21.6733C4.75989 22.1986 4.91417 22.6875 5.15734 23.1647C5.39641 23.6338 5.70873 24.063 6.08128 24.4351C6.45383 24.8073 6.88341 25.1191 7.35292 25.3579C7.83094 25.601 8.3206 25.7552 8.84674 25.8496C9.36486 25.9426 9.89341 25.9734 10.4173 25.9876C10.6579 25.9941 10.8984 25.9968 11.1391 25.9983C11.4247 26 11.7103 26 11.996 26H15.2769H17.7587H21.0333C21.3184 26 21.6035 26 21.8886 25.9983C22.1287 25.9968 22.3688 25.9941 22.6089 25.9876C23.132 25.9734 23.6597 25.9425 24.1771 25.8495C24.7019 25.7551 25.1903 25.601 25.6671 25.358C26.1358 25.1193 26.5647 24.8073 26.9365 24.4351C27.3083 24.063 27.62 23.6339 27.8586 23.1649C28.1014 22.6874 28.2555 22.1983 28.3498 21.6727C28.4427 21.1552 28.4736 20.6272 28.4877 20.1039C28.4942 19.8636 28.4969 19.6233 28.4984 19.383C28.5 19.0976 28.5 18.8123 28.5 18.527C28.5 18.527 28.5 18.527 28.5 18.527C28.5 18.527 28.5 15.3102 28.5 15.2524V12.7475C28.5 12.7048 28.5 9.47457 28.5 9.47457C28.5 9.47457 28.5 9.47457 28.5 9.47457C28.5 9.18966 28.5 8.90472 28.4984 8.61978Z",
                  fill: "url(#paint0_linear_6886_72578)"
                }),
                /* @__PURE__ */ _jsx21("g", {
                  style: {
                    mixBlendMode: "hard-light"
                  },
                  filter: "url(#filter1_ddiii_6886_72578)",
                  children: /* @__PURE__ */ _jsx21("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.793 6.72677C30.8008 7.01282 30.8041 7.29893 30.8058 7.58512C30.8078 7.92486 30.8078 8.2646 30.8078 8.6043V12.5067V15.4932V19.3976C30.8078 19.7378 30.8078 20.0779 30.8058 20.4181C30.8041 20.7047 30.8008 20.9912 30.7931 21.2777C30.7762 21.9017 30.7395 22.5312 30.6287 23.1483C30.5162 23.7749 30.3326 24.3581 30.043 24.9273C29.7585 25.4866 29.3869 25.9982 28.9436 26.4419C28.5003 26.8856 27.989 27.2576 27.4301 27.5423C26.8616 27.8319 26.2792 28.0157 25.6535 28.1282C25.0366 28.2392 24.4074 28.276 23.7837 28.2929C23.4975 28.3006 23.2112 28.3039 22.9249 28.3056C22.5853 28.3077 22.2457 28.3077 21.9061 28.3077H21.9052H18.0009H15.0417H11.1299H11.1289C10.7887 28.3077 10.4484 28.3077 10.1082 28.3056C9.82128 28.3039 9.53447 28.3006 9.24765 28.2929C8.62298 28.276 7.99279 28.2392 7.37503 28.1284C6.74772 28.0158 6.16388 27.832 5.59394 27.5422C5.03414 27.2574 4.52195 26.8856 4.07775 26.4419C3.63356 25.9982 3.26118 25.4864 2.97614 24.9271C2.6862 24.3581 2.50225 23.7752 2.38956 23.149C2.27847 22.5316 2.24163 21.9019 2.22475 21.2777C2.217 20.9912 2.21367 20.7047 2.21193 20.4181C2.21001 20.0983 2.21002 19.7784 2.21002 19.4585L2.21002 19.3976L2.19238 15.4932V12.5098V8.68667C2.19238 8.50453 2.1974 8.29874 2.20238 8.09465C2.20669 7.91806 2.21097 7.74274 2.21193 7.58512C2.21367 7.29897 2.217 7.01285 2.22471 6.72677C2.24163 6.10359 2.2784 5.47499 2.38939 4.85872C2.50211 4.23297 2.6861 3.65056 2.97628 3.08204C3.26128 2.52362 3.63359 2.01264 4.07775 1.56959C4.52198 1.12644 5.03431 0.755031 5.59422 0.470684C6.16381 0.18144 6.74737 -0.00205868 7.3743 -0.114436C7.99234 -0.225286 8.62274 -0.262027 9.24765 -0.27887C9.53447 -0.286614 9.82124 -0.289878 10.1082 -0.291649C10.4244 -0.293584 10.7406 -0.293573 11.0569 -0.293561L11.1299 -0.293559L15.0067 -0.307693H17.9585L21.9052 -0.293559L21.978 -0.293561C22.2937 -0.293573 22.6093 -0.293584 22.9249 -0.291649C23.2112 -0.289878 23.4975 -0.286614 23.7837 -0.27887C24.4072 -0.262027 25.0362 -0.22532 25.6528 -0.11461C26.2789 -0.00219759 26.8615 0.181371 27.4304 0.470823C27.9891 0.755135 28.5003 1.12651 28.9436 1.56959C29.387 2.01268 29.7586 2.52376 30.0431 3.08228C30.3325 3.65052 30.5161 4.23259 30.6286 4.85799C30.7395 5.4745 30.7762 6.10331 30.793 6.72677ZM16.5001 23.2308C21.5981 23.2308 25.7308 19.098 25.7308 14C25.7308 8.90198 21.5981 4.76923 16.5001 4.76923C11.4021 4.76923 7.2693 8.90198 7.2693 14C7.2693 19.098 11.4021 23.2308 16.5001 23.2308Z",
                    fill: "url(#paint1_linear_6886_72578)"
                  })
                }),
                /* @__PURE__ */ _jsx21("g", {
                  style: {
                    mixBlendMode: "soft-light"
                  },
                  opacity: "0.2",
                  children: /* @__PURE__ */ _jsx21("path", {
                    d: "M16.2767 7.4737C16.3366 7.24349 16.6634 7.24349 16.7233 7.4737L17.7518 11.4264C17.9203 12.074 18.426 12.5797 19.0736 12.7482L23.0263 13.7767C23.2565 13.8366 23.2565 14.1634 23.0263 14.2233L19.0736 15.2518C18.426 15.4203 17.9203 15.926 17.7518 16.5736L16.7233 20.5263C16.6634 20.7565 16.3366 20.7565 16.2767 20.5263L15.2482 16.5736C15.0797 15.926 14.574 15.4203 13.9264 15.2518L9.97368 14.2233C9.74347 14.1634 9.74347 13.8366 9.97368 13.7767L13.9264 12.7482C14.574 12.5797 15.0797 12.074 15.2482 11.4264L16.2767 7.4737Z",
                    fill: "white"
                  })
                }),
                /* @__PURE__ */ _jsx21("g", {
                  style: {
                    mixBlendMode: "overlay"
                  },
                  opacity: "0.44",
                  children: /* @__PURE__ */ _jsx21("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.2783 8.77829C11.0981 8.95853 11.0981 9.25076 11.2783 9.431L12.5838 10.7364C12.764 10.9167 13.0563 10.9167 13.2365 10.7364C13.4167 10.5562 13.4167 10.264 13.2365 10.0837L11.9311 8.77829C11.7508 8.59805 11.4586 8.59805 11.2783 8.77829ZM19.7636 17.2636C19.5834 17.4438 19.5834 17.736 19.7636 17.9163L21.0691 19.2217C21.2493 19.402 21.5415 19.402 21.7218 19.2217C21.902 19.0415 21.902 18.7492 21.7218 18.569L20.4163 17.2636C20.2361 17.0833 19.9439 17.0833 19.7636 17.2636ZM11.9311 19.2217C11.7508 19.402 11.4586 19.402 11.2784 19.2217C11.0981 19.0415 11.0981 18.7492 11.2784 18.569L12.5838 17.2636C12.764 17.0833 13.0563 17.0833 13.2365 17.2636C13.4167 17.4438 13.4167 17.736 13.2365 17.9163L11.9311 19.2217ZM19.7636 10.7364C19.9439 10.9167 20.2361 10.9167 20.4163 10.7364L21.7218 9.431C21.902 9.25076 21.902 8.95853 21.7218 8.77829C21.5415 8.59804 21.2493 8.59804 21.0691 8.77829L19.7636 10.0837C19.5834 10.264 19.5834 10.5562 19.7636 10.7364Z",
                    fill: "white"
                  })
                }),
                /* @__PURE__ */ _jsxs5("g", {
                  filter: "url(#filter2_dd_6886_72578)",
                  children: [
                    /* @__PURE__ */ _jsx21("path", {
                      d: "M20.8839 7.33825C21.0651 7.12205 21.4018 7.35775 21.2606 7.60198L17.2561 14.5295L15.7438 13.4705L20.8839 7.33825Z",
                      fill: "url(#paint2_linear_6886_72578)"
                    }),
                    /* @__PURE__ */ _jsx21("g", {
                      style: {
                        mixBlendMode: "overlay"
                      },
                      children: /* @__PURE__ */ _jsx21("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.1932 7.29745C21.104 7.23502 20.9745 7.23015 20.8839 7.33825L15.7438 13.4705L17.2561 14.5295L17.2563 14.5292L16.5002 13.9997L21.1932 7.29745Z",
                        fill: "url(#paint3_linear_6886_72578)"
                      })
                    }),
                    /* @__PURE__ */ _jsx21("path", {
                      d: "M12.1161 20.6617C11.9349 20.8779 11.5982 20.6422 11.7394 20.398L15.7439 13.4705L17.2562 14.5295L12.1161 20.6617Z",
                      fill: "url(#paint4_linear_6886_72578)"
                    }),
                    /* @__PURE__ */ _jsx21("g", {
                      style: {
                        mixBlendMode: "overlay"
                      },
                      children: /* @__PURE__ */ _jsx21("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M17.256 14.5297L17.2562 14.5295L15.7439 13.4705L11.7394 20.398C11.6688 20.5201 11.7177 20.6401 11.8068 20.7025L16.4998 14.0002L17.256 14.5297Z",
                        fill: "url(#paint5_linear_6886_72578)"
                      })
                    })
                  ]
                }),
                /* @__PURE__ */ _jsx21("path", {
                  opacity: "0.1",
                  d: "M28.5 18.527L28 18.527V18.5269V18.5267V18.5264V18.5261V18.5257V18.5252V18.5247V18.5241V18.5234V18.5226V18.5218V18.5209V18.5199V18.5189V18.5178V18.5166V18.5153V18.514V18.5127V18.5112V18.5097V18.5081V18.5065V18.5047V18.5029V18.5011V18.4992V18.4972V18.4951V18.493V18.4909V18.4886V18.4863V18.4839V18.4815V18.479V18.4764V18.4738V18.4711V18.4684V18.4656V18.4627V18.4598V18.4568V18.4537V18.4506V18.4474V18.4442V18.4409V18.4375V18.4341V18.4307V18.4271V18.4235V18.4199V18.4162V18.4124V18.4086V18.4047V18.4008V18.3968V18.3928V18.3887V18.3845V18.3803V18.376V18.3717V18.3673V18.3629V18.3584V18.3539V18.3493V18.3447V18.34V18.3352V18.3304V18.3256V18.3207V18.3157V18.3107V18.3057V18.3006V18.2954V18.2902V18.2849V18.2796V18.2743V18.2689V18.2634V18.2579V18.2524V18.2468V18.2412V18.2355V18.2298V18.224V18.2182V18.2123V18.2064V18.2004V18.1944V18.1884V18.1823V18.1761V18.1699V18.1637V18.1574V18.1511V18.1448V18.1384V18.132V18.1255V18.1189V18.1124V18.1058V18.0991V18.0925V18.0857V18.079V18.0722V18.0653V18.0584V18.0515V18.0446V18.0376V18.0305V18.0235V18.0164V18.0092V18.002V17.9948V17.9876V17.9803V17.9729V17.9656V17.9582V17.9508V17.9433V17.9358V17.9283V17.9207V17.9131V17.9055V17.8978V17.8901V17.8824V17.8746V17.8668V17.859V17.8512V17.8433V17.8354V17.8274V17.8195V17.8115V17.8034V17.7954V17.7873V17.7791V17.771V17.7628V17.7546V17.7464V17.7381V17.7299V17.7216V17.7132V17.7049V17.6965V17.6881V17.6796V17.6712V17.6627V17.6542V17.6456V17.6371V17.6285V17.6199V17.6113V17.6026V17.594V17.5853V17.5766V17.5678V17.5591V17.5503V17.5415V17.5327V17.5239V17.515V17.5061V17.4972V17.4883V17.4794V17.4705V17.4615V17.4525V17.4435V17.4345V17.4255V17.4164V17.4073V17.3983V17.3892V17.3801V17.3709V17.3618V17.3526V17.3435V17.3343V17.3251V17.3159V17.3066V17.2974V17.2882V17.2789V17.2696V17.2603V17.251V17.2417V17.2324V17.2231V17.2138V17.2044V17.1951V17.1857V17.1763V17.1669V17.1575V17.1481V17.1387V17.1293V17.1199V17.1105V17.101V17.0916V17.0821V17.0727V17.0632V17.0538V17.0443V17.0348V17.0253V17.0159V17.0064V16.9969V16.9874V16.9779V16.9684V16.9589V16.9494V16.9399V16.9304V16.9209V16.9114V16.9019V16.8924V16.8828V16.8733V16.8638V16.8543V16.8448V16.8353V16.8258V16.8163V16.8068V16.7973V16.7878V16.7783V16.7688V16.7593V16.7499V16.7404V16.7309V16.7214V16.712V16.7025V16.6931V16.6836V16.6742V16.6647V16.6553V16.6459V16.6365V16.6271V16.6177V16.6083V16.5989V16.5896V16.5802V16.5708V16.5615V16.5522V16.5428V16.5335V16.5242V16.5149V16.5057V16.4964V16.4871V16.4779V16.4687V16.4594V16.4502V16.441V16.4319V16.4227V16.4135V16.4044V16.3953V16.3862V16.3771V16.368V16.3589V16.3499V16.3409V16.3319V16.3229V16.3139V16.3049V16.296V16.2871V16.2782V16.2693V16.2604V16.2516V16.2427V16.2339V16.2251V16.2164V16.2076V16.1989V16.1902V16.1815V16.1729V16.1642V16.1556V16.147V16.1384V16.1299V16.1214V16.1129V16.1044V16.0959V16.0875V16.0791V16.0707V16.0624V16.0541V16.0458V16.0375V16.0292V16.021V16.0128V16.0047V15.9965V15.9884V15.9803V15.9723V15.9643V15.9563V15.9483V15.9404V15.9325V15.9246V15.9168V15.909V15.9012V15.8934V15.8857V15.878V15.8704V15.8628V15.8552V15.8476V15.8401V15.8326V15.8252V15.8177V15.8104V15.803V15.7957V15.7884V15.7812V15.774V15.7668V15.7597V15.7526V15.7455V15.7385V15.7315V15.7246V15.7177V15.7108V15.704V15.6972V15.6904V15.6837V15.6771V15.6704V15.6639V15.6573V15.6508V15.6443V15.6379V15.6315V15.6252V15.6189V15.6126V15.6064V15.6003V15.5941V15.5881V15.582V15.576V15.5701V15.5642V15.5584V15.5525V15.5468V15.5411V15.5354V15.5298V15.5242V15.5187V15.5132V15.5078V15.5024V15.4971V15.4918V15.4865V15.4813V15.4762V15.4711V15.4661V15.4611V15.4562V15.4513V15.4465V15.4417V15.4369V15.4323V15.4276V15.4231V15.4186V15.4141V15.4097V15.4053V15.401V15.3968V15.3926V15.3885V15.3844V15.3803V15.3764V15.3725V15.3686V15.3648V15.3611V15.3574V15.3538V15.3502V15.3467V15.3432V15.3398V15.3365V15.3332V15.33V15.3269V15.3238V15.3207V15.3178V15.3148V15.312V15.3092V15.3065V15.3038V15.3012V15.2987V15.2962V15.2938V15.2914V15.2892V15.2869V15.2848V15.2827V15.2807V15.2787V15.2768V15.275V15.2732V15.2715V15.2699V15.2684V15.2669V15.2654V15.2641V15.2628V15.2616V15.2604V15.2593V15.2583V15.2574V15.2565V15.2557V15.255V15.2543V15.2537V15.2532V15.2528V15.2524V12.7475V12.7472V12.7469V12.7465V12.746V12.7454V12.7447V12.744V12.7432V12.7424V12.7414V12.7404V12.7394V12.7382V12.737V12.7357V12.7344V12.733V12.7315V12.7299V12.7283V12.7266V12.7249V12.7231V12.7212V12.7192V12.7172V12.7151V12.713V12.7108V12.7085V12.7061V12.7037V12.7013V12.6987V12.6961V12.6935V12.6908V12.688V12.6851V12.6822V12.6793V12.6762V12.6731V12.67V12.6668V12.6635V12.6602V12.6568V12.6533V12.6498V12.6462V12.6426V12.6389V12.6352V12.6314V12.6275V12.6236V12.6196V12.6156V12.6115V12.6074V12.6032V12.5989V12.5946V12.5903V12.5859V12.5814V12.5769V12.5723V12.5677V12.563V12.5583V12.5535V12.5486V12.5437V12.5388V12.5338V12.5288V12.5237V12.5185V12.5133V12.5081V12.5028V12.4975V12.4921V12.4866V12.4811V12.4756V12.47V12.4644V12.4587V12.453V12.4472V12.4414V12.4355V12.4296V12.4237V12.4177V12.4116V12.4055V12.3994V12.3932V12.387V12.3807V12.3744V12.3681V12.3617V12.3553V12.3488V12.3423V12.3357V12.3291V12.3225V12.3158V12.3091V12.3023V12.2955V12.2886V12.2818V12.2748V12.2679V12.2609V12.2539V12.2468V12.2397V12.2325V12.2253V12.2181V12.2109V12.2036V12.1962V12.1889V12.1815V12.174V12.1666V12.1591V12.1515V12.144V12.1364V12.1287V12.1211V12.1134V12.1056V12.0979V12.0901V12.0822V12.0744V12.0665V12.0586V12.0506V12.0426V12.0346V12.0266V12.0185V12.0104V12.0023V11.9941V11.986V11.9777V11.9695V11.9612V11.9529V11.9446V11.9363V11.9279V11.9195V11.9111V11.9027V11.8942V11.8857V11.8772V11.8686V11.8601V11.8515V11.8429V11.8342V11.8256V11.8169V11.8082V11.7995V11.7907V11.7819V11.7732V11.7643V11.7555V11.7467V11.7378V11.7289V11.72V11.7111V11.7021V11.6932V11.6842V11.6752V11.6662V11.6572V11.6481V11.6391V11.63V11.6209V11.6118V11.6026V11.5935V11.5843V11.5752V11.566V11.5568V11.5476V11.5383V11.5291V11.5199V11.5106V11.5013V11.492V11.4827V11.4734V11.4641V11.4548V11.4454V11.4361V11.4267V11.4173V11.408V11.3986V11.3892V11.3798V11.3703V11.3609V11.3515V11.342V11.3326V11.3232V11.3137V11.3042V11.2948V11.2853V11.2758V11.2663V11.2568V11.2473V11.2378V11.2283V11.2188V11.2093V11.1998V11.1903V11.1808V11.1712V11.1617V11.1522V11.1427V11.1331V11.1236V11.1141V11.1046V11.095V11.0855V11.076V11.0665V11.0569V11.0474V11.0379V11.0284V11.0189V11.0094V10.9999V10.9903V10.9808V10.9713V10.9619V10.9524V10.9429V10.9334V10.9239V10.9145V10.905V10.8955V10.8861V10.8767V10.8672V10.8578V10.8484V10.839V10.8295V10.8202V10.8108V10.8014V10.792V10.7827V10.7733V10.764V10.7546V10.7453V10.736V10.7267V10.7174V10.7082V10.6989V10.6897V10.6804V10.6712V10.662V10.6528V10.6436V10.6345V10.6253V10.6162V10.6071V10.598V10.5889V10.5798V10.5707V10.5617V10.5527V10.5437V10.5347V10.5257V10.5168V10.5078V10.4989V10.49V10.4811V10.4723V10.4634V10.4546V10.4458V10.437V10.4283V10.4195V10.4108V10.4021V10.3935V10.3848V10.3762V10.3676V10.359V10.3504V10.3419V10.3334V10.3249V10.3164V10.308V10.2996V10.2912V10.2829V10.2745V10.2662V10.2579V10.2497V10.2415V10.2333V10.2251V10.2169V10.2088V10.2007V10.1927V10.1847V10.1767V10.1687V10.1607V10.1528V10.145V10.1371V10.1293V10.1215V10.1138V10.106V10.0984V10.0907V10.0831V10.0755V10.0679V10.0604V10.0529V10.0455V10.038V10.0307V10.0233V10.016V10.0087V10.0015V9.99427V9.9871V9.97997V9.97288V9.96582V9.9588V9.95182V9.94487V9.93797V9.9311V9.92428V9.91749V9.91074V9.90404V9.89737V9.89075V9.88416V9.87762V9.87111V9.86465V9.85824V9.85186V9.84553V9.83924V9.83299V9.82679V9.82063V9.81451V9.80844V9.80241V9.79643V9.7905V9.78461V9.77876V9.77296V9.76721V9.7615V9.75584V9.75023V9.74467V9.73915V9.73368V9.72826V9.72289V9.71757V9.7123V9.70708V9.7019V9.69678V9.69171V9.68668V9.68171V9.67679V9.67192V9.66711V9.66234V9.65763V9.65297V9.64837V9.64381V9.63931V9.63487V9.63048V9.62614V9.62186V9.61763V9.61346V9.60934V9.60528V9.60128V9.59733V9.59344V9.5896V9.58583V9.58211V9.57845V9.57484V9.5713V9.56781V9.56438V9.56102V9.55771V9.55446V9.55127V9.54814V9.54508V9.54207V9.53913V9.53624V9.53342V9.53066V9.52797V9.52533V9.52276V9.52025V9.51781V9.51543V9.51311V9.51086V9.50868V9.50655V9.5045V9.50251V9.50058V9.49872V9.49693V9.49521V9.49355V9.49196V9.49043V9.48898V9.48759V9.48627V9.48502V9.48384V9.48273V9.48169V9.48072V9.47982V9.47898V9.47822V9.47753V9.47692V9.47637V9.47589V9.47549V9.47516V9.47491V9.47472V9.47461L28.5 9.47457H28C28 9.18942 28 8.90592 27.9984 8.62265M28.5 18.527L21.8855 2.51345C22.1241 2.51492 22.3603 2.51763 22.5954 2.52399L22.5954 2.52399C23.1101 2.5379 23.6081 2.56788 24.0881 2.65407L24.1764 2.16216L24.0881 2.65407C24.5713 2.74084 25.0125 2.88073 25.4406 3.09857C25.8623 3.31316 26.2483 3.59357 26.583 3.92814L26.5831 3.92818C26.9178 4.26271 27.1984 4.64859 27.4131 5.0701C27.6309 5.49776 27.7708 5.93837 27.8576 6.42099L27.8576 6.42102C27.9439 6.90092 27.974 7.39873 27.9878 7.91335L27.9878 7.91346C27.9942 8.14832 27.997 8.38432 27.9984 8.62265M28.5 18.527H28C28 18.8126 28 19.0964 27.9984 19.3801M28.5 18.527L7.5796 24.9123M27.9984 8.62265L28.4984 8.61978L27.9984 8.62275C27.9984 8.62272 27.9984 8.62268 27.9984 8.62265ZM27.9984 19.3801C27.9984 19.3801 27.9984 19.38 27.9984 19.38L28.4984 19.383L27.9984 19.3801ZM27.9984 19.3801C27.997 19.6187 27.9942 19.8551 27.9879 20.0903L27.9879 20.0904C27.974 20.6055 27.9439 21.1039 27.8577 21.5844C27.7708 22.0682 27.6309 22.5097 27.4129 22.9382M27.4129 22.9382C27.1982 23.3603 26.9176 23.7467 26.5828 24.0817L26.5828 24.0817C26.248 24.4168 25.8619 24.6977 25.4402 24.9125L25.4402 24.9125C25.0123 25.1305 24.5714 25.2705 24.0885 25.3574C23.6083 25.4437 23.1102 25.4738 22.5954 25.4877C22.3602 25.4941 22.1241 25.4968 21.8856 25.4983C21.6022 25.5 21.3187 25.5 21.0333 25.5H17.7587H15.2769H11.996C11.7101 25.5 11.426 25.5 11.1421 25.4983C10.9031 25.4968 10.6664 25.4941 10.4308 25.4877L10.4308 25.4877C9.91512 25.4738 9.41609 25.4438 8.93507 25.3575L8.93503 25.3575C8.45075 25.2706 8.00864 25.1305 7.5796 24.9123M27.4129 22.9382L27.8586 23.1649M27.4129 22.9382C27.4129 22.9382 27.4129 22.9382 27.4129 22.9382L27.8586 23.1649M7.5796 24.9123L7.35292 25.3579L7.57956 24.9123C7.15694 24.6973 6.7701 24.4165 6.43464 24.0814C6.09916 23.7463 5.81797 23.3598 5.60283 22.9376C5.38462 22.5094 5.24445 22.0681 5.15747 21.5848C5.07099 21.1042 5.04089 20.6056 5.02696 20.0903C5.0206 19.855 5.01784 19.6186 5.01639 19.3799L7.5796 24.9123ZM27.8586 23.1649C28.1014 22.6874 28.2555 22.1983 28.3498 21.6727C28.4427 21.1552 28.4736 20.6272 28.4877 20.1039L26.9365 24.4351C27.3083 24.063 27.62 23.6339 27.8586 23.1649ZM21.0333 2.51185H21.0315L17.7232 2.5H17.7223H15.2484H15.2475L11.9978 2.51185L11.996 2.51186L11.935 2.51185C11.6695 2.51184 11.4057 2.51183 11.1421 2.51345L21.0333 2.51185ZM21.0333 2.51185L21.0941 2.51185M21.0333 2.51185L21.0941 2.51185M10.4308 2.52399L10.4308 2.52399C9.91489 2.5379 9.41566 2.56791 8.93439 2.65423L8.93434 2.65424C8.4503 2.74101 8.00836 2.88089 7.57956 3.09864L10.4308 2.52399ZM10.4308 2.52399C10.6664 2.51763 10.903 2.51492 11.1421 2.51345L10.4308 2.52399ZM6.4344 3.92848L6.43439 3.92849C6.09898 4.26307 5.81788 4.6489 5.60281 5.0703L5.6028 5.07031C5.38447 5.49806 5.2443 5.93886 5.15732 6.42174L6.4344 3.92848ZM6.4344 3.92848C6.76986 3.59384 7.1568 3.31334 7.57954 3.09865L6.4344 3.92848ZM5.01639 8.62282L5.01639 8.62285C5.01555 8.75985 5.01185 8.91138 5.00826 9.05828C5.00797 9.07018 5.00768 9.08205 5.0074 9.09388C5.0035 9.25443 5 9.40821 5 9.54366V12.7502V15.2512V15.2524L5.01479 18.5247L5.0148 18.527L5.0148 18.5777C5.01479 18.8464 5.01478 19.1132 5.01639 19.3799L5.01639 8.62282ZM5.01639 8.62282C5.01783 8.38452 5.0206 8.14844 5.02693 7.91344L5.01639 8.62282ZM21.0941 2.51185C21.3591 2.51184 21.6224 2.51183 21.8855 2.51345L21.0941 2.51185ZM5.02693 7.91334C5.0409 7.39893 5.07094 6.90137 5.15731 6.42176L5.02693 7.91334Z",
                  stroke: "black"
                })
              ]
            })
          ]
        })
      }),
      /* @__PURE__ */ _jsxs5("defs", {
        children: [
          /* @__PURE__ */ _jsxs5("filter", {
            id: "filter0_d_6886_72578",
            x: "0.5",
            y: "0",
            width: "32",
            height: "32",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx21("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {
                dy: "2"
              }),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "2"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_6886_72578",
                result: "shape"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("filter", {
            id: "filter1_ddiii_6886_72578",
            x: "-9.80762",
            y: "-12.3077",
            width: "52.6155",
            height: "52.6154",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx21("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {
                dy: "2"
              }),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "2"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {}),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "6"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0.117647 0 0 0 0 0.243137 0 0 0 0 0.494118 0 0 0 0.2 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "effect1_dropShadow_6886_72578",
                result: "effect2_dropShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect2_dropShadow_6886_72578",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {}),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "4"
              }),
              /* @__PURE__ */ _jsx21("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect3_innerShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {
                dy: "2"
              }),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "1"
              }),
              /* @__PURE__ */ _jsx21("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "effect3_innerShadow_6886_72578",
                result: "effect4_innerShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {
                dy: "-1"
              }),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "1"
              }),
              /* @__PURE__ */ _jsx21("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "effect4_innerShadow_6886_72578",
                result: "effect5_innerShadow_6886_72578"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("filter", {
            id: "filter2_dd_6886_72578",
            x: "1.70581",
            y: "-1.74682",
            width: "29.5884",
            height: "33.4936",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx21("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {
                dy: "1"
              }),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "5"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx21("feOffset", {
                dy: "2"
              }),
              /* @__PURE__ */ _jsx21("feGaussianBlur", {
                stdDeviation: "1"
              }),
              /* @__PURE__ */ _jsx21("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in2: "effect1_dropShadow_6886_72578",
                result: "effect2_dropShadow_6886_72578"
              }),
              /* @__PURE__ */ _jsx21("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect2_dropShadow_6886_72578",
                result: "shape"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("linearGradient", {
            id: "paint0_linear_6886_72578",
            x1: "16.5",
            y1: "2",
            x2: "16.5",
            y2: "26",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx21("stop", {
                stopColor: "#3ED4F9"
              }),
              /* @__PURE__ */ _jsx21("stop", {
                offset: "1",
                stopColor: "#2E6DEA"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("linearGradient", {
            id: "paint1_linear_6886_72578",
            x1: "16.5001",
            y1: "2.23077",
            x2: "16.5001",
            y2: "25.6538",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx21("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx21("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0.8"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("linearGradient", {
            id: "paint2_linear_6886_72578",
            x1: "22.5887",
            y1: "5.30438",
            x2: "16.5",
            y2: "14",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx21("stop", {
                offset: "0.234375",
                stopColor: "#FF667A"
              }),
              /* @__PURE__ */ _jsx21("stop", {
                offset: "1",
                stopColor: "#BE113A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("linearGradient", {
            id: "paint3_linear_6886_72578",
            x1: "21.1932",
            y1: "7.29745",
            x2: "16.5",
            y2: "14",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx21("stop", {
                stopColor: "white",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx21("stop", {
                offset: "1",
                stopColor: "white"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("linearGradient", {
            id: "paint4_linear_6886_72578",
            x1: "10.4113",
            y1: "22.6956",
            x2: "16.5",
            y2: "14",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx21("stop", {
                offset: "0.234375",
                stopColor: "white",
                stopOpacity: "0.9"
              }),
              /* @__PURE__ */ _jsx21("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0.5"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs5("linearGradient", {
            id: "paint5_linear_6886_72578",
            x1: "13.3191",
            y1: "21.7614",
            x2: "18.0123",
            y2: "15.0589",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx21("stop", {
                stopColor: "white",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx21("stop", {
                offset: "1",
                stopColor: "white"
              })
            ]
          }),
          /* @__PURE__ */ _jsx21("clipPath", {
            id: "clip0_6886_72578",
            children: /* @__PURE__ */ _jsx21("rect", {
              x: "4.5",
              y: "2",
              width: "24",
              height: "24",
              rx: "12",
              fill: "white"
            })
          })
        ]
      })
    ]
  }));
};
var BrowserSafari_default = /* @__PURE__ */ React14.memo(BrowserSafari);

// src/shared/ui/icons/shared/BrowserYandex.tsx
import { jsx as _jsx22, jsxs as _jsxs6 } from "react/jsx-runtime";
import React15 from "react";
function _define_property25(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread25(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property25(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys16(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props16(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys16(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties16(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose16(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose16(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BrowserYandex = (_param) => {
  var { width: width2 = 25, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties16(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs6("svg", _object_spread_props16(_object_spread25({
    width: width2,
    height: height2,
    viewBox: "0 0 25 24",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx22("path", {
        d: "M12.4887 23.4199C18.7906 23.4199 23.8992 18.3079 23.8992 12.002C23.8992 5.69599 18.7906 0.583984 12.4887 0.583984C6.18681 0.583984 1.07812 5.69599 1.07812 12.002C1.07812 18.3079 6.18681 23.4199 12.4887 23.4199Z",
        fill: "white"
      }),
      /* @__PURE__ */ _jsx22("path", {
        d: "M6.92569 4.75391L4.80469 6.87491L11.0047 13.0754V20.4464H14.0047V13.0674L20.1972 6.87491L18.0762 4.75391L12.5007 10.3294L6.92569 4.75391Z",
        fill: "#FF0000"
      })
    ]
  }));
};
var BrowserYandex_default = /* @__PURE__ */ React15.memo(BrowserYandex);

// src/shared/ui/icons/shared/BrowserEdge.tsx
import { jsx as _jsx23, jsxs as _jsxs7 } from "react/jsx-runtime";
import React16 from "react";
function _define_property26(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread26(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property26(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys17(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props17(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys17(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties17(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose17(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose17(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var BrowserEdge = (_param) => {
  var { width: width2 = 25, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties17(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs7("svg", _object_spread_props17(_object_spread26({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx23("path", {
        d: "M20.8563 17.3727C20.563 17.5261 20.2605 17.6612 19.9506 17.7774C18.964 18.1465 17.919 18.3346 16.8656 18.3325C12.7993 18.3325 9.25718 15.5356 9.25718 11.9464C9.26239 11.465 9.39598 10.9937 9.64417 10.5811C9.89237 10.1686 10.2462 9.8298 10.669 9.59967C6.99115 9.75434 6.0459 13.5867 6.0459 15.832C6.0459 22.1803 11.897 22.8239 13.1576 22.8239C13.8374 22.8239 14.8625 22.6263 15.4778 22.4321L15.5904 22.3943C17.958 21.5758 19.9764 19.9757 21.3135 17.8573C21.3544 17.7928 21.3727 17.7165 21.3654 17.6404C21.3581 17.5643 21.3257 17.4929 21.2733 17.4373C21.2209 17.3817 21.1514 17.3452 21.0759 17.3335C21.0004 17.3218 20.9231 17.3356 20.8563 17.3727Z",
        fill: "url(#paint0_linear_2354_45454)"
      }),
      /* @__PURE__ */ _jsx23("path", {
        opacity: "0.35",
        d: "M20.8563 17.3727C20.563 17.5261 20.2605 17.6612 19.9506 17.7774C18.964 18.1465 17.919 18.3346 16.8656 18.3325C12.7993 18.3325 9.25718 15.5356 9.25718 11.9464C9.26239 11.465 9.39598 10.9937 9.64417 10.5811C9.89237 10.1686 10.2462 9.8298 10.669 9.59967C6.99115 9.75434 6.0459 13.5867 6.0459 15.832C6.0459 22.1803 11.897 22.8239 13.1576 22.8239C13.8374 22.8239 14.8625 22.6263 15.4778 22.4321L15.5904 22.3943C17.958 21.5758 19.9764 19.9757 21.3135 17.8573C21.3544 17.7928 21.3727 17.7165 21.3654 17.6404C21.3581 17.5643 21.3257 17.4929 21.2733 17.4373C21.2209 17.3817 21.1514 17.3452 21.0759 17.3335C21.0004 17.3218 20.9231 17.3356 20.8563 17.3727Z",
        fill: "url(#paint1_radial_2354_45454)"
      }),
      /* @__PURE__ */ _jsx23("path", {
        d: "M10.0854 21.7447C9.31893 21.269 8.65469 20.6457 8.13129 19.911C7.53474 19.0937 7.12423 18.1558 6.92855 17.1631C6.73287 16.1704 6.75677 15.1469 6.99856 14.1644C7.24035 13.1819 7.69418 12.2642 8.32822 11.4756C8.96226 10.6871 9.76115 10.0468 10.6689 9.59968C10.937 9.47337 11.395 9.2448 12.0043 9.25597C12.4335 9.25909 12.8562 9.36157 13.2392 9.55538C13.6222 9.74918 13.9551 10.029 14.2118 10.373C14.5589 10.8363 14.7502 11.3977 14.7584 11.9764C14.7584 11.9584 16.8603 5.1366 7.88381 5.1366C4.11139 5.1366 1.00924 8.71634 1.00924 11.857C0.994358 13.5184 1.34985 15.1622 2.04988 16.6689C3.19391 19.1098 5.19452 21.0455 7.6718 22.1086C10.1491 23.1717 12.9305 23.288 15.4879 22.4356C14.5925 22.7179 13.6465 22.8026 12.7151 22.6839C11.7837 22.5653 10.8892 22.246 10.0931 21.7481L10.0854 21.7447Z",
        fill: "url(#paint2_linear_2354_45454)"
      }),
      /* @__PURE__ */ _jsx23("path", {
        opacity: "0.41",
        d: "M10.0854 21.7447C9.31893 21.269 8.65469 20.6457 8.13129 19.911C7.53474 19.0937 7.12423 18.1558 6.92855 17.1631C6.73287 16.1704 6.75677 15.1469 6.99856 14.1644C7.24035 13.1819 7.69418 12.2642 8.32822 11.4756C8.96226 10.6871 9.76115 10.0468 10.6689 9.59968C10.937 9.47337 11.395 9.2448 12.0043 9.25597C12.4335 9.25909 12.8562 9.36157 13.2392 9.55538C13.6222 9.74918 13.9551 10.029 14.2118 10.373C14.5589 10.8363 14.7502 11.3977 14.7584 11.9764C14.7584 11.9584 16.8603 5.1366 7.88381 5.1366C4.11139 5.1366 1.00924 8.71634 1.00924 11.857C0.994358 13.5184 1.34985 15.1622 2.04988 16.6689C3.19391 19.1098 5.19452 21.0455 7.6718 22.1086C10.1491 23.1717 12.9305 23.288 15.4879 22.4356C14.5925 22.7179 13.6465 22.8026 12.7151 22.6839C11.7837 22.5653 10.8892 22.246 10.0931 21.7481L10.0854 21.7447Z",
        fill: "url(#paint3_radial_2354_45454)"
      }),
      /* @__PURE__ */ _jsx23("path", {
        d: "M14.09 13.7912C14.0204 13.8814 13.8065 14.006 13.8065 14.2775C13.8065 14.5018 13.9525 14.7175 14.2121 14.8988C15.4478 15.7581 17.7774 15.6446 17.7834 15.6446C18.699 15.6425 19.5973 15.3947 20.3846 14.9272C21.1788 14.4635 21.8379 13.8002 22.2966 13.0031C22.7553 12.206 22.9976 11.3029 22.9995 10.3833C23.0218 8.45766 22.312 7.17734 22.025 6.61022C20.2041 3.04852 16.2736 1 11.9993 1C9.10872 0.999714 6.33419 2.13725 4.2758 4.16658C2.21742 6.19591 1.04065 8.95391 1 11.8441C1.04125 8.70427 4.1623 6.16855 7.87457 6.16855C8.17533 6.16855 9.89054 6.19776 11.4837 7.03384C12.8878 7.7711 13.6234 8.66131 14.1347 9.54379C14.6658 10.4606 14.7603 11.6189 14.7603 12.0804C14.7603 12.5418 14.5249 13.2258 14.09 13.7912Z",
        fill: "url(#paint4_radial_2354_45454)"
      }),
      /* @__PURE__ */ _jsx23("path", {
        d: "M14.09 13.7912C14.0204 13.8814 13.8065 14.006 13.8065 14.2775C13.8065 14.5018 13.9525 14.7175 14.2121 14.8988C15.4478 15.7581 17.7774 15.6446 17.7834 15.6446C18.699 15.6425 19.5973 15.3947 20.3846 14.9272C21.1788 14.4635 21.8379 13.8002 22.2966 13.0031C22.7553 12.206 22.9976 11.3029 22.9995 10.3833C23.0218 8.45766 22.312 7.17734 22.025 6.61022C20.2041 3.04852 16.2736 1 11.9993 1C9.10872 0.999714 6.33419 2.13725 4.2758 4.16658C2.21742 6.19591 1.04065 8.95391 1 11.8441C1.04125 8.70427 4.1623 6.16855 7.87457 6.16855C8.17533 6.16855 9.89054 6.19776 11.4837 7.03384C12.8878 7.7711 13.6234 8.66131 14.1347 9.54379C14.6658 10.4606 14.7603 11.6189 14.7603 12.0804C14.7603 12.5418 14.5249 13.2258 14.09 13.7912Z",
        fill: "url(#paint5_radial_2354_45454)"
      }),
      /* @__PURE__ */ _jsxs7("defs", {
        children: [
          /* @__PURE__ */ _jsxs7("linearGradient", {
            id: "paint0_linear_2354_45454",
            x1: "6.0459",
            y1: "16.2135",
            x2: "21.371",
            y2: "16.2135",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx23("stop", {
                stopColor: "#0C59A4"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "1",
                stopColor: "#114A8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs7("radialGradient", {
            id: "paint1_radial_2354_45454",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(14.5102 16.3343) scale(8.19621 7.78599)",
            children: [
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.72",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.95",
                stopOpacity: "0.53"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "1"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs7("linearGradient", {
            id: "paint2_linear_2354_45454",
            x1: "14.1251",
            y1: "9.56617",
            x2: "4.55362",
            y2: "19.9923",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx23("stop", {
                stopColor: "#1B9DE2"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.16",
                stopColor: "#1595DF"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.67",
                stopColor: "#0680D7"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "1",
                stopColor: "#0078D4"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs7("radialGradient", {
            id: "paint3_radial_2354_45454",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.06612 18.1004) rotate(-81.3839) scale(12.3243 9.95728)",
            children: [
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.76",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.95",
                stopOpacity: "0.5"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "1"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs7("radialGradient", {
            id: "paint4_radial_2354_45454",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(3.22242 5.07098) rotate(92.2907) scale(17.4082 37.0779)",
            children: [
              /* @__PURE__ */ _jsx23("stop", {
                stopColor: "#35C1F1"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.11",
                stopColor: "#34C1ED"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.23",
                stopColor: "#2FC2DF"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.31",
                stopColor: "#2BC3D2"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "0.67",
                stopColor: "#36C752"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs7("radialGradient", {
            id: "paint5_radial_2354_45454",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(21.6299 7.65132) rotate(73.739) scale(8.36423 6.80209)",
            children: [
              /* @__PURE__ */ _jsx23("stop", {
                stopColor: "#66EB6E"
              }),
              /* @__PURE__ */ _jsx23("stop", {
                offset: "1",
                stopColor: "#66EB6E",
                stopOpacity: "0"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var BrowserEdge_default = /* @__PURE__ */ React16.memo(BrowserEdge);

// src/shared/ui/icons/shared/ButtonLoader.tsx
import { jsx as _jsx24 } from "react/jsx-runtime";
function _define_property27(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread27(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property27(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys18(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props18(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys18(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties18(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose18(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose18(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ButtonLoader = (_param) => {
  var { width: width2 = 22, height: height2 = 22, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties18(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx24("svg", _object_spread_props18(_object_spread27({
    width: width2,
    height: height2,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx24("path", {
      d: "M21 11C21 13.0619 20.3626 15.0735 19.1751 16.7592C17.9876 18.4448 16.308 19.7222 14.3664 20.4163C12.4248 21.1105 10.3161 21.1874 8.32909 20.6367C6.34205 20.086 4.57383 18.9345 3.26658 17.3399C1.95933 15.7453 1.17696 13.7856 1.02662 11.7291C0.876274 9.67267 1.36531 7.62001 2.42675 5.85225C3.48819 4.08449 5.07014 2.68806 6.95595 1.8542C8.84177 1.02034 10.9393 0.789812 12.9612 1.19419",
      stroke: fill,
      strokeWidth: "2",
      strokeLinecap: "round"
    })
  }));
};
var ButtonLoader_default = ButtonLoader;

// src/shared/ui/icons/shared/ButtonPip.tsx
import { jsx as _jsx25 } from "react/jsx-runtime";
function _define_property28(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread28(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property28(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys19(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props19(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys19(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties19(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose19(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose19(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ButtonPip = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties19(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx25("svg", _object_spread_props19(_object_spread28({
    xmlns: "http://www.w3.org/2000/svg",
    width: width2,
    height: height2,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), {
    children: /* @__PURE__ */ _jsx25("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M8.292 25.359h4.343a3 3 0 0 0 2.992 2.782h9.552a3 3 0 0 0 3-3V15.59a3 3 0 0 0-2.687-2.984V8.16a4.8 4.8 0 0 0-4.8-4.8h-12.4a4.8 4.8 0 0 0-4.8 4.8v12.4a4.8 4.8 0 0 0 4.8 4.8Zm4.335-9.77v7.27H8.292a2.3 2.3 0 0 1-2.3-2.3v-12.4a2.3 2.3 0 0 1 2.3-2.3h12.4a2.3 2.3 0 0 1 2.3 2.3v4.43h-7.365a3 3 0 0 0-3 3Zm3.705 2.474 4.24 4.24h-3.26a.7.7 0 0 0-.7.7v1.1a.7.7 0 0 0 .7.7h6.828a.7.7 0 0 0 .7-.7v-6.828a.7.7 0 0 0-.7-.7h-1.1a.7.7 0 0 0-.7.7v3.26l-4.24-4.24a.7.7 0 0 0-.99 0l-.777.778a.7.7 0 0 0 0 .99Z",
      clipRule: "evenodd"
    })
  }));
};
var ButtonPip_default = ButtonPip;

// src/shared/ui/icons/shared/Call.tsx
import { jsx as _jsx26 } from "react/jsx-runtime";
import React17 from "react";
function _object_without_properties20(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose20(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose20(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Call = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties20(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx26("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ _jsx26("path", {
      d: "M10.6374 5.27488C10.3501 3.97828 9.22554 2.92714 7.90366 3.05475L5.51967 3.28489C4.33502 3.39925 3.42931 4.42122 3.60894 5.59774C4.81014 13.4652 11.0272 19.6825 18.8945 20.884C20.0711 21.0637 21.0931 20.158 21.2075 18.9733L21.4376 16.5893C21.5652 15.2675 20.5142 14.1429 19.2176 13.8556C18.9103 13.7875 18.6077 13.7069 18.3105 13.6143C17.2537 13.2853 16.0531 13.5474 15.401 14.4418L14.7467 15.339C12.0612 13.9643 10.4577 12.3608 9.08291 9.67524L9.96205 9.07707C10.9002 8.43876 11.1909 7.20642 10.8598 6.12109C10.7751 5.84348 10.7008 5.56126 10.6374 5.27488Z",
      fill: "#EBEDF0"
    })
  });
};
var Call_default = /* @__PURE__ */ React17.memo(Call);

// src/shared/ui/icons/shared/CameraLoading.tsx
import { jsx as _jsx27 } from "react/jsx-runtime";
function _define_property29(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread29(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property29(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys20(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props20(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys20(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties21(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose21(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose21(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CameraLoading = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties21(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx27("svg", _object_spread_props20(_object_spread29({
    width: width2,
    height: height2,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx27("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.3799 12.7318C20.0706 11.8041 19.0525 10.4926 18.4893 8.96123C17.897 8.70522 17.2439 8.56334 16.5576 8.56334H13.6652L21.4304 18.6551V13.4361C21.4304 13.1969 21.4131 12.9618 21.3799 12.7318ZM29.0041 13.6168C28.0765 13.9929 27.0625 14.2 26 14.2C25.4902 14.2 24.9915 14.1523 24.5082 14.0612L24.1613 14.5148C24.074 14.629 24.0267 14.7687 24.0267 14.9124V18.389C24.0267 18.5334 24.0745 18.6737 24.1625 18.7881L27.8307 23.5563C28.2118 24.0517 29.0041 23.7822 29.0041 23.1572V13.6168ZM23.999 29.2745C23.7125 29.4948 23.3015 29.4412 23.0812 29.1547L19.1451 24.0371C18.3953 24.5079 17.5083 24.7801 16.5576 24.7801H7.58635C4.89522 24.7801 2.71362 22.5985 2.71362 19.9074V13.4361C2.71362 10.8572 4.71707 8.74617 7.25247 8.5746L5.07277 5.74062C4.85238 5.45407 4.90601 5.04312 5.19256 4.82273L6.17258 4.06897C6.45912 3.84858 6.87007 3.90221 7.09046 4.18876L14.3856 13.6737L20.894 22.1321L20.8929 22.1343L25.0988 27.6028C25.3192 27.8894 25.2656 28.3003 24.9791 28.5207L23.999 29.2745Z"
    })
  }));
};
var CameraLoading_default = CameraLoading;

// src/shared/ui/icons/shared/CameraOff.tsx
import { jsx as _jsx28 } from "react/jsx-runtime";
function _define_property30(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread30(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property30(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys21(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props21(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys21(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties22(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose22(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose22(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CameraOff = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties22(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx28("svg", _object_spread_props21(_object_spread30({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx28("path", {
      fill: props.fill || getCssVar("red", 300),
      fillRule: "evenodd",
      d: "M23.08 28.954c.22.286.632.34.918.12l.98-.754a.655.655 0 0 0 .12-.918l-4.206-5.469.001-.002-6.508-8.458L7.09 3.988a.655.655 0 0 0-.918-.12l-.98.754a.655.655 0 0 0-.12.918l2.18 2.834a4.873 4.873 0 0 0-4.54 4.861v6.472a4.873 4.873 0 0 0 4.874 4.872h8.97a4.85 4.85 0 0 0 2.588-.743l3.936 5.118Zm-1.65-15.719v5.22L13.664 8.362h2.893a4.873 4.873 0 0 1 4.873 4.872Zm7.573 9.721c0 .625-.792.895-1.173.4l-3.668-4.769a.654.654 0 0 1-.136-.399v-3.476c0-.144.047-.284.135-.398l3.668-4.798c.38-.497 1.174-.228 1.174.398v13.042Z",
      clipRule: "evenodd"
    })
  }));
};
var CameraOff_default = CameraOff;

// src/shared/ui/icons/shared/CameraOn.tsx
import { jsx as _jsx29 } from "react/jsx-runtime";
function _define_property31(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread31(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property31(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys22(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props22(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys22(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties23(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose23(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose23(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CameraOn = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties23(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx29("svg", _object_spread_props22(_object_spread31({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx29("path", {
      fill: props.fill || getCssVar("grey", 100),
      d: "M27.831 23.357c.381.495 1.174.226 1.174-.399V9.916c0-.626-.795-.895-1.175-.398l-3.668 4.798a.654.654 0 0 0-.135.397v3.477c0 .144.048.284.136.399l3.668 4.768ZM2.713 13.236a4.873 4.873 0 0 1 4.873-4.873h8.97a4.873 4.873 0 0 1 4.874 4.873v6.471a4.873 4.873 0 0 1-4.873 4.873H7.586a4.873 4.873 0 0 1-4.873-4.873v-6.471Z"
    })
  }));
};
var CameraOn_default = CameraOn;

// src/shared/ui/icons/shared/CameraUnavailable.tsx
import { jsx as _jsx30 } from "react/jsx-runtime";
function _define_property32(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread32(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property32(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys23(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props23(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys23(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties24(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose24(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose24(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CameraUnavailable = (_param) => {
  var { width: width2 = 33, height: height2 = 33 } = _param, props = _object_without_properties24(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx30("svg", _object_spread_props23(_object_spread32({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 33",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx30("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M21.38 13.531a8.022 8.022 0 0 1-2.891-3.77 4.857 4.857 0 0 0-1.932-.398h-2.893l7.766 10.091v-5.219c0-.239-.018-.474-.05-.704Zm7.623.885a8.05 8.05 0 0 1-4.496.444l-.346.454a.655.655 0 0 0-.135.398v3.476c0 .145.048.285.136.4l3.668 4.767c.381.496 1.173.226 1.173-.399v-9.54Zm-5.005 15.658a.655.655 0 0 1-.918-.12l-3.936-5.118a4.85 4.85 0 0 1-2.587.743H7.586a4.873 4.873 0 0 1-4.873-4.872v-6.472a4.873 4.873 0 0 1 4.539-4.861L5.072 6.54a.655.655 0 0 1 .12-.918l.98-.754a.655.655 0 0 1 .918.12l7.295 9.485 6.508 8.458v.002l4.205 5.469a.655.655 0 0 1-.12.918l-.98.754ZM26 1.75a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm-.615 8.032c0 .16.129.288.288.288h.654c.16 0 .288-.129.288-.288v-.501a.288.288 0 0 0-.288-.288h-.654a.288.288 0 0 0-.288.288v.501Zm.841-1.639c.16 0 .288-.129.288-.288V4.167a.288.288 0 0 0-.288-.288h-.452a.288.288 0 0 0-.288.288v3.688c0 .159.129.288.288.288h.452Z",
      clipRule: "evenodd"
    })
  }));
};
var CameraUnavailable_default = CameraUnavailable;

// src/shared/ui/icons/shared/Caution.tsx
import { jsx as _jsx31, jsxs as _jsxs8 } from "react/jsx-runtime";
import React18 from "react";
function _define_property33(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread33(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property33(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys24(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props24(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys24(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties25(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose25(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose25(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Caution = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties25(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs8("svg", _object_spread_props24(_object_spread33({
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx31("path", {
        opacity: "0.5",
        d: "M71.7216 17.4535C71.4251 15.6048 69.83 14.2451 67.9577 14.2451H27.7445C25.9848 14.2451 24.6428 15.8195 24.9215 17.557L34.8809 79.6544C35.1774 81.5031 36.7726 82.8628 38.6449 82.8628H40.5182C42.2779 82.8628 43.6199 81.2884 43.3412 79.551L42.8376 76.411C42.559 74.6736 43.901 73.0992 45.6606 73.0992H68.8407C70.7131 73.0992 72.3082 74.4589 72.6047 76.3076L73.1415 79.6544C73.438 81.5031 75.0332 82.8628 76.9055 82.8628H78.8581C80.6177 82.8628 81.9597 81.2884 81.6811 79.551L71.7216 17.4535Z",
        fill: "url(#paint0_linear_35771_82357)"
      }),
      /* @__PURE__ */ _jsx31("path", {
        opacity: "0.6",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M28.0414 14.2461C26.1691 14.2461 24.5739 15.6058 24.2774 17.4545L14.318 79.552C14.0393 81.2894 15.3813 82.8638 17.141 82.8638H19.0935C20.9659 82.8638 22.561 81.5041 22.8575 79.6554L23.3943 76.3086C23.6908 74.4599 25.286 73.1002 27.1583 73.1002H50.3384C52.0981 73.1002 53.4401 74.6746 53.1614 76.412L52.6578 79.552C52.3792 81.2894 53.7212 82.8638 55.4808 82.8638H57.3541C59.2265 82.8638 60.8216 81.5041 61.1181 79.6554L71.0775 17.5579C71.3562 15.8205 70.0142 14.2461 68.2545 14.2461H28.0414ZM46.862 32.4308C47.7409 32.4308 48.4116 33.2164 48.2739 34.0845L45.8241 49.5185C45.6771 50.4443 44.8789 51.1258 43.9416 51.1258H40.2026C39.3237 51.1258 38.653 50.3402 38.7908 49.4721L41.2406 34.0381C41.3875 33.1123 42.1857 32.4308 43.123 32.4308H46.862ZM43.1382 55.8909C44.0171 55.8909 44.6879 56.6765 44.5501 57.5445L44.1529 60.0467C44.006 60.9724 43.2078 61.6539 42.2705 61.6539H38.5315C37.6526 61.6539 36.9819 60.8683 37.1196 60.0003L37.5168 57.4981C37.6637 56.5724 38.462 55.8909 39.3993 55.8909H43.1382Z",
        fill: "url(#paint1_linear_35771_82357)"
      }),
      /* @__PURE__ */ _jsx31("path", {
        opacity: "0.6",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M28.0414 14.2461C26.1691 14.2461 24.5739 15.6058 24.2774 17.4545L14.318 79.552C14.0393 81.2894 15.3813 82.8638 17.141 82.8638H19.0935C20.9659 82.8638 22.561 81.5041 22.8575 79.6554L23.3943 76.3086C23.6908 74.4599 25.286 73.1002 27.1583 73.1002H50.3384C52.0981 73.1002 53.4401 74.6746 53.1614 76.412L52.6578 79.552C52.3792 81.2894 53.7212 82.8638 55.4808 82.8638H57.3541C59.2265 82.8638 60.8216 81.5041 61.1181 79.6554L71.0775 17.5579C71.3562 15.8205 70.0142 14.2461 68.2545 14.2461H28.0414ZM46.862 32.4308C47.7409 32.4308 48.4116 33.2164 48.2739 34.0845L45.8241 49.5185C45.6771 50.4443 44.8789 51.1258 43.9416 51.1258H40.2026C39.3237 51.1258 38.653 50.3402 38.7908 49.4721L41.2406 34.0381C41.3875 33.1123 42.1857 32.4308 43.123 32.4308H46.862ZM43.1382 55.8909C44.0171 55.8909 44.6879 56.6765 44.5501 57.5445L44.1529 60.0467C44.006 60.9724 43.2078 61.6539 42.2705 61.6539H38.5315C37.6526 61.6539 36.9819 60.8683 37.1196 60.0003L37.5168 57.4981C37.6637 56.5724 38.462 55.8909 39.3993 55.8909H43.1382Z",
        fill: "url(#paint2_linear_35771_82357)"
      }),
      /* @__PURE__ */ _jsxs8("g", {
        opacity: "0.3",
        children: [
          /* @__PURE__ */ _jsx31("path", {
            d: "M48.2738 34.0843C48.4116 33.2163 47.7408 32.4307 46.8619 32.4307H43.123C42.1856 32.4307 41.3874 33.1122 41.2405 34.0379L38.7907 49.472C38.6529 50.34 39.3236 51.1256 40.2025 51.1256H43.9415C44.8788 51.1256 45.677 50.4441 45.824 49.5184L48.2738 34.0843Z",
            fill: "url(#paint3_linear_35771_82357)"
          }),
          /* @__PURE__ */ _jsx31("path", {
            d: "M44.55 57.5444C44.6878 56.6763 44.0171 55.8907 43.1382 55.8907H39.3992C38.4619 55.8907 37.6637 56.5722 37.5167 57.498L37.1196 60.0001C36.9818 60.8682 37.6525 61.6538 38.5314 61.6538H42.2704C43.2077 61.6538 44.0059 60.9723 44.1529 60.0465L44.55 57.5444Z",
            fill: "url(#paint4_linear_35771_82357)"
          })
        ]
      }),
      /* @__PURE__ */ _jsxs8("defs", {
        children: [
          /* @__PURE__ */ _jsxs8("linearGradient", {
            id: "paint0_linear_35771_82357",
            x1: "53.3013",
            y1: "14.2451",
            x2: "53.3013",
            y2: "82.8628",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx31("stop", {
                "stop-color": "#FCD065"
              }),
              /* @__PURE__ */ _jsx31("stop", {
                offset: "1",
                "stop-color": "#E2AF51",
                "stop-opacity": "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs8("linearGradient", {
            id: "paint1_linear_35771_82357",
            x1: "14.2813",
            y1: "42.049",
            x2: "71.1152",
            y2: "43.1198",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx31("stop", {
                "stop-color": "#FCD065"
              }),
              /* @__PURE__ */ _jsx31("stop", {
                offset: "1",
                "stop-color": "#E2AF51",
                "stop-opacity": "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs8("linearGradient", {
            id: "paint2_linear_35771_82357",
            x1: "45.9961",
            y1: "4.86174",
            x2: "45.9961",
            y2: "41.6851",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx31("stop", {
                "stop-color": "#FCD065"
              }),
              /* @__PURE__ */ _jsx31("stop", {
                offset: "1",
                "stop-color": "#E2AF51",
                "stop-opacity": "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs8("linearGradient", {
            id: "paint3_linear_35771_82357",
            x1: "42.6967",
            y1: "32.4307",
            x2: "42.6967",
            y2: "61.6538",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx31("stop", {
                "stop-color": "#585F71"
              }),
              /* @__PURE__ */ _jsx31("stop", {
                offset: "1",
                "stop-color": "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs8("linearGradient", {
            id: "paint4_linear_35771_82357",
            x1: "42.6967",
            y1: "32.4307",
            x2: "42.6967",
            y2: "61.6538",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx31("stop", {
                "stop-color": "#585F71"
              }),
              /* @__PURE__ */ _jsx31("stop", {
                offset: "1",
                "stop-color": "#2A323A"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Caution_default = /* @__PURE__ */ React18.memo(Caution);

// src/shared/ui/icons/shared/Channel.tsx
import { jsx as _jsx32, jsxs as _jsxs9 } from "react/jsx-runtime";
import React19 from "react";
function _define_property34(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread34(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property34(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys25(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props25(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys25(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties26(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose26(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose26(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Channel = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties26(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs9("svg", _object_spread_props25(_object_spread34({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx32("path", {
        d: "M7.24174 12.311C7.86306 12.311 8.36674 11.8073 8.36674 11.186C8.36674 10.5647 7.86306 10.061 7.24174 10.061C6.62041 10.061 6.11674 10.5647 6.11674 11.186C6.11674 11.8073 6.62041 12.311 7.24174 12.311Z",
        fill
      }),
      /* @__PURE__ */ _jsx32("path", {
        d: "M8.36674 15.4713C8.36674 16.0926 7.86306 16.5963 7.24174 16.5963C6.62041 16.5963 6.11674 16.0926 6.11674 15.4713C6.11674 14.85 6.62041 14.3463 7.24174 14.3463C7.86306 14.3463 8.36674 14.85 8.36674 15.4713Z",
        fill
      }),
      /* @__PURE__ */ _jsx32("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9822 6.10427L8.12843 2.25045C7.9234 2.04542 7.59099 2.04542 7.38597 2.25045L6.8026 2.83381C6.59758 3.03884 6.59758 3.37125 6.8026 3.57627L9.3306 6.10427H7.00723C4.50123 6.10427 2.46973 8.13578 2.46973 10.6418V16.0156C2.46973 18.5215 4.50124 20.5531 7.00723 20.5531H16.9142C19.4202 20.5531 21.4517 18.5215 21.4517 16.0156V10.6418C21.4517 8.13578 19.4202 6.10427 16.9142 6.10427H14.6696L17.1976 3.57627C17.4026 3.37125 17.4026 3.03884 17.1976 2.83381L16.6142 2.25045C16.4092 2.04542 16.0768 2.04542 15.8718 2.25045L12.0179 6.10427H11.9822ZM9.97774 18.6781V7.97927H7.00723C5.53677 7.97927 4.34473 9.17131 4.34473 10.6418V16.0156C4.34473 17.486 5.53677 18.6781 7.00723 18.6781H9.97774Z",
        fill
      })
    ]
  }));
};
var Channel_default = /* @__PURE__ */ React19.memo(Channel);

// src/shared/ui/icons/shared/Chat.tsx
import { jsx as _jsx33 } from "react/jsx-runtime";
function _define_property35(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread35(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property35(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys26(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props26(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys26(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties27(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose27(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose27(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Chat = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties27(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx33("svg", _object_spread_props26(_object_spread35({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx33("path", {
      fill: props.fill || getCssVar("grey", 100),
      d: "M3.926 11.665A4.873 4.873 0 0 1 8.8 6.792h14.402a4.873 4.873 0 0 1 4.873 4.873v6.573A4.873 4.873 0 0 1 23.2 23.11h-3.328c-.121 0-.24.033-.343.096l-7.802 4.784a.655.655 0 0 1-.996-.558v-3.668a.654.654 0 0 0-.655-.654H8.799a4.873 4.873 0 0 1-4.873-4.873v-6.573Z"
    })
  }));
};
var Chat_default = Chat;

// src/shared/ui/icons/shared/ChatBubbles.tsx
import { jsx as _jsx34, jsxs as _jsxs10 } from "react/jsx-runtime";
import React20 from "react";
function _define_property36(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread36(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property36(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys27(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props27(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys27(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties28(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose28(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose28(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChatBubbles = (_param) => {
  var { width: width2 = 74, height: height2 = 70 } = _param, props = _object_without_properties28(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs10("svg", _object_spread_props27(_object_spread36({
    width: width2,
    height: height2,
    viewBox: "0 0 74 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx34("rect", {
        x: "28.4995",
        y: "27",
        width: "45",
        height: "38",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "46.5015",
        y: "47",
        width: "21",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "35.5005",
        y: "42",
        width: "32",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "35.5005",
        y: "37",
        width: "32",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "54.5015",
        y: "52",
        width: "13",
        height: "2",
        fill: "#4E5158"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.6",
        x: "0.500488",
        width: "46",
        height: "34",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx34("path", {
        opacity: "0.6",
        d: "M6.50146 39L7.43751 34H13.5015L6.50146 39Z",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx34("path", {
        d: "M67.5015 70L66.5654 65H60.5015L67.5015 70Z",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "6.50146",
        y: "12",
        width: "21",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "6.50146",
        y: "7",
        width: "21",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx34("rect", {
        opacity: "0.9",
        x: "6.52881",
        y: "17",
        width: "13",
        height: "2",
        fill: "#4E5158"
      })
    ]
  }));
};
var ChatBubbles_default = /* @__PURE__ */ React20.memo(ChatBubbles);

// src/shared/ui/icons/shared/ChatNoMessages.tsx
import { jsx as _jsx35, jsxs as _jsxs11 } from "react/jsx-runtime";
function _define_property37(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread37(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property37(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys28(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props28(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys28(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties29(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose29(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose29(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChatNoMessages = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties29(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs11("svg", _object_spread_props28(_object_spread37({
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx35("path", {
        d: "M10 25.7081C10 20.1853 14.4772 15.7081 20 15.7081H57.6255C63.1484 15.7081 67.6255 20.1853 67.6255 25.7081V44.651C67.6255 50.1738 63.1484 54.6509 57.6255 54.6509H24.745C24.1408 54.6509 23.5506 54.8334 23.0518 55.1745L13.1288 61.959C11.8014 62.8666 10 61.9161 10 60.308V25.7081Z",
        fill: "url(#paint0_linear_18420_193)"
      }),
      /* @__PURE__ */ _jsxs11("g", {
        opacity: "0.3",
        children: [
          /* @__PURE__ */ _jsx35("path", {
            d: "M21.0664 32.1001C20.5141 32.1001 20.0664 31.6524 20.0664 31.1001V28.1001C20.0664 27.5478 20.5141 27.1001 21.0664 27.1001H30.0488C30.6011 27.1001 31.0488 27.5478 31.0488 28.1001V31.1001C31.0488 31.6524 30.6011 32.1001 30.0488 32.1001L21.0664 32.1001Z",
            fill: "url(#paint1_linear_18420_193)"
          }),
          /* @__PURE__ */ _jsx35("path", {
            d: "M37.0995 32.1001C36.5472 32.1001 36.0995 31.6524 36.0995 31.1001V28.1001C36.0995 27.5478 36.5472 27.1001 37.0995 27.1001H56.5585C57.1108 27.1001 57.5585 27.5478 57.5585 28.1001V31.1001C57.5585 31.6524 57.1108 32.1001 56.5585 32.1001L37.0995 32.1001Z",
            fill: "url(#paint2_linear_18420_193)"
          }),
          /* @__PURE__ */ _jsx35("path", {
            d: "M20.0664 41.606C20.0664 42.1582 20.5141 42.606 21.0664 42.606L45.9746 42.606C46.5269 42.606 46.9746 42.1582 46.9746 41.606V38.606C46.9746 38.0537 46.5269 37.606 45.9746 37.606L21.0664 37.606C20.5141 37.606 20.0664 38.0537 20.0664 38.606V41.606Z",
            fill: "url(#paint3_linear_18420_193)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx35("path", {
        opacity: "0.7",
        d: "M86 47.6094C86 42.0865 81.5229 37.6094 76 37.6094H38.3745C32.8517 37.6094 28.3745 42.0865 28.3745 47.6094V66.5522C28.3745 72.075 32.8517 76.5522 38.3745 76.5522H69.0907C71.1049 76.5522 73.0721 77.1604 74.7348 78.2972L82.8712 83.8603C84.1986 84.7678 86 83.8173 86 82.2093V47.6094Z",
        fill: "url(#paint4_linear_18420_193)"
      }),
      /* @__PURE__ */ _jsxs11("g", {
        opacity: "0.8",
        children: [
          /* @__PURE__ */ _jsx35("path", {
            d: "M75.9336 50.6206C75.9336 50.0683 75.4859 49.6206 74.9336 49.6206H52.5098C51.9575 49.6206 51.5098 50.0683 51.5098 50.6206V53.6206C51.5098 54.1729 51.9575 54.6206 52.5098 54.6206L74.9336 54.6206C75.4859 54.6206 75.9336 54.1729 75.9336 53.6206V50.6206Z",
            fill: "url(#paint5_linear_18420_193)"
          }),
          /* @__PURE__ */ _jsx35("path", {
            d: "M75.9336 61.1265C75.9336 60.5742 75.4859 60.1265 74.9336 60.1265L39.4414 60.1265C38.8891 60.1265 38.4414 60.5742 38.4414 61.1265L38.4414 64.1265C38.4414 64.6788 38.8891 65.1265 39.4414 65.1265L74.9336 65.1265C75.4859 65.1265 75.9336 64.6788 75.9336 64.1265V61.1265Z",
            fill: "url(#paint6_linear_18420_193)"
          })
        ]
      }),
      /* @__PURE__ */ _jsxs11("defs", {
        children: [
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint0_linear_18420_193",
            x1: "-34.6254",
            y1: "-11.0198",
            x2: "60.4758",
            y2: "112.814",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#606779"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#15191C"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint1_linear_18420_193",
            x1: "38.8124",
            y1: "27.1001",
            x2: "38.8124",
            y2: "42.606",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint2_linear_18420_193",
            x1: "38.8124",
            y1: "27.1001",
            x2: "38.8124",
            y2: "42.606",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint3_linear_18420_193",
            x1: "38.8124",
            y1: "27.1001",
            x2: "38.8124",
            y2: "42.606",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint4_linear_18420_193",
            x1: "28.3745",
            y1: "-9.24549",
            x2: "85.9995",
            y2: "84.2126",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#ADB6CD"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#414B58"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint5_linear_18420_193",
            x1: "57.1875",
            y1: "49.6206",
            x2: "57.1875",
            y2: "65.1265",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs11("linearGradient", {
            id: "paint6_linear_18420_193",
            x1: "57.1875",
            y1: "49.6206",
            x2: "57.1875",
            y2: "65.1265",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx35("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx35("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var ChatNoMessages_default = ChatNoMessages;

// src/shared/ui/icons/shared/ChatError.tsx
import { jsx as _jsx36, jsxs as _jsxs12 } from "react/jsx-runtime";
function _define_property38(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread38(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property38(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys29(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props29(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys29(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties30(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose30(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose30(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChatError = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties30(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs12("svg", _object_spread_props29(_object_spread38({
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx36("path", {
        d: "M54.5424 76.8613L67.0675 77.9571C72.1032 78.3977 74.621 78.6179 76.6301 77.8062C78.3973 77.0922 79.8932 75.837 80.9032 74.2206C82.0515 72.383 82.2718 69.8652 82.7123 64.8296L85.2382 35.9587C85.6787 30.923 85.899 28.4052 85.0873 26.3961C84.3733 24.6289 83.1181 23.133 81.5017 22.123C79.6641 20.9747 77.1463 20.7544 72.1106 20.3139L48.0263 18.2068L58.5979 30.6246L45.864 41.1559L56.5757 53.7383L43.8418 64.2696L54.5424 76.8613Z",
        fill: "url(#paint0_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsx36("path", {
        d: "M36.4516 19.2053L23.7809 20.3139C18.7452 20.7544 16.2274 20.9747 14.3898 22.123C12.7734 23.133 11.5182 24.6289 10.8042 26.3961C9.99247 28.4052 10.2128 30.923 10.6533 35.9587L13.1792 64.8295C13.6198 69.8652 13.84 72.383 14.9883 74.2206C15.9984 75.837 17.4942 77.0922 19.2614 77.8062C21.2705 78.6179 23.7884 78.3976 28.824 77.9571L53.0539 75.8372L40.3293 65.295L51.0411 52.7125L38.3071 42.1812L49.0189 29.5988L36.4516 19.2053Z",
        fill: "url(#paint1_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsx36("path", {
        opacity: "0.35",
        d: "M50.397 71.9618L67.4616 73.4548C70.0536 73.6815 71.7276 73.8245 73.0105 73.8318C74.2405 73.8389 74.7081 73.7091 74.9403 73.6153C75.8239 73.2583 76.5719 72.6307 77.0769 71.8225C77.2096 71.6101 77.4186 71.1722 77.6252 69.9596C77.8407 68.6949 77.9907 67.0216 78.2174 64.4296L80.3214 40.3807L50.0013 37.7281L58.5987 30.6178L48.0273 18.2002L72.1114 20.3073C74.4532 20.5122 76.2505 20.6694 77.6881 20.8945C79.3417 21.1534 80.5195 21.5021 81.5025 22.1164C82.1087 22.4951 82.664 22.9422 83.1591 23.4463C83.9842 24.2865 84.6418 25.285 85.0881 26.3895C85.5646 27.569 85.6855 28.9238 85.6149 30.8604C85.5653 32.2226 85.4209 33.8727 85.239 35.9521L82.7131 64.8229C82.2725 69.8585 82.0523 72.3764 80.904 74.214C79.8939 75.8304 78.3981 77.0855 76.6308 77.7996C74.6218 78.6113 72.1039 78.391 67.0683 77.9505L54.543 76.8546L50.397 71.9618Z",
        fill: "url(#paint2_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsx36("path", {
        opacity: "0.35",
        d: "M36.4518 19.2056L23.7809 20.3141C19.3747 20.6996 16.8962 20.9165 15.1144 21.7339C14.8598 21.8507 14.6195 21.9797 14.3898 22.1232C12.8744 23.0702 11.6765 24.444 10.9444 26.0683C10.8956 26.1765 10.8488 26.2859 10.8042 26.3964C10.0432 28.2799 10.1892 30.6105 10.5735 35.0437C10.5991 35.3393 10.6258 35.6442 10.6533 35.9589L13.1792 64.8298C13.6197 69.8654 13.84 72.3832 14.9883 74.2208C15.9983 75.8372 17.4942 77.0924 19.2614 77.8064C21.2705 78.6181 23.7883 78.3979 28.824 77.9573L53.0537 75.8375L48.1211 71.7389L28.4306 73.4616C25.8387 73.6884 24.1647 73.8313 22.8818 73.8387C21.6518 73.8458 21.1842 73.716 20.952 73.6222C20.0683 73.2652 19.3204 72.6376 18.8154 71.8294C18.6827 71.617 18.4737 71.179 18.2671 69.9664C18.0515 68.7018 17.9016 67.0284 17.6749 64.4364L15.5709 40.3876L41.7867 38.094L49.0189 29.5988L36.4518 19.2056Z",
        fill: "url(#paint3_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsxs12("g", {
        opacity: "0.3",
        children: [
          /* @__PURE__ */ _jsx36("path", {
            d: "M19.1138 34.6158C18.5636 34.6639 18.0786 34.2569 18.0305 33.7067L17.769 30.7181C17.7209 30.168 18.1279 29.6829 18.678 29.6348L21.6666 29.3733C22.2168 29.3252 22.7018 29.7322 22.75 30.2824L23.0114 33.2709C23.0596 33.8211 22.6526 34.3062 22.1024 34.3543L19.1138 34.6158Z",
            fill: "url(#paint4_linear_18420_73)"
          }),
          /* @__PURE__ */ _jsx36("path", {
            d: "M29.0758 33.7442C28.5256 33.7923 28.0406 33.3854 27.9924 32.8352L27.7309 29.8466C27.6828 29.2964 28.0898 28.8114 28.64 28.7632L31.6286 28.5018C32.1788 28.4536 32.6638 28.8606 32.7119 29.4108L32.9734 32.3994C33.0215 32.9496 32.6145 33.4346 32.0644 33.4827L29.0758 33.7442Z",
            fill: "url(#paint5_linear_18420_73)"
          }),
          /* @__PURE__ */ _jsx36("path", {
            d: "M37.9544 31.9636C38.0025 32.5138 38.4875 32.9208 39.0377 32.8726L42.0263 32.6112C42.5765 32.563 42.9835 32.078 42.9353 31.5278L42.6739 28.5392C42.6257 27.9891 42.1407 27.5821 41.5905 27.6302L38.6019 27.8917C38.0518 27.9398 37.6448 28.4248 37.6929 28.975L37.9544 31.9636Z",
            fill: "url(#paint6_linear_18420_73)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx36("path", {
        d: "M26.8086 51.5772C26.8086 49.337 26.8086 48.2169 27.2446 47.3613C27.6281 46.6086 28.24 45.9967 28.9926 45.6132C29.8483 45.1772 30.9684 45.1772 33.2086 45.1772H62.7934C65.0336 45.1772 66.1537 45.1772 67.0093 45.6132C67.762 45.9967 68.3739 46.6086 68.7574 47.3613C69.1934 48.2169 69.1934 49.337 69.1934 51.5772V52.7604C69.1934 55.0006 69.1934 56.1207 68.7574 56.9764C68.3739 57.729 67.762 58.3409 67.0093 58.7244C66.1537 59.1604 65.0336 59.1604 62.7934 59.1604H33.2086C30.9684 59.1604 29.8483 59.1604 28.9926 58.7244C28.24 58.3409 27.6281 57.729 27.2446 56.9764C26.8086 56.1207 26.8086 55.0006 26.8086 52.7604V51.5772Z",
        fill: "url(#paint7_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsx36("path", {
        opacity: "0.3",
        d: "M26.8086 49.1772C26.8086 46.9681 28.5995 45.1772 30.8086 45.1772H65.1934C67.4025 45.1772 69.1934 46.9681 69.1934 49.1772V55.1604C69.1934 57.3695 67.4025 59.1604 65.1934 59.1604H30.8086C28.5995 59.1604 26.8086 57.3695 26.8086 55.1604V49.1772Z",
        fill: "url(#paint8_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsx36("path", {
        opacity: "0.3",
        d: "M41.8672 48.6362C41.8672 48.0839 42.3149 47.6362 42.8672 47.6362H53.4004C53.9527 47.6362 54.4004 48.0839 54.4004 48.6362V55.7007C54.4004 56.253 53.9527 56.7007 53.4004 56.7007H42.8672C42.3149 56.7007 41.8672 56.253 41.8672 55.7007V48.6362Z",
        fill: "url(#paint9_linear_18420_73)"
      }),
      /* @__PURE__ */ _jsxs12("defs", {
        children: [
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint0_linear_18420_73",
            x1: "67.1849",
            y1: "19.8827",
            x2: "62.1417",
            y2: "77.5259",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "0.0001",
                stopColor: "#9B4747"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#471C1C"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint1_linear_18420_73",
            x1: "28.7079",
            y1: "19.8828",
            x2: "33.751",
            y2: "77.526",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "0.0001",
                stopColor: "#9B4747"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#471C1C"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint2_linear_18420_73",
            x1: "67.2625",
            y1: "19.8831",
            x2: "62.2193",
            y2: "77.5262",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#FF9393",
                stopOpacity: "0.66"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#883737",
                stopOpacity: "0.51"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint3_linear_18420_73",
            x1: "28.7078",
            y1: "19.8831",
            x2: "33.751",
            y2: "77.5262",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#FF9393",
                stopOpacity: "0.66"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#883737",
                stopOpacity: "0.51"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint4_linear_18420_73",
            x1: "22.9127",
            y1: "27.6263",
            x2: "22.9127",
            y2: "31.687",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint5_linear_18420_73",
            x1: "22.9127",
            y1: "27.6263",
            x2: "22.9127",
            y2: "31.687",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint6_linear_18420_73",
            x1: "22.9127",
            y1: "27.6263",
            x2: "22.9127",
            y2: "31.687",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint7_linear_18420_73",
            x1: "38.977",
            y1: "30.0546",
            x2: "65.8251",
            y2: "117.392",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "0.0001",
                stopColor: "#A45454"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#450000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint8_linear_18420_73",
            x1: "26.8086",
            y1: "40.4056",
            x2: "65.5016",
            y2: "69.1945",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#834A4A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs12("linearGradient", {
            id: "paint9_linear_18420_73",
            x1: "44.4299",
            y1: "47.6362",
            x2: "44.4299",
            y2: "52.8995",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx36("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx36("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var ChatError_default = ChatError;

// src/shared/ui/icons/shared/ChatUnread.tsx
import { jsx as _jsx37, jsxs as _jsxs13 } from "react/jsx-runtime";
function _define_property39(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread39(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property39(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys30(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props30(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys30(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties31(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose31(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose31(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChatUnread = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties31(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs13("svg", _object_spread_props30(_object_spread39({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx37("circle", {
        cx: "23.055",
        cy: "8.983",
        r: "4.945",
        fill: getCssVar("red", 300)
      }),
      /* @__PURE__ */ _jsx37("path", {
        fill: props.fill || getCssVar("grey", 100),
        d: "M28.074 14.544a7.49 7.49 0 0 1-12.185-7.752H8.8a4.873 4.873 0 0 0-4.873 4.873v6.573A4.873 4.873 0 0 0 8.8 23.11h1.278c.361 0 .655.293.655.654v3.668c0 .512.56.826.996.558l7.803-4.784a.655.655 0 0 1 .342-.096H23.2a4.873 4.873 0 0 0 4.873-4.873v-3.694Z"
      })
    ]
  }));
};
var ChatUnread_default = ChatUnread;

// src/shared/ui/icons/shared/CheckRound.tsx
import { jsx as _jsx38 } from "react/jsx-runtime";
import React21 from "react";
function _define_property40(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread40(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property40(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys31(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props31(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys31(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties32(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose32(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose32(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CheckRound = (_param) => {
  var { width: width2 = 18, height: height2 = 18, fill = "#4e5158" } = _param, props = _object_without_properties32(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx38("svg", _object_spread_props31(_object_spread40({
    width: width2,
    height: height2,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx38("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM14.4714 5.59526C14.7318 5.85561 14.7318 6.27772 14.4714 6.53807L8.47141 12.5381C8.21106 12.7984 7.78895 12.7984 7.5286 12.5381L4.19526 9.20474C3.93491 8.94439 3.93491 8.52228 4.19526 8.26193C4.45561 8.00158 4.87772 8.00158 5.13807 8.26193L8 11.1239L13.5286 5.59526C13.7889 5.33491 14.2111 5.33491 14.4714 5.59526Z",
      fill
    })
  }));
};
var CheckRound_default = /* @__PURE__ */ React21.memo(CheckRound);

// src/shared/ui/icons/shared/ChevronDown.tsx
import { jsx as _jsx39 } from "react/jsx-runtime";
import React22 from "react";
function _define_property41(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread41(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property41(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys32(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props32(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys32(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties33(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose33(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose33(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChevronDown = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) || "#EBEDF0" } = _param, props = _object_without_properties33(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx39("svg", _object_spread_props32(_object_spread41({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx39("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.96967 9.96967C7.26256 9.67678 7.73744 9.67678 8.03033 9.96967L12 13.9393L15.9697 9.96967C16.2626 9.67678 16.7374 9.67678 17.0303 9.96967C17.3232 10.2626 17.3232 10.7374 17.0303 11.0303L12 16.0607L6.96967 11.0303C6.67678 10.7374 6.67678 10.2626 6.96967 9.96967Z",
      fill
    })
  }));
};
var ChevronDown_default = /* @__PURE__ */ React22.memo(ChevronDown);

// src/shared/ui/icons/shared/ChevronLeft.tsx
import { jsx as _jsx40 } from "react/jsx-runtime";
import React23 from "react";
function _define_property42(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread42(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property42(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys33(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props33(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys33(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties34(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose34(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose34(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChevronLeft = (_param) => {
  var { width: width2 = 8, height: height2 = 14, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties34(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx40("svg", _object_spread_props33(_object_spread42({
    width: width2,
    height: height2,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx40("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.7769 6.9999L7.18266 1.59414C7.42674 1.35006 7.42674 0.95433 7.18266 0.710252C6.93859 0.466175 6.54286 0.466175 6.29878 0.710252L0.504111 6.50492C0.230744 6.77829 0.230744 7.2215 0.504111 7.49487L6.29878 13.2895C6.54286 13.5336 6.93859 13.5336 7.18266 13.2895C7.42674 13.0455 7.42674 12.6497 7.18266 12.4057L1.7769 6.9999Z",
      fill
    })
  }));
};
var ChevronLeft_default = /* @__PURE__ */ React23.memo(ChevronLeft);

// src/shared/ui/icons/shared/ChevronRight.tsx
import { jsx as _jsx41 } from "react/jsx-runtime";
import React24 from "react";
function _define_property43(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread43(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property43(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys34(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props34(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys34(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties35(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose35(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose35(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChevronRight = (_param) => {
  var { width: width2 = 8, height: height2 = 14, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties35(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx41("svg", _object_spread_props34(_object_spread43({
    width: width2,
    height: height2,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx41("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.22358 7.0001L0.817824 12.4059C0.573746 12.6499 0.573746 13.0457 0.817824 13.2897V13.2897C1.0619 13.5338 1.45763 13.5338 1.70171 13.2897L7.49638 7.49508C7.76974 7.22171 7.76974 6.7785 7.49638 6.50513L1.70171 0.710459C1.45763 0.466382 1.0619 0.466382 0.817823 0.710459V0.710459C0.573745 0.954537 0.573745 1.35027 0.817823 1.59434L6.22358 7.0001Z",
      fill
    })
  }));
};
var ChevronRight_default = /* @__PURE__ */ React24.memo(ChevronRight);

// src/shared/ui/icons/shared/ChevronUp.tsx
import { jsx as _jsx42 } from "react/jsx-runtime";
import React25 from "react";
function _define_property44(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread44(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property44(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys35(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props35(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys35(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties36(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose36(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose36(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ChevronUp = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) || "#898E96" } = _param, props = _object_without_properties36(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx42("svg", _object_spread_props35(_object_spread44({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx42("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.0303 15.5303C16.7374 15.8232 16.2626 15.8232 15.9697 15.5303L12 11.5607L8.03033 15.5303C7.73744 15.8232 7.26256 15.8232 6.96967 15.5303C6.67678 15.2374 6.67678 14.7626 6.96967 14.4697L12 9.43934L17.0303 14.4697C17.3232 14.7626 17.3232 15.2374 17.0303 15.5303Z",
      fill
    })
  }));
};
var ChevronUp_default = /* @__PURE__ */ React25.memo(ChevronUp);

// src/shared/ui/icons/shared/Clock.tsx
import { jsx as _jsx43 } from "react/jsx-runtime";
import React26 from "react";
function _define_property45(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread45(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property45(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys36(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props36(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys36(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties37(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose37(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose37(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Clock = (_param) => {
  var { width: width2 = 18, height: height2 = 18, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties37(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx43("svg", _object_spread_props36(_object_spread45({
    width: width2,
    height: height2,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx43("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM9 4.50342C9.35898 4.50342 9.65 4.79443 9.65 5.15342V9.00342H13C13.359 9.00342 13.65 9.29443 13.65 9.65342C13.65 10.0124 13.359 10.3034 13 10.3034H9C8.64101 10.3034 8.35 10.0124 8.35 9.65342V5.15342C8.35 4.79443 8.64101 4.50342 9 4.50342Z",
      fill
    })
  }));
};
var Clock_default = /* @__PURE__ */ React26.memo(Clock);

// src/shared/ui/icons/shared/Close.tsx
import { jsx as _jsx44, jsxs as _jsxs14 } from "react/jsx-runtime";
function _define_property46(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread46(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property46(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys37(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props37(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys37(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties38(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose38(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose38(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Close = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties38(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs14("svg", _object_spread_props37(_object_spread46({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx44("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.39927 20.2633C3.1259 19.9899 3.12591 19.5467 3.39927 19.2733L19.2753 3.39732C19.5487 3.12395 19.9919 3.12395 20.2653 3.39732L20.6012 3.7332C20.8745 4.00656 20.8745 4.44978 20.6012 4.72315L4.7251 20.5992C4.45173 20.8725 4.00851 20.8725 3.73515 20.5992L3.39927 20.2633Z",
        fill
      }),
      /* @__PURE__ */ _jsx44("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.73476 3.39732C4.00813 3.12395 4.45134 3.12395 4.72471 3.39732L20.6007 19.2734C20.8741 19.5467 20.8741 19.99 20.6007 20.2633L20.2649 20.5992C19.9915 20.8726 19.5483 20.8726 19.2749 20.5992L3.39888 4.72314C3.12551 4.44977 3.12551 4.00656 3.39888 3.73319L3.73476 3.39732Z",
        fill
      })
    ]
  }));
};
var Close_default = Close;

// src/shared/ui/icons/shared/Comments.tsx
import { jsx as _jsx45, jsxs as _jsxs15 } from "react/jsx-runtime";
import React27 from "react";
function _define_property47(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread47(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property47(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys38(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props38(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys38(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties39(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose39(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose39(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Comments = (_param) => {
  var { width: width2 = 73, height: height2 = 70, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties39(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs15("svg", _object_spread_props38(_object_spread47({
    width: width2,
    height: height2,
    viewBox: "0 0 73 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx45("rect", {
        x: "27.9995",
        y: "27",
        width: "45",
        height: "38",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "46.0015",
        y: "47",
        width: "21",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "35.0005",
        y: "42",
        width: "32",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "35.0005",
        y: "37",
        width: "32",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "54.0015",
        y: "52",
        width: "13",
        height: "2",
        fill: "#4E5158"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.6",
        x: "0.000488281",
        width: "46",
        height: "34",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx45("path", {
        opacity: "0.6",
        d: "M6.00146 39L6.93751 34H13.0015L6.00146 39Z",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx45("path", {
        d: "M67.0015 70L66.0654 65H60.0015L67.0015 70Z",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "6.00146",
        y: "12",
        width: "21",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "6.00146",
        y: "7",
        width: "21",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx45("rect", {
        opacity: "0.9",
        x: "6.02881",
        y: "17",
        width: "13",
        height: "2",
        fill: "#4E5158"
      })
    ]
  }));
};
var Comments_default = /* @__PURE__ */ React27.memo(Comments);

// src/shared/ui/icons/shared/Copy.tsx
import { jsx as _jsx46, jsxs as _jsxs16 } from "react/jsx-runtime";
function _define_property48(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread48(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property48(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys39(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props39(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys39(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties40(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose40(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose40(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Copy = (_param) => {
  var { width: width2 = 16, height: height2 = 18, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties40(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs16("svg", _object_spread_props39(_object_spread48({
    width: width2,
    height: height2,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx46("path", {
        d: "M13.925 0.75C14.7534 0.75 15.425 1.42157 15.425 2.25L15.425 10.8C15.425 11.6284 14.7534 12.3 13.925 12.3H12.125V7.35C12.125 5.52746 10.6475 4.05 8.82501 4.05H5.52501V2.25C5.52501 1.42157 6.19658 0.75 7.02501 0.75H13.925Z",
        fill
      }),
      /* @__PURE__ */ _jsx46("path", {
        d: "M2.22501 5.7C1.31374 5.7 0.575012 6.43873 0.575012 7.35V15.6C0.575012 16.5113 1.31374 17.25 2.22501 17.25H8.82501C9.73628 17.25 10.475 16.5113 10.475 15.6L10.475 7.35C10.475 6.49568 9.82574 5.79302 8.99371 5.70852C8.93824 5.70289 8.88196 5.7 8.82501 5.7L2.22501 5.7Z",
        fill
      })
    ]
  }));
};
var Copy_default = Copy;

// src/shared/ui/icons/shared/CopyText.tsx
import { jsx as _jsx47, jsxs as _jsxs17 } from "react/jsx-runtime";
function _define_property49(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread49(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property49(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys40(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props40(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys40(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var CopyText = (props) => /* @__PURE__ */ _jsxs17("svg", _object_spread_props40(_object_spread49({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [
    /* @__PURE__ */ _jsx47("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.4254 5.75C19.4254 4.64543 18.53 3.75 17.4254 3.75H11.5254C10.4208 3.75 9.52539 4.64543 9.52539 5.75V7.05H12.8254C14.6479 7.05 16.1254 8.52746 16.1254 10.35L16.1254 15.3H17.4254C18.53 15.3 19.4254 14.4046 19.4254 13.3V5.75ZM14.4754 15.3L14.4754 10.35C14.4754 9.43873 13.7367 8.7 12.8254 8.7H9.52539V13.3C9.52539 14.4046 10.4208 15.3 11.5254 15.3H14.4754Z",
      fill: "#898E96"
    }),
    /* @__PURE__ */ _jsx47("path", {
      d: "M12.8251 8.69995C13.7364 8.69995 14.4751 9.43868 14.4751 10.35L14.4751 18.6C14.4751 19.5112 13.7364 20.25 12.8251 20.25L6.2251 20.25C5.31383 20.25 4.5751 19.5112 4.5751 18.6L4.5751 10.35C4.5751 9.43868 5.31383 8.69995 6.2251 8.69995L12.8251 8.69995Z",
      fill: "#898E96"
    })
  ]
}));
var CopyText_default = CopyText;

// src/shared/ui/icons/shared/CopySuccess.tsx
import { jsx as _jsx48 } from "react/jsx-runtime";
function _define_property50(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread50(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property50(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys41(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props41(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys41(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties41(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose41(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose41(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CopySuccess = (_param) => {
  var { fill = getCssVar("grey", 100) } = _param, props = _object_without_properties41(_param, [
    "fill"
  ]);
  return /* @__PURE__ */ _jsx48("svg", _object_spread_props41(_object_spread50({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx48("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.99482 16.3109L4.87088 12.187C4.66586 11.982 4.33345 11.982 4.12842 12.187L3.54506 12.7704C3.34003 12.9754 3.34003 13.3078 3.54506 13.5128L8.62359 18.5914C8.82861 18.7964 9.16102 18.7964 9.36605 18.5914L20.7821 7.17528C20.9871 6.97026 20.9872 6.63785 20.7821 6.43282L20.1988 5.84946C19.9937 5.64443 19.6613 5.64443 19.4563 5.84946L8.99482 16.3109Z",
      fill
    })
  }));
};
var CopySuccess_default = CopySuccess;

// src/shared/ui/icons/shared/Cross.tsx
import { jsx as _jsx49, jsxs as _jsxs18 } from "react/jsx-runtime";
function _define_property51(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread51(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property51(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys42(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props42(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys42(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties42(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose42(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose42(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Cross = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties42(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs18("svg", _object_spread_props42(_object_spread51({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx49("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.39927 20.2633C3.1259 19.9899 3.12591 19.5467 3.39927 19.2733L19.2753 3.39732C19.5487 3.12395 19.9919 3.12395 20.2653 3.39732L20.6012 3.7332C20.8745 4.00656 20.8745 4.44978 20.6012 4.72315L4.7251 20.5992C4.45173 20.8725 4.00851 20.8725 3.73515 20.5992L3.39927 20.2633Z",
        fill
      }),
      /* @__PURE__ */ _jsx49("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.73476 3.39732C4.00813 3.12395 4.45134 3.12395 4.72471 3.39732L20.6007 19.2734C20.8741 19.5467 20.8741 19.99 20.6007 20.2633L20.2649 20.5992C19.9915 20.8726 19.5483 20.8726 19.2749 20.5992L3.39888 4.72314C3.12551 4.44977 3.12551 4.00656 3.39888 3.73319L3.73476 3.39732Z",
        fill
      })
    ]
  }));
};
var Cross_default = Cross;

// src/shared/ui/icons/shared/Customize.tsx
import { jsx as _jsx50 } from "react/jsx-runtime";
import React28 from "react";
function _define_property52(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread52(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property52(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys43(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props43(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys43(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties43(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose43(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose43(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Search = (_param) => {
  var { width: width2 = 28, height: height2 = 18, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties43(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx50("svg", _object_spread_props43(_object_spread52({
    width: width2,
    height: height2,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx50("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.5759 2.5H13.4106C12.9073 1.18431 11.633 0.25 10.1404 0.25C8.64777 0.25 7.37339 1.18431 6.87018 2.5H1.42372C1.03712 2.5 0.723717 2.8134 0.723717 3.2V4.3C0.723717 4.6866 1.03712 5 1.42372 5H6.87018C7.37339 6.31569 8.64777 7.25 10.1404 7.25C11.633 7.25 12.9073 6.31569 13.4106 5H26.5759C26.9625 5 27.2759 4.6866 27.2759 4.3V3.2C27.2759 2.8134 26.9625 2.5 26.5759 2.5ZM26.6332 15.5005C27.0198 15.5005 27.3332 15.1871 27.3332 14.8005V13.7005C27.3332 13.3139 27.0198 13.0005 26.6332 13.0005L21.1295 13.0005C20.6263 11.6848 19.3519 10.7505 17.8593 10.7505C16.3667 10.7505 15.0923 11.6848 14.5891 13.0005L1.36651 13.0005C0.979906 13.0005 0.666504 13.3139 0.666504 13.7005V14.8005C0.666504 15.1871 0.979905 15.5005 1.3665 15.5005L14.5891 15.5005C15.0923 16.8162 16.3667 17.7505 17.8593 17.7505C19.3519 17.7505 20.6263 16.8162 21.1295 15.5005L26.6332 15.5005Z",
      fill
    })
  }));
};
var Customize_default = /* @__PURE__ */ React28.memo(Search);

// src/shared/ui/icons/shared/Delete.tsx
import { jsx as _jsx51, jsxs as _jsxs19 } from "react/jsx-runtime";
function _define_property53(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread53(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property53(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys44(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props44(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys44(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties44(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose44(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose44(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Delete = (_param) => {
  var { width: width2 = 22, height: height2 = 22, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties44(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs19("svg", _object_spread_props44(_object_spread53({
    width: width2,
    height: height2,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx51("path", {
        d: "M13.7938 17.0371L15.125 8.93359H6.875L8.11959 17.027C8.19462 17.5148 8.61438 17.875 9.10798 17.875H12.807C13.2968 17.875 13.7144 17.5203 13.7938 17.0371Z",
        fill,
        stroke: fill,
        strokeWidth: "2"
      }),
      /* @__PURE__ */ _jsx51("path", {
        d: "M4.8125 8.25H17.1875",
        stroke: fill,
        strokeWidth: "2",
        strokeLinecap: "round"
      }),
      /* @__PURE__ */ _jsx51("path", {
        d: "M8.25 4.125H13.75",
        stroke: fill,
        strokeWidth: "2",
        strokeLinecap: "round"
      })
    ]
  }));
};
var Delete_default = Delete;

// src/shared/ui/icons/shared/DeleteUser.tsx
import { jsx as _jsx52, jsxs as _jsxs20 } from "react/jsx-runtime";
import React29 from "react";
function _define_property54(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread54(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property54(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys45(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props45(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys45(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DeleteUser = (props) => /* @__PURE__ */ _jsxs20("svg", _object_spread_props45(_object_spread54({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [
    /* @__PURE__ */ _jsx52("path", {
      d: "M6.87213 7.39231C6.62844 5.28436 8.30587 3.4375 10.4641 3.4375C12.6224 3.4375 14.2998 5.28436 14.0561 7.39232L13.8439 9.22798C13.6486 10.9177 12.1941 12.1941 10.4641 12.1941C8.73412 12.1941 7.27968 10.9177 7.08434 9.22798L6.87213 7.39231Z"
    }),
    /* @__PURE__ */ _jsx52("path", {
      d: "M9.77908 12.9901C10.1962 12.9901 10.4754 13.4227 10.3708 13.8196C10.2731 14.1905 10.2212 14.5794 10.2212 14.9803C10.2212 15.6263 10.3561 16.2413 10.5999 16.7996C10.7846 17.2228 10.5 17.7665 10.0315 17.7665H4.69212C4.32945 17.7665 4.06006 17.4364 4.13873 17.0884L4.21966 16.7303C4.71371 14.545 6.68556 12.9901 8.96298 12.9901H9.77908Z"
    }),
    /* @__PURE__ */ _jsx52("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4951 12.4472C18.9183 13.8462 18.9183 16.1143 17.4951 17.5133C16.0719 18.9122 13.7645 18.9122 12.3413 17.5133C10.9182 16.1143 10.9182 13.8462 12.3413 12.4472C13.7645 11.0483 16.0719 11.0483 17.4951 12.4472ZM14.1412 13.4847C13.9356 13.2826 13.6023 13.2826 13.3967 13.4847C13.1912 13.6867 13.1912 14.0143 13.3967 14.2164L14.1738 14.9803L13.4743 15.6679C13.2687 15.87 13.2687 16.1976 13.4743 16.3997C13.6798 16.6017 14.0131 16.6017 14.2187 16.3997L14.9182 15.712L15.6953 16.4759C15.9009 16.678 16.2342 16.678 16.4398 16.4759C16.6453 16.2738 16.6453 15.9462 16.4398 15.7441L15.6627 14.9803L16.3622 14.2926C16.5678 14.0906 16.5678 13.7629 16.3622 13.5609C16.1566 13.3588 15.8233 13.3588 15.6178 13.5609L14.9182 14.2485L14.1412 13.4847Z"
    })
  ]
}));
var DeleteUser_default = /* @__PURE__ */ React29.memo(DeleteUser);

// src/shared/ui/icons/shared/DesktopClose.tsx
import { jsx as _jsx53 } from "react/jsx-runtime";
function _define_property55(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread55(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property55(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys46(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props46(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys46(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopClose = (props) => /* @__PURE__ */ _jsx53("svg", _object_spread_props46(_object_spread55({
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "12",
  fill: "none",
  viewBox: "0 0 11 12"
}, props), {
  children: /* @__PURE__ */ _jsx53("path", {
    fill: "#898E96",
    fillRule: "evenodd",
    d: "M.861.648a.505.505 0 0 0-.713.713L4.788 6l-4.64 4.638a.504.504 0 1 0 .713.714l4.64-4.638 4.638 4.636a.505.505 0 1 0 .713-.713L6.214 5.999l4.638-4.636a.504.504 0 1 0-.713-.714L5.5 5.286.86.648Z",
    clipRule: "evenodd"
  })
}));
var DesktopClose_default = DesktopClose;

// src/shared/ui/icons/shared/DesktopMaximize.tsx
import { jsx as _jsx54 } from "react/jsx-runtime";
function _define_property56(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread56(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property56(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys47(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props47(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys47(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopMaximize = (props) => /* @__PURE__ */ _jsx54("svg", _object_spread_props47(_object_spread56({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none",
  viewBox: "0 0 10 10"
}, props), {
  children: /* @__PURE__ */ _jsx54("rect", {
    width: "9",
    height: "9",
    x: ".5",
    y: ".5",
    stroke: "#898E96",
    rx: ".5"
  })
}));
var DesktopMaximize_default = DesktopMaximize;

// src/shared/ui/icons/shared/DesktopMenu.tsx
import { jsx as _jsx55 } from "react/jsx-runtime";
function _define_property57(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread57(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property57(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys48(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props48(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys48(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopMenu = (props) => /* @__PURE__ */ _jsx55("svg", _object_spread_props48(_object_spread57({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "12",
  fill: "none",
  viewBox: "0 0 16 12"
}, props), {
  children: /* @__PURE__ */ _jsx55("path", {
    fill: "#898E96",
    fillRule: "evenodd",
    d: "M0 1A.5.5 0 0 1 .5.5h15a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 1Zm0 5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 6Zm.5 4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5Z",
    clipRule: "evenodd"
  })
}));
var DesktopMenu_default = DesktopMenu;

// src/shared/ui/icons/shared/DesktopMinimize.tsx
import { jsx as _jsx56 } from "react/jsx-runtime";
function _define_property58(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread58(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property58(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys49(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props49(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys49(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopMinimize = (props) => /* @__PURE__ */ _jsx56("svg", _object_spread_props49(_object_spread58({
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "2",
  fill: "none",
  viewBox: "0 0 12 2"
}, props), {
  children: /* @__PURE__ */ _jsx56("rect", {
    width: "12",
    height: "1",
    y: ".5",
    fill: "#898E96",
    rx: ".5"
  })
}));
var DesktopMinimize_default = DesktopMinimize;

// src/shared/ui/icons/shared/DesktopPIPHide.tsx
import { jsx as _jsx57 } from "react/jsx-runtime";
function _define_property59(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread59(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property59(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys50(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props50(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys50(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopPIPHide = (props) => /* @__PURE__ */ _jsx57("svg", _object_spread_props50(_object_spread59({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), {
  children: /* @__PURE__ */ _jsx57("path", {
    fill: "#EBEDF0",
    d: "M13.625 7.43h3.285c.241 0 .437.197.437.438v.688a.438.438 0 0 1-.437.437h-5.515a.437.437 0 0 1-.438-.437V3.04c0-.241.196-.437.438-.437h.687c.242 0 .438.196.438.437v3.285l3.965-3.965c.171-.171.448-.171.62 0l.485.486c.171.17.171.448 0 .618l-3.965 3.966ZM7.529 13.673v3.285c0 .242.195.438.437.438h.688a.438.438 0 0 0 .437-.438v-5.515a.438.438 0 0 0-.437-.437H3.139a.438.438 0 0 0-.438.437v.688c0 .242.196.437.438.437h3.285l-3.966 3.966a.437.437 0 0 0 0 .619l.486.486c.171.17.448.17.62 0l3.965-3.966Z"
  })
}));
var DesktopPIPHide_default = DesktopPIPHide;

// src/shared/ui/icons/shared/DesktopPIPShow.tsx
import { jsx as _jsx58 } from "react/jsx-runtime";
function _define_property60(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread60(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property60(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys51(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props51(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys51(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopPIPShow = (props) => /* @__PURE__ */ _jsx58("svg", _object_spread_props51(_object_spread60({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), {
  children: /* @__PURE__ */ _jsx58("path", {
    fill: "#FAFCFF",
    d: "M13.64 5.552h-2.476a.33.33 0 0 1-.33-.33v-.517a.33.33 0 0 1 .33-.33h4.156a.33.33 0 0 1 .33.33V8.86a.33.33 0 0 1-.33.33h-.518a.33.33 0 0 1-.33-.33V6.385l-2.988 2.988a.33.33 0 0 1-.466 0l-.367-.366a.33.33 0 0 1 0-.466l2.988-2.989ZM6.41 14.447h2.475a.33.33 0 0 1 .33.33v.518a.33.33 0 0 1-.33.33H4.729a.33.33 0 0 1-.33-.33V11.14a.33.33 0 0 1 .33-.33h.518a.33.33 0 0 1 .33.33v2.475l2.988-2.988a.33.33 0 0 1 .466 0l.367.366a.33.33 0 0 1 0 .466l-2.989 2.989Z"
  })
}));
var DesktopPIPShow_default = DesktopPIPShow;

// src/shared/ui/icons/shared/DesktopUnmaximize.tsx
import { jsx as _jsx59 } from "react/jsx-runtime";
function _define_property61(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread61(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property61(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys52(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props52(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys52(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DesktopMaximize2 = (props) => /* @__PURE__ */ _jsx59("svg", _object_spread_props52(_object_spread61({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none",
  viewBox: "0 0 10 10"
}, props), {
  children: /* @__PURE__ */ _jsx59("path", {
    fill: "#EBEDF0",
    fillRule: "evenodd",
    d: "M2 1h5.5A1.5 1.5 0 0 1 9 2.5V8h1V2.5A2.5 2.5 0 0 0 7.5 0H2v1ZM1 4h5v5H1V4ZM0 4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4Z",
    clipRule: "evenodd"
  })
}));
var DesktopUnmaximize_default = DesktopMaximize2;

// src/shared/ui/icons/shared/Dislike.tsx
import { jsx as _jsx60, jsxs as _jsxs21 } from "react/jsx-runtime";
import React30 from "react";
function _define_property62(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread62(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property62(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys53(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props53(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys53(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties45(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose45(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose45(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Dislike = (_param) => {
  var { width: width2 = 19, height: height2 = 18, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties45(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs21("svg", _object_spread_props53(_object_spread62({
    width: width2,
    height: height2,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx60("path", {
        d: "M12.1551 13.2217C12.9789 12.2394 13.4304 10.9984 13.4304 9.7165V1.38244C13.4304 1.11132 13.2106 0.891535 12.9395 0.891535H5.88969C4.13297 0.891535 2.54754 1.94497 1.8669 3.56449L0.645027 6.47179C0.279463 7.34161 0.0911636 8.27563 0.0911636 9.21915V10.0647C0.0911636 10.9685 0.82379 11.7011 1.72753 11.7011H7.38498C7.72066 11.7011 7.95733 12.0305 7.85023 12.3486L6.6518 15.9087C6.47598 16.431 6.65158 17.0073 7.08878 17.3428C7.63643 17.7631 8.41796 17.6775 8.86158 17.1486L12.1551 13.2217Z",
        fill
      }),
      /* @__PURE__ */ _jsx60("path", {
        d: "M18.0611 10.6548C18.3322 10.6548 18.552 10.435 18.552 10.1639V1.38245C18.552 1.11132 18.3322 0.891537 18.0611 0.891537H16.1031C15.832 0.891537 15.6122 1.11133 15.6122 1.38245V10.1639C15.6122 10.435 15.832 10.6548 16.1031 10.6548H18.0611Z",
        fill
      })
    ]
  }));
};
var Dislike_default = /* @__PURE__ */ React30.memo(Dislike);

// src/shared/ui/icons/shared/Download.tsx
import { jsx as _jsx61, jsxs as _jsxs22 } from "react/jsx-runtime";
import React31 from "react";
function _define_property63(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread63(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property63(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys54(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props54(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys54(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties46(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose46(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose46(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Download = (_param) => {
  var { width: width2 = 12, height: height2 = 13, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties46(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs22("svg", _object_spread_props54(_object_spread63({
    width: width2,
    height: height2,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx61("path", {
        d: "M11.019 4.94238C11.327 5.25037 11.327 5.74972 11.019 6.05772L7.11534 9.96139C6.49935 10.5774 5.50065 10.5774 4.88467 9.96139L0.980994 6.05771C0.673002 5.74972 0.673002 5.25037 0.980994 4.94238C1.28899 4.63439 1.78834 4.63439 2.09633 4.94238L5.21442 8.06047C5.21467 7.12436 5.213 6.31335 5.21133 5.50178L5.21133 5.50102C5.20863 4.19009 5.20593 2.87743 5.21133 1.03635C5.21261 0.600784 5.56674 0.248726 6.0023 0.250003C6.43786 0.25128 6.78992 0.60541 6.78865 1.04097C6.78326 2.87806 6.78595 4.18732 6.78865 5.498L6.78865 5.49889C6.79031 6.30862 6.79198 7.11919 6.79174 8.05432L9.90367 4.94238C10.2117 4.63439 10.711 4.63439 11.019 4.94238Z",
        fill
      }),
      /* @__PURE__ */ _jsx61("path", {
        d: "M1.5 11.5C1.08579 11.5 0.75 11.8358 0.75 12.25C0.75 12.6642 1.08579 13 1.5 13H10.5C10.9142 13 11.25 12.6642 11.25 12.25C11.25 11.8358 10.9142 11.5 10.5 11.5H1.5Z",
        fill
      })
    ]
  }));
};
var Download_default = /* @__PURE__ */ React31.memo(Download);

// src/shared/ui/icons/shared/DrawerShare.tsx
import { jsx as _jsx62, jsxs as _jsxs23 } from "react/jsx-runtime";
import React32 from "react";
function _define_property64(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread64(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property64(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys55(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props55(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys55(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties47(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose47(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose47(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var DrawerShare = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties47(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs23("svg", _object_spread_props55(_object_spread64({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsxs23("g", {
        clipPath: "url(#clip0_5061_30175)",
        children: [
          /* @__PURE__ */ _jsx62("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.23163 13.5196C3.78194 14.9693 3.78194 17.3197 5.23163 18.7694C6.68133 20.2191 9.03175 20.2191 10.4814 18.7694L12.2723 16.9786C12.5456 16.7052 12.9889 16.7052 13.2622 16.9786L13.5981 17.3145C13.8715 17.5878 13.8715 18.0311 13.5981 18.3044L11.8073 20.0953C9.62534 22.2772 6.08774 22.2772 3.90581 20.0953C1.72388 17.9133 1.72388 14.3757 3.90581 12.1938L5.69664 10.403C5.97001 10.1296 6.41322 10.1296 6.68659 10.403L7.02246 10.7388C7.29583 11.0122 7.29583 11.4554 7.02247 11.7288L5.23163 13.5196ZM13.519 5.23226L11.7282 7.0231C11.4548 7.29646 11.0116 7.29646 10.7382 7.0231L10.4023 6.68722C10.129 6.41385 10.129 5.97064 10.4023 5.69727L12.1932 3.90644C14.3751 1.72451 17.9127 1.72451 20.0946 3.90644C22.2766 6.08837 22.2766 9.62597 20.0946 11.8079L18.3038 13.5987C18.0304 13.8721 17.5872 13.8721 17.3138 13.5987L16.978 13.2629C16.7046 12.9895 16.7046 12.5463 16.978 12.2729L18.7688 10.4821C20.2185 9.03238 20.2185 6.68196 18.7688 5.23226C17.3191 3.78257 14.9687 3.78257 13.519 5.23226Z",
            fill
          }),
          /* @__PURE__ */ _jsx62("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.16685 16.495C6.89348 16.2216 6.89348 15.7784 7.16685 15.505L15.5057 7.16614C15.7791 6.89277 16.2223 6.89277 16.4957 7.16614L16.8316 7.50201C17.1049 7.77538 17.1049 8.2186 16.8316 8.49196L8.49267 16.8309C8.21931 17.1042 7.77609 17.1042 7.50273 16.8309L7.16685 16.495Z",
            fill
          })
        ]
      }),
      /* @__PURE__ */ _jsx62("defs", {
        children: /* @__PURE__ */ _jsx62("clipPath", {
          id: "clip0_5061_30175",
          children: /* @__PURE__ */ _jsx62("rect", {
            width: "24",
            height: "24",
            fill
          })
        })
      })
    ]
  }));
};
var DrawerShare_default = /* @__PURE__ */ React32.memo(DrawerShare);

// src/shared/ui/icons/shared/Edit.tsx
import { jsx as _jsx63 } from "react/jsx-runtime";
import React33 from "react";
function _define_property65(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread65(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property65(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys56(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props56(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys56(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties48(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose48(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose48(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Edit = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties48(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx63("svg", _object_spread_props56(_object_spread65({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx63("path", {
      fill,
      d: "M20.5937 7.52088L16.7073 3.45793C16.4457 3.17803 16.0906 3.01415 15.716 3.00039C15.5259 2.99582 15.3369 3.03159 15.1605 3.10552C14.984 3.17945 14.8238 3.29001 14.6896 3.43048L12.3736 5.83713L4.16232 14.4114C4.03152 14.5468 3.92773 14.7079 3.85696 14.8854C3.78619 15.0629 3.74984 15.2532 3.75 15.4455V19.5359C3.75 19.9242 3.89788 20.2966 4.16112 20.5712C4.42435 20.8457 4.78137 21 5.15364 21H9.07505C9.44689 20.9983 9.80309 20.8438 10.0664 20.5699L20.5937 9.58896C20.854 9.31332 21 8.94189 21 8.55492C21 8.16795 20.854 7.79652 20.5937 7.52088ZM17.7864 10.4491L13.865 6.35873L15.6809 4.46452L19.6023 8.55492L17.7864 10.4491Z"
    })
  }));
};
var Edit_default = /* @__PURE__ */ React33.memo(Edit);

// src/shared/ui/icons/shared/Email.tsx
import { jsx as _jsx64 } from "react/jsx-runtime";
import { memo } from "react";
function _define_property66(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread66(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property66(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys57(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props57(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys57(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties49(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose49(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose49(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Email = (_param) => {
  var { width: width2 = 14, height: height2 = 14, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties49(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx64("svg", _object_spread_props57(_object_spread66({
    xmlns: "http://www.w3.org/2000/svg",
    width: width2,
    height: height2,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), {
    children: /* @__PURE__ */ _jsx64("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill,
      d: "M11.7092 5.09936V9.5329C11.7092 10.0886 11.2587 10.5392 10.7029 10.5392H3.29727C2.74153 10.5392 2.29102 10.0886 2.29102 9.5329L2.29102 5.09938L5.63438 7.57185C6.44595 8.17201 7.55422 8.17201 8.36578 7.57185L11.7092 5.09936ZM11.5196 3.87919C11.3369 3.62581 11.0392 3.46088 10.7029 3.46088L3.29727 3.46088C2.96101 3.46088 2.66327 3.62582 2.48054 3.8792L6.28472 6.69244C6.70982 7.00681 7.29035 7.00681 7.71545 6.69244L11.5196 3.87919ZM10.7029 2.36713C11.8627 2.36713 12.8029 3.30733 12.8029 4.46713V9.5329C12.8029 10.6927 11.8627 11.6329 10.7029 11.6329H3.29727C2.13747 11.6329 1.19727 10.6927 1.19727 9.5329V4.46713C1.19727 3.30733 2.13747 2.36713 3.29727 2.36713H10.7029Z"
    })
  }));
};
var Email_default = /* @__PURE__ */ memo(Email);

// src/shared/ui/icons/shared/EmailSecond.tsx
import { jsx as _jsx65 } from "react/jsx-runtime";
import React34 from "react";
function _define_property67(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread67(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property67(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys58(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props58(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys58(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties50(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose50(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose50(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EmailSecond = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("red", 300) } = _param, props = _object_without_properties50(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx65("svg", _object_spread_props58(_object_spread67({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx65("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.9482 7.65762C21.9482 5.66939 20.3364 4.05762 18.3482 4.05762L5.65274 4.05762C3.66451 4.05762 2.05273 5.6694 2.05273 7.65762L2.05273 16.3418C2.05273 18.33 3.66451 19.9418 5.65274 19.9418H18.3482C20.3364 19.9418 21.9482 18.33 21.9482 16.3418V7.65762ZM5.8933 7.38789L12.0004 11.9042L18.1076 7.3879C18.3407 7.2155 18.6695 7.26472 18.8419 7.49785L19.3324 8.16118C19.5048 8.3943 19.4556 8.72305 19.2224 8.89545L12.3126 14.0054C12.1271 14.1425 11.8738 14.1425 11.6883 14.0054L4.77845 8.89545C4.54532 8.72305 4.49609 8.3943 4.66849 8.16117L5.15903 7.49785C5.33143 7.26472 5.66017 7.21549 5.8933 7.38789Z",
      fill
    })
  }));
};
var EmailSecond_default = /* @__PURE__ */ React34.memo(EmailSecond);

// src/shared/ui/icons/shared/Error.tsx
import { jsx as _jsx66 } from "react/jsx-runtime";
import React35 from "react";
function _define_property68(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread68(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property68(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys59(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props59(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys59(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties51(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose51(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose51(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Error2 = (_param) => {
  var { width: width2 = 33, height: height2 = 34, fill = getCssVar("red", 300) } = _param, props = _object_without_properties51(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx66("svg", _object_spread_props59(_object_spread68({
    width: width2,
    height: height2,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx66("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 33.5C25.6127 33.5 33 26.1127 33 17C33 7.8873 25.6127 0.5 16.5 0.5C7.3873 0.5 0 7.8873 0 17C0 26.1127 7.3873 33.5 16.5 33.5ZM24.3178 10.188C24.6713 10.5415 24.6713 11.1146 24.3178 11.4681L18.7859 17L24.3177 22.5318C24.6712 22.8853 24.6712 23.4585 24.3177 23.8119L23.3119 24.8177C22.9584 25.1712 22.3853 25.1712 22.0318 24.8177L16.5 19.2859L10.9682 24.8177C10.6147 25.1712 10.0416 25.1712 9.68809 24.8177L8.6823 23.8119C8.32881 23.4584 8.32881 22.8853 8.6823 22.5318L14.2141 17L8.68223 11.4681C8.32874 11.1146 8.32874 10.5415 8.68223 10.188L9.68803 9.18224C10.0415 8.82875 10.6146 8.82875 10.9681 9.18224L16.5 14.7141L22.0319 9.18223C22.3854 8.82874 22.9585 8.82874 23.312 9.18223L24.3178 10.188Z",
      fill
    })
  }));
};
var Error_default = /* @__PURE__ */ React35.memo(Error2);

// src/shared/ui/icons/shared/Exit.tsx
import { jsx as _jsx67 } from "react/jsx-runtime";
import React36 from "react";
function _object_without_properties52(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose52(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose52(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Exit = (_param) => {
  var { width: width2 = 25, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties52(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx67("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ _jsx67("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7927 19.4247C18.8766 19.0473 18.5552 18.73 18.1686 18.73H17.6936C17.307 18.73 17.0084 19.0647 16.8116 19.3974C16.5831 19.7836 16.1624 20.0426 15.6811 20.0426L7.69922 20.0426C7.50875 20.0426 7.32777 20.002 7.16442 19.929L10.8412 17.5973C11.4919 17.1846 11.8862 16.4677 11.8862 15.6972V7.65698C11.8862 6.80949 11.41 6.03389 10.6542 5.65045L7.33776 3.96788C7.45259 3.93506 7.57385 3.91748 7.69922 3.91748L15.6811 3.91748C16.1624 3.91748 16.5831 4.17646 16.8116 4.56264C17.0084 4.89537 17.307 5.23 17.6936 5.23H18.1686C18.5552 5.23 18.8766 4.91272 18.7927 4.53533C18.4757 3.10898 17.203 2.04248 15.6811 2.04248L7.69922 2.04248C5.93881 2.04248 4.51172 3.46957 4.51172 5.22998L4.51172 18.7301C4.51172 20.4905 5.93881 21.9176 7.69922 21.9176L15.6811 21.9176C17.203 21.9176 18.4757 20.8511 18.7927 19.4247ZM18.514 11.0624H14.9365C14.5499 11.0624 14.2365 11.3758 14.2365 11.7624V12.2374C14.2365 12.624 14.5499 12.9374 14.9365 12.9374H18.5142L17.1003 14.3513C16.8269 14.6247 16.8269 15.0679 17.1003 15.3413L17.4362 15.6772C17.7095 15.9505 18.1528 15.9505 18.4261 15.6772L21.6083 12.495C21.8817 12.2216 21.8817 11.7784 21.6083 11.5051L18.4261 8.32289C18.1528 8.04953 17.7095 8.04953 17.4362 8.32289L17.1003 8.65877C16.8269 8.93214 16.8269 9.37535 17.1003 9.64872L18.514 11.0624Z",
      fill
    })
  });
};
var Exit_default = /* @__PURE__ */ React36.memo(Exit);

// src/shared/ui/icons/shared/Eye.tsx
import { jsx as _jsx68 } from "react/jsx-runtime";
import React37 from "react";
function _define_property69(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread69(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property69(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys60(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props60(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys60(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties53(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose53(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose53(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Eye = (_param) => {
  var { width: width2 = 11, height: height2 = 8, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties53(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx68("svg", _object_spread_props60(_object_spread69({
    width: width2,
    height: height2,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx68("path", {
      d: "M10.1602 3.875C10.1485 3.84375 9.81649 3.10938 9.08211 2.37109C8.10165 1.39453 6.86336 0.875 5.50008 0.875C4.1368 0.875 2.89852 1.39453 1.91805 2.37109C1.18368 3.10938 0.851645 3.84375 0.839927 3.875C0.822486 3.91437 0.813477 3.95694 0.813477 4C0.813477 4.04306 0.822486 4.08563 0.839927 4.125C0.851645 4.15625 1.18368 4.89062 1.91805 5.62891C2.89852 6.60547 4.1368 7.125 5.50008 7.125C6.86336 7.125 8.10165 6.60547 9.08211 5.62891C9.81649 4.89062 10.1485 4.15625 10.1602 4.125C10.1777 4.08563 10.1867 4.04306 10.1867 4C10.1867 3.95694 10.1777 3.91437 10.1602 3.875ZM5.50008 2.59375C5.77821 2.59375 6.0501 2.67623 6.28135 2.83075C6.51261 2.98527 6.69285 3.20489 6.79929 3.46185C6.90572 3.71881 6.93357 4.00156 6.87931 4.27435C6.82505 4.54713 6.69112 4.7977 6.49445 4.99437C6.29778 5.19104 6.04721 5.32497 5.77443 5.37923C5.50164 5.43349 5.21889 5.40564 4.96193 5.29921C4.70498 5.19277 4.48535 5.01253 4.33083 4.78127C4.17631 4.55001 4.09383 4.27813 4.09383 4C4.09383 3.62704 4.24199 3.26935 4.50571 3.00563C4.76944 2.74191 5.12712 2.59375 5.50008 2.59375Z",
      fill
    })
  }));
};
var Eye_default = /* @__PURE__ */ React37.memo(Eye);

// src/shared/ui/icons/shared/EyeClose.tsx
import { jsx as _jsx69, jsxs as _jsxs24 } from "react/jsx-runtime";
import React38 from "react";
function _define_property70(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread70(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property70(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys61(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props61(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys61(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties54(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose54(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose54(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EyeClose = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties54(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs24("svg", _object_spread_props61(_object_spread70({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx69("path", {
        d: "M20 10C20 12.5714 16.4183 16 12 16C7.58172 16 4 12.5714 4 10",
        stroke: fill,
        strokeWidth: "2",
        strokeLinecap: "round"
      }),
      /* @__PURE__ */ _jsx69("rect", {
        x: "11",
        y: "15",
        width: "2",
        height: "5",
        rx: "1",
        fill
      }),
      /* @__PURE__ */ _jsx69("rect", {
        x: "6.38403",
        y: "13.835",
        width: "2",
        height: "4.49902",
        rx: "1",
        transform: "rotate(30 6.38403 13.835)",
        fill
      }),
      /* @__PURE__ */ _jsx69("rect", {
        x: "15.884",
        y: "14.835",
        width: "2",
        height: "4.5",
        rx: "1",
        transform: "rotate(-30 15.884 14.835)",
        fill
      })
    ]
  }));
};
var EyeClose_default = /* @__PURE__ */ React38.memo(EyeClose);

// src/shared/ui/icons/shared/EyeOpen.tsx
import { jsx as _jsx70, jsxs as _jsxs25 } from "react/jsx-runtime";
import React39 from "react";
function _define_property71(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread71(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property71(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys62(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props62(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys62(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties55(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose55(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose55(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EyeOpen = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties55(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs25("svg", _object_spread_props62(_object_spread71({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx70("path", {
        d: "M20 12C20 13.0928 19.2258 14.5887 17.7189 15.8609C16.2451 17.1051 14.2177 18 12 18C9.78228 18 7.75494 17.1051 6.28113 15.8609C4.77423 14.5887 4 13.0928 4 12C4 10.9072 4.77423 9.4113 6.28113 8.13911C7.75494 6.89486 9.78228 6 12 6C14.2177 6 16.2451 6.89486 17.7189 8.13911C19.2258 9.4113 20 10.9072 20 12Z",
        stroke: fill,
        strokeWidth: "2"
      }),
      /* @__PURE__ */ _jsx70("circle", {
        cx: "12",
        cy: "12",
        r: "2",
        fill
      })
    ]
  }));
};
var EyeOpen_default = /* @__PURE__ */ React39.memo(EyeOpen);

// src/shared/ui/icons/shared/Hand.tsx
import { jsx as _jsx71 } from "react/jsx-runtime";
import { memo as memo2 } from "react";
function _define_property72(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread72(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property72(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys63(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props63(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys63(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Hand = (props) => /* @__PURE__ */ _jsx71("svg", _object_spread_props63(_object_spread72({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), {
  children: /* @__PURE__ */ _jsx71("path", {
    fill: props.fill || getCssVar("grey", 100),
    d: "M14.311 4.678c.04-1 .666-1.712 1.567-1.712.902 0 1.454.765 1.5 1.787.04.894.163 7.724.193 9.426.004.223.17.41.395.448a.471.471 0 0 0 .549-.384c.258-1.661 1.133-7.26 1.328-8.232.23-1.142.824-1.703 1.773-1.572.89.123 1.231.855 1.11 2.063-.105 1.055-.86 7.214-1.049 8.748-.025.205.093.4.288.48a.474.474 0 0 0 .632-.29c.362-1.152 1.291-4.108 1.9-6.022.393-1.239.958-1.757 1.865-1.509.907.249 1.035.982.764 2.331-.27 1.35-1.173 6.06-2.19 10.133-1.515 6.062-4.16 8.328-8.354 8.328-4.875 0-6.154-1.645-10.7-6.838-1.07-1.222-1.416-1.474-2.396-2.813-.923-1.262-.947-2.11-.292-2.73.98-.928 2.28-.12 3.267.658 1.181.933 2.308 1.81 2.813 2.2a.51.51 0 0 0 .576.032.485.485 0 0 0 .235-.46C9.91 16.887 8.968 6.986 8.871 5.994c-.108-1.096.327-1.953 1.328-2.056 1-.104 1.63.755 1.772 1.735.123.85.968 6.825 1.192 8.409a.453.453 0 0 0 .455.384c.25 0 .454-.19.46-.435.042-1.784.199-8.488.233-9.354Z"
  })
}));
var Hand_default = /* @__PURE__ */ memo2(Hand);

// src/shared/ui/icons/shared/Image.tsx
import { jsx as _jsx72, jsxs as _jsxs26 } from "react/jsx-runtime";
function _define_property73(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread73(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property73(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys64(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props64(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys64(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties56(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose56(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose56(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Image = (_param) => {
  var { width: width2 = 60, height: height2 = 54, fill = getCssVar("grey", 700) } = _param, props = _object_without_properties56(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs26("svg", _object_spread_props64(_object_spread73({
    width: width2,
    height: height2,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx72("path", {
        d: "M40.5 18C42.9853 18 45 15.9853 45 13.5C45 11.0147 42.9853 9 40.5 9C38.0147 9 36 11.0147 36 13.5C36 15.9853 38.0147 18 40.5 18Z",
        fill
      }),
      /* @__PURE__ */ _jsx72("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 0C4.02944 0 0 4.02944 0 9V45C0 49.9706 4.02944 54 9 54H51C55.9706 54 60 49.9706 60 45V9C60 4.02944 55.9706 0 51 0H9ZM51 6H9C7.34315 6 6 7.34315 6 9V24.3748L15 16.4993L39 39L48 30L54 35V9C54 7.34314 52.6569 6 51 6Z",
        fill
      })
    ]
  }));
};
var Image_default = Image;

// src/shared/ui/icons/shared/Info.tsx
import { jsx as _jsx73 } from "react/jsx-runtime";
import React40 from "react";
function _define_property74(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread74(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property74(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys65(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props65(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys65(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties57(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose57(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose57(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Info = (_param) => {
  var { width: width2 = 12, height: height2 = 12, fill = "#d9d9d9" } = _param, props = _object_without_properties57(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx73("svg", _object_spread_props65(_object_spread74({
    width: width2,
    height: height2,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx73("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.29674 2.82015C5.29674 2.63837 5.4441 2.491 5.62589 2.491H6.37411C6.5559 2.491 6.70326 2.63837 6.70326 2.82015V3.39319C6.70326 3.57497 6.5559 3.72234 6.37411 3.72234H5.62589C5.4441 3.72234 5.29674 3.57497 5.29674 3.39319V2.82015ZM6.25861 4.69377C6.4404 4.69377 6.58777 4.84114 6.58777 5.02292V9.23779C6.58777 9.41957 6.4404 9.56694 6.25861 9.56694H5.74138C5.55959 9.56694 5.41223 9.41957 5.41223 9.23779V5.02292C5.41223 4.84114 5.55959 4.69377 5.74138 4.69377H6.25861Z",
      fill
    })
  }));
};
var Info_default = /* @__PURE__ */ React40.memo(Info);

// src/shared/ui/icons/shared/InfoRound.tsx
import { jsx as _jsx74 } from "react/jsx-runtime";
function _define_property75(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread75(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property75(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys66(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props66(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys66(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties58(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose58(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose58(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var InfoRound = (_param) => {
  var { width: width2 = 16, height: height2 = 16, fill = getCssVar("red", 300) } = _param, props = _object_without_properties58(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx74("svg", _object_spread_props66(_object_spread75({
    width: width2,
    height: height2,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx74("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM7.29674 4.82015C7.29674 4.63837 7.4441 4.491 7.62589 4.491H8.37411C8.5559 4.491 8.70326 4.63837 8.70326 4.82015V5.39319C8.70326 5.57497 8.5559 5.72234 8.37411 5.72234H7.62589C7.4441 5.72234 7.29674 5.57497 7.29674 5.39319V4.82015ZM8.25861 6.69377C8.4404 6.69377 8.58777 6.84114 8.58777 7.02292V11.2378C8.58777 11.4196 8.4404 11.5669 8.25861 11.5669H7.74138C7.55959 11.5669 7.41223 11.4196 7.41223 11.2378V7.02292C7.41223 6.84114 7.55959 6.69377 7.74138 6.69377H8.25861Z",
      fill
    })
  }));
};
var InfoRound_default = InfoRound;

// src/shared/ui/icons/shared/Key.tsx
import { jsx as _jsx75 } from "react/jsx-runtime";
import React41 from "react";
function _define_property76(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread76(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property76(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys67(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props67(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys67(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties59(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose59(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose59(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Key = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = "#D9D9D9" } = _param, props = _object_without_properties59(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx75("svg", _object_spread_props67(_object_spread76({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx75("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7256 15.1877C11.0007 15.4817 10.2081 15.6436 9.37771 15.6436C5.92538 15.6436 3.12671 12.8449 3.12671 9.3926C3.12671 5.94027 5.92538 3.1416 9.37771 3.1416C12.83 3.1416 15.6287 5.94027 15.6287 9.3926C15.6287 10.2156 15.4697 11.0014 15.1806 11.7211L20.3587 16.8991C20.4571 16.9976 20.5124 17.1311 20.5124 17.2703V19.9887C20.5124 20.2786 20.2774 20.5137 19.9874 20.5137H17.269C17.1298 20.5137 16.9963 20.4584 16.8978 20.3599L15.7102 19.1723C15.658 19.1201 15.6287 19.0493 15.6287 18.9755V17.287C15.6287 16.9971 15.3936 16.762 15.1037 16.762H13.5174C13.3782 16.762 13.2446 16.7067 13.1462 16.6083L11.7256 15.1877ZM8.94385 7.50009C8.94385 8.29745 8.29746 8.94384 7.5001 8.94384C6.70274 8.94384 6.05635 8.29745 6.05635 7.50009C6.05635 6.70273 6.70274 6.05634 7.5001 6.05634C8.29746 6.05634 8.94385 6.70273 8.94385 7.50009Z",
      fill
    })
  }));
};
var Key_default = /* @__PURE__ */ React41.memo(Key);

// src/shared/ui/icons/shared/Like.tsx
import { jsx as _jsx76, jsxs as _jsxs27 } from "react/jsx-runtime";
import React42 from "react";
function _define_property77(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread77(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property77(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys68(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props68(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys68(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties60(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose60(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose60(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Like = (_param) => {
  var { width: width2 = 8, height: height2 = 8, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties60(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs27("svg", _object_spread_props68(_object_spread77({
    width: width2,
    height: height2,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx76("path", {
        d: "M2.95346 2.03305C2.61021 2.44231 2.42208 2.95939 2.42208 3.49353V6.96606C2.42208 7.07902 2.51365 7.1706 2.62662 7.1706H5.56405C6.29602 7.1706 6.95661 6.73167 7.24021 6.05687L7.74933 4.8455C7.90164 4.48307 7.9801 4.09389 7.9801 3.70076V3.34844C7.9801 2.97188 7.67484 2.66662 7.29828 2.66662H4.94101C4.80114 2.66662 4.70253 2.52938 4.74716 2.39682L5.2465 0.913452C5.31976 0.695822 5.2466 0.455691 5.06443 0.315888C4.83624 0.140765 4.5106 0.176454 4.32576 0.396844L2.95346 2.03305Z",
        fill
      }),
      /* @__PURE__ */ _jsx76("path", {
        d: "M0.492631 3.10259C0.379664 3.10259 0.288086 3.19416 0.288086 3.30713V6.96605C0.288086 7.07902 0.379664 7.1706 0.492631 7.1706H1.30844C1.42141 7.1706 1.51299 7.07902 1.51299 6.96605V3.30713C1.51299 3.19416 1.42141 3.10259 1.30844 3.10259H0.492631Z",
        fill
      })
    ]
  }));
};
var Like_default = /* @__PURE__ */ React42.memo(Like);

// src/shared/ui/icons/shared/Link.tsx
import { jsx as _jsx77, jsxs as _jsxs28 } from "react/jsx-runtime";
import React43 from "react";
function _object_without_properties61(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose61(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose61(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Link = (_param) => {
  var { width: width2 = 25, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties61(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs28("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsxs28("g", {
        clipPath: "url(#clip0_1442_1426)",
        children: [
          /* @__PURE__ */ _jsx77("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.23383 13.5186C3.78414 14.9683 3.78413 17.3188 5.23383 18.7685C6.68352 20.2182 9.03394 20.2182 10.4836 18.7685L12.2745 16.9776C12.5478 16.7043 12.9911 16.7043 13.2644 16.9776L13.6003 17.3135C13.8737 17.5869 13.8737 18.0301 13.6003 18.3035L11.8095 20.0943C9.62754 22.2762 6.08993 22.2762 3.908 20.0943C1.72608 17.9124 1.72608 14.3748 3.90801 12.1928L5.69884 10.402C5.9722 10.1286 6.41542 10.1286 6.68879 10.402L7.02466 10.7379C7.29803 11.0112 7.29803 11.4545 7.02466 11.7278L5.23383 13.5186ZM13.5212 5.23128L11.7304 7.02212C11.457 7.29549 11.0138 7.29549 10.7404 7.02212L10.4045 6.68624C10.1312 6.41288 10.1312 5.96966 10.4045 5.69629L12.1954 3.90546C14.3773 1.72353 17.9149 1.72353 20.0968 3.90546C22.2788 6.08739 22.2788 9.62499 20.0968 11.8069L18.306 13.5978C18.0326 13.8711 17.5894 13.8711 17.316 13.5978L16.9802 13.2619C16.7068 12.9885 16.7068 12.5453 16.9802 12.2719L18.771 10.4811C20.2207 9.0314 20.2207 6.68098 18.771 5.23129C17.3213 3.78159 14.9709 3.78159 13.5212 5.23128Z",
            fill: "#EBEDF0"
          }),
          /* @__PURE__ */ _jsx77("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.17002 16.4964C6.89666 16.2231 6.89666 15.7799 7.17002 15.5065L15.5089 7.1676C15.7823 6.89423 16.2255 6.89423 16.4989 7.1676L16.8347 7.50348C17.1081 7.77684 17.1081 8.22006 16.8347 8.49343L8.49585 16.8323C8.22248 17.1057 7.77927 17.1057 7.5059 16.8323L7.17002 16.4964Z",
            fill: "#EBEDF0"
          })
        ]
      }),
      /* @__PURE__ */ _jsx77("defs", {
        children: /* @__PURE__ */ _jsx77("clipPath", {
          id: "clip0_1442_1426",
          children: /* @__PURE__ */ _jsx77("rect", {
            width: "24",
            height: "24",
            fill,
            transform: "translate(0.00244141)"
          })
        })
      })
    ]
  });
};
var Link_default = /* @__PURE__ */ React43.memo(Link);

// src/shared/ui/icons/shared/LogoSymbol.tsx
import { jsx as _jsx78, jsxs as _jsxs29 } from "react/jsx-runtime";
import React44 from "react";
function _define_property78(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread78(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property78(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys69(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props69(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys69(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties62(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose62(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose62(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var LogoSymbol = (_param) => {
  var { width: width2 = 348, height: height2 = 391, fill = "white" } = _param, props = _object_without_properties62(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs29("svg", _object_spread_props69(_object_spread78({
    width: width2,
    height: height2,
    viewBox: "0 0 348 391",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx78("path", {
        d: "M93.2465 81.2411H10.4536C7.68117 81.2411 5.02223 80.1345 3.06179 78.1649C1.10136 76.1952 0 73.5237 0 70.7382V10.5038C0 7.71826 1.10136 5.04679 3.06179 3.0771C5.02223 1.10742 7.68117 0.000873441 10.4536 0.000873441H162.972C164.498 -0.0188958 166.009 0.297141 167.4 0.926707C168.792 1.55627 170.029 2.48411 171.025 3.64515C172.021 4.8062 172.752 6.17228 173.167 7.64746C173.582 9.12263 173.67 10.6712 173.426 12.1843C170.499 31.4306 160.798 48.9836 146.085 61.6551C131.373 74.3266 112.625 81.276 93.2465 81.2411Z"
      }),
      /* @__PURE__ */ _jsx78("path", {
        d: "M130.494 298.051V195.322C130.494 143.519 151.105 93.8385 187.794 57.2085C224.483 20.5785 274.243 0 326.129 0H337.285C340.09 0 342.78 1.11242 344.763 3.09242C346.746 5.07242 347.86 7.7578 347.86 10.5579V71.055C347.86 73.8552 346.746 76.5406 344.763 78.5206C342.78 80.5006 340.09 81.613 337.285 81.613H228.523C225.718 81.613 223.028 82.7253 221.045 84.7053C219.062 86.6853 217.948 89.3708 217.948 92.1709V194.636C217.948 246.438 197.336 296.119 160.648 332.749C123.959 369.379 74.1986 389.958 22.313 389.958H10.5749C7.77023 389.958 5.08047 388.845 3.0973 386.865C1.11413 384.885 0 382.2 0 379.4V318.744C0 315.944 1.11413 313.259 3.0973 311.279C5.08047 309.299 7.77023 308.186 10.5749 308.186H120.078C122.783 308.148 125.371 307.076 127.308 305.191C129.246 303.305 130.386 300.75 130.494 298.051Z"
      }),
      /* @__PURE__ */ _jsx78("path", {
        d: "M254.208 308.717H336.611C339.399 308.717 342.072 309.83 344.043 311.813C346.014 313.795 347.122 316.484 347.122 319.288V380.124C347.122 382.928 346.014 385.617 344.043 387.599C342.072 389.582 339.399 390.696 336.611 390.696H184.207C182.673 390.715 181.154 390.397 179.755 389.764C178.356 389.13 177.112 388.196 176.111 387.028C175.109 385.859 174.374 384.484 173.957 382.999C173.54 381.515 173.451 379.956 173.697 378.433C176.602 359.046 186.323 341.35 201.096 328.557C215.869 315.765 234.714 308.725 254.208 308.717Z"
      })
    ]
  }));
};
var LogoSymbol_default = /* @__PURE__ */ React44.memo(LogoSymbol);

// src/shared/ui/icons/shared/MicOff.tsx
import { jsx as _jsx79 } from "react/jsx-runtime";
function _define_property79(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread79(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property79(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys70(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props70(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys70(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties63(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose63(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose63(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MicOff = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("red", 300) } = _param, props = _object_without_properties63(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx79("svg", _object_spread_props70(_object_spread79({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx79("path", {
      fill,
      d: "M16.315 2.691A4.407 4.407 0 0 0 12.001 6.2l8.444 10.973c.178-.479.276-.998.276-1.54V7.098a4.406 4.406 0 0 0-4.406-4.406ZM7.09 3.988a.655.655 0 0 0-.917-.12l-.98.754a.655.655 0 0 0-.12.918l6.836 8.889v1.205a4.406 4.406 0 0 0 4.315 4.405l2.088 2.714a6.75 6.75 0 0 1-1.542.177h-1.107a6.727 6.727 0 0 1-6.728-6.727v-.734a.655.655 0 0 0-.654-.655H7.044a.655.655 0 0 0-.654.655v.734c0 4.476 3.171 8.211 7.39 9.081v3.334c0 .361.293.654.654.654h3.564a.655.655 0 0 0 .654-.654v-3.334c.453-.093.893-.219 1.318-.375l3.112 4.045c.22.287.631.34.918.12l.98-.754a.655.655 0 0 0 .12-.918l-2.857-3.713.002-.002-1.553-2.018-.002.001-1.86-2.418.002-.001L7.09 3.988ZM26.042 16.203c0 2.15-.73 4.128-1.958 5.7l-1.624-2.11a6.696 6.696 0 0 0 1.037-3.59v-.734c0-.362.293-.655.654-.655h1.237c.361 0 .654.293.654.655v.734Z"
    })
  }));
};
var MicOff_default = MicOff;

// src/shared/ui/icons/shared/MicOn.tsx
import { jsx as _jsx80 } from "react/jsx-runtime";
function _define_property80(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread80(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property80(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys71(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props71(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys71(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties64(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose64(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose64(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MicOn = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties64(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx80("svg", _object_spread_props71(_object_spread80({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx80("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M16.314 2.691a4.406 4.406 0 0 0-4.406 4.406v8.537a4.406 4.406 0 0 0 8.812 0V7.097a4.406 4.406 0 0 0-4.406-4.406ZM8.28 14.814c.361 0 .654.293.654.655v.734a6.727 6.727 0 0 0 6.727 6.727h1.107a6.727 6.727 0 0 0 6.728-6.727v-.734c0-.362.293-.655.654-.655h1.237c.361 0 .654.293.654.655v.734c0 4.476-3.171 8.211-7.39 9.081v3.334a.655.655 0 0 1-.654.654h-3.564a.655.655 0 0 1-.655-.654v-3.334c-4.218-.87-7.39-4.605-7.39-9.081v-.734c0-.362.294-.655.655-.655H8.28Z",
      clipRule: "evenodd"
    })
  }));
};
var MicOn_default = MicOn;

// src/shared/ui/icons/shared/MicUnavailable.tsx
import { jsx as _jsx81 } from "react/jsx-runtime";
function _define_property81(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread81(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property81(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys72(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props72(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys72(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties65(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose65(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose65(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MicUnavailable = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties65(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx81("svg", _object_spread_props72(_object_spread81({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx81("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M17.627 2.89a4.407 4.407 0 0 0-5.626 3.31l8.444 10.973c.178-.479.276-.998.276-1.54V12.76A7.994 7.994 0 0 1 17.001 6c0-1.103.223-2.154.626-3.11ZM7.091 3.988a.655.655 0 0 0-.918-.12l-.98.754a.655.655 0 0 0-.12.918l6.836 8.889v1.205a4.406 4.406 0 0 0 4.315 4.405l2.088 2.714a6.75 6.75 0 0 1-1.542.177h-1.107a6.727 6.727 0 0 1-6.728-6.727v-.734a.655.655 0 0 0-.654-.655H7.044a.655.655 0 0 0-.654.655v.734c0 4.476 3.171 8.211 7.39 9.081v3.334c0 .361.293.654.654.654h3.564a.655.655 0 0 0 .654-.654v-3.334c.453-.093.893-.219 1.318-.375l3.112 4.045c.22.287.631.34.918.12l.98-.754a.655.655 0 0 0 .12-.918l-2.857-3.713.002-.002-1.553-2.018-.002.001-1.86-2.418.002-.001L7.09 3.988Zm16.993 17.915a9.233 9.233 0 0 0 1.958-5.7v-.734a.654.654 0 0 0-.654-.655H24.15a.654.654 0 0 0-.654.655v.734c0 1.32-.38 2.55-1.037 3.59l1.624 2.11ZM25 .75a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm-.615 8.032c0 .16.129.288.288.288h.654c.16 0 .288-.129.288-.288v-.501a.288.288 0 0 0-.288-.288h-.654a.288.288 0 0 0-.288.288v.501Zm.841-1.64c.16 0 .288-.128.288-.287V3.167a.288.288 0 0 0-.288-.288h-.452a.288.288 0 0 0-.288.288v3.688c0 .159.129.288.288.288h.452Z",
      clipRule: "evenodd"
    })
  }));
};
var MicUnavailable_default = MicUnavailable;

// src/shared/ui/icons/shared/MicLoading.tsx
import { jsx as _jsx82 } from "react/jsx-runtime";
function _define_property82(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread82(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property82(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys73(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props73(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys73(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties66(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose66(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose66(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MicLoading = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties66(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx82("svg", _object_spread_props73(_object_spread82({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx82("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.6268 2.84044C17.2124 2.71134 16.7717 2.64178 16.3148 2.64178C14.1891 2.64178 12.415 4.14716 12.0005 6.14999L20.4442 17.1236C20.6229 16.6443 20.7206 16.1256 20.7206 15.5841V12.7104C18.4843 11.2919 17 8.79429 17 5.95001C17 4.84713 17.2232 3.79638 17.6268 2.84044ZM7.09044 3.93881C6.87006 3.65226 6.45911 3.59863 6.17256 3.81902L5.19254 4.57278C4.906 4.79317 4.85237 5.20412 5.07276 5.49067L11.909 14.379V15.5841C11.909 17.9869 13.8325 19.9405 16.2238 19.989L18.3113 22.7031C17.816 22.8192 17.2997 22.8806 16.7691 22.8806H15.6622C11.9468 22.8806 8.93487 19.8687 8.93487 16.1534V15.4192C8.93487 15.0577 8.64182 14.7647 8.28033 14.7647H7.04396C6.68247 14.7647 6.38942 15.0577 6.38942 15.4192V16.1534C6.38942 20.6294 9.56087 24.3647 13.7793 25.2348V28.5682C13.7793 28.9297 14.0723 29.2228 14.4338 29.2228H17.9974C18.3589 29.2228 18.652 28.9297 18.652 28.5682V25.2348C19.104 25.1416 19.5441 25.0154 19.9695 24.859L23.0811 28.9047C23.3015 29.1913 23.7125 29.2449 23.999 29.0245L24.979 28.2707C25.2656 28.0504 25.3192 27.6394 25.0988 27.3529L22.2425 23.6392L22.2447 23.6376L20.6917 21.6193L20.6899 21.6206L18.8298 19.202L18.831 19.2012L7.09044 3.93881ZM24.0836 21.8534C25.3107 20.2809 26.0418 18.3025 26.0418 16.1534V15.4192C26.0418 15.0577 25.7488 14.7647 25.3873 14.7647H24.1509C23.7894 14.7647 23.4964 15.0577 23.4964 15.4192V16.1534C23.4964 17.4732 23.1163 18.7042 22.4597 19.7429L24.0836 21.8534Z"
    })
  }));
};
var MicLoading_default = MicLoading;

// src/shared/ui/icons/shared/MicVad.tsx
import { jsx as _jsx83, jsxs as _jsxs30 } from "react/jsx-runtime";
function _define_property83(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread83(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property83(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys74(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props74(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys74(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties67(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose67(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose67(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MicVad = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties67(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs30("svg", _object_spread_props74(_object_spread83({
    xmlns: "http://www.w3.org/2000/svg",
    width: width2,
    height: height2,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx83("path", {
        fill: "#F5F5F5",
        d: "M16.315 2.692a4.406 4.406 0 0 0-4.406 4.406v8.536a4.406 4.406 0 0 0 8.812 0V7.098a4.406 4.406 0 0 0-4.406-4.406Z"
      }),
      /* @__PURE__ */ _jsx83("path", {
        fill: "#F5F5F5",
        d: "M8.28 14.815c.362 0 .655.293.655.654v.734a6.727 6.727 0 0 0 6.727 6.728h1.107a6.727 6.727 0 0 0 6.727-6.728v-.734c0-.361.293-.654.655-.654h1.236c.362 0 .655.293.655.654v.734c0 4.476-3.172 8.212-7.39 9.082v3.333a.655.655 0 0 1-.655.655h-3.563a.655.655 0 0 1-.655-.655v-3.333c-4.218-.87-7.39-4.606-7.39-9.082v-.734c0-.361.293-.654.655-.654H8.28Z"
      }),
      /* @__PURE__ */ _jsx83("mask", {
        id: "mask0_66_4312",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "8",
        y: "8",
        width: "16",
        height: "16",
        children: /* @__PURE__ */ _jsx83("path", {
          fill: "#2FC063",
          d: "M20.72 10.273H11.91v5.361a4.406 4.406 0 0 0 8.812 0v-5.36Z"
        })
      }),
      /* @__PURE__ */ _jsx83("g", {
        mask: "url(#mask0_66_4312)",
        children: /* @__PURE__ */ _jsx83("rect", {
          x: "8",
          y: "8",
          width: "16",
          height: "16",
          fill: "#2FC063"
        })
      })
    ]
  }));
};
var MicVad_default = MicVad;

// src/shared/ui/icons/shared/MoreVertical.tsx
import { jsx as _jsx84, jsxs as _jsxs31 } from "react/jsx-runtime";
function _define_property84(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread84(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property84(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys75(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props75(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys75(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties68(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose68(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose68(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MoreVertical = (_param) => {
  var { width: width2 = 4, height: height2 = 18 } = _param, props = _object_without_properties68(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs31("svg", _object_spread_props75(_object_spread84({
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx84("path", {
        d: "M-8.74226e-08 16C-1.35705e-07 14.8954 0.89543 14 2 14C3.10457 14 4 14.8954 4 16C4 17.1046 3.10457 18 2 18C0.895431 18 -3.91404e-08 17.1046 -8.74226e-08 16Z"
      }),
      /* @__PURE__ */ _jsx84("path", {
        d: "M-6.99381e-07 2C-7.47663e-07 0.895433 0.89543 1.86821e-06 2 1.81993e-06C3.10457 1.77164e-06 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.89543 4 -6.51099e-07 3.10457 -6.99381e-07 2Z"
      }),
      /* @__PURE__ */ _jsx84("path", {
        d: "M2 7C0.89543 7 -4.41684e-07 7.89543 -3.93402e-07 9C-3.45119e-07 10.1046 0.89543 11 2 11C3.10457 11 4 10.1046 4 9C4 7.89543 3.10457 7 2 7Z"
      })
    ]
  }));
};
var MoreVertical_default = MoreVertical;

// src/shared/ui/icons/shared/NavCalls.tsx
import { jsx as _jsx85 } from "react/jsx-runtime";
function _define_property85(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread85(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property85(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys76(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props76(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys76(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties69(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose69(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose69(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NavCalls = (_param) => {
  var { fill = getCssVar("grey", 500) } = _param, props = _object_without_properties69(_param, [
    "fill"
  ]);
  return /* @__PURE__ */ _jsx85("svg", _object_spread_props76(_object_spread85({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {
    children: /* @__PURE__ */ _jsx85("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.0933 3.69531C23.4799 3.69565 23.793 4.00932 23.7927 4.39592L23.7902 7.28765H23.8028C26.4537 7.28765 28.6028 9.43669 28.6028 12.0877V23.5057C28.6028 26.1566 26.4537 28.3057 23.8028 28.3057L8.19746 28.3057C5.54649 28.3057 3.39746 26.1566 3.39746 23.5057V12.0877C3.39746 9.43669 5.54649 7.28765 8.19746 7.28765H8.40937L8.40937 4.39484C8.40937 4.00824 8.72277 3.69484 9.10937 3.69484L10.2094 3.69484C10.596 3.69484 10.9094 4.00824 10.9094 4.39484L10.9094 7.28765H14.7657L14.7657 4.39484C14.7657 4.00824 15.0791 3.69484 15.4657 3.69484L16.5657 3.69484C16.9523 3.69484 17.2657 4.00824 17.2657 4.39484L17.2657 7.28765L21.2902 7.28765L21.2927 4.39372C21.293 4.00712 21.6067 3.694 21.9933 3.69434L23.0933 3.69531ZM13.833 11.0664C14.2442 11.0267 14.5976 11.3506 14.6354 11.7621C14.7144 12.6203 14.924 13.4392 15.2438 14.1998C15.3807 14.5252 15.2855 14.9089 14.9936 15.1075L14.1684 15.6689C13.8766 15.8675 13.7761 16.2538 13.9517 16.56C14.8 18.0386 15.7981 19.0342 17.2804 19.8813C17.5794 20.0521 17.9559 19.9606 18.1588 19.6824L18.763 18.8538C18.9659 18.5756 19.3399 18.4893 19.657 18.6236C20.4226 18.9477 21.2476 19.1601 22.1126 19.2397C22.524 19.2776 22.8479 19.6309 22.8082 20.0422L22.4535 23.7166C22.4179 24.0852 22.1011 24.3643 21.7322 24.3328C15.2553 23.7814 10.0934 18.6194 9.54227 12.1424C9.51087 11.7735 9.78996 11.4567 10.1585 11.4211L13.833 11.0664Z",
      fill
    })
  }));
};
var NavCalls_default = NavCalls;

// src/shared/ui/icons/shared/NavChats.tsx
import { jsx as _jsx86 } from "react/jsx-runtime";
import React45 from "react";
function _define_property86(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread86(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property86(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys77(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props77(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys77(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties70(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose70(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose70(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NavChats = (_param) => {
  var { width: width2 = 24, height: height2 = 21, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties70(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx86("svg", _object_spread_props77(_object_spread86({
    width: width2,
    height: height2,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx86("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.843 0C2.16829 0 0 2.15121 0 4.80486V11.2864C0 13.94 2.16828 16.0912 4.843 16.0912H6.11308C6.47237 16.0912 6.76364 16.3802 6.76364 16.7367V20.3536C6.76364 20.858 7.32077 21.1675 7.75424 20.9038L15.509 16.1864C15.6113 16.1242 15.729 16.0912 15.849 16.0912H19.157C21.8317 16.0912 24 13.94 24 11.2864V4.80486C24 2.15121 21.8317 0 19.157 0H4.843ZM11.9999 6.14336C10.9432 6.14336 10.0866 6.9932 10.0866 8.04154C10.0866 9.08988 10.9432 9.93973 11.9999 9.93973C13.0566 9.93973 13.9132 9.08988 13.9132 8.04154C13.9132 6.9932 13.0566 6.14336 11.9999 6.14336ZM16.398 8.04154C16.398 6.9932 17.2546 6.14336 18.3113 6.14336C19.3679 6.14336 20.2245 6.9932 20.2245 8.04154C20.2245 9.08988 19.3679 9.93973 18.3113 9.93973C17.2546 9.93973 16.398 9.08988 16.398 8.04154ZM5.68867 6.14336C4.63201 6.14336 3.77541 6.9932 3.77541 8.04154C3.77541 9.08988 4.63201 9.93973 5.68867 9.93973C6.74533 9.93973 7.60192 9.08988 7.60192 8.04154C7.60192 6.9932 6.74533 6.14336 5.68867 6.14336Z",
      fill
    })
  }));
};
var NavChats_default = /* @__PURE__ */ React45.memo(NavChats);

// src/shared/ui/icons/shared/NavRooms.tsx
import { jsx as _jsx87, jsxs as _jsxs32 } from "react/jsx-runtime";
import React46 from "react";
function _define_property87(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread87(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property87(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys78(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props78(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys78(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties71(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose71(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose71(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NavRooms = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties71(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs32("svg", _object_spread_props78(_object_spread87({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx87("path", {
        d: "M18.9734 13.95C18.9734 15.3381 20.0986 16.4633 21.4867 16.4633C22.8748 16.4633 24 15.3381 24 13.95V2.51331C24 1.12525 22.8748 -2.38419e-07 21.4867 0C20.0986 0 18.9734 1.12525 18.9734 2.51331V13.95Z",
        fill
      }),
      /* @__PURE__ */ _jsx87("path", {
        d: "M2.5502 18.8996C1.14176 18.8996 0 20.0414 0 21.4498C0 22.8582 1.14176 24 2.5502 24H13.9131C15.3216 24 16.4633 22.8582 16.4633 21.4498C16.4633 20.0414 15.3216 18.8996 13.9131 18.8996H2.5502Z",
        fill
      }),
      /* @__PURE__ */ _jsx87("path", {
        d: "M21.4498 24C20.0414 24 18.8996 22.8582 18.8996 21.4498C18.8996 20.0414 20.0414 18.8996 21.4498 18.8996C22.8582 18.8996 24 20.0414 24 21.4498C24 22.8582 22.8582 24 21.4498 24Z",
        fill
      }),
      /* @__PURE__ */ _jsx87("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 4.8C0 2.14903 2.14903 0 4.8 0H11.6633C14.3143 0 16.4633 2.14903 16.4633 4.8V11.6633C16.4633 14.3143 14.3143 16.4633 11.6633 16.4633H4.8C2.14903 16.4633 0 14.3143 0 11.6633V4.8ZM2.47162 6.81384C2.47162 5.63463 3.42756 4.67868 4.60678 4.67868H8.53788C9.7171 4.67868 10.673 5.63463 10.673 6.81384V9.64948C10.673 10.8287 9.7171 11.7846 8.53788 11.7846H4.60678C3.42756 11.7846 2.47162 10.8287 2.47162 9.64948V6.81384ZM13.4776 11.2484C13.6446 11.4655 13.9917 11.3474 13.9917 11.0735V5.35849C13.9917 5.08421 13.6437 4.96639 13.4771 5.18429L11.8697 7.28654C11.8315 7.33657 11.8107 7.39779 11.8107 7.46075V8.98416C11.8107 9.04742 11.8317 9.10891 11.8702 9.15905L13.4776 11.2484Z",
        fill
      })
    ]
  }));
};
var NavRooms_default = /* @__PURE__ */ React46.memo(NavRooms);

// src/shared/ui/icons/shared/NavSuperuserDashboard.tsx
import { jsx as _jsx88, jsxs as _jsxs33 } from "react/jsx-runtime";
import React47 from "react";
function _define_property88(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread88(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property88(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys79(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props79(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys79(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties72(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose72(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose72(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NavSuperuserDashboard = (_param) => {
  var { width: width2 = 25, height: height2 = 25, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties72(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs33("svg", _object_spread_props79(_object_spread88({
    width: width2,
    height: height2,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx88("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.0391 6.20978C24.0391 3.31767 21.6945 0.973145 18.8024 0.973145H5.2757C2.38358 0.973145 0.0390625 3.31767 0.0390625 6.20978C0.0390625 9.10189 2.38358 11.4464 5.2757 11.4464H18.8024C21.6945 11.4464 24.0391 9.10189 24.0391 6.20978ZM2.47639 6.20981C2.47639 7.75581 3.72967 9.00909 5.27567 9.00909C6.82167 9.00909 8.07495 7.75581 8.07495 6.20981C8.07495 4.6638 6.82167 3.41052 5.27567 3.41052C3.72967 3.41052 2.47639 4.6638 2.47639 6.20981Z",
        fill
      }),
      /* @__PURE__ */ _jsx88("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.0390625 19.7365C0.0390625 16.8444 2.38358 14.4999 5.2757 14.4999H18.8024C21.6945 14.4999 24.0391 16.8444 24.0391 19.7365C24.0391 22.6286 21.6945 24.9731 18.8024 24.9731H5.2757C2.38358 24.9731 0.0390625 22.6286 0.0390625 19.7365ZM21.6017 19.7365C21.6017 21.2825 20.3485 22.5358 18.8025 22.5358C17.2565 22.5358 16.0032 21.2825 16.0032 19.7365C16.0032 18.1905 17.2565 16.9373 18.8025 16.9373C20.3485 16.9373 21.6017 18.1905 21.6017 19.7365Z",
        fill
      })
    ]
  }));
};
var NavSuperuserDashboard_default = /* @__PURE__ */ React47.memo(NavSuperuserDashboard);

// src/shared/ui/icons/shared/NavVideo.tsx
import { jsx as _jsx89 } from "react/jsx-runtime";
import React48 from "react";
function _define_property89(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread89(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property89(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys80(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props80(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys80(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties73(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose73(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose73(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NavVideo = (_param) => {
  var { width: width2 = 24, height: height2 = 20, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties73(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx89("svg", _object_spread_props80(_object_spread89({
    width: width2,
    height: height2,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx89("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 0C2.23858 0 0 2.23858 0 5V15C0 17.7614 2.23858 20 5 20H19C21.7614 20 24 17.7614 24 15V5C24 2.23858 21.7614 0 19 0H5ZM15.5244 10.8457C16.1585 10.4699 16.1585 9.53014 15.5244 9.15426L10.4267 6.13229C9.7926 5.75641 9 6.22626 9 6.97803V13.022C9 13.7737 9.7926 14.2436 10.4267 13.8677L15.5244 10.8457Z",
      fill
    })
  }));
};
var NavVideo_default = /* @__PURE__ */ React48.memo(NavVideo);

// src/shared/ui/icons/shared/NoDocument.tsx
import { jsx as _jsx90, jsxs as _jsxs34 } from "react/jsx-runtime";
import React49 from "react";
function _define_property90(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread90(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property90(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys81(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props81(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys81(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties74(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose74(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose74(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NoDocument = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties74(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs34("svg", _object_spread_props81(_object_spread90({
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx90("path", {
        opacity: "0.7",
        d: "M46.7495 11.4727H33.2363C27.6358 11.4727 24.8355 11.4727 22.6964 12.5626C20.8148 13.5213 19.285 15.0511 18.3263 16.9328C17.2363 19.0719 17.2363 21.8721 17.2363 27.4727L17.2363 57.9507C17.2363 63.5512 17.2363 66.3515 18.3263 68.4906C19.285 70.3722 20.8148 71.9021 22.6964 72.8608C24.8355 73.9507 27.6358 73.9507 33.2363 73.9507H54.2527C59.8532 73.9507 62.6534 73.9507 64.7926 72.8608C66.6742 71.9021 68.204 70.3722 69.1627 68.4906C70.2527 66.3515 70.2527 63.5512 70.2527 57.9507V34.9758L46.7495 11.4727Z",
        fill: "url(#paint0_linear_2847_218541)"
      }),
      /* @__PURE__ */ _jsx90("path", {
        opacity: "0.4",
        d: "M70.2526 34.9759H62.6929C57.0923 34.9759 54.2921 34.9759 52.153 33.8859C50.2713 32.9272 48.7415 31.3974 47.7828 29.5158C46.6929 27.3767 46.6929 24.5764 46.6929 18.9759L46.6929 11.4727H46.7495L70.2526 34.9759Z",
        fill: "url(#paint1_linear_2847_218541)"
      }),
      /* @__PURE__ */ _jsxs34("g", {
        opacity: "0.3",
        children: [
          /* @__PURE__ */ _jsx90("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.7231 44.4043C26.1709 44.4043 25.7231 43.9566 25.7231 43.4043L25.7231 40.4043C25.7231 39.852 26.1709 39.4043 26.7231 39.4043L60.1626 39.4043C60.7149 39.4043 61.1626 39.852 61.1626 40.4043V43.4043C61.1626 43.9566 60.7149 44.4043 60.1626 44.4043L26.7231 44.4043Z",
            fill: "url(#paint2_linear_2847_218541)"
          }),
          /* @__PURE__ */ _jsx90("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.7231 57.4043C26.1709 57.4043 25.7231 56.9566 25.7231 56.4043L25.7231 53.4043C25.7231 52.852 26.1709 52.4043 26.7231 52.4043H44.4235C44.9758 52.4043 45.4235 52.852 45.4235 53.4043V56.4043C45.4235 56.9566 44.9758 57.4043 44.4235 57.4043L26.7231 57.4043Z",
            fill: "url(#paint3_linear_2847_218541)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx90("circle", {
        opacity: "0.7",
        cx: "67.9409",
        cy: "66.8984",
        r: "19.5645",
        fill: "url(#paint4_linear_2847_218541)"
      }),
      /* @__PURE__ */ _jsx90("path", {
        opacity: "0.7",
        d: "M76.755 61.9392C77.1455 61.5487 77.1455 60.9155 76.755 60.525L74.6337 58.4037C74.2432 58.0132 73.61 58.0132 73.2195 58.4037L68.2611 63.3621L63.3028 58.4039C62.9123 58.0134 62.2791 58.0134 61.8886 58.4039L59.7673 60.5252C59.3768 60.9157 59.3768 61.5489 59.7673 61.9394L64.7255 66.8977L59.7673 71.8559C59.3768 72.2464 59.3768 72.8795 59.7673 73.2701L61.8886 75.3914C62.2792 75.7819 62.9123 75.7819 63.3028 75.3914L68.2611 70.4332L73.2194 75.3916C73.61 75.7821 74.2431 75.7821 74.6336 75.3916L76.755 73.2702C77.1455 72.8797 77.1455 72.2466 76.755 71.856L71.7966 66.8977L76.755 61.9392Z",
        fill: "#F4F4F4"
      }),
      /* @__PURE__ */ _jsxs34("defs", {
        children: [
          /* @__PURE__ */ _jsxs34("linearGradient", {
            id: "paint0_linear_2847_218541",
            x1: "43.7445",
            y1: "11.4727",
            x2: "43.7445",
            y2: "73.9507",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx90("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx90("stop", {
                offset: "0.0001",
                stopColor: "#FF7E7E",
                stopOpacity: "0.63"
              }),
              /* @__PURE__ */ _jsx90("stop", {
                offset: "1",
                stopColor: "#CA3E3E",
                stopOpacity: "0.48"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs34("linearGradient", {
            id: "paint1_linear_2847_218541",
            x1: "58.4727",
            y1: "11.4727",
            x2: "58.4727",
            y2: "34.9759",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx90("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx90("stop", {
                offset: "1",
                stopColor: "#EF5E5E",
                stopOpacity: "0.92"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs34("linearGradient", {
            id: "paint2_linear_2847_218541",
            x1: "32.9697",
            y1: "39.4043",
            x2: "32.9697",
            y2: "49.8559",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx90("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx90("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs34("linearGradient", {
            id: "paint3_linear_2847_218541",
            x1: "32.9697",
            y1: "39.4043",
            x2: "32.9697",
            y2: "49.8559",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx90("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx90("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs34("linearGradient", {
            id: "paint4_linear_2847_218541",
            x1: "67.9409",
            y1: "47.334",
            x2: "67.9409",
            y2: "86.4629",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx90("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx90("stop", {
                offset: "1",
                stopColor: "#EF5E5E",
                stopOpacity: "0.92"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var NoDocument_default = /* @__PURE__ */ React49.memo(NoDocument);

// src/shared/ui/icons/shared/People.tsx
import { jsx as _jsx91 } from "react/jsx-runtime";
function _define_property91(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread91(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property91(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys82(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props82(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys82(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties75(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose75(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose75(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var People = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties75(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx91("svg", _object_spread_props82(_object_spread91({
    xmlns: "http://www.w3.org/2000/svg",
    width: width2,
    height: height2,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), {
    children: /* @__PURE__ */ _jsx91("path", {
      fill: props.fill || getCssVar("grey", 100),
      d: "M20.651 14.968c-.28 0-.546-.016-.8-.047.12-.667.201-1.364.25-2.083.33-3.105-1.395-5.63-3.796-6.93.827-1.508 2.468-2.524 4.346-2.524 2.825 0 5.296 2.309 4.971 5.115-.308 4.657-1.947 6.469-4.97 6.469ZM22.933 22.553h5.95c.248 0 .45-.201.45-.45 0-2.275-1.393-4.336-3.585-4.944-1.627-.45-3.524-.86-5.054-.86-.376 0-.775.025-1.187.07-.272.901-.645 1.725-1.148 2.448l.012.003c2.088.578 3.656 1.982 4.562 3.733ZM12.594 19.08c-3.024 0-4.542-1.783-4.9-6.468-.215-2.816 2.076-5.114 4.9-5.114 2.825 0 5.296 2.308 4.971 5.114-.308 4.657-1.947 6.469-4.97 6.469ZM17.691 21.273c2.192.607 3.585 2.668 3.585 4.943a.45.45 0 0 1-.45.45H4.449a.45.45 0 0 1-.451-.45c0-2.275 1.393-4.336 3.585-4.943 1.627-.451 3.524-.86 5.054-.86 1.53 0 3.427.409 5.054.86Z"
    })
  }));
};
var People_default = People;

// src/shared/ui/icons/shared/Phone.tsx
import { jsx as _jsx92 } from "react/jsx-runtime";
function _define_property92(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread92(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property92(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys83(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props83(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys83(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties76(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose76(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose76(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Phone = (_param) => {
  var { fill = "#EBEDF0" } = _param, props = _object_without_properties76(_param, [
    "fill"
  ]);
  return /* @__PURE__ */ _jsx92("svg", _object_spread_props83(_object_spread92({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx92("path", {
      d: "M10.2717 3.82159C9.63785 2.9409 8.40383 2.73607 7.51509 3.36401L6.29008 4.22954C5.6183 4.70419 5.0551 5.44532 5.00991 6.38279C4.93076 8.02524 5.27017 11.1905 8.07635 15.0894C10.8689 18.9694 13.8058 20.3793 15.4234 20.8827C16.3575 21.1734 17.2876 20.8911 17.989 20.3955L19.1705 19.5607C20.0597 18.9324 20.2665 17.7085 19.6323 16.8274L18.1541 14.7735C17.5201 13.8926 16.2856 13.6879 15.3969 14.3163L14.3707 15.0419C14.3685 15.0435 14.3648 15.0455 14.3648 15.0455C13.8361 14.6525 12.8116 13.7977 11.8577 12.4724C10.9038 11.1471 10.4218 9.9086 10.219 9.28519C10.219 9.28519 10.2221 9.2824 10.2243 9.28084L11.2505 8.55524C12.1392 7.9268 12.3457 6.70323 11.7117 5.82232L10.2717 3.82159Z"
    })
  }));
};
var Phone_default = Phone;

// src/shared/ui/icons/shared/Pin.tsx
import { jsx as _jsx93 } from "react/jsx-runtime";
import React50 from "react";
function _define_property93(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread93(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property93(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys84(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props84(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys84(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Pin = (props) => /* @__PURE__ */ _jsx93("svg", _object_spread_props84(_object_spread93({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ _jsx93("path", {
    d: "M21.6962 8.09357C22.282 7.50779 22.282 6.55804 21.6962 5.97225L18.093 2.36903C17.5072 1.78324 16.5575 1.78324 15.9717 2.36903L12.2035 6.13716C12.0931 6.24763 11.9391 6.30316 11.7836 6.28866L8.99934 6.02899C8.55488 5.98754 8.11504 6.1462 7.79939 6.46185L6.12402 8.13723C5.53823 8.72301 5.53823 9.67276 6.12402 10.2585L9.27893 13.4135L2.57076 20.1216C2.36574 20.3267 2.36574 20.6591 2.57076 20.8641L3.15412 21.4475C3.35915 21.6525 3.69156 21.6525 3.89659 21.4475L10.6048 14.7393L13.8574 17.992C14.4432 18.5778 15.393 18.5778 15.9788 17.992L17.6463 16.3244C17.9664 16.0043 18.1249 15.5567 18.0774 15.1065L17.7799 12.2852C17.7633 12.1277 17.8188 11.971 17.9308 11.859L21.6962 8.09357Z",
    fill: props.fill || "#898E96"
  })
}));
var Pin_default = /* @__PURE__ */ React50.memo(Pin);

// src/shared/ui/icons/shared/PinWhite.tsx
import { jsx as _jsx94 } from "react/jsx-runtime";
import React51 from "react";
function _define_property94(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread94(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property94(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys85(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props85(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys85(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PinWhite = (props) => /* @__PURE__ */ _jsx94("svg", _object_spread_props85(_object_spread94({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ _jsx94("path", {
    d: "M16.2729 6.07018C16.7122 5.63084 16.7122 4.91853 16.2729 4.47919L13.5705 1.77677C13.1311 1.33743 12.4188 1.33743 11.9795 1.77677L9.15338 4.60287C9.07053 4.68572 8.95507 4.72737 8.8384 4.71649L6.75024 4.52174C6.41689 4.49065 6.08701 4.60965 5.85028 4.84639L4.59374 6.10292C4.1544 6.54226 4.1544 7.25457 4.59374 7.69391L6.95993 10.0601L1.9288 15.0912C1.77503 15.245 1.77503 15.4943 1.9288 15.6481L2.36633 16.0856C2.52009 16.2394 2.7694 16.2394 2.92317 16.0856L7.9543 11.0545L10.3938 13.494C10.8332 13.9333 11.5455 13.9333 11.9848 13.494L13.2355 12.2433C13.4756 12.0032 13.5944 11.6675 13.5588 11.3299L13.3357 9.21393C13.3232 9.09575 13.3648 8.97826 13.4488 8.89422L16.2729 6.07018Z",
    fill: "#EBEDF0"
  })
}));
var PinWhite_default = /* @__PURE__ */ React51.memo(PinWhite);

// src/shared/ui/icons/shared/Play.tsx
import { jsx as _jsx95 } from "react/jsx-runtime";
import React52 from "react";
function _define_property95(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread95(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property95(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys86(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props86(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys86(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties77(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose77(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose77(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Play = (_param) => {
  var { width: width2 = 11, height: height2 = 12, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties77(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx95("svg", _object_spread_props86(_object_spread95({
    width: width2,
    height: height2,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx95("path", {
      d: "M9.5 4.7009C10.5 5.27825 10.5 6.72163 9.5 7.29898L2.75 11.1961C1.75 11.7734 0.5 11.0518 0.5 9.89705L0.5 2.10282C0.5 0.948124 1.75 0.226435 2.75 0.803785L9.5 4.7009Z",
      fill
    })
  }));
};
var Play_default = /* @__PURE__ */ React52.memo(Play);

// src/shared/ui/icons/shared/Playlist.tsx
import { jsx as _jsx96, jsxs as _jsxs35 } from "react/jsx-runtime";
import React53 from "react";
function _define_property96(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread96(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property96(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys87(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props87(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys87(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties78(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose78(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose78(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Playlist = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties78(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs35("svg", _object_spread_props87(_object_spread96({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx96("path", {
        d: "M20.686 6.6C20.686 6.88995 20.4509 7.125 20.1609 7.125H3.95273C3.66278 7.125 3.42773 6.88995 3.42773 6.6V5.775C3.42773 5.48505 3.66279 5.25 3.95273 5.25H20.1609C20.4509 5.25 20.686 5.48505 20.686 5.775V6.6Z",
        fill
      }),
      /* @__PURE__ */ _jsx96("path", {
        d: "M11.3799 12.6C11.3799 12.8899 11.1449 13.125 10.8549 13.125H3.95273C3.66278 13.125 3.42773 12.8899 3.42773 12.6V11.775C3.42773 11.485 3.66279 11.25 3.95273 11.25H10.8549C11.1449 11.25 11.3799 11.4851 11.3799 11.775V12.6Z",
        fill
      }),
      /* @__PURE__ */ _jsx96("path", {
        d: "M10.8549 19.125C11.1449 19.125 11.3799 18.8899 11.3799 18.6V17.775C11.3799 17.485 11.1449 17.25 10.8549 17.25L3.95273 17.25C3.66279 17.25 3.42773 17.485 3.42773 17.775V18.6C3.42773 18.8899 3.66279 19.125 3.95273 19.125H10.8549Z",
        fill
      }),
      /* @__PURE__ */ _jsx96("path", {
        d: "M20.8472 15.8119C21.1372 15.6444 21.3159 15.3349 21.3159 15C21.3159 14.665 21.1372 14.3555 20.8472 14.1881L14.8644 10.7339C14.5743 10.5664 14.217 10.5664 13.9269 10.7339C13.6368 10.9014 13.4581 11.2109 13.4581 11.5458V18.4541C13.4581 18.7891 13.6368 19.0985 13.9269 19.266C14.217 19.4335 14.5743 19.4335 14.8644 19.266L20.8472 15.8119Z",
        fill
      })
    ]
  }));
};
var Playlist_default = /* @__PURE__ */ React53.memo(Playlist);

// src/shared/ui/icons/shared/PlayOutline.tsx
import { jsx as _jsx97 } from "react/jsx-runtime";
import React54 from "react";
function _define_property97(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread97(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property97(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys88(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props88(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys88(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties79(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose79(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose79(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var PlayOutline = (_param) => {
  var { width: width2 = 36, height: height2 = 32, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties79(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx97("svg", _object_spread_props88(_object_spread97({
    width: width2,
    height: height2,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx97("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 0.5C1.67893 0.5 0 2.17893 0 4.25V11.75C0 13.8211 1.67893 15.5 3.75 15.5H14.25C16.3211 15.5 18 13.8211 18 11.75V4.25C18 2.17893 16.3211 0.5 14.25 0.5H3.75ZM11.6433 8.63431C12.1188 8.35239 12.1188 7.64761 11.6433 7.36569L7.81995 5.09922C7.34439 4.81731 6.74994 5.1697 6.74994 5.73353V10.2665C6.74994 10.8303 7.34439 11.1827 7.81995 10.9008L11.6433 8.63431Z",
      fill
    })
  }));
};
var PlayOutline_default = /* @__PURE__ */ React54.memo(PlayOutline);

// src/shared/ui/icons/shared/Plus.tsx
import { jsx as _jsx98 } from "react/jsx-runtime";
import React55 from "react";
function _define_property98(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread98(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property98(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys89(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props89(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys89(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties80(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose80(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose80(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Plus = (_param) => {
  var { width: width2 = 14, height: height2 = 14, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties80(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx98("svg", _object_spread_props89(_object_spread98({
    width: width2,
    height: height2,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx98("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.999965 5.99994C0.44768 5.99994 -3.54904e-05 6.44766 -3.54535e-05 6.99994C-3.54798e-05 7.55223 0.44768 7.99994 0.999965 7.99994L5.99991 7.99994L5.99991 13C5.99991 13.5523 6.44762 14 6.99991 14C7.55219 14 7.99991 13.5523 7.99991 13L7.99991 7.99994H13C13.5522 7.99994 14 7.55223 14 6.99994C14 6.44766 13.5522 5.99994 13 5.99994H7.99991L7.99991 1C7.99991 0.447717 7.55219 1.16683e-06 6.99991 8.92876e-07C6.44762 6.13653e-07 5.99991 0.447716 5.99991 1L5.99991 5.99994L0.999965 5.99994Z",
      fill
    })
  }));
};
var Plus_default = /* @__PURE__ */ React55.memo(Plus);

// src/shared/ui/icons/shared/Question.tsx
import { jsx as _jsx99, jsxs as _jsxs36 } from "react/jsx-runtime";
function _define_property99(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread99(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property99(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys90(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props90(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys90(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Question = (props) => /* @__PURE__ */ _jsxs36("svg", _object_spread_props90(_object_spread99({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), {
  children: [
    /* @__PURE__ */ _jsx99("rect", {
      width: "5.473",
      height: "4.772",
      x: "13.22",
      y: "23.915",
      fill: props.fill || "#EBEDF0",
      rx: ".9"
    }),
    /* @__PURE__ */ _jsx99("path", {
      fill: props.fill || "#EBEDF0",
      d: "M9.033 8.505c0 .67.71 1.11 1.32.83.404-.186.838-.375 1.203-.512 1.001-.375 2.793-.886 4.675-.74 1.96.15 2.862.853 3.142 1.527.435 1.048.264 1.795-.276 2.642-.515.807-1.21 1.478-2.06 2.3-.273.263-.563.543-.867.847-1.036 1.036-2.348 2.493-2.632 4.735-.063.493.347.898.844.898h3.084c.497 0 .875-.425 1.097-.87.182-.364.51-.759 1.06-1.31.161-.16.352-.343.562-.545.903-.866 2.168-2.08 3.029-3.429 1.202-1.883 1.844-4.31.67-7.14-1.33-3.205-4.603-4.318-7.276-4.525-1.732-.134-4.303.136-7.043 1.273a.873.873 0 0 0-.532.811v3.208Z"
    })
  ]
}));
var Question_default = Question;

// src/shared/ui/icons/shared/QRScan.tsx
import { jsx as _jsx100, jsxs as _jsxs37 } from "react/jsx-runtime";
function _define_property100(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread100(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property100(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys91(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props91(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys91(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties81(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose81(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose81(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var QRScan = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties81(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx100("svg", _object_spread_props91(_object_spread100({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx100("g", {
      id: "icons/qr_scan",
      children: /* @__PURE__ */ _jsxs37("g", {
        id: "Union",
        children: [
          /* @__PURE__ */ _jsx100("path", {
            d: "M18.4973 4.91699C18.808 4.91699 19.0598 5.16883 19.0598 5.47949V8.78174C19.0598 9.16834 19.3732 9.48174 19.7598 9.48174H20.2348C20.6214 9.48174 20.9348 9.16834 20.9348 8.78174V5.47949C20.9348 4.1333 19.8435 3.04199 18.4973 3.04199H15.1951C14.8085 3.04199 14.4951 3.35539 14.4951 3.74199V4.21699C14.4951 4.60359 14.8085 4.91699 15.1951 4.91699L18.4973 4.91699Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M5.4834 4.92047C5.17274 4.92047 4.9209 5.17231 4.9209 5.48297V8.78522C4.9209 9.17182 4.6075 9.48522 4.2209 9.48522H3.7459C3.3593 9.48522 3.0459 9.17182 3.0459 8.78522V5.48297C3.0459 4.13678 4.1372 3.04547 5.4834 3.04547H8.78565C9.17225 3.04547 9.48565 3.35887 9.48565 3.74547V4.22047C9.48565 4.60707 9.17225 4.92047 8.78565 4.92047H5.4834Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M10.9863 8.43731C10.9863 8.05072 10.6729 7.73731 10.2863 7.73731H8.23638C7.84978 7.73731 7.53638 8.05072 7.53638 8.43731V10.4872C7.53638 10.8738 7.84978 11.1872 8.23638 11.1872H10.2863C10.6729 11.1872 10.9863 10.8738 10.9863 10.4872V8.43731Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M10.9863 13.4523C10.9863 13.0657 10.6729 12.7523 10.2863 12.7523H8.23638C7.84978 12.7523 7.53638 13.0657 7.53638 13.4523V15.5022C7.53638 15.8888 7.84978 16.2022 8.23638 16.2022H10.2863C10.6729 16.2022 10.9863 15.8888 10.9863 15.5022V13.4523Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M16.2201 8.43731C16.2201 8.05072 15.9067 7.73731 15.5201 7.73731H13.4702C13.0836 7.73731 12.7702 8.05072 12.7702 8.43731V10.4872C12.7702 10.8738 13.0836 11.1872 13.4702 11.1872H15.5201C15.9067 11.1872 16.2201 10.8738 16.2201 10.4872V8.43731Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M16.2201 13.4523C16.2201 13.0657 15.9067 12.7523 15.5201 12.7523H13.4702C13.0836 12.7523 12.7702 13.0657 12.7702 13.4523V15.5022C12.7702 15.8888 13.0836 16.2022 13.4702 16.2022H15.5201C15.9067 16.2022 16.2201 15.8888 16.2201 15.5022V13.4523Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M19.079 18.4795C19.079 18.7901 18.8271 19.042 18.5165 19.042H15.2142C14.8276 19.042 14.5142 19.3554 14.5142 19.742V20.217C14.5142 20.6036 14.8276 20.917 15.2142 20.917H18.5165C19.8627 20.917 20.954 19.8257 20.954 18.4795V15.1772C20.954 14.7906 20.6406 14.4772 20.254 14.4772H19.779C19.3924 14.4772 19.079 14.7906 19.079 15.1772V18.4795Z",
            fill
          }),
          /* @__PURE__ */ _jsx100("path", {
            d: "M4.95395 18.4794C4.95395 18.7901 5.20579 19.0419 5.51645 19.0419H8.8187C9.2053 19.0419 9.5187 19.3553 9.5187 19.7419V20.2169C9.5187 20.6035 9.2053 20.9169 8.8187 20.9169H5.51645C4.17026 20.9169 3.07895 19.8256 3.07895 18.4794L3.07895 15.1772C3.07895 14.7906 3.39235 14.4772 3.77895 14.4772H4.25395C4.64055 14.4772 4.95395 14.7906 4.95395 15.1772L4.95395 18.4794Z",
            fill
          })
        ]
      })
    })
  }));
};
var QRScan_default = QRScan;

// src/shared/ui/icons/shared/Random.tsx
import { jsx as _jsx101, jsxs as _jsxs38 } from "react/jsx-runtime";
import React56 from "react";
function _define_property101(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread101(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property101(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys92(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props92(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys92(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties82(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose82(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose82(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Random = (_param) => {
  var { width: width2 = 17, height: height2 = 17, fill = getCssVar("blue", 300) } = _param, props = _object_without_properties82(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs38("svg", _object_spread_props92(_object_spread101({
    width: width2,
    height: height2,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx101("path", {
        fill,
        d: "M15.4714 3.44306V6.86412C15.4714 7.23692 15.7736 7.53912 16.1464 7.53912H16.6714C17.0442 7.53912 17.3464 7.23692 17.3464 6.86412V0.917187C17.3464 0.544395 17.0442 0.242188 16.6714 0.242188H10.7244C10.3516 0.242188 10.0494 0.544396 10.0494 0.917188V1.44219C10.0494 1.81498 10.3516 2.11719 10.7244 2.11719L14.1456 2.11719L0.391369 15.8714C0.127765 16.135 0.127765 16.5624 0.391369 16.826L0.762599 17.1972C1.0262 17.4608 1.45359 17.4608 1.71719 17.1972L15.4714 3.44306Z"
      }),
      /* @__PURE__ */ _jsx101("path", {
        fill,
        d: "M14.1455 15.7318L10.4824 12.0687C10.2188 11.8051 10.2188 11.3777 10.4824 11.1141L10.8536 10.7429C11.1172 10.4793 11.5446 10.4793 11.8082 10.7429L15.4714 14.406V10.9849C15.4714 10.6121 15.7736 10.3099 16.1464 10.3099H16.6714C17.0442 10.3099 17.3464 10.6121 17.3464 10.9849V16.9318C17.3464 17.3046 17.0442 17.6068 16.6714 17.6068H10.7244C10.3516 17.6068 10.0494 17.3046 10.0494 16.9318V16.4068C10.0494 16.034 10.3516 15.7318 10.7244 15.7318H14.1455Z"
      }),
      /* @__PURE__ */ _jsx101("path", {
        fill,
        d: "M5.49939 7.08567C5.763 7.34927 6.19038 7.34927 6.45399 7.08567L6.82522 6.71444C7.08882 6.45083 7.08882 6.02345 6.82522 5.75984L1.71716 0.651786C1.45356 0.388183 1.02617 0.388183 0.762568 0.651787L0.391337 1.02302C0.127733 1.28662 0.127733 1.71401 0.391337 1.97761L5.49939 7.08567Z"
      })
    ]
  }));
};
var Random_default = /* @__PURE__ */ React56.memo(Random);

// src/shared/ui/icons/shared/Reactions.tsx
import { jsx as _jsx102 } from "react/jsx-runtime";
function _define_property102(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread102(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property102(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys93(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props93(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys93(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties83(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose83(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose83(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Reactions = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties83(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx102("svg", _object_spread_props93(_object_spread102({
    width: width2,
    height: height2,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx102("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9186 29C21.5623 29 26.1373 24.6206 26.1373 18.9449C26.1373 14.2465 22.9828 11.8352 20.7428 10.1229C20.1209 9.64756 19.5695 9.22609 19.1757 8.82452C17.938 7.56247 17.2497 6.18472 17.2115 4.28594C17.1918 3.30535 15.9998 2.60087 15.2668 3.2525C7.53192 10.1285 5.69995 14.6028 5.69995 18.9449C5.69995 24.6206 10.275 29 15.9186 29ZM12.059 23.3585C12.059 24.7102 12.4962 25.6138 13.0577 26.1748C13.6262 26.7428 14.4641 27.1022 15.5226 27.1022C16.386 27.1022 17.3755 26.6531 18.1894 25.78C18.9966 24.9142 19.4837 23.7823 19.4837 22.6784C19.4837 21.5209 19.347 20.6219 18.7171 19.4654C18.2034 18.5221 17.3383 17.3672 15.8556 15.808C15.5488 16.6522 15.0863 17.4253 14.486 18.149L14.3978 18.2551C13.1644 19.7406 12.059 21.0721 12.059 23.3585Z",
      fill
    })
  }));
};
var Reactions_default = Reactions;

// src/shared/ui/icons/shared/RecordRedCircle.tsx
import { jsx as _jsx103 } from "react/jsx-runtime";
import React57 from "react";
function _define_property103(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread103(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property103(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys94(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props94(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys94(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties84(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose84(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose84(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RecordRedCircle = (_param) => {
  var { width: width2 = 6, height: height2 = 6 } = _param, props = _object_without_properties84(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx103("svg", _object_spread_props94(_object_spread103({
    width: width2,
    height: height2,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx103("circle", {
      cx: "3",
      cy: "3",
      r: "2",
      fill: getCssVar("red", 300),
      stroke: getCssVar("red", 300),
      strokeWidth: "2"
    })
  }));
};
var RecordRedCircle_default = /* @__PURE__ */ React57.memo(RecordRedCircle);

// src/shared/ui/icons/shared/RecordStart.tsx
import { jsx as _jsx104 } from "react/jsx-runtime";
function _define_property104(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread104(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property104(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys95(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props95(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys95(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties85(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose85(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose85(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RecordStart = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties85(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx104("svg", _object_spread_props95(_object_spread104({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx104("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M16 29.236c7.31 0 13.236-5.926 13.236-13.237C29.236 8.69 23.31 2.762 16 2.762c-7.31 0-13.237 5.926-13.237 13.237 0 7.31 5.926 13.237 13.237 13.237Zm0-2.543c5.905 0 10.693-4.788 10.693-10.694 0-5.906-4.788-10.693-10.694-10.693-5.906 0-10.693 4.787-10.693 10.693s4.787 10.694 10.693 10.694Zm8.147-10.694a8.148 8.148 0 1 1-16.296 0 8.148 8.148 0 0 1 16.296 0Z",
      clipRule: "evenodd"
    })
  }));
};
var RecordStart_default = RecordStart;

// src/shared/ui/icons/shared/RecordStop.tsx
import { jsx as _jsx105 } from "react/jsx-runtime";
function _define_property105(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread105(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property105(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys96(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props96(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys96(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties86(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose86(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose86(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var RecordStop = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties86(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx105("svg", _object_spread_props96(_object_spread105({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx105("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M16 28.707c7.047 0 12.76-5.713 12.76-12.76 0-7.048-5.713-12.76-12.76-12.76S3.24 8.899 3.24 15.947c0 7.047 5.713 12.76 12.76 12.76ZM11.833 10.88a.9.9 0 0 0-.9.9v8.333a.9.9 0 0 0 .9.9h8.334a.9.9 0 0 0 .9-.9V11.78a.9.9 0 0 0-.9-.9h-8.334Z",
      clipRule: "evenodd"
    })
  }));
};
var RecordStop_default = RecordStop;

// src/shared/ui/icons/shared/ScreenSharing.tsx
import { jsx as _jsx106 } from "react/jsx-runtime";
function _define_property106(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread106(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property106(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys97(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props97(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys97(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties87(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose87(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose87(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ScreenSharing = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties87(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx106("svg", _object_spread_props97(_object_spread106({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx106("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      d: "M8.265 5.92a4.873 4.873 0 0 0-4.872 4.873v10.414a4.873 4.873 0 0 0 4.872 4.873h15.47a4.873 4.873 0 0 0 4.873-4.873V10.793a4.873 4.873 0 0 0-4.873-4.873H8.265Zm7.272 3.865a.654.654 0 0 1 .926 0l5.58 5.58a.655.655 0 0 1 0 .925l-.874.874a.654.654 0 0 1-.926 0l-2.97-2.97v7.309a.655.655 0 0 1-.655.654h-1.236a.655.655 0 0 1-.655-.654v-7.309l-2.97 2.97a.654.654 0 0 1-.925 0l-.875-.874a.655.655 0 0 1 0-.926l5.58-5.58Z",
      clipRule: "evenodd"
    })
  }));
};
var ScreenSharing_default = ScreenSharing;

// src/shared/ui/icons/shared/ScreenSharingLoading.tsx
import { jsx as _jsx107 } from "react/jsx-runtime";
function _define_property107(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread107(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property107(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys98(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props98(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys98(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties88(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose88(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose88(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ScreenSharingLoading = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties88(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx107("svg", _object_spread_props98(_object_spread107({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx107("path", {
      fill: props.fill || getCssVar("grey", 100),
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0004 5.91992H8.26531C5.57417 5.91992 3.39258 8.10151 3.39258 10.7926V21.2073C3.39258 23.8984 5.57418 26.08 8.26531 26.08H23.7349C26.426 26.08 28.6076 23.8984 28.6076 21.2073V13.5654C27.7903 13.8471 26.913 14 26 14C21.5817 14 18 10.4183 18 6C18 5.97328 18.0001 5.94658 18.0004 5.91992ZM16.4629 9.78466C16.2073 9.52905 15.7929 9.52905 15.5373 9.78466L9.95749 15.3644C9.70187 15.6201 9.70187 16.0345 9.95749 16.2901L10.8317 17.1643C11.0873 17.42 11.5018 17.42 11.7574 17.1643L14.7274 14.1944V21.5026C14.7274 21.8641 15.0204 22.1572 15.3819 22.1572H16.6183C16.9798 22.1572 17.2728 21.8641 17.2728 21.5026V14.1944L20.2428 17.1643C20.4984 17.42 20.9128 17.42 21.1685 17.1643L22.0427 16.2901C22.2983 16.0345 22.2983 15.6201 22.0427 15.3644L16.4629 9.78466Z"
    })
  }));
};
var ScreenSharingLoading_default = ScreenSharingLoading;

// src/shared/ui/icons/shared/ScreenSharingUnavailable.tsx
import { jsx as _jsx108, jsxs as _jsxs39 } from "react/jsx-runtime";
import React58 from "react";
var ScreenSharingUnavailable = ({ fill, width: width2 = "32", height: height2 = "32" }) => /* @__PURE__ */ _jsxs39("svg", {
  width: width2,
  height: height2,
  viewBox: "0 0 26 27",
  fill: getCssVar("grey", 500),
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ _jsx108("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.0812 25.9949C20.3016 26.2814 20.7125 26.3351 20.9991 26.1147L21.9791 25.3609C22.2656 25.1405 22.3193 24.7296 22.0989 24.443L21.0439 23.0713L21.0479 23.0711L14.2728 14.2661V14.2678L4.0905 1.02897C3.87011 0.742421 3.45916 0.688792 3.17262 0.909181L2.1926 1.66294C1.90605 1.88333 1.85242 2.29428 2.07281 2.58083L2.83367 3.57007C1.3746 4.41191 0.392578 5.98809 0.392578 7.79364V18.2083C0.392578 20.8994 2.57418 23.081 5.26531 23.081H17.84L20.0812 25.9949ZM14.2728 18.443L11.7274 15.1334V18.4644C11.7274 18.8259 12.0204 19.1189 12.3819 19.1189H13.6183C13.9798 19.1189 14.2728 18.8259 14.2728 18.4644V18.443ZM9.99822 12.8852L8.4332 10.8504L6.95746 12.3262C6.70184 12.5818 6.70184 12.9962 6.95746 13.2519L7.8317 14.1261C8.08732 14.3817 8.50175 14.3817 8.75737 14.1261L9.99822 12.8852Z",
      fill
    }),
    /* @__PURE__ */ _jsx108("path", {
      d: "M25.6076 18.2083C25.6076 19.8425 24.8031 21.2889 23.5685 22.1728L17.4986 14.2844C17.7263 14.36 17.9873 14.3073 18.1684 14.1261L19.0427 13.2519C19.2983 12.9962 19.2983 12.5818 19.0427 12.3262L13.4629 6.74641C13.2073 6.4908 12.7929 6.4908 12.5372 6.74642L12.0632 7.22044L8.75491 2.92091H20.7349C23.426 2.92091 25.6076 5.10251 25.6076 7.79364V18.2083Z",
      fill
    })
  ]
});
var ScreenSharingUnavailable_default = /* @__PURE__ */ React58.memo(ScreenSharingUnavailable);

// src/shared/ui/icons/shared/Search.tsx
import { jsx as _jsx109 } from "react/jsx-runtime";
import React59 from "react";
function _define_property108(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread108(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property108(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys99(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props99(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys99(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties89(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose89(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose89(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Search2 = (_param) => {
  var { width: width2 = 16, height: height2 = 17, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties89(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx109("svg", _object_spread_props99(_object_spread108({
    width: width2,
    height: height2,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx109("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 7C0 3.13 3.13 0 7 0C10.87 0 14 3.13 14 7C14 8.76212 13.3511 10.3708 12.2789 11.6005L15.7802 15.111C16.0337 15.3652 16.0332 15.7767 15.779 16.0302C15.5248 16.2837 15.1133 16.2832 14.8598 16.029L11.3373 12.4973C10.1453 13.4386 8.639 14 7 14C3.13 14 0 10.87 0 7ZM12.7 7C12.7 3.86 10.14 1.3 7 1.3C3.86 1.3 1.3 3.86 1.3 7C1.3 10.14 3.86 12.7 7 12.7C10.14 12.7 12.7 10.14 12.7 7Z",
      fill
    })
  }));
};
var Search_default = /* @__PURE__ */ React59.memo(Search2);

// src/shared/ui/icons/shared/SecurityOnPermise.tsx
import { jsx as _jsx110 } from "react/jsx-runtime";
import React60 from "react";
function _define_property109(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread109(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property109(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys100(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props100(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys100(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var SecurityOnPermise = (props) => /* @__PURE__ */ _jsx110("svg", _object_spread_props100(_object_spread109({
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ _jsx110("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.61124C0 2.07828 0.355238 1.61371 0.861616 1.48445L6.36334 0.0800277C6.78135 -0.026676 7.21865 -0.0266759 7.63666 0.0800278L13.1384 1.48445C13.6448 1.61371 14 2.07828 14 2.61124V7.2843C14 10.0567 12.6012 12.6336 10.2987 14.103L7.60287 15.8235C7.23402 16.0588 6.76598 16.0588 6.39713 15.8235L3.70126 14.103C1.39876 12.6336 0 10.0567 0 7.28429V2.61124ZM6.16767 9.21079C6.41267 9.46096 6.81517 9.45202 7.05142 9.19293L9.72967 6.25358C9.93967 6.01235 9.92217 5.64604 9.69467 5.43161C9.46717 5.21719 9.09967 5.22612 8.88967 5.46735L6.58767 7.99572L5.34406 6.74243C5.12531 6.51907 4.75781 6.51907 4.53906 6.74243C4.32031 6.96579 4.32031 7.34104 4.53906 7.5644L6.16767 9.21079Z"
  })
}));
var SecurityOnPermise_default = /* @__PURE__ */ React60.memo(SecurityOnPermise);

// src/shared/ui/icons/shared/Send.tsx
import { jsx as _jsx111 } from "react/jsx-runtime";
import React61 from "react";
function _define_property110(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread110(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property110(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys101(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props101(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys101(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties90(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose90(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose90(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Send = (_param) => {
  var { isDisabled = false, width: width2 = 21, height: height2 = 18, fill = "#d9d9d9" } = _param, props = _object_without_properties90(_param, [
    "isDisabled",
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx111("svg", _object_spread_props101(_object_spread110({
    width: width2,
    height: height2,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx111("path", {
      d: "M1.85167 17.5211L20.3666 9.69073C20.9771 9.43254 20.9771 8.56738 20.3666 8.3092L1.85167 0.478872C1.30833 0.249084 0.724648 0.707588 0.819234 1.28989L1.41156 4.93643C1.62328 6.23983 2.66236 7.25154 3.97095 7.4284L11.6963 8.47248C11.9604 8.50816 12.1574 8.73356 12.1574 9C12.1574 9.26644 11.9604 9.49183 11.6963 9.52752L3.97094 10.5716C2.66235 10.7485 1.62326 11.7602 1.41155 13.0636L0.819233 16.71C0.724647 17.2923 1.30833 17.7508 1.85167 17.5211Z",
      fill: isDisabled ? getCssVar("grey", 900) : fill
    })
  }));
};
var Send_default = /* @__PURE__ */ React61.memo(Send);

// src/shared/ui/icons/shared/SendMessage.tsx
import { jsx as _jsx112 } from "react/jsx-runtime";
function _define_property111(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread111(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property111(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys102(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props102(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys102(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties91(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose91(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose91(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SendMessage = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties91(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx112("svg", _object_spread_props102(_object_spread111({
    width: width2,
    height: height2,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx112("path", {
      d: "M26.5081 15.7258L7.13832 7.0704C6.55959 6.81179 5.92841 7.30192 6.0066 7.94921L6.7671 14.245C6.81462 14.6384 7.12047 14.9444 7.50197 14.9803L17.5467 15.9252C17.834 15.9522 18.054 16.2015 18.054 16.5C18.054 16.7985 17.834 17.0478 17.5467 17.0748L7.50197 18.0197C7.12046 18.0556 6.81462 18.3616 6.7671 18.755L6.0066 25.0508C5.92841 25.6981 6.55959 26.1882 7.13832 25.9296L26.5081 17.2742C27.164 16.9812 27.164 16.0188 26.5081 15.7258Z"
    })
  }));
};
var SendMessage_default = SendMessage;

// src/shared/ui/icons/shared/Settings.tsx
import { jsx as _jsx113 } from "react/jsx-runtime";
import React62 from "react";
function _define_property112(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread112(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property112(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys103(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props103(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys103(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties92(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose92(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose92(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var NavVideo2 = (_param) => {
  var { width: width2 = 20, height: height2 = 20, fill = "#d9d9d9" } = _param, props = _object_without_properties92(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx113("svg", _object_spread_props103(_object_spread112({
    width: width2,
    height: height2,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx113("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.56845 1.2037C7.64442 0.740166 8.04499 0.399902 8.51471 0.399902H11.4851C11.9548 0.399902 12.3554 0.740165 12.4314 1.2037L12.6252 2.38618C12.6803 2.72237 12.9117 2.99977 13.2199 3.14481C13.6072 3.32706 13.9766 3.54116 14.3246 3.78374C14.6043 3.97868 14.9605 4.04054 15.2794 3.92009L16.4019 3.4961C16.8413 3.33013 17.3363 3.5069 17.5711 3.91369L19.0563 6.48611C19.2912 6.8929 19.1968 7.40994 18.8334 7.7075L17.9048 8.4677C17.6415 8.68328 17.5169 9.02192 17.5452 9.36103C17.5628 9.57166 17.5718 9.78473 17.5718 9.9999C17.5718 10.2151 17.5628 10.4281 17.5452 10.6388C17.5169 10.9779 17.6415 11.3165 17.9048 11.5321L18.8334 12.2923C19.1968 12.5899 19.2912 13.1069 19.0563 13.5137L17.5712 16.0861C17.3363 16.4929 16.8413 16.6697 16.4019 16.5037L15.2794 16.0797C14.9605 15.9593 14.6043 16.0211 14.3246 16.2161C13.9766 16.4586 13.6073 16.6727 13.2199 16.855C12.9117 17 12.6803 17.2774 12.6252 17.6136L12.4314 18.7961C12.3554 19.2596 11.9548 19.5999 11.4851 19.5999H8.51471C8.04499 19.5999 7.64442 19.2596 7.56845 18.7961L7.37465 17.6136C7.31955 17.2774 7.08811 17 6.77986 16.855C6.39256 16.6727 6.02321 16.4586 5.67518 16.2161C5.39552 16.0211 5.03931 15.9593 4.7204 16.0797L3.59789 16.5037C3.15848 16.6697 2.66351 16.4929 2.42865 16.0861L0.943462 13.5137C0.708602 13.1069 0.802994 12.5899 1.16644 12.2923L2.09499 11.5321C2.35829 11.3165 2.4829 10.9779 2.45457 10.6388C2.43698 10.4281 2.428 10.2151 2.428 9.9999C2.428 9.78473 2.43698 9.57166 2.45457 9.36104C2.4829 9.02193 2.35829 8.68328 2.09499 8.46771L1.16644 7.7075C0.802997 7.40994 0.708605 6.8929 0.943465 6.48612L2.42866 3.91369C2.66352 3.5069 3.15848 3.33013 3.5979 3.4961L4.7204 3.92009C5.03931 4.04055 5.39552 3.97868 5.67519 3.78374C6.02321 3.54116 6.39256 3.32706 6.77986 3.14482C7.08811 2.99977 7.31955 2.72237 7.37465 2.38619L7.56845 1.2037ZM9.99991 14.2611C12.3533 14.2611 14.2612 12.3533 14.2612 9.9999C14.2612 7.64648 12.3533 5.73866 9.99991 5.73866C7.64649 5.73866 5.73867 7.64648 5.73867 9.9999C5.73867 12.3533 7.64649 14.2611 9.99991 14.2611Z",
      fill
    })
  }));
};
var Settings_default = /* @__PURE__ */ React62.memo(NavVideo2);

// src/shared/ui/icons/shared/Share.tsx
import { jsx as _jsx114 } from "react/jsx-runtime";
import React63 from "react";
function _define_property113(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread113(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property113(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys104(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props104(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys104(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties93(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose93(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose93(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Share = (_param) => {
  var { width: width2 = 17, height: height2 = 14, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties93(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx114("svg", _object_spread_props104(_object_spread113({
    width: width2,
    height: height2,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx114("path", {
      d: "M0.896046 13.726C1.02743 13.765 1.16829 13.7563 1.29377 13.7014C1.41926 13.6463 1.5213 13.5487 1.58178 13.4256C2.96792 11.1885 5.09383 10.0711 7.58839 9.53705C8.29993 9.39683 9.01993 9.30303 9.74369 9.25647C9.98946 9.23683 10.068 9.29588 10.0632 9.55422C10.0461 10.3392 10.0632 11.1219 10.0632 11.9071C10.0632 12.2147 10.137 12.4683 10.4467 12.5839C10.7564 12.6996 10.9579 12.5347 11.1496 12.3206C12.7667 10.5159 14.3864 8.71089 16.0085 6.9062C16.3305 6.5494 16.3305 6.31549 16.0085 5.95621C14.3815 4.15144 12.7537 2.34154 11.125 0.527003C10.9308 0.307947 10.7121 0.172673 10.4172 0.29806C10.2926 0.352035 10.1898 0.446387 10.1256 0.566145C10.0613 0.685902 10.0394 0.823791 10.0632 0.957707V2.11685C10.0632 2.51309 10.0484 2.91176 10.0632 3.31046C10.0632 3.55657 10.0067 3.61315 9.76097 3.63773C5.73351 4.01843 2.89557 6.05627 1.24751 9.75113C0.794238 10.8089 0.544079 11.9428 0.510198 13.0933C0.483865 13.2279 0.508964 13.3675 0.580418 13.4846C0.651874 13.6017 0.764521 13.6878 0.896046 13.726Z",
      fill
    })
  }));
};
var Share_default = /* @__PURE__ */ React63.memo(Share);

// src/shared/ui/icons/shared/Shield.tsx
import { jsx as _jsx115 } from "react/jsx-runtime";
import React64 from "react";
function _define_property114(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread114(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property114(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys105(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props105(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys105(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties94(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose94(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose94(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Shield = (_param) => {
  var { width: width2 = 14, height: height2 = 16, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties94(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx115("svg", _object_spread_props105(_object_spread114({
    width: width2,
    height: height2,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx115("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 2.61124C0 2.07828 0.355238 1.61371 0.861616 1.48445L6.36334 0.0800277C6.78135 -0.026676 7.21865 -0.0266759 7.63666 0.0800278L13.1384 1.48445C13.6448 1.61371 14 2.07828 14 2.61124V7.2843C14 10.0567 12.6012 12.6336 10.2987 14.103L7.60287 15.8235C7.23402 16.0588 6.76598 16.0588 6.39713 15.8235L3.70126 14.103C1.39876 12.6336 0 10.0567 0 7.28429V2.61124ZM6.16767 9.21079C6.41267 9.46096 6.81517 9.45202 7.05142 9.19293L9.72967 6.25358C9.93967 6.01235 9.92217 5.64604 9.69467 5.43161C9.46717 5.21719 9.09967 5.22612 8.88967 5.46735L6.58767 7.99572L5.34406 6.74243C5.12531 6.51907 4.75781 6.51907 4.53906 6.74243C4.32031 6.96579 4.32031 7.34104 4.53906 7.5644L6.16767 9.21079Z",
      fill
    })
  }));
};
var Shield_default = /* @__PURE__ */ React64.memo(Shield);

// src/shared/ui/icons/shared/SidebarPin.tsx
import { jsx as _jsx116, jsxs as _jsxs40 } from "react/jsx-runtime";
import React65 from "react";
function _define_property115(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread115(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property115(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys106(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props106(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys106(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties95(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose95(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose95(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SidebarPin = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties95(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs40("svg", _object_spread_props106(_object_spread115({
    width: width2,
    height: height2,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx116("rect", {
        x: "9",
        y: "7",
        width: "7",
        height: "4",
        rx: "2",
        fill
      }),
      /* @__PURE__ */ _jsx116("rect", {
        x: "9",
        y: "14",
        width: "7",
        height: "4",
        rx: "2",
        fill
      }),
      /* @__PURE__ */ _jsx116("rect", {
        x: "9",
        y: "21",
        width: "7",
        height: "4",
        rx: "2",
        fill
      }),
      /* @__PURE__ */ _jsx116("path", {
        d: "M24.4331 15.3453C24.7585 15.7211 24.7585 16.2789 24.4331 16.6547L22.2559 19.1686C21.6498 19.8685 20.5 19.4398 20.5 18.5139L20.5 13.4861C20.5 12.5602 21.6498 12.1315 22.2559 12.8314L24.4331 15.3453Z",
        fill
      })
    ]
  }));
};
var SidebarPin_default = /* @__PURE__ */ React65.memo(SidebarPin);

// src/shared/ui/icons/shared/SidebarUnpin.tsx
import { jsx as _jsx117, jsxs as _jsxs41 } from "react/jsx-runtime";
import React66 from "react";
function _define_property116(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread116(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property116(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys107(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props107(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys107(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties96(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose96(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose96(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SidebarUnpin = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties96(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs41("svg", _object_spread_props107(_object_spread116({
    width: width2,
    height: height2,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx117("rect", {
        x: "17",
        y: "7",
        width: "7",
        height: "4",
        rx: "2",
        fill
      }),
      /* @__PURE__ */ _jsx117("rect", {
        x: "17",
        y: "14",
        width: "7",
        height: "4",
        rx: "2",
        fill
      }),
      /* @__PURE__ */ _jsx117("rect", {
        x: "17",
        y: "21",
        width: "7",
        height: "4",
        rx: "2",
        fill
      }),
      /* @__PURE__ */ _jsx117("path", {
        d: "M8.56695 15.3453C8.24152 15.7211 8.24152 16.2789 8.56695 16.6547L10.7441 19.1686C11.3502 19.8685 12.5 19.4398 12.5 18.5139L12.5 13.4861C12.5 12.5602 11.3502 12.1315 10.7441 12.8314L8.56695 15.3453Z",
        fill
      })
    ]
  }));
};
var SidebarUnpin_default = /* @__PURE__ */ React66.memo(SidebarUnpin);

// src/shared/ui/icons/shared/Sorting.tsx
import { jsx as _jsx118, jsxs as _jsxs42 } from "react/jsx-runtime";
import React67 from "react";
function _define_property117(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread117(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property117(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys108(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props108(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys108(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties97(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose97(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose97(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Sorting = (_param) => {
  var { width: width2 = 38, height: height2 = 38, fill = getCssVar("grey", 950) } = _param, props = _object_without_properties97(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs42("svg", _object_spread_props108(_object_spread117({
    width: width2,
    height: height2,
    viewBox: "0 0 38 38"
  }, props), {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsx118("rect", {
        width: "38",
        height: "38",
        rx: "4",
        fill
      }),
      /* @__PURE__ */ _jsx118("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.2571 14.1248H18.558C18.1806 13.1381 17.2248 12.4373 16.1054 12.4373C14.9859 12.4373 14.0302 13.1381 13.6528 14.1248H9.74291C9.35631 14.1248 9.04291 14.4382 9.04291 14.8248V15.2998C9.04291 15.6864 9.35631 15.9998 9.74291 15.9998H13.6528C14.0302 16.9866 14.9859 17.6873 16.1054 17.6873C17.2248 17.6873 18.1806 16.9866 18.558 15.9998H28.2571C28.6437 15.9998 28.9571 15.6864 28.9571 15.2998V14.8248C28.9571 14.4382 28.6437 14.1248 28.2571 14.1248ZM28.3 23.8752C28.6866 23.8752 29 23.5618 29 23.1752V22.7002C29 22.3136 28.6866 22.0002 28.3 22.0002H24.3472C23.9698 21.0134 23.014 20.3127 21.8946 20.3127C20.7751 20.3127 19.8194 21.0134 19.442 22.0002L9.7 22.0002C9.3134 22.0002 9 22.3136 9 22.7002V23.1752C9 23.5618 9.3134 23.8752 9.7 23.8752L19.442 23.8752C19.8194 24.8619 20.7751 25.5627 21.8946 25.5627C23.014 25.5627 23.9698 24.8619 24.3472 23.8752H28.3Z",
        fill: "#EBEDF0"
      })
    ]
  }));
};
var Sorting_default = /* @__PURE__ */ React67.memo(Sorting);

// src/shared/ui/icons/shared/Speaker.tsx
import { jsx as _jsx119, jsxs as _jsxs43 } from "react/jsx-runtime";
import React68 from "react";
var Speaker = ({ fill = getCssVar("grey", 100), width: width2 = "24", height: height2 = "24" }) => /* @__PURE__ */ _jsxs43("svg", {
  width: width2,
  height: height2,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ _jsx119("path", {
      d: "M11.921 6.11489L7.99742 9.33122L5.80826 9.53326C5.35357 9.58377 5 9.95424 5 10.4257V13.4064C5 13.861 5.35369 14.2483 5.80826 14.2988L7.99742 14.5009L11.921 17.7172C12.241 17.9867 12.7293 17.7509 12.7293 17.3299V6.50218C12.7125 6.08108 12.241 5.84533 11.921 6.11479V6.11489Z",
      fill
    }),
    /* @__PURE__ */ _jsx119("path", {
      d: "M15.7096 10.0544C15.4906 9.68391 14.9856 9.59968 14.6487 9.88593L14.5982 9.91964C14.3624 10.1217 14.2951 10.4753 14.4466 10.7448C14.6319 11.0816 14.7497 11.4688 14.7497 11.8898C14.7497 12.3108 14.6318 12.6981 14.4466 13.0348C14.2951 13.3043 14.3624 13.6579 14.5982 13.86L14.6487 13.8937C14.9687 14.18 15.4906 14.1127 15.7096 13.7253C16.0126 13.1864 16.1979 12.5465 16.1979 11.8729C16.198 11.2332 16.0128 10.61 15.7096 10.0543V10.0544Z",
      fill
    }),
    /* @__PURE__ */ _jsx119("path", {
      d: "M17.4775 8.38829C17.2418 8.05153 16.7535 8.00101 16.4503 8.27036L16.4166 8.30407C16.1641 8.53981 16.1136 8.9271 16.3156 9.21334C16.8545 9.97108 17.1576 10.9141 17.1576 11.9077C17.1576 12.9181 16.8376 13.8442 16.3156 14.6021C16.1135 14.8883 16.1641 15.2756 16.4166 15.5113L16.4503 15.5451C16.7534 15.8145 17.2418 15.764 17.4775 15.4271C18.1848 14.4336 18.589 13.2212 18.589 11.9077C18.589 10.5942 18.1848 9.38177 17.4775 8.38824V8.38829Z",
      fill
    }),
    /* @__PURE__ */ _jsx119("path", {
      d: "M19.2469 6.75565C18.9943 6.43567 18.5396 6.38518 18.2364 6.65463L18.1859 6.68834C17.9165 6.92409 17.8829 7.32827 18.1017 7.61454C19.011 8.8102 19.5331 10.292 19.5331 11.8918C19.5331 13.4915 18.9942 14.9902 18.1017 16.169C17.8828 16.4552 17.9165 16.8594 18.1859 17.0952L18.2364 17.1289C18.5395 17.3983 18.9942 17.3478 19.2469 17.0279C20.3414 15.5965 20.9813 13.8115 20.9813 11.875C20.9813 9.97211 20.3414 8.18716 19.2469 6.75581V6.75565Z",
      fill
    })
  ]
});
var Speaker_default = /* @__PURE__ */ React68.memo(Speaker);

// src/shared/ui/icons/shared/Spinner.tsx
import { jsx as _jsx120 } from "react/jsx-runtime";
import React69 from "react";
function _define_property118(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread118(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property118(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys109(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props109(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys109(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties98(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose98(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose98(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Spinner = (_param) => {
  var { width: width2 = 20, height: height2 = 20, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties98(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx120("svg", _object_spread_props109(_object_spread118({
    width: width2,
    height: height2,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx120("path", {
      d: "M9.99979 0.972021C9.99979 0.474965 9.59551 0.0677545 9.10045 0.112207C4.0388 0.566696 0.0717773 4.8201 0.0717773 10C0.0717773 15.4831 4.51671 19.928 9.99979 19.928C15.1798 19.928 19.4331 15.9611 19.8876 10.8994C19.9321 10.4043 19.5249 9.99764 19.0278 9.99385C18.9837 9.99351 18.9396 9.99321 18.8954 9.99296C18.408 9.99021 18.0253 10.3897 17.9728 10.8742C17.5372 14.8924 14.1338 18.0202 9.99979 18.0202C5.5704 18.0202 1.97967 14.4294 1.97967 10C1.97967 5.8744 5.0948 2.47634 9.10125 2.02969C9.59524 1.97461 9.99979 1.57697 9.99979 1.07991V1.02597V0.972021Z",
      fill
    })
  }));
};
var Spinner_default = /* @__PURE__ */ React69.memo(Spinner);

// src/shared/ui/icons/shared/SpinnerSmall.tsx
import { jsx as _jsx121 } from "react/jsx-runtime";
import React70 from "react";
function _define_property119(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread119(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property119(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys110(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props110(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys110(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties99(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose99(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose99(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SpinnerSmall = (_param) => {
  var { width: width2 = 12, height: height2 = 12, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties99(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx121("svg", _object_spread_props110(_object_spread119({
    width: width2,
    height: height2,
    viewBox: "0 0 12 12"
  }, props), {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ _jsx121("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.25 5.75C0.25 2.57436 2.82436 0 6 0C9.17564 0 11.75 2.57436 11.75 5.75H9.25C9.25 3.95507 7.79492 2.5 6 2.5C4.20508 2.5 2.75 3.95507 2.75 5.75C2.75 7.54493 4.20508 9 6 9V11.5C2.82436 11.5 0.25 8.92564 0.25 5.75Z",
      fill: "#EBEDF0"
    })
  }));
};
var SpinnerSmall_default = /* @__PURE__ */ React70.memo(SpinnerSmall);

// src/shared/ui/icons/shared/Star.tsx
import { jsx as _jsx122 } from "react/jsx-runtime";
import React71 from "react";
function _define_property120(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread120(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property120(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys111(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props111(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys111(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties100(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose100(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose100(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Star = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties100(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx122("svg", _object_spread_props111(_object_spread120({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx122("path", {
      d: "M10.716 3.81808C11.1201 2.57431 12.8797 2.57431 13.2838 3.81808L14.4345 7.35954C14.6153 7.91577 15.1336 8.29236 15.7184 8.29236H19.4422C20.7499 8.29236 21.2937 9.96585 20.2357 10.7345L17.2231 12.9233C16.75 13.267 16.552 13.8764 16.7327 14.4326L17.8834 17.9741C18.2875 19.2178 16.864 20.2521 15.806 19.4834L12.7934 17.2947C12.3203 16.9509 11.6796 16.9509 11.2064 17.2947L8.19386 19.4834C7.13585 20.2521 5.7123 19.2178 6.11642 17.9741L7.26711 14.4326C7.44784 13.8764 7.24985 13.267 6.77669 12.9233L3.76416 10.7345C2.70614 9.96585 3.24989 8.29236 4.55766 8.29236H8.28137C8.86622 8.29236 9.38456 7.91577 9.56529 7.35954L10.716 3.81808Z",
      fill
    })
  }));
};
var Star_default = /* @__PURE__ */ React71.memo(Star);

// src/shared/ui/icons/shared/StarOutline.tsx
import { jsx as _jsx123 } from "react/jsx-runtime";
import React72 from "react";
function _define_property121(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread121(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property121(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys112(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props112(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys112(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties101(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose101(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose101(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var StarOutline = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties101(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx123("svg", _object_spread_props112(_object_spread121({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx123("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9528 3.5729C11.2867 2.80839 12.3702 2.80968 12.7034 3.5729L14.9515 8.72153L20.5429 9.26859C21.3731 9.34982 21.7067 10.3807 21.0838 10.9335L16.8819 14.6626L18.0894 20.1493C18.2687 20.964 17.3914 21.5998 16.6732 21.1783L11.8281 18.3343L6.9831 21.1783C6.26366 21.6006 5.38785 20.9626 5.56685 20.1493L6.77439 14.6626L2.57245 10.9335C1.94851 10.3798 2.28456 9.34968 3.11341 9.26859L8.70475 8.72153L10.9528 3.5729ZM11.8281 6.33915L10.2303 9.99866C10.0918 10.3157 9.79263 10.5333 9.44796 10.567L5.47379 10.9559L8.46042 13.6064C8.71917 13.836 8.83366 14.1878 8.75922 14.526L7.90094 18.4258L11.3447 16.4044C11.643 16.2293 12.013 16.2291 12.3116 16.4044L15.7553 18.4258L14.8971 14.526C14.8227 14.1881 14.9368 13.8363 15.1959 13.6064L18.1825 10.9559L14.2083 10.567C13.864 10.5333 13.5646 10.316 13.426 9.99866L11.8281 6.33915Z",
      fill
    })
  }));
};
var StarOutline_default = /* @__PURE__ */ React72.memo(StarOutline);

// src/shared/ui/icons/shared/StopCall.tsx
import { jsx as _jsx124 } from "react/jsx-runtime";
function _define_property122(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread122(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property122(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys113(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props113(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys113(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties102(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose102(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose102(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var StopCall = (_param) => {
  var { width: width2 = 32, height: height2 = 32 } = _param, props = _object_without_properties102(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsx124("svg", _object_spread_props113(_object_spread122({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx124("path", {
      fill: props.fill || getCssVar("red", 300),
      d: "M24.73 21.814c.994.721 2.417.666 3.199-.282l2.952-3.583c.7-.85.622-2.107-.244-2.787-8.396-6.59-20.28-6.59-28.675 0-.867.68-.944 1.937-.244 2.787L4.67 21.53c.781.949 2.204 1.004 3.2.283.744-.54 1.528-1 2.34-1.379.928-.433 1.538-1.395 1.38-2.407l-.323-2.055c3.653-1.179 6.538-1.179 10.191 0l-.381 2.006c-.196 1.032.415 2.033 1.364 2.481.794.375 1.56.826 2.288 1.354Z"
    })
  }));
};
var StopCall_default = StopCall;

// src/shared/ui/icons/shared/Tick.tsx
import { jsx as _jsx125 } from "react/jsx-runtime";
import React73 from "react";
function _define_property123(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread123(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property123(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys114(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props114(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys114(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties103(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose103(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose103(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Tick = (_param) => {
  var { width: width2 = 15, height: height2 = 10, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties103(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx125("svg", _object_spread_props114(_object_spread123({
    width: width2,
    height: height2,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx125("path", {
      d: "M13.8393 2.25584C14.1647 1.9304 14.1647 1.40277 13.8393 1.07733C13.5138 0.751893 12.9862 0.751893 12.6607 1.07733L5.75 7.98807L2.17259 4.41066C1.84715 4.08523 1.31951 4.08523 0.994078 4.41066C0.668641 4.7361 0.668641 5.26374 0.994078 5.58917L5.16074 9.75584C5.48618 10.0813 6.01382 10.0813 6.33926 9.75584L13.8393 2.25584Z",
      fill
    })
  }));
};
var Tick_default = /* @__PURE__ */ React73.memo(Tick);

// src/shared/ui/icons/shared/Trash.tsx
import { jsx as _jsx126 } from "react/jsx-runtime";
import React74 from "react";
function _define_property124(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread124(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property124(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys115(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props115(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys115(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties104(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose104(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose104(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Trash = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("red", 300) } = _param, props = _object_without_properties104(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx126("svg", _object_spread_props115(_object_spread124({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx126("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.2071 2.06641C13.5799 2.06641 13.8821 2.36861 13.8821 2.74141V4.93127H19.5043C19.7943 4.93127 20.0293 5.16633 20.0293 5.45627V6.28127C20.0293 6.57122 19.7943 6.80627 19.5043 6.80627H18.5647L17.934 19.794C17.8758 20.9928 16.8869 21.9348 15.6866 21.9348H8.42305C7.22283 21.9348 6.23391 20.9928 6.1757 19.794L5.54498 6.80627H4.5543C4.26435 6.80627 4.0293 6.57122 4.0293 6.28127V5.45627C4.0293 5.16633 4.26435 4.93127 4.5543 4.93127H10.2276V2.74141C10.2276 2.36861 10.5298 2.06641 10.9026 2.06641H13.2071ZM10.62 18.0748C10.7857 18.0748 10.92 17.9405 10.92 17.7748L10.92 9.99261C10.92 9.82693 10.7857 9.69261 10.62 9.69261H9.34504C9.17935 9.69261 9.04504 9.82693 9.04504 9.99261V17.7748C9.04504 17.9405 9.17935 18.0748 9.34504 18.0748H10.62ZM14.7061 18.0748C14.8718 18.0748 15.0061 17.9405 15.0061 17.7748V9.99261C15.0061 9.82693 14.8718 9.69261 14.7061 9.69261H13.4311C13.2654 9.69261 13.1311 9.82693 13.1311 9.99261V17.7748C13.1311 17.9405 13.2654 18.0748 13.4311 18.0748H14.7061Z",
      fill
    })
  }));
};
var Trash_default = /* @__PURE__ */ React74.memo(Trash);

// src/shared/ui/icons/shared/TriplePoints.tsx
import { jsx as _jsx127, jsxs as _jsxs44 } from "react/jsx-runtime";
import React75 from "react";
function _define_property125(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread125(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property125(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys116(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props116(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys116(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties105(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose105(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose105(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var TriplePoints = (_param) => {
  var { width: width2 = 4, height: height2 = 18, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties105(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs44("svg", _object_spread_props116(_object_spread125({
    width: width2,
    height: height2,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx127("path", {
        d: "M-8.74226e-08 16C-1.35705e-07 14.8954 0.89543 14 2 14C3.10457 14 4 14.8954 4 16C4 17.1046 3.10457 18 2 18C0.895431 18 -3.91404e-08 17.1046 -8.74226e-08 16Z",
        fill
      }),
      /* @__PURE__ */ _jsx127("path", {
        d: "M-6.99381e-07 2C-7.47663e-07 0.895433 0.89543 1.86821e-06 2 1.81993e-06C3.10457 1.77164e-06 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.89543 4 -6.51099e-07 3.10457 -6.99381e-07 2Z",
        fill
      }),
      /* @__PURE__ */ _jsx127("path", {
        d: "M2 7C0.89543 7 -4.41684e-07 7.89543 -3.93402e-07 9C-3.45119e-07 10.1046 0.89543 11 2 11C3.10457 11 4 10.1046 4 9C4 7.89543 3.10457 7 2 7Z",
        fill
      })
    ]
  }));
};
var TriplePoints_default = /* @__PURE__ */ React75.memo(TriplePoints);

// src/shared/ui/icons/shared/Upload.tsx
import { jsx as _jsx128, jsxs as _jsxs45 } from "react/jsx-runtime";
import React76 from "react";
function _define_property126(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread126(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property126(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys117(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props117(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys117(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties106(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose106(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose106(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Upload = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties106(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs45("svg", _object_spread_props117(_object_spread126({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx128("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.32 5.38489C12.1433 5.2106 11.8567 5.2106 11.68 5.38489L6.52527 10.4691C6.34856 10.6434 6.06205 10.6434 5.88534 10.4691L5.38253 9.97315C5.20582 9.79886 5.20582 9.51628 5.38253 9.34198L11.68 3.13072C11.8567 2.95643 12.1433 2.95643 12.32 3.13072L18.6175 9.34198C18.7942 9.51628 18.7942 9.79886 18.6175 9.97315L18.1147 10.4691C17.938 10.6434 17.6514 10.6434 17.4747 10.4691L12.32 5.38489Z",
        fill
      }),
      /* @__PURE__ */ _jsx128("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.6445 3.94224C11.3946 3.94224 11.192 4.14205 11.192 4.38854L11.192 16.0537C11.192 16.3002 11.3946 16.5 11.6445 16.5H12.3556C12.6055 16.5 12.8081 16.3002 12.8081 16.0537L12.808 4.38854C12.808 4.14205 12.6054 3.94223 12.3555 3.94223L11.6445 3.94224Z",
        fill
      }),
      /* @__PURE__ */ _jsx128("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 20.58C6 20.812 6.19057 21 6.42565 21L17.5744 21C17.8094 21 18 20.8119 18 20.58L18 19.92C18 19.688 17.8094 19.5 17.5744 19.5L6.42564 19.5C6.19057 19.5 6 19.6881 6 19.92L6 20.58Z",
        fill
      })
    ]
  }));
};
var Upload_default = /* @__PURE__ */ React76.memo(Upload);

// src/shared/ui/icons/shared/User.tsx
import { jsx as _jsx129, jsxs as _jsxs46 } from "react/jsx-runtime";
import React77 from "react";
var User = ({ fill = getCssVar("grey", 700), width: width2 = "80", height: height2 = "80" }) => /* @__PURE__ */ _jsxs46("svg", {
  width: width2,
  height: height2,
  viewBox: "0 0 80 80",
  fill,
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ _jsx129("path", {
      d: "M55.9561 24.4123C54.8158 39.3513 49.9739 45.0384 40.3318 45.0384C30.6898 45.0384 25.4632 39.2609 24.4817 24.4123C23.4465 15.4657 31.3255 8.10498 40.3318 8.10498C49.3381 8.10498 56.6416 15.4322 55.9561 24.4123Z",
      fill
    }),
    /* @__PURE__ */ _jsx129("path", {
      d: "M12.6484 67.7887C12.6484 60.5362 17.0913 53.9646 24.0803 52.0274C29.2675 50.5896 35.3181 49.285 40.1954 49.285C45.0726 49.285 51.1232 50.5896 56.3104 52.0274C63.2994 53.9646 67.7423 60.5362 67.7423 67.7887C67.7423 68.5828 67.0986 69.2265 66.3046 69.2265H14.0862C13.2921 69.2265 12.6484 68.5828 12.6484 67.7887Z",
      fill
    })
  ]
});
var User_default = /* @__PURE__ */ React77.memo(User);

// src/shared/ui/icons/shared/Users.tsx
import { jsx as _jsx130, jsxs as _jsxs47 } from "react/jsx-runtime";
import React78 from "react";
var Users = ({ fill = getCssVar("grey", 700), width: width2 = "60", height: height2 = "60" }) => /* @__PURE__ */ _jsxs47("svg", {
  width: width2,
  height: height2,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    /* @__PURE__ */ _jsx130("path", {
      d: "M38.721 28.066C38.197 28.066 37.697 28.0374 37.2206 27.9786C37.4468 26.7288 37.5975 25.4218 37.6899 24.0722C38.3098 18.2502 35.0728 13.5184 30.5722 11.0802C32.1218 8.25198 35.2002 6.34766 38.721 6.34766C44.0171 6.34766 48.6503 10.6761 48.0415 15.937C47.4644 24.6686 44.391 28.066 38.721 28.066Z",
      fill
    }),
    /* @__PURE__ */ _jsx130("path", {
      d: "M43.0001 42.2895H54.1545C54.6215 42.2895 55 41.911 55 41.4441C55 37.1793 52.3874 33.3149 48.2776 32.1758C45.2273 31.3303 41.6693 30.5631 38.8013 30.5631C38.0954 30.5631 37.3477 30.6096 36.5761 30.6923C36.0654 32.3831 35.3658 33.9284 34.4236 35.2826C34.431 35.2847 34.4384 35.2867 34.4458 35.2888C38.3605 36.3739 41.3011 39.0065 43.0001 42.2895Z",
      fill
    }),
    /* @__PURE__ */ _jsx130("path", {
      d: "M23.6144 35.7769C17.9445 35.7769 15.0973 32.4326 14.4267 23.648C14.0236 18.3673 18.3184 14.0586 23.6144 14.0586C28.9105 14.0586 33.5436 18.387 32.9349 23.648C32.3578 32.3795 29.2843 35.7769 23.6144 35.7769Z",
      fill
    }),
    /* @__PURE__ */ _jsx130("path", {
      d: "M33.171 39.8867C37.2808 41.0259 39.8934 44.8902 39.8934 49.155C39.8934 49.6219 39.5148 50.0005 39.0479 50.0005H8.34143C7.8745 50.0005 7.49597 49.6219 7.49597 49.155C7.49597 44.8902 10.1086 41.0259 14.2184 39.8867C17.2687 39.0412 20.8267 38.274 23.6947 38.274C26.5627 38.274 30.1207 39.0412 33.171 39.8867Z",
      fill
    })
  ]
});
var Users_default = /* @__PURE__ */ React78.memo(Users);

// src/shared/ui/icons/shared/Update.tsx
import { jsx as _jsx131, jsxs as _jsxs48 } from "react/jsx-runtime";
import React79 from "react";
function _define_property127(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread127(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property127(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys118(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props118(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys118(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties107(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose107(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose107(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Update = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties107(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs48("svg", _object_spread_props118(_object_spread127({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx131("path", {
        d: "M16.4592 7.43458C15.3082 6.31013 13.7352 5.61872 12.0007 5.61872C8.65307 5.61872 5.90753 8.1964 5.64059 11.4752C5.61707 11.7642 5.38427 12.0001 5.09432 12.0001H4.26932C3.97937 12.0001 3.74258 11.7643 3.76075 11.475C4.03158 7.15977 7.61719 3.74372 12.0007 3.74372C14.0723 3.74372 15.9656 4.50719 17.4144 5.76638V3.49473C17.4144 3.20478 17.6495 2.96973 17.9394 2.96973H18.7644C19.0544 2.96973 19.2894 3.20478 19.2894 3.49473V8.78458C19.2894 9.07452 19.0544 9.30958 18.7644 9.30958H13.4746C13.1846 9.30958 12.9496 9.07452 12.9496 8.78458V7.95958C12.9496 7.66963 13.1846 7.43458 13.4746 7.43458H16.4592Z",
        fill
      }),
      /* @__PURE__ */ _jsx131("path", {
        d: "M6.58017 18.2279V20.455C6.58017 20.745 6.34512 20.98 6.05517 20.98H5.23017C4.94022 20.98 4.70517 20.745 4.70517 20.455L4.70517 15.1652C4.70517 14.8752 4.94022 14.6402 5.23017 14.6402H10.52C10.81 14.6402 11.045 14.8752 11.045 15.1652V15.9902C11.045 16.2801 10.81 16.5152 10.52 16.5152H7.49108C8.64644 17.6693 10.2404 18.3814 12.0007 18.3814C15.3483 18.3814 18.0938 15.8037 18.3607 12.5249C18.3843 12.2359 18.6171 12.0001 18.907 12.0001H19.732C20.022 12.0001 20.2587 12.2358 20.2406 12.5252C19.9698 16.8404 16.3841 20.2564 12.0007 20.2564C9.92581 20.2564 8.0299 19.4906 6.58017 18.2279Z",
        fill
      })
    ]
  }));
};
var Update_default = /* @__PURE__ */ React79.memo(Update);

// src/shared/ui/icons/shared/InfoOutline.tsx
import { jsx as _jsx132, jsxs as _jsxs49 } from "react/jsx-runtime";
import React80 from "react";
function _define_property128(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread128(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property128(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys119(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props119(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys119(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var InfoOutline = (props) => /* @__PURE__ */ _jsxs49("svg", _object_spread_props119(_object_spread128({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [
    /* @__PURE__ */ _jsx132("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 18.375C15.5208 18.375 18.375 15.5208 18.375 12C18.375 8.47918 15.5208 5.625 12 5.625C8.47918 5.625 5.625 8.47918 5.625 12C5.625 15.5208 8.47918 18.375 12 18.375ZM12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z",
      fill: "#898E96"
    }),
    /* @__PURE__ */ _jsx132("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.25 8.66144C11.25 8.43421 11.4342 8.25 11.6614 8.25H12.5967C12.824 8.25 13.0082 8.43421 13.0082 8.66144V9.37773C13.0082 9.60496 12.824 9.78917 12.5967 9.78917H11.6614C11.4342 9.78917 11.25 9.60496 11.25 9.37773V8.66144ZM12.4523 11.0035C12.6796 11.0035 12.8638 11.1877 12.8638 11.4149V15.9335C12.8638 16.1607 12.6796 16.3449 12.4523 16.3449H11.8058C11.5786 16.3449 11.3944 16.1607 11.3944 15.9335V11.4149C11.3944 11.1877 11.5786 11.0035 11.8058 11.0035H12.4523Z",
      fill: "#898E96"
    })
  ]
}));
var InfoOutline_default = /* @__PURE__ */ React80.memo(InfoOutline);

// src/shared/ui/icons/shared/Book.tsx
import { jsx as _jsx133, jsxs as _jsxs50 } from "react/jsx-runtime";
function _define_property129(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread129(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property129(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys120(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props120(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys120(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties108(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose108(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose108(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Book = (_param) => {
  var { width: width2 = 98, height: height2 = 98 } = _param, props = _object_without_properties108(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs50("svg", _object_spread_props120(_object_spread129({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 97 97",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx133("path", {
        opacity: "0.45",
        d: "M24.6074 83.1919C20.7414 83.1919 17.6074 80.0579 17.6074 76.1919L17.6074 20.8076C17.6074 16.9416 20.7414 13.8076 24.6074 13.8076L72.7363 13.8076C74.9455 13.8076 76.7363 15.5985 76.7363 17.8076L76.7363 79.1919C76.7363 81.4011 74.9455 83.1919 72.7363 83.1919H24.6074Z",
        fill: "url(#paint0_linear_9435_33906)"
      }),
      /* @__PURE__ */ _jsx133("path", {
        d: "M76.7365 20.2076C76.7365 17.9674 76.7365 16.8473 76.3005 15.9917C75.917 15.239 75.3051 14.6271 74.5524 14.2436C73.6968 13.8076 72.5767 13.8076 70.3365 13.8076L27.6021 13.8076L27.6021 71.718H76.7365L76.7365 20.2076Z",
        fill: "url(#paint1_linear_9435_33906)"
      }),
      /* @__PURE__ */ _jsx133("path", {
        opacity: "0.5",
        d: "M17.6074 77.4547C17.6074 74.2863 20.176 71.7178 23.3444 71.7178H76.7363V77.0723C76.7363 79.2143 76.7363 80.2853 76.3195 81.1034C75.9528 81.8231 75.3677 82.4082 74.648 82.7749C73.8299 83.1917 72.7589 83.1917 70.6169 83.1917L23.3444 83.1917C20.176 83.1917 17.6074 80.6232 17.6074 77.4547Z",
        fill: "url(#paint2_linear_9435_33906)"
      }),
      /* @__PURE__ */ _jsxs50("g", {
        opacity: "0.45",
        children: [
          /* @__PURE__ */ _jsx133("path", {
            d: "M76.7363 21.5693H80.7363C81.2886 21.5693 81.7363 22.0171 81.7363 22.5693V31.3652C81.7363 31.9175 81.2886 32.3652 80.7363 32.3652H76.7363V21.5693Z",
            fill: "url(#paint3_linear_9435_33906)"
          }),
          /* @__PURE__ */ _jsx133("path", {
            d: "M76.7363 37.3652H80.7363C81.2886 37.3652 81.7363 37.813 81.7363 38.3652V47.1611C81.7363 47.7134 81.2886 48.1611 80.7363 48.1611H76.7363V37.3652Z",
            fill: "url(#paint4_linear_9435_33906)"
          }),
          /* @__PURE__ */ _jsx133("path", {
            d: "M80.7363 53.1611H76.7363V63.957H80.7363C81.2886 63.957 81.7363 63.5093 81.7363 62.957V54.1611C81.7363 53.6088 81.2886 53.1611 80.7363 53.1611Z",
            fill: "url(#paint5_linear_9435_33906)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx133("path", {
        d: "M39.6689 31.7627C39.6689 32.315 40.1167 32.7627 40.6689 32.7627L63.6689 32.7627C64.2212 32.7627 64.6689 32.315 64.6689 31.7627V28.7627C64.6689 28.2104 64.2212 27.7627 63.6689 27.7627H40.6689C40.1167 27.7627 39.6689 28.2104 39.6689 28.7627V31.7627Z",
        fill: "url(#paint6_linear_9435_33906)"
      }),
      /* @__PURE__ */ _jsx133("path", {
        d: "M39.6689 41.7627C39.6689 42.315 40.1167 42.7627 40.6689 42.7627L63.6689 42.7627C64.2212 42.7627 64.6689 42.315 64.6689 41.7627V38.7627C64.6689 38.2104 64.2212 37.7627 63.6689 37.7627L40.6689 37.7627C40.1167 37.7627 39.6689 38.2104 39.6689 38.7627V41.7627Z",
        fill: "url(#paint7_linear_9435_33906)"
      }),
      /* @__PURE__ */ _jsxs50("defs", {
        children: [
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint0_linear_9435_33906",
            x1: "7.82792",
            y1: "55.6152",
            x2: "34.3139",
            y2: "55.6152",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint1_linear_9435_33906",
            x1: "21.7971",
            y1: "25.4847",
            x2: "89.295",
            y2: "63.6466",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#666E81"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint2_linear_9435_33906",
            x1: "47.1719",
            y1: "71.7178",
            x2: "47.1719",
            y2: "103.735",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#727B8B",
                stopOpacity: "0.13"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint3_linear_9435_33906",
            x1: "82.8616",
            y1: "40.48",
            x2: "74.2729",
            y2: "39.6363",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint4_linear_9435_33906",
            x1: "82.8616",
            y1: "40.48",
            x2: "74.2729",
            y2: "39.6363",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint5_linear_9435_33906",
            x1: "82.8616",
            y1: "40.48",
            x2: "74.2729",
            y2: "39.6363",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint6_linear_9435_33906",
            x1: "52.1689",
            y1: "27.7627",
            x2: "52.1689",
            y2: "42.7627",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs50("linearGradient", {
            id: "paint7_linear_9435_33906",
            x1: "52.1689",
            y1: "27.7627",
            x2: "52.1689",
            y2: "42.7627",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx133("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx133("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Book_default = Book;

// src/shared/ui/icons/shared/Calendar.tsx
import { jsx as _jsx134 } from "react/jsx-runtime";
function _define_property130(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread130(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property130(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys121(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props121(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys121(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties109(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose109(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose109(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Calendar = (_param) => {
  var { width: width2 = 24, height: height2 = 24, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties109(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx134("svg", _object_spread_props121(_object_spread130({
    width: width2,
    height: height2,
    viewBox: "0 0 24 24",
    fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx134("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.01816 4.00001V2.48496C7.01816 2.19501 7.25321 1.95996 7.54316 1.95996H8.36816C8.65811 1.95996 8.89316 2.19501 8.89316 2.48496V4.00001L15.2223 4.00001V2.48496C15.2223 2.19501 15.4573 1.95996 15.7473 1.95996H16.5723C16.8622 1.95996 17.0973 2.19501 17.0973 2.48496V4.0012C19.0423 4.05082 20.6037 5.64306 20.6037 7.60001V17.4C20.6037 19.3882 18.9919 21 17.0037 21H6.99454C5.00631 21 3.39453 19.3882 3.39453 17.4V7.60001C3.39453 5.61179 5.00631 4.00001 6.99453 4.00001H7.01816ZM18.7287 7.60001V9.52631H5.26953V7.60001C5.26953 6.64732 6.04184 5.87501 6.99453 5.87501L17.0037 5.87501C17.9564 5.87501 18.7287 6.64732 18.7287 7.60001ZM5.26953 11.4013H18.7287V17.4C18.7287 18.3527 17.9564 19.125 17.0037 19.125H6.99454C6.04184 19.125 5.26953 18.3527 5.26953 17.4L5.26953 11.4013Z",
      fill
    })
  }));
};
var Calendar_default = Calendar;

// src/shared/ui/icons/shared/Report.tsx
import { jsx as _jsx135, jsxs as _jsxs51 } from "react/jsx-runtime";
function _define_property131(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread131(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property131(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys122(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props122(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys122(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties110(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose110(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose110(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Book2 = (_param) => {
  var { width: width2 = 98, height: height2 = 98 } = _param, props = _object_without_properties110(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs51("svg", _object_spread_props122(_object_spread131({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 97 97",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx135("path", {
        d: "M18.4023 35.3574C18.4023 29.7569 18.4023 26.9566 19.4923 24.8175C20.451 22.9359 21.9808 21.4061 23.8624 20.4474C26.0016 19.3574 28.8018 19.3574 34.4023 19.3574H61.5948C67.1953 19.3574 69.9956 19.3574 72.1347 20.4474C74.0163 21.4061 75.5461 22.9359 76.5048 24.8175C77.5948 26.9566 77.5948 29.7569 77.5948 35.3574V69.0005C77.5948 74.601 77.5948 77.4013 76.5048 79.5404C75.5461 81.422 74.0163 82.9519 72.1347 83.9106C69.9956 85.0005 67.1953 85.0005 61.5948 85.0005H34.4024C28.8018 85.0005 26.0016 85.0005 23.8624 83.9106C21.9808 82.9519 20.451 81.422 19.4923 79.5404C18.4023 77.4013 18.4023 74.601 18.4023 69.0005V35.3574Z",
        fill: "url(#paint0_linear_8924_61495)"
      }),
      /* @__PURE__ */ _jsx135("path", {
        opacity: "0.45",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72.9702 20.9229V75.3775C72.9702 78.1389 70.7316 80.3775 67.9702 80.3775H41.0648L23.0352 62.3478V20.922C23.3035 20.7512 23.5806 20.5927 23.8659 20.4474C26.005 19.3574 28.8052 19.3574 34.4058 19.3574H61.5982C67.1987 19.3574 69.999 19.3574 72.1381 20.4474C72.4238 20.5929 72.7014 20.7517 72.9702 20.9229ZM63.8811 49.8671C63.8811 58.6365 56.7721 65.7456 48.0026 65.7456C39.2332 65.7456 32.1241 58.6365 32.1241 49.8671C32.1241 41.0976 39.2332 33.9886 48.0026 33.9886C56.7721 33.9886 63.8811 41.0976 63.8811 49.8671Z",
        fill: "url(#paint1_linear_8924_61495)"
      }),
      /* @__PURE__ */ _jsx135("path", {
        d: "M57.5169 46.4886C57.9074 46.0981 57.9074 45.4649 57.5169 45.0744L55.3956 42.9531C55.0051 42.5625 54.3719 42.5625 53.9814 42.953L46.3251 50.6093L42.016 46.2999C41.6255 45.9094 40.9923 45.9093 40.6018 46.2998L38.4804 48.4211C38.0899 48.8116 38.0899 49.4448 38.4804 49.8353L45.6179 56.9733C46.0084 57.3639 46.6416 57.3639 47.0321 56.9733L57.5169 46.4886Z",
        fill: "url(#paint2_linear_8924_61495)"
      }),
      /* @__PURE__ */ _jsx135("path", {
        d: "M35.4796 13.444C36.5392 13.444 37.069 13.444 37.4719 13.3602C38.1578 13.2176 37.8773 13.3173 38.4992 12.9948C38.8645 12.8053 40.2554 11.6723 43.037 9.40648C44.3908 8.30374 46.1186 7.64258 48.0008 7.64258C49.8829 7.64258 51.6107 8.30374 52.9645 9.40648C55.7462 11.6723 57.137 12.8053 57.5023 12.9948C58.1242 13.3173 57.8437 13.2176 58.5296 13.3602C58.9325 13.444 59.4624 13.444 60.5221 13.444C62.7921 13.444 63.9271 13.444 64.7827 13.88C65.5354 14.2635 66.1473 14.8754 66.5308 15.6281C66.9667 16.4837 66.9667 17.6218 66.9667 19.898C66.9667 22.1742 66.9667 23.3123 66.5308 24.1679C66.1473 24.9206 65.5354 25.5325 64.7827 25.916C63.9271 26.352 62.807 26.352 60.5667 26.352H35.4351C33.1949 26.352 32.0748 26.352 31.2192 25.916C30.4665 25.5325 29.8546 24.9206 29.4711 24.1679C29.0352 23.3123 29.0352 22.1742 29.0352 19.898C29.0352 17.6218 29.0352 16.4837 29.4711 15.6281C29.8546 14.8754 30.4665 14.2635 31.2192 13.88C32.0748 13.444 33.2098 13.444 35.4796 13.444Z",
        fill: "url(#paint3_linear_8924_61495)"
      }),
      /* @__PURE__ */ _jsx135("path", {
        opacity: "0.45",
        d: "M23.041 62.418L28.9178 62.418C33.2714 62.418 35.4483 62.418 37.1112 63.2653C38.5739 64.0105 39.7631 65.1998 40.5084 66.6625C41.3557 68.3254 41.3557 70.5022 41.3557 74.8559V80.6887H41.3117L23.041 62.418Z",
        fill: "url(#paint4_linear_8924_61495)"
      }),
      /* @__PURE__ */ _jsxs51("defs", {
        children: [
          /* @__PURE__ */ _jsxs51("linearGradient", {
            id: "paint0_linear_8924_61495",
            x1: "77.5948",
            y1: "23.5344",
            x2: "18.4023",
            y2: "82.2309",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx135("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx135("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs51("linearGradient", {
            id: "paint1_linear_8924_61495",
            x1: "72.971",
            y1: "19.3564",
            x2: "16.6779",
            y2: "55.6967",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx135("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx135("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs51("linearGradient", {
            id: "paint2_linear_8924_61495",
            x1: "47.9987",
            y1: "42.6602",
            x2: "47.9987",
            y2: "57.2662",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx135("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx135("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs51("linearGradient", {
            id: "paint3_linear_8924_61495",
            x1: "66.6184",
            y1: "3.9424",
            x2: "56.0859",
            y2: "39.3132",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx135("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx135("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs51("linearGradient", {
            id: "paint4_linear_8924_61495",
            x1: "41.3557",
            y1: "62.4178",
            x2: "18.7774",
            y2: "85.6852",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx135("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx135("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Report_default = Book2;

// src/shared/ui/icons/shared/File.tsx
import { jsx as _jsx136 } from "react/jsx-runtime";
function _define_property132(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread132(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property132(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys123(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props123(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys123(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties111(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose111(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose111(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var File = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("grey", 100) } = _param, props = _object_without_properties111(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx136("svg", _object_spread_props123(_object_spread132({
    width: width2,
    height: height2,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx136("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.67109 3.14161C7.02012 3.14162 4.87109 5.29065 4.87109 7.94161V24.0585C4.87109 26.7094 7.02013 28.8585 9.6711 28.8585H22.327C24.9779 28.8585 27.127 26.7094 27.127 24.0585V13.6564C27.127 12.4074 26.6401 11.2075 25.7697 10.3117L20.2176 4.59685C19.3138 3.66653 18.0719 3.1416 16.7748 3.1416L9.67109 3.14161ZM17.5799 6.76598C17.5799 6.28238 18.0688 5.95696 18.4152 6.29451L18.4395 6.31857L23.7697 11.6446C24.0957 11.9719 23.8339 12.4437 23.372 12.4437H18.2799C17.8933 12.4437 17.5799 12.1303 17.5799 11.7437V6.76598Z",
      fill,
      fillOpacity: "0.4"
    })
  }));
};
var File_default = File;

// src/shared/ui/icons/shared/ErrorTriangle.tsx
import { jsx as _jsx137 } from "react/jsx-runtime";
function _define_property133(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread133(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property133(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys124(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props124(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys124(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties112(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose112(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose112(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ErrorTriangle = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("red", 300) } = _param, props = _object_without_properties112(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx137("svg", _object_spread_props124(_object_spread133({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: width2,
    height: height2
  }, props), {
    children: /* @__PURE__ */ _jsx137("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.4933 6.47725C14.6074 4.50758 17.3926 4.50758 18.5067 6.47726L27.6079 22.5682C28.722 24.5379 27.3294 27 25.1012 27H6.89875C4.67061 27 3.27803 24.5379 4.3921 22.5682L13.4933 6.47725ZM15.5447 18.859C15.1717 18.859 14.8694 18.5503 14.8694 18.1696L14.8694 12.0026C14.8694 11.6218 15.1717 11.3132 15.5447 11.3132H16.606C16.979 11.3132 17.2814 11.6218 17.2814 12.0026V18.1696C17.2814 18.5503 16.979 18.859 16.606 18.859H15.5447ZM16.843 23.6094C17.216 23.6094 17.5184 23.3008 17.5184 22.92V21.7198C17.5184 21.3391 17.216 21.0305 16.843 21.0305H15.3078C14.9348 21.0305 14.6324 21.3391 14.6324 21.7198V22.92C14.6324 23.3008 14.9348 23.6094 15.3078 23.6094H16.843Z",
      fill
    })
  }));
};
var ErrorTriangle_default = ErrorTriangle;

// src/shared/ui/icons/shared/SearchEmpty.tsx
import { jsx as _jsx138, jsxs as _jsxs52 } from "react/jsx-runtime";
function _define_property134(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread134(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property134(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys125(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props125(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys125(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties113(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose113(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose113(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SearchEmpty = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties113(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs52("svg", _object_spread_props125(_object_spread134({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx138("path", {
        d: "M41.6248 13.9414H56.3581C62.4643 13.9414 65.5174 13.9414 67.8497 15.1298C69.9012 16.1751 71.5691 17.843 72.6144 19.8945C73.8028 22.2268 73.8028 25.2799 73.8028 31.3861L73.8028 64.6161C73.8028 70.7223 73.8028 73.7754 72.6144 76.1077C71.5691 78.1592 69.9012 79.8271 67.8497 80.8724C65.5174 82.0607 62.4643 82.0607 56.3581 82.0607H33.4442C27.338 82.0607 24.2849 82.0607 21.9526 80.8724C19.9011 79.8271 18.2332 78.1592 17.1879 76.1077C15.9995 73.7754 15.9995 70.7223 15.9995 64.6161V39.5667L41.6248 13.9414Z",
        fill: "url(#paint0_linear_15926_342)"
      }),
      /* @__PURE__ */ _jsx138("path", {
        opacity: "0.45",
        d: "M16.0005 39.5668H24.2428C30.349 39.5668 33.4021 39.5668 35.7344 38.3784C37.7859 37.3331 39.4538 35.6652 40.4991 33.6137C41.6875 31.2814 41.6875 28.2283 41.6875 22.1221V13.9414H41.6258L16.0005 39.5668Z",
        fill: "url(#paint1_linear_15926_342)"
      }),
      /* @__PURE__ */ _jsxs52("g", {
        opacity: "0.8",
        children: [
          /* @__PURE__ */ _jsx138("path", {
            d: "M25.0684 61.5312C25.0684 62.0835 25.5161 62.5312 26.0684 62.5312L35.4727 62.5312C36.0249 62.5312 36.4727 62.0835 36.4727 61.5312V58.5312C36.4727 57.979 36.0249 57.5312 35.4727 57.5312H26.0684C25.5161 57.5312 25.0684 57.979 25.0684 58.5312V61.5312Z",
            fill: "url(#paint2_linear_15926_342)"
          }),
          /* @__PURE__ */ _jsx138("path", {
            d: "M25.0684 72.0372C25.0684 72.5895 25.5161 73.0372 26.0684 73.0372L44.0684 73.0372C44.6206 73.0372 45.0684 72.5895 45.0684 72.0372V69.0372C45.0684 68.4849 44.6206 68.0372 44.0684 68.0372L26.0684 68.0372C25.5161 68.0372 25.0684 68.4849 25.0684 69.0372V72.0372Z",
            fill: "url(#paint3_linear_15926_342)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx138("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.1948 62.6134C89.5805 53.4633 89.0223 40.0257 80.5203 31.5237C71.421 22.4244 56.668 22.4244 47.5687 31.5237C38.4693 40.6231 38.4693 55.3761 47.5687 64.4754C56.071 72.9777 69.5093 73.5356 78.6594 66.149L87.6407 75.1303C88.0367 75.5263 88.2347 75.7243 88.463 75.7985C88.6639 75.8638 88.8802 75.8638 89.081 75.7985C89.3094 75.7243 89.5074 75.5263 89.9034 75.1303L91.1762 73.8575C91.5722 73.4615 91.7702 73.2635 91.8444 73.0351C91.9097 72.8343 91.9097 72.618 91.8444 72.4171C91.7702 72.1888 91.5722 71.9908 91.1762 71.5948L82.1948 62.6134ZM76.9848 35.0593C84.1315 42.206 84.1315 53.7931 76.9848 60.9399C69.8381 68.0866 58.2509 68.0866 51.1042 60.9399C43.9575 53.7931 43.9575 42.206 51.1042 35.0593C58.2509 27.9125 69.8381 27.9125 76.9848 35.0593Z",
        fill: "url(#paint4_linear_15926_342)"
      }),
      /* @__PURE__ */ _jsx138("path", {
        opacity: "0.45",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.1948 62.6134C89.5805 53.4633 89.0223 40.0257 80.5203 31.5237C71.421 22.4244 56.668 22.4244 47.5687 31.5237C38.4693 40.6231 38.4693 55.3761 47.5687 64.4754C56.071 72.9777 69.5093 73.5356 78.6594 66.149L88.0649 75.5546C88.4554 75.9451 89.0886 75.9451 89.4791 75.5546L91.6005 73.4332C91.991 73.0427 91.991 72.4095 91.6005 72.019L82.1948 62.6134ZM76.9848 35.0593C84.1315 42.206 84.1315 53.7931 76.9848 60.9399C69.8381 68.0866 58.2509 68.0866 51.1042 60.9399C43.9575 53.7931 43.9575 42.206 51.1042 35.0593C58.2509 27.9125 69.8381 27.9125 76.9848 35.0593Z",
        fill: "url(#paint5_linear_15926_342)"
      }),
      /* @__PURE__ */ _jsx138("path", {
        opacity: "0.8",
        d: "M64.0453 44.4629L58.1058 38.5234C57.7152 38.1328 57.0821 38.1328 56.6916 38.5234L54.5702 40.6447C54.1797 41.0352 54.1797 41.6684 54.5702 42.0589L60.5098 47.9984L54.5702 53.938C54.1797 54.3285 54.1797 54.9617 54.5702 55.3522L56.6916 57.4735C57.0821 57.8641 57.7152 57.8641 58.1058 57.4735L64.0453 51.534L69.9846 57.4732C70.3751 57.8637 71.0082 57.8637 71.3988 57.4732L73.5201 55.3519C73.9106 54.9614 73.9106 54.3282 73.5201 53.9377L67.5809 47.9984L73.5201 42.0592C73.9106 41.6687 73.9106 41.0355 73.5201 40.645L71.3988 38.5237C71.0082 38.1332 70.3751 38.1332 69.9846 38.5237L64.0453 44.4629Z",
        fill: "url(#paint6_linear_15926_342)"
      }),
      /* @__PURE__ */ _jsxs52("defs", {
        children: [
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint0_linear_15926_342",
            x1: "17.522",
            y1: "30.0882",
            x2: "79.1204",
            y2: "67.6416",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint1_linear_15926_342",
            x1: "31.7192",
            y1: "40.1683",
            x2: "31.7192",
            y2: "13.9413",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint2_linear_15926_342",
            x1: "35.0684",
            y1: "57.5312",
            x2: "35.0684",
            y2: "73.0372",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint3_linear_15926_342",
            x1: "35.0684",
            y1: "57.5312",
            x2: "35.0684",
            y2: "73.0372",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint4_linear_15926_342",
            x1: "37.5824",
            y1: "56.2856",
            x2: "95.9295",
            y2: "86.5253",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint5_linear_15926_342",
            x1: "36.4714",
            y1: "52.4645",
            x2: "96.9832",
            y2: "50.2733",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#99A1B5"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs52("linearGradient", {
            id: "paint6_linear_15926_342",
            x1: "64.0452",
            y1: "38.2305",
            x2: "64.0452",
            y2: "57.7664",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx138("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx138("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var SearchEmpty_default = SearchEmpty;

// src/shared/ui/icons/shared/SearchError.tsx
import { jsx as _jsx139, jsxs as _jsxs53 } from "react/jsx-runtime";
function _define_property135(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread135(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property135(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys126(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props126(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys126(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties114(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose114(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose114(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SearchError = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties114(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs53("svg", _object_spread_props126(_object_spread135({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx139("path", {
        d: "M54.5424 76.8615L67.0675 77.9573C72.1032 78.3979 74.621 78.6182 76.6301 77.8064C78.3973 77.0924 79.8932 75.8373 80.9032 74.2209C82.0515 72.3832 82.2718 69.8654 82.7123 64.8298L85.2382 35.9589C85.6787 30.9233 85.899 28.4055 85.0873 26.3964C84.3733 24.6291 83.1181 23.1333 81.5017 22.1232C79.6641 20.975 77.1463 20.7547 72.1106 20.3141L48.0263 18.207L58.5979 30.6249L45.864 41.1561L56.5757 53.7386L43.8418 64.2698L54.5424 76.8615Z",
        fill: "url(#paint0_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsx139("path", {
        d: "M36.4513 19.207L23.7806 20.3156C18.745 20.7561 16.2272 20.9764 14.3895 22.1247C12.7731 23.1347 11.518 24.6306 10.804 26.3978C9.99223 28.4069 10.2125 30.9247 10.6531 35.9604L13.1789 64.8312C13.6195 69.8669 13.8398 72.3847 14.9881 74.2223C15.9981 75.8387 17.4939 77.0939 19.2612 77.8079C21.2703 78.6196 23.7881 78.3993 28.8237 77.9588L53.0536 75.8389L40.3291 65.2967L51.0409 52.7142L38.3069 42.1829L49.0187 29.6005L36.4513 19.207Z",
        fill: "url(#paint1_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsx139("path", {
        opacity: "0.35",
        d: "M50.397 71.9608L67.4616 73.4538C70.0536 73.6806 71.7276 73.8235 73.0105 73.8309C74.2405 73.8379 74.7081 73.7082 74.9403 73.6143C75.8239 73.2573 76.5719 72.6298 77.0769 71.8215C77.2096 71.6092 77.4186 71.1712 77.6252 69.9586C77.8407 68.6939 77.9907 67.0206 78.2174 64.4286L80.3214 40.3798L50.0013 37.7271L58.5987 30.6168L48.0273 18.1992L72.1114 20.3063C74.4532 20.5112 76.2505 20.6684 77.6881 20.8935C79.3417 21.1524 80.5195 21.5011 81.5025 22.1154C82.1087 22.4942 82.664 22.9413 83.1591 23.4454C83.9842 24.2855 84.6418 25.284 85.0881 26.3886C85.5646 27.568 85.6855 28.9228 85.6149 30.8594C85.5653 32.2216 85.4209 33.8717 85.239 35.9511L82.7131 64.8219C82.2725 69.8576 82.0523 72.3754 80.904 74.213C79.8939 75.8294 78.3981 77.0846 76.6308 77.7986C74.6218 78.6103 72.1039 78.39 67.0683 77.9495L54.543 76.8537L50.397 71.9608Z",
        fill: "url(#paint2_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsx139("path", {
        opacity: "0.35",
        d: "M36.4516 19.207L23.7806 20.3156C19.3745 20.7011 16.896 20.9179 15.1141 21.7354C14.8596 21.8521 14.6192 21.9812 14.3895 22.1247C12.8742 23.0716 11.6763 24.4455 10.9441 26.0697C10.8953 26.178 10.8486 26.2874 10.804 26.3978C10.043 28.2814 10.189 30.612 10.5732 35.0452C10.5989 35.3408 10.6255 35.6456 10.6531 35.9604L13.1789 64.8312C13.6195 69.8668 13.8398 72.3847 14.988 74.2223C15.9981 75.8387 17.4939 77.0939 19.2612 77.8079C21.2703 78.6196 23.7881 78.3993 28.8237 77.9588L53.0535 75.8389L48.1208 71.7404L28.4304 73.4631C25.8384 73.6899 24.1645 73.8328 22.8816 73.8402C21.6515 73.8472 21.1839 73.7174 20.9517 73.6236C20.0681 73.2666 19.3202 72.639 18.8152 71.8308C18.6824 71.6185 18.4735 71.1805 18.2668 69.9679C18.0513 68.7032 17.9014 67.0299 17.6746 64.4379L15.5706 40.389L41.7865 38.0955L49.0186 29.6003L36.4516 19.207Z",
        fill: "url(#paint3_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsxs53("g", {
        opacity: "0.3",
        children: [
          /* @__PURE__ */ _jsx139("path", {
            d: "M19.1136 34.6144C18.5634 34.6626 18.0784 34.2556 18.0302 33.7054L17.7688 30.7168C17.7206 30.1666 18.1276 29.6816 18.6778 29.6334L21.6664 29.372C22.2166 29.3238 22.7016 29.7308 22.7497 30.281L23.0112 33.2696C23.0593 33.8198 22.6523 34.3048 22.1022 34.353L19.1136 34.6144Z",
            fill: "url(#paint4_linear_15926_247)"
          }),
          /* @__PURE__ */ _jsx139("path", {
            d: "M29.0755 33.7429C28.5253 33.791 28.0403 33.384 27.9922 32.8338L27.7307 29.8452C27.6826 29.2951 28.0896 28.81 28.6397 28.7619L31.6283 28.5004C32.1785 28.4523 32.6635 28.8593 32.7117 29.4095L32.9731 32.398C33.0213 32.9482 32.6143 33.4333 32.0641 33.4814L29.0755 33.7429Z",
            fill: "url(#paint5_linear_15926_247)"
          }),
          /* @__PURE__ */ _jsx139("path", {
            d: "M37.9541 31.9623C38.0023 32.5125 38.4873 32.9194 39.0375 32.8713L42.0261 32.6098C42.5762 32.5617 42.9832 32.0767 42.9351 31.5265L42.6736 28.5379C42.6255 27.9877 42.1405 27.5807 41.5903 27.6289L38.6017 27.8903C38.0515 27.9385 37.6445 28.4235 37.6927 28.9737L37.9541 31.9623Z",
            fill: "url(#paint6_linear_15926_247)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx139("path", {
        d: "M26.8086 51.5758C26.8086 49.3356 26.8086 48.2155 27.2446 47.3598C27.6281 46.6072 28.24 45.9952 28.9926 45.6118C29.8483 45.1758 30.9684 45.1758 33.2086 45.1758H62.7934C65.0336 45.1758 66.1537 45.1758 67.0093 45.6118C67.762 45.9952 68.3739 46.6072 68.7574 47.3598C69.1934 48.2155 69.1934 49.3356 69.1934 51.5758V52.7589C69.1934 54.9991 69.1934 56.1193 68.7574 56.9749C68.3739 57.7275 67.762 58.3395 67.0093 58.723C66.1537 59.1589 65.0336 59.1589 62.7934 59.1589H33.2086C30.9684 59.1589 29.8483 59.1589 28.9926 58.723C28.24 58.3395 27.6281 57.7275 27.2446 56.9749C26.8086 56.1193 26.8086 54.9991 26.8086 52.7589V51.5758Z",
        fill: "url(#paint7_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsx139("path", {
        opacity: "0.3",
        d: "M26.8086 49.1758C26.8086 46.9666 28.5995 45.1758 30.8086 45.1758H65.1934C67.4025 45.1758 69.1934 46.9666 69.1934 49.1758V55.1589C69.1934 57.3681 67.4025 59.1589 65.1934 59.1589H30.8086C28.5995 59.1589 26.8086 57.3681 26.8086 55.1589V49.1758Z",
        fill: "url(#paint8_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsx139("path", {
        opacity: "0.3",
        d: "M41.8672 48.6367C41.8672 48.0844 42.3149 47.6367 42.8672 47.6367H53.4004C53.9527 47.6367 54.4004 48.0844 54.4004 48.6367V55.7012C54.4004 56.2535 53.9527 56.7012 53.4004 56.7012H42.8672C42.3149 56.7012 41.8672 56.2535 41.8672 55.7012V48.6367Z",
        fill: "url(#paint9_linear_15926_247)"
      }),
      /* @__PURE__ */ _jsxs53("defs", {
        children: [
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint0_linear_15926_247",
            x1: "67.1849",
            y1: "19.8829",
            x2: "62.1417",
            y2: "77.5261",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "0.0001",
                stopColor: "#9B4747"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#471C1C"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint1_linear_15926_247",
            x1: "28.7077",
            y1: "19.8845",
            x2: "33.7508",
            y2: "77.5277",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "0.0001",
                stopColor: "#9B4747"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#471C1C"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint2_linear_15926_247",
            x1: "67.2625",
            y1: "19.8821",
            x2: "62.2193",
            y2: "77.5253",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#FF9393",
                stopOpacity: "0.66"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#883737",
                stopOpacity: "0.51"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint3_linear_15926_247",
            x1: "28.7076",
            y1: "19.8845",
            x2: "33.7507",
            y2: "77.5277",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#FF9393",
                stopOpacity: "0.66"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#883737",
                stopOpacity: "0.51"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint4_linear_15926_247",
            x1: "22.9124",
            y1: "27.625",
            x2: "22.9124",
            y2: "31.6856",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint5_linear_15926_247",
            x1: "22.9124",
            y1: "27.625",
            x2: "22.9124",
            y2: "31.6856",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint6_linear_15926_247",
            x1: "22.9124",
            y1: "27.625",
            x2: "22.9124",
            y2: "31.6856",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint7_linear_15926_247",
            x1: "38.977",
            y1: "30.0531",
            x2: "65.8251",
            y2: "117.39",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#FF8585"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "0.0001",
                stopColor: "#A45454"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#450000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint8_linear_15926_247",
            x1: "26.8086",
            y1: "40.4042",
            x2: "65.5016",
            y2: "69.1931",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#834A4A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs53("linearGradient", {
            id: "paint9_linear_15926_247",
            x1: "44.4299",
            y1: "47.6367",
            x2: "44.4299",
            y2: "52.8999",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx139("stop", {
                stopColor: "#C58D8D"
              }),
              /* @__PURE__ */ _jsx139("stop", {
                offset: "1",
                stopColor: "#BA9D9D"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var SearchError_default = SearchError;

// src/shared/ui/icons/shared/SearchPeople.tsx
import { jsx as _jsx140, jsxs as _jsxs54 } from "react/jsx-runtime";
function _define_property136(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread136(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property136(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys127(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props127(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys127(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties115(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose115(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose115(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SearchPeople = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties115(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs54("svg", _object_spread_props127(_object_spread136({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.5",
        d: "M80.9478 27.0031C80.9478 32.0198 80.9478 47.0412 80.9478 58.4241C78.8626 63.9753 70.8155 67.9793 67.0423 67.9793C63.2692 67.9793 55.2221 63.9753 53.1369 58.4241C53.1365 48.688 53.1369 32.0198 53.1369 27.0031C53.1369 19.3234 59.3626 13.0977 67.0423 13.0977C74.7221 13.0977 80.9478 19.3234 80.9478 27.0031Z",
        fill: "url(#paint0_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.5",
        d: "M44.2285 62.7655C44.2285 59.9675 47.1007 56.937 54.3165 52.961C60.7595 49.4108 61.1981 47.6936 61.1981 43.9126C61.1981 41.977 61.0832 39.73 60.9709 37.5366C60.864 35.4457 60.7595 33.4035 60.7595 31.7266H73.3258C73.3258 33.4035 73.2213 35.4457 73.1143 37.5366C73.0021 39.73 72.8871 41.977 72.8871 43.9126C72.8871 47.6936 73.3258 49.4108 79.7688 52.961C86.9845 56.937 89.8567 59.9675 89.8567 62.7655C89.8567 63.8503 82.3751 72.5857 67.1034 72.6318C67.0628 72.6318 67.0224 72.632 66.9818 72.632C51.7101 72.5859 44.2285 63.8503 44.2285 62.7655Z",
        fill: "url(#paint1_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        d: "M77.5558 29.2398C77.5558 35.0461 75.2689 45.7531 67.0425 45.7531C58.8162 45.7531 56.5293 35.0461 56.5293 29.2398C56.5293 23.4335 61.2362 18.7266 67.0425 18.7266C72.8488 18.7266 77.5558 23.4335 77.5558 29.2398Z",
        fill: "url(#paint2_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.5",
        d: "M77.5558 29.2398C77.5558 35.0461 75.2689 45.7531 67.0425 45.7531C58.8162 45.7531 56.5293 35.0461 56.5293 29.2398C56.5293 23.4335 61.2362 18.7266 67.0425 18.7266C72.8488 18.7266 77.5558 23.4335 77.5558 29.2398Z",
        fill: "url(#paint3_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        d: "M80.9478 53.6262V27.0031C80.9478 19.3234 74.7221 13.0977 67.0424 13.0977C59.3626 13.0977 53.1369 19.3234 53.1369 27.0031C53.1369 28.3068 53.1368 30.3974 53.1368 32.9487C53.1368 38.739 53.1367 46.9026 53.1368 53.6266C53.5164 53.4082 53.9095 53.187 54.3165 52.9627C56.0684 51.9974 56.8509 51.4192 57.3523 51.0901C57.3523 51.0901 57.3523 36.507 57.3523 32.3253C57.3523 25.6839 65.7223 21.1329 71.7211 21.1329C71.7211 21.1329 77.0446 26.2342 76.7329 32.3253V51.0901C77.1414 51.3167 78.0169 51.9974 79.7688 52.9627C80.1755 53.1868 80.5684 53.4079 80.9478 53.6262Z",
        fill: "url(#paint4_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        d: "M54.3165 52.9642C47.1007 56.9402 44.2285 59.9707 44.2285 62.7687C44.2285 63.8534 51.7101 72.589 66.9818 72.6352L67.1034 72.635C82.3751 72.5889 89.8567 63.8534 89.8567 62.7687C89.8567 59.9707 86.9845 56.9402 79.7688 52.9642C77.638 51.7901 76.1639 50.8164 75.1452 49.9023C75.1452 49.9023 73.8648 54.9465 67.0426 54.9465C60.2204 54.9465 58.94 49.9023 58.94 49.9023C57.9213 50.8164 56.4472 51.7901 54.3165 52.9642Z",
        fill: "url(#paint5_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.7",
        d: "M21.5996 57.0683C21.6061 57.092 23.3826 63.5509 32.7737 63.5509C42.166 63.5509 43.9417 57.0904 43.9478 57.0683C41.3563 55.3325 40.6656 54.0223 40.6656 51.2161C40.6656 49.0647 40.7934 46.5672 40.9182 44.1294C41.0371 41.8055 41.1532 39.5358 41.1532 37.6719H25.15C25.15 39.5358 25.2661 41.8055 25.385 44.1294C25.5098 46.5672 25.6375 49.0647 25.6375 51.2161C25.6375 54.0223 24.4928 55.3325 21.5996 57.0683Z",
        fill: "url(#paint6_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.7",
        d: "M19.2749 37.7458C20.1369 36.5207 21.6433 35.6326 23.6487 37.1459C24.0121 39.6369 24.2365 44.5613 22.2269 44.3311C19.7149 44.0434 18.4129 38.9709 19.2749 37.7458Z",
        fill: "url(#paint7_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.7",
        d: "M47.0293 37.7458C46.1673 36.5207 44.6609 35.6326 42.6555 37.1459C42.2921 39.6369 42.0677 44.5613 44.0773 44.3311C46.5893 44.0434 47.8913 38.9709 47.0293 37.7458Z",
        fill: "url(#paint8_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        d: "M45.5626 33.6914C45.5626 43.184 42.8631 55.3066 33.1525 55.3066C23.442 55.3066 20.7424 43.184 20.7424 33.6914C20.7424 26.8374 26.2986 21.2812 33.1525 21.2812C40.0064 21.2812 45.5626 26.8374 45.5626 33.6914Z",
        fill: "url(#paint9_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.7",
        d: "M45.5626 33.6914C45.5626 43.184 42.8631 55.3066 33.1525 55.3066C23.442 55.3066 20.7424 43.184 20.7424 33.6914C20.7424 26.8374 26.2986 21.2812 33.1525 21.2812C40.0064 21.2812 45.5626 26.8374 45.5626 33.6914Z",
        fill: "url(#paint10_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        d: "M42.8903 29.5105C42.0654 28.3909 37.2385 27.5847 32.9247 27.5847C28.9443 27.5847 24.8839 27.5847 23.9848 29.5105C23.2655 31.0511 21.1849 37.2779 21.1849 40.2953C20.714 37.1283 20.0202 32.1117 19.7428 27.5847C19.5409 24.29 20.4141 21.5503 22.0832 20.2664C23.7523 18.9825 31.793 15.8979 35.0027 16.283C37.5706 16.5912 40.4516 18.9397 41.6927 20.2664C43.0194 20.6088 44.9576 20.695 45.9847 21.5167C47.2686 22.5438 48.3958 23.7883 47.7539 28.6671C47.2403 32.5701 45.9847 38.1126 45.1288 40.2953C45.1288 40.2953 43.7151 30.63 42.8903 29.5105Z",
        fill: "url(#paint11_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsx140("path", {
        opacity: "0.7",
        d: "M15.9102 60.2097C7.89026 64.6288 6.73438 67.9541 6.73438 71.0638C6.73438 72.2695 16.1111 81.9787 33.0848 82.03L33.2199 82.0298C50.1936 81.9785 59.5703 72.2695 59.5703 71.0638C59.5703 67.9541 57.3962 64.6288 49.3763 60.2097L49.3452 60.1925C46.982 58.8904 45.2321 57.9262 43.9486 57.0664C43.9486 57.0664 42.1828 63.549 32.7745 63.549C23.3661 63.549 21.6004 57.0664 21.6004 57.0664C20.6561 57.6329 19.5256 58.2448 18.188 58.9688C17.4867 59.3484 16.7284 59.7588 15.9102 60.2097Z",
        fill: "url(#paint12_linear_15926_738)"
      }),
      /* @__PURE__ */ _jsxs54("defs", {
        children: [
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint0_linear_15926_738",
            x1: "67.0423",
            y1: "13.0977",
            x2: "67.0423",
            y2: "67.9793",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint1_linear_15926_738",
            x1: "97.3331",
            y1: "38.1362",
            x2: "58.0374",
            y2: "92.8378",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint2_linear_15926_738",
            x1: "67.0425",
            y1: "18.7266",
            x2: "67.0425",
            y2: "45.7531",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint3_linear_15926_738",
            x1: "85.5561",
            y1: "16.048",
            x2: "54.643",
            y2: "50.0384",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint4_linear_15926_738",
            x1: "67.0423",
            y1: "13.0977",
            x2: "67.0423",
            y2: "53.6266",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint5_linear_15926_738",
            x1: "51.915",
            y1: "41.7119",
            x2: "73.2939",
            y2: "74.752",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint6_linear_15926_738",
            x1: "47.6096",
            y1: "41.726",
            x2: "30.7316",
            y2: "88.4845",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint7_linear_15926_738",
            x1: "25.4547",
            y1: "38.3012",
            x2: "16.5034",
            y2: "43.4057",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint8_linear_15926_738",
            x1: "40.8495",
            y1: "38.3012",
            x2: "49.8008",
            y2: "43.4057",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint9_linear_15926_738",
            x1: "33.1525",
            y1: "21.2812",
            x2: "33.1525",
            y2: "55.3066",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint10_linear_15926_738",
            x1: "58.3501",
            y1: "21.2813",
            x2: "15.7351",
            y2: "58.492",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint11_linear_15926_738",
            x1: "33.8269",
            y1: "16.25",
            x2: "33.8269",
            y2: "40.2953",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs54("linearGradient", {
            id: "paint12_linear_15926_738",
            x1: "55.1609",
            y1: "38.3149",
            x2: "19.1833",
            y2: "74.9611",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx140("stop", {
                stopColor: "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx140("stop", {
                offset: "1",
                stopColor: "#495462"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var SearchPeople_default = SearchPeople;

// src/shared/ui/icons/shared/Review.tsx
import { jsx as _jsx141, jsxs as _jsxs55 } from "react/jsx-runtime";
function _define_property137(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread137(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property137(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys128(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props128(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys128(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties116(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose116(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose116(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Review = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties116(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs55("svg", _object_spread_props128(_object_spread137({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx141("path", {
        opacity: "0.5",
        d: "M33.3651 22.9479C32.9102 21.9063 31.4314 21.9045 30.9758 22.9479L28.2733 29.1372C28.1401 29.4422 28.0735 29.5947 27.9693 29.7112C27.877 29.8142 27.7639 29.8964 27.6374 29.9523C27.4943 30.0155 27.3287 30.0317 26.9975 30.0641L20.2761 30.7217C19.1448 30.8324 18.6862 32.2383 19.5378 32.9941L24.589 37.4769C24.8379 37.6978 24.9623 37.8082 25.0409 37.9434C25.1104 38.063 25.1536 38.196 25.1677 38.3336C25.1836 38.4891 25.1478 38.6516 25.0763 38.9766L23.6247 45.5723C23.3804 46.6824 24.5757 47.5531 25.5576 46.9767L31.3819 43.558C31.669 43.3895 31.8125 43.3053 31.9653 43.2723C32.1005 43.2432 32.2404 43.2432 32.3756 43.2723C32.5284 43.3053 32.6719 43.3895 32.9589 43.558L38.7832 46.9767C39.7635 47.5521 40.9609 46.6843 40.7162 45.5723L39.2646 38.9766C39.193 38.6516 39.1573 38.4891 39.1732 38.3336C39.1872 38.196 39.2304 38.063 39.2999 37.9434C39.3785 37.8082 39.503 37.6978 39.7519 37.4769L44.8031 32.9941C45.6532 32.2396 45.1979 30.8326 44.0647 30.7217L37.3433 30.0641C37.0121 30.0317 36.8465 30.0155 36.7035 29.9523C36.577 29.8964 36.4638 29.8142 36.3716 29.7112C36.2673 29.5947 36.2007 29.4422 36.0675 29.1372L33.3651 22.9479Z",
        fill: "url(#paint0_linear_15952_33855)"
      }),
      /* @__PURE__ */ _jsxs55("g", {
        opacity: "0.29",
        children: [
          /* @__PURE__ */ _jsx141("path", {
            d: "M22.7151 60.9498C22.9234 61.0559 23.196 61.0559 23.7412 61.0559L48.5795 61.0559C49.1247 61.0559 49.3973 61.0559 49.6056 60.9498C49.7888 60.8565 49.9377 60.7076 50.031 60.5244C50.1371 60.3161 50.1371 60.0435 50.1371 59.4983V57.7461C50.1371 57.2009 50.1371 56.9282 50.031 56.72C49.9377 56.5368 49.7888 56.3879 49.6056 56.2946C49.3973 56.1885 49.1247 56.1885 48.5795 56.1885H23.7412C23.196 56.1885 22.9234 56.1885 22.7151 56.2946C22.532 56.3879 22.383 56.5368 22.2897 56.72C22.1836 56.9282 22.1836 57.2009 22.1836 57.7461V59.4983C22.1836 60.0435 22.1836 60.3161 22.2897 60.5244C22.383 60.7076 22.532 60.8565 22.7151 60.9498Z",
            fill: "url(#paint1_linear_15952_33855)"
          }),
          /* @__PURE__ */ _jsx141("path", {
            d: "M22.7151 72.8845C22.9234 72.9906 23.196 72.9906 23.7412 72.9906H35.6409C36.1861 72.9906 36.4587 72.9906 36.667 72.8845C36.8501 72.7912 36.9991 72.6423 37.0924 72.4591C37.1985 72.2509 37.1985 71.9783 37.1985 71.4331V69.6808C37.1985 69.1356 37.1985 68.863 37.0924 68.6547C36.9991 68.4716 36.8501 68.3226 36.667 68.2293C36.4587 68.1232 36.1861 68.1232 35.6409 68.1232L23.7412 68.1232C23.196 68.1232 22.9234 68.1232 22.7151 68.2293C22.532 68.3226 22.383 68.4716 22.2897 68.6547C22.1836 68.863 22.1836 69.1356 22.1836 69.6808V71.4331C22.1836 71.9783 22.1836 72.2509 22.2897 72.4591C22.383 72.6423 22.532 72.7912 22.7151 72.8845Z",
            fill: "url(#paint2_linear_15952_33855)"
          })
        ]
      }),
      /* @__PURE__ */ _jsx141("path", {
        opacity: "0.5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M70.1548 12.5459C68.0724 11.4849 65.3463 11.4849 59.8943 11.4849H28.4117C22.9597 11.4849 20.2337 11.4849 18.1513 12.5459C16.3195 13.4792 14.8303 14.9685 13.897 16.8002C12.8359 18.8826 12.8359 21.6086 12.8359 27.0607L12.8359 69.8941C12.8359 75.3461 12.8359 78.0721 13.897 80.1545C14.8303 81.9863 16.3195 83.4755 18.1513 84.4088C20.2337 85.4699 22.9597 85.4699 28.4117 85.4699H59.8943C65.3463 85.4699 68.0724 85.4699 70.1548 84.4088C71.9865 83.4755 73.4757 81.9863 74.4091 80.1546C75.4701 78.0722 75.4701 75.3461 75.4701 69.8941V27.0607C75.4701 21.6086 75.4701 18.8826 74.4091 16.8002C73.4757 14.9685 71.9865 13.4792 70.1548 12.5459ZM22.1867 72.0174C22.1867 72.5551 22.6226 72.9909 23.1602 72.9909H36.2281C36.7658 72.9909 37.2016 72.5551 37.2016 72.0174V69.097C37.2016 68.5593 36.7658 68.1235 36.2281 68.1235H23.1602C22.6226 68.1235 22.1867 68.5593 22.1867 69.097V72.0174ZM23.1602 61.0562C22.6226 61.0562 22.1867 60.6203 22.1867 60.0827V57.1622C22.1867 56.6246 22.6226 56.1887 23.1602 56.1887H49.1668C49.7044 56.1887 50.1403 56.6246 50.1403 57.1622V60.0827C50.1403 60.6203 49.7044 61.0562 49.1668 61.0562H23.1602ZM30.9771 22.9481C31.4327 21.9046 32.9115 21.9064 33.3664 22.9481L36.206 29.4515C36.3472 29.7748 36.6523 29.9965 37.0034 30.0308L44.066 30.7218C45.1992 30.8327 45.6545 32.2397 44.8044 32.9942L39.4967 37.7045C39.2329 37.9387 39.1163 38.2973 39.1922 38.6419L40.7175 45.5724C40.9622 46.6844 39.7648 47.5522 38.7845 46.9768L32.6645 43.3845C32.3603 43.2059 31.9832 43.2059 31.6789 43.3845L25.559 46.9768C24.577 47.5532 23.3817 46.6825 23.626 45.5724L25.1513 38.6419C25.2271 38.2973 25.1106 37.9387 24.8467 37.7045L19.5391 32.9942C18.6875 32.2384 19.1461 30.8325 20.2774 30.7218L27.3401 30.0308C27.6912 29.9965 27.9962 29.7748 28.1374 29.4515L30.9771 22.9481Z",
        fill: "url(#paint3_linear_15952_33855)"
      }),
      /* @__PURE__ */ _jsx141("path", {
        opacity: "0.6",
        d: "M83.3385 24.5906C83.7194 24.9714 83.9098 25.1619 84.0632 25.3303C87.4456 29.0451 87.4456 34.7236 84.0632 38.4384C83.9098 38.6068 83.7194 38.7973 83.3385 39.1781L56.4111 66.1055C55.2939 67.2228 54.7352 67.7814 54.1042 68.2374C53.544 68.6423 52.9422 68.9863 52.3091 69.2638C51.596 69.5762 50.8312 69.7742 49.3016 70.1703L41.4104 72.2135C38.8821 72.8681 37.618 73.1954 36.7409 72.8553C35.9756 72.5586 35.3705 71.9535 35.0737 71.1882C34.7336 70.3111 35.061 69.0469 35.7156 66.5187L37.7588 58.6275C38.1548 57.0979 38.3529 56.3331 38.6653 55.62C38.9427 54.9869 39.2868 54.3851 39.6917 53.8249C40.1477 53.1938 40.7063 52.6352 41.8236 51.5179L68.751 24.5906C69.1318 24.2097 69.3222 24.0193 69.4907 23.8659C73.2055 20.4835 78.884 20.4835 82.5987 23.8659C82.7672 24.0193 82.9576 24.2097 83.3385 24.5906Z",
        fill: "url(#paint4_linear_15952_33855)"
      }),
      /* @__PURE__ */ _jsx141("path", {
        opacity: "0.6",
        d: "M79.8063 42.7145L65.2188 28.127L68.7542 24.5915C69.1351 24.2107 69.3255 24.0202 69.494 23.8669C73.2087 20.4845 78.8872 20.4845 82.602 23.8669C82.7705 24.0202 82.9609 24.2107 83.3418 24.5915C83.7226 24.9724 83.913 25.1628 84.0664 25.3313C87.4488 29.0461 87.4488 34.7246 84.0664 38.4393C83.913 38.6078 83.7226 38.7982 83.3418 39.1791L79.8063 42.7145Z",
        fill: "url(#paint5_linear_15952_33855)"
      }),
      /* @__PURE__ */ _jsx141("path", {
        opacity: "0.6",
        d: "M53.7666 68.4718C53.3044 68.777 52.8168 69.0424 52.3091 69.2648C51.596 69.5773 50.8312 69.7753 49.3016 70.1714L41.4104 72.2146C38.8821 72.8692 37.618 73.1965 36.7409 72.8564C35.9756 72.5597 35.3705 71.9546 35.0737 71.1893C34.7336 70.3122 35.061 69.048 35.7156 66.5198L37.7588 58.6286C38.1548 57.099 38.3529 56.3342 38.6653 55.6211C38.8878 55.1133 39.1531 54.6257 39.4583 54.1636L53.7666 68.4718Z",
        fill: "url(#paint6_linear_15952_33855)"
      }),
      /* @__PURE__ */ _jsxs55("defs", {
        children: [
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint0_linear_15952_33855",
            x1: "-7.4949",
            y1: "-28.5099",
            x2: "50.4059",
            y2: "63.5823",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.21"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint1_linear_15952_33855",
            x1: "51.8483",
            y1: "78.4431",
            x2: "-2.95205",
            y2: "64.5896",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint2_linear_15952_33855",
            x1: "51.8483",
            y1: "78.4431",
            x2: "-2.95205",
            y2: "64.5896",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint3_linear_15952_33855",
            x1: "44.153",
            y1: "11.4849",
            x2: "44.153",
            y2: "85.4699",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint4_linear_15952_33855",
            x1: "34.9373",
            y1: "42.262",
            x2: "101.013",
            y2: "42.262",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint5_linear_15952_33855",
            x1: "71.6599",
            y1: "21.6852",
            x2: "90.3172",
            y2: "40.3425",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.57"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs55("linearGradient", {
            id: "paint6_linear_15952_33855",
            x1: "35.0493",
            y1: "58.5714",
            x2: "53.3494",
            y2: "76.8715",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx141("stop", {
                stopColor: "#FCD065"
              }),
              /* @__PURE__ */ _jsx141("stop", {
                offset: "1",
                stopColor: "#E2AF51",
                stopOpacity: "0.57"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Review_default = Review;

// src/shared/ui/icons/shared/Leave.tsx
import { jsx as _jsx142, jsxs as _jsxs56 } from "react/jsx-runtime";
function _define_property138(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread138(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property138(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys129(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props129(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys129(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties117(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose117(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose117(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Leave = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties117(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs56("svg", _object_spread_props129(_object_spread138({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx142("path", {
        opacity: "0.9",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M80.0769 20.1265C80.0769 14.6036 75.5997 10.1265 70.0769 10.1265L25.8008 10.1265C20.2779 10.1265 15.8008 14.6036 15.8008 20.1265L15.8008 76.0806C15.8008 81.6034 20.2779 86.0806 25.8008 86.0806H70.0769C75.5997 86.0806 80.0769 81.6034 80.0769 76.0806V20.1265ZM70.0769 15.1265C72.8383 15.1265 75.0769 17.365 75.0769 20.1265L75.0769 76.0806C75.0769 78.842 72.8383 81.0806 70.0769 81.0806H33.0736C34.8147 80.5299 36.8649 79.7998 39.3412 78.9179L49.7236 75.2206C53.5524 73.857 55.4668 73.1753 56.8797 71.9591C58.1276 70.885 59.0909 69.5193 59.6842 67.9833C60.3559 66.2444 60.3559 64.2122 60.3559 60.1478V36.0586C60.3559 31.9942 60.3559 29.962 59.6842 28.2231C59.0909 26.6871 58.1276 25.3214 56.8797 24.2473C55.4668 23.0311 53.5524 22.3494 49.7236 20.9858L39.3412 17.2885C36.8659 16.407 34.8164 15.6771 33.0757 15.1265L70.0769 15.1265Z",
        fill: "url(#paint0_linear_15952_33881)"
      }),
      /* @__PURE__ */ _jsx142("path", {
        opacity: "0.3",
        d: "M37.5079 63.3326C37.8984 63.7231 38.5315 63.7232 38.9221 63.3326L53.4453 48.8104C53.8359 48.4199 53.8359 47.7867 53.4453 47.3962L38.9222 32.873C38.5317 32.4824 37.8985 32.4824 37.508 32.873L35.3867 34.9943C34.9961 35.3848 34.9961 36.018 35.3867 36.4085L44.5813 45.6032L23.5156 45.6032C22.9633 45.6032 22.5156 46.0509 22.5156 46.6032V49.6032C22.5156 50.1555 22.9633 50.6032 23.5156 50.6032H44.5811L35.3867 59.797C34.9961 60.1875 34.9961 60.8207 35.3866 61.2112L37.5079 63.3326Z",
        fill: "url(#paint1_linear_15952_33881)"
      }),
      /* @__PURE__ */ _jsxs56("defs", {
        children: [
          /* @__PURE__ */ _jsxs56("linearGradient", {
            id: "paint0_linear_15952_33881",
            x1: "47.9388",
            y1: "10.1265",
            x2: "47.9388",
            y2: "86.0806",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx142("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx142("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs56("linearGradient", {
            id: "paint1_linear_15952_33881",
            x1: "38.1269",
            y1: "32.5801",
            x2: "38.1269",
            y2: "63.6255",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx142("stop", {
                stopColor: "#79829A"
              }),
              /* @__PURE__ */ _jsx142("stop", {
                offset: "1",
                stopColor: "#727B8B"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Leave_default = Leave;

// src/shared/ui/icons/shared/Success.tsx
import { jsx as _jsx143, jsxs as _jsxs57 } from "react/jsx-runtime";
function _define_property139(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread139(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property139(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys130(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props130(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys130(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties118(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose118(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose118(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Success = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties118(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs57("svg", _object_spread_props130(_object_spread139({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx143("path", {
        opacity: "0.5",
        d: "M26.9141 55.6739C26.9141 53.4337 26.9141 52.3136 27.35 51.458C27.7335 50.7053 28.3455 50.0934 29.0981 49.7099C29.9537 49.2739 31.0739 49.2739 33.3141 49.2739H62.6881C64.9283 49.2739 66.0484 49.2739 66.904 49.7099C67.6567 50.0934 68.2686 50.7053 68.6521 51.458C69.0881 52.3136 69.0881 53.4337 69.0881 55.6739V80.1507C69.0881 83.2989 69.0881 84.873 68.4262 85.8755C67.8474 86.7523 66.9468 87.3662 65.9191 87.5845C64.744 87.834 63.2789 87.2586 60.3485 86.1078L50.3406 82.1774C49.4759 81.8378 49.0435 81.668 48.5976 81.6007C48.2021 81.5411 47.8 81.5411 47.4045 81.6007C46.9586 81.668 46.5263 81.8378 45.6615 82.1774L35.6536 86.1078C32.7233 87.2586 31.2581 87.834 30.083 87.5845C29.0553 87.3662 28.1548 86.7523 27.5759 85.8755C26.9141 84.873 26.9141 83.2989 26.9141 80.1507V55.6739Z",
        fill: "url(#paint0_linear_15952_33939)"
      }),
      /* @__PURE__ */ _jsx143("path", {
        d: "M41.4199 12.6056C44.7686 8.33851 51.2305 8.33851 54.5791 12.6056C56.5452 15.1109 59.7635 16.2822 62.88 15.6268C68.188 14.5105 73.1381 18.6642 72.9605 24.0854C72.8562 27.2683 74.5686 30.2343 77.3773 31.7355C82.161 34.2923 83.2831 40.656 79.6623 44.6947C77.5365 47.066 76.9418 50.4388 78.1284 53.3941C80.1494 58.4276 76.9185 64.0238 71.5488 64.7903C68.3961 65.2403 65.7725 67.4417 64.7819 70.4684C63.0946 75.6234 57.0224 77.8335 52.4163 74.9691C49.7119 73.2873 46.2871 73.2873 43.5827 74.9691C38.9766 77.8335 32.9045 75.6234 31.2172 70.4684C30.2265 67.4417 27.603 65.2403 24.4503 64.7903C19.0806 64.0238 15.8496 58.4276 17.8707 53.3941C19.0573 50.4388 18.4626 47.066 16.3367 44.6947C12.716 40.656 13.8381 34.2923 18.6218 31.7355C21.4305 30.2343 23.1429 27.2683 23.0386 24.0854C22.861 18.6642 27.8111 14.5105 33.1191 15.6268C36.2356 16.2822 39.4539 15.1109 41.4199 12.6056Z",
        fill: "url(#paint1_linear_15952_33939)"
      }),
      /* @__PURE__ */ _jsx143("path", {
        opacity: "0.45",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M47.9987 67.1542C61.0091 67.1542 71.556 56.6072 71.556 43.5969C71.556 30.5865 61.0091 20.0396 47.9987 20.0396C34.9884 20.0396 24.4414 30.5865 24.4414 43.5969C24.4414 56.6072 34.9884 67.1542 47.9987 67.1542ZM61.677 38.1904C62.0675 37.7999 62.0675 37.1667 61.677 36.7762L58.8485 33.9478C58.458 33.5572 57.8249 33.5572 57.4343 33.9478L45.5704 45.8116L38.5606 38.8014C38.1701 38.4109 37.537 38.4108 37.1464 38.8013L34.3179 41.6297C33.9274 42.0202 33.9273 42.6533 34.3179 43.0439L44.8631 53.5899C45.2537 53.9804 45.8868 53.9805 46.2774 53.5899L61.677 38.1904Z",
        fill: "url(#paint2_linear_15952_33939)"
      }),
      /* @__PURE__ */ _jsx143("path", {
        opacity: "0.3",
        d: "M61.6793 36.7761C62.0698 37.1666 62.0698 37.7998 61.6793 38.1903L46.2797 53.5898C45.8892 53.9804 45.256 53.9804 44.8655 53.5898L34.3202 43.0438C33.9297 42.6532 33.9297 42.0201 34.3203 41.6296L37.1488 38.8012C37.5393 38.4107 38.1725 38.4108 38.563 38.8013L45.5728 45.8115L57.4367 33.9477C57.8272 33.5572 58.4604 33.5572 58.8509 33.9477L61.6793 36.7761Z",
        fill: "url(#paint3_linear_15952_33939)"
      }),
      /* @__PURE__ */ _jsxs57("defs", {
        children: [
          /* @__PURE__ */ _jsxs57("linearGradient", {
            id: "paint0_linear_15952_33939",
            x1: "69.0875",
            y1: "96.3896",
            x2: "57.2356",
            y2: "60.5256",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx143("stop", {
                stopColor: "#6CB089"
              }),
              /* @__PURE__ */ _jsx143("stop", {
                offset: "1",
                stopColor: "#214A31"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs57("linearGradient", {
            id: "paint1_linear_15952_33939",
            x1: "47.8861",
            y1: "88.443",
            x2: "23.1558",
            y2: "5.14511",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx143("stop", {
                stopColor: "#397250"
              }),
              /* @__PURE__ */ _jsx143("stop", {
                offset: "1",
                stopColor: "#193D28"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs57("linearGradient", {
            id: "paint2_linear_15952_33939",
            x1: "67.4779",
            y1: "56.9176",
            x2: "28.8016",
            y2: "25.2178",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx143("stop", {
                stopColor: "#6EDF99"
              }),
              /* @__PURE__ */ _jsx143("stop", {
                offset: "1",
                stopColor: "#499967",
                stopOpacity: "0.66"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs57("linearGradient", {
            id: "paint3_linear_15952_33939",
            x1: "47.9998",
            y1: "33.6548",
            x2: "47.9998",
            y2: "53.8827",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx143("stop", {
                stopColor: "#585F71"
              }),
              /* @__PURE__ */ _jsx143("stop", {
                offset: "1",
                stopColor: "#2A323A"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Success_default = Success;

// src/shared/ui/icons/shared/Attach.tsx
import { jsx as _jsx144, jsxs as _jsxs58 } from "react/jsx-runtime";
import React81 from "react";
function _define_property140(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread140(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property140(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys131(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props131(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys131(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties119(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose119(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose119(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Attach = (_param) => {
  var { width: width2 = 32, height: height2 = 32, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties119(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs58("svg", _object_spread_props131(_object_spread140({
    width: width2,
    height: height2,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx144("g", {
        clipPath: "url(#clip0_2263_23014)",
        children: /* @__PURE__ */ _jsx144("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.2428 26.1521C20.3468 29.256 25.2791 29.3144 28.3104 26.283C31.4026 23.1908 31.3359 18.0724 28.1623 14.9138L19.6044 6.39638C19.1211 5.91533 18.3483 5.93194 17.9085 6.43283C17.4954 6.90322 17.5301 7.62879 17.9871 8.07731L26.6311 16.5608C28.9026 18.8125 28.954 22.47 26.7451 24.6789C24.5828 26.8412 21.0645 26.7996 18.8503 24.5854L7.34534 13.0804C5.9898 11.7249 5.96388 9.53442 7.2877 8.2106C8.58771 6.91058 10.703 6.93561 12.0341 8.26677L23.6143 19.8469C24.0611 20.2936 24.0696 21.0155 23.6333 21.4518C23.206 21.8791 22.511 21.8722 22.072 21.4361L13.2228 12.5097C12.7336 12.0163 11.9419 12.0439 11.5111 12.5693C11.1287 13.0357 11.171 13.73 11.6084 14.1647L20.4974 23.0008C21.8209 24.3163 23.9167 24.3379 25.2054 23.0492C26.5205 21.734 26.4948 19.5579 25.1481 18.2112L13.64 6.70322C11.4201 4.48336 7.89271 4.44161 5.72477 6.60953C3.51709 8.8172 3.56034 12.4701 5.82094 14.7307L17.2428 26.1521Z",
          fill
        })
      }),
      /* @__PURE__ */ _jsx144("defs", {
        children: /* @__PURE__ */ _jsx144("clipPath", {
          id: "clip0_2263_23014",
          children: /* @__PURE__ */ _jsx144("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0.951294 0.150391)"
          })
        })
      })
    ]
  }));
};
var Attach_default = /* @__PURE__ */ React81.memo(Attach);

// src/shared/ui/icons/shared/Document.tsx
import { jsx as _jsx145 } from "react/jsx-runtime";
import React82 from "react";
function _define_property141(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread141(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property141(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys132(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props132(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys132(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties120(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose120(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose120(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Document = (_param) => {
  var { width: width2 = 32, height: height2 = 33, fill = getCssVar("grey", 500) } = _param, props = _object_without_properties120(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsx145("svg", _object_spread_props132(_object_spread141({
    width: width2,
    height: height2,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ _jsx145("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.67206 3.21876C7.0211 3.21877 4.87207 5.3678 4.87207 8.01876V24.1356C4.87207 26.7866 7.02111 28.9356 9.67208 28.9356H22.3279C24.9789 28.9356 27.1279 26.7866 27.1279 24.1356V13.7336C27.1279 12.4845 26.6411 11.2847 25.7707 10.3888L20.2186 4.674C19.3147 3.74368 18.0729 3.21875 16.7758 3.21875L9.67206 3.21876ZM17.5809 6.84313C17.5809 6.35953 18.0698 6.03411 18.4161 6.37165L18.4405 6.39572L23.7707 11.7218C24.0967 12.0491 23.8348 12.5208 23.3729 12.5208H18.2809C17.8943 12.5208 17.5809 12.2074 17.5809 11.8208V6.84313Z",
      fill
    })
  }));
};
var Document_default = /* @__PURE__ */ React82.memo(Document);

// src/shared/ui/icons/shared/AccessDenied.tsx
import { jsx as _jsx146, jsxs as _jsxs59 } from "react/jsx-runtime";
import React83 from "react";
function _define_property142(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread142(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property142(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys133(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props133(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys133(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties121(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose121(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose121(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var AccessDenied = (_param) => {
  var { width: width2 = 96, height: height2 = 96, fill = getCssVar("grey", 950) } = _param, props = _object_without_properties121(_param, [
    "width",
    "height",
    "fill"
  ]);
  return /* @__PURE__ */ _jsxs59("svg", _object_spread_props133(_object_spread142({
    xmlns: "http://www.w3.org/2000/svg",
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx146("path", {
        d: "M12.998 29.998C12.998 24.3975 12.998 21.5973 14.088 19.4581C15.0467 17.5765 16.5765 16.0467 18.4581 15.088C20.5973 13.998 23.3975 13.998 28.998 13.998H58.8863C64.4869 13.998 67.2871 13.998 69.4262 15.088C71.3079 16.0467 72.8377 17.5765 73.7964 19.4581C74.8863 21.5973 74.8863 24.3975 74.8863 29.998V59.8863C74.8863 65.4869 74.8863 68.2871 73.7964 70.4262C72.8377 72.3079 71.3079 73.8377 69.4262 74.7964C67.2871 75.8863 64.4869 75.8863 58.8863 75.8863H28.998C23.3975 75.8863 20.5973 75.8863 18.4581 74.7964C16.5765 73.8377 15.0467 72.3079 14.088 70.4262C12.998 68.2871 12.998 65.4869 12.998 59.8863V29.998Z",
        fill: "url(#paint0_linear_29770_2572)"
      }),
      /* @__PURE__ */ _jsx146("path", {
        opacity: "0.45",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M46.6926 30.7177C46.6926 31.27 47.1403 31.7177 47.6926 31.7177L74.886 31.7177L74.886 37.2177L64.6799 37.2177C64.1276 37.2177 63.6799 37.6654 63.6799 38.2177L63.6799 51.6668C63.6799 52.2191 64.1276 52.6668 64.6799 52.6668L74.886 52.6668L74.886 58.1668L47.6926 58.1668C47.1404 58.1668 46.6926 58.6145 46.6926 59.1668L46.6926 75.8864L41.1926 75.8864L41.1926 59.1668C41.1926 58.6145 40.7449 58.1668 40.1926 58.1668L12.998 58.1667L12.9981 52.6667L23.2035 52.6667C23.7558 52.6667 24.2035 52.219 24.2035 51.6667L24.2035 38.2177C24.2035 37.6654 23.7558 37.2177 23.2035 37.2177L12.998 37.2177L12.9981 31.7177L40.1926 31.7177C40.7449 31.7177 41.1926 31.27 41.1926 30.7177L41.1926 13.998L46.6926 13.9981L46.6926 30.7177ZM29.7035 51.6668C29.7035 52.219 30.1512 52.6668 30.7035 52.6668L57.1799 52.6668C57.7322 52.6668 58.1799 52.2191 58.1799 51.6668L58.1799 38.2177C58.1799 37.6654 57.7322 37.2177 57.1799 37.2177L30.7035 37.2177C30.1512 37.2177 29.7035 37.6654 29.7035 38.2177L29.7035 51.6668Z",
        fill: "url(#paint1_linear_29770_2572)"
      }),
      /* @__PURE__ */ _jsx146("path", {
        d: "M47.1859 49.4265C47.2775 48.6383 47.8501 47.9921 48.6178 47.7915C50.8647 47.2044 55.8068 45.8139 61.3065 43.6339C62.6743 43.0917 64.3831 42.075 65.4699 41.3905C66.1251 40.9778 66.9665 40.9797 67.6209 41.3934C68.697 42.0738 70.3905 43.0814 71.7947 43.6339C77.6719 45.9462 82.1845 47.2438 84.2721 47.794C85.0349 47.9951 85.6128 48.6329 85.7144 49.4152L87.3464 61.9873C88.6274 71.855 83.7967 81.5138 75.133 86.4078L67.4609 90.7417C66.8846 91.0672 66.1796 91.0657 65.6048 90.7376L57.8541 86.3147C49.349 81.4613 44.5629 71.999 45.6932 62.272L47.1859 49.4265Z",
        fill: "url(#paint2_linear_29770_2572)"
      }),
      /* @__PURE__ */ _jsx146("path", {
        opacity: "0.7",
        d: "M47.1859 49.4265C47.2775 48.6383 47.8501 47.9921 48.6178 47.7915C50.8647 47.2044 55.8068 45.8139 61.3065 43.6339C62.6743 43.0917 64.3831 42.075 65.4699 41.3905C66.1251 40.9778 66.9665 40.9797 67.6209 41.3934C68.697 42.0738 70.3905 43.0814 71.7947 43.6339C77.6719 45.9462 82.1845 47.2438 84.2721 47.794C85.0349 47.9951 85.6128 48.6329 85.7144 49.4152L87.3464 61.9873C88.6274 71.855 83.7967 81.5138 75.133 86.4078L67.4609 90.7417C66.8846 91.0672 66.1796 91.0657 65.6048 90.7376L57.8541 86.3147C49.349 81.4613 44.5629 71.999 45.6932 62.272L47.1859 49.4265Z",
        fill: "url(#paint3_linear_29770_2572)"
      }),
      /* @__PURE__ */ _jsx146("path", {
        d: "M79.2802 57.9821C79.6763 58.3782 79.8743 58.5762 79.9484 58.8045C80.0137 59.0053 80.0137 59.2217 79.9484 59.4225C79.8743 59.6509 79.6762 59.8489 79.2802 60.2449L64.8325 74.6925C64.4365 75.0886 64.2385 75.2866 64.0101 75.3608C63.8093 75.426 63.5929 75.426 63.3921 75.3608C63.1637 75.2866 62.9657 75.0885 62.5697 74.6925L53.0589 65.181C52.6629 64.785 52.4649 64.587 52.3907 64.3587C52.3255 64.1578 52.3255 63.9415 52.3908 63.7406C52.4649 63.5123 52.663 63.3143 53.059 62.9183L54.3318 61.6456C54.7279 61.2496 54.9259 61.0515 55.1542 60.9774C55.3551 60.9121 55.5714 60.9121 55.7722 60.9774C56.0006 61.0516 56.1986 61.2496 56.5946 61.6456L63.7012 68.7528L75.7447 56.7093C76.1407 56.3133 76.3387 56.1153 76.5671 56.0411C76.7679 55.9759 76.9842 55.9759 77.1851 56.0411C77.4134 56.1153 77.6114 56.3133 78.0074 56.7093L79.2802 57.9821Z",
        fill: "url(#paint4_linear_29770_2572)"
      }),
      /* @__PURE__ */ _jsxs59("defs", {
        children: [
          /* @__PURE__ */ _jsxs59("linearGradient", {
            id: "paint0_linear_29770_2572",
            x1: "9.59577",
            y1: "141.81",
            x2: "74.8861",
            y2: "10.8768",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx146("stop", {
                "stop-color": "#585F71"
              }),
              /* @__PURE__ */ _jsx146("stop", {
                offset: "1",
                "stop-color": "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs59("linearGradient", {
            id: "paint1_linear_29770_2572",
            x1: "12.998",
            y1: "13.9971",
            x2: "74.8867",
            y2: "71.3958",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx146("stop", {
                "stop-color": "#99A1B5"
              }),
              /* @__PURE__ */ _jsx146("stop", {
                offset: "1",
                "stop-color": "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs59("linearGradient", {
            id: "paint2_linear_29770_2572",
            x1: "47.7686",
            y1: "44.3688",
            x2: "78.5568",
            y2: "84.287",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx146("stop", {
                "stop-color": "#585F71"
              }),
              /* @__PURE__ */ _jsx146("stop", {
                offset: "1",
                "stop-color": "#2A323A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs59("linearGradient", {
            id: "paint3_linear_29770_2572",
            x1: "20.6711",
            y1: "22.5148",
            x2: "91.6441",
            y2: "78.5353",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx146("stop", {
                "stop-color": "#C0C9DD"
              }),
              /* @__PURE__ */ _jsx146("stop", {
                offset: "1",
                "stop-color": "#495462"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs59("linearGradient", {
            id: "paint4_linear_29770_2572",
            x1: "58.9568",
            y1: "53.3361",
            x2: "77.202",
            y2: "75.4097",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx146("stop", {
                "stop-color": "#585F71"
              }),
              /* @__PURE__ */ _jsx146("stop", {
                offset: "1",
                "stop-color": "#2A323A"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var AccessDenied_default = /* @__PURE__ */ React83.memo(AccessDenied);

// src/shared/ui/icons/emoji/AstonishedFace.tsx
import { jsx as _jsx147, jsxs as _jsxs60 } from "react/jsx-runtime";
function _define_property143(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread143(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property143(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys134(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props134(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys134(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties122(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose122(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose122(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var AstonishedFace = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties122(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs60("svg", _object_spread_props134(_object_spread143({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx147("path", {
        d: "M24 43.2008C34.6039 43.2008 43.2 34.6046 43.2 24.0008C43.2 13.3969 34.6039 4.80078 24 4.80078C13.3961 4.80078 4.79999 13.3969 4.79999 24.0008C4.79999 34.6046 13.3961 43.2008 24 43.2008Z",
        fill: "url(#paint0_radial_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        opacity: "0.5",
        d: "M24 43.2008C34.6039 43.2008 43.2 34.6046 43.2 24.0008C43.2 13.3969 34.6039 4.80078 24 4.80078C13.3961 4.80078 4.79999 13.3969 4.79999 24.0008C4.79999 34.6046 13.3961 43.2008 24 43.2008Z",
        fill: "url(#paint1_radial_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M17.731 24.8227C18.7519 24.8227 19.5796 23.5713 19.5796 22.0276C19.5796 20.4839 18.7519 19.2324 17.731 19.2324C16.7101 19.2324 15.8824 20.4839 15.8824 22.0276C15.8824 23.5713 16.7101 24.8227 17.731 24.8227Z",
        fill: "url(#paint2_radial_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M17.731 20.179C18.5258 20.179 19.2134 20.8667 19.5796 21.8936C19.5528 20.3844 18.7401 19.1699 17.731 19.1699C16.7219 19.1699 15.9092 20.3844 15.8824 21.8936C16.2486 20.8667 16.9362 20.179 17.731 20.179Z",
        fill: "url(#paint3_linear_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M30.2691 24.8227C31.29 24.8227 32.1176 23.5713 32.1176 22.0276C32.1176 20.4839 31.29 19.2324 30.2691 19.2324C29.2482 19.2324 28.4205 20.4839 28.4205 22.0276C28.4205 23.5713 29.2482 24.8227 30.2691 24.8227Z",
        fill: "url(#paint4_radial_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M30.2691 20.2415C29.4743 20.2415 28.7867 20.9292 28.4205 21.9561C28.4473 20.4469 29.26 19.2324 30.2691 19.2324C31.2782 19.2324 32.0909 20.4469 32.1176 21.9561C31.7515 20.9381 31.0639 20.2415 30.2691 20.2415Z",
        fill: "url(#paint5_linear_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M28.2597 13.83C28.3044 13.062 29.1617 12.6244 30.5905 12.7048C31.805 12.7762 34.4305 13.5888 36.1362 16.0536C36.4487 16.509 35.9129 16.7144 35.6004 16.4197C34.5287 15.4017 31.5728 13.9996 29.1974 14.1157C28.2329 14.1693 28.2597 13.83 28.2597 13.83Z",
        fill: "url(#paint6_linear_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M19.7402 13.83C19.6956 13.062 18.8383 12.6244 17.4095 12.7048C16.1949 12.7762 13.5695 13.5888 11.8638 16.0536C11.5512 16.509 12.087 16.7144 12.3996 16.4197C13.4712 15.4017 16.4271 13.9996 18.8026 14.1157C19.767 14.1693 19.7402 13.83 19.7402 13.83Z",
        fill: "url(#paint7_linear_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M23.9999 39.3785C26.3969 39.3785 28.34 36.7837 28.34 33.5828C28.34 30.3819 26.3969 27.7871 23.9999 27.7871C21.603 27.7871 19.6599 30.3819 19.6599 33.5828C19.6599 36.7837 21.603 39.3785 23.9999 39.3785Z",
        fill: "url(#paint8_radial_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M24 29.5821C25.8753 29.5821 27.5006 30.9841 28.3222 33.0381C28.1168 30.0911 26.2593 27.7871 24 27.7871C21.7406 27.7871 19.8831 30.0911 19.6777 33.0381C20.4993 30.9841 22.1246 29.5821 24 29.5821Z",
        fill: "url(#paint9_linear_5994_44772)"
      }),
      /* @__PURE__ */ _jsx147("path", {
        d: "M23.9999 32.1276C25.1519 32.1276 26.2414 31.949 27.2237 31.6454C26.6879 29.8683 25.4466 28.627 23.9999 28.627C22.5532 28.627 21.3119 29.8772 20.7761 31.6454C21.7584 31.9579 22.8479 32.1276 23.9999 32.1276Z",
        fill: "url(#paint10_radial_5994_44772)"
      }),
      /* @__PURE__ */ _jsxs60("defs", {
        children: [
          /* @__PURE__ */ _jsxs60("radialGradient", {
            id: "paint0_radial_5994_44772",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.2223 16.2197) scale(23.1623)",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                stopColor: "#FFDF30"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#FFB82E"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("radialGradient", {
            id: "paint1_radial_5994_44772",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.2223 16.2197) scale(18.2228)",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                stopColor: "#FFE95F"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#FFBB47",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("radialGradient", {
            id: "paint2_radial_5994_44772",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(17.1706 22.0949) rotate(73.8539) scale(2.71282 1.75515)",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("linearGradient", {
            id: "paint3_linear_5994_44772",
            x1: "17.7315",
            y1: "19.2144",
            x2: "17.7315",
            y2: "21.8201",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("radialGradient", {
            id: "paint4_radial_5994_44772",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(29.7083 22.0953) rotate(73.8539) scale(2.71282 1.75515)",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("linearGradient", {
            id: "paint5_linear_5994_44772",
            x1: "30.2686",
            y1: "19.2829",
            x2: "30.2686",
            y2: "21.8886",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("linearGradient", {
            id: "paint6_linear_5994_44772",
            x1: "32.2245",
            y1: "15.3371",
            x2: "32.338",
            y2: "13.3172",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#7A4400"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("linearGradient", {
            id: "paint7_linear_5994_44772",
            x1: "15.7813",
            y1: "15.3376",
            x2: "15.6678",
            y2: "13.3177",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#7A4400"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("radialGradient", {
            id: "paint8_radial_5994_44772",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.7346 33.926) rotate(77.7577) scale(6.90683 3.4667)",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("linearGradient", {
            id: "paint9_linear_5994_44772",
            x1: "24",
            y1: "25.0598",
            x2: "24",
            y2: "34.5062",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs60("radialGradient", {
            id: "paint10_radial_5994_44772",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.9998 30.3804) rotate(0.231607) scale(6.55304 4.61858)",
            children: [
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.00132565",
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.4312",
                stopColor: "#D3DCDD"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "0.7963",
                stopColor: "#B4C4C6"
              }),
              /* @__PURE__ */ _jsx147("stop", {
                offset: "1",
                stopColor: "#A8BBBD"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var AstonishedFace_default = AstonishedFace;

// src/shared/ui/icons/emoji/TearsOfJoy.tsx
import { jsx as _jsx148, jsxs as _jsxs61 } from "react/jsx-runtime";
function _define_property144(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread144(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property144(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys135(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props135(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys135(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties123(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose123(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose123(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var TearsOfJoy = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties123(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs61("svg", _object_spread_props135(_object_spread144({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx148("path", {
        d: "M24.084 43.2008C34.6879 43.2008 43.284 34.6046 43.284 24.0008C43.284 13.3969 34.6879 4.80078 24.084 4.80078C13.4802 4.80078 4.88403 13.3969 4.88403 24.0008C4.88403 34.6046 13.4802 43.2008 24.084 43.2008Z",
        fill: "url(#paint0_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        opacity: "0.5",
        d: "M24.084 43.2008C34.6879 43.2008 43.284 34.6046 43.284 24.0008C43.284 13.3969 34.6879 4.80078 24.084 4.80078C13.4802 4.80078 4.88403 13.3969 4.88403 24.0008C4.88403 34.6046 13.4802 43.2008 24.084 43.2008Z",
        fill: "url(#paint1_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M30.2161 15.3367C30.3481 14.5807 31.2481 14.2447 32.6521 14.4847C33.8521 14.6887 36.3721 15.8047 37.7881 18.4447C38.0521 18.9367 37.4881 19.0807 37.2121 18.7447C36.2641 17.6047 33.4801 15.8767 31.1041 15.7327C30.1441 15.6727 30.2161 15.3367 30.2161 15.3367Z",
        fill: "url(#paint2_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M32.2802 19.4774C32.2802 19.4774 35.6282 19.8134 36.5642 22.3454C36.6242 22.5014 36.6602 22.6694 36.6482 22.8374C36.6482 23.1734 36.3362 23.5334 35.7362 23.2094C32.0642 21.1814 29.9402 22.1414 28.3562 22.8014C27.7442 23.0654 27.1922 22.4414 27.3842 21.8894C27.4322 21.7334 27.4802 21.5654 27.5642 21.4214C28.9442 19.1174 32.2802 19.4774 32.2802 19.4774Z",
        fill: "url(#paint3_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M32.2081 20.2694C32.2081 20.2694 34.9321 20.5454 36.6361 22.6334C36.6241 22.5374 36.6001 22.4414 36.5641 22.3454C35.6281 19.8134 32.2802 19.4774 32.2802 19.4774C32.2802 19.4774 28.9322 19.1174 27.5642 21.4214C27.5162 21.5054 27.4682 21.6014 27.4442 21.6974C29.4842 19.9814 32.2081 20.2694 32.2081 20.2694Z",
        fill: "url(#paint4_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M37.044 27.2528C36.9 27.1928 36.744 27.1928 36.6 27.2288C32.544 28.3808 28.344 28.9688 24.084 28.9688C19.836 28.9688 15.624 28.3808 11.568 27.2288C11.424 27.1808 11.268 27.1928 11.124 27.2528C10.68 27.4328 9.99598 28.0928 10.908 30.6248C12.288 33.8528 15.876 39.5288 24.096 39.5288C32.28 39.5288 35.892 33.8408 37.272 30.6128C38.172 28.0928 37.488 27.4328 37.044 27.2528Z",
        fill: "url(#paint5_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M17.9521 15.3367C17.8201 14.5807 16.92 14.2447 15.516 14.4847C14.316 14.6887 11.7961 15.8047 10.3801 18.4447C10.1161 18.9367 10.68 19.0807 10.956 18.7447C11.904 17.6047 14.6881 15.8767 17.0641 15.7327C18.0121 15.6727 17.9521 15.3367 17.9521 15.3367Z",
        fill: "url(#paint6_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M15.8759 19.4774C15.8759 19.4774 12.5279 19.8134 11.5919 22.3454C11.5319 22.5014 11.4959 22.6694 11.5079 22.8374C11.5079 23.1734 11.8199 23.5334 12.4199 23.2094C16.0919 21.1814 18.2159 22.1414 19.7999 22.8014C20.4119 23.0654 20.9639 22.4414 20.7719 21.8894C20.7239 21.7334 20.6759 21.5654 20.5919 21.4214C19.2239 19.1174 15.8759 19.4774 15.8759 19.4774Z",
        fill: "url(#paint7_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M15.9479 20.2694C15.9479 20.2694 13.224 20.5454 11.52 22.6334C11.532 22.5374 11.556 22.4414 11.592 22.3454C12.528 19.8134 15.8759 19.4774 15.8759 19.4774C15.8759 19.4774 19.224 19.1174 20.592 21.4214C20.64 21.5054 20.688 21.6014 20.712 21.6974C18.672 19.9814 15.9479 20.2694 15.9479 20.2694Z",
        fill: "url(#paint8_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M9.45608 30.9603C9.52808 33.4803 7.26008 34.9203 5.32808 34.5843C3.40808 34.2483 1.88409 32.3283 2.58009 30.0243C4.17609 24.7683 11.2801 23.8203 11.2801 23.8203C11.2801 23.8203 9.36008 27.5643 9.45608 30.9603Z",
        fill: "url(#paint9_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M6.91209 30.48C5.38809 32.436 2.01609 31.344 3.07209 28.836C2.88009 29.208 2.71209 29.604 2.58009 30.036C1.88409 32.34 3.40808 34.272 5.32808 34.596C7.24808 34.932 9.51608 33.492 9.45608 30.972C9.37208 27.576 11.2801 23.832 11.2801 23.832C7.42809 27.672 7.65609 29.52 6.91209 30.48Z",
        fill: "url(#paint10_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M8.79597 29.3043C8.07597 33.3723 3.20397 33.3123 2.44797 30.5763C2.12397 32.6283 3.55197 34.2843 5.32797 34.5843C7.24797 34.9203 9.51597 33.4803 9.45597 30.9603C9.37197 27.5643 11.28 23.8203 11.28 23.8203C11.28 23.8203 9.38397 25.9683 8.79597 29.3043Z",
        fill: "url(#paint11_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M8.11202 31.668C6.36002 34.284 3.22802 33.084 2.40002 31.152C2.40002 32.04 2.73602 32.832 3.26402 33.444C6.36002 35.82 9.36002 32.844 9.44402 31.116C9.44402 31.068 9.44402 31.02 9.44402 30.972C9.44402 30.912 9.44402 30.852 9.44402 30.78C9.43202 27.432 11.268 23.832 11.268 23.832C8.58001 27.696 10.26 28.464 8.11202 31.668Z",
        fill: "url(#paint12_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        opacity: "0.75",
        d: "M11.2801 23.8203C11.2801 23.8203 6.20407 26.4003 5.76007 28.8483C5.31607 31.2963 2.94007 30.1923 3.48007 28.8843C4.44007 26.5923 8.28007 24.4203 11.2801 23.8203Z",
        fill: "url(#paint13_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M24.084 38.6417C27.48 38.6417 30.036 37.5977 31.944 36.1697C29.844 35.2217 27.264 34.5977 24.084 34.5977C20.904 34.5977 18.312 35.2217 16.212 36.1697C18.12 37.5977 20.676 38.6417 24.084 38.6417Z",
        fill: "url(#paint14_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M38.7121 30.9603C38.6401 33.4803 40.9081 34.9203 42.8401 34.5843C44.7601 34.2483 46.2841 32.3283 45.5881 30.0243C43.9921 24.7683 36.8881 23.8203 36.8881 23.8203C36.8881 23.8203 38.7961 27.5643 38.7121 30.9603Z",
        fill: "url(#paint15_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M41.2561 30.48C42.7801 32.436 46.1521 31.344 45.0961 28.836C45.2881 29.208 45.4561 29.604 45.5881 30.036C46.2841 32.34 44.7601 34.272 42.8401 34.596C40.9201 34.932 38.6521 33.492 38.7121 30.972C38.7961 27.576 36.8881 23.832 36.8881 23.832C40.7281 27.672 40.5001 29.52 41.2561 30.48Z",
        fill: "url(#paint16_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M39.3601 29.3043C40.0801 33.3723 44.9521 33.3123 45.7081 30.5763C46.0321 32.6283 44.6041 34.2843 42.8281 34.5843C40.9081 34.9203 38.6401 33.4803 38.7001 30.9603C38.7841 27.5643 36.8761 23.8203 36.8761 23.8203C36.8761 23.8203 38.7721 25.9683 39.3601 29.3043Z",
        fill: "url(#paint17_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M40.0441 31.668C41.7961 34.284 44.9281 33.084 45.7561 31.152C45.7561 32.04 45.4201 32.832 44.8921 33.444C41.7961 35.82 38.7961 32.844 38.7121 31.116C38.7121 31.068 38.7121 31.02 38.7121 30.972C38.7121 30.912 38.7121 30.852 38.7121 30.78C38.7241 27.432 36.8881 23.832 36.8881 23.832C39.5881 27.696 37.9081 28.464 40.0441 31.668Z",
        fill: "url(#paint18_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        opacity: "0.75",
        d: "M36.8881 23.8203C36.8881 23.8203 41.9641 26.4003 42.4081 28.8483C42.8521 31.2843 45.2281 30.1923 44.6881 28.8843C43.7281 26.5923 39.8881 24.4203 36.8881 23.8203Z",
        fill: "url(#paint19_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M11.448 27.2054C11.424 27.1934 11.388 27.1934 11.364 27.1934C11.088 27.2174 9.76804 27.4934 10.896 30.6254C11.448 31.9334 12.372 33.6254 13.812 35.1974C12.468 33.6014 14.124 32.7134 17.088 33.0734C20.052 33.4334 24.084 33.4334 24.084 33.4334V28.9694C19.788 28.9814 15.54 28.3814 11.448 27.2054Z",
        fill: "url(#paint20_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M36.7079 27.2054C36.7319 27.1934 36.768 27.1934 36.792 27.1934C37.068 27.2174 38.388 27.4934 37.26 30.6254C36.708 31.9334 35.784 33.6254 34.344 35.1974C35.688 33.6014 34.0319 32.7134 31.0679 33.0734C28.1039 33.4334 24.072 33.4334 24.072 33.4334V28.9694C28.368 28.9814 32.6159 28.3814 36.7079 27.2054Z",
        fill: "url(#paint21_linear_5994_44776)"
      }),
      /* @__PURE__ */ _jsx148("path", {
        d: "M35.4839 31.3686C36.0359 31.2366 36.4559 30.7686 36.5039 30.1926L36.7079 28.1406C32.6159 29.2926 28.3799 29.8806 24.084 29.8806C19.8 29.8806 15.552 29.2926 11.46 28.1406L11.664 30.1926C11.724 30.7566 12.132 31.2366 12.684 31.3686C16.404 32.2566 20.232 32.7006 24.084 32.7006C27.936 32.7006 31.764 32.2566 35.4839 31.3686Z",
        fill: "url(#paint22_radial_5994_44776)"
      }),
      /* @__PURE__ */ _jsxs61("defs", {
        children: [
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint0_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.3035 16.2224) scale(23.1623 23.1623)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                stopColor: "#FFE030"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#FFB92E"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint1_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.3035 16.2224) scale(18.2228 18.2228)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                stopColor: "#FFEA5F"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint2_linear_5994_44776",
            x1: "33.9795",
            y1: "17.2916",
            x2: "34.3212",
            y2: "15.2975",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#7A4400"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint3_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(32.093 21.3716) rotate(5.868) scale(3.61881 1.74596)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint4_linear_5994_44776",
            x1: "32.4001",
            y1: "18.4215",
            x2: "32.1744",
            y2: "20.7487",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint5_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(24.0812 33.3747) scale(10.5769 10.5769)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint6_linear_5994_44776",
            x1: "14.1619",
            y1: "17.2761",
            x2: "13.8202",
            y2: "15.2821",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#7A4400"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint7_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.0293 21.3723) rotate(174.132) scale(3.61881 1.74596)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint8_linear_5994_44776",
            x1: "15.741",
            y1: "18.4194",
            x2: "15.9667",
            y2: "20.7466",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint9_linear_5994_44776",
            x1: "2.7292",
            y1: "23.9909",
            x2: "10.9492",
            y2: "32.3909",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.0723628",
                stopColor: "#17BBFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.2085",
                stopColor: "#D1F2FF"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.668",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint10_linear_5994_44776",
            x1: "12.942",
            y1: "36.5122",
            x2: "2.62202",
            y2: "22.1922",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                stopColor: "#D1F2FF"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.668",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint11_linear_5994_44776",
            x1: "4.85131",
            y1: "22.3128",
            x2: "10.0113",
            y2: "36.5328",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.566",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint12_linear_5994_44776",
            x1: "5.45284",
            y1: "23.002",
            x2: "9.13286",
            y2: "35.5619",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.566",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint13_linear_5994_44776",
            x1: "6.55234",
            y1: "32.3981",
            x2: "8.23233",
            y2: "19.7982",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#80DAFE"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint14_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(24.2395 37.0942) scale(8.76595 2.64996)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.2479",
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#C20000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint15_linear_5994_44776",
            x1: "45.4333",
            y1: "23.9909",
            x2: "37.2133",
            y2: "32.3909",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.0723628",
                stopColor: "#17BBFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.2085",
                stopColor: "#D1F2FF"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.668",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint16_linear_5994_44776",
            x1: "35.2204",
            y1: "36.5122",
            x2: "45.5404",
            y2: "22.1922",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                stopColor: "#D1F2FF"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.668",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint17_linear_5994_44776",
            x1: "43.3111",
            y1: "22.3128",
            x2: "38.1511",
            y2: "36.5328",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.566",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint18_linear_5994_44776",
            x1: "42.7095",
            y1: "23.002",
            x2: "39.0296",
            y2: "35.562",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.566",
                stopColor: "#80DAFE"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#0099D6"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint19_linear_5994_44776",
            x1: "41.6101",
            y1: "32.3982",
            x2: "39.9301",
            y2: "19.7982",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#80DAFE"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint20_linear_5994_44776",
            x1: "10.4519",
            y1: "31.201",
            x2: "24.0812",
            y2: "31.201",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("linearGradient", {
            id: "paint21_linear_5994_44776",
            x1: "37.7071",
            y1: "31.201",
            x2: "24.0778",
            y2: "31.201",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs61("radialGradient", {
            id: "paint22_radial_5994_44776",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(24.0811 30.4239) scale(23.1954 23.1954)",
            children: [
              /* @__PURE__ */ _jsx148("stop", {
                offset: "0.00132565",
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx148("stop", {
                offset: "1",
                stopColor: "#A9BCBE"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var TearsOfJoy_default = TearsOfJoy;

// src/shared/ui/icons/emoji/Fire.tsx
import { jsx as _jsx149, jsxs as _jsxs62 } from "react/jsx-runtime";
function _define_property145(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread145(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property145(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys136(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props136(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys136(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties124(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose124(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose124(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var TearsOfJoy2 = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties124(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs62("svg", _object_spread_props136(_object_spread145({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx149("path", {
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint0_linear_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M31.3172 16.343C33.8471 11.6785 27.5789 11.0347 27.5676 8.16602C27.5676 8.16602 26.4608 11.1251 29.1036 13.1467C31.2608 14.7844 31.3172 16.343 31.3172 16.343Z",
        fill: "url(#paint1_linear_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M18.0127 7.41992C17.0527 8.36863 18.3741 12.2877 15.3698 13.835C15.3698 13.835 14.3534 9.53192 18.0127 7.41992Z",
        fill: "url(#paint2_linear_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M10.9765 22.9171C10.1407 24.3514 9 27.0055 9 30.7665C9 34.9679 14.3534 42.6931 23.1064 42.6931C31.656 42.6931 38.2969 36.1086 38.2969 30.4502C38.2969 28.406 37.7322 25.7971 36.4786 23.9448C36.3882 25.1081 36.1059 26.6893 35.2362 27.5138C34.7845 27.9429 34.2198 28.1349 33.5986 28.0672L32.9661 28.0107L33.1581 27.4121C33.1807 27.3556 34.8184 22.0022 33.6325 18.8286C33.1581 19.9919 32.3449 21.494 31.3511 21.5731L30.7864 21.6182L30.7976 21.0535C30.8428 18.7156 29.4085 17.4733 27.7482 16.0389C25.3765 13.9834 22.6998 11.6568 23.6824 5.75C22.0334 6.72129 18.8259 9.398 19.6278 14.9208C20.0344 17.6879 19.0744 19.7434 19.0405 19.8338L18.9275 20.0709L18.6791 20.1161C18.2047 20.2065 17.7078 20.0145 17.256 19.5853C16.6461 18.9867 16.0927 17.8573 16.0701 16.3213C15.144 17.27 13.8678 18.9076 13.8678 20.7712C13.8678 23.8319 15.3586 27.1298 15.3699 27.1636L15.7878 28.0898L14.7939 27.8752C12.1962 27.3105 11.2249 24.8935 10.9765 22.9171Z",
        fill: "url(#paint3_linear_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M27.5675 8.16602C27.3417 9.87143 28.0193 12.3223 29.1035 13.1467C30.0974 13.9034 31.2155 15.2023 31.3059 16.343C33 13.0225 30.617 11.7914 29.2504 11.3058C28.6744 11.1025 27.6127 9.9166 27.5675 8.16602Z",
        fill: "url(#paint4_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M22.3609 7.67969C18.6113 13.5526 23.4791 19.7531 20.9718 23.4689C18.4645 27.1846 15.9233 23.7512 15.7539 21.4246C15.7539 21.4246 15.7765 28.9465 19.4922 31.9169C23.208 34.8872 12.3431 34.2435 10.8522 30.618C10.8522 30.618 10.8522 42.6915 23.1064 42.6915C35.3605 42.6915 37.4047 31.4538 37.4047 31.4538C37.4047 31.4538 32.9435 35.2599 29.9732 32.2896C29.9732 32.2896 32.1981 28.3931 32.7628 24.395C32.7628 24.395 31.2268 25.3663 28.8664 24.9936C28.8664 24.9936 30.1765 19.3804 27.4998 17.5395C24.0664 15.179 21.1638 9.55451 22.3609 7.67969Z",
        fill: "url(#paint5_linear_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M23.2983 14.5918C21.3331 17.1781 25.1618 23.8191 21.1411 26.4506C18.9162 27.9076 17.6399 26.157 17.6399 26.157C17.6399 26.157 18.2385 28.845 20.6329 31.2393C23.0272 33.6337 17.0301 36.8751 12.1623 32.685C12.1623 32.685 13.8338 42.748 25.1618 41.0539C37.6644 39.1904 36.7383 29.8953 36.7383 29.8953C36.7383 29.8953 33.3501 35.2261 28.5275 32.6737C28.5275 32.6737 31.5656 28.4384 31.5656 26.0101C31.5656 26.0101 29.5101 27.2299 27.1609 26.0553C27.1609 26.0553 28.279 20.4083 26.9463 19.5612C23.7501 17.517 23.2983 14.5918 23.2983 14.5918Z",
        fill: "url(#paint6_linear_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint7_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint8_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M9.76794 28.1465C10.0277 34.5276 15.2795 42.1738 23.4903 42.1738C31.7011 42.1738 35.8009 33.5112 36.0606 28.4401C36.0606 28.4401 34.5246 31.4218 31.0573 32.0203C27.5901 32.6189 31.2945 26.0571 28.8663 22.1719C28.8663 22.1719 26.7204 28.9371 23.671 29.1855C20.6216 29.434 18.0352 24.7131 18.0352 22.1719C18.0352 22.1719 16.1604 26.746 16.6235 30.3827C17.335 35.9055 9.76794 28.1465 9.76794 28.1465Z",
        fill: "url(#paint9_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint10_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M31.3172 16.343C33.8471 11.6785 27.5789 11.0347 27.5676 8.16602C27.5676 8.16602 26.4608 11.1251 29.1036 13.1467C31.2608 14.7844 31.3172 16.343 31.3172 16.343Z",
        fill: "url(#paint11_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        d: "M18.0127 7.41992C17.0639 8.36863 17.6738 11.3616 15.3698 13.835C15.3698 13.835 14.3534 9.53192 18.0127 7.41992Z",
        fill: "url(#paint12_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M18.0127 7.41992C17.0527 8.36863 18.3741 12.2877 15.3698 13.835C15.3698 13.835 14.3534 9.53192 18.0127 7.41992Z",
        fill: "url(#paint13_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.5",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint14_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.25",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint15_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.25",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint16_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsx149("path", {
        opacity: "0.25",
        d: "M31.3059 21.053C31.4301 14.8074 21.9431 15.6657 24.3826 4.80078C24.3826 4.80078 18.0127 7.30808 19.1308 14.9994C19.5148 17.6422 18.5887 19.6187 18.5887 19.6187C17.6513 19.8107 16.1944 17.9471 16.7026 15.0671C16.7026 15.0671 13.3595 17.5631 13.3595 20.7707C13.3595 23.9782 14.9068 27.3777 14.9068 27.3777C11.0555 26.542 11.4395 21.3467 11.4395 21.3467C11.4395 21.3467 9 24.6107 9 30.766C9 35.5547 14.3986 43.2008 23.1064 43.2008C31.8141 43.2008 38.8052 36.4469 38.8052 30.4384C38.8052 27.8069 37.9129 24.4074 35.9816 22.5551C35.9816 22.5551 36.2414 27.8069 33.6438 27.5584C33.6438 27.5584 35.7896 20.7029 33.5421 17.5631C33.5421 17.5631 32.4579 20.9514 31.3059 21.053Z",
        fill: "url(#paint17_radial_5994_44778)"
      }),
      /* @__PURE__ */ _jsxs62("defs", {
        children: [
          /* @__PURE__ */ _jsxs62("linearGradient", {
            id: "paint0_linear_5994_44778",
            x1: "25.8125",
            y1: "44.2621",
            x2: "18.889",
            y2: "-5.91215",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.2317",
                stopColor: "#FF1500"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.7367",
                stopColor: "#FF3D00"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9987",
                stopColor: "#FF4C00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("linearGradient", {
            id: "paint1_linear_5994_44778",
            x1: "33.9255",
            y1: "43.1422",
            x2: "27.002",
            y2: "-7.03206",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.2317",
                stopColor: "#FF1500"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.7367",
                stopColor: "#FF3D00"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9987",
                stopColor: "#FF4C00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("linearGradient", {
            id: "paint2_linear_5994_44778",
            x1: "21.4076",
            y1: "44.8689",
            x2: "14.4841",
            y2: "-5.30542",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.2317",
                stopColor: "#FF1500"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.7367",
                stopColor: "#FF3D00"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9987",
                stopColor: "#FF4C00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("linearGradient", {
            id: "paint3_linear_5994_44778",
            x1: "25.626",
            y1: "35.716",
            x2: "10.4968",
            y2: "-7.49202",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FF8000"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.6388",
                stopColor: "#FF5B00"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9987",
                stopColor: "#FF4C00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint4_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(32.1056 0.550866) scale(20.1612 20.1612)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C",
                stopOpacity: "0.6"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9477",
                stopColor: "#FFED1C",
                stopOpacity: "0.0264782"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9914",
                stopColor: "#FFED1C",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("linearGradient", {
            id: "paint5_linear_5994_44778",
            x1: "19.7511",
            y1: "6.88131",
            x2: "25.2216",
            y2: "37.5671",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FF8000"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.022669",
                stopColor: "#FE7F02",
                stopOpacity: "0.9773"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.6663",
                stopColor: "#ED582A",
                stopOpacity: "0.3337"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#E74939",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("linearGradient", {
            id: "paint6_linear_5994_44778",
            x1: "23.9991",
            y1: "40.0406",
            x2: "25.1815",
            y2: "18.4945",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.1869",
                stopColor: "#FFB137",
                stopOpacity: "0.8131"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.7223",
                stopColor: "#FF940F",
                stopOpacity: "0.2777"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FF8900",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint7_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.7052 34.227) scale(15.5958 12.6607)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.2941",
                stopColor: "#FFBF4B",
                stopOpacity: "0.7068"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.5624",
                stopColor: "#FEC656",
                stopOpacity: "0.4382"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.8201",
                stopColor: "#FCD368",
                stopOpacity: "0.1801"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FBE07A",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint8_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.7052 33.5859) scale(15.1152 12.2705)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint9_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(17.0774 36.3746) scale(18.568 21.6187)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C",
                stopOpacity: "0.6"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9477",
                stopColor: "#FFED1C",
                stopOpacity: "0.0264782"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9914",
                stopColor: "#FFED1C",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint10_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.706 33.5843) rotate(92.8876) scale(5.86837 4.76368)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint11_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(26.95 8.1553) scale(6.66107 6.66108)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.1997",
                stopColor: "#FFEE2B",
                stopOpacity: "0.8013"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.5839",
                stopColor: "#FFF254",
                stopOpacity: "0.4167"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FFF686",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint12_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.9661 11.3599) rotate(-56.4116) scale(5.39561 1.22536)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C",
                stopOpacity: "0.6"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9477",
                stopColor: "#FFED1C",
                stopOpacity: "0.0264782"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9914",
                stopColor: "#FFED1C",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint13_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(17.0347 7.12885) rotate(95.0573) scale(4.84823 1.95078)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.1997",
                stopColor: "#FFEE2B",
                stopOpacity: "0.8013"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.5839",
                stopColor: "#FFF254",
                stopOpacity: "0.4167"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FFF686",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint14_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(25.4698 7.30095) scale(20.7846)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FF4C00"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.135",
                stopColor: "#FF5B0C",
                stopOpacity: "0.8661"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.3941",
                stopColor: "#FF842C",
                stopOpacity: "0.6067"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.7491",
                stopColor: "#FFC45F",
                stopOpacity: "0.2512"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FFF686",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint15_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(34.9232 24.1397) scale(11.0321)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.1997",
                stopColor: "#FFEE2B",
                stopOpacity: "0.8013"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.5839",
                stopColor: "#FFF254",
                stopOpacity: "0.4167"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FFF686",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint16_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.3402 28.0716) scale(11.7588)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.00134333",
                stopColor: "#FFED1C"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.1997",
                stopColor: "#FFEE2B",
                stopOpacity: "0.8013"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.5839",
                stopColor: "#FFF254",
                stopOpacity: "0.4167"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "1",
                stopColor: "#FFF686",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs62("radialGradient", {
            id: "paint17_radial_5994_44778",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.5297 25.6949) rotate(86.1102) scale(20.142 12.2443)",
            children: [
              /* @__PURE__ */ _jsx149("stop", {
                stopColor: "#FF4C00",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9874",
                stopColor: "#FF4C00",
                stopOpacity: "0.9888"
              }),
              /* @__PURE__ */ _jsx149("stop", {
                offset: "0.9987",
                stopColor: "#FF4C00"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var Fire_default = TearsOfJoy2;

// src/shared/ui/icons/emoji/HeartEyes.tsx
import { jsx as _jsx150, jsxs as _jsxs63 } from "react/jsx-runtime";
function _define_property146(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread146(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property146(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys137(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props137(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys137(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties125(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose125(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose125(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var HeartEyes = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties125(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs63("svg", _object_spread_props137(_object_spread146({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx150("path", {
        d: "M24 43.2008C34.6039 43.2008 43.2 34.6046 43.2 24.0008C43.2 13.3969 34.6039 4.80078 24 4.80078C13.3961 4.80078 4.79999 13.3969 4.79999 24.0008C4.79999 34.6046 13.3961 43.2008 24 43.2008Z",
        fill: "url(#paint0_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M24 43.2008C34.6039 43.2008 43.2 34.6046 43.2 24.0008C43.2 13.3969 34.6039 4.80078 24 4.80078C13.3961 4.80078 4.79999 13.3969 4.79999 24.0008C4.79999 34.6046 13.3961 43.2008 24 43.2008Z",
        fill: "url(#paint1_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M24 43.2008C34.6039 43.2008 43.2 34.6046 43.2 24.0008C43.2 13.3969 34.6039 4.80078 24 4.80078C13.3961 4.80078 4.79999 13.3969 4.79999 24.0008C4.79999 34.6046 13.3961 43.2008 24 43.2008Z",
        fill: "url(#paint2_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M24 43.2008C34.6039 43.2008 43.2 34.6046 43.2 24.0008C43.2 13.3969 34.6039 4.80078 24 4.80078C13.3961 4.80078 4.79999 13.3969 4.79999 24.0008C4.79999 34.6046 13.3961 43.2008 24 43.2008Z",
        fill: "url(#paint3_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M37.2359 30.3841C37.2479 30.2761 37.2599 30.1681 37.2719 30.0721C37.2479 29.7241 37.0319 29.4001 36.6839 29.2801C36.5039 29.2081 36.3119 29.2081 36.1199 29.2561C32.1959 30.3481 28.1159 30.9121 23.9999 30.9121C19.8839 30.9121 15.8039 30.3601 11.8799 29.2561C11.6999 29.2081 11.4959 29.2081 11.3159 29.2801C10.9799 29.4121 10.7639 29.7121 10.7279 30.0601C10.7399 30.1801 10.7519 30.3001 10.7759 30.4321L10.9919 31.3321C11.0399 31.5001 11.0999 31.6801 11.1719 31.8721C12.5159 35.0161 16.0199 40.5481 24.0119 40.5481C31.9919 40.5481 35.4959 35.0041 36.8519 31.8601C36.9119 31.6921 36.9719 31.5361 37.0079 31.3801L37.2359 30.3841Z",
        fill: "url(#paint4_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M24 39.672C27.096 39.672 29.472 38.784 31.284 37.524C29.292 36.6 26.892 36 24 36C21.108 36 18.696 36.6 16.704 37.536C18.528 38.796 20.904 39.672 24 39.672Z",
        fill: "url(#paint5_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M37.0079 31.3441L37.2239 30.4201C37.2479 30.2881 37.2599 30.1681 37.2599 30.0601C37.2359 29.7121 37.0079 29.4121 36.6719 29.2801C36.4919 29.2081 36.2999 29.2081 36.1079 29.2561C32.1839 30.3481 28.1039 30.9121 23.9879 30.9121C19.8719 30.9121 15.7919 30.3601 11.8679 29.2561C11.6879 29.2081 11.4839 29.2081 11.3039 29.2801C10.9679 29.4121 10.7519 29.7121 10.7159 30.0601C10.7279 30.1681 10.7399 30.3001 10.7519 30.4321L10.9679 31.3441C11.0159 31.5121 11.0759 31.6921 11.1479 31.8721C11.6879 33.1441 12.5879 34.8001 13.9799 36.3241C12.6719 34.7641 14.2799 33.9121 17.1719 34.2601C20.0519 34.6081 23.9879 34.6201 23.9879 34.6201C23.9879 34.6201 27.9239 34.6081 30.8039 34.2601C33.6839 33.9121 35.3039 34.7761 33.9959 36.3241C35.3999 34.8001 36.2879 33.1441 36.8279 31.8721C36.8999 31.6801 36.9599 31.5121 37.0079 31.3441Z",
        fill: "url(#paint6_linear_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M24 31.7888C19.848 31.7888 15.744 31.2368 11.772 30.1328L11.82 30.6728C11.916 31.7048 12.672 32.5568 13.68 32.7848C17.052 33.5288 20.508 33.9008 23.988 33.9008C27.744 33.9008 31.464 33.4688 35.088 32.6048C35.628 32.4728 36.024 32.0168 36.084 31.4648L36.216 30.1448C32.256 31.2368 28.152 31.7888 24 31.7888Z",
        fill: "url(#paint7_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M16.2722 12.9018C14.9762 13.4898 14.1242 14.6658 13.8842 15.9618C12.7442 15.2778 11.3042 15.1338 10.0082 15.7218C7.90818 16.6698 6.98418 19.1418 7.93218 21.2298C10.0202 25.8498 18.8282 26.8818 18.8282 26.8818C18.8282 26.8818 23.8682 19.5978 21.7802 14.9658C20.8442 12.8898 18.3722 11.9538 16.2722 12.9018Z",
        fill: "url(#paint8_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M18.0003 12.5293C21.5763 14.9053 21.6243 20.1133 19.8843 22.3813C17.9643 24.8893 15.9363 25.0333 11.4243 24.6133C14.7003 26.4013 18.8283 26.8813 18.8283 26.8813C18.8283 26.8813 23.8683 19.5973 21.7803 14.9653C21.0963 13.4533 19.5843 12.5413 18.0003 12.5293Z",
        fill: "url(#paint9_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M16.2722 12.9018C14.9762 13.4898 14.1242 14.6658 13.8842 15.9618C12.7442 15.2778 11.3042 15.1338 10.0082 15.7218C7.90818 16.6698 6.98418 19.1418 7.93218 21.2298C10.0202 25.8498 18.8282 26.8818 18.8282 26.8818C18.8282 26.8818 23.8682 19.5978 21.7802 14.9658C20.8442 12.8898 18.3722 11.9538 16.2722 12.9018Z",
        fill: "url(#paint10_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M16.2722 12.9018C14.9762 13.4898 14.1242 14.6658 13.8842 15.9618C12.7442 15.2778 11.3042 15.1338 10.0082 15.7218C7.90818 16.6698 6.98418 19.1418 7.93218 21.2298C10.0202 25.8498 18.8282 26.8818 18.8282 26.8818C18.8282 26.8818 23.8682 19.5978 21.7802 14.9658C20.8442 12.8898 18.3722 11.9538 16.2722 12.9018Z",
        fill: "url(#paint11_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.24",
        d: "M12.9001 16.2852C13.6801 17.0052 13.3921 18.6012 12.2401 19.8492C11.0881 21.0972 9.52814 21.5172 8.73614 20.7972C7.95614 20.0772 8.24414 18.4812 9.39614 17.2332C10.5481 15.9852 12.1081 15.5652 12.9001 16.2852Z",
        fill: "url(#paint12_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.24",
        d: "M17.2081 13.4655C18.0121 13.8135 18.2161 15.1455 17.6521 16.4415C17.0881 17.7255 15.9841 18.4815 15.1681 18.1335C14.3521 17.7855 14.1601 16.4535 14.7241 15.1575C15.2881 13.8735 16.3921 13.1175 17.2081 13.4655Z",
        fill: "url(#paint13_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.32",
        d: "M16.8002 13.8853C18.9962 13.6693 22.0922 15.6613 20.6042 20.5573C19.7162 23.4853 18.1922 25.4533 15.4442 26.1973C17.3522 26.7253 18.8402 26.9053 18.8402 26.9053C18.8402 26.9053 23.8802 19.6213 21.7922 14.9893C20.8442 12.8893 18.3722 11.9653 16.2842 12.9133C14.9882 13.5013 14.1362 14.6773 13.8962 15.9733C13.8962 15.9733 15.1922 14.0413 16.8002 13.8853Z",
        fill: "url(#paint14_linear_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        d: "M38.2802 15.708C36.9842 15.12 35.5322 15.264 34.4042 15.96C34.1642 14.652 33.3122 13.488 32.0162 12.9C29.9162 11.964 27.4562 12.9 26.5082 15C24.4322 19.62 29.5082 26.892 29.5082 26.892C29.5082 26.892 38.3042 25.836 40.3802 21.204C41.3162 19.116 40.3802 16.644 38.2802 15.708Z",
        fill: "url(#paint15_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M39.708 16.752C40.308 21 36.432 24.492 33.576 24.696C30.4201 24.924 28.9801 23.496 26.2921 19.848C27.1201 23.484 29.4961 26.904 29.4961 26.904C29.4961 26.904 38.292 25.848 40.368 21.216C41.064 19.668 40.752 17.94 39.708 16.752Z",
        fill: "url(#paint16_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M38.2802 15.708C36.9842 15.12 35.5322 15.264 34.4042 15.96C34.1642 14.652 33.3122 13.488 32.0162 12.9C29.9162 11.964 27.4562 12.9 26.5082 15C24.4322 19.62 29.5082 26.892 29.5082 26.892C29.5082 26.892 38.3042 25.836 40.3802 21.204C41.3162 19.116 40.3802 16.644 38.2802 15.708Z",
        fill: "url(#paint17_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.5",
        d: "M38.2802 15.708C36.9842 15.12 35.5322 15.264 34.4042 15.96C34.1642 14.652 33.3122 13.488 32.0162 12.9C29.9162 11.964 27.4562 12.9 26.5082 15C24.4322 19.62 29.5082 26.892 29.5082 26.892C29.5082 26.892 38.3042 25.836 40.3802 21.204C41.3162 19.116 40.3802 16.644 38.2802 15.708Z",
        fill: "url(#paint18_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.24",
        d: "M33.5042 15.4208C33.4802 16.4888 32.0882 17.3288 30.3962 17.2928C28.7042 17.2568 27.3482 16.3688 27.3602 15.3008C27.3842 14.2328 28.7762 13.3928 30.4682 13.4288C32.1722 13.4648 33.5282 14.3528 33.5042 15.4208Z",
        fill: "url(#paint19_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.24",
        d: "M38.4841 16.7761C38.7601 17.6161 37.8961 18.6481 36.5641 19.0801C35.2321 19.5121 33.9241 19.1881 33.6481 18.3481C33.3721 17.5081 34.2361 16.4761 35.5681 16.0441C36.9001 15.6001 38.2081 15.9361 38.4841 16.7761Z",
        fill: "url(#paint20_radial_5994_44780)"
      }),
      /* @__PURE__ */ _jsx150("path", {
        opacity: "0.32",
        d: "M37.8962 16.7407C39.5162 18.2407 40.0682 21.8767 35.4242 24.0127C32.6402 25.2847 30.1562 25.4527 27.7802 23.8927C28.6442 25.6687 29.5082 26.9047 29.5082 26.9047C29.5082 26.9047 38.3042 25.8487 40.3802 21.2167C41.3162 19.1167 40.3802 16.6567 38.2802 15.7087C36.9842 15.1207 35.5322 15.2647 34.4042 15.9607C34.4042 15.9487 36.7202 15.6487 37.8962 16.7407Z",
        fill: "url(#paint21_linear_5994_44780)"
      }),
      /* @__PURE__ */ _jsxs63("defs", {
        children: [
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint0_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.2224 16.2197) scale(23.1623)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#FFE030"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#FFB92E"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint1_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.2224 16.2197) scale(18.2228)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#FFEA5F"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint2_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.3414 24.1693) rotate(32.7366) scale(10.1656 7.41978)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#EB672A",
                stopOpacity: "0.5"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.4286",
                stopColor: "#DC641B",
                stopOpacity: "0.2846"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.995",
                stopColor: "#C25E00",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint3_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(34.6699 24.1536) rotate(147.263) scale(10.1656 7.41978)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#EB672A",
                stopOpacity: "0.5"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.4286",
                stopColor: "#DC641B",
                stopOpacity: "0.2846"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.995",
                stopColor: "#C25E00",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint4_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.998 34.8877) scale(10.2018 10.2018)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint5_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(24.146 38.2796) scale(8.11686 2.45422)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.2479",
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#C20000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("linearGradient", {
            id: "paint6_linear_5994_44780",
            x1: "37.1215",
            y1: "32.7774",
            x2: "11.0379",
            y2: "32.7774",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.5",
                stopColor: "#512D00"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#3C2200"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint7_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(23.9989 32.0158) scale(22.3755 22.3755)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.00132565",
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#A9BCBE"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint8_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.759 18.7001) rotate(-53.7394) scale(11.8914 9.43162)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.2479",
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.8639",
                stopColor: "#C20000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint9_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.7265 17.9139) rotate(-53.7394) scale(10.2381 8.1203)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.2479",
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#C20000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint10_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.759 18.7001) rotate(-53.7394) scale(11.8914 9.43162)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "white",
                stopOpacity: "0.25"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint11_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(18.3113 20.6421) rotate(-50.6229) scale(8.67973 4.28841)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#BD2719",
                stopOpacity: "0.25"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#BD2719",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint12_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.8168 18.56) rotate(-46.0208) scale(3.08548 1.91669)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint13_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.1872 15.8132) rotate(-65.0908) scale(2.55459 1.58698)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("linearGradient", {
            id: "paint14_linear_5994_44780",
            x1: "22.5015",
            y1: "31.1898",
            x2: "15.664",
            y2: "12.4941",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#860805"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#BD2719",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint15_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(31.5812 16.9134) rotate(-5.26571) scale(11.8913 9.43181)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.2479",
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.8639",
                stopColor: "#C20000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint16_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(32.1478 16.3681) rotate(-5.26571) scale(10.238 8.12046)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                offset: "0.2479",
                stopColor: "#FF0000"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#C20000"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint17_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(31.5812 16.9134) rotate(-5.26571) scale(11.8913 9.43181)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "white",
                stopOpacity: "0.25"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint18_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(33.8307 22.3435) rotate(-2.1516) scale(8.67997 4.28847)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#BD2719",
                stopOpacity: "0.25"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#BD2719",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint19_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(30.4384 15.3751) rotate(2.44968) scale(3.08553 1.91689)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("radialGradient", {
            id: "paint20_radial_5994_44780",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(36.0823 17.5528) rotate(-16.6195) scale(2.55467 1.587)",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs63("linearGradient", {
            id: "paint21_linear_5994_44780",
            x1: "28.7269",
            y1: "32.4867",
            x2: "38.1898",
            y2: "14.9739",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx150("stop", {
                stopColor: "#860805"
              }),
              /* @__PURE__ */ _jsx150("stop", {
                offset: "1",
                stopColor: "#BD2719",
                stopOpacity: "0"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var HeartEyes_default = HeartEyes;

// src/shared/ui/icons/emoji/ThinkingFace.tsx
import { jsx as _jsx151, jsxs as _jsxs64 } from "react/jsx-runtime";
function _define_property147(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread147(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property147(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys138(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props138(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys138(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties126(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose126(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose126(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ThinkingFace = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties126(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs64("svg", _object_spread_props138(_object_spread147({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx151("path", {
        d: "M24 41.9996C34.6039 41.9996 43.2 33.4035 43.2 22.7996C43.2 12.1957 34.6039 3.59961 24 3.59961C13.3961 3.59961 4.79999 12.1957 4.79999 22.7996C4.79999 33.4035 13.3961 41.9996 24 41.9996Z",
        fill: "url(#paint0_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        opacity: "0.5",
        d: "M24 41.9996C34.6039 41.9996 43.2 33.4035 43.2 22.7996C43.2 12.1957 34.6039 3.59961 24 3.59961C13.3961 3.59961 4.79999 12.1957 4.79999 22.7996C4.79999 33.4035 13.3961 41.9996 24 41.9996Z",
        fill: "url(#paint1_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M28.4038 21.1085C28.3078 22.6445 29.0518 23.9525 30.0718 24.0125C31.0918 24.0725 32.0038 22.8845 32.0998 21.3485C32.1958 19.8125 31.4518 18.5045 30.4318 18.4445C29.4118 18.3725 28.4998 19.5725 28.4038 21.1085Z",
        fill: "url(#paint2_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M30.3721 19.3794C29.5801 19.3314 28.8481 19.9794 28.4161 20.9754C28.5361 19.4634 29.4361 18.3114 30.4321 18.3714C31.4401 18.4314 32.1721 19.7034 32.1001 21.2154C31.8121 20.1714 31.1641 19.4274 30.3721 19.3794Z",
        fill: "url(#paint3_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M15.8999 20.3029C15.8039 21.8389 16.5479 23.1469 17.5679 23.2069C18.5879 23.2669 19.4999 22.0789 19.5959 20.5429C19.6919 19.0069 18.9479 17.6989 17.9279 17.6389C16.9079 17.5789 15.9959 18.7669 15.8999 20.3029Z",
        fill: "url(#paint4_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M17.8562 18.6482C18.6482 18.6962 19.2962 19.4282 19.5962 20.4722C19.6682 18.9602 18.9362 17.7002 17.9282 17.6282C16.9202 17.5562 16.0322 18.7202 15.9122 20.2322C16.3322 19.2362 17.0642 18.5882 17.8562 18.6482Z",
        fill: "url(#paint5_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M20.508 13.7284C19.848 13.5124 19.224 12.7084 17.736 12.1084C15.876 11.3524 14.604 11.7364 13.308 12.6604C13.188 12.7444 13.056 12.8284 12.912 12.9244C12.636 13.1044 12.552 13.5004 12.72 13.8244C12.816 14.0284 13.308 14.4124 13.824 14.1004C15.444 13.1164 16.476 13.4044 17.7 13.8964C18.672 14.2924 19.308 15.2404 20.556 15.1444C21.06 15.1084 21.288 14.8564 21.312 14.4844C21.348 14.0404 20.988 13.8844 20.508 13.7284Z",
        fill: "url(#paint6_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M28.5122 31.3911C28.4282 31.3911 28.3562 31.3671 28.2722 31.3431C28.2602 31.3311 26.4482 30.6831 24.2282 30.2031C21.3962 29.5911 19.2002 29.5311 17.8682 30.0351C17.4362 30.2031 16.9442 29.9751 16.7882 29.5431C16.6202 29.1111 16.8482 28.6191 17.2802 28.4631C21.1682 26.9991 28.5362 29.6511 28.8482 29.7591C29.2802 29.9151 29.5082 30.3951 29.3522 30.8391C29.2202 31.1871 28.8722 31.4031 28.5122 31.3911Z",
        fill: "#643800"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M29.4 30.5751C29.412 30.2151 29.196 29.8791 28.848 29.7591C28.536 29.6511 21.168 26.9991 17.28 28.4631C16.872 28.6191 16.656 29.0391 16.764 29.4471C18.564 28.2951 21.444 27.8511 29.4 30.5751Z",
        fill: "url(#paint7_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M24 41.9996C34.6039 41.9996 43.2 33.4035 43.2 22.7996C43.2 12.1957 34.6039 3.59961 24 3.59961C13.3961 3.59961 4.79999 12.1957 4.79999 22.7996C4.79999 33.4035 13.3961 41.9996 24 41.9996Z",
        fill: "url(#paint8_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M27.3961 16.3922C27.1681 15.5523 27.9361 14.7963 29.4841 14.3763C30.8041 14.0163 33.8881 13.9683 36.5761 15.9842C37.0681 16.3562 36.5761 16.7642 36.1321 16.5602C34.6321 15.8523 30.9841 15.4083 28.5001 16.3682C27.4921 16.7642 27.3961 16.3922 27.3961 16.3922Z",
        fill: "url(#paint9_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M24 41.9996C34.6039 41.9996 43.2 33.4035 43.2 22.7996C43.2 12.1957 34.6039 3.59961 24 3.59961C13.3961 3.59961 4.79999 12.1957 4.79999 22.7996C4.79999 33.4035 13.3961 41.9996 24 41.9996Z",
        fill: "url(#paint10_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M38.1719 27.6965C39.4679 28.4285 38.3519 30.8765 38.1599 32.2445C37.8599 34.3925 39.7439 38.1605 38.6879 41.5685C37.6319 44.9765 36.2879 47.2205 30.2759 46.4885C24.2639 45.7565 23.7959 44.2205 24.0719 43.3805C24.3239 42.6005 24.8999 42.7325 24.8999 42.7325C24.8999 42.7325 23.6759 42.1325 23.8319 40.8485C23.9879 39.5645 25.3679 39.7085 25.3679 39.7085C25.3679 39.7085 24.2399 39.2885 24.4079 37.8605C24.5759 36.4325 26.1239 36.6005 26.1239 36.6005C26.1239 36.6005 23.4839 35.0525 20.4479 33.4325C18.2999 32.2925 18.4319 31.6565 18.7679 31.2005C19.1039 30.7445 20.4719 30.0605 23.5799 31.7885C26.6879 33.5165 31.1399 34.8485 32.5079 34.8245C33.8759 34.7885 35.2799 34.1045 35.2559 30.8405C35.2199 28.2005 37.1159 27.0965 38.1719 27.6965Z",
        fill: "url(#paint11_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M26.1 36.6127C26.1 36.6127 23.46 35.0647 20.424 33.4447C18.276 32.3047 18.408 31.6687 18.744 31.2127C18.804 31.1287 18.912 31.0327 19.056 30.9727C18 32.8327 29.52 36.4687 26.1 36.6127Z",
        fill: "url(#paint12_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M32.4842 34.8243C33.8522 34.7883 35.2562 34.1043 35.2322 30.8403C35.2082 28.1883 37.1162 27.0963 38.1602 27.6843C38.2442 27.7323 38.3162 27.7803 38.3762 27.8403C36.7682 27.7803 35.8682 29.2443 35.8322 31.1643C35.7962 33.0603 35.3282 35.4723 31.9922 34.8003C32.1842 34.8243 32.3522 34.8363 32.4842 34.8243Z",
        fill: "url(#paint13_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M23.808 40.9568C25.776 41.5688 27.516 42.9608 30.012 43.2968C32.22 43.5968 36.252 43.0928 38.868 40.8008C38.82 41.0528 38.76 41.3048 38.688 41.5688C37.632 44.9768 36.288 47.2208 30.276 46.4888C24.264 45.7568 23.796 44.2208 24.072 43.3808C24.324 42.6008 24.9 42.7328 24.9 42.7328C24.9 42.7328 23.736 42.1568 23.808 40.9568Z",
        fill: "url(#paint14_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M18.7199 31.2595C18.7319 31.2475 18.7439 31.2355 18.7439 31.2235C19.0799 30.7675 20.4479 30.0835 23.5559 31.8115C26.6639 33.5395 31.1159 34.8715 32.4839 34.8475C33.8519 34.8115 35.2559 34.1275 35.2319 30.8635C35.2319 30.0475 35.3999 29.3875 35.6759 28.8715C36.3719 28.7995 36.9119 29.1835 36.9719 30.6715C37.1399 34.6315 37.7159 38.5555 34.1519 38.3755C27.6479 38.0395 25.2239 32.9395 18.7199 31.2595Z",
        fill: "url(#paint15_radial_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M25.3441 39.709C25.3441 39.709 25.9441 39.949 26.5201 40.045C26.1481 40.021 25.3321 40.117 24.8281 40.189C24.6601 40.213 24.5161 40.309 24.4321 40.453C23.7961 41.593 24.8761 42.733 24.8761 42.733C24.8761 42.733 23.6521 42.133 23.8081 40.849C23.9641 39.577 25.3441 39.709 25.3441 39.709Z",
        fill: "url(#paint16_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M24.0603 43.3799C24.2643 42.7439 24.6963 42.7199 24.8403 42.7199L24.8883 42.7319C24.8883 42.7319 25.4163 42.8159 25.9923 42.7319C25.5483 42.8399 25.0083 43.0199 24.7563 43.1519C24.3723 44.2079 25.8243 45.1559 29.7003 45.7439C36.1083 46.7279 37.2483 43.4879 37.9443 41.2799C38.9643 38.0879 36.9723 35.0159 37.5843 32.0399C37.8483 30.7559 38.4003 28.7639 38.2683 27.7559C39.4083 28.5599 38.3643 30.9119 38.1603 32.2319C37.8363 34.2839 39.7443 38.1479 38.6883 41.5559C37.6323 44.9639 36.2883 47.2079 30.2763 46.4759C24.2523 45.7559 23.7843 44.2199 24.0603 43.3799Z",
        fill: "url(#paint17_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M26.0045 42.7313C25.9925 42.7313 25.9925 42.7313 25.9805 42.7313C26.0165 42.7193 26.0645 42.7073 26.1005 42.6953L26.0045 42.7313Z",
        fill: "url(#paint18_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsx151("path", {
        d: "M25.6082 36.6355C25.6442 36.6235 25.6922 36.6235 25.7282 36.6235C25.7402 36.6235 25.7522 36.6235 25.7762 36.6235C25.8002 36.6235 25.8242 36.6235 25.8482 36.6235C25.8602 36.6235 25.8722 36.6235 25.8842 36.6235C25.9082 36.6235 25.9322 36.6235 25.9562 36.6235C25.9682 36.6235 25.9802 36.6235 25.9922 36.6235C26.0162 36.6235 26.0282 36.6235 26.0402 36.6235C26.0522 36.6235 26.0522 36.6235 26.0642 36.6235C26.0762 36.6235 26.0882 36.6235 26.0882 36.6235H26.1002C26.1122 36.6235 26.1122 36.6235 26.1122 36.6235C26.1122 36.6235 26.0042 36.5635 25.8002 36.4435C26.0522 36.1435 26.1842 35.8555 26.1842 35.8555L27.7802 36.8755C27.1802 36.5995 25.9802 36.8155 25.4162 36.9475C24.6722 37.6675 24.8402 39.3115 25.3562 39.7195C25.3562 39.7195 24.2282 39.2995 24.3962 37.8715C24.4922 36.9715 25.1402 36.7075 25.6082 36.6355Z",
        fill: "url(#paint19_linear_5994_44782)"
      }),
      /* @__PURE__ */ _jsxs64("defs", {
        children: [
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint0_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(27.7776 15.0185) rotate(180) scale(23.1623)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFE030"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFB92E"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint1_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(27.7776 15.0185) rotate(180) scale(27.4908)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFEA5F"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint2_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(30.8096 21.324) rotate(109.828) scale(2.71266 1.75504)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint3_linear_5994_44782",
            x1: "30.4578",
            y1: "18.4198",
            x2: "30.2904",
            y2: "21.02",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint4_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(18.2986 20.5167) rotate(109.828) scale(2.71266 1.75504)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#7A4400"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint5_linear_5994_44782",
            x1: "17.9339",
            y1: "17.6834",
            x2: "17.7665",
            y2: "20.2836",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint6_linear_5994_44782",
            x1: "16.9172",
            y1: "16.5163",
            x2: "17.0372",
            y2: "11.7163",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#7A4400"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint7_linear_5994_44782",
            x1: "22.9975",
            y1: "31.9982",
            x2: "23.2647",
            y2: "23.5191",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#512D00"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint8_linear_5994_44782",
            x1: "23.8613",
            y1: "20.1077",
            x2: "24.8813",
            y2: "39.9077",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.4938",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FF8900"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint9_linear_5994_44782",
            x1: "32.1604",
            y1: "16.5977",
            x2: "31.5697",
            y2: "14.4092",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#3C2200"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#7A4400"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint10_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(25.2726 37.9385) scale(7.4292)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.1836",
                stopColor: "#FF8000",
                stopOpacity: "0.75"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.995",
                stopColor: "#FF8000",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint11_linear_5994_44782",
            x1: "28.4951",
            y1: "44.5925",
            x2: "28.8873",
            y2: "32.5423",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint12_linear_5994_44782",
            x1: "23.5095",
            y1: "30.7056",
            x2: "21.1095",
            y2: "39.9456",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint13_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(35.2142 31.262) rotate(-173.079) scale(3.40727 3.40726)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFE85B"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFE85B",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint14_linear_5994_44782",
            x1: "30.8551",
            y1: "39.4232",
            x2: "32.4759",
            y2: "47.5691",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                offset: "0.4938",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FF8900"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("radialGradient", {
            id: "paint15_radial_5994_44782",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(32.5613 35.7002) rotate(-174.35) scale(6.06005 2.21193)",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFE85B"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFE85B",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint16_linear_5994_44782",
            x1: "25.6859",
            y1: "39.1655",
            x2: "23.6759",
            y2: "43.8455",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint17_linear_5994_44782",
            x1: "30.2569",
            y1: "33.2774",
            x2: "35.8969",
            y2: "48.1574",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint18_linear_5994_44782",
            x1: "21.5256",
            y1: "39.6902",
            x2: "33.624",
            y2: "47.8422",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs64("linearGradient", {
            id: "paint19_linear_5994_44782",
            x1: "25.7305",
            y1: "35.89",
            x2: "26.5216",
            y2: "39.8661",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx151("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx151("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var ThinkingFace_default = ThinkingFace;

// src/shared/ui/icons/emoji/ThumbsUp.tsx
import { jsx as _jsx152, jsxs as _jsxs65 } from "react/jsx-runtime";
function _define_property148(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread148(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property148(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys139(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props139(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys139(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties127(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose127(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose127(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ThumbsUp = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties127(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs65("svg", _object_spread_props139(_object_spread148({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx152("path", {
        d: "M23.8757 4.80078C22.3891 4.80078 21.8239 5.99065 21.939 8.29579C22.0154 9.81536 22.5272 14.0517 20.3824 16.1985C18.3822 18.1997 17.8005 18.022 15.5213 20.6062C13.2431 23.1894 11.3442 22.658 8.68581 22.4296C5.34628 22.1432 6.48401 40.6838 8.83769 40.3624C10.5084 40.134 14.3063 39.6782 14.9138 39.6782C15.5213 39.6782 19.6875 42.907 23.3446 42.9457C29.2679 43.0074 32.5347 41.9575 32.5347 41.9575L34.2707 38.0177L34.8516 26.0048L32.0781 20.2258C32.0781 20.2258 28.3566 20.8336 27.2934 19.1621C26.2303 17.4906 28.1292 15.4387 28.1292 10.6516C28.1292 5.86448 24.6351 4.80078 23.8757 4.80078Z",
        fill: "url(#paint0_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M32.7419 41.9223L32.5163 41.0999C31.849 41.029 30.9902 41.3329 29.8175 41.3237C24.2163 41.2804 18.8618 39.6715 16.5643 37.8517C15.0593 36.66 14.3993 35.0741 13.3361 35.53C12.0244 36.0927 8.30291 36.9676 6.93414 35.2344C7.31707 38.1998 8.00007 40.4764 8.83771 40.3622C10.5084 40.1338 14.3063 39.6779 14.9138 39.6779C15.5214 39.6779 19.5715 42.8221 23.3446 42.9455C28.2259 43.1048 32.5614 42.264 32.5614 42.264L32.7419 41.9223Z",
        fill: "url(#paint1_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M11.0579 23.6002C13.2607 24.208 14.6598 23.2024 15.7856 21.8338C16.904 20.4745 17.8741 19.269 20.6844 17.4455C23.4946 15.622 23.1338 10.6065 22.9055 8.93494C22.6772 7.26341 22.8291 4.80078 23.8757 4.80078C22.3891 4.80078 21.824 5.99065 21.939 8.2958C22.0154 9.81537 22.5272 14.0518 20.3825 16.1985C18.3823 18.1997 17.8005 18.022 15.5214 20.6062C13.2432 23.1895 11.3442 22.6581 8.68585 22.4297C8.68677 23.0062 8.85522 22.9924 11.0579 23.6002Z",
        fill: "url(#paint2_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M27.2934 19.1621C26.2302 17.4906 28.1292 15.4387 28.1292 10.6516C28.1292 5.86448 24.636 4.80078 23.8756 4.80078C23.6759 4.80078 23.4982 4.82288 23.339 4.86525C26.4373 5.05957 28.3032 8.96901 27.2354 13C26.3692 16.2712 25.9375 18.8941 27.3523 20.4321C28.2673 21.4277 30.0871 21.2582 32.079 20.2258C32.0781 20.2258 28.3566 20.8336 27.2934 19.1621Z",
        fill: "url(#paint3_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M27.5024 20.8672C25.6798 21.475 21.0764 22.9053 17.5896 26.0687C8.75297 34.0856 23.8398 35.0904 26.9556 41.9469C27.5512 43.2574 31.0324 35.0738 31.0324 35.0738L32.1582 33.1785L28.9052 24.5114L27.5024 20.8672Z",
        fill: "url(#paint4_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M27.7702 21.5625C25.9477 22.1703 18.5018 26.9427 18.5018 29.2994C18.5018 36.1007 23.6584 32.7438 26.4456 40.769C26.8313 41.8806 28.1946 42.8154 28.1946 42.8154C29.324 41.8935 31.0333 35.0747 31.0333 35.0747L32.1591 33.1794L28.9061 24.5123L27.7702 21.5625Z",
        fill: "url(#paint5_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M31.9769 42.4083L35.4656 38.4178L36.2342 21.7476L27.5015 20.8672C25.4967 21.9465 25.2647 23.4228 26.0094 25.7934C26.3224 26.7908 25.0493 27.0763 24.9674 29.9819C24.9103 31.996 26.2285 32.0052 26.2285 32.6038C26.2285 33.2024 25.5722 33.149 25.354 34.8832C25.0429 37.3642 27.1195 37.4121 27.1195 37.9426C27.1195 38.4731 25.9661 38.788 26.037 40.8104C26.1272 43.3753 21.3665 42.8568 18.1475 40.5231C16.8257 39.5644 15.6723 39.4659 14.7721 39.6832C14.8282 39.6804 14.8761 39.6786 14.912 39.6786C15.5195 39.6786 19.6 42.9461 23.3427 42.9461C27.7197 42.9461 30.7462 42.6901 31.9769 42.4083Z",
        fill: "url(#paint6_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M32.7796 21.9668C30.0835 21.9668 28.6024 24.6026 29.6278 26.6277C30.6532 28.6529 27.7289 31.3338 28.0326 32.6535C28.3364 33.9733 28.8684 37.3136 29.2854 37.8661C29.7033 38.4187 28.6015 39.6721 28.6015 39.6721L32.0192 40.0902L35.2087 38.683L35.0946 29.0342L35.4361 22.9927L32.7796 21.9668Z",
        fill: "url(#paint7_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M15.5213 20.6056C14.0412 22.2836 12.7212 22.6474 11.2493 22.6336C11.6737 23.3188 11.9691 24.0675 11.9388 24.7997C11.8587 26.719 12.2812 29.0849 12.6043 26.6241C12.8501 24.7499 14.1203 22.4337 15.6483 20.4629C15.6069 20.5099 15.5655 20.5559 15.5213 20.6056Z",
        fill: "url(#paint8_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M34.8221 20.151C31.6345 20.0294 25.9035 19.8489 25.7756 23.1901C25.6835 25.6132 27.4011 26.408 30.0577 26.5093C32.7142 26.6106 34.0425 26.6612 35.1424 26.7027C36.2424 26.7441 39.7035 26.7239 39.7375 23.798C39.7799 20.1427 34.8221 20.151 34.8221 20.151Z",
        fill: "url(#paint9_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M29.579 32.2292C28.7248 32.2043 26.187 32.8444 25.9495 34.457C25.7627 35.7252 26.4098 37.3635 28.618 37.7503C31.4154 38.2403 36.0767 38.4972 37.8183 37.8452C38.5961 37.5542 39.2745 36.7391 39.3104 35.5041C39.3463 34.2691 38.4295 32.605 36.4366 32.5469C34.4438 32.4898 33.4055 32.5202 32.2696 32.3858C30.9036 32.2255 30.262 32.2495 29.579 32.2292Z",
        fill: "url(#paint10_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.6889 37.8652C27.7206 37.8652 26.5239 38.7199 26.5239 40.1446C26.5239 41.5693 26.894 42.6238 28.9733 43.0226C31.0527 43.4214 34.3849 43.0797 35.6377 42.6809C36.6143 42.3696 36.9761 41.456 36.9761 39.9457C36.9761 38.4353 36.0372 38.171 35.0117 38.171C33.9863 38.171 32.7418 38.3579 32.0312 38.3211C30.0466 38.2161 29.6573 37.8652 28.6889 37.8652Z",
        fill: "url(#paint11_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M34.5506 20.8249C31.767 20.719 26.7623 20.5578 26.662 23.1991C26.5893 25.1147 28.0915 25.7483 30.4112 25.8367C32.7308 25.9251 38.8336 26.0366 38.8539 23.7241C38.8787 20.8341 34.5506 20.8249 34.5506 20.8249Z",
        fill: "url(#paint12_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M29.8358 32.9098C29.0921 32.8886 27.0099 33.0654 26.8102 34.6062C26.6749 35.6487 27.2152 36.9878 29.1381 37.3073C31.5746 37.7126 35.6321 37.9299 37.1482 37.3985C37.8247 37.1609 38.4148 36.4951 38.4433 35.4829C38.4728 34.4708 37.5403 33.2302 35.8061 33.1796C34.0719 33.1289 33.1487 33.2901 32.1591 33.1778C30.9699 33.0442 30.4305 32.9263 29.8358 32.9098Z",
        fill: "url(#paint13_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M29.1032 38.3848C28.2655 38.3848 27.2309 39.0727 27.2309 40.2202C27.2309 41.3677 27.5512 42.2169 29.3499 42.5374C31.1485 42.8578 34.0305 42.5834 35.1149 42.262C35.959 42.0115 36.2728 41.2756 36.2728 40.0591C36.2728 38.8425 35.4601 38.6307 34.5727 38.6307C33.6854 38.6307 32.6093 38.7817 31.9944 38.7513C30.2768 38.6675 29.9399 38.3848 29.1032 38.3848Z",
        fill: "url(#paint14_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.5923 23.2009C28.6613 21.3811 30.112 20.509 31.9447 20.1074C29.0194 20.1756 25.8695 20.7226 25.7746 23.1899C25.6826 25.6129 27.4002 26.4077 30.0567 26.509C30.3495 26.52 30.6247 26.5311 30.8861 26.5403C29.3949 26.1038 28.5195 25.1193 28.5923 23.2009Z",
        fill: "url(#paint15_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.8426 20.4355C27.1406 20.8076 25.8354 21.6125 25.7755 23.1883C25.6991 25.2024 26.8746 26.0912 28.7993 26.3923C24.8946 24.8331 26.2956 20.9927 28.8426 20.4355Z",
        fill: "url(#paint16_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M24.3102 39.5803C23.8601 40.6146 21.7181 40.6799 19.5255 39.7249C17.3329 38.7708 15.9209 37.1582 16.371 36.1231C16.8211 35.0888 18.9631 35.0235 21.1557 35.9785C23.3474 36.9335 24.7603 38.5461 24.3102 39.5803Z",
        fill: "url(#paint17_radial_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M37.2099 23.6889C37.1878 25.0869 35.3192 25.75 33.2748 25.8744C31.6032 25.9757 29.7475 24.7922 29.7953 23.4265C29.8432 22.0607 30.0862 20.8506 33.5601 20.9712C35.6073 21.0421 37.231 22.3232 37.2099 23.6889Z",
        fill: "url(#paint18_radial_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M37.5808 35.9784C37.5688 37.9142 35.4416 37.5431 33.3972 37.6775C30.8051 37.8488 29.0866 37.0411 29.0856 35.6744C29.0838 34.3078 30.0696 33.3122 33.5463 33.3067C35.5944 33.3039 37.5955 33.4918 37.5808 35.9784Z",
        fill: "url(#paint19_radial_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M35.7067 40.8596C35.6966 42.51 33.7635 42.7347 31.9318 42.7356C30.1 42.7374 28.1118 41.7658 28.1108 40.6008C28.1099 39.4358 28.9908 38.5867 32.0993 38.5821C33.9302 38.5793 35.7196 38.7396 35.7067 40.8596Z",
        fill: "url(#paint20_radial_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.3262 34.8489C28.6171 32.645 30.3071 32.774 32.2447 32.5456C30.0144 32.3789 29.0783 32.3549 29.0783 32.3549C28.8702 32.3347 28.6373 32.3338 28.3952 32.3586C27.6708 32.518 26.8498 32.8477 26.3619 33.4665C26.1962 33.7023 26.0618 33.9804 25.9734 34.3101C25.9642 34.358 25.955 34.4068 25.9495 34.4566C25.7921 35.7293 26.4098 37.3631 28.618 37.7499C28.9365 37.8061 29.2798 37.8586 29.6397 37.9074C29.8119 37.9295 29.9997 37.9525 30.2012 37.9783C30.2556 37.9847 30.3099 37.9912 30.3651 37.9976C29.1464 37.422 28.1117 36.4688 28.3262 34.8489Z",
        fill: "url(#paint21_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.8657 32.3414C28.7156 32.3368 28.5564 32.3423 28.3935 32.3589C27.6626 32.5201 26.8341 32.8544 26.349 33.4834C26.1889 33.7155 26.06 33.9899 25.9735 34.3113C25.9643 34.3592 25.9578 34.4071 25.9496 34.4568C25.7259 35.7103 26.3463 37.1875 28.2756 37.6765C24.984 35.8604 26.3886 32.3432 28.8657 32.3414Z",
        fill: "url(#paint22_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M30.7821 38.2003C29.8091 38.0576 29.4097 37.8633 28.6898 37.8633C27.7215 37.8633 26.5248 38.7179 26.5248 40.1426C26.5248 40.6602 26.5745 41.1281 26.7356 41.5342C26.8995 41.8694 27.1379 42.1835 27.4647 42.4487C27.8237 42.6992 28.3115 42.8935 28.9733 43.0206C29.4179 43.1063 29.9205 43.1569 30.447 43.1818C29.4308 42.5915 27.7095 42.2737 28.0703 40.2974C28.4689 38.1147 29.7714 38.4094 30.7821 38.2003Z",
        fill: "url(#paint23_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.6466 37.8652C27.6865 37.8901 26.5248 38.7401 26.5248 40.1437C26.5248 41.4487 26.8369 42.4433 28.4883 42.9074C25.909 41.2497 26.7366 38.4528 28.6466 37.8652Z",
        fill: "url(#paint24_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M39.7375 23.7974C39.7412 23.4695 39.7043 23.1721 39.6353 22.9004C39.8921 24.0424 38.875 25.177 36.1789 25.7277C34.3922 26.0924 29.6471 26.5483 26.3637 25.2442C27.0725 26.1007 28.3768 26.4433 30.0576 26.5078C32.7142 26.6091 34.0424 26.6597 35.1424 26.7012C36.2424 26.7445 39.7025 26.7233 39.7375 23.7974Z",
        fill: "url(#paint25_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M39.3104 35.4261C39.3067 34.1994 38.3872 32.6034 36.4357 32.5472C34.4429 32.4901 33.4046 32.5205 32.2687 32.386C30.9036 32.2249 30.262 32.2488 29.579 32.2295C29.0626 32.2147 27.7887 32.3704 26.9225 32.9091C27.8964 33.2471 29.4833 33.7555 31.7164 33.6127C37.0672 33.2683 38.5897 33.9157 39.3104 35.4261Z",
        fill: "url(#paint26_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.4312 26.7017C27.2925 26.6787 25.4838 27.3492 25.4368 29.7151C25.3899 32.0801 27.4582 32.6437 28.3695 32.6621C29.2808 32.6805 32.4666 32.8979 36.3961 32.9762C40.3257 33.0545 40.8522 30.9446 40.8743 29.8394C40.8964 28.7334 40.1959 26.734 37.8321 26.6861C30.9975 26.5489 28.4312 26.7017 28.4312 26.7017Z",
        fill: "url(#paint27_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M29.0424 27.3875C28.0519 27.3682 26.4816 27.8821 26.4457 29.7065C26.4089 31.5318 28.2084 31.9702 29 31.9858C29.7926 32.0015 32.5623 32.1755 35.9782 32.2437C39.3942 32.3118 39.848 30.6854 39.8645 29.8317C39.882 28.9789 39.7642 27.4354 37.7088 27.394C31.7689 27.2761 29.0424 27.3875 29.0424 27.3875Z",
        fill: "url(#paint28_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M27.8807 29.4858C27.9948 27.0573 29.6895 27.0499 31.6022 26.6309C29.3655 26.6447 28.4312 26.6999 28.4312 26.6999C27.2925 26.6769 25.4838 27.3474 25.4368 29.7133C25.3899 32.0783 27.4582 32.6419 28.3695 32.6603C28.6981 32.6668 29.3231 32.699 30.17 32.7414C28.9071 32.221 27.7969 31.2725 27.8807 29.4858Z",
        fill: "url(#paint29_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M38.8732 29.7366C38.9523 31.6706 36.8048 32.0343 34.7586 32.132C32.7123 32.2296 30.4378 31.1954 30.3725 29.8305C30.3071 28.4657 31.2451 27.425 34.7172 27.2565C36.7634 27.1579 38.7719 27.2519 38.8732 29.7366Z",
        fill: "url(#paint30_radial_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.2185 26.7051C27.0808 26.7659 25.481 27.4916 25.4368 29.7138C25.3917 31.9628 27.2584 32.5826 28.2259 32.6535C24.4822 31.1422 25.7092 26.9279 28.2185 26.7051Z",
        fill: "url(#paint31_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M40.8679 29.5996C40.3745 33.0992 31.1264 32.4582 26.1291 31.7067C26.8038 32.4297 27.8071 32.6489 28.3696 32.6608C29.2808 32.6793 32.4666 32.8966 36.3962 32.9749C40.3257 33.0532 40.8523 30.9433 40.8744 29.8381C40.8753 29.7626 40.8734 29.6825 40.8679 29.5996Z",
        fill: "url(#paint32_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M36.2351 37.3919C34.4438 37.4711 29.7042 38.0605 26.2487 36.2084C26.6344 36.9249 27.3809 37.5337 28.6171 37.7501C31.4145 38.2401 36.0758 38.497 37.8174 37.845C38.5952 37.554 39.2736 36.7389 39.3095 35.5039C39.1945 36.5777 38.1718 37.3062 36.2351 37.3919Z",
        fill: "url(#paint33_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M36.8389 41.2812C35.6652 42.1746 33.6365 42.7023 30.7093 42.2077C28.9015 41.902 27.6625 41.7979 26.8479 41.7758C27.1738 42.3652 27.8024 42.798 28.9733 43.0228C31.0527 43.4215 34.3848 43.0799 35.6376 42.6811C36.281 42.4748 36.6566 42.007 36.8389 41.2812Z",
        fill: "url(#paint34_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M26.9087 38.8626C29.0774 38.0724 30.1405 39.2448 32.4611 39.2448C34.8709 39.2448 36.0197 38.2714 36.8757 39.1969C36.6069 38.3432 35.8374 38.171 35.0117 38.171C33.9863 38.171 32.7418 38.3579 32.0303 38.3211C30.0457 38.217 29.6573 37.8652 28.6889 37.8652C28.0621 37.8652 27.3404 38.2235 26.9087 38.8626Z",
        fill: "url(#paint35_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M8.83859 40.3628C10.5093 40.1344 14.3072 39.6785 14.9147 39.6785C9.40653 35.7396 11.8559 27.3617 13.8875 23.1244C14.1728 22.5295 14.3486 22.0414 14.4434 21.627C12.6107 23.025 10.9152 22.6216 8.68579 22.43C5.34627 22.1436 6.48491 40.6842 8.83859 40.3628Z",
        fill: "url(#paint36_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M12.3116 36.5556C11.7418 35.7958 12.2352 37.4296 12.6918 38.6075C13.0793 39.6095 10.107 39.0173 7.83252 39.2632C8.12984 39.9972 8.4695 40.4126 8.83861 40.3619C10.5093 40.1335 14.3072 39.6777 14.9147 39.6777C14.0578 38.9492 12.8805 37.3154 12.3116 36.5556Z",
        fill: "url(#paint37_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M14.9138 39.6784C14.4416 39.276 13.8718 38.5981 13.3591 37.9434C13.3591 37.9434 10.594 39.3588 7.62909 38.693C7.97059 39.776 8.38113 40.4244 8.83769 40.3617C10.5093 40.1343 14.3063 39.6784 14.9138 39.6784Z",
        fill: "url(#paint38_linear_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M25.3882 11.9343C24.3057 12.1683 23.4285 10.6726 22.9333 8.92743C22.5283 7.49995 23.0787 5.68199 24.1419 5.47754C25.2051 5.27217 26.1863 5.26296 26.7726 8.28829C27.1169 10.0703 26.4468 11.7059 25.3882 11.9343Z",
        fill: "url(#paint39_radial_5994_44774)"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.6465 37.8656C28.051 37.9282 27.5116 38.2478 27.1406 38.6871C26.7641 39.1301 26.5883 39.7084 26.627 40.2896C26.6307 40.8744 26.719 41.4721 27.0504 41.9454C27.379 42.4234 27.9313 42.708 28.4882 42.9078C27.9138 42.778 27.3128 42.5404 26.928 42.0366C26.5377 41.5384 26.4475 40.8891 26.4282 40.2932C26.4024 39.6836 26.5966 39.0352 27.0265 38.5858C27.4435 38.1318 28.0455 37.8536 28.6465 37.8656Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M27.6911 32.5645C27.299 32.7348 26.9372 32.9678 26.6381 33.2579C26.3334 33.5443 26.1714 33.9367 26.06 34.3345L26.0609 34.3281C25.9173 35.0538 26.0388 35.8265 26.465 36.4297C26.8811 37.0412 27.5567 37.4409 28.2747 37.6748C27.5355 37.5321 26.7909 37.172 26.3233 36.5301C26.0922 36.2142 25.932 35.8449 25.8547 35.459C25.7765 35.0731 25.8124 34.6698 25.8842 34.2931L25.886 34.2866C26.0029 33.8685 26.2109 33.4495 26.5543 33.1668C26.8829 32.8748 27.2861 32.6952 27.6911 32.5645Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.2185 26.7031C27.5143 26.7832 26.8332 27.0761 26.3481 27.5688C25.8612 28.0615 25.5979 28.7403 25.5556 29.4319C25.4847 30.1208 25.5961 30.84 25.99 31.4119C26.3785 31.9857 27.0136 32.3706 27.6929 32.5696C26.997 32.4425 26.3048 32.099 25.8648 31.5013C25.4156 30.9082 25.2969 30.1318 25.3567 29.4153C25.4156 28.6951 25.6982 27.9602 26.2413 27.4601C26.7789 26.9545 27.5088 26.7105 28.2185 26.7031Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M28.8426 20.4355C28.0897 20.6418 27.3413 20.9264 26.7476 21.4154C26.1493 21.9017 25.8253 22.6523 25.875 23.4213C25.8649 24.1848 26.1143 24.9639 26.6942 25.4695C27.2659 25.9816 28.0372 26.2302 28.7985 26.3923C28.0262 26.3011 27.2226 26.1077 26.5939 25.5846C25.9505 25.0689 25.6771 24.2142 25.6762 23.4231C25.6348 22.6191 25.9965 21.7774 26.6519 21.2966C27.2944 20.8039 28.074 20.5718 28.8426 20.4355Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M26.2496 36.207C26.7679 37.105 27.7638 37.57 28.7478 37.7026C29.7493 37.8574 30.7582 37.9633 31.7698 38.0277C32.7796 38.1134 33.793 38.1668 34.8065 38.1631C35.3127 38.1567 35.8199 38.1438 36.3234 38.094C36.8269 38.0535 37.335 38.002 37.8192 37.8426C36.861 38.2027 35.8218 38.2598 34.8092 38.2957C33.7912 38.3215 32.7722 38.293 31.756 38.2267C30.7416 38.1392 29.73 38.0112 28.7267 37.8334C28.2222 37.7505 27.7196 37.594 27.2778 37.3251C26.8378 37.0534 26.477 36.662 26.2496 36.207Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M26.1291 31.707C26.5175 32.0938 27.0174 32.3489 27.5393 32.4788C28.0584 32.6344 28.6043 32.6004 29.1529 32.6252L32.4289 32.7201L35.7031 32.8813C36.7892 32.9476 37.8947 32.9623 38.9358 32.6059C37.9214 33.0387 36.7819 33.0737 35.7003 33.0139L32.4243 32.919L29.1501 32.7569C28.6116 32.7201 28.0455 32.7459 27.5126 32.5718C26.9861 32.407 26.4936 32.1169 26.1291 31.707Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx152("path", {
        d: "M37.832 26.6854C37.0487 26.6873 36.2644 26.7094 35.4811 26.702L33.1311 26.7066L30.782 26.7388C29.9996 26.7434 29.2154 26.7481 28.4357 26.7794H28.4293C27.6588 26.7665 26.8608 27.0299 26.3057 27.5815C25.7396 28.1276 25.4727 28.9224 25.4368 29.7144C25.4432 29.3175 25.4856 28.9169 25.6071 28.5329C25.7304 28.1497 25.9412 27.7915 26.2275 27.5032C26.7982 26.9166 27.6211 26.6256 28.4329 26.6237H28.4265C29.9959 26.5289 31.5635 26.5279 33.1311 26.5528C34.6996 26.5703 36.2663 26.5998 37.832 26.6854Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsxs65("defs", {
        children: [
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint0_linear_5994_44774",
            x1: "32.2015",
            y1: "23.5572",
            x2: "20.776",
            y2: "24.0157",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint1_linear_5994_44774",
            x1: "19.8692",
            y1: "39.4002",
            x2: "19.6395",
            y2: "33.392",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint2_linear_5994_44774",
            x1: "18.4046",
            y1: "16.7824",
            x2: "27.0117",
            y2: "29.0882",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint3_linear_5994_44774",
            x1: "12.1758",
            y1: "11.8794",
            x2: "34.2201",
            y2: "13.5305",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.3118",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FF8900"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint4_linear_5994_44774",
            x1: "11.7561",
            y1: "31.4784",
            x2: "40.7039",
            y2: "31.4784",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint5_linear_5994_44774",
            x1: "7.08842",
            y1: "31.5229",
            x2: "64.278",
            y2: "33.3447",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint6_linear_5994_44774",
            x1: "16.1754",
            y1: "38.9964",
            x2: "25.6332",
            y2: "33.8713",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint7_linear_5994_44774",
            x1: "27.0097",
            y1: "31.7197",
            x2: "34.8963",
            y2: "30.6841",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#643800",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint8_linear_5994_44774",
            x1: "13.0128",
            y1: "14.3076",
            x2: "14.7234",
            y2: "42.6319",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint9_linear_5994_44774",
            x1: "39.1972",
            y1: "23.405",
            x2: "28.0059",
            y2: "23.405",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint10_linear_5994_44774",
            x1: "39.197",
            y1: "35.2324",
            x2: "27.9996",
            y2: "35.2324",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint11_linear_5994_44774",
            x1: "39.1972",
            y1: "40.5327",
            x2: "28.0059",
            y2: "40.5327",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint12_linear_5994_44774",
            x1: "26.4971",
            y1: "23.4602",
            x2: "32.3262",
            y2: "23.3274",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint13_linear_5994_44774",
            x1: "36.6908",
            y1: "35.3107",
            x2: "30.749",
            y2: "35.3107",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint14_linear_5994_44774",
            x1: "36.6909",
            y1: "40.5328",
            x2: "30.749",
            y2: "40.5328",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint15_linear_5994_44774",
            x1: "29.4377",
            y1: "23.3237",
            x2: "26.2674",
            y2: "23.3237",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint16_linear_5994_44774",
            x1: "28.8681",
            y1: "23.4141",
            x2: "25.2221",
            y2: "23.4141",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#E89043"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("radialGradient", {
            id: "paint17_radial_5994_44774",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(20.042 37.0549) rotate(23.5251) scale(4.45085 2.06647)",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("radialGradient", {
            id: "paint18_radial_5994_44774",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(33.508 23.4325) rotate(2.02718) scale(3.80823 2.49946)",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("radialGradient", {
            id: "paint19_radial_5994_44774",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(33.3236 35.7045) rotate(-0.0544055) scale(4.0898 2.20471)",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("radialGradient", {
            id: "paint20_radial_5994_44774",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(31.9087 40.6615) rotate(-0.0539601) scale(3.74454 2.34361)",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint21_linear_5994_44774",
            x1: "29.8174",
            y1: "35.1685",
            x2: "25.2225",
            y2: "35.1685",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint22_linear_5994_44774",
            x1: "28.8409",
            y1: "35.0082",
            x2: "26.3658",
            y2: "35.0082",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint23_linear_5994_44774",
            x1: "29.6523",
            y1: "40.5618",
            x2: "24.2788",
            y2: "39.5749",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint24_linear_5994_44774",
            x1: "29.0967",
            y1: "40.3862",
            x2: "26.8254",
            y2: "40.3862",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint25_linear_5994_44774",
            x1: "32.7173",
            y1: "22.6998",
            x2: "34.1617",
            y2: "29.6904",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint26_linear_5994_44774",
            x1: "33.8146",
            y1: "36.5113",
            x2: "32.2386",
            y2: "30.8253",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint27_linear_5994_44774",
            x1: "39.1971",
            y1: "29.803",
            x2: "28.0059",
            y2: "29.803",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint28_linear_5994_44774",
            x1: "27.5544",
            y1: "29.4904",
            x2: "36.1271",
            y2: "29.8035",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.7382",
                stopColor: "#FFD748"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFCB4B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint29_linear_5994_44774",
            x1: "30.8997",
            y1: "29.6864",
            x2: "24.4949",
            y2: "29.6864",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("radialGradient", {
            id: "paint30_radial_5994_44774",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(34.6185 29.6985) rotate(-2.73606) scale(4.1877 2.74866)",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint31_linear_5994_44774",
            x1: "27.9226",
            y1: "29.6792",
            x2: "25.9004",
            y2: "29.6792",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint32_linear_5994_44774",
            x1: "33.2485",
            y1: "29.0627",
            x2: "34.4648",
            y2: "36.7941",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint33_linear_5994_44774",
            x1: "32.4055",
            y1: "35.0431",
            x2: "35.522",
            y2: "41.8047",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint34_linear_5994_44774",
            x1: "31.7848",
            y1: "40.9753",
            x2: "32.241",
            y2: "45.2495",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint35_linear_5994_44774",
            x1: "31.8924",
            y1: "40.3274",
            x2: "31.8924",
            y2: "37.2356",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint36_linear_5994_44774",
            x1: "11.0183",
            y1: "31.7916",
            x2: "1.32804",
            y2: "46.4337",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#C86F34",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint37_linear_5994_44774",
            x1: "10.3786",
            y1: "35.0293",
            x2: "11.9751",
            y2: "42.1528",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("linearGradient", {
            id: "paint38_linear_5994_44774",
            x1: "11.3453",
            y1: "36.3656",
            x2: "11.1173",
            y2: "45.085",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs65("radialGradient", {
            id: "paint39_radial_5994_44774",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(24.8672 8.68668) rotate(79.0714) scale(4.01537 2.35553)",
            children: [
              /* @__PURE__ */ _jsx152("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx152("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var ThumbsUp_default = ThumbsUp;

// src/shared/ui/icons/emoji/ThumbsDown.tsx
import { jsx as _jsx153, jsxs as _jsxs66 } from "react/jsx-runtime";
function _define_property149(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread149(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property149(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys140(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props140(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys140(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties128(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose128(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose128(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ThumbsDown = (_param) => {
  var { width: width2 = 48, height: height2 = 48 } = _param, props = _object_without_properties128(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs66("svg", _object_spread_props140(_object_spread149({
    width: width2,
    height: height2,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx153("path", {
        d: "M23.8756 43.2011C22.389 43.2011 21.8239 42.0112 21.9389 39.7061C22.0153 38.1865 22.5271 33.9501 20.3824 31.8034C18.3822 29.8022 17.8004 29.9799 15.5213 27.3966C13.2422 24.8134 11.3442 25.3448 8.6858 25.5732C5.34629 25.8596 6.48401 7.31904 8.83768 7.64046C10.5084 7.86885 14.3063 8.32472 14.9138 8.32472C15.5213 8.32472 19.6874 5.09403 23.3436 5.05535C29.2669 4.99365 32.5337 6.04353 32.5337 6.04353L34.2697 9.98243L34.8505 21.9953L32.078 27.7752C32.078 27.7752 28.3565 27.1673 27.2934 28.8389C26.2302 30.5104 28.1292 32.5623 28.1292 37.3493C28.1292 42.1364 24.635 43.2011 23.8756 43.2011Z",
        fill: "url(#paint0_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M32.7408 6.07842L32.5153 6.90083C31.8479 6.97174 30.9891 6.66783 29.8164 6.67703C24.2153 6.72032 18.8608 8.32922 16.5633 10.149C15.0583 11.3407 14.3983 12.9266 13.3352 12.4707C12.0235 11.908 8.30199 11.0331 6.93323 12.7664C7.31615 9.8009 7.99915 7.52431 8.83771 7.63851C10.5084 7.8669 14.3063 8.32277 14.9138 8.32277C15.5213 8.32277 19.5715 5.17865 23.3445 5.05524C28.2258 4.89592 32.5613 5.73674 32.5613 5.73674L32.7408 6.07842Z",
        fill: "url(#paint1_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M11.0579 24.4019C13.2606 23.794 14.6597 24.7997 15.7855 26.1682C16.9039 27.5276 17.8741 28.7331 20.6843 30.5566C23.4945 32.38 23.1337 37.3955 22.9054 39.067C22.6771 40.7386 22.829 43.2012 23.8756 43.2012C22.389 43.2012 21.8238 42.0113 21.9389 39.7062C22.0153 38.1866 22.5271 33.9503 20.3824 31.8035C18.3822 29.8023 17.8004 29.9801 15.5213 27.3968C13.2431 24.8135 11.3441 25.3449 8.68579 25.5733C8.68579 24.995 8.85516 25.0097 11.0579 24.4019Z",
        fill: "url(#paint2_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M27.2933 28.8401C26.2302 30.5116 28.1291 32.5635 28.1291 37.3506C28.1291 42.1377 24.6359 43.2013 23.8756 43.2013C23.6758 43.2013 23.4982 43.1792 23.3389 43.1369C26.4373 42.9426 28.3031 39.0331 27.2353 35.0021C26.3692 31.7309 25.9375 29.109 27.3522 27.5701C28.2672 26.5745 30.087 26.744 32.0789 27.7764C32.078 27.7764 28.3565 27.1676 27.2933 28.8401Z",
        fill: "url(#paint3_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M27.5023 27.1329C25.6798 26.5251 21.0764 25.0949 17.5896 21.9314C8.753 13.9145 23.8397 12.9098 26.9555 6.05424C27.5511 4.74373 31.0324 12.9273 31.0324 12.9273L32.1581 14.8226L28.9051 23.4887L27.5023 27.1329Z",
        fill: "url(#paint4_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M27.7692 26.4402C25.9466 25.8324 18.5009 21.0601 18.5009 18.7033C18.5009 11.9021 23.6574 15.259 26.4446 7.23385C26.8303 6.12226 28.1935 5.1875 28.1935 5.1875C29.323 6.10937 31.0323 12.9281 31.0323 12.9281L32.1581 14.8234L28.9051 23.4895L27.7692 26.4402Z",
        fill: "url(#paint5_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M31.9767 5.59344L35.4653 9.58391L36.2339 26.2531L27.5013 27.1335C25.4965 26.0542 25.2646 24.5779 26.0092 22.2074C26.3222 21.21 25.0492 20.9245 24.9672 18.0189C24.9102 16.0057 26.2283 15.9956 26.2283 15.3969C26.2283 14.7983 25.572 14.8517 25.3538 13.1176C25.0427 10.6366 27.1193 10.5887 27.1193 10.0582C27.1193 9.52774 25.966 9.21277 26.0368 7.19037C26.127 4.62553 21.3663 5.14402 18.1474 7.4777C16.8256 8.43641 15.6722 8.53495 14.772 8.31761C14.8281 8.32037 14.876 8.32221 14.9119 8.32221C15.5194 8.32221 19.5999 5.05469 23.3426 5.05469C27.7186 5.05469 30.746 5.31163 31.9767 5.59344Z",
        fill: "url(#paint6_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M32.7785 26.0335C30.0824 26.0335 28.6014 23.3978 29.6268 21.3726C30.6522 19.3474 27.7278 16.6665 28.0316 15.3468C28.3353 14.028 28.8674 10.6868 29.2844 10.1342C29.7013 9.58168 28.6004 8.32827 28.6004 8.32827L32.0182 7.91016L35.2077 9.31737L35.0935 18.9662L35.435 25.0067L32.7785 26.0335Z",
        fill: "url(#paint7_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M15.5214 27.3949C14.0412 25.7169 12.7212 25.3532 11.2494 25.367C11.6737 24.6818 11.9692 23.933 11.9388 23.2009C11.8587 21.2816 12.2813 18.9157 12.6043 21.3765C12.8501 23.2506 14.1204 25.5668 15.6484 27.5376C15.606 27.4907 15.5646 27.4446 15.5214 27.3949Z",
        fill: "url(#paint8_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M34.8211 27.8506C31.6335 27.9722 25.9025 28.1527 25.7746 24.8115C25.6825 22.3885 27.4002 21.5937 30.0567 21.4924C32.7132 21.3911 34.0414 21.3404 35.1414 21.299C36.2423 21.2566 39.7024 21.2778 39.7365 24.2037C39.7788 27.8589 34.8211 27.8506 34.8211 27.8506Z",
        fill: "url(#paint9_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M29.578 15.7723C28.7238 15.7971 26.186 15.1571 25.9485 13.5445C25.7617 12.2763 26.4088 10.638 28.617 10.2512C31.4144 9.76122 36.0757 9.50428 37.8172 10.1563C38.5951 10.4473 39.2735 11.2624 39.3094 12.4974C39.3453 13.7323 38.4284 15.3965 36.4356 15.4545C34.4428 15.5116 33.4045 15.4812 32.2686 15.6157C30.9026 15.7769 30.2619 15.7529 29.578 15.7723Z",
        fill: "url(#paint10_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.6888 10.1359C27.7205 10.1359 26.5239 9.28123 26.5239 7.85653C26.5239 6.43182 26.8939 5.37734 28.9733 4.97857C31.0526 4.5798 34.3848 4.92147 35.6376 5.32024C36.6142 5.63152 36.9759 6.5451 36.9759 8.05545C36.9759 9.56581 36.0361 9.8292 35.0107 9.8292C33.9853 9.8292 32.7408 9.64225 32.0302 9.67908C30.0465 9.78499 29.6572 10.1359 28.6888 10.1359Z",
        fill: "url(#paint11_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M34.5496 27.177C31.766 27.2829 26.7614 27.444 26.661 24.8027C26.5883 22.8872 28.0905 22.2536 30.4102 22.1651C32.7298 22.0767 38.8326 21.9653 38.8528 24.2778C38.8786 27.1677 34.5496 27.177 34.5496 27.177Z",
        fill: "url(#paint12_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M29.8348 15.0907C29.0911 15.1119 27.009 14.9351 26.8092 13.3943C26.6739 12.3518 27.2142 11.0127 29.1371 10.6932C31.5736 10.2879 35.6311 10.0706 37.1471 10.602C37.8237 10.8396 38.4137 11.5054 38.4423 12.5176C38.4717 13.5297 37.5393 14.7702 35.8051 14.8209C34.07 14.8706 33.1477 14.7103 32.1581 14.8227C30.9698 14.9553 30.4295 15.0732 29.8348 15.0907Z",
        fill: "url(#paint13_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M29.1021 9.61771C28.2645 9.61771 27.2299 8.92977 27.2299 7.78226C27.2299 6.63476 27.5502 5.78565 29.3488 5.46516C31.1474 5.14467 34.0295 5.41911 35.1138 5.74052C35.9579 5.99102 36.2718 6.72686 36.2718 7.94343C36.2718 9.15908 35.459 9.37182 34.5716 9.37182C33.6843 9.37182 32.6082 9.22079 31.9934 9.25118C30.2767 9.33498 29.9398 9.61771 29.1021 9.61771Z",
        fill: "url(#paint14_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.5922 24.8003C28.6612 26.6201 30.1119 27.4922 31.9446 27.8938C29.0193 27.8256 25.8694 27.2786 25.7746 24.8113C25.6825 22.3883 27.4002 21.5936 30.0567 21.4922C30.3494 21.4812 30.6246 21.4701 30.886 21.4609C29.3939 21.8975 28.5195 22.881 28.5922 24.8003Z",
        fill: "url(#paint15_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.8416 27.5641C27.1396 27.192 25.8344 26.3871 25.7746 24.8114C25.6982 22.7973 26.8736 21.9086 28.7983 21.6074C24.8937 23.1675 26.2946 27.0078 28.8416 27.5641Z",
        fill: "url(#paint16_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M21.3876 9.45089C21.0847 8.36416 18.9713 8.00407 16.6682 8.6469C14.3652 9.28972 12.7442 10.6914 13.0471 11.7781C13.3499 12.8648 15.4633 13.2249 17.7664 12.5821C20.0694 11.9393 21.6904 10.5385 21.3876 9.45089Z",
        fill: "url(#paint17_radial_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M37.2088 24.3126C37.1867 22.9146 35.3181 22.2515 33.2737 22.1272C31.6021 22.0258 29.7464 23.2093 29.7943 24.575C29.8422 25.9408 30.0852 27.1509 33.5591 27.0303C35.6062 26.9594 37.23 25.6793 37.2088 24.3126Z",
        fill: "url(#paint18_radial_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M37.5807 12.0227C37.5697 10.0869 35.4415 10.458 33.3971 10.3236C30.805 10.1523 29.0865 10.9599 29.0856 12.3266C29.0837 13.6933 30.0696 14.6888 33.5462 14.6944C35.5934 14.6981 37.5954 14.5102 37.5807 12.0227Z",
        fill: "url(#paint19_radial_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M35.7066 7.14355C35.6965 5.49321 33.7635 5.2685 31.9317 5.26758C30.0999 5.26574 28.1117 6.23734 28.1108 7.40234C28.1099 8.56734 28.9908 9.41646 32.0992 9.42106C33.9301 9.42382 35.7195 9.26358 35.7066 7.14355Z",
        fill: "url(#paint20_radial_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.3252 13.1526C28.6161 15.3565 30.3061 15.2275 32.2437 15.4559C30.0134 15.6226 29.0773 15.6466 29.0773 15.6466C28.8692 15.6668 28.6363 15.6677 28.3943 15.6429C27.6698 15.4836 26.8488 15.1539 26.3609 14.535C26.1952 14.2992 26.0608 14.0211 25.9725 13.6914C25.9633 13.6435 25.9541 13.5947 25.9485 13.545C25.7911 12.2722 26.4088 10.6384 28.617 10.2516C28.9355 10.1955 29.2798 10.143 29.6388 10.0942C29.8109 10.0721 29.9987 10.049 30.2002 10.0232C30.2546 10.0168 30.3089 10.0104 30.3641 10.0039C29.1463 10.5795 28.1117 11.5327 28.3252 13.1526Z",
        fill: "url(#paint21_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.8655 15.6612C28.7155 15.6658 28.5562 15.6603 28.3933 15.6437C27.6625 15.4826 26.834 15.1483 26.3489 14.5192C26.1888 14.2872 26.0599 14.0127 25.9734 13.6913C25.9642 13.6434 25.9577 13.5955 25.9494 13.5458C25.7258 12.2924 26.3462 10.8152 28.2755 10.3262C24.9838 12.1423 26.3876 15.6594 28.8655 15.6612Z",
        fill: "url(#paint22_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M30.7811 9.80172C29.8082 9.94447 29.4087 10.1388 28.6888 10.1388C27.7205 10.1388 26.5239 9.28415 26.5239 7.85944C26.5239 7.34187 26.5736 6.87403 26.7347 6.46789C26.8985 6.13266 27.1369 5.81862 27.4637 5.55339C27.8227 5.30289 28.3105 5.10857 28.9724 4.98148C29.4169 4.89583 29.9195 4.84518 30.446 4.82031C29.4298 5.41064 27.7085 5.72837 28.0694 7.70472C28.4688 9.88737 29.7713 9.59267 30.7811 9.80172Z",
        fill: "url(#paint23_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.6456 10.1359C27.6855 10.1111 26.5239 9.26104 26.5239 7.85752C26.5239 6.55253 26.8359 5.55791 28.4873 5.09375C25.909 6.75146 26.7365 9.54838 28.6456 10.1359Z",
        fill: "url(#paint24_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M39.7364 24.2049C39.7401 24.5328 39.7033 24.8303 39.6342 25.1019C39.8911 23.96 38.8739 22.8254 36.1778 22.2746C34.3912 21.9099 29.6461 21.4541 26.3627 22.7581C27.0715 21.9016 28.3758 21.5591 30.0566 21.4946C32.7131 21.3933 34.0414 21.3426 35.1414 21.3012C36.2423 21.2579 39.7024 21.2791 39.7364 24.2049Z",
        fill: "url(#paint25_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M39.3094 12.5762C39.3057 13.8029 38.3861 15.3989 36.4347 15.4551C34.4419 15.5122 33.4035 15.4818 32.2677 15.6162C30.9026 15.7774 30.261 15.7534 29.578 15.7728C29.0616 15.7875 27.7877 15.6319 26.9215 15.0931C27.8954 14.7551 29.4823 14.2468 31.7154 14.3895C37.0661 14.734 38.5886 14.0865 39.3094 12.5762Z",
        fill: "url(#paint26_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.4311 21.3C27.2925 21.323 25.4837 20.6526 25.4368 18.2866C25.3898 15.9207 27.4581 15.358 28.3694 15.3396C29.2807 15.3212 32.4665 15.1038 36.396 15.0256C40.3256 14.9473 40.8521 17.0572 40.8742 18.1623C40.8963 19.2684 40.1958 21.2677 37.832 21.3156C30.9974 21.4529 28.4311 21.3 28.4311 21.3Z",
        fill: "url(#paint27_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M29.0422 20.6141C28.0518 20.6334 26.4814 20.1196 26.4455 18.2952C26.4096 16.4708 28.2083 16.0315 28.9999 16.0158C29.7924 16.0001 32.5621 15.8261 35.9781 15.7579C39.394 15.6898 39.8478 17.3162 39.8643 18.1699C39.8809 19.0227 39.764 20.5662 37.7086 20.6077C31.7678 20.7255 29.0422 20.6141 29.0422 20.6141Z",
        fill: "url(#paint28_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M27.8806 18.5153C27.9948 20.9439 29.6894 20.9503 31.6022 21.3703C29.3654 21.3564 28.4311 21.3012 28.4311 21.3012C27.2925 21.3242 25.4837 20.6538 25.4368 18.2878C25.3898 15.9219 27.4581 15.3592 28.3694 15.3408C28.698 15.3344 29.323 15.3021 30.1699 15.2598C28.907 15.7801 27.7969 16.7287 27.8806 18.5153Z",
        fill: "url(#paint29_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M38.8721 18.2651C38.9512 16.3311 36.8038 15.9673 34.7575 15.8697C32.7113 15.772 30.4368 16.8063 30.3714 18.1711C30.3061 19.536 31.244 20.5766 34.7161 20.7452C36.7633 20.8437 38.7708 20.7498 38.8721 18.2651Z",
        fill: "url(#paint30_radial_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.2175 21.2961C27.0798 21.2353 25.48 20.5096 25.4358 18.2873C25.3907 16.0384 27.2574 15.4186 28.2249 15.3477C24.4813 16.8589 25.7083 21.0732 28.2175 21.2961Z",
        fill: "url(#paint31_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M40.8677 18.4028C40.3744 14.9032 31.1263 15.5442 26.129 16.2957C26.8037 15.5727 27.807 15.3535 28.3694 15.3416C29.2807 15.3231 32.4665 15.1058 36.396 15.0275C40.3256 14.9492 40.8521 17.0591 40.8742 18.1643C40.8751 18.2398 40.8733 18.3199 40.8677 18.4028Z",
        fill: "url(#paint32_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M36.2349 10.6094C34.4437 10.5302 29.7041 9.94081 26.2486 11.7928C26.6343 11.0763 27.3808 10.4676 28.617 10.2512C31.4143 9.76122 36.0757 9.50428 37.8172 10.1563C38.595 10.4473 39.2734 11.2624 39.3093 12.4974C39.1943 11.4235 38.1716 10.6951 36.2349 10.6094Z",
        fill: "url(#paint33_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M36.8388 6.72008C35.6651 5.82676 33.6364 5.29906 30.7093 5.79361C28.9014 6.09936 27.6625 6.20343 26.8478 6.22553C27.1737 5.63612 27.8024 5.20328 28.9732 4.97857C31.0526 4.5798 34.3848 4.92147 35.6375 5.32024C36.2809 5.52653 36.6565 5.99437 36.8388 6.72008Z",
        fill: "url(#paint34_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M26.9086 9.14001C29.0773 9.93018 30.1404 8.75781 32.461 8.75781C34.8708 8.75781 36.0196 9.73125 36.8756 8.8057C36.6068 9.65942 35.8373 9.83164 35.0116 9.83164C33.9862 9.83164 32.7417 9.64469 32.0302 9.68152C30.0456 9.78559 29.6572 10.1374 28.6888 10.1374C28.062 10.1374 27.3403 9.77914 26.9086 9.14001Z",
        fill: "url(#paint35_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M8.83768 7.6389C10.5084 7.86729 14.3063 8.32316 14.9138 8.32316C9.40562 12.2621 11.855 20.6399 13.8874 24.8772C14.1728 25.4721 14.3486 25.9602 14.4434 26.3747C12.6107 24.9767 10.9152 25.3801 8.6858 25.5716C5.34629 25.858 6.48401 7.31749 8.83768 7.6389Z",
        fill: "url(#paint36_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M14.9138 8.32227C14.4416 8.72473 13.8718 9.40254 13.3591 10.0573C13.3591 10.0573 10.594 8.64184 7.62909 9.30769C7.97059 8.22465 8.38112 7.5763 8.83768 7.63893C10.5084 7.8664 14.3063 8.32227 14.9138 8.32227Z",
        fill: "url(#paint37_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M25.6476 36.2312C24.5651 35.9973 23.6879 37.4929 23.1926 39.2381C22.7876 40.6656 23.3381 42.4826 24.4012 42.688C25.4644 42.8934 26.4456 42.9026 27.032 39.8773C27.3762 38.0943 26.7052 36.4596 25.6476 36.2312Z",
        fill: "url(#paint38_radial_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M32.0781 27.7764C32.0781 27.7764 28.3566 27.1686 27.2934 28.8401C26.2302 30.5117 28.1292 32.5635 28.1292 37.3506C28.1292 42.1377 24.635 43.2014 23.8756 43.2014C22.3891 43.2014 21.8239 42.0115 21.939 39.7064C22.0154 38.1868 22.5271 33.9505 20.3824 31.8037C18.3822 29.8025 17.8005 29.9803 15.5213 27.397C13.2422 24.8137 29.6462 26.6768 32.0781 27.7764Z",
        fill: "url(#paint39_linear_5994_44784)"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.6456 10.1359C28.0445 10.1479 27.4425 9.86887 27.0255 9.41576C26.5956 8.96634 26.4014 8.31799 26.4272 7.70832C26.4465 7.11247 26.5367 6.46412 26.927 5.96497C27.3118 5.46121 27.9128 5.2236 28.4882 5.09375C27.9313 5.29452 27.3799 5.57909 27.0504 6.05614C26.7181 6.52951 26.6306 7.12813 26.6269 7.71201C26.5892 8.29313 26.765 8.87148 27.1406 9.31446C27.5106 9.75375 28.05 10.0733 28.6456 10.1359Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M27.69 15.4355C27.286 15.3047 26.8819 15.1251 26.5542 14.8323C26.2108 14.5495 26.0028 14.1305 25.8859 13.7124L25.8841 13.7059C25.8113 13.3293 25.7754 12.9259 25.8537 12.54C25.931 12.1541 26.0912 11.7858 26.3222 11.469C26.7898 10.8271 27.5345 10.467 28.2736 10.3242C27.5547 10.5581 26.88 10.9588 26.463 11.5693C26.0369 12.1735 25.9154 12.9462 26.059 13.6709L26.0571 13.6645C26.1685 14.0623 26.3314 14.4547 26.6361 14.7411C26.9362 15.0321 27.2979 15.2651 27.69 15.4355Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.2175 21.2972C27.5078 21.2898 26.777 21.0457 26.2403 20.5411C25.6963 20.041 25.4147 19.3061 25.3558 18.5859C25.2959 17.8694 25.4147 17.0921 25.8639 16.4999C26.3039 15.9022 26.9951 15.5587 27.6919 15.4316C27.0126 15.6306 26.3775 16.0155 25.989 16.5893C25.5951 17.1603 25.4837 17.8804 25.5546 18.5693C25.5969 19.2609 25.8602 19.9397 26.3471 20.4324C26.8322 20.9242 27.5134 21.217 28.2175 21.2972Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M28.8417 27.5641C28.0731 27.4287 27.2934 27.1957 26.6509 26.703C25.9964 26.2223 25.6338 25.3805 25.6752 24.5766C25.677 23.7845 25.9495 22.9299 26.5929 22.4142C27.2216 21.892 28.0252 21.6977 28.7975 21.6074C28.0362 21.7695 27.2649 22.0182 26.6932 22.5302C26.1124 23.0367 25.8639 23.8159 25.8731 24.5793C25.8225 25.3483 26.1474 26.0989 26.7457 26.5851C27.3403 27.0732 28.0887 27.3587 28.8417 27.5641Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M26.2486 11.7925C26.476 11.3376 26.8377 10.9471 27.2759 10.6745C27.7168 10.4056 28.2203 10.2499 28.7247 10.167C29.728 9.9893 30.7387 9.86129 31.754 9.7738C32.7702 9.70749 33.7892 9.67894 34.8072 9.70473C35.8198 9.74064 36.859 9.79774 37.8172 10.1578C37.333 9.99851 36.8249 9.94694 36.3214 9.90641C35.8179 9.85668 35.3107 9.84379 34.8045 9.83734C33.791 9.83366 32.7776 9.88615 31.7678 9.9718C30.7562 10.0363 29.7473 10.1422 28.7459 10.2969C27.7628 10.4304 26.7668 10.8946 26.2486 11.7925Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M26.129 16.2952C26.4935 15.8853 26.9859 15.5952 27.5125 15.4295C28.0454 15.2554 28.6106 15.2812 29.15 15.2444L32.4242 15.0823L35.7002 14.9874C36.7817 14.9275 37.9222 14.9625 38.9357 15.3954C37.8946 15.0381 36.7891 15.0537 35.7029 15.12L32.4288 15.2812L29.1528 15.376C28.6051 15.4009 28.0592 15.3668 27.5401 15.5225C27.0163 15.6542 26.5165 15.9084 26.129 16.2952Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsx153("path", {
        d: "M37.832 21.3161C36.2663 21.4018 34.6987 21.4312 33.1311 21.4487C31.5626 21.4736 29.9959 21.4727 28.4265 21.3778H28.4329C27.622 21.376 26.7982 21.084 26.2275 20.4983C25.9412 20.21 25.7304 19.8518 25.6071 19.4687C25.4856 19.0846 25.4423 18.684 25.4368 18.2871C25.4727 19.0791 25.7396 19.8739 26.3057 20.42C26.8608 20.9707 27.6597 21.2341 28.4293 21.2222H28.4357C29.2154 21.2526 29.9996 21.2572 30.782 21.2627L33.1311 21.2949L35.4811 21.2995C36.2644 21.2912 37.0477 21.3133 37.832 21.3161Z",
        fill: "#804B24"
      }),
      /* @__PURE__ */ _jsxs66("defs", {
        children: [
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint0_linear_5994_44784",
            x1: "32.2009",
            y1: "24.4436",
            x2: "20.7755",
            y2: "23.9851",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint1_linear_5994_44784",
            x1: "20.6808",
            y1: "18.4931",
            x2: "19.8826",
            y2: "9.91618",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint2_linear_5994_44784",
            x1: "18.404",
            y1: "31.2186",
            x2: "27.011",
            y2: "18.9128",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint3_linear_5994_44784",
            x1: "12.1753",
            y1: "36.1217",
            x2: "34.2195",
            y2: "34.4708",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.3118",
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FF8900"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint4_linear_5994_44784",
            x1: "11.7557",
            y1: "16.5216",
            x2: "40.7034",
            y2: "16.5218",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint5_linear_5994_44784",
            x1: "7.08799",
            y1: "16.4789",
            x2: "64.2773",
            y2: "14.6574",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint6_linear_5994_44784",
            x1: "16.1749",
            y1: "9.00429",
            x2: "25.6326",
            y2: "14.1294",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint7_linear_5994_44784",
            x1: "27.0092",
            y1: "16.2805",
            x2: "34.8957",
            y2: "17.3162",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#643800",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#643800"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint8_linear_5994_44784",
            x1: "13.0123",
            y1: "33.6918",
            x2: "14.7229",
            y2: "5.36778",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFA754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint9_linear_5994_44784",
            x1: "39.1965",
            y1: "24.5956",
            x2: "28.0053",
            y2: "24.5955",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint10_linear_5994_44784",
            x1: "39.1965",
            y1: "12.769",
            x2: "27.9991",
            y2: "12.7689",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint11_linear_5994_44784",
            x1: "39.1966",
            y1: "7.46745",
            x2: "28.0054",
            y2: "7.46737",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint12_linear_5994_44784",
            x1: "26.4966",
            y1: "24.5415",
            x2: "32.3256",
            y2: "24.6744",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint13_linear_5994_44784",
            x1: "36.6903",
            y1: "12.6887",
            x2: "30.7485",
            y2: "12.6887",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint14_linear_5994_44784",
            x1: "36.6903",
            y1: "7.4687",
            x2: "30.7485",
            y2: "7.46866",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint15_linear_5994_44784",
            x1: "29.4372",
            y1: "24.6765",
            x2: "26.2668",
            y2: "24.6765",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint16_linear_5994_44784",
            x1: "28.8675",
            y1: "24.5854",
            x2: "25.2216",
            y2: "24.5854",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#E89043"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("radialGradient", {
            id: "paint17_radial_5994_44784",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.8029 11.36) rotate(-15.5933) scale(4.45076 2.06675)",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("radialGradient", {
            id: "paint18_radial_5994_44784",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(33.5071 24.5693) rotate(-2.02716) scale(3.80821 2.49945)",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("radialGradient", {
            id: "paint19_radial_5994_44784",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(33.323 12.297) rotate(0.0544049) scale(4.08977 2.2047)",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("radialGradient", {
            id: "paint20_radial_5994_44784",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(31.9081 7.34113) rotate(0.0539593) scale(3.74453 2.3436)",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint21_linear_5994_44784",
            x1: "29.817",
            y1: "12.832",
            x2: "25.2221",
            y2: "12.8319",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint22_linear_5994_44784",
            x1: "28.8403",
            y1: "12.9934",
            x2: "26.3652",
            y2: "12.9934",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint23_linear_5994_44784",
            x1: "29.6519",
            y1: "7.43929",
            x2: "24.2783",
            y2: "8.42612",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint24_linear_5994_44784",
            x1: "29.0962",
            y1: "7.61389",
            x2: "26.8249",
            y2: "7.61388",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint25_linear_5994_44784",
            x1: "32.7167",
            y1: "25.3015",
            x2: "34.1611",
            y2: "18.311",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint26_linear_5994_44784",
            x1: "33.8141",
            y1: "11.49",
            x2: "32.2382",
            y2: "17.1759",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint27_linear_5994_44784",
            x1: "39.1966",
            y1: "18.1977",
            x2: "28.0054",
            y2: "18.1976",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint28_linear_5994_44784",
            x1: "27.5538",
            y1: "18.5102",
            x2: "36.1265",
            y2: "18.1971",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFCB4B"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.7382",
                stopColor: "#FFD748"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFCB4B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint29_linear_5994_44784",
            x1: "30.8992",
            y1: "18.3136",
            x2: "24.4944",
            y2: "18.3136",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FBA23B",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("radialGradient", {
            id: "paint30_radial_5994_44784",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(34.618 18.3024) rotate(2.73604) scale(4.18768 2.74866)",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint31_linear_5994_44784",
            x1: "27.9221",
            y1: "18.3209",
            x2: "25.8999",
            y2: "18.3209",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                offset: "0.00132565",
                stopColor: "#FFBC47"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FBA23B"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint32_linear_5994_44784",
            x1: "33.2479",
            y1: "18.9387",
            x2: "34.4643",
            y2: "11.2072",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint33_linear_5994_44784",
            x1: "32.4049",
            y1: "12.9572",
            x2: "35.5214",
            y2: "6.19551",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint34_linear_5994_44784",
            x1: "31.7844",
            y1: "7.02502",
            x2: "32.2405",
            y2: "2.75079",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint35_linear_5994_44784",
            x1: "31.8919",
            y1: "7.67417",
            x2: "31.8919",
            y2: "10.766",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint36_linear_5994_44784",
            x1: "10.6504",
            y1: "19.0169",
            x2: "6.65941",
            y2: "31.1831",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#C86F34",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint37_linear_5994_44784",
            x1: "11.3449",
            y1: "11.6341",
            x2: "11.1169",
            y2: "2.91458",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("radialGradient", {
            id: "paint38_radial_5994_44784",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(25.1262 39.4782) rotate(-79.0714) scale(4.01535 2.35552)",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FBE07A"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#FFD748",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs66("linearGradient", {
            id: "paint39_linear_5994_44784",
            x1: "23.5494",
            y1: "26.0887",
            x2: "26.4763",
            y2: "52.5508",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx153("stop", {
                stopColor: "#FFBC47",
                stopOpacity: "0"
              }),
              /* @__PURE__ */ _jsx153("stop", {
                offset: "1",
                stopColor: "#C86F34"
              })
            ]
          })
        ]
      })
    ]
  }));
};
var ThumbsDown_default = ThumbsDown;

// src/shared/ui/checkbox/shared/ui.tsx
import styled9 from "styled-components";
import { Checkbox as MuiCheckbox } from "@mui/material";
var StyledCheckbox = styled9(MuiCheckbox)`
  &.MuiCheckbox-root {
    display: flex;
    position: relative;
    padding: 0;
    width: 2rem;
    height: 2rem;
    background: ${({ checked = false }) => checked ? getCssVar("blue", 500) : "transparent"};
    border: 1px solid transparent;
    border-color: ${({ checked = false }) => checked ? getCssVar("blue", 500) : getCssVar("grey", 500)};
    border-radius: 0.4rem;
    transition: all 0.27s;

    &:hover {
      background: ${({ checked = false }) => checked ? getCssVar("blue", 500) : "transparent"};
    }
    &.Mui-disabled {
      opacity: 0.5;
    }
  }
`;
var CheckboxWrapper = styled9.div`
  display: flex;
  align-items: center;
  margin: 0.8rem 0 0;
  max-width: 100%;
`;
var CheckboxLabel = styled9.label`
  margin-left: 1rem;
  font-size: ${getCssVar("font", "large")};
  color: ${getCssVar("grey", 100)};
  cursor: pointer;
  width: 100%;
`;

// src/shared/ui/checkbox/index.tsx
function _define_property150(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread150(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property150(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys141(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props141(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys141(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties129(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose129(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose129(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Checkbox = (_param) => {
  var { isChecked = false, isRequired = false, label, id, name } = _param, props = _object_without_properties129(_param, [
    "isChecked",
    "isRequired",
    "label",
    "id",
    "name"
  ]);
  const labelComponent = useMemo3(() => {
    if (label) {
      return /* @__PURE__ */ _jsx154(CheckboxLabel, {
        htmlFor: id || name,
        children: label
      });
    }
    return null;
  }, [
    label,
    id,
    name
  ]);
  return /* @__PURE__ */ _jsxs67(CheckboxWrapper, {
    children: [
      /* @__PURE__ */ _jsx154(StyledCheckbox, _object_spread_props141(_object_spread150({
        checked: isChecked,
        required: isRequired,
        id: id || name,
        name
      }, props), {
        icon: /* @__PURE__ */ _jsx154("span", {}),
        checkedIcon: /* @__PURE__ */ _jsx154("span", {
          children: /* @__PURE__ */ _jsx154(Tick_default, {})
        })
      })),
      labelComponent
    ]
  });
};
var checkbox_default = Checkbox;

// src/shared/ui/chip/index.tsx
import { jsx as _jsx155 } from "react/jsx-runtime";

// src/shared/ui/chip/shared/ui.ts
import { Chip as MuiChip } from "@mui/material";
import styled10 from "styled-components";
var ChipComponent = styled10(MuiChip)`
  padding: .8rem;
  height: auto;
  font-family: var(--font-family);
  font-size: ${getCssVar("font", "small")};
  border-color: ${getCssVar("grey", 950)};
  border-radius: 100px;

  & > span {
    padding: 0 .8rem;
  }

  [class*=avatar] {
    margin: 0;
  }
`;

// src/shared/ui/chip/index.tsx
function _define_property151(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread151(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property151(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys142(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props142(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys142(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties130(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose130(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose130(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Chip = (_param) => {
  var { children } = _param, props = _object_without_properties130(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx155(ChipComponent, _object_spread_props142(_object_spread151({}, props), {
    children
  }));
};
var chip_default = Chip;

// src/shared/ui/col/index.tsx
import { jsx as _jsx156 } from "react/jsx-runtime";
import { Grid } from "@mui/material";
function _define_property152(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread152(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property152(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties131(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose131(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose131(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Col = (_param) => {
  var { sx } = _param, props = _object_without_properties131(_param, [
    "sx"
  ]);
  return /* @__PURE__ */ _jsx156(Grid, _object_spread152({
    item: true,
    display: "flex",
    sx: _object_spread152({
      flex: 1,
      flexFlow: "column"
    }, sx)
  }, props));
};
var col_default = Col;

// src/shared/ui/desktop/screen-share-border/index.tsx
import { jsx as _jsx157 } from "react/jsx-runtime";
var ScreenShareBorder = () => /* @__PURE__ */ _jsx157(box_default, {
  sx: {
    display: "grid",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: 1500,
    width: "100%",
    height: "100%",
    background: "transparent",
    border: "4px solid #2FC063",
    pointerEvents: "none"
  }
});

// src/shared/ui/desktop/title-bar/index.tsx
import { jsx as _jsx161, jsxs as _jsxs70 } from "react/jsx-runtime";
import { useEffect as useEffect9 } from "react";

// src/shared/ui/desktop/title-bar/shared/ui/linux-controls.tsx
import { jsx as _jsx158, jsxs as _jsxs68 } from "react/jsx-runtime";
import { isMacOs, isWindows } from "react-device-detect";

// src/shared/ui/desktop/title-bar/shared/ui/ui.tsx
import { Box as Box2 } from "@mui/material";
import styled11 from "styled-components";
var Container = styled11(Box2)`
  width: 46px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
  margin-right: auto;
 -webkit-app-region :  no-drag;

  &:hover, &:focus {
    background-color: #3A3C41;

    svg rect {
      fill:  #EBEDF0;
    }
  }

  &:active {
    background-color: #4E5158;

   svg rect { fill:  #EBEDF0; },
  }
`;
var InnerContainer = styled11(Box2)`
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 8px;
  margin-right: 8px;
  -webkit-app-region: no-drag;
`;

// src/units/desktop/context-bridge/index.ts
import { isElectron } from "react-device-detect";
function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator2(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var ContextBridge = class {
  proxy(params) {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.proxyMessage(params);
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  getSettingsOpen() {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getSettingsOpen();
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  getSources() {
    return _async_to_generator2(function* () {
      try {
        var _window_electron, _window;
        return yield (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getSources();
      } catch (error) {
        if (isElectron && error instanceof Error) {
          console.error(error);
        }
        return null;
      }
    })();
  }
  getPreventDisplaySleep(enable) {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getPreventDisplaySleep(enable);
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  getVersion() {
    return _async_to_generator2(function* () {
      try {
        var _window_electron, _window;
        return yield (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getVersion();
      } catch (error) {
        if (isElectron && error instanceof Error) {
          console.error(error);
        }
        return null;
      }
    })();
  }
  getOpenBrowserPage(url) {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getOpenBrowserPage(url);
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  restartAfterUpdate() {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.restartAfterUpdate();
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  downloadFile(file) {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.downloadFile(file);
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  quit() {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.quit();
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  openAutotestWindow(url) {
    try {
      var _window_electron, _window;
      (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.openAutotestWindow(url);
    } catch (error) {
      if (isElectron && error instanceof Error) {
        console.error(error);
      }
    }
  }
  getPermissions(type) {
    return _async_to_generator2(function* () {
      try {
        var _window_electron, _window;
        return yield (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getPermissions(type);
      } catch (error) {
        if (isElectron && error instanceof Error) {
          console.error(error);
        }
        return null;
      }
    })();
  }
  getWindowsSupportInfo() {
    return _async_to_generator2(function* () {
      try {
        var _window_electron, _window;
        return yield (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getWindowsSupportInfo();
      } catch (error) {
        if (isElectron && error instanceof Error) {
          console.error(error);
        }
        return null;
      }
    })();
  }
};

// src/units/desktop/services/proxy/index.ts
import { isElectron as isElectron2 } from "react-device-detect";
var ProxyService = class {
  /**
  * Метод для отправки данных.
  *
  * @param params Данные для отправки.
  */
  send(params) {
    if (!isElectron2) {
      return;
    }
    try {
      this.contextBridge.proxy(JSON.stringify(params));
    } catch (error) {
      if (error instanceof Error) {
        console.error(error);
      }
    }
  }
  /**
  * Метод для обработки данных.
  *
  * @param params Данные обработки.
  * @returns Обработанные данные.
  */
  parse(params) {
    if (!isElectron2) {
      return null;
    }
    try {
      return JSON.parse(params);
    } catch (error) {
      if (error instanceof Error) {
        console.error(error);
      }
      return null;
    }
  }
  constructor({ contextBridge }) {
    this.contextBridge = contextBridge;
  }
};
var proxyMessage = new ProxyService({
  contextBridge: new ContextBridge()
});

// src/units/desktop/modules/app/index.ts
function asyncGeneratorStep3(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator3(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep3(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep3(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var App = class {
  isOpen() {
    var _this = this;
    return _async_to_generator3(function* () {
      return new Promise((resolve) => {
        let timeout = null;
        const handleProxyParams = (event) => {
          const params = _this.proxy.parse(event.data);
          if (params === null) {
            return;
          }
          if (params.type === "app") {
            if (params.data.action.name === "is-open") {
              if (timeout) {
                clearTimeout(timeout);
              }
              window.removeEventListener("message", handleProxyParams);
              return resolve(true);
            }
          }
        };
        window.addEventListener("message", handleProxyParams);
        _this.proxy.send({
          type: "app",
          data: {
            action: {
              name: "is-open"
            }
          }
        });
        timeout = setTimeout(() => {
          window.removeEventListener("message", handleProxyParams);
          return resolve(false);
        }, 250);
      });
    })();
  }
  constructor({ proxy }) {
    this.proxy = proxy;
  }
};

// src/units/desktop/modules/notifications/index.ts
var Notifications = class {
  get toast() {
    const show = (params) => {
      this.version.compare("5.6.0").on("above-or-equal", () => {
        this.proxy.send({
          type: "notifications",
          data: {
            action: {
              name: "base",
              value: params
            }
          }
        });
      });
    };
    return {
      show
    };
  }
  get badge() {
    const show = () => {
      this.version.compare("5.6.0").on("above-or-equal", () => {
        this.proxy.send({
          type: "notifications",
          data: {
            action: {
              name: "icon",
              value: true
            }
          }
        });
      });
    };
    const close = () => {
      this.version.compare("5.6.0").on("above-or-equal", () => {
        this.proxy.send({
          type: "notifications",
          data: {
            action: {
              name: "icon",
              value: false
            }
          }
        });
      });
    };
    return {
      show,
      close
    };
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
  }
};

// src/units/desktop/modules/version/hooks/index.ts
import { useEffect, useState as useState2 } from "react";
function asyncGeneratorStep4(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator4(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep4(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep4(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var useCompareVersion = (version) => {
  const [value, setValue] = useState2(CompareVersion.Default);
  const prepareVersion2 = (version2) => Number(version2.split(".").join(""));
  const getVersion = function() {
    var _ref = _async_to_generator4(function* () {
      try {
        const appVersionRaw = yield desktop.contextBridge.getVersion();
        const appVersion = prepareVersion2(appVersionRaw);
        const versionRaw = prepareVersion2(version);
        if (appVersion > versionRaw) {
          setValue(CompareVersion.Above);
        }
        if (appVersion < versionRaw) {
          setValue(CompareVersion.Less);
        }
        if (appVersion === versionRaw) {
          setValue(CompareVersion.Equal);
        }
      } catch (error) {
        setValue(CompareVersion.Error);
      }
    });
    return function getVersion2() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(() => {
    getVersion();
  }, []);
  return value;
};

// src/units/desktop/modules/version/index.ts
function asyncGeneratorStep5(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator5(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep5(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep5(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var Version = class {
  prepareVersion(appVersion, version) {
    const appVersionPatch = appVersion.split(".").slice(-1).join("");
    let versionPatch = version.split(".").slice(-1).join("");
    if (versionPatch.length === appVersionPatch.length) {
      return Number([
        ...version.split(".").slice(0, 2),
        versionPatch
      ].join(""));
    }
    if (versionPatch.length > appVersionPatch.length) {
      return Number([
        ...version.split(".").slice(0, 2),
        versionPatch.slice(0, appVersionPatch.length)
      ].join(""));
    }
    while (appVersionPatch.length > versionPatch.length) {
      versionPatch += 0;
    }
    return Number([
      ...version.split(".").slice(0, 2),
      versionPatch
    ].join(""));
  }
  get() {
    return this.contextBridge.getVersion();
  }
  compare(version) {
    var _this = this;
    const on = function() {
      var _ref = _async_to_generator5(function* (event, callback) {
        try {
          const appVersionRaw = yield _this.contextBridge.getVersion();
          const appVersion = _this.prepareVersion(appVersionRaw, appVersionRaw);
          const versionRaw = _this.prepareVersion(appVersionRaw, version);
          if (event === "less" && appVersion < versionRaw) {
            return callback();
          }
          if (event === "less-or-equal" && appVersion <= versionRaw) {
            return callback();
          }
          if (event === "equal" && appVersion === versionRaw) {
            return callback();
          }
          if (event === "above-or-equal" && appVersion >= versionRaw) {
            return callback();
          }
          if (event === "above" && appVersion > versionRaw) {
            return callback();
          }
        } catch (error) {
          if (error instanceof Error) {
            return callback(error);
          }
        }
      });
      return function on2(event, callback) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      on
    };
  }
  constructor({ contextBridge }) {
    this.contextBridge = contextBridge;
    this.hooks = {
      useCompareVersion
    };
  }
};

// src/units/desktop/event/index.ts
var Event = class {
  get window() {
    return {
      main: {
        on: (type, callback) => {
          const handleProxyParams = (event) => {
            const params = this.proxy.parse(event.data);
            if (params === null) {
              return;
            }
            if (params.type === "event") {
              if (type === "focus" && params.data.action.name === "main-window-focus") {
                callback();
              }
            }
          };
          window.addEventListener("message", handleProxyParams);
        },
        show: () => {
          this.version.compare("5.9.0").on("above-or-equal", () => {
            this.proxy.send({
              type: "event",
              data: {
                action: {
                  name: "main-window-show"
                }
              }
            });
          });
        }
      }
    };
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
  }
};

// src/units/desktop/modules/reactions/index.ts
var Reactions2 = class {
  show(params) {
    this.version.compare("5.5.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "reactions",
        data: {
          action: {
            name: "show",
            value: params
          }
        }
      });
    });
  }
  close() {
    this.version.compare("5.5.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "reactions",
        data: {
          action: {
            name: "close"
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
  }
};

// src/units/desktop/modules/calls/hooks/index.ts
import { useEffect as useEffect2, useRef as useRef2 } from "react";
var useCalls = ({ incomingCallData, onAcceptCallDeprecated, onCancelCallDeprecated, onAcceptedCallDeprecated, onAcceptCall, onCancelCall, onAcceptedCall, isInConference, isAdmin, accessToken }) => {
  const callsTimeout = useRef2(null);
  useEffect2(() => {
    const handleProxyParams = (event) => {
      const params = proxyMessage.parse(event.data);
      if (params === null) {
        return;
      }
      if (params.type === "calls") {
        var _params_data, _params_data_actions, _params_data_actions1, _params_data_actions2;
        const { callId, slug } = ((_params_data = params.data) === null || _params_data === void 0 ? void 0 : _params_data.incomingCallData) || {};
        if ((_params_data_actions = params.data.actions) === null || _params_data_actions === void 0 ? void 0 : _params_data_actions.onAcceptCall) {
          if (callId) {
            onAcceptCallDeprecated({
              callId
            });
          }
        }
        if ((_params_data_actions1 = params.data.actions) === null || _params_data_actions1 === void 0 ? void 0 : _params_data_actions1.onCancelCall) {
          if (callId) {
            onCancelCallDeprecated({
              callId
            });
          }
        }
        if ((_params_data_actions2 = params.data.actions) === null || _params_data_actions2 === void 0 ? void 0 : _params_data_actions2.onAcceptedCall) {
          if (slug) {
            onAcceptedCallDeprecated(slug);
          }
        }
      }
      desktop.module.version.compare("5.6.0").on("above-or-equal", () => {
        const params2 = proxyMessage.parse(event.data);
        if (params2.type === "calls") {
          if (params2.data.action.name === "accept") {
            if (params2.data.action.value) {
              onAcceptCall(params2.data.action.value);
            }
          }
          if (params2.data.action.name === "decline") {
            if (params2.data.action.value) {
              onCancelCall(params2.data.action.value);
            }
          }
          if (params2.data.action.name === "accepted") {
            if (params2.data.action.value) {
              onAcceptedCall(params2.data.action.value);
            }
          }
        }
      });
    };
    window.addEventListener("message", handleProxyParams);
    return () => {
      window.removeEventListener("message", handleProxyParams);
    };
  }, []);
  useEffect2(() => {
    if (incomingCallData === null || incomingCallData === void 0) {
      proxyMessage.send({
        type: "calls",
        data: {
          actions: {
            show: false
          }
        }
      });
      desktop.module.calls.close();
    } else if (incomingCallData.callStatus === "declinedByCaller" || incomingCallData.callStatus === "accepted" || incomingCallData.callStatus === "busy" || incomingCallData.callStatus === "closed" || incomingCallData.callStatus === "declined" || incomingCallData.callStatus === "declinedByTarget" || incomingCallData.callStatus === "notAnswered") {
      callsTimeout.current = setTimeout(() => {
        proxyMessage.send({
          type: "calls",
          data: {
            actions: {
              show: false
            }
          }
        });
      }, 500);
      desktop.module.calls.show({
        incomingCallData,
        isInConference,
        isAdmin,
        accessToken
      });
    } else {
      proxyMessage.send({
        type: "calls",
        data: {
          actions: {
            show: true
          }
        }
      });
      desktop.module.calls.show({
        incomingCallData,
        isInConference,
        isAdmin,
        accessToken
      });
    }
    proxyMessage.send({
      type: "windows-communication",
      window: "calls-window",
      data: {
        type: "calls",
        data: {
          incomingCallData,
          isInConference,
          isAdmin,
          accessToken: localStorage.getItem("vc-access-token") || ""
        }
      }
    });
    return () => {
      if (callsTimeout.current) {
        clearTimeout(callsTimeout.current);
      }
    };
  }, [
    incomingCallData
  ]);
};

// src/units/desktop/modules/calls/index.ts
function asyncGeneratorStep6(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator6(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep6(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep6(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var Calls = class {
  show(params) {
    var _this = this;
    return _async_to_generator6(function* () {
      _this.version.compare("5.6.0").on("above-or-equal", () => {
        _this.proxy.send({
          type: "calls",
          data: {
            action: {
              name: "show",
              value: params
            }
          }
        });
      });
    })();
  }
  close() {
    var _this = this;
    return _async_to_generator6(function* () {
      _this.version.compare("5.6.0").on("above-or-equal", () => {
        _this.proxy.send({
          type: "calls",
          data: {
            action: {
              name: "close"
            }
          }
        });
      });
    })();
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
    this.hooks = {
      useCalls
    };
  }
};

// src/units/desktop/modules/screen-share/hooks/index.ts
import { useEffect as useEffect3 } from "react";
var useScreenShare = ({ screenShareInfo }) => {
  useEffect3(() => {
    if (screenShareInfo && screenShareInfo.isYourScreenSharing) {
      desktop.module.screenShare.active({
        isUserScreenShare: screenShareInfo.isYourScreenSharing
      });
    }
    if (screenShareInfo === null) {
      desktop.module.screenShare.inactive();
    }
    if (screenShareInfo) {
      desktop.module.screenShare.setIsScreenShare(true);
      if (screenShareInfo.isYourScreenSharing) {
        desktop.module.screenShare.setIsScreenShareByUser(true);
      }
    } else {
      desktop.module.screenShare.setIsScreenShare(false);
      desktop.module.screenShare.setIsScreenShareByUser(false);
    }
  }, [
    screenShareInfo
  ]);
};

// src/units/desktop/modules/screen-share/index.ts
var ScreenShare = class {
  active({ isUserScreenShare }) {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "screen-share",
        data: {
          action: {
            name: "active",
            value: {
              isUserScreenShare
            }
          }
        }
      });
      this.border.show();
      this.controls.show();
    });
  }
  inactive() {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "screen-share",
        data: {
          action: {
            name: "inactive"
          }
        }
      });
      this.border.close();
      this.waitingRoom.close();
      this.reactions.close();
      this.controls.close();
      this.draw.close();
    });
  }
  setIsScreenShareByUser(isScreenShareByUser) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "screen-share",
        data: {
          action: {
            name: "is-screen-share-by-user",
            value: isScreenShareByUser
          }
        }
      });
    });
  }
  setIsScreenShare(isScreenShare) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "screen-share",
        data: {
          action: {
            name: "is-screen-share",
            value: isScreenShare
          }
        }
      });
    });
  }
  constructor({ proxy, version, border: border2, waitingRoom, reactions, controls, draw }) {
    this.proxy = proxy;
    this.version = version;
    this.border = border2;
    this.waitingRoom = waitingRoom;
    this.reactions = reactions;
    this.controls = controls;
    this.draw = draw;
    this.hooks = {
      useScreenShare
    };
  }
};

// src/units/desktop/modules/url/index.ts
var URL = class {
  navigate(url) {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "url",
        data: {
          action: {
            name: "navigate",
            value: url
          }
        }
      });
    });
  }
  external(url) {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "url",
        data: {
          action: {
            name: "external",
            value: url
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
  }
};

// src/units/desktop/modules/border/index.ts
var Border = class {
  show() {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "border",
        data: {
          action: {
            name: "show"
          }
        }
      });
    });
  }
  close() {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "border",
        data: {
          action: {
            name: "close"
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
  }
};

// src/units/desktop/modules/waiting-room/hooks/index.ts
import { useEffect as useEffect4 } from "react";
var useWaitingRoom = ({ speakersInWaitingRoom, screenSharingInfo, approveOneInWaitingRoom, declineOneInWaitingRoom, accessToken }) => {
  useEffect4(() => {
    const handleProxyParams = (event) => {
      const params = proxyMessage.parse(event.data);
      if (params === null) {
        return;
      }
      if (params.type === "waiting-room") {
        if (params.data.action.name === "approve-speaker") {
          approveOneInWaitingRoom(params.data.action.value);
        }
        if (params.data.action.name === "decline-speaker") {
          declineOneInWaitingRoom(params.data.action.value);
        }
      }
    };
    window.addEventListener("message", handleProxyParams);
    return () => {
      window.removeEventListener("message", handleProxyParams);
    };
  }, []);
  useEffect4(() => {
    if (screenSharingInfo === null || screenSharingInfo === void 0 ? void 0 : screenSharingInfo.isYourScreenSharing) {
      desktop.module.waitingRoom.show({
        speaker: speakersInWaitingRoom[0],
        speakersCount: speakersInWaitingRoom.length,
        accessToken
      });
    }
  }, [
    speakersInWaitingRoom,
    screenSharingInfo,
    accessToken
  ]);
};

// src/units/desktop/modules/waiting-room/index.ts
var WaitingRoom = class {
  show(params) {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "waiting-room",
        data: {
          action: {
            name: "speaker",
            value: params
          }
        }
      });
    });
  }
  close() {
    this.version.compare("5.6.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "waiting-room",
        data: {
          action: {
            name: "close"
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
    this.hooks = {
      useWaitingRoom
    };
  }
};

// src/units/desktop/modules/controls/hooks/index.ts
import { useEffect as useEffect5 } from "react";
var useControls = ({ isMic, toggleMic, isCam, toggleCam, toggleScreenShare }) => {
  useEffect5(() => {
    const handleProxyParams = (event) => {
      desktop.module.version.compare("5.9.0").on("above-or-equal", () => {
        const params = proxyMessage.parse(event.data);
        if (params === null) {
          return;
        }
        if (params.type === "controls") {
          if (params.data.action.name === "toggle-mic") {
            toggleMic();
          }
          if (params.data.action.name === "toggle-cam") {
            toggleCam();
          }
          if (params.data.action.name === "toggle-screen-share") {
            toggleScreenShare();
          }
        }
      });
    };
    window.addEventListener("message", handleProxyParams);
    return () => {
      window.removeEventListener("message", handleProxyParams);
    };
  }, []);
  useEffect5(() => {
    desktop.module.controls.setIsMic(Boolean(isMic));
  }, [
    isMic
  ]);
  useEffect5(() => {
    desktop.module.controls.setIsCam(Boolean(isCam));
  }, [
    isCam
  ]);
};

// src/units/desktop/modules/controls/index.ts
var Controls = class {
  show() {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "controls",
        data: {
          action: {
            name: "params"
          }
        }
      });
    });
  }
  close() {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "controls",
        data: {
          action: {
            name: "close"
          }
        }
      });
    });
  }
  setIsMic(isMic) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "controls",
        data: {
          action: {
            name: "is-mic",
            value: isMic
          }
        }
      });
    });
  }
  setIsCam(isCam) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "controls",
        data: {
          action: {
            name: "is-cam",
            value: isCam
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
    this.hooks = {
      useControls
    };
  }
};

// src/units/desktop/modules/draw/index.ts
var Draw = class {
  close() {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "draw",
        data: {
          action: {
            name: "close"
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
  }
};

// src/units/desktop/modules/pip/hooks/index.ts
import { useEffect as useEffect6 } from "react";
var usePiP = ({ isPiP, isBrowserPiP, speakersCount, isPiPMinimize, isPiPMenu, togglePiP }) => {
  useEffect6(() => {
    const handleProxyParams = (event) => {
      desktop.module.version.compare("5.9.0").on("above-or-equal", () => {
        const params = proxyMessage.parse(event.data);
        if (params === null) {
          return;
        }
        if (params.type === "pip") {
          if (params.data.action.name === "toggle-pip") {
            togglePiP();
          }
        }
      });
    };
    window.addEventListener("message", handleProxyParams);
    return () => {
      window.removeEventListener("message", handleProxyParams);
    };
  }, []);
  useEffect6(() => {
    desktop.module.pip.setIsPiP(Boolean(isPiP));
  }, [
    isPiP
  ]);
  useEffect6(() => {
    desktop.module.pip.setIsBrowserPiP(Boolean(isBrowserPiP));
  }, [
    isBrowserPiP
  ]);
  useEffect6(() => {
    desktop.module.pip.setSpeakersCount(speakersCount || 0);
  }, [
    speakersCount
  ]);
  useEffect6(() => {
    desktop.module.pip.setIsPiPMinimize(Boolean(isPiPMinimize));
  }, [
    isPiPMinimize
  ]);
  useEffect6(() => {
    desktop.module.pip.setIsPiPMenu(Boolean(isPiPMenu));
  }, [
    isPiPMenu
  ]);
};

// src/units/desktop/modules/pip/index.ts
var PiP = class {
  setIsPiP(isPiP) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "pip",
        data: {
          action: {
            name: "is-pip",
            value: isPiP
          }
        }
      });
    });
  }
  setIsBrowserPiP(isBrowserPiP) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "pip",
        data: {
          action: {
            name: "is-browser-pip",
            value: isBrowserPiP
          }
        }
      });
    });
  }
  setSpeakersCount(speakersCount) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "pip",
        data: {
          action: {
            name: "speakers-count",
            value: speakersCount
          }
        }
      });
    });
  }
  setIsPiPMinimize(isPiPMinimize) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "pip",
        data: {
          action: {
            name: "is-pip-minimize",
            value: isPiPMinimize
          }
        }
      });
    });
  }
  setIsPiPMenu(isPiPMenu) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "pip",
        data: {
          action: {
            name: "is-pip-menu",
            value: isPiPMenu
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
    this.hooks = {
      usePiP
    };
  }
};

// src/units/desktop/modules/events/hooks/index.ts
import { useEffect as useEffect7, useState as useState3 } from "react";
var useEvents = ({ isUserInEvent, setIsCloseModal, setIsOpenModal }) => {
  const [isCloseAllow, setIsCloseAllow] = useState3(false);
  const [isOpenAllow, setIsOpenAllow] = useState3(false);
  const [isCloseDeny, setIsCloseDeny] = useState3(false);
  const [isOpenDeny, setIsOpenDeny] = useState3(false);
  useEffect7(() => {
    const handleProxyParams = (event) => {
      desktop.module.version.compare("5.9.0").on("above-or-equal", () => {
        const params = proxyMessage.parse(event.data);
        if (params === null) {
          return;
        }
        if (params.type === "events") {
          if (params.data.action.name === "is-close-by-user-status") {
            if (isUserInEvent && params.data.action.value === "request") {
              setIsCloseModal && setIsCloseModal(true);
              setIsOpenModal && setIsOpenModal(false);
            }
          }
          if (params.data.action.name === "is-open-by-user-status") {
            if (isUserInEvent && params.data.action.value === "request") {
              setIsOpenModal && setIsOpenModal(true);
              setIsCloseModal && setIsCloseModal(false);
            }
          }
        }
      });
    };
    window.addEventListener("message", handleProxyParams);
    return () => {
      window.removeEventListener("message", handleProxyParams);
    };
  }, [
    isUserInEvent
  ]);
  useEffect7(() => {
    desktop.module.events.setIsUserInEvent(Boolean(isUserInEvent));
  }, [
    isUserInEvent
  ]);
  useEffect7(() => {
    if (isCloseAllow) {
      desktop.module.events.setIsCloseByUserStatus("allow");
    }
  }, [
    isCloseAllow
  ]);
  useEffect7(() => {
    if (isCloseDeny) {
      desktop.module.events.setIsCloseByUserStatus("deny");
    }
  }, [
    isCloseDeny
  ]);
  useEffect7(() => {
    if (isOpenAllow) {
      desktop.module.events.setIsOpenByUserStatus("allow");
    }
  }, [
    isOpenAllow
  ]);
  useEffect7(() => {
    if (isOpenDeny) {
      desktop.module.events.setIsOpenByUserStatus("deny");
    }
  }, [
    isOpenDeny
  ]);
  return {
    setIsCloseAllow,
    setIsOpenAllow,
    setIsCloseDeny,
    setIsOpenDeny
  };
};
var useContentLoader = ({ slug }) => {
  const [isOpenUrl, setIsOpenUrl] = useState3("");
  const [isContentLoaderStatus, setIsContentLoaderStatus] = useState3("default");
  const [isContentLoader, setIsContentLoader] = useState3(false);
  useEffect7(() => {
    const handleProxyParams = (event) => {
      desktop.module.version.compare("5.9.0").on("above-or-equal", () => {
        const params = proxyMessage.parse(event.data);
        if (params === null) {
          return;
        }
        if (params.type === "events") {
          if (params.data.action.name === "is-open-url") {
            setIsOpenUrl(params.data.action.value);
          }
          if (params.data.action.name === "is-content-loader-status") {
            setIsContentLoaderStatus(params.data.action.value);
          }
        }
      });
    };
    window.addEventListener("message", handleProxyParams);
    return () => {
      window.removeEventListener("message", handleProxyParams);
    };
  }, []);
  useEffect7(() => {
    if (isContentLoaderStatus === "pending" && slug === isOpenUrl) {
      setIsContentLoader(true);
    }
    if (isContentLoaderStatus === "pending" && slug !== isOpenUrl) {
      setIsContentLoader(false);
    }
    if (isContentLoaderStatus === "success" || isContentLoaderStatus === "default") {
      setIsContentLoader(false);
    }
  }, [
    isContentLoaderStatus,
    isOpenUrl,
    slug
  ]);
  return {
    isContentLoader
  };
};

// src/units/desktop/modules/events/index.ts
var Events = class {
  setIsUserInEvent(isUserInEvent) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "events",
        data: {
          action: {
            name: "is-user-in-event",
            value: isUserInEvent
          }
        }
      });
    });
  }
  setIsCloseByUserStatus(isCloseByUserStatus) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "events",
        data: {
          action: {
            name: "is-close-by-user-status",
            value: isCloseByUserStatus
          }
        }
      });
    });
  }
  setIsOpenByUserStatus(isOpenByUserStatus) {
    this.version.compare("5.9.0").on("above-or-equal", () => {
      this.proxy.send({
        type: "events",
        data: {
          action: {
            name: "is-open-by-user-status",
            value: isOpenByUserStatus
          }
        }
      });
    });
  }
  constructor({ proxy, version }) {
    this.proxy = proxy;
    this.version = version;
    this.hooks = {
      useEvents,
      useContentLoader
    };
  }
};

// src/units/desktop/index.ts
var Desktop = class {
  constructor() {
    const contextBridge = new ContextBridge();
    const proxy = new ProxyService({
      contextBridge
    });
    const app = new App({
      proxy
    });
    const version = new Version({
      contextBridge
    });
    const notifications = new Notifications({
      proxy,
      version
    });
    const event = new Event({
      proxy,
      version
    });
    const reactions = new Reactions2({
      proxy,
      version
    });
    const calls = new Calls({
      proxy,
      version
    });
    const url = new URL({
      proxy,
      version
    });
    const border2 = new Border({
      proxy,
      version
    });
    const waitingRoom = new WaitingRoom({
      proxy,
      version
    });
    const controls = new Controls({
      proxy,
      version
    });
    const draw = new Draw({
      proxy,
      version
    });
    const screenShare = new ScreenShare({
      proxy,
      version,
      border: border2,
      waitingRoom,
      reactions,
      controls,
      draw
    });
    const pip = new PiP({
      proxy,
      version
    });
    const events = new Events({
      proxy,
      version
    });
    this.contextBridge = contextBridge;
    this.module = {
      app,
      version,
      notifications,
      reactions,
      calls,
      url,
      border: border2,
      screenShare,
      waitingRoom,
      controls,
      draw,
      pip,
      events
    };
    this.event = event;
  }
};
var desktop = new Desktop();

// src/shared/ui/desktop/title-bar/shared/ui/linux-controls.tsx
var LinuxControls = () => {
  const isEventRoute = window.location.href.includes("/event/");
  const windowType = isEventRoute ? "events-window" : "main-window";
  if (isMacOs || isWindows) {
    return null;
  }
  return /* @__PURE__ */ _jsxs68(box_default, {
    sx: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    children: [
      /* @__PURE__ */ _jsx158(Container, {
        onClick: () => {
          proxyMessage.send({
            type: "window",
            window: windowType,
            data: {
              actions: {
                openMenu: true
              }
            }
          });
        },
        children: /* @__PURE__ */ _jsx158(DesktopMenu_default, {})
      }),
      /* @__PURE__ */ _jsxs68(InnerContainer, {
        children: [
          /* @__PURE__ */ _jsx158(box_default, {
            onClick: () => {
              proxyMessage.send({
                type: "window",
                window: windowType,
                data: {
                  actions: {
                    minimize: true
                  }
                }
              });
            },
            sx: {
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1e4,
              borderRadius: "50%",
              "&:hover, &:focus": {
                backgroundColor: "#3A3C41",
                "svg rect": {
                  fill: "#EBEDF0"
                }
              },
              "&:active": {
                backgroundColor: "#4E5158",
                "svg rect": {
                  fill: "#EBEDF0"
                }
              }
            },
            children: /* @__PURE__ */ _jsx158(DesktopMinimize_default, {})
          }),
          /* @__PURE__ */ _jsx158(box_default, {
            onClick: () => {
              proxyMessage.send({
                type: "window",
                window: windowType,
                data: {
                  actions: {
                    maximize: true
                  }
                }
              });
            },
            sx: {
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1e4,
              borderRadius: "50%",
              "&:hover, &:focus": {
                backgroundColor: "#3A3C41",
                "svg rect": {
                  stroke: "#EBEDF0"
                }
              },
              "&:active": {
                backgroundColor: "#4E5158",
                "svg rect": {
                  stroke: "#EBEDF0"
                }
              }
            },
            children: /* @__PURE__ */ _jsx158(DesktopMaximize_default, {})
          }),
          /* @__PURE__ */ _jsx158(box_default, {
            onClick: () => {
              proxyMessage.send({
                type: "window",
                window: windowType,
                data: {
                  actions: {
                    close: true
                  }
                }
              });
            },
            sx: {
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1e4,
              borderRadius: "50%",
              "&:hover, &:focus": {
                backgroundColor: "#F94C4C",
                "svg path": {
                  fill: "#EBEDF0"
                }
              },
              "&:active": {
                backgroundColor: "#F60909",
                "svg path": {
                  fill: "#EBEDF0"
                }
              }
            },
            children: /* @__PURE__ */ _jsx158(DesktopClose_default, {})
          })
        ]
      })
    ]
  });
};

// src/shared/ui/desktop/title-bar/shared/ui/macos-controls.tsx
import { jsx as _jsx159 } from "react/jsx-runtime";
import { Box as Box3 } from "@mui/material";
import { isMacOs as isMacOs2 } from "react-device-detect";
var MacOSControls = () => isMacOs2 ? /* @__PURE__ */ _jsx159(Box3, {
  sx: {
    "-webkit-app-region": "no-drag"
  }
}) : null;

// src/shared/ui/desktop/title-bar/shared/ui/windows-controls.tsx
import { jsx as _jsx160, jsxs as _jsxs69 } from "react/jsx-runtime";
import { Box as Box4 } from "@mui/material";
import { useEffect as useEffect8, useState as useState4 } from "react";
import { isElectron as isElectron3, isWindows as isWindows2 } from "react-device-detect";
var WindowsControls = () => {
  const [isMainWindowMaximize, setIsMainWindowMaximize] = useState4(false);
  const isEventRoute = window.location.href.includes("/event/");
  const windowType = isEventRoute ? "events-window" : "main-window";
  useEffect8(() => {
    if (isElectron3) {
      window.addEventListener("message", (event) => {
        const params = proxyMessage.parse(event.data);
        if ((params === null || params === void 0 ? void 0 : params.type) === "window") {
          var _params_data_state;
          if (typeof ((_params_data_state = params.data.state) === null || _params_data_state === void 0 ? void 0 : _params_data_state.maximize) === "boolean") {
            var _params_data_state1;
            setIsMainWindowMaximize((_params_data_state1 = params.data.state) === null || _params_data_state1 === void 0 ? void 0 : _params_data_state1.maximize);
          }
        }
      });
    }
  }, []);
  return isWindows2 ? /* @__PURE__ */ _jsxs69(Box4, {
    sx: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    children: [
      /* @__PURE__ */ _jsx160(Container, {
        onClick: () => {
          proxyMessage.send({
            type: "window",
            window: windowType,
            data: {
              actions: {
                openMenu: true
              }
            }
          });
        },
        children: /* @__PURE__ */ _jsx160(DesktopMenu_default, {})
      }),
      /* @__PURE__ */ _jsxs69(Box4, {
        sx: {
          display: "flex",
          alignItems: "center",
          marginLeft: "auto",
          "-webkit-app-region": "no-drag"
        },
        children: [
          /* @__PURE__ */ _jsx160(Box4, {
            onClick: () => {
              proxyMessage.send({
                type: "window",
                window: windowType,
                data: {
                  actions: {
                    minimize: true
                  }
                }
              });
            },
            sx: {
              width: "46px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1e4,
              "&:hover, &:focus": {
                backgroundColor: "#3A3C41",
                "svg rect": {
                  fill: "#EBEDF0"
                }
              },
              "&:active": {
                backgroundColor: "#4E5158",
                "svg rect": {
                  fill: "#EBEDF0"
                }
              }
            },
            children: /* @__PURE__ */ _jsx160(DesktopMinimize_default, {})
          }),
          /* @__PURE__ */ _jsx160(Box4, {
            onClick: () => {
              proxyMessage.send({
                type: "window",
                window: windowType,
                data: {
                  actions: {
                    maximize: true
                  }
                }
              });
            },
            sx: {
              width: "46px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1e4,
              "&:hover, &:focus": {
                backgroundColor: "#3A3C41",
                "svg rect": {
                  stroke: "#EBEDF0"
                }
              },
              "&:active": {
                backgroundColor: "#4E5158",
                "svg rect": {
                  stroke: "#EBEDF0"
                }
              }
            },
            children: isMainWindowMaximize ? /* @__PURE__ */ _jsx160(DesktopUnmaximize_default, {}) : /* @__PURE__ */ _jsx160(DesktopMaximize_default, {})
          }),
          /* @__PURE__ */ _jsx160(Box4, {
            onClick: () => {
              proxyMessage.send({
                type: "window",
                window: windowType,
                data: {
                  actions: {
                    close: true
                  }
                }
              });
            },
            sx: {
              width: "46px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1e4,
              "&:hover, &:focus": {
                backgroundColor: "#F94C4C",
                "svg path": {
                  fill: "#EBEDF0"
                }
              },
              "&:active": {
                backgroundColor: "#F60909",
                "svg path": {
                  fill: "#EBEDF0"
                }
              }
            },
            children: /* @__PURE__ */ _jsx160(DesktopClose_default, {})
          })
        ]
      })
    ]
  }) : null;
};

// src/shared/ui/desktop/title-bar/index.tsx
var TitleBar = ({ title = "DION" }) => {
  useEffect9(() => {
    document.title = title;
  }, [
    title
  ]);
  return /* @__PURE__ */ _jsxs70(box_default, {
    sx: {
      position: "fixed",
      display: "flex",
      alignItems: "center",
      width: "100%",
      height: "32px",
      background: "#292A2E",
      boxShadow: "0px 0.5px 0px rgba(0, 0, 0, 0.15), inset 0px -0.5px 0px rgba(0, 0, 0, 0.05)",
      zIndex: 1e4,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "-webkit-app-region": "drag",
      span: {
        fontSize: "13px",
        lineHeight: "16px",
        fontWeight: "700",
        color: "rgba(235, 235, 245, 0.6)",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }
    },
    children: [
      /* @__PURE__ */ _jsx161(MacOSControls, {}),
      /* @__PURE__ */ _jsx161(WindowsControls, {}),
      /* @__PURE__ */ _jsx161(LinuxControls, {}),
      /* @__PURE__ */ _jsx161("span", {
        children: title
      })
    ]
  });
};

// src/shared/ui/desktop/screen-share-controls/index.tsx
import { jsx as _jsx163, jsxs as _jsxs71 } from "react/jsx-runtime";
import { Box as Box5, Typography as Typography2 } from "@mui/material";
import { useEffect as useEffect10, useState as useState5 } from "react";

// src/shared/ui/desktop/screen-share-controls/shared/ui.tsx
import styled12 from "styled-components";
var PanelSubstrateDiv = styled12.div`
  display: flex;
  align-items: end;
  padding-left: 20px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
`;
var PanelShrink = styled12.div`
  position: relative;
  width: 24px;
  height: 24px;
  background-color: #111314;
  color: #ffffff;
  margin-left: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 36px;
  font-weight: 100;
  margin-bottom: 24px;
  cursor: pointer;
  -webkit-app-region: no-drag;

  div {
    position: absolute;
    top: -18px;
  }
`;
var PanelSubstrate = styled12.div`
  display: flex;
  align-items: center;
  width: ${({ isShrink }) => isShrink ? 48 : 400}px;
  background-color: ${({ isShrink }) => isShrink ? "none" : "#111314"};
  border-radius: 8px;
  padding: 4px 18px;
  display: flex;
  column-gap: 18px;
  /* -webkit-app-region: drag; */

  div {
    cursor: pointer;
    -webkit-app-region: no-drag;
  }
`;
var ScreenShareButton = styled12.div`
  cursor: pointer;
  -webkit-app-region: no-drag;
`;
var AudioButton = styled12.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-app-region: no-drag;

  &:hover,
  &:focus {
    svg path {
      opacity: 0.8;
    }
  }

  &:active {
    svg path {
      opacity: 0.5;
    }
  }
`;
var VideoButton = styled12(AudioButton)`
  margin-right: 14px;
`;

// src/shared/ui/tooltip/index.tsx
import { jsx as _jsx162 } from "react/jsx-runtime";
import { styled as styled13, Tooltip as TooltipMUI, tooltipClasses as tooltipClasses2 } from "@mui/material";
import React85 from "react";
function _define_property153(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread153(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property153(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys143(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props143(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys143(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties132(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose132(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose132(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Tooltip2 = styled13((_param) => {
  var { className, title } = _param, props = _object_without_properties132(_param, [
    "className",
    "title"
  ]);
  return /* @__PURE__ */ _jsx162(TooltipMUI, _object_spread_props143(_object_spread153({}, props), {
    title: /* @__PURE__ */ _jsx162("span", {
      style: {
        whiteSpace: "pre-line"
      },
      children: title
    }),
    classes: {
      popper: className
    }
  }));
})(() => ({
  [`& .${tooltipClasses2.tooltip}`]: {
    backgroundColor: getCssVar("grey", 900),
    color: getCssVar("white", 100),
    borderRadius: "4px",
    fontSize: 14,
    padding: "12px",
    filter: "drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.4)) drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.08))"
  },
  [`& .${tooltipClasses2.arrow}`]: {
    color: getCssVar("grey", 900)
  }
}));
var tooltip_default = /* @__PURE__ */ React85.memo(Tooltip2);

// src/shared/ui/desktop/screen-share-controls/index.tsx
var ScreenShareControls = () => {
  const [isMic, setIsMic] = useState5(false);
  const [isCam, setIsCam] = useState5(false);
  const [isTogglePIP, setIsTogglePIP] = useState5(true);
  const [isHover, setIsHover] = useState5(false);
  useEffect10(() => {
    window.addEventListener("message", (event) => {
      const params = proxyMessage.parse(event.data);
      if ((params === null || params === void 0 ? void 0 : params.type) === "controls") {
        var _params_data_state, _params_data, _params_data_state1, _params_data1;
        if (typeof (params === null || params === void 0 ? void 0 : (_params_data = params.data) === null || _params_data === void 0 ? void 0 : (_params_data_state = _params_data.state) === null || _params_data_state === void 0 ? void 0 : _params_data_state.toggleMic) === "boolean") {
          var _params_data_state2, _params_data2;
          setIsMic(params === null || params === void 0 ? void 0 : (_params_data2 = params.data) === null || _params_data2 === void 0 ? void 0 : (_params_data_state2 = _params_data2.state) === null || _params_data_state2 === void 0 ? void 0 : _params_data_state2.toggleMic);
        }
        if (typeof (params === null || params === void 0 ? void 0 : (_params_data1 = params.data) === null || _params_data1 === void 0 ? void 0 : (_params_data_state1 = _params_data1.state) === null || _params_data_state1 === void 0 ? void 0 : _params_data_state1.toggleCam) === "boolean") {
          var _params_data_state3, _params_data3;
          setIsCam(params === null || params === void 0 ? void 0 : (_params_data3 = params.data) === null || _params_data3 === void 0 ? void 0 : (_params_data_state3 = _params_data3.state) === null || _params_data_state3 === void 0 ? void 0 : _params_data_state3.toggleCam);
        }
      }
      if ((params === null || params === void 0 ? void 0 : params.type) === "picture-in-picture") {
        var _params_data_state4;
        if (typeof ((_params_data_state4 = params.data.state) === null || _params_data_state4 === void 0 ? void 0 : _params_data_state4.togglePIP) === "boolean") {
          var _params_data_state5;
          setIsTogglePIP((_params_data_state5 = params.data.state) === null || _params_data_state5 === void 0 ? void 0 : _params_data_state5.togglePIP);
        }
      }
    });
  });
  const handleMicToggle = () => {
    proxyMessage.send({
      type: "windows-communication",
      // @ts-ignore
      window: "events-window",
      data: {
        type: "controls",
        data: {
          actions: {
            toggleMic: !isMic
          }
        }
      }
    });
  };
  const handleVideoToggle = () => {
    proxyMessage.send({
      type: "windows-communication",
      // @ts-ignore
      window: "events-window",
      data: {
        type: "controls",
        data: {
          actions: {
            toggleCam: !isCam
          }
        }
      }
    });
  };
  const handleScreenShareToggle = () => {
    proxyMessage.send({
      type: "windows-communication",
      // @ts-ignore
      window: "events-window",
      data: {
        type: "controls",
        data: {
          actions: {
            toggleScreenShare: true
          }
        }
      }
    });
  };
  return /* @__PURE__ */ _jsxs71(PanelSubstrateDiv, {
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false),
    children: [
      /* @__PURE__ */ _jsxs71(PanelSubstrate, {
        isShrink: false,
        children: [
          /* @__PURE__ */ _jsx163(tooltip_default, {
            title: Translate_default.get(isTogglePIP ? "event.screenShareControls.pip.hidePip" : "event.screenShareControls.pip.showPip"),
            arrow: true,
            placement: "top",
            children: /* @__PURE__ */ _jsx163(AudioButton, {
              onClick: () => {
                proxyMessage.send({
                  type: "picture-in-picture",
                  data: {
                    actions: {
                      togglePIP: !isTogglePIP
                    }
                  }
                });
              },
              children: isTogglePIP ? /* @__PURE__ */ _jsx163(ButtonPip_default, {
                fill: "#2fc063",
                width: "32px",
                height: "32px"
              }) : /* @__PURE__ */ _jsx163(ButtonPip_default, {
                width: "32px",
                height: "32px"
              })
            })
          }),
          /* @__PURE__ */ _jsxs71(Box5, {
            onClick: () => handleScreenShareToggle(),
            sx: {
              display: "flex",
              backgroundColor: "#2fc063",
              borderRadius: "8px",
              padding: "4px 8px 4px 4px",
              alignItems: "center",
              columnGap: "2px",
              width: "100%",
              "&:hover, &:focus": {
                opacity: 0.8
              },
              "&:active": {
                opacity: 0.5
              }
            },
            children: [
              /* @__PURE__ */ _jsx163(ScreenShareButton, {
                children: /* @__PURE__ */ _jsx163(ScreenSharing_default, {
                  fill: "#111314",
                  width: "32px",
                  height: "32px"
                })
              }),
              /* @__PURE__ */ _jsx163(Typography2, {
                sx: {
                  fontSize: "14px",
                  lineHeight: "18px",
                  whiteSpace: "nowrap",
                  userSelect: "none",
                  color: "#000000"
                },
                children: Translate_default.get("event.screenShareControls.screenShare.screenShareOff")
              })
            ]
          }),
          /* @__PURE__ */ _jsxs71(Box5, {
            sx: {
              display: "flex",
              alignItems: "center",
              columnGap: "24px"
            },
            children: [
              /* @__PURE__ */ _jsx163(tooltip_default, {
                title: Translate_default.get(isMic ? "event.screenShareControls.mic.micOff" : "event.screenShareControls.mic.micOn"),
                arrow: true,
                placement: "top",
                children: /* @__PURE__ */ _jsx163(AudioButton, {
                  onClick: handleMicToggle,
                  children: isMic ? /* @__PURE__ */ _jsx163(MicOn_default, {
                    width: "32px",
                    height: "32px"
                  }) : /* @__PURE__ */ _jsx163(MicOff_default, {
                    width: "32px",
                    height: "32px"
                  })
                })
              }),
              /* @__PURE__ */ _jsx163(tooltip_default, {
                title: Translate_default.get(isCam ? "event.screenShareControls.cam.camOff" : "event.screenShareControls.cam.camOn"),
                arrow: true,
                placement: "top",
                children: /* @__PURE__ */ _jsx163(VideoButton, {
                  onClick: handleVideoToggle,
                  children: isCam ? /* @__PURE__ */ _jsx163(CameraOn_default, {
                    width: "32px",
                    height: "32px"
                  }) : /* @__PURE__ */ _jsx163(CameraOff_default, {
                    width: "32px",
                    height: "32px"
                  })
                })
              })
            ]
          })
        ]
      }),
      isHover && /* @__PURE__ */ _jsx163(tooltip_default, {
        title: Translate_default.get("event.screenShareControls.hide"),
        arrow: true,
        placement: "top",
        children: /* @__PURE__ */ _jsx163(PanelShrink, {
          onClick: () => {
            proxyMessage.send({
              type: "window",
              window: "screen-share-controls-window",
              data: {
                actions: {
                  minimize: true
                }
              }
            });
          },
          children: /* @__PURE__ */ _jsx163(Box5, {
            sx: {
              userSelect: "none",
              "&:hover, &:focus": {
                opacity: 0.8
              },
              "&:active": {
                opacity: 0.5
              }
            },
            children: "-"
          })
        })
      })
    ]
  });
};

// src/shared/ui/desktop-calls/index.tsx
import { useEffect as useEffect11, useRef as useRef3 } from "react";
import { isElectron as isElectron4 } from "react-device-detect";
var DesktopCalls = ({ incomingCallData, onAcceptCall, onCancelCall, onAcceptedCall, setIsModalOpen, isInConference, isAdmin }) => {
  const callsTimeout = useRef3(null);
  useEffect11(() => {
    const handleProxyParams = (event) => {
      const params = proxyMessage.parse(event.data);
      if ((params === null || params === void 0 ? void 0 : params.type) === "calls") {
        var _params_data, _params_data_actions, _params_data_actions1, _params_data_actions2, _params_data_actions3;
        const { callId, slug } = ((_params_data = params.data) === null || _params_data === void 0 ? void 0 : _params_data.incomingCallData) || {};
        if ((_params_data_actions = params.data.actions) === null || _params_data_actions === void 0 ? void 0 : _params_data_actions.onAcceptCall) {
          if (callId) {
            onAcceptCall({
              callId
            });
          }
        }
        if (((_params_data_actions1 = params.data.actions) === null || _params_data_actions1 === void 0 ? void 0 : _params_data_actions1.isModalOpen) && setIsModalOpen) {
          var _params_data_actions4;
          setIsModalOpen((_params_data_actions4 = params.data.actions) === null || _params_data_actions4 === void 0 ? void 0 : _params_data_actions4.isModalOpen);
        }
        if ((_params_data_actions2 = params.data.actions) === null || _params_data_actions2 === void 0 ? void 0 : _params_data_actions2.onCancelCall) {
          if (callId) {
            onCancelCall({
              callId
            });
          }
        }
        if ((_params_data_actions3 = params.data.actions) === null || _params_data_actions3 === void 0 ? void 0 : _params_data_actions3.onAcceptedCall) {
          if (slug) {
            onAcceptedCall(slug);
          }
        }
      }
    };
    if (isElectron4) {
      window.addEventListener("message", handleProxyParams);
    }
    return () => {
      if (isElectron4) {
        window.removeEventListener("message", handleProxyParams);
      }
    };
  }, []);
  useEffect11(() => {
    if (isElectron4) {
      if (incomingCallData === null) {
        proxyMessage.send({
          type: "calls",
          data: {
            actions: {
              show: false
            }
          }
        });
      } else if ((incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "declinedByCaller" || (incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "accepted" || (incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "busy" || (incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "closed" || (incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "declined" || (incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "declinedByTarget" || (incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus) === "notAnswered") {
        callsTimeout.current = setTimeout(() => {
          proxyMessage.send({
            type: "calls",
            data: {
              actions: {
                show: false
              }
            }
          });
        }, 500);
      } else {
        proxyMessage.send({
          type: "calls",
          data: {
            actions: {
              show: true
            }
          }
        });
      }
      proxyMessage.send({
        type: "windows-communication",
        window: "calls-window",
        data: {
          type: "calls",
          data: {
            incomingCallData,
            isInConference,
            isAdmin,
            accessToken: localStorage.getItem("vc-access-token") || ""
          }
        }
      });
    }
    return () => {
      if (callsTimeout.current) {
        clearTimeout(callsTimeout.current);
      }
    };
  }, [
    incomingCallData
  ]);
  return null;
};
var desktop_calls_default = DesktopCalls;

// src/shared/ui/form/index.tsx
var import_lodash9 = __toESM(require_lodash());
import { jsx as _jsx164 } from "react/jsx-runtime";
import { useCallback as useCallback2 } from "react";

// src/shared/ui/form/shared/ui.ts
import styled14 from "styled-components";
var StyledFormWrapper = styled14.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  line-height: ${getCssVar("font", "line-height")};
  height: inherit;
  font-size: ${getCssVar("font", "common")};
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
var StyledForm = styled14.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
var getFormComponent = (Component = StyledForm) => styled14(Component)``;

// src/shared/ui/form/index.tsx
function _define_property154(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread154(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property154(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys144(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props144(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys144(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties133(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose133(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose133(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Form = (_param) => {
  var { initialValues: initialValues2 = {}, children, formProvider: FormProvider2, formComponent: FormComponent2, onSubmit, onChange, className } = _param, props = _object_without_properties133(_param, [
    "initialValues",
    "children",
    "formProvider",
    "formComponent",
    "onSubmit",
    "onChange",
    "className"
  ]);
  const renderChildren = useCallback2((props2) => {
    if ((0, import_lodash9.isFunction)(children)) {
      return /* @__PURE__ */ _jsx164(FormComponent2, {
        children: children(props2)
      });
    }
    return /* @__PURE__ */ _jsx164(FormComponent2, {
      children
    });
  }, [
    children
  ]);
  return /* @__PURE__ */ _jsx164(StyledFormWrapper, {
    className,
    children: /* @__PURE__ */ _jsx164(FormProvider2, _object_spread_props144(_object_spread154({
      initialValues: initialValues2,
      onSubmit,
      onChange
    }, props), {
      children: renderChildren
    }))
  });
};
var form_default = Form;

// src/shared/ui/grid/index.tsx
import { jsx as _jsx165 } from "react/jsx-runtime";

// src/shared/ui/grid/shared/ui.ts
import styled15 from "styled-components";
var StyledGrid = styled15.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 0;
  width: 100%;
`;

// src/shared/ui/grid/index.tsx
var Grid2 = ({ children }) => /* @__PURE__ */ _jsx165(StyledGrid, {
  children
});
var grid_default = Grid2;

// src/shared/ui/button-icon-stroke/index.tsx
import styled16 from "styled-components";
var ButtonIconStroke = styled16.button`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${getCssVar("grey", 900)};
  }

  &.light {
    svg {
      stroke: ${getCssVar("grey", 100)};
    }
    &:hover {
      svg {
        stroke: #d2d4d6;
      }
    }
  }
`;
var button_icon_stroke_default = ButtonIconStroke;

// src/shared/ui/icon-button-wrapper/index.tsx
import { jsx as _jsx166 } from "react/jsx-runtime";

// src/shared/ui/icon-button-wrapper/shared/ui.tsx
import { ButtonBase } from "@mui/material";
import { styled as styled17 } from "@mui/material/styles";
var ButtonBaseStyled = styled17(ButtonBase)`
  width: 32px;
  height: 32px;
  display: grid;
  align-items: center;
  justify-content: center;
  
  &:hover { opacity: 0.8}

  &:disabled { opacity: 0.5 }
`;

// src/shared/ui/icon-button-wrapper/index.tsx
function _define_property155(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread155(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property155(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys145(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props145(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys145(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties134(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose134(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose134(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var IconButtonWrapper = (_param) => {
  var { sx, children } = _param, props = _object_without_properties134(_param, [
    "sx",
    "children"
  ]);
  return /* @__PURE__ */ _jsx166(ButtonBaseStyled, _object_spread_props145(_object_spread155({
    disableRipple: true,
    sx
  }, props), {
    children
  }));
};
var icon_button_wrapper_default = IconButtonWrapper;

// src/shared/ui/icon-button-copy/index.tsx
import { jsx as _jsx167 } from "react/jsx-runtime";
import { useState as useState6 } from "react";
function _define_property156(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread156(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property156(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys146(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props146(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys146(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties135(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose135(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose135(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var IconButtonCopy = (_param) => {
  var { copyValue, iconProps } = _param, rest = _object_without_properties135(_param, [
    "copyValue",
    "iconProps"
  ]);
  const [isCopied, setIsCopied] = useState6(false);
  const onCopyClick = () => {
    if (isCopied)
      return;
    copy2Clipboard(copyValue, setIsCopied);
  };
  return /* @__PURE__ */ _jsx167(icon_button_wrapper_default, _object_spread_props146(_object_spread156({
    onClick: onCopyClick,
    style: {
      cursor: isCopied ? "default" : "pointer"
    }
  }, rest), {
    children: isCopied ? /* @__PURE__ */ _jsx167(CopySuccess_default, _object_spread156({}, iconProps)) : /* @__PURE__ */ _jsx167(Copy_default, _object_spread156({}, iconProps))
  }));
};
var icon_button_copy_default = IconButtonCopy;

// src/shared/ui/link/index.tsx
import { jsx as _jsx168 } from "react/jsx-runtime";
import React87, { useMemo as useMemo4 } from "react";

// src/shared/ui/link/shared/ui.ts
import styled18 from "styled-components";
import { Link as MuiLink } from "@mui/material";
var LinkComponent = styled18.a`
  text-transform: inherit;
`;
var StyledLink = styled18(MuiLink)`
  /* font-weight: inherit; */
`;

// src/shared/ui/link/index.tsx
function _define_property157(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread157(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property157(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys147(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props147(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys147(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties136(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose136(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose136(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Link2 = (_param) => {
  var { component: Component = LinkComponent, to, children } = _param, props = _object_without_properties136(_param, [
    "component",
    "to",
    "children"
  ]);
  const Wrapper4 = useMemo4(() => (props2) => {
    if (to) {
      return /* @__PURE__ */ _jsx168(Component, _object_spread157({
        href: to
      }, props2));
    }
    return /* @__PURE__ */ _jsx168(React87.Fragment, _object_spread157({}, props2));
  }, [
    to
  ]);
  return /* @__PURE__ */ _jsx168(Wrapper4, {
    children: /* @__PURE__ */ _jsx168(StyledLink, _object_spread_props147(_object_spread157({}, props), {
      children
    }))
  });
};
var link_default = Link2;

// src/shared/ui/list/index.tsx
import { jsx as _jsx170, jsxs as _jsxs72 } from "react/jsx-runtime";
import React88, { useMemo as useMemo5 } from "react";

// src/shared/ui/spinner/index.tsx
import { jsx as _jsx169 } from "react/jsx-runtime";

// src/shared/ui/spinner/shared/ui.ts
import styled19 from "styled-components";
var SpinnerWrapper = styled19.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;

  .spinner {
    animation: spin .5s infinite linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`;

// src/shared/ui/spinner/index.tsx
var Spinner2 = ({ size = 48, fill = getCssVar("blue", 500), type = "normal", style: style4 }) => /* @__PURE__ */ _jsx169(SpinnerWrapper, {
  style: style4,
  children: type === "small" ? /* @__PURE__ */ _jsx169(SpinnerSmall_default, {
    className: "spinner",
    width: size,
    height: size,
    fill
  }) : /* @__PURE__ */ _jsx169(Spinner_default, {
    className: "spinner",
    width: size,
    height: size,
    fill
  })
});
var spinner_default = Spinner2;

// src/shared/ui/list/shared/ui.ts
import styled20 from "styled-components";
import { ListItemButton as MuiListItemButton, ListItemIcon as MuiListItemIcon, ListItemText as MuiListItemText } from "@mui/material";
var ListWrapper = styled20.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
`;
var ListScroller = styled20.div`
  display: flex;
  flex: 1;
`;
var StyledList = styled20.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  max-width: 100%;
`;
var StyledListItem = styled20.li`
  display: flex;
  flex: 0 1 auto;
  padding: 0;
  color: ${({ isActive }) => isActive ? getCssVar("grey", 950) : getCssVar("grey", 500)};
`;
var StyledListItemButton = styled20(MuiListItemButton)`
  padding: .8rem;
  border-radius: .4rem;
  color: currentColor;
`;
var StyledListItemText = styled20(MuiListItemText)`
  white-space: nowrap;
  color: currentColor;

  span {
    font-weight: inherit;
    color: currentColor;
  }
`;
var StyledListItemIcon = styled20(MuiListItemIcon)`
  display: inline-flex;
  justify-content: center;
  min-width: 3.2rem;
  color: currentColor;
`;

// src/shared/ui/list/index.tsx
var List = /* @__PURE__ */ React88.forwardRef(({ isReady = false, isError = false, className, itemClassName, listClassName, style: style4, itemStyle, listComponent: ListComponent = StyledList, itemComponent: ItemComponent = StyledListItem, emptyContent, errorContent, loader: Loader2 = spinner_default, data, children: _children, renderItem }, ref3) => {
  const children = useMemo5(() => {
    if (isError) {
      return errorContent;
    }
    if (!isReady) {
      return /* @__PURE__ */ _jsx170(Loader2, {});
    }
    if (!data || !data.length) {
      return emptyContent;
    }
    return /* @__PURE__ */ _jsxs72(ListComponent, {
      ref: ref3,
      className: listClassName,
      children: [
        data.map((item, index, data2) => /* @__PURE__ */ _jsx170(ItemComponent, {
          className: itemClassName,
          style: itemStyle,
          children: renderItem(item, index, data2)
        }, index + JSON.stringify(item))),
        _children
      ]
    });
  }, [
    isReady,
    listClassName,
    itemClassName,
    ref3,
    data,
    renderItem,
    _children,
    ListComponent,
    ItemComponent,
    itemStyle
  ]);
  return /* @__PURE__ */ _jsx170(ListWrapper, {
    className,
    style: style4,
    children: /* @__PURE__ */ _jsx170(ListScroller, {
      children
    })
  });
});
List.displayName = "List";
var list_default = /* @__PURE__ */ React88.memo(List);

// src/shared/ui/loader/index.tsx
import { jsx as _jsx171, jsxs as _jsxs73 } from "react/jsx-runtime";

// src/shared/ui/loader/shared.tsx
import styled21 from "styled-components";
var LoaderElement = styled21.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 14.6rem;
  margin-top: 7.3rem;
  margin-bottom: 7.3rem;
  color: #fff;
  font-size: 18px;

  &:before {
    width: 100%;
    padding-bottom: 100%;
    box-shadow: inset 0 0 0 1.7rem #fff;
    animation-name: pulsA;
  }

  &:after {
    width: calc(100% - 1.7rem * 2);
    padding-bottom: calc(100% - 1.7rem * 2);
    box-shadow: 0 0 0 0 #fff;
    animation-name: pulsB;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    border-radius: 50%;
    animation-duration: 1.8s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    filter: drop-shadow(0 0 0.7555555556rem rgba(255, 255, 255, 0.75));
  }

  @keyframes pulsA {
    0% {
      box-shadow: inset 0 0 0 1.7rem #fff;
      opacity: 1;
    }
    50%,
    100% {
      box-shadow: inset 0 0 0 0 #fff;
      opacity: 0;
    }
  }
  @keyframes pulsB {
    0%,
    50% {
      box-shadow: 0 0 0 0 #fff;
      opacity: 0;
    }
    100% {
      box-shadow: 0 0 0 1.7rem #fff;
      opacity: 1;
    }
  }
`;
var LoadingElement = styled21.div`
  opacity: 0.8;

  span {
    display: inline-block;
    animation: pulse 0.4s alternate infinite ease-in-out;

    &:nth-child(odd) {
      animation-delay: 0.4s;
    }
  }

  @keyframes pulse {
    to {
      transform: scale(0.8);
      opacity: 0.5;
    }
  }
`;
var CircleLoader = styled21.div`
  @keyframes loader-1-1 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loader-1-2 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(220deg);
    }
  }

  @keyframes loader-1-3 {
    0% {
      transform: rotate(-140deg);
    }
    50% {
      transform: rotate(-160deg);
    }
    100% {
      transform: rotate(140deg);
    }
  }

  animation: loader-1-1 4.8s linear infinite;
  width: 36px;
  height: 36px;

  span {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    height: 36px;
    width: 36px;
    clip: rect(0, 36px, 36px, 18px);
    animation: loader-1-2 1.2s linear infinite;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 36px;
      width: 36px;
      clip: rect(0, 36px, 36px, 18px);
      border: 3px solid #fff;
      border-radius: 50%;
      animation: loader-1-3 1.2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
    }
  }
`;

// src/shared/ui/loader/index.tsx
var Loader = () => /* @__PURE__ */ _jsx171(LoadingElement, {
  children: /* @__PURE__ */ _jsx171("span", {
    children: /* @__PURE__ */ _jsx171("svg", {
      width: "55px",
      height: "62.5px",
      viewBox: "0 0 22 25",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: /* @__PURE__ */ _jsx171("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: /* @__PURE__ */ _jsx171("g", {
          id: "Desktop-HD",
          transform: "translate(-677.000000, -732.000000)",
          fill: "#EBEDF0",
          fillRule: "nonzero",
          children: /* @__PURE__ */ _jsxs73("g", {
            id: "logo-full",
            transform: "translate(677.231100, 732.063995)",
            children: [
              /* @__PURE__ */ _jsx171("path", {
                d: "M5.73632438,5.02350831 L0.64298285,5.02350831 C0.47247357,5.02350831 0.308944202,4.95508044 0.188291437,4.83328098 C0.0676386714,4.71148151 0,4.54630688 0,4.37405262 L0,0.649498435 C0,0.477254148 0.0676386714,0.31206622 0.188291437,0.190271741 C0.308944202,0.0684772612 0.47247357,5.40143905e-05 0.64298285,5.40143905e-05 L10.0258127,5.40143905e-05 C10.119543,-0.00116846735 10.2126084,0.0183734583 10.2981955,0.057302422 C10.3837825,0.096230721 10.4598968,0.153603936 10.5210541,0.225395655 C10.5823776,0.297189036 10.6274146,0.381659267 10.6528415,0.472876746 C10.6784345,0.564092563 10.6839187,0.659846985 10.6687956,0.753411044 C10.4888135,1.94349768 9.89203106,3.028874 8.98680294,3.81240237 C8.08174101,4.59594735 6.92839364,5.02566065 5.73632438,5.02350831 Z",
                id: "Path"
              }),
              /* @__PURE__ */ _jsx171("path", {
                d: "M8.03005643,18.3370675 L8.03005643,12.0179039 C8.03005643,8.83140783 9.29591333,5.77541953 11.5490954,3.52222083 C13.8022775,1.26902712 16.8583157,0.003195141 20.0448117,0.003195141 L20.7300064,0.003195141 C20.9021775,0.003195141 21.0673688,0.0716232073 21.1891849,0.193417687 C21.311001,0.315212166 21.3794706,0.480395108 21.3794706,0.652639395 L21.3794706,4.37395291 C21.3794706,4.54619055 21.311001,4.7113818 21.1891849,4.83318127 C21.0673688,4.95498073 20.9021775,5.02340049 20.7300064,5.02340049 L14.0503968,5.02340049 C13.8782256,5.02340049 13.7130343,5.09182024 13.5912183,5.21361971 C13.4694022,5.33540256 13.4010987,5.50059381 13.4010987,5.67284807 L13.4010987,11.975692 C13.4010987,15.1621881 12.1352418,18.2182428 9.88205976,20.4714249 C7.62887767,22.724607 4.57283952,23.9904639 1.38634348,23.9904639 L0.665418281,23.9904639 C0.493247118,23.9904639 0.328055866,23.9219943 0.206239782,23.8001782 C0.084423698,23.6783621 0.0159540847,23.5131709 0.0159540847,23.3409997 L0.0159540847,19.6099043 C0.0159540847,19.4377332 0.084423698,19.2725419 0.206239782,19.1507258 C0.328055866,19.0289098 0.493247118,18.9604401 0.665418281,18.9604401 L7.39039734,18.9604401 C7.55658573,18.9581135 7.71546182,18.8921367 7.8344527,18.7761372 C7.95344358,18.6601377 8.02357508,18.5030897 8.03005643,18.3370675 Z",
                id: "Path"
              }),
              /* @__PURE__ */ _jsx171("path", {
                d: "M15.636831,18.9635977 L20.7045796,18.9635977 C20.8759198,18.9635977 21.0404463,19.0320673 21.1615976,19.1537172 C21.2827489,19.2755333 21.3508862,19.4407246 21.3508862,19.6130619 L21.3508862,23.3506386 C21.3508862,23.5228098 21.2827489,23.688001 21.1615976,23.8098171 C21.0404463,23.9316332 20.8759198,23.9999366 20.7045796,23.9999366 L11.331721,23.9999366 C11.2374922,24.0012661 11.1439281,23.9816559 11.0580087,23.9427678 C10.9719232,23.9038798 10.8954765,23.8463786 10.8338206,23.7745852 C10.7723309,23.702958 10.7269615,23.6183681 10.7013685,23.5271307 C10.6757755,23.4358933 10.6702913,23.3401688 10.6854144,23.2466047 C10.8640669,22.0555326 11.4618465,20.9683282 12.3703984,20.1824233 C13.2789503,19.3965185 14.4379481,18.9640963 15.636831,18.9635977 Z",
                id: "Path"
              })
            ]
          })
        })
      })
    })
  })
});
var loader_default = Loader;

// src/shared/ui/menu/index.tsx
import { jsx as _jsx172 } from "react/jsx-runtime";

// src/shared/ui/menu/shared/ui.tsx
import styled22 from "styled-components";
import { Menu as MuiMenu, MenuItem as MuiMenuItem } from "@mui/material";
var StyledMenu = styled22(MuiMenu)``;
var StyledMenuItem = styled22(MuiMenuItem)`
  background: transparent;

  &:active, &[class*=selected] {
    background: ${getCssVar("grey", 900)};

    &:hover {
      background: ${getCssVar("grey", 900)};
    }
  }

  &:hover {
    background: ${getCssVar("grey", 900)};
  }
`;

// src/shared/ui/menu/index.tsx
function _define_property158(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread158(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property158(target, key, source[key]);
    });
  }
  return target;
}
var Menu = (props) => /* @__PURE__ */ _jsx172(StyledMenu, _object_spread158({}, props));
var menu_default = Menu;

// src/shared/ui/modal/index.tsx
import { jsx as _jsx173, jsxs as _jsxs74 } from "react/jsx-runtime";
import { useEffect as useEffect12, useMemo as useMemo6, useRef as useRef4, useState as useState7 } from "react";

// src/shared/ui/modal/shared/ui.tsx
import styled23 from "styled-components";
import { Modal as MuiModal, Typography as Typography3 } from "@mui/material";
var StyledModal = styled23(MuiModal)`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
`;
var ModalContainer = styled23.section`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${getCssVar("grey", 950)};
  outline: 0;
  border: 0 solid transparent;
  border-radius: 0.4rem;
  max-height: 100%;
  box-sizing: border-box;

  @media screen and (max-width: ${breakpoints_default.mobile}px) {
    max-width: 100%;
    padding: 1.6rem 0.6rem 0;
  }
`;
var ModalCloseButton = styled23.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
`;
var ModalTitle = styled23.h4`
  padding: 2.4rem 3.2rem 1rem;
  font-size: ${getCssVar("font", "h4")};
  font-weight: ${getCssVar("font", "bold")};
`;
var ModalContent = styled23.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: ${getCssVar("font", "common")};
  margin-bottom: 3.2rem;
  overflow-y: auto;
  ${TINY_SCROLLBAR_STYLES}


`;
var ChildrenContainer = styled23.div`
  padding: 3.2rem 3.2rem 0;
`;
var ModalFooter = styled23.div`
  align-self: flex-end;
  width: 100%;
  padding: 2.4rem 3.2rem 0;
  position: sticky;
  margin-top: 1.6rem;
  bottom:  0;
  background: var(--dion-grey-950);

  ${(p) => p.isScrollVisible ? `
  border-top: 1px solid #3A3C41;
  ` : ""};

  button {
    min-width: 150px;
  }
`;
var StorySubstrate = styled23.div`
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  justify-content: center;
`;
var ModalButtonsCaption = styled23(Typography3)``;
var ButtonsWrapper = styled23.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;

  ${ModalButtonsCaption} {
    font-size: ${getCssVar("font", "large")};
    margin-left: 1rem;
  }
`;

// src/shared/ui/modal/index.tsx
function _define_property159(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread159(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property159(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys148(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props148(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys148(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties137(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose137(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose137(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Modal = (_param) => {
  var { title, children, actionButtonProps, cancelButtonProps, buttonsCaptionProps, onClose, onCloseIcon, onOpen } = _param, props = _object_without_properties137(_param, [
    "title",
    "children",
    "actionButtonProps",
    "cancelButtonProps",
    "buttonsCaptionProps",
    "onClose",
    "onCloseIcon",
    "onOpen"
  ]);
  const childrenContainerRef = useRef4(null);
  const modalContainerRef = useRef4(null);
  const [isScrollVisible, setIsScrollVisible] = useState7(false);
  useEffect12(() => {
    if (childrenContainerRef.current && modalContainerRef.current) {
      setIsScrollVisible(childrenContainerRef.current.clientHeight > modalContainerRef.current.clientHeight);
    }
  }, [
    childrenContainerRef,
    modalContainerRef
  ]);
  const onSubmit = (event) => {
    event.preventDefault();
    if (actionButtonProps === null || actionButtonProps === void 0 ? void 0 : actionButtonProps.onClick) {
      actionButtonProps.onClick(event);
    }
  };
  const footerContent = useMemo6(() => {
    if (!actionButtonProps && !cancelButtonProps)
      return null;
    return /* @__PURE__ */ _jsx173(ModalFooter, {
      isScrollVisible,
      children: /* @__PURE__ */ _jsxs74(ButtonsWrapper, {
        children: [
          actionButtonProps && /* @__PURE__ */ _jsx173(button_default, _object_spread_props148(_object_spread159({
            type: "submit",
            variant: "contained",
            color: "primary"
          }, actionButtonProps), {
            children: actionButtonProps.children
          })),
          cancelButtonProps && /* @__PURE__ */ _jsx173(button_default, _object_spread_props148(_object_spread159({
            variant: "contained",
            color: "secondary",
            onClick: onClose
          }, cancelButtonProps), {
            children: cancelButtonProps.children || Translate_default.get("buttons.cancel")
          })),
          buttonsCaptionProps && /* @__PURE__ */ _jsx173(ModalButtonsCaption, _object_spread_props148(_object_spread159({}, buttonsCaptionProps), {
            children: buttonsCaptionProps.children
          }))
        ]
      })
    });
  }, [
    actionButtonProps,
    cancelButtonProps
  ]);
  return /* @__PURE__ */ _jsx173(StyledModal, _object_spread_props148(_object_spread159({}, props), {
    onClose,
    children: /* @__PURE__ */ _jsxs74(ModalContainer, {
      children: [
        (onCloseIcon || onClose) && /* @__PURE__ */ _jsx173(ModalCloseButton, {
          onClick: onCloseIcon || onClose,
          children: /* @__PURE__ */ _jsx173(Cross_default, {})
        }),
        title && /* @__PURE__ */ _jsx173(ModalTitle, {
          children: title
        }),
        /* @__PURE__ */ _jsxs74(ModalContent, {
          style: {
            marginTop: title ? 0 : "1.6rem"
          },
          onSubmit,
          ref: modalContainerRef,
          children: [
            /* @__PURE__ */ _jsx173(ChildrenContainer, {
              ref: childrenContainerRef,
              children
            }),
            footerContent
          ]
        })
      ]
    })
  }));
};
var modal_default = Modal;

// src/shared/ui/pagination/index.tsx
import { jsx as _jsx175, jsxs as _jsxs75, Fragment as _Fragment3 } from "react/jsx-runtime";
import React90, { useCallback as useCallback3, useMemo as useMemo7, useState as useState8 } from "react";
import { PaginationItem, useMediaQuery } from "@mui/material";

// src/shared/ui/typography/index.tsx
import { jsx as _jsx174 } from "react/jsx-runtime";

// src/shared/ui/typography/shared/ui.tsx
import { Typography as MuiTypography } from "@mui/material";
import styled24 from "styled-components";
var StyledTypography = styled24(MuiTypography)``;

// src/shared/ui/typography/index.tsx
function _define_property160(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread160(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property160(target, key, source[key]);
    });
  }
  return target;
}
var Typography4 = (props) => /* @__PURE__ */ _jsx174(StyledTypography, _object_spread160({}, props));
var typography_default = Typography4;

// src/shared/ui/pagination/shared/constants.ts
var PAGINATION_LIMITS = [
  10,
  25,
  50
];

// src/shared/ui/pagination/shared/ui.tsx
import styled25 from "styled-components";
import { Pagination as MuiPagination } from "@mui/material";
var PaginationWrapper = styled25.div`
  display: flex;
  align-items: center;
  margin: 2.4rem 0;
`;
var StyledPagination = styled25(MuiPagination)``;
var PaginationDropdown = styled25.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
var PaginationDropdownButton = styled25.button`
  display: flex;
  align-items: center;
  margin-left: .8rem;
  background: transparent;
  font-size: ${getCssVar("font", "common")};
  font-weight: ${getCssVar("font", "bold")};
`;
var PaginationDropdownIcon = styled25.i`
  display: inline-flex;
  margin-left: .8rem;
`;

// src/shared/ui/pagination/index.tsx
function _define_property161(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread161(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property161(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys149(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props149(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys149(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties138(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose138(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose138(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Pagination = (_param) => {
  var { pages, page: _page = 1, limit: _limit = PAGINATION_LIMITS[0], onChange } = _param, props = _object_without_properties138(_param, [
    "pages",
    "page",
    "limit",
    "onChange"
  ]);
  const [page, setPage] = useState8(_page);
  const [limit, setLimit] = useState8(_limit);
  const isMobile = useMediaQuery(`(max-width: 768px)`);
  const renderMenuItem = useCallback3((item) => /* @__PURE__ */ _jsxs75(_Fragment3, {
    children: [
      item,
      item === limit && /* @__PURE__ */ _jsx175("span", {
        className: "ml-3",
        children: /* @__PURE__ */ _jsx175(Tick_default, {})
      })
    ]
  }), [
    limit
  ]);
  const onClickMenuItem = useCallback3((_5, newLimit) => {
    setLimit(newLimit);
    if (onChange) {
      onChange(page, newLimit);
    }
  }, [
    page,
    onChange
  ]);
  const onChangeCallback = useCallback3((_5, newPage) => {
    setPage(newPage);
    if (onChange) {
      onChange(newPage, limit);
    }
  }, [
    limit,
    onChange
  ]);
  const paginationListMenu = useMemo7(() => PAGINATION_LIMITS.map((limit2) => ({
    render: () => renderMenuItem(limit2),
    onClick: (e) => onClickMenuItem(e, limit2)
  })), [
    renderMenuItem,
    onClickMenuItem
  ]);
  const { menu, open } = useMenu_default({
    id: "pagination-menu",
    list: paginationListMenu,
    transformOrigin: {
      vertical: "bottom",
      horizontal: "right"
    }
  });
  if (!pages) {
    return null;
  }
  return /* @__PURE__ */ _jsxs75(PaginationWrapper, {
    children: [
      pages && pages > 1 && /* @__PURE__ */ _jsx175(StyledPagination, _object_spread_props149(_object_spread161({
        shape: "rounded",
        page,
        count: pages
      }, props), {
        renderItem: (item) => /* @__PURE__ */ _jsx175(PaginationItem, _object_spread_props149(_object_spread161({
          components: {
            previous: ChevronLeft_default,
            next: ChevronRight_default
          }
        }, item), {
          color: "primary"
        })),
        onChange: onChangeCallback
      })),
      !isMobile && /* @__PURE__ */ _jsxs75(PaginationDropdown, {
        children: [
          /* @__PURE__ */ _jsx175(typography_default, {
            variant: "body1",
            children: "Записей на странице:"
          }),
          /* @__PURE__ */ _jsxs75(PaginationDropdownButton, {
            type: "button",
            onClick: (e) => open(e),
            children: [
              limit,
              /* @__PURE__ */ _jsx175(PaginationDropdownIcon, {
                children: /* @__PURE__ */ _jsx175(ChevronDown_default, {})
              })
            ]
          })
        ]
      }),
      menu
    ]
  });
};
var pagination_default = /* @__PURE__ */ React90.memo(Pagination);

// src/shared/ui/row/index.tsx
import { jsx as _jsx176 } from "react/jsx-runtime";
import { Grid as Grid3 } from "@mui/material";
function _define_property162(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread162(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property162(target, key, source[key]);
    });
  }
  return target;
}
var Row = (props) => /* @__PURE__ */ _jsx176(Grid3, _object_spread162({
  container: true,
  display: "flex"
}, props));
var row_default = Row;

// src/shared/ui/section-list/index.tsx
import { jsx as _jsx177 } from "react/jsx-runtime";
import React91, { useCallback as useCallback4, useMemo as useMemo8 } from "react";
function _define_property163(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread163(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property163(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys150(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props150(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys150(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties139(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose139(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose139(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SectionList = /* @__PURE__ */ React91.forwardRef((_param, ref3) => {
  var { sections, renderItem: _renderItem, renderSectionHeader: _renderSectionHeader } = _param, props = _object_without_properties139(_param, [
    "sections",
    "renderItem",
    "renderSectionHeader"
  ]);
  const data = useMemo8(() => sections.reduce((res, { title, data: data2 }) => {
    if (title && Array.isArray(data2) && data2.length) {
      res.push({
        title,
        data: data2
      });
      res.push(...data2);
    }
    return res;
  }, []), [
    sections
  ]);
  const renderSectionHeader = useCallback4(_renderSectionHeader, [
    _renderSectionHeader
  ]);
  const renderItem = useCallback4((section, index, data2) => {
    if (section && section.title) {
      return renderSectionHeader(section, index, data2);
    }
    return _renderItem(section, index, data2);
  }, [
    _renderItem,
    renderSectionHeader
  ]);
  return /* @__PURE__ */ _jsx177(list_default, _object_spread_props150(_object_spread163({
    ref: ref3
  }, props), {
    data,
    renderItem
  }));
});
SectionList.displayName = "SectionList";
var section_list_default = /* @__PURE__ */ React91.memo(SectionList);

// src/shared/ui/select/shared/Select.tsx
var import_lodash10 = __toESM(require_lodash());
import { jsx as _jsx179, jsxs as _jsxs77 } from "react/jsx-runtime";
import { useEffect as useEffect14, useRef as useRef5, useState as useState10 } from "react";

// src/shared/ui/select/shared/SelectList.tsx
import { jsx as _jsx178, jsxs as _jsxs76 } from "react/jsx-runtime";
import { useEffect as useEffect13, useState as useState9 } from "react";

// src/shared/ui/select/shared/ui.tsx
import styled26 from "styled-components";
var SelectContainer = styled26.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 4px;
  background: var(--dion-grey-900);
  padding: 5px;
  height: 38px;
  min-width: 200px;
  width: inherit;
  cursor: pointer;
`;
var SelectFieldContainer = styled26.div`
  display: flex;
  align-items: center;
  padding: .5rem 1rem ;
  flex-grow: 1;
  height: 100%;
  font-weight: var(--dion-font-semi-bol);
  font-size: var(--dion-font-large);
  line-height: var(--dion-font-line-height);
  background-color: var(--dion-grey-900);
  user-select: none;
  cursor: pointer;
  &:first-child {
    display: inline-block;
    width: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
var SelectListContainer = styled26.div`
  display: ${({ isCollapsed }) => isCollapsed ? "none" : "flex"};
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 42px;
  left: 0;
  width: 100%;
  background: var(--dion-grey-900);
  border-radius: 4px;
  z-index: 99;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  padding: 1.5rem;
  transition: all 0.27s;
  user-select: none;
`;
var SelectListWrapper = styled26.div`
  width: inherit
`;
var SelectOptionContainer = styled26.div`
  display: flex;
  align-items: center;
  width: 100%;
  &:not(:first-child) {
    margin-top: 1rem;
  };
  & div div:first-child {
    display: flex;
    flex-wrap: wrap;
    width: inherit;
    text-align: left;
  }

`;
var SelectListFixedOption = styled26.button`
  display: flex;
  align-items: center;
  justify-content: start;
  text-align: left;
  width: 100%;
  padding: 7px 12px 7px 0;
  margin-top: 12px;
  cursor: ${({ disabled }) => disabled ? "default" : "pointer"};
  color: ${({ disabled }) => disabled ? getCssVar("grey", 600) : getCssVar("blue", 300)};
`;
var IconArea = styled26.div`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

// src/shared/ui/select/shared/SelectList.tsx
var SelectList = ({ options, multi = false, showButton = true, style: style4, onSelect, onClear }) => {
  const [isButtonDisable, setIsButtonDisable] = useState9(true);
  const optionElements = options.map((option, index) => /* @__PURE__ */ _jsx178(SelectOption, {
    option,
    multi,
    onSelect
  }, index));
  useEffect13(() => {
    const option = options.find((option2) => option2.isSelected);
    if (option) {
      setIsButtonDisable(false);
    } else {
      setIsButtonDisable(true);
    }
  }, [
    options
  ]);
  return /* @__PURE__ */ _jsxs76(SelectListWrapper, {
    style: style4,
    children: [
      optionElements,
      multi && showButton && /* @__PURE__ */ _jsx178(SelectListFixedOption, {
        onClick: onClear,
        disabled: isButtonDisable,
        children: "Сбросить фильтры"
      })
    ]
  });
};

// src/shared/ui/select/shared/Select.tsx
var Select = ({ options: _options, multi, isCollapsed: _isCollapsed, placeholder, showButton, style: style4, onSelect: _onSelect, onClear: _onClear }) => {
  const [isCollapsed, setIsCollapsed] = useState10(_isCollapsed !== null && _isCollapsed !== void 0 ? _isCollapsed : true);
  const [amount, setAmount] = useState10(0);
  const [options, setOptions] = useState10(_options);
  const [option, setOption] = useState10();
  const ref3 = useRef5(null);
  const selectedOptions = (source) => source.filter((option2) => option2.isSelected) || [];
  const findSelectedOption = (source) => source === null || source === void 0 ? void 0 : source.find((option2) => option2.isSelected);
  const setSelectedOption = (option2) => {
    const newOptions = (0, import_lodash10.cloneDeep)(options);
    const currentSelectedOption = findSelectedOption(newOptions);
    if (!multi && currentSelectedOption) {
      currentSelectedOption.isSelected = false;
    }
    const selectedOption = newOptions.find((opt) => opt.value === option2.value);
    if (selectedOption) {
      selectedOption.isSelected = true;
    }
    setOptions(newOptions);
  };
  const onSelect = (option2) => {
    if (!option2)
      return;
    setSelectedOption(option2);
    if (!multi) {
      setIsCollapsed(true);
    }
    _onSelect(option2);
  };
  const onClear = () => {
    const newOptions = (0, import_lodash10.cloneDeep)(options);
    options.forEach((option2) => {
      option2.isSelected = false;
    });
    setOptions(newOptions);
    setOption(void 0);
    if (typeof _onClear === "function") {
      _onClear();
    }
  };
  const handleClickOutside = (event) => {
    var _ref_current;
    if (ref3.current && !((_ref_current = ref3.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(event.target))) {
      setIsCollapsed(true);
    }
  };
  useEffect14(() => {
    if (multi) {
      var _selectedOptions;
      setAmount((_selectedOptions = selectedOptions(_options)) === null || _selectedOptions === void 0 ? void 0 : _selectedOptions.length);
    }
    if (!multi) {
      const selectedOption = findSelectedOption(_options);
      setOption(selectedOption);
    }
  }, [
    _options,
    multi
  ]);
  useEffect14(() => {
    if (!multi) {
      const selectedOption = findSelectedOption(_options);
      setOption(selectedOption);
    }
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [
    _options
  ]);
  useEffect14(() => {
    if (multi && amount === 0) {
      setOption(void 0);
    }
  }, [
    amount
  ]);
  var _option_label, _ref;
  return /* @__PURE__ */ _jsxs77(SelectContainer, {
    style: style4,
    ref: ref3,
    onClick: () => setIsCollapsed(!isCollapsed),
    children: [
      /* @__PURE__ */ _jsx179(SelectField, {
        value: (_ref = (_option_label = option === null || option === void 0 ? void 0 : option.label) !== null && _option_label !== void 0 ? _option_label : placeholder) !== null && _ref !== void 0 ? _ref : "",
        multi,
        amount
      }),
      /* @__PURE__ */ _jsx179(CollapseButton, {
        onCollapse: () => setIsCollapsed(!isCollapsed),
        isCollapsed
      }),
      /* @__PURE__ */ _jsx179(SelectListContainer, {
        isCollapsed,
        children: /* @__PURE__ */ _jsx179(SelectList, {
          multi,
          showButton,
          options: _options,
          onSelect,
          onClear
        })
      })
    ]
  });
};

// src/shared/ui/select/shared/SelectField.tsx
import { jsxs as _jsxs78 } from "react/jsx-runtime";
var SelectField = ({ value, amount = 0, multi = false }) => /* @__PURE__ */ _jsxs78(SelectFieldContainer, {
  children: [
    !multi && value,
    multi && amount > 0 && /* @__PURE__ */ _jsxs78("span", {
      children: [
        "Фильтры (",
        amount,
        ")"
      ]
    }),
    multi && !amount && value
  ]
});

// src/shared/ui/select/shared/SelectOption.tsx
import { jsx as _jsx180, jsxs as _jsxs79 } from "react/jsx-runtime";
function _define_property164(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread164(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property164(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys151(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props151(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys151(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var SelectOption = ({ multi, option, onSelect }) => {
  const onChange = (event, checked) => {
    onSelect(_object_spread_props151(_object_spread164({}, option), {
      isSelected: checked
    }));
  };
  const onClick = (event) => {
    onSelect(_object_spread_props151(_object_spread164({}, option), {
      isSelected: true
    }));
  };
  var _option_value;
  return /* @__PURE__ */ _jsxs79(SelectOptionContainer, {
    children: [
      multi && /* @__PURE__ */ _jsx180(checkbox_default, {
        isChecked: option.isSelected,
        name: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : "",
        label: option === null || option === void 0 ? void 0 : option.label,
        onChange
      }),
      !multi && /* @__PURE__ */ _jsx180("button", {
        onClick,
        className: "w-full justify-self-start",
        children: /* @__PURE__ */ _jsxs79("div", {
          className: "flex justify-space-between w-full items-center text-3xl",
          children: [
            /* @__PURE__ */ _jsx180("div", {
              children: option === null || option === void 0 ? void 0 : option.label
            }),
            option.isSelected && /* @__PURE__ */ _jsx180(IconArea, {
              style: {
                maxHeight: "16px"
              },
              children: /* @__PURE__ */ _jsx180(Tick_default, {})
            })
          ]
        })
      })
    ]
  });
};

// src/shared/ui/select/shared/CollapseButton.tsx
import { jsx as _jsx181 } from "react/jsx-runtime";
import { useState as useState11 } from "react";
var CollapseButton = ({ onCollapse: _onCollapse, isCollapsed: _isCollapsed = true }) => {
  const Icon = () => _isCollapsed ? /* @__PURE__ */ _jsx181(ChevronDown_default, {}) : /* @__PURE__ */ _jsx181(ChevronUp_default, {});
  const [isCollapsed, setIsCollapsed] = useState11(_isCollapsed);
  const onCollapse = () => {
    _onCollapse(isCollapsed);
    setIsCollapsed(!isCollapsed);
  };
  return /* @__PURE__ */ _jsx181("div", {
    onClick: onCollapse,
    children: /* @__PURE__ */ _jsx181(IconArea, {
      children: /* @__PURE__ */ _jsx181(Icon, {})
    })
  });
};

// src/shared/ui/side-navigation/index.tsx
import { jsx as _jsx184, jsxs as _jsxs81 } from "react/jsx-runtime";
import React93, { useCallback as useCallback6, useEffect as useEffect15, useRef as useRef6, useState as useState13 } from "react";

// src/shared/ui/side-navigation/shared/ui.tsx
import styled27 from "styled-components";
var SideNavigationWrapper = styled27.aside`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: 72px 0 82px;
  padding: 32px 0;
  width: 72px;
  background: ${getCssVar("black", 100)};
  transform: ${({ isHovered = false }) => isHovered ? "translateX(0)" : "translateX(-100%)"};
  transition: all .27s;
`;
var SideNavigationCTA = styled27.button`
  width: 5px;
  height: 34px;
  background: ${getCssVar("grey", 900)};
  border: 0 solid transparent;
  border-radius: 100px;
  transform: ${({ isHovered = false }) => isHovered ? "translateX(-100%)" : "translateX(0)"};
  opacity: ${({ isHovered = false }) => isHovered ? 0 : 1};
  transition: all .27s;

  &:hover {
    background: ${getCssVar("grey", 950)};
    cursor: pointer;
  }
`;
var SideNavigationCTAWrapper = styled27.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  right: -38px;
  width: 34px;
  height: 68px;
  transform: translateY(-50%);
  cursor: pointer;
`;
var StyledPinButton = styled27.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
`;
var StyledAction = styled27.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 0;
  background: transparent;
  border: 2px transparent solid;
  border-left-color: ${({ isActive = false }) => isActive ? getCssVar("blue", 500) : "transparent"};
  color: ${({ isActive = false }) => isActive ? getCssVar("grey", 100) : getCssVar("grey", 500)};
  transition: all .25s;

  &:hover {
    color: ${getCssVar("grey", 500)};
  }
`;
var StyledActionLabel = styled27.span`
  margin-top: 4px;
  font-size: 10px;
  color: currentColor;
`;

// src/shared/ui/side-navigation/shared/Action.tsx
var import_lodash11 = __toESM(require_lodash());
import { jsx as _jsx182, jsxs as _jsxs80 } from "react/jsx-runtime";
var Action = ({ isActive = false, disabled = false, label, icon, className, onClick }) => /* @__PURE__ */ _jsxs80(StyledAction, {
  disabled,
  isActive,
  className,
  onClick,
  children: [
    icon,
    /* @__PURE__ */ _jsx182(StyledActionLabel, {
      children: (0, import_lodash11.isFunction)(label) && label() || label
    })
  ]
});
var Action_default = Action;

// src/shared/ui/side-navigation/shared/PinButton.tsx
import { jsx as _jsx183 } from "react/jsx-runtime";
import React92, { useCallback as useCallback5, useMemo as useMemo9, useState as useState12 } from "react";
var PinButton = ({ isVisible = false, isPinned = false, color: color2 = getCssVar("grey", 500), colorHovered = getCssVar("grey", 100), onClick: _onClick }) => {
  const [isHovered, setIsHovered] = useState12(false);
  const fill = isHovered ? colorHovered : color2;
  const Icon = useMemo9(() => {
    if (isPinned) {
      return SidebarUnpin_default;
    }
    return SidebarPin_default;
  }, [
    isHovered,
    isPinned
  ]);
  const onClick = useCallback5(() => {
    if (_onClick) {
      _onClick(isPinned, isVisible);
    }
  }, [
    isPinned,
    isVisible,
    _onClick
  ]);
  return /* @__PURE__ */ _jsx183(StyledPinButton, {
    "data-testid": isVisible ? "action-collapse-sidebar" : "action-expand-sidebar",
    onClick,
    onMouseOver: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: /* @__PURE__ */ _jsx183(Icon, {
      fill
    })
  });
};
var PinButton_default = /* @__PURE__ */ React92.memo(PinButton);

// src/shared/ui/side-navigation/index.tsx
var SideNavigation = ({ isHovered: _isHovered = false, isHoverDisabled = false, children, className, style: style4, onChange: _onChange }) => {
  const [isHovered, setIsHovered] = useState13(_isHovered);
  const timeout = useRef6();
  const show = () => {
    clearTimeout(timeout.current);
    setIsHovered(true);
  };
  const hide = () => {
    timeout.current = setTimeout(() => {
      setIsHovered(false);
      clearTimeout(timeout.current);
    }, 1e3);
  };
  const onChange = useCallback6((isHovered2) => {
    if (isHoverDisabled) {
      return;
    }
    if (_onChange) {
      _onChange(isHovered2);
    }
  }, [
    isHoverDisabled,
    _onChange
  ]);
  const onMouseOverCTA = useCallback6(() => {
    if (isHoverDisabled) {
      return;
    }
    show();
  }, [
    isHoverDisabled
  ]);
  const onMouseLeave = useCallback6(() => {
    if (isHoverDisabled) {
      return;
    }
    hide();
  }, [
    isHoverDisabled
  ]);
  useEffect15(() => () => {
    clearTimeout(timeout.current);
  }, []);
  useEffect15(() => {
    if (isHoverDisabled) {
      setIsHovered(true);
      return;
    }
    setIsHovered(_isHovered);
  }, [
    _isHovered,
    isHoverDisabled
  ]);
  useEffect15(() => {
    onChange(isHovered);
  }, [
    isHovered
  ]);
  return /* @__PURE__ */ _jsxs81(SideNavigationWrapper, {
    isHovered,
    className,
    style: style4,
    onMouseLeave,
    children: [
      children,
      !isHoverDisabled && /* @__PURE__ */ _jsx184(SideNavigationCTAWrapper, {
        onMouseOver: onMouseOverCTA,
        children: /* @__PURE__ */ _jsx184(SideNavigationCTA, {
          isHovered
        })
      })
    ]
  });
};
var side_navigation_default = /* @__PURE__ */ React93.memo(SideNavigation);

// src/shared/ui/slider/index.tsx
import { jsx as _jsx185 } from "react/jsx-runtime";
import { Slider as MuiSlider } from "@mui/material";
function _define_property165(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread165(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property165(target, key, source[key]);
    });
  }
  return target;
}
var Slider = (props) => /* @__PURE__ */ _jsx185(MuiSlider, _object_spread165({}, props));
var slider_default = Slider;

// src/shared/ui/scroll-view/index.tsx
import { jsx as _jsx186 } from "react/jsx-runtime";

// src/shared/ui/scroll-view/shared/ui.ts
import styled28 from "styled-components";
var ScrollViewWrapper = styled28.div`
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  min-height: 100%;
`;

// src/shared/ui/scroll-view/index.tsx
var ScrollView = ({ style: style4, children, className }) => /* @__PURE__ */ _jsx186(ScrollViewWrapper, {
  className,
  style: style4,
  children
});
var scroll_view_default = ScrollView;

// src/shared/ui/stack/index.tsx
import { jsx as _jsx187 } from "react/jsx-runtime";

// src/shared/ui/stack/shared/ui.ts
import { Stack as MuiStack } from "@mui/material";
import styled29 from "styled-components";
var StackStyled = styled29(MuiStack)`
  display: flex;
`;

// src/shared/ui/stack/index.tsx
function _define_property166(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread166(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property166(target, key, source[key]);
    });
  }
  return target;
}
var Stack3 = (props) => /* @__PURE__ */ _jsx187(StackStyled, _object_spread166({}, props));
var stack_default = Stack3;

// src/shared/ui/stepper/index.tsx
import { jsx as _jsx188, jsxs as _jsxs82 } from "react/jsx-runtime";
import { useCallback as useCallback7, useMemo as useMemo10 } from "react";

// src/shared/ui/stepper/shared/ui.tsx
import { Stepper as MuiStepper, Step as MuiStep } from "@mui/material";
import styled30 from "styled-components";
var StyledStepper = styled30(MuiStepper)`
  display: flex;
  /* flex: 1; */
`;
var StyledStep = styled30(MuiStep)`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 .8rem;
  padding: 0;
  color: ${({ isActive = false, isCompleted = false }) => {
  if (isCompleted) {
    return getCssVar("green", 500);
  }
  if (isActive) {
    return getCssVar("grey", 100);
  }
  return getCssVar("grey", 900);
}};
  cursor: ${({ isActive = false }) => isActive ? "pointer" : "default"};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;
var StepStuff = styled30.div`
  display: flex;
  align-items: center;
`;
var StepContainer = styled30.div`
  display: flex;
  margin-top: 1rem;
  font-size: ${getCssVar("font", "large")};
  color: currentColor;
`;
var StepBullet = styled30.i`
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  border: 0.54rem solid currentColor;
  border-radius: 50%;
`;
var StepInlineConnector = styled30.div`
  display: flex;
  flex: 1;
  margin: 0 .5rem;
  height: .2rem;
  background: currentColor;
  border: 0 solid transparent;
  border-radius: 1px;
`;

// src/shared/ui/stepper/index.tsx
function _define_property167(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread167(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property167(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys152(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props152(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys152(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties140(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose140(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose140(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Stepper = (_param) => {
  var { isNonLinear = false, activeStep = -1, data, skippedSteps, renderStep } = _param, props = _object_without_properties140(_param, [
    "isNonLinear",
    "activeStep",
    "data",
    "skippedSteps",
    "renderStep"
  ]);
  const isStepCompleted = useCallback7((step) => {
    if (isNonLinear) {
      return !!skippedSteps && !skippedSteps.has(step) && step < activeStep;
    }
    return step < activeStep && !!activeStep;
  }, [
    isNonLinear,
    activeStep,
    skippedSteps
  ]);
  const renderStepBullet = useCallback7((isCompleted) => {
    if (isCompleted) {
      return /* @__PURE__ */ _jsx188(CheckRound_default, {
        fill: "currentColor",
        width: 18,
        height: 18
      });
    }
    return /* @__PURE__ */ _jsx188(StepBullet, {});
  }, []);
  const steps = useMemo10(() => {
    if (Array.isArray(data) && data.length > 0) {
      return data.map((stepData, index) => {
        const isActive = activeStep === index;
        const isCompleted = isStepCompleted(index);
        const stepBullet = renderStepBullet(isCompleted);
        return /* @__PURE__ */ _jsxs82(StyledStep, {
          isActive,
          isCompleted,
          children: [
            /* @__PURE__ */ _jsxs82(StepStuff, {
              children: [
                stepBullet,
                /* @__PURE__ */ _jsx188(StepInlineConnector, {})
              ]
            }),
            /* @__PURE__ */ _jsx188(StepContainer, {
              children: renderStep(stepData, index, data)
            })
          ]
        }, index);
      });
    }
    return null;
  }, [
    activeStep,
    data
  ]);
  return /* @__PURE__ */ _jsx188(StyledStepper, _object_spread_props152(_object_spread167({}, props), {
    nonLinear: isNonLinear,
    connector: null,
    children: steps
  }));
};
var stepper_default = Stepper;

// src/shared/ui/tabs/index.tsx
import { jsx as _jsx189 } from "react/jsx-runtime";

// src/shared/ui/tabs/shared/ui.tsx
import { Tabs as MuiTabs } from "@mui/material";
import styled31 from "styled-components";
var StyledTabs = styled31(MuiTabs)``;

// src/shared/ui/tabs/index.tsx
function _define_property168(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread168(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property168(target, key, source[key]);
    });
  }
  return target;
}
var Tabs = (props) => /* @__PURE__ */ _jsx189(StyledTabs, _object_spread168({}, props));
var tabs_default = Tabs;

// src/shared/ui/tab/index.tsx
import { jsx as _jsx190 } from "react/jsx-runtime";

// src/shared/ui/tab/shared/ui.tsx
import { Tab as MuiTab } from "@mui/material";
import styled32 from "styled-components";
var StyledTab = styled32(MuiTab)``;

// src/shared/ui/tab/index.tsx
function _define_property169(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread169(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property169(target, key, source[key]);
    });
  }
  return target;
}
var Tab = (props) => /* @__PURE__ */ _jsx190(StyledTab, _object_spread169({}, props));
var tab_default = Tab;

// src/shared/ui/textfield/index.tsx
import { jsx as _jsx191 } from "react/jsx-runtime";
import cn from "classnames";
import React95, { useCallback as useCallback8, useEffect as useEffect16, useRef as useRef7, useState as useState14 } from "react";

// src/shared/ui/textfield/shared/ui.tsx
import { TextField as MuiTextField } from "@mui/material";
import styled33 from "styled-components";
var StyledTextField = styled33(MuiTextField)`
  width: ${({ isFullWidth = false }) => isFullWidth ? "100%" : "auto"};
  border: 0 solid transparent;
  border-radius: .4rem;
  outline: 0;

  & > div {
    padding: .8rem 1.2rem;
    background: ${getCssVar("grey", 950)};
    font-size: ${getCssVar("font", "large")};
  }

  &.contrast > div, & > div[class*=focused] {
    background: ${getCssVar("grey", 900)};
  }

  input {
    padding: 0;
    font-weight: ${getCssVar("font", "semi-bold")};
  }

  fieldset {
    border: 0 solid transparent !important;
  }

  label {
    position: relative;
    margin-bottom: .8rem;
    font-size: ${getCssVar("font", "common")};
    font-weight: ${getCssVar("font", "semi-bold")};
    color: ${getCssVar("grey", 100)};
    line-height: 1;
    overflow: initial;
    transform: scale(1);
    transition: none;

    &[class*=focused],
    &[class*=error] {
      color: ${getCssVar("grey", 100)};
    }

    & > span {
      display: none;
    }
  }
`;

// src/shared/ui/textfield/shared/constants.ts
var SYMBOL_WIDTH = 8.8;
var ROWS_MAX = 10;
var TRIM_SYMBOLS = [
  " ",
  "\n"
];

// src/shared/ui/textfield/shared/helpers.ts
var getSymbolsInRow = (el) => {
  if (!el) {
    return 30;
  }
  const symbolsByRow = parseInt(`${(el === null || el === void 0 ? void 0 : el.clientWidth) / SYMBOL_WIDTH}`);
  return symbolsByRow;
};
var getLines = (comment) => comment.replace(/(.*[^\n])/g, "").length + 1;
var getRows = (comment, el) => {
  if (!comment || !el) {
    return 1;
  }
  const symbolsInRow = getSymbolsInRow(el);
  const lines = getLines(comment);
  const linesByString = parseInt(`${comment.length / symbolsInRow}`) + 1;
  const linesMax = Math.max(lines, linesByString);
  return Math.min(Math.max(1, linesMax), ROWS_MAX);
};

// src/shared/ui/textfield/index.tsx
function _define_property170(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread170(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property170(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties141(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose141(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose141(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var TextField = /* @__PURE__ */ React95.forwardRef((_param) => {
  var { isContrast = false, isDisabled = false, isFullWidth = false, isMultiline = false, isDynamicMultiline = false, className, value, onChange: _onChange, onKeyDown: _onKeyDown, onKeyUp: _onKeyUp } = _param, props = _object_without_properties141(_param, [
    "isContrast",
    "isDisabled",
    "isFullWidth",
    "isMultiline",
    "isDynamicMultiline",
    "className",
    "value",
    "onChange",
    "onKeyDown",
    "onKeyUp"
  ]);
  const ref3 = useRef7(null);
  const classes = cn(className, {
    contrast: isContrast
  });
  const [rows, setRows] = useState14(1);
  const onChange = useCallback8((e) => {
    const { value: value2 } = e.target;
    const update = (value3) => {
      if (_onChange) {
        _onChange(e);
      }
    };
    if (!isDynamicMultiline) {
      update(value2);
      return;
    }
    const lastChar = value2.substr(-1);
    const preLastChar = value2.substr(-2, 1);
    if (lastChar === preLastChar && TRIM_SYMBOLS.includes(preLastChar)) {
      e.preventDefault();
      return;
    }
    update(value2);
  }, [
    isDynamicMultiline,
    _onChange
  ]);
  const onKeyDown = useCallback8((e) => {
    if (_onKeyDown) {
      _onKeyDown(e);
      return;
    }
    if (!isDynamicMultiline) {
      return;
    }
    e.stopPropagation();
  }, [
    isDynamicMultiline,
    ref3,
    _onKeyDown
  ]);
  const onKeyUp = useCallback8((e) => {
    if (_onKeyUp) {
      _onKeyUp(e);
    }
    if (!isDynamicMultiline) {
      return;
    }
    e.stopPropagation();
  }, [
    isDynamicMultiline,
    _onKeyUp
  ]);
  useEffect16(() => {
    const rows2 = getRows(value, ref3.current);
    setRows(rows2);
  }, [
    value,
    ref3.current
  ]);
  return /* @__PURE__ */ _jsx191(StyledTextField, _object_spread170({
    inputRef: ref3,
    disabled: isDisabled,
    multiline: isMultiline || isDynamicMultiline,
    isFullWidth,
    className: classes,
    value,
    rows,
    onChange,
    onKeyDown,
    onKeyUp
  }, props));
});
TextField.displayName = "TextField";
var textfield_default = TextField;

// src/shared/ui/virtualized-list/index.tsx
var import_lodash12 = __toESM(require_lodash());
import { jsx as _jsx193, jsxs as _jsxs83, Fragment as _Fragment4 } from "react/jsx-runtime";
import React97, { useCallback as useCallback9, useEffect as useEffect18, useRef as useRef9, useState as useState15 } from "react";

// src/shared/ui/virtualized-list/shared/Item.tsx
import { jsx as _jsx192 } from "react/jsx-runtime";
import React96, { useEffect as useEffect17, useRef as useRef8 } from "react";

// src/shared/ui/virtualized-list/shared/ui.ts
import styled34 from "styled-components";
var VirtualizedListWrapper = styled34.div`
  display: flex;
  flex: 1;
`;
var VirtualizedListScroller = styled34.div`
  display: flex;
  flex: 1;
  overflow: auto;
`;
var StyledVirtualizedList = styled34.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
`;
var VirtualizedItemWrapper = styled34.li`
  /* background: gray; */
`;

// src/shared/ui/virtualized-list/shared/Item.tsx
var Item = ({ children, className, index, key, root, callback, boundsCallback }) => {
  const ref3 = useRef8(null);
  useEffect17(() => {
    if (!ref3.current) {
      return;
    }
    const bounds = ref3.current.getBoundingClientRect();
    boundsCallback(bounds, index);
    const observer = new IntersectionObserver(callback, {
      root,
      threshold: 0.1
    });
    observer.observe(ref3.current);
    return () => {
      if (!ref3.current) {
        observer.disconnect();
        return;
      }
      observer.unobserve(ref3.current);
    };
  }, [
    index,
    ref3
  ]);
  return /* @__PURE__ */ _jsx192(VirtualizedItemWrapper, {
    ref: ref3,
    "data-index": index,
    className,
    children
  }, key);
};
var Item_default = /* @__PURE__ */ React96.memo(Item);

// src/shared/ui/virtualized-list/index.tsx
var CHUNK_SIZE = 25;
var VirtualizedList = ({ isReady = false, data = [], emptyContent, style: style4, className, prerenderCount = CHUNK_SIZE, defaultItemHeight = 100, listClassName, itemClassName = "itemVirtualized", keyExtractor, renderItem: _renderItem }) => {
  var _scrollerRef_current;
  const [isPrerendered, setIsPrerendered] = useState15(false);
  const [scrollHeight, setScrollHeight] = useState15(0);
  const [scrollTop, setScrollTop] = useState15(0);
  const wrapperRef = useRef9(null);
  const virtualList = useRef9(/* @__PURE__ */ new Map([]));
  const scrollerRef = useRef9(null);
  const listRef = useRef9(null);
  const intersectingListRef = useRef9(/* @__PURE__ */ new Set([]));
  const heightsListRef = useRef9(/* @__PURE__ */ new Map([]));
  const [renderedListChunk, setRenderedListChunk] = useState15([]);
  const observerCallback = useCallback9((entries, entry) => {
    const [{ isIntersecting = false, target: el }] = entries;
    const intersectionIndex = +(el.dataset.index || 0);
    if (isIntersecting) {
      intersectingListRef.current.add(intersectionIndex);
    }
    if (!isIntersecting) {
      intersectingListRef.current.delete(intersectionIndex);
    }
  }, [
    intersectingListRef
  ]);
  const observeBoundsCallback = useCallback9((bounds2, index) => {
    heightsListRef.current.set(index, bounds2);
  }, [
    heightsListRef.current
  ]);
  const renderItem = useCallback9(({ index = 0, isScrolling = false, style: style5 = {} }) => {
    const item = data && data[index] || null;
    const newVirtualListItem = /* @__PURE__ */ _jsx193(Item_default, {
      index,
      className: itemClassName,
      root: listRef.current,
      callback: observerCallback,
      boundsCallback: observeBoundsCallback,
      children: _renderItem(item, index, data)
    }, `${index}`);
    virtualList.current.set(index, newVirtualListItem);
    return newVirtualListItem;
  }, [
    virtualList.current,
    listRef.current,
    data,
    _renderItem,
    observerCallback,
    observeBoundsCallback
  ]);
  const prepareListChunk = useCallback9(() => {
    const ids = [
      ...intersectingListRef.current
    ];
    if ((0, import_lodash12.isEmpty)(ids)) {
      if (data.length < CHUNK_SIZE * 2) {
        setRenderedListChunk(Array(data.length).fill(0).map((_5, index) => renderItem({
          index
        })));
        return;
      }
      setRenderedListChunk(Array(CHUNK_SIZE * 2).fill(0).map((_5, index) => renderItem({
        index
      })));
      return;
    }
    const minId = (0, import_lodash12.min)(ids) || 0;
    const maxId = (0, import_lodash12.max)(ids) || prerenderCount;
    const middleId = Math.round((maxId + minId) / 2);
    const cursorMinId = Math.max(0, middleId - prerenderCount);
    const cursorMaxId = Math.min(middleId + prerenderCount, data.length);
    const renderedListChunk2 = Array(cursorMaxId - cursorMinId).fill(0).map((_5, i) => {
      const index = cursorMinId + i;
      return renderItem({
        index
      });
    });
    setRenderedListChunk(renderedListChunk2);
  }, [
    prerenderCount,
    intersectingListRef.current,
    data,
    renderItem
  ]);
  const getRowHeight = useCallback9((index) => {
    var _heightsListRef_current_get;
    return ((_heightsListRef_current_get = heightsListRef.current.get(index)) === null || _heightsListRef_current_get === void 0 ? void 0 : _heightsListRef_current_get.height) || defaultItemHeight;
  }, [
    defaultItemHeight,
    heightsListRef.current
  ]);
  const getScrollHeight = useCallback9(() => {
    const ids = [
      ...intersectingListRef.current
    ];
    const minId = (0, import_lodash12.min)(ids) || 0;
    return Array(minId).fill(0).reduce((height2, index) => {
      height2 += getRowHeight(index);
      return height2;
    }, 0);
  }, [
    defaultItemHeight,
    prerenderCount,
    intersectingListRef.current,
    heightsListRef.current,
    getRowHeight
  ]);
  const onScroll = useCallback9(() => {
    if (!scrollerRef.current) {
      return;
    }
    const { scrollTop: scrollTop2 } = scrollerRef.current;
    const newScrollHeight = getScrollHeight();
    setScrollTop(scrollTop2);
    setScrollHeight(newScrollHeight);
    prepareListChunk();
  }, [
    prerenderCount,
    scrollHeight,
    scrollerRef.current,
    prepareListChunk,
    getScrollHeight
  ]);
  useEffect18(() => {
    if (isPrerendered) {
      prepareListChunk();
      return;
    }
    if (Array.isArray(data) && data.length >= 1) {
      data.forEach((_5, index) => renderItem({
        index
      }));
      prepareListChunk();
      setIsPrerendered(true);
    }
  }, [
    isPrerendered,
    data,
    renderItem,
    prepareListChunk
  ]);
  const bounds = (_scrollerRef_current = scrollerRef.current) === null || _scrollerRef_current === void 0 ? void 0 : _scrollerRef_current.getBoundingClientRect();
  if (isReady && !(data && (data === null || data === void 0 ? void 0 : data.length))) {
    return /* @__PURE__ */ _jsx193(_Fragment4, {
      children: emptyContent
    });
  }
  return /* @__PURE__ */ _jsx193(VirtualizedListWrapper, {
    ref: wrapperRef,
    className,
    style: style4,
    children: /* @__PURE__ */ _jsx193(VirtualizedListScroller, {
      ref: scrollerRef,
      style: {
        height: bounds === null || bounds === void 0 ? void 0 : bounds.height
      },
      onScroll,
      children: isPrerendered && /* @__PURE__ */ _jsxs83(StyledVirtualizedList, {
        ref: listRef,
        children: [
          /* @__PURE__ */ _jsx193("li", {
            children: /* @__PURE__ */ _jsx193("div", {
              style: {
                height: scrollHeight
              }
            })
          }, "nuller"),
          renderedListChunk
        ]
      })
    })
  });
};
var virtualized_list_default = /* @__PURE__ */ React97.memo(VirtualizedList);

// src/shared/ui/images/shared/EmptyChat.tsx
import { jsx as _jsx194, jsxs as _jsxs84 } from "react/jsx-runtime";
import React98 from "react";
function _object_without_properties142(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose142(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose142(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EmptyChat = (_param) => {
  var { fill = getCssVar("grey", 100), width: width2 = 97, height: height2 = 96 } = _param, props = _object_without_properties142(_param, [
    "fill",
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs84("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsx194("path", {
        d: "M5.9873 30.6688C5.9873 24.1954 5.9873 20.9587 7.24712 18.4862C8.35528 16.3113 10.1235 14.543 12.2984 13.4349C14.7709 12.175 18.0076 12.175 24.4811 12.175H51.1446C57.618 12.175 60.8547 12.175 63.3272 13.4349C65.5021 14.543 67.2704 16.3113 68.3785 18.4862C69.6383 20.9587 69.6383 24.1954 69.6383 30.6688V39.0418C69.6383 45.5152 69.6383 48.7519 68.3785 51.2244C67.2704 53.3993 65.5021 55.1676 63.3272 56.2757C60.8547 57.5355 55.2163 57.5355 48.7429 57.5355H45.7803C44.0797 57.5355 43.2293 57.5355 42.4121 57.694C41.6869 57.8345 40.9827 58.0672 40.3165 58.3863C39.5658 58.746 38.8828 59.2526 37.5169 60.2657L27.4335 68.3259C25.6509 69.6481 24.7596 70.3093 24.0142 70.291C23.3655 70.2751 22.758 69.9694 22.3588 69.4578C21.9001 68.87 21.9001 67.7603 21.9001 65.5409V60.7181C21.9001 60.4461 21.9001 60.3101 21.8909 60.1954C21.7781 58.7808 20.6548 57.6576 19.2402 57.5447C19.1255 57.5355 18.9895 57.5355 18.7175 57.5355C17.6295 57.5355 17.0856 57.5355 16.6267 57.4989C10.9684 57.0475 6.47532 52.5544 6.02391 46.8962C5.9873 46.4373 5.9873 45.8933 5.9873 44.8053V30.6688Z",
        fill: "#D6E8FF"
      }),
      /* @__PURE__ */ _jsxs84("g", {
        filter: "url(#filter0_i_86_9078)",
        children: [
          /* @__PURE__ */ _jsx194("path", {
            d: "M16.9609 35.2247C16.9609 38.2552 19.4176 40.7119 22.4481 40.7119C25.4786 40.7119 27.9353 38.2552 27.9353 35.2247C27.9353 32.1942 25.4786 29.7375 22.4481 29.7375C19.4176 29.7375 16.9609 32.1942 16.9609 35.2247Z",
            fill: "#C4DAFF"
          }),
          /* @__PURE__ */ _jsx194("path", {
            d: "M32.2216 35.2247C32.2216 38.2552 34.6783 40.7119 37.7087 40.7119C40.7392 40.7119 43.1959 38.2552 43.1959 35.2247C43.1959 32.1942 40.7392 29.7375 37.7087 29.7375C34.6783 29.7375 32.2216 32.1942 32.2216 35.2247Z",
            fill: "#C4DAFF"
          }),
          /* @__PURE__ */ _jsx194("path", {
            d: "M52.9694 40.7119C49.9389 40.7119 47.4822 38.2552 47.4822 35.2247C47.4822 32.1942 49.9389 29.7375 52.9694 29.7375C55.9998 29.7375 58.4565 32.1942 58.4565 35.2247C58.4565 38.2552 55.9998 40.7119 52.9694 40.7119Z",
            fill: "#C4DAFF"
          })
        ]
      }),
      /* @__PURE__ */ _jsxs84("g", {
        filter: "url(#filter1_b_86_9078)",
        children: [
          /* @__PURE__ */ _jsx194("path", {
            d: "M90.6846 55.8863C90.6846 49.4211 90.6846 46.1885 89.4255 43.7191C88.318 41.547 86.5507 39.781 84.3771 38.6742C81.906 37.416 78.6712 37.416 72.2015 37.416H54.2961C47.8264 37.416 44.5915 37.416 42.1204 38.6742C39.9468 39.781 38.1796 41.547 37.0721 43.7191C35.813 46.1885 35.813 49.4211 35.813 55.8863V57.328C35.813 63.5833 35.813 66.711 36.9939 69.1163C38.121 71.4123 39.9793 73.2693 42.2769 74.3957C44.6839 75.5757 50.2154 75.5757 56.475 75.5757C58.2591 75.5757 59.1512 75.5757 60.0095 75.7364C60.8346 75.8908 61.6354 76.1549 62.3904 76.5216C63.1757 76.9031 63.8925 77.4338 65.3261 78.4951L71.2691 83.4719C73.203 84.9035 74.1699 85.6193 74.9785 85.5992C75.6822 85.5817 76.341 85.25 76.774 84.6954C77.2715 84.0581 77.2715 82.8556 77.2715 80.4506V78.4372C77.2715 76.8569 78.5535 75.5757 80.135 75.5757C85.9614 75.5757 90.6846 70.8558 90.6846 65.0334V55.8863Z",
            fill: "#9EBFFF",
            fillOpacity: "0.3"
          }),
          /* @__PURE__ */ _jsx194("path", {
            d: "M65.4749 78.2942L65.4809 78.2986L65.4866 78.3034L71.4239 83.2754C72.3918 83.9919 73.1044 84.519 73.6757 84.8663C74.2513 85.2163 74.6431 85.3575 74.9723 85.3493C75.6012 85.3336 76.19 85.0372 76.577 84.5416C76.7794 84.2822 76.8991 83.8836 76.9604 83.2132C77.0213 82.5463 77.0215 81.6581 77.0215 80.4506V78.4372C77.0215 76.7186 78.4156 75.3257 80.135 75.3257C85.8235 75.3257 90.4346 70.7176 90.4346 65.0334V55.8863C90.4346 52.6496 90.4344 50.2371 90.278 48.3246C90.1219 46.4151 89.8113 45.0262 89.2028 43.8327C88.1192 41.7076 86.3903 39.9798 84.2637 38.897C83.0692 38.2888 81.6793 37.9785 79.7684 37.8225C77.8547 37.6662 75.4405 37.666 72.2015 37.666H54.2961C51.0571 37.666 48.6429 37.6662 46.7291 37.8225C44.8183 37.9785 43.4283 38.2888 42.2339 38.897C40.1073 39.9798 38.3783 41.7076 37.2948 43.8327C36.6862 45.0262 36.3757 46.4151 36.2196 48.3246C36.0632 50.2371 36.063 52.6496 36.063 55.8863V57.328C36.063 60.4597 36.0632 62.7938 36.2098 64.6462C36.3563 66.4957 36.6475 67.8436 37.2183 69.0061C38.321 71.2524 40.1391 73.0692 42.3869 74.1712C43.5401 74.7366 45.4777 75.031 47.9461 75.1787C50.4033 75.3256 53.3429 75.3257 56.475 75.3257H56.5064C58.2609 75.3257 59.1744 75.3257 60.0555 75.4906C60.9025 75.6492 61.7245 75.9203 62.4996 76.2968C63.3059 76.6884 64.0399 77.2318 65.4498 78.2756L65.4749 78.2942Z",
            stroke: "url(#paint0_linear_86_9078)",
            strokeOpacity: "0.4",
            strokeWidth: "0.5"
          })
        ]
      }),
      /* @__PURE__ */ _jsxs84("defs", {
        children: [
          /* @__PURE__ */ _jsxs84("filter", {
            id: "filter0_i_86_9078",
            x: "15.2364",
            y: "28.013",
            width: "43.2197",
            height: "12.6989",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx194("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx194("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx194("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx194("feOffset", {
                dx: "-1.72453",
                dy: "-1.72453"
              }),
              /* @__PURE__ */ _jsx194("feGaussianBlur", {
                stdDeviation: "2.40167"
              }),
              /* @__PURE__ */ _jsx194("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx194("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0.382552 0 0 0 0 0.543782 0 0 0 0 0.8125 0 0 0 0.3 0"
              }),
              /* @__PURE__ */ _jsx194("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect1_innerShadow_86_9078"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs84("filter", {
            id: "filter1_b_86_9078",
            x: "29.8093",
            y: "31.4118",
            width: "66.8795",
            height: "60.192",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx194("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx194("feGaussianBlur", {
                in: "BackgroundImageFix",
                stdDeviation: "3.00209"
              }),
              /* @__PURE__ */ _jsx194("feComposite", {
                in2: "SourceAlpha",
                operator: "in",
                result: "effect1_backgroundBlur_86_9078"
              }),
              /* @__PURE__ */ _jsx194("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_backgroundBlur_86_9078",
                result: "shape"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs84("linearGradient", {
            id: "paint0_linear_86_9078",
            x1: "63.2488",
            y1: "37.416",
            x2: "79.5567",
            y2: "72.0504",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx194("stop", {
                stopColor: "#D6E8FF"
              }),
              /* @__PURE__ */ _jsx194("stop", {
                offset: "1",
                stopColor: "#D6E8FF",
                stopOpacity: "0"
              })
            ]
          })
        ]
      })
    ]
  });
};
var EmptyChat_default = /* @__PURE__ */ React98.memo(EmptyChat);

// src/shared/ui/images/shared/EmptyChatsList.tsx
import { jsx as _jsx195, jsxs as _jsxs85 } from "react/jsx-runtime";
import React99 from "react";
function _object_without_properties143(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose143(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose143(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EmptyChatsList = (_param) => {
  var { width: width2 = 80, height: height2 = 80 } = _param, props = _object_without_properties143(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs85("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsxs85("g", {
        filter: "url(#filter0_i_444_18754)",
        children: [
          /* @__PURE__ */ _jsx195("path", {
            d: "M8.63477 20.7561C8.63477 16.6285 8.63477 14.5646 9.91707 13.2823C11.1994 12 13.2632 12 17.3909 12H37.8786C42.0063 12 44.0701 12 45.3525 13.2823C46.6348 14.5646 46.6348 16.6285 46.6348 20.7562V57.2438C46.6348 61.3715 46.6348 63.4354 45.3525 64.7177C44.0701 66 42.0063 66 37.8786 66H17.3909C13.2632 66 11.1994 66 9.91707 64.7177C8.63477 63.4354 8.63477 61.3715 8.63477 57.2438V20.7561Z",
            fill: "url(#paint0_linear_444_18754)"
          }),
          /* @__PURE__ */ _jsx195("path", {
            d: "M29.3838 38.2294C29.3838 29.4431 36.5065 22.3203 45.2929 22.3203H45.891C48.3221 22.3203 50.2929 24.2911 50.2929 26.7222V49.7366C50.2929 52.1677 48.3221 54.1385 45.891 54.1385H45.2929C36.5065 54.1385 29.3838 47.0158 29.3838 38.2294Z",
            fill: "#95B9FF"
          }),
          /* @__PURE__ */ _jsx195("g", {
            filter: "url(#filter1_f_444_18754)",
            children: /* @__PURE__ */ _jsx195("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M47.0001 21.5598C46.4614 21.5202 45.9169 21.5 45.3673 21.5C33.9789 21.5 24.7471 30.1719 24.7471 40.875C24.7471 51.5781 33.9789 60.25 45.3673 60.25C45.9168 60.25 46.4614 60.2297 47.0001 60.1898V55.1691C46.4636 55.2226 45.9189 55.25 45.3673 55.25C36.9182 55.25 30.0684 48.8145 30.0684 40.875C30.0684 32.9355 36.9182 26.5 45.3673 26.5C45.9189 26.5 46.4636 26.5274 47.0001 26.5809V21.5598Z",
              fill: "#0645AB",
              fillOpacity: "0.8"
            })
          })
        ]
      }),
      /* @__PURE__ */ _jsx195("g", {
        filter: "url(#filter2_b_444_18754)",
        children: /* @__PURE__ */ _jsx195("circle", {
          cx: "43.0112",
          cy: "37.559",
          r: "14.375",
          fill: "#A3C8FF",
          fillOpacity: "0.4"
        })
      }),
      /* @__PURE__ */ _jsx195("circle", {
        opacity: "0.6",
        cx: "38.7377",
        cy: "32.6797",
        r: "5.90909",
        fill: "url(#paint1_linear_444_18754)",
        fillOpacity: "0.9"
      }),
      /* @__PURE__ */ _jsx195("g", {
        filter: "url(#filter3_i_444_18754)",
        children: /* @__PURE__ */ _jsx195("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54.1105 53.4379C50.9672 55.6351 47.1396 56.934 43.0112 56.934C32.3105 56.934 23.6362 48.2621 23.6362 37.559C23.6362 26.8558 32.3105 18.184 43.0112 18.184C53.7119 18.184 62.3862 26.8558 62.3862 37.559C62.3862 42.3246 60.6638 46.6898 57.8074 50.0687L72.7271 65.5579C73.7037 66.5345 73.7037 68.1165 72.7271 69.0931C71.7512 70.0696 70.1679 70.0696 69.192 69.0931L54.1105 53.4379ZM57.3862 37.559C57.3862 45.4984 50.9501 51.934 43.0112 51.934C35.0724 51.934 28.6362 45.4984 28.6362 37.559C28.6362 29.6195 35.0724 23.184 43.0112 23.184C50.9501 23.184 57.3862 29.6195 57.3862 37.559Z",
          fill: "#5A99FF"
        })
      }),
      /* @__PURE__ */ _jsxs85("defs", {
        children: [
          /* @__PURE__ */ _jsxs85("filter", {
            id: "filter0_i_444_18754",
            x: "8.63477",
            y: "12",
            width: "42.5673",
            height: "55.8182",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx195("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx195("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx195("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx195("feOffset", {
                dx: "0.909091",
                dy: "1.81818"
              }),
              /* @__PURE__ */ _jsx195("feGaussianBlur", {
                stdDeviation: "1.81818"
              }),
              /* @__PURE__ */ _jsx195("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx195("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0.525 0 0 0 0 0.715 0 0 0 0 1 0 0 0 0.4 0"
              }),
              /* @__PURE__ */ _jsx195("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect1_innerShadow_444_18754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs85("filter", {
            id: "filter1_f_444_18754",
            x: "17.4743",
            y: "14.2273",
            width: "36.7984",
            height: "53.2955",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx195("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx195("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx195("feGaussianBlur", {
                stdDeviation: "3.63636",
                result: "effect1_foregroundBlur_444_18754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs85("filter", {
            id: "filter2_b_444_18754",
            x: "24.9999",
            y: "19.5476",
            width: "36.0227",
            height: "36.0227",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx195("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx195("feGaussianBlur", {
                in: "BackgroundImageFix",
                stdDeviation: "1.81818"
              }),
              /* @__PURE__ */ _jsx195("feComposite", {
                in2: "SourceAlpha",
                operator: "in",
                result: "effect1_backgroundBlur_444_18754"
              }),
              /* @__PURE__ */ _jsx195("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_backgroundBlur_444_18754",
                result: "shape"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs85("filter", {
            id: "filter3_i_444_18754",
            x: "22.7271",
            y: "16.3658",
            width: "50.7323",
            height: "53.4597",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx195("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx195("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx195("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx195("feOffset", {
                dx: "-0.909091",
                dy: "-1.81818"
              }),
              /* @__PURE__ */ _jsx195("feGaussianBlur", {
                stdDeviation: "1.81818"
              }),
              /* @__PURE__ */ _jsx195("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx195("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0.242851 0 0 0 0 0.635547 0 0 0 0.81 0"
              }),
              /* @__PURE__ */ _jsx195("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect1_innerShadow_444_18754"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs85("linearGradient", {
            id: "paint0_linear_444_18754",
            x1: "16.2348",
            y1: "16.3393",
            x2: "65.9339",
            y2: "92.737",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx195("stop", {
                stopColor: "#DFEDFF"
              }),
              /* @__PURE__ */ _jsx195("stop", {
                offset: "1",
                stopColor: "#6CA6FF"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs85("linearGradient", {
            id: "paint1_linear_444_18754",
            x1: "44.1922",
            y1: "35.407",
            x2: "29.6468",
            y2: "27.6797",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx195("stop", {
                stopColor: "#E3EEFF"
              }),
              /* @__PURE__ */ _jsx195("stop", {
                offset: "1",
                stopColor: "#E3EEFF",
                stopOpacity: "0"
              })
            ]
          })
        ]
      })
    ]
  });
};
var EmptyChatsList_default = /* @__PURE__ */ React99.memo(EmptyChatsList);

// src/shared/ui/images/shared/EmptyConversation.tsx
import { jsx as _jsx196, jsxs as _jsxs86 } from "react/jsx-runtime";
import React100 from "react";
var EmptyConversation = ({ width: width2 = 80, height: height2 = 81 }) => /* @__PURE__ */ _jsxs86("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: width2,
  height: height2,
  viewBox: "0 0 80 81",
  fill: "none",
  children: [
    /* @__PURE__ */ _jsxs86("g", {
      filter: "url(#filter0_i_444_18804)",
      children: [
        /* @__PURE__ */ _jsx196("path", {
          d: "M35.4999 39.0996C43.2319 39.0996 49.4998 32.8397 49.4998 25.124C49.4998 17.4083 43.2319 11.1484 35.4999 11.1484C27.7679 11.1484 21.5 17.4083 21.5 25.124C21.5 32.8397 27.7679 39.0996 35.4999 39.0996Z",
          fill: "url(#paint0_linear_444_18804)"
        }),
        /* @__PURE__ */ _jsx196("path", {
          d: "M34.3332 41.4289C22.2359 41.4289 12.2891 50.6176 11.1158 62.3864C10.9876 63.6715 12.047 64.7215 13.3385 64.7215H56.4946C57.7861 64.7215 58.8455 63.6715 58.7173 62.3864C57.5441 50.6176 47.5973 41.4289 35.4999 41.4289H34.3332Z",
          fill: "url(#paint1_linear_444_18804)"
        })
      ]
    }),
    /* @__PURE__ */ _jsx196("g", {
      opacity: "0.3",
      filter: "url(#filter1_f_444_18804)",
      children: /* @__PURE__ */ _jsx196("path", {
        d: "M35.405 49.0328L32.8919 44.8334C35.7135 44.4903 36.3309 44.3945 39.4033 44.8334L37.9182 49.0328L43.0589 63.7307H31.6353L35.405 49.0328Z",
        fill: "#0044B2"
      })
    }),
    /* @__PURE__ */ _jsx196("g", {
      filter: "url(#filter2_i_444_18804)",
      children: /* @__PURE__ */ _jsx196("path", {
        d: "M32.8003 48.1527L31.3887 45.3295C31.0323 44.6168 31.4778 43.7628 32.2707 43.6846C33.8465 43.5292 35.4101 43.5001 37.0759 43.6693C37.8565 43.7486 38.2834 44.5905 37.9325 45.2923L36.5022 48.1527C36.3714 48.4144 36.3434 48.7155 36.4238 48.9968L40.55 63.4386C40.7634 64.1855 40.2026 64.9291 39.4257 64.9291H29.8768C29.0999 64.9291 28.5391 64.1855 28.7525 63.4386L32.8787 48.9968C32.9591 48.7155 32.9311 48.4144 32.8003 48.1527Z",
        fill: "url(#paint2_linear_444_18804)"
      })
    }),
    /* @__PURE__ */ _jsxs86("g", {
      filter: "url(#filter3_bi_444_18804)",
      children: [
        /* @__PURE__ */ _jsx196("path", {
          d: "M50.9933 46.6546C58.3796 46.6546 64.3673 40.6746 64.3673 33.3039C64.3673 25.9331 58.3796 19.9531 50.9933 19.9531C43.6071 19.9531 37.6194 25.9331 37.6194 33.3039C37.6194 40.6746 43.6071 46.6546 50.9933 46.6546Z",
          fill: "#A3C8FF",
          fillOpacity: "0.4"
        }),
        /* @__PURE__ */ _jsx196("path", {
          d: "M49.8788 48.8797C38.3224 48.8797 28.8203 57.6576 27.6995 68.9002C27.5771 70.1278 28.589 71.1309 29.8228 71.1309H71.0494C72.2831 71.1309 73.2951 70.1278 73.1727 68.9002C72.0519 57.6576 62.5498 48.8797 50.9933 48.8797H49.8788Z",
          fill: "#A3C8FF",
          fillOpacity: "0.4"
        }),
        /* @__PURE__ */ _jsx196("path", {
          d: "M64.1998 33.3039C64.1998 40.5818 58.2873 46.487 50.9933 46.487C43.6993 46.487 37.7869 40.5818 37.7869 33.3039C37.7869 26.0259 43.6993 20.1207 50.9933 20.1207C58.2873 20.1207 64.1998 26.0259 64.1998 33.3039ZM27.8662 68.9168C28.9785 57.7592 38.4091 49.0472 49.8788 49.0472H50.9933C62.4631 49.0472 71.8936 57.7592 73.006 68.9168C73.1175 70.0347 72.1956 70.9634 71.0494 70.9634H29.8228C28.6766 70.9634 27.7547 70.0347 27.8662 68.9168Z",
          stroke: "url(#paint3_linear_444_18804)",
          strokeOpacity: "0.5",
          strokeWidth: "0.335093"
        })
      ]
    }),
    /* @__PURE__ */ _jsxs86("defs", {
      children: [
        /* @__PURE__ */ _jsxs86("filter", {
          id: "filter0_i_444_18804",
          x: "11.1052",
          y: "11.1484",
          width: "48.7919",
          height: "55.9116",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ _jsx196("feFlood", {
              floodOpacity: "0",
              result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in: "SourceGraphic",
              in2: "BackgroundImageFix",
              result: "shape"
            }),
            /* @__PURE__ */ _jsx196("feColorMatrix", {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }),
            /* @__PURE__ */ _jsx196("feOffset", {
              dx: "1.16925",
              dy: "2.33851"
            }),
            /* @__PURE__ */ _jsx196("feGaussianBlur", {
              stdDeviation: "2.33851"
            }),
            /* @__PURE__ */ _jsx196("feComposite", {
              in2: "hardAlpha",
              operator: "arithmetic",
              k2: "-1",
              k3: "1"
            }),
            /* @__PURE__ */ _jsx196("feColorMatrix", {
              type: "matrix",
              values: "0 0 0 0 0.525 0 0 0 0 0.772 0 0 0 0 1 0 0 0 1 0"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in2: "shape",
              result: "effect1_innerShadow_444_18804"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("filter", {
          id: "filter1_f_444_18804",
          x: "30.5183",
          y: "43.4221",
          width: "13.6575",
          height: "21.4256",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ _jsx196("feFlood", {
              floodOpacity: "0",
              result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in: "SourceGraphic",
              in2: "BackgroundImageFix",
              result: "shape"
            }),
            /* @__PURE__ */ _jsx196("feGaussianBlur", {
              stdDeviation: "0.558488",
              result: "effect1_foregroundBlur_444_18804"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("filter", {
          id: "filter2_i_444_18804",
          x: "27.5375",
          y: "43.5547",
          width: "13.0582",
          height: "22.5436",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ _jsx196("feFlood", {
              floodOpacity: "0",
              result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in: "SourceGraphic",
              in2: "BackgroundImageFix",
              result: "shape"
            }),
            /* @__PURE__ */ _jsx196("feColorMatrix", {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }),
            /* @__PURE__ */ _jsx196("feOffset", {
              dx: "-1.16925",
              dy: "1.16925"
            }),
            /* @__PURE__ */ _jsx196("feGaussianBlur", {
              stdDeviation: "1.16925"
            }),
            /* @__PURE__ */ _jsx196("feComposite", {
              in2: "hardAlpha",
              operator: "arithmetic",
              k2: "-1",
              k3: "1"
            }),
            /* @__PURE__ */ _jsx196("feColorMatrix", {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in2: "shape",
              result: "effect1_innerShadow_444_18804"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("filter", {
          id: "filter3_bi_444_18804",
          x: "22.8386",
          y: "15.1023",
          width: "55.195",
          height: "60.8795",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ _jsx196("feFlood", {
              floodOpacity: "0",
              result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ _jsx196("feGaussianBlur", {
              in: "BackgroundImageFix",
              stdDeviation: "2.42543"
            }),
            /* @__PURE__ */ _jsx196("feComposite", {
              in2: "SourceAlpha",
              operator: "in",
              result: "effect1_backgroundBlur_444_18804"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_backgroundBlur_444_18804",
              result: "shape"
            }),
            /* @__PURE__ */ _jsx196("feColorMatrix", {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }),
            /* @__PURE__ */ _jsx196("feOffset", {
              dx: "0.594671",
              dy: "0.594671"
            }),
            /* @__PURE__ */ _jsx196("feGaussianBlur", {
              stdDeviation: "0.594671"
            }),
            /* @__PURE__ */ _jsx196("feComposite", {
              in2: "hardAlpha",
              operator: "arithmetic",
              k2: "-1",
              k3: "1"
            }),
            /* @__PURE__ */ _jsx196("feColorMatrix", {
              type: "matrix",
              values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.33 0"
            }),
            /* @__PURE__ */ _jsx196("feBlend", {
              mode: "normal",
              in2: "shape",
              result: "effect2_innerShadow_444_18804"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("linearGradient", {
          id: "paint0_linear_444_18804",
          x1: "31.4166",
          y1: "30.3649",
          x2: "53.524",
          y2: "70.5772",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ _jsx196("stop", {
              stopColor: "#8DBAFF"
            }),
            /* @__PURE__ */ _jsx196("stop", {
              offset: "1",
              stopColor: "#0062FF"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("linearGradient", {
          id: "paint1_linear_444_18804",
          x1: "31.4166",
          y1: "30.3649",
          x2: "53.524",
          y2: "70.5772",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ _jsx196("stop", {
              stopColor: "#8DBAFF"
            }),
            /* @__PURE__ */ _jsx196("stop", {
              offset: "1",
              stopColor: "#0062FF"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("linearGradient", {
          id: "paint2_linear_444_18804",
          x1: "40.0192",
          y1: "56.1607",
          x2: "15.1459",
          y2: "47.5009",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ _jsx196("stop", {
              stopColor: "#005EF4"
            }),
            /* @__PURE__ */ _jsx196("stop", {
              offset: "1",
              stopColor: "#ADCDFF"
            })
          ]
        }),
        /* @__PURE__ */ _jsxs86("linearGradient", {
          id: "paint3_linear_444_18804",
          x1: "41.5201",
          y1: "32.1913",
          x2: "67.0913",
          y2: "71.1718",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ _jsx196("stop", {
              stopColor: "#86B6FF"
            }),
            /* @__PURE__ */ _jsx196("stop", {
              offset: "1",
              stopColor: "#C4DBFF",
              stopOpacity: "0"
            })
          ]
        })
      ]
    })
  ]
});
var EmptyConversation_default = /* @__PURE__ */ React100.memo(EmptyConversation);

// src/shared/ui/images/shared/EmptyList.tsx
import { jsx as _jsx197, jsxs as _jsxs87 } from "react/jsx-runtime";
import React101 from "react";
function _define_property171(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread171(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property171(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys153(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props153(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys153(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties144(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose144(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose144(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EmptyList = (_param) => {
  var { fill = getCssVar("grey", 100), width: width2 = 72, height: height2 = 72 } = _param, props = _object_without_properties144(_param, [
    "fill",
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs87("svg", _object_spread_props153(_object_spread171({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    fill,
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx197("rect", {
        y: "52",
        width: "72",
        height: "20",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        opacity: "0.9",
        x: "23",
        y: "58",
        width: "24",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        opacity: "0.9",
        x: "23",
        y: "63",
        width: "13",
        height: "2",
        fill: "#4E5158"
      }),
      /* @__PURE__ */ _jsx197("path", {
        d: "M14 61.1339C14.6667 61.5188 14.6667 62.4811 14 62.866L9.5 65.4641C8.83333 65.849 8 65.3678 8 64.598L8 59.4019C8 58.6321 8.83333 58.151 9.5 58.5359L14 61.1339Z",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        y: "26",
        width: "72",
        height: "20",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        opacity: "0.9",
        x: "23",
        y: "32",
        width: "24",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        opacity: "0.9",
        x: "23",
        y: "37",
        width: "13",
        height: "2",
        fill: "#4E5158"
      }),
      /* @__PURE__ */ _jsx197("path", {
        d: "M14 35.1339C14.6667 35.5188 14.6667 36.4811 14 36.866L9.5 39.4641C8.83333 39.849 8 39.3678 8 38.598L8 33.4019C8 32.6321 8.83333 32.151 9.5 32.5359L14 35.1339Z",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        width: "72",
        height: "20",
        rx: "4",
        fill: "#3A3C41"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        opacity: "0.9",
        x: "23",
        y: "7",
        width: "24",
        height: "2",
        fill: "#898E96"
      }),
      /* @__PURE__ */ _jsx197("rect", {
        opacity: "0.9",
        x: "23",
        y: "12",
        width: "13",
        height: "2",
        fill: "#4E5158"
      }),
      /* @__PURE__ */ _jsx197("path", {
        d: "M14 9.13393C14.6667 9.51883 14.6667 10.4811 14 10.866L9.5 13.4641C8.83333 13.849 8 13.3678 8 12.598L8 7.40188C8 6.63208 8.83333 6.15096 9.5 6.53586L14 9.13393Z",
        fill: "#898E96"
      })
    ]
  }));
};
var EmptyList_default = /* @__PURE__ */ React101.memo(EmptyList);

// src/shared/ui/images/shared/PictureBulk.tsx
import { jsx as _jsx198, jsxs as _jsxs88 } from "react/jsx-runtime";
import React102 from "react";
function _define_property172(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread172(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property172(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys154(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props154(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys154(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties145(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose145(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose145(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var PictureBulk = (_param) => {
  var { fill = getCssVar("grey", 500), width: width2 = 60, height: height2 = 54 } = _param, props = _object_without_properties145(_param, [
    "fill",
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs88("svg", _object_spread_props154(_object_spread172({
    width: width2,
    height: height2,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ _jsx198("path", {
        d: "M40.5 18C42.9853 18 45 15.9853 45 13.5C45 11.0147 42.9853 9 40.5 9C38.0147 9 36 11.0147 36 13.5C36 15.9853 38.0147 18 40.5 18Z",
        fill
      }),
      /* @__PURE__ */ _jsx198("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 0C4.02944 0 0 4.02944 0 9V45C0 49.9706 4.02944 54 9 54H51C55.9706 54 60 49.9706 60 45V9C60 4.02944 55.9706 0 51 0H9ZM51 6H9C7.34315 6 6 7.34315 6 9V24.3748L15 16.4993L39 39L48 30L54 35V9C54 7.34314 52.6569 6 51 6Z",
        fill
      })
    ]
  }));
};
var PictureBulk_default = /* @__PURE__ */ React102.memo(PictureBulk);

// src/shared/ui/images/shared/Logo.tsx
import { jsx as _jsx199, jsxs as _jsxs89 } from "react/jsx-runtime";
import React103 from "react";
function _define_property173(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread173(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property173(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys155(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props155(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys155(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties146(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose146(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose146(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Logo = (_param) => {
  var { fill = getCssVar("grey", 100), width: width2 = 61, height: height2 = 15 } = _param, props = _object_without_properties146(_param, [
    "fill",
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs89("svg", _object_spread_props155(_object_spread173({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 15",
    fill,
    width: width2,
    height: height2
  }, props), {
    children: [
      /* @__PURE__ */ _jsx199("path", {
        d: "M60.6013 0.0580645H58.1413C58.0377 0.0580645 57.9383 0.0992364 57.865 0.172523C57.7917 0.24581 57.7505 0.345209 57.7505 0.448852V9.38617H57.6723L57.2816 8.84297L49.8976 0.19484C49.862 0.15173 49.8172 0.117093 49.7665 0.0934367C49.7158 0.0697801 49.6605 0.0576968 49.6045 0.0580645H46.9335C46.8299 0.0580645 46.7305 0.0992364 46.6572 0.172523C46.5839 0.24581 46.5427 0.345209 46.5427 0.448852V14.1147C46.5427 14.2183 46.5839 14.3177 46.6572 14.391C46.7305 14.4643 46.8299 14.5055 46.9335 14.5055H49.3955C49.4991 14.5055 49.5985 14.4643 49.6718 14.391C49.7451 14.3177 49.7863 14.2183 49.7863 14.1147V5.17738H49.8644L50.2552 5.71862L57.645 14.3668C57.6817 14.409 57.727 14.443 57.7779 14.4662C57.8288 14.4895 57.8841 14.5015 57.94 14.5016H60.6091C60.7128 14.5016 60.8122 14.4604 60.8854 14.3871C60.9587 14.3138 60.9999 14.2144 60.9999 14.1108V0.446899C60.9997 0.395081 60.9891 0.343829 60.9689 0.296126C60.9486 0.248424 60.9191 0.205222 60.882 0.169038C60.8449 0.132854 60.801 0.104409 60.7528 0.0853569C60.7046 0.0663052 60.6531 0.0570275 60.6013 0.0580645Z"
      }),
      /* @__PURE__ */ _jsx199("path", {
        d: "M7.31555 0.0579863H0.390788C0.287144 0.0579863 0.187746 0.0991581 0.114459 0.172445C0.0411719 0.245732 0 0.345131 0 0.448774V14.1146C0 14.2183 0.0411719 14.3177 0.114459 14.3909C0.187746 14.4642 0.287144 14.5054 0.390788 14.5054H7.45623C9.34649 14.5033 11.1607 13.7609 12.5102 12.4373C13.8597 11.1137 14.6372 9.31419 14.676 7.42433C14.7522 3.37187 11.3622 0.0579863 7.31555 0.0579863ZM7.16704 11.4768H3.60306C3.49942 11.4768 3.40002 11.4356 3.32673 11.3623C3.25345 11.2891 3.21227 11.1897 3.21227 11.086V3.47738C3.21227 3.37374 3.25345 3.27434 3.32673 3.20105C3.40002 3.12776 3.49942 3.08659 3.60306 3.08659H7.45818C9.75602 3.08659 11.4169 4.93697 11.4423 7.22894C11.4657 9.5639 9.502 11.4768 7.16509 11.4768H7.16704Z"
      }),
      /* @__PURE__ */ _jsx199("path", {
        d: "M44.8475 7.28661C44.8475 3.26382 41.657 0.0038625 37.7192 0H36.1221C32.1804 0 28.9861 3.26189 28.9861 7.28661C28.9861 11.3113 32.1862 14.5752 36.1221 14.5752H37.7385C41.6686 14.5578 44.8475 11.3017 44.8475 7.28661ZM37.7018 11.5354H36.1143C33.8239 11.5354 32.1765 9.63888 32.1765 7.30013C32.1765 4.96139 33.8239 3.0649 36.1143 3.0649H37.7018C39.9942 3.0649 41.6416 4.96139 41.6416 7.30013C41.6416 9.63888 40.0019 11.5373 37.7095 11.5373L37.7018 11.5354Z"
      }),
      /* @__PURE__ */ _jsx199("path", {
        d: "M18.6827 3.08678H15.6179C15.5153 3.08678 15.4169 3.04561 15.3443 2.97232C15.2717 2.89904 15.231 2.79964 15.231 2.69599V0.454827C15.231 0.351184 15.2717 0.251785 15.3443 0.178498C15.4169 0.105211 15.5153 0.0640393 15.6179 0.0640393H21.2637C21.3202 0.0633037 21.3762 0.0750627 21.4277 0.0984872C21.4791 0.121912 21.5249 0.156434 21.5618 0.199634C21.5987 0.242833 21.6258 0.293662 21.6411 0.348549C21.6565 0.403437 21.6597 0.461054 21.6507 0.517354C21.5423 1.23346 21.1832 1.88656 20.6386 2.35804C20.094 2.82951 19.4 3.08808 18.6827 3.08678Z"
      }),
      /* @__PURE__ */ _jsx199("path", {
        d: "M20.063 11.0978V7.29548C20.063 5.37808 20.8247 3.53921 22.1805 2.1834C23.5363 0.827593 25.3752 0.0659075 27.2926 0.0659075H27.7049C27.8085 0.0659075 27.9079 0.107082 27.9812 0.180369C28.0545 0.253656 28.0957 0.353052 28.0957 0.456695V2.69591C28.0957 2.79955 28.0545 2.89895 27.9812 2.97224C27.9079 3.04553 27.8085 3.0867 27.7049 3.0867H23.6856C23.582 3.0867 23.4826 3.12787 23.4093 3.20116C23.336 3.27444 23.2949 3.37384 23.2949 3.47748V7.27008C23.2949 9.18748 22.5332 11.0264 21.1774 12.3822C19.8216 13.738 17.9827 14.4997 16.0653 14.4997H15.6315C15.5279 14.4997 15.4285 14.4585 15.3552 14.3852C15.2819 14.3119 15.2407 14.2125 15.2407 14.1089V11.8638C15.2407 11.7601 15.2819 11.6607 15.3552 11.5875C15.4285 11.5142 15.5279 11.473 15.6315 11.473H19.6781C19.7781 11.4716 19.8737 11.4319 19.9453 11.3621C20.0169 11.2923 20.0591 11.1977 20.063 11.0978Z"
      }),
      /* @__PURE__ */ _jsx199("path", {
        d: "M24.6402 11.4749H27.6896C27.7927 11.4749 27.8917 11.5161 27.9646 11.5893C28.0375 11.6626 28.0785 11.762 28.0785 11.8657V14.1147C28.0785 14.2183 28.0375 14.3177 27.9646 14.391C27.8917 14.4643 27.7927 14.5054 27.6896 14.5054H22.0497C21.993 14.5062 21.9367 14.4944 21.885 14.471C21.8332 14.4476 21.7872 14.4131 21.7501 14.3699C21.7131 14.3267 21.6858 14.2758 21.6704 14.2209C21.655 14.1661 21.6517 14.1084 21.6608 14.0521C21.7683 13.3354 22.128 12.6812 22.6747 12.2083C23.2214 11.7355 23.9188 11.4752 24.6402 11.4749Z"
      })
    ]
  }));
};
var Logo_default = /* @__PURE__ */ React103.memo(Logo);

// src/shared/ui/images/shared/DataError.tsx
import { jsx as _jsx200, jsxs as _jsxs90 } from "react/jsx-runtime";
import React104 from "react";
function _object_without_properties147(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose147(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose147(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var DataError = (_param) => {
  var { width: width2 = 80, height: height2 = 80 } = _param, props = _object_without_properties147(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs90("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsx200("g", {
        filter: "url(#filter0_i_444_18702)",
        children: /* @__PURE__ */ _jsx200("path", {
          d: "M46.9089 12.1499C46.2805 11.5215 45.4281 11.1685 44.5394 11.1685H26.9468C26.058 11.1685 25.2057 11.5215 24.5773 12.1499L12.1511 24.5761C11.5227 25.2045 11.1696 26.0569 11.1696 26.9456V44.5382C11.1696 45.427 11.5227 46.2793 12.1511 46.9077L24.5773 59.3339C25.2057 59.9623 26.058 60.3154 26.9468 60.3154H44.5394C45.4281 60.3154 46.2805 59.9623 46.9089 59.3339L59.3351 46.9077C59.9635 46.2793 60.3165 45.427 60.3165 44.5382V26.9456C60.3165 26.0569 59.9635 25.2045 59.3351 24.5761L46.9089 12.1499Z",
          fill: "url(#paint0_linear_444_18702)"
        })
      }),
      /* @__PURE__ */ _jsx200("g", {
        filter: "url(#filter1_f_444_18702)",
        children: /* @__PURE__ */ _jsx200("path", {
          d: "M23.9848 45.8346C23.0247 46.7888 23.0247 48.336 23.9848 49.2902L25.015 50.3142C25.975 51.2685 27.5316 51.2685 28.4917 50.3142L36.1928 42.6596C36.4107 42.4431 36.7624 42.4431 36.9803 42.6596L44.8447 50.4765C45.8048 51.4307 47.3613 51.4307 48.3214 50.4765L49.3516 49.4525C50.3117 48.4982 50.3117 46.9511 49.3516 45.9968L41.492 38.1847C41.2723 37.9663 41.2723 37.6109 41.492 37.3925L49.3518 29.5801C50.3119 28.6259 50.3119 27.0787 49.3518 26.1244L48.3216 25.1005C47.3616 24.1462 45.805 24.1462 44.8449 25.1005L36.9803 32.9176C36.7624 33.1341 36.4107 33.1341 36.1928 32.9176L28.4914 25.2627C27.5314 24.3085 25.9748 24.3085 25.0147 25.2627L23.9845 26.2867C23.0245 27.241 23.0245 28.7881 23.9845 29.7424L31.6811 37.3925C31.9008 37.6109 31.9008 37.9663 31.6811 38.1847L23.9848 45.8346Z",
          fill: "url(#paint1_linear_444_18702)"
        })
      }),
      /* @__PURE__ */ _jsx200("path", {
        d: "M30.1614 34.8656C30.5975 35.3019 30.5973 36.0092 30.161 36.4453L23.1297 43.4729C22.6933 43.9091 22.6932 44.6165 23.1295 45.0528L26.247 48.1702C26.6831 48.6064 27.3902 48.6065 27.8264 48.1704L34.8581 41.142C35.2943 40.7061 36.0012 40.7061 36.4374 41.142L43.6598 48.3608C44.0961 48.7968 44.8031 48.7967 45.2393 48.3606L48.3568 45.2431C48.7931 44.8068 48.793 44.0994 48.3566 43.6632L41.135 36.4453C40.6986 36.0092 40.6985 35.3019 41.1346 34.8656L48.1671 27.8297C48.6031 27.3935 48.603 26.6864 48.1669 26.2503L45.049 23.1324C44.6128 22.6963 43.9058 22.6962 43.4695 23.1322L36.4374 30.1606C36.0012 30.5966 35.2943 30.5966 34.8581 30.1606L28.0167 23.3225C27.5805 22.8865 26.8734 22.8866 26.4373 23.3227L23.3194 26.4406C22.8832 26.8767 22.8831 27.5838 23.3192 28.02L30.1614 34.8656Z",
        fill: "url(#paint2_linear_444_18702)"
      }),
      /* @__PURE__ */ _jsx200("path", {
        d: "M30.2795 36.5638C30.7812 36.0623 30.7814 35.2489 30.2799 34.7472L23.4377 27.9016C23.067 27.5308 23.0671 26.9298 23.4378 26.5591L26.5558 23.4412C26.9265 23.0705 27.5275 23.0704 27.8983 23.441L34.7397 30.2791C35.2412 30.7805 36.0542 30.7805 36.5558 30.2792L43.588 23.2507C43.9588 22.8801 44.5598 22.8801 44.9305 23.2508L48.0484 26.3687C48.4191 26.7395 48.4192 27.3405 48.0486 27.7113L41.0161 34.7472C40.5145 35.2489 40.5147 36.0623 41.0165 36.5638L48.2382 43.7817C48.6091 44.1525 48.6092 44.7538 48.2383 45.1246L45.1208 48.2421C44.7501 48.6128 44.1491 48.6129 43.7783 48.2423L36.5558 41.0235C36.0542 40.5222 35.2412 40.5222 34.7397 41.0235L27.708 48.0519C27.3372 48.4226 26.7362 48.4225 26.3655 48.0518L23.2479 44.9343C22.8771 44.5634 22.8772 43.9622 23.2481 43.5914L30.2795 36.5638Z",
        stroke: "url(#paint3_linear_444_18702)",
        strokeOpacity: "0.5",
        strokeWidth: "0.335093"
      }),
      /* @__PURE__ */ _jsxs90("g", {
        filter: "url(#filter2_bi_444_18702)",
        children: [
          /* @__PURE__ */ _jsx200("mask", {
            id: "path-5-inside-1_444_18702",
            fill: "white",
            children: /* @__PURE__ */ _jsx200("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M59.5322 35.5576C60.2806 35.5576 60.9983 35.8549 61.5275 36.3841L70.2844 45.141C70.8136 45.6702 71.1109 46.3879 71.1109 47.1363V59.5345C71.1109 60.2829 70.8136 61.0006 70.2844 61.5298L61.5275 70.2867C60.9983 70.8159 60.2806 71.1132 59.5322 71.1132H47.1341C46.3857 71.1132 45.6679 70.8159 45.1387 70.2867L36.3819 61.5298C35.8527 61.0006 35.5554 60.2829 35.5554 59.5345V47.1363C35.5554 46.3879 35.8527 45.6702 36.3819 45.141L45.1387 36.3841C45.6679 35.8549 46.3857 35.5576 47.1341 35.5576H59.5322ZM53.6146 60.3156C57.3159 60.3156 60.3164 57.315 60.3164 53.6137C60.3164 49.9124 57.3159 46.9119 53.6146 46.9119C49.9132 46.9119 46.9127 49.9124 46.9127 53.6137C46.9127 57.315 49.9132 60.3156 53.6146 60.3156Z"
            })
          }),
          /* @__PURE__ */ _jsx200("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.5322 35.5576C60.2806 35.5576 60.9983 35.8549 61.5275 36.3841L70.2844 45.141C70.8136 45.6702 71.1109 46.3879 71.1109 47.1363V59.5345C71.1109 60.2829 70.8136 61.0006 70.2844 61.5298L61.5275 70.2867C60.9983 70.8159 60.2806 71.1132 59.5322 71.1132H47.1341C46.3857 71.1132 45.6679 70.8159 45.1387 70.2867L36.3819 61.5298C35.8527 61.0006 35.5554 60.2829 35.5554 59.5345V47.1363C35.5554 46.3879 35.8527 45.6702 36.3819 45.141L45.1387 36.3841C45.6679 35.8549 46.3857 35.5576 47.1341 35.5576H59.5322ZM53.6146 60.3156C57.3159 60.3156 60.3164 57.315 60.3164 53.6137C60.3164 49.9124 57.3159 46.9119 53.6146 46.9119C49.9132 46.9119 46.9127 49.9124 46.9127 53.6137C46.9127 57.315 49.9132 60.3156 53.6146 60.3156Z",
            fill: "#FDC2C2",
            fillOpacity: "0.3"
          }),
          /* @__PURE__ */ _jsx200("path", {
            d: "M61.5275 36.3841L61.2282 36.6834V36.6834L61.5275 36.3841ZM70.2844 45.141L69.9851 45.4403V45.4403L70.2844 45.141ZM70.2844 61.5298L69.9851 61.2305L70.2844 61.5298ZM61.5275 70.2867L61.2282 69.9874L61.5275 70.2867ZM45.1387 70.2867L45.438 69.9874H45.438L45.1387 70.2867ZM36.3819 61.5298L36.6812 61.2305H36.6812L36.3819 61.5298ZM36.3819 45.141L36.0826 44.8417H36.0826L36.3819 45.141ZM45.1387 36.3841L44.8394 36.0848V36.0848L45.1387 36.3841ZM61.8268 36.0848C61.2183 35.4762 60.3929 35.1343 59.5322 35.1343V35.9809C60.1683 35.9809 60.7784 36.2336 61.2282 36.6834L61.8268 36.0848ZM70.5837 44.8417L61.8268 36.0848L61.2282 36.6834L69.9851 45.4403L70.5837 44.8417ZM71.5342 47.1363C71.5342 46.2757 71.1923 45.4503 70.5837 44.8417L69.9851 45.4403C70.4349 45.8901 70.6876 46.5002 70.6876 47.1363H71.5342ZM71.5342 59.5345V47.1363H70.6876V59.5345H71.5342ZM70.5837 61.8291C71.1923 61.2205 71.5342 60.3951 71.5342 59.5345H70.6876C70.6876 60.1706 70.4349 60.7807 69.9851 61.2305L70.5837 61.8291ZM61.8268 70.586L70.5837 61.8291L69.9851 61.2305L61.2282 69.9874L61.8268 70.586ZM59.5322 71.5364C60.3929 71.5364 61.2183 71.1946 61.8268 70.586L61.2282 69.9874C60.7784 70.4372 60.1683 70.6899 59.5322 70.6899V71.5364ZM47.1341 71.5364H59.5322V70.6899H47.1341V71.5364ZM44.8394 70.586C45.448 71.1946 46.2734 71.5364 47.1341 71.5364V70.6899C46.4979 70.6899 45.8879 70.4372 45.438 69.9874L44.8394 70.586ZM36.0826 61.8291L44.8394 70.586L45.438 69.9874L36.6812 61.2305L36.0826 61.8291ZM35.1321 59.5345C35.1321 60.3951 35.474 61.2205 36.0826 61.8291L36.6812 61.2305C36.2313 60.7807 35.9786 60.1706 35.9786 59.5345H35.1321ZM35.1321 47.1363V59.5345H35.9786V47.1363H35.1321ZM36.0826 44.8417C35.474 45.4503 35.1321 46.2757 35.1321 47.1363H35.9786C35.9786 46.5002 36.2313 45.8901 36.6812 45.4403L36.0826 44.8417ZM44.8394 36.0848L36.0826 44.8417L36.6812 45.4403L45.438 36.6834L44.8394 36.0848ZM47.1341 35.1343C46.2734 35.1343 45.448 35.4762 44.8394 36.0848L45.438 36.6834C45.8879 36.2336 46.4979 35.9809 47.1341 35.9809V35.1343ZM59.5322 35.1343H47.1341V35.9809H59.5322V35.1343ZM59.8931 53.6137C59.8931 57.0813 57.0821 59.8923 53.6146 59.8923V60.7388C57.5497 60.7388 60.7397 57.5488 60.7397 53.6137H59.8931ZM53.6146 47.3351C57.0821 47.3351 59.8931 50.1462 59.8931 53.6137H60.7397C60.7397 49.6786 57.5497 46.4886 53.6146 46.4886V47.3351ZM47.336 53.6137C47.336 50.1462 50.147 47.3351 53.6146 47.3351V46.4886C49.6795 46.4886 46.4894 49.6786 46.4894 53.6137H47.336ZM53.6146 59.8923C50.147 59.8923 47.336 57.0813 47.336 53.6137H46.4894C46.4894 57.5488 49.6795 60.7388 53.6146 60.7388V59.8923Z",
            fill: "url(#paint4_linear_444_18702)",
            fillOpacity: "0.4",
            mask: "url(#path-5-inside-1_444_18702)"
          })
        ]
      }),
      /* @__PURE__ */ _jsxs90("defs", {
        children: [
          /* @__PURE__ */ _jsxs90("filter", {
            id: "filter0_i_444_18702",
            x: "11.1696",
            y: "11.1685",
            width: "50.2639",
            height: "51.3809",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx200("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx200("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx200("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx200("feOffset", {
                dx: "1.11698",
                dy: "2.23395"
              }),
              /* @__PURE__ */ _jsx200("feGaussianBlur", {
                stdDeviation: "2.23395"
              }),
              /* @__PURE__ */ _jsx200("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx200("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 1 0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 1 0"
              }),
              /* @__PURE__ */ _jsx200("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect1_innerShadow_444_18702"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("filter", {
            id: "filter1_f_444_18702",
            x: "14.1256",
            y: "15.2459",
            width: "45.0852",
            height: "45.0851",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx200("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx200("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx200("feGaussianBlur", {
                stdDeviation: "4.56944",
                result: "effect1_foregroundBlur_444_18702"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("filter", {
            id: "filter2_bi_444_18702",
            x: "29.428",
            y: "29.4302",
            width: "47.8104",
            height: "47.8105",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx200("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx200("feGaussianBlur", {
                in: "BackgroundImageFix",
                stdDeviation: "3.0637"
              }),
              /* @__PURE__ */ _jsx200("feComposite", {
                in2: "SourceAlpha",
                operator: "in",
                result: "effect1_backgroundBlur_444_18702"
              }),
              /* @__PURE__ */ _jsx200("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_backgroundBlur_444_18702",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx200("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx200("feOffset", {
                dx: "0.751163",
                dy: "0.751163"
              }),
              /* @__PURE__ */ _jsx200("feGaussianBlur", {
                stdDeviation: "0.751163"
              }),
              /* @__PURE__ */ _jsx200("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx200("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.33 0"
              }),
              /* @__PURE__ */ _jsx200("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect2_innerShadow_444_18702"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("linearGradient", {
            id: "paint0_linear_444_18702",
            x1: "29.5997",
            y1: "15.0779",
            x2: "36.8601",
            y2: "56.406",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx200("stop", {
                stopColor: "#FF9696"
              }),
              /* @__PURE__ */ _jsx200("stop", {
                offset: "1",
                stopColor: "#FD6767"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("linearGradient", {
            id: "paint1_linear_444_18702",
            x1: "43.7575",
            y1: "45.9757",
            x2: "17.4785",
            y2: "21.3814",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx200("stop", {
                stopColor: "#950404"
              }),
              /* @__PURE__ */ _jsx200("stop", {
                offset: "0.796875",
                stopColor: "#D14646"
              }),
              /* @__PURE__ */ _jsx200("stop", {
                offset: "1",
                stopColor: "#FF7A7A"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("linearGradient", {
            id: "paint2_linear_444_18702",
            x1: "32.3922",
            y1: "25.1352",
            x2: "43.0035",
            y2: "44.1238",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx200("stop", {
                stopColor: "#FFC5C5"
              }),
              /* @__PURE__ */ _jsx200("stop", {
                offset: "1",
                stopColor: "#FF6969"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("linearGradient", {
            id: "paint3_linear_444_18702",
            x1: "31.8337",
            y1: "19.5503",
            x2: "45.7959",
            y2: "41.3314",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx200("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx200("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs90("linearGradient", {
            id: "paint4_linear_444_18702",
            x1: "41.8517",
            y1: "44.4465",
            x2: "56.6665",
            y2: "64.4465",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx200("stop", {
                stopColor: "white"
              }),
              /* @__PURE__ */ _jsx200("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0.01"
              })
            ]
          })
        ]
      })
    ]
  });
};
var DataError_default = /* @__PURE__ */ React104.memo(DataError);

// src/shared/ui/images/shared/EmptySearchList.tsx
import { jsx as _jsx201, jsxs as _jsxs91 } from "react/jsx-runtime";
import React105 from "react";
function _object_without_properties148(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose148(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose148(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EmptySearchList = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties148(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs91("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsx201("path", {
        d: "M10.3689 24.9249C10.3689 19.9682 10.3689 17.4898 11.9087 15.95C13.4486 14.4102 15.9269 14.4102 20.8836 14.4102H45.486C50.4427 14.4102 52.921 14.4102 54.4609 15.95C56.0007 17.4898 56.0007 19.9682 56.0007 24.9249V68.7406C56.0007 73.6973 56.0007 76.1757 54.4609 77.7155C52.921 79.2553 50.4427 79.2553 45.486 79.2553H20.8836C15.9269 79.2553 13.4486 79.2553 11.9087 77.7155C10.3689 76.1757 10.3689 73.6973 10.3689 68.7406V24.9249Z",
        fill: "#6F7687"
      }),
      /* @__PURE__ */ _jsx201("path", {
        d: "M32.6235 45.6318C32.6235 35.0206 41.2257 26.4185 51.8369 26.4185H54.4282C57.6395 26.4185 60.2428 29.0217 60.2428 32.233V45.6318V59.0307C60.2428 62.242 57.6395 64.8452 54.4282 64.8452H51.8369C41.2257 64.8452 32.6235 56.2431 32.6235 45.6318Z",
        fill: "#565C6A"
      }),
      /* @__PURE__ */ _jsx201("g", {
        filter: "url(#filter0_f_1109_34192)",
        children: /* @__PURE__ */ _jsx201("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M56.4396 25.8897C55.7927 25.8421 55.1388 25.8179 54.4788 25.8179C40.8032 25.8179 29.7173 36.2314 29.7173 49.0841C29.7173 61.9368 40.8032 72.3503 54.4788 72.3503C55.1388 72.3503 55.7927 72.3259 56.4396 72.278V66.249C55.7954 66.3132 55.1412 66.3461 54.4788 66.3461C44.3329 66.3461 36.1074 58.6181 36.1074 49.0841C36.1074 39.5501 44.3329 31.8221 54.4788 31.8221C55.1412 31.8221 55.7954 31.855 56.4396 31.9192V25.8897Z",
          fill: "#6780A7",
          fillOpacity: "0.2"
        })
      }),
      /* @__PURE__ */ _jsx201("g", {
        filter: "url(#filter1_b_1109_34192)",
        children: /* @__PURE__ */ _jsx201("circle", {
          cx: "51.6497",
          cy: "45.1024",
          r: "17.262",
          fill: "#8B99AE",
          fillOpacity: "0.3"
        })
      }),
      /* @__PURE__ */ _jsx201("circle", {
        opacity: "0.6",
        cx: "46.5175",
        cy: "39.2433",
        r: "7.09585",
        fill: "url(#paint0_linear_1109_34192)",
        fillOpacity: "0.5"
      }),
      /* @__PURE__ */ _jsx201("g", {
        filter: "url(#filter2_i_1109_34192)",
        children: /* @__PURE__ */ _jsx201("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M65.5709 64.7855C65.2296 64.4311 64.6824 64.3798 64.2691 64.6468C60.6341 66.9955 56.301 68.3684 51.6498 68.3684C38.8 68.3684 28.3835 57.9549 28.3835 45.1022C28.3835 32.2494 38.8 21.8359 51.6498 21.8359C64.4995 21.8359 74.916 32.2494 74.916 45.1022C74.916 50.5009 73.0752 55.4718 69.9868 59.424C69.6711 59.828 69.688 60.4051 70.0437 60.7744L87.3337 78.7243C88.5064 79.897 88.5064 81.7968 87.3337 82.9695C86.1618 84.1421 84.2605 84.1421 83.0886 82.9695L65.5709 64.7855ZM68.9118 45.1022C68.9118 54.6361 61.183 62.3642 51.6498 62.3642C42.1165 62.3642 34.3877 54.6361 34.3877 45.1022C34.3877 35.5682 42.1165 27.8401 51.6498 27.8401C61.183 27.8401 68.9118 35.5682 68.9118 45.1022Z",
          fill: "#4D566D"
        })
      }),
      /* @__PURE__ */ _jsxs91("defs", {
        children: [
          /* @__PURE__ */ _jsxs91("filter", {
            id: "filter0_f_1109_34192",
            x: "24.9139",
            y: "21.0145",
            width: "36.3291",
            height: "56.1389",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx201("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx201("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx201("feGaussianBlur", {
                stdDeviation: "2.40167",
                result: "effect1_foregroundBlur_1109_34192"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs91("filter", {
            id: "filter1_b_1109_34192",
            x: "30.7852",
            y: "24.2378",
            width: "41.7292",
            height: "41.7289",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx201("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx201("feGaussianBlur", {
                in: "BackgroundImageFix",
                stdDeviation: "1.80126"
              }),
              /* @__PURE__ */ _jsx201("feComposite", {
                in2: "SourceAlpha",
                operator: "in",
                result: "effect1_backgroundBlur_1109_34192"
              }),
              /* @__PURE__ */ _jsx201("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_backgroundBlur_1109_34192",
                result: "shape"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs91("filter", {
            id: "filter2_i_1109_34192",
            x: "26.659",
            y: "20.1114",
            width: "61.5541",
            height: "63.7377",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _jsx201("feFlood", {
                floodOpacity: "0",
                result: "BackgroundImageFix"
              }),
              /* @__PURE__ */ _jsx201("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              /* @__PURE__ */ _jsx201("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }),
              /* @__PURE__ */ _jsx201("feOffset", {
                dx: "-1.72453",
                dy: "-1.72453"
              }),
              /* @__PURE__ */ _jsx201("feGaussianBlur", {
                stdDeviation: "2"
              }),
              /* @__PURE__ */ _jsx201("feComposite", {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1"
              }),
              /* @__PURE__ */ _jsx201("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0.0971007 0 0 0 0 0.130012 0 0 0 0 0.195833 0 0 0 0.5 0"
              }),
              /* @__PURE__ */ _jsx201("feBlend", {
                mode: "normal",
                in2: "shape",
                result: "effect1_innerShadow_1109_34192"
              })
            ]
          }),
          /* @__PURE__ */ _jsxs91("linearGradient", {
            id: "paint0_linear_1109_34192",
            x1: "53.0675",
            y1: "42.5183",
            x2: "40.4999",
            y2: "34.5003",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ _jsx201("stop", {
                stopColor: "#B3CBE1"
              }),
              /* @__PURE__ */ _jsx201("stop", {
                offset: "1",
                stopColor: "white",
                stopOpacity: "0"
              })
            ]
          })
        ]
      })
    ]
  });
};
var EmptySearchList_default = /* @__PURE__ */ React105.memo(EmptySearchList);

// src/shared/ui/images/shared/EmptySelectedUsers.tsx
import { jsx as _jsx202, jsxs as _jsxs92 } from "react/jsx-runtime";
import React106 from "react";
function _object_without_properties149(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose149(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose149(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EmptySelectedUsers = (_param) => {
  var { width: width2 = 96, height: height2 = 96 } = _param, props = _object_without_properties149(_param, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ _jsxs92("svg", {
    width: width2,
    height: height2,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _jsx202("path", {
        d: "M23.0795 21.9685C25.5226 16.1698 31.4042 13.5723 37.4242 13.5728C43.4442 13.5723 49.3258 16.1698 51.7688 21.9685C54.7278 28.9926 53.4326 42.7922 47.1709 48.1937C44.3953 50.5874 44.1255 51.8334 44.5874 55.4091C44.9958 58.576 47.9617 59.9132 55.6507 62.9424C63.478 66.026 66.1716 69.1969 67.616 76.8092C67.8779 78.1897 66.7893 79.4367 65.3842 79.4367H9.46418C8.05908 79.4367 6.97047 78.1897 7.23239 76.8092C8.67673 69.1969 11.3703 66.026 19.1977 62.9424C26.8867 59.9132 29.8525 58.576 30.2609 55.4091C30.7229 51.8334 30.4531 50.5874 27.6775 48.1937C21.4158 42.7922 20.1205 28.9926 23.0795 21.9685Z",
        fill: "#373B45"
      }),
      /* @__PURE__ */ _jsx202("path", {
        d: "M40.7923 21.5492C43.4658 15.2418 49.9023 12.4165 56.4902 12.417C63.0782 12.4165 69.5146 15.2418 72.1881 21.5492C75.4263 29.1895 74.0089 44.1995 67.1564 50.0748C64.119 52.6785 63.8237 54.0338 64.3292 57.9232C64.7762 61.3679 68.0218 62.8224 76.4362 66.1173C85.0799 69.502 88.0029 72.9833 89.5731 81.4278C89.8301 82.81 88.7426 84.0585 87.3367 84.0585H25.6437C24.2378 84.0585 23.1503 82.81 23.4073 81.4278C24.9775 72.9833 27.9005 69.502 36.5442 66.1173C44.9586 62.8224 48.2043 61.3679 48.6512 57.9232C49.1567 54.0338 48.8614 52.6785 45.824 50.0748C38.9716 44.1995 37.5541 29.1895 40.7923 21.5492Z",
        fill: "#6F7687"
      }),
      /* @__PURE__ */ _jsx202("g", {
        filter: "url(#filter0_i_1337_10494)",
        children: /* @__PURE__ */ _jsx202("path", {
          d: "M54.3183 70.471L51.4101 65.3328C50.9366 64.4962 51.4645 63.4583 52.4238 63.3952C54.8771 63.2339 58.0804 63.202 60.6053 63.3769C61.5519 63.4425 62.0604 64.4667 61.5931 65.2925L58.662 70.471C58.4621 70.8243 58.4316 71.2488 58.579 71.627L63.4232 84.0584H49.5571L54.4014 71.627C54.5488 71.2488 54.5183 70.8243 54.3183 70.471Z",
          fill: "#4D566D",
          fillOpacity: "0.7"
        })
      }),
      /* @__PURE__ */ _jsx202("defs", {
        children: /* @__PURE__ */ _jsxs92("filter", {
          id: "filter0_i_1337_10494",
          x: "47.8326",
          y: "63.2593",
          width: "15.5907",
          height: "20.7993",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ _jsx202("feFlood", {
              floodOpacity: "0",
              result: "BackgroundImageFix"
            }),
            /* @__PURE__ */ _jsx202("feBlend", {
              mode: "normal",
              in: "SourceGraphic",
              in2: "BackgroundImageFix",
              result: "shape"
            }),
            /* @__PURE__ */ _jsx202("feColorMatrix", {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }),
            /* @__PURE__ */ _jsx202("feOffset", {
              dx: "-1.72453"
            }),
            /* @__PURE__ */ _jsx202("feGaussianBlur", {
              stdDeviation: "2"
            }),
            /* @__PURE__ */ _jsx202("feComposite", {
              in2: "hardAlpha",
              operator: "arithmetic",
              k2: "-1",
              k3: "1"
            }),
            /* @__PURE__ */ _jsx202("feColorMatrix", {
              type: "matrix",
              values: "0 0 0 0 0.0971007 0 0 0 0 0.130012 0 0 0 0 0.195833 0 0 0 0.5 0"
            }),
            /* @__PURE__ */ _jsx202("feBlend", {
              mode: "normal",
              in2: "shape",
              result: "effect1_innerShadow_1337_10494"
            })
          ]
        })
      })
    ]
  });
};
var EmptySelectedUsers_default = /* @__PURE__ */ React106.memo(EmptySelectedUsers);

// src/shared/ui/user-agreement/index.tsx
import { jsx as _jsx203, jsxs as _jsxs93 } from "react/jsx-runtime";
import { Typography as Typography5 } from "@mui/material";
var UserAgreement = ({ linkComponent: LinkComponent2 }) => /* @__PURE__ */ _jsxs93(Typography5, {
  variant: "caption",
  children: [
    Translate_default.get("components.agreement.1"),
    /* @__PURE__ */ _jsx203("br", {}),
    /* @__PURE__ */ _jsx203(link_default, {
      id: "agreement-link",
      to: "/agreement",
      target: "_blank",
      rel: "noreferrer",
      component: LinkComponent2,
      children: Translate_default.get("links.userAgreement.2")
    }),
    Translate_default.get("components.agreement.2"),
    /* @__PURE__ */ _jsx203("br", {}),
    Translate_default.get("components.agreement.3"),
    /* @__PURE__ */ _jsx203(link_default, {
      id: "policy-link",
      to: "/policy",
      target: "_blank",
      rel: "noreferrer",
      component: LinkComponent2,
      children: Translate_default.get("links.privacyPolicy")
    })
  ]
});
var user_agreement_default = UserAgreement;

// src/shared/ui/download-app-link/index.tsx
import { jsx as _jsx204, jsxs as _jsxs94, Fragment as _Fragment5 } from "react/jsx-runtime";
import { useMediaQuery as useMediaQuery2 } from "@mui/material";
var DownloadAppLink = ({ linkComponent: LinkComponent2, to, callback }) => {
  const isMobile = useMediaQuery2(`(max-width: ${breakpoints_default.md}px)`);
  return /* @__PURE__ */ _jsx204(typography_default, {
    variant: "body1",
    color: "text.secondary",
    children: isMobile ? /* @__PURE__ */ _jsx204(link_default, {
      color: "primary",
      href: to,
      component: LinkComponent2,
      onClick: callback,
      children: Translate_default.get("links.downloadAppMobile")
    }) : /* @__PURE__ */ _jsxs94(_Fragment5, {
      children: [
        /* @__PURE__ */ _jsx204("span", {
          children: Translate_default.get("misc.alsoYouCan")
        }),
        /* @__PURE__ */ _jsx204(link_default, {
          color: "primary",
          href: to,
          component: LinkComponent2,
          onClick: callback,
          children: Translate_default.get("links.downloadApp")
        })
      ]
    })
  });
};
var download_app_link_default = DownloadAppLink;

// src/shared/ui/popper/index.tsx
import { jsx as _jsx205, jsxs as _jsxs95 } from "react/jsx-runtime";
import { Fade as Fade2 } from "@mui/material";

// src/shared/ui/popper/shared/ui.tsx
import { Popper, Stack as Stack4 } from "@mui/material";
import styled35 from "styled-components";
var StyledPopper = styled35(Popper)`
  ${({ placement }) => {
  switch (placement) {
    case "right-start":
      return `padding-left: 7px`;
    default:
      return `padding-top: 14px;`;
  }
}}
`;
var MainContainer = styled35.div`
  position: relative;
  ${({ placement }) => {
  switch (placement) {
    case "right-start":
      return `padding-left: 14px`;
    default:
      return ``;
  }
}}
`;
var Corner = styled35.div`
  position: absolute;
  width: 14px;
  height: 14px;
  transform: rotate(45deg) translate(50%, -7px);
  z-index:-1;
  ${({ placement }) => {
  switch (placement) {
    case "bottom-start":
      return `left: 2%; top: -7px; background: #1256ee;`;
    case "bottom-end":
      return `right: 9%; top: -7px; background: #552baf;`;
    case "right-start":
      return `
      transform: rotate(45deg) translate(100%, 50%);
      left: 2px; top: 7px; background: #1256ee;`;
    default:
      return `right: 50%; top: -7px; background: #4B32B9`;
  }
}}
`;
var IconButtonWrapper2 = styled35.div`
  position: absolute;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
var StorySubstrate2 = styled35.div`
  display: flex;
  justify-content: center;
`;
var StyledStack = styled35(Stack4)`
  background: linear-gradient(70.54deg, #0062ff -8.09%, #552baf 72.38%);
  border-radius: 4px;
  padding: 16px 28px 16px 16px;
  width: 340px;
`;

// src/shared/ui/popper/index.tsx
function _define_property174(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread174(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property174(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys156(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props156(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys156(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties150(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose150(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose150(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Popper2 = (_param) => {
  var { id, open, anchorEl, placement = "bottom", transitionProps, title, subtitle, onClose, children } = _param, rest = _object_without_properties150(_param, [
    "id",
    "open",
    "anchorEl",
    "placement",
    "transitionProps",
    "title",
    "subtitle",
    "onClose",
    "children"
  ]);
  const PopperBody = /* @__PURE__ */ _jsxs95(MainContainer, {
    placement,
    children: [
      /* @__PURE__ */ _jsx205(Corner, {
        placement
      }),
      /* @__PURE__ */ _jsx205(IconButtonWrapper2, {
        onClick: onClose,
        children: /* @__PURE__ */ _jsx205(Plus_default, {
          width: "14px",
          height: "14px"
        })
      }),
      /* @__PURE__ */ _jsxs95(StyledStack, {
        rowGap: 1.5,
        children: [
          title && /* @__PURE__ */ _jsx205(typography_default, {
            variant: "h6",
            children: title
          }),
          subtitle && /* @__PURE__ */ _jsx205(typography_default, {
            variant: "body1",
            children: subtitle
          }),
          children
        ]
      })
    ]
  });
  return /* @__PURE__ */ _jsx205(StyledPopper, _object_spread_props156(_object_spread174({
    id,
    open,
    anchorEl,
    placement,
    transition: Boolean(transitionProps)
  }, rest), {
    children: transitionProps ? ({ TransitionProps }) => {
      var _transitionProps_in;
      return /* @__PURE__ */ _jsx205(Fade2, _object_spread_props156(_object_spread174({}, TransitionProps), {
        timeout: transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.timeout,
        in: (_transitionProps_in = transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.in) !== null && _transitionProps_in !== void 0 ? _transitionProps_in : open,
        children: PopperBody
      }));
    } : PopperBody
  }));
};
var popper_default = Popper2;

// src/shared/ui/drawer/index.tsx
import { jsx as _jsx206, jsxs as _jsxs96 } from "react/jsx-runtime";

// src/shared/ui/drawer/shared/ui.tsx
import styled36 from "styled-components";
import { Drawer as MuiDrawer } from "@mui/material";
var StyledDrawer = styled36(MuiDrawer)`
  position: relative;
  .MuiDrawer-paper {
    border-radius: 18px;
  }
`;
var DrawerContainer = styled36.div`
`;

// src/shared/ui/drawer/index.tsx
function _define_property175(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread175(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property175(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys157(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props157(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys157(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Drawer = (props) => {
  const { children, styles, onClose: _onClose } = props;
  const onClose = (event) => {
    if (typeof _onClose === "function") {
      _onClose(event, "escapeKeyDown");
    }
  };
  return /* @__PURE__ */ _jsxs96(StyledDrawer, _object_spread_props157(_object_spread175({}, props), {
    children: [
      /* @__PURE__ */ _jsx206("button", {
        onClick: onClose,
        className: "absolute",
        style: {
          top: "24px",
          right: "24px",
          zIndex: 1e3
        },
        children: /* @__PURE__ */ _jsx206(IconArea, {
          style: {
            maxHeight: "24px",
            maxWidth: "24px"
          },
          children: /* @__PURE__ */ _jsx206(Cross_default, {
            height: "24px",
            width: "24px"
          })
        })
      }),
      /* @__PURE__ */ _jsx206(DrawerContainer, {
        style: styles,
        children
      })
    ]
  }));
};
Drawer.displayName = "Drawer";
var drawer_default = Drawer;

// src/shared/ui/button-switch/index.ts
import { styled as styledMui2 } from "@mui/material";
import Switch, { switchClasses } from "@mui/material/Switch";
var ButtonSwitch = styledMui2(Switch)(({ theme }) => ({
  borderRadius: "20px",
  width: 38,
  height: 21,
  padding: 0,
  display: "flex",
  "&:active": {
    [`& .${switchClasses.thumb}`]: {
      width: 17
    },
    [`& .${switchClasses.switchBase}.${switchClasses.checked}`]: {
      transform: "translateX(17px)"
    }
  },
  "&:hover": {
    [`& .${switchClasses.switchBase}`]: {
      [`& + .${switchClasses.track}`]: {
        backgroundColor: getCssVar("grey", 700)
      },
      [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
        backgroundColor: getCssVar("blue", 700)
      }
    }
  },
  [`& .${switchClasses.switchBase}`]: {
    padding: 2,
    [`&.${switchClasses.checked}`]: {
      transform: "translateX(17px)",
      color: "#fff",
      [`& + .${switchClasses.track}`]: {
        opacity: 1,
        backgroundColor: getCssVar("blue", 500)
      }
    },
    [`&.${switchClasses.disabled}`]: {
      [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
        backgroundColor: getCssVar("grey", 900)
      },
      [`& .${switchClasses.thumb}`]: {
        backgroundColor: getCssVar("grey", 950)
      },
      [`& + .${switchClasses.track}`]: {
        backgroundColor: getCssVar("grey", 900),
        opacity: 1
      }
    }
  },
  [`& .${switchClasses.thumb}`]: {
    backgroundColor: getCssVar("grey", 100),
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 17,
    height: 17,
    borderRadius: "50%",
    transition: theme.transitions.create([
      "width"
    ], {
      duration: 200
    })
  },
  [`& .${switchClasses.track}`]: {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: getCssVar("grey", 500),
    boxSizing: "border-box"
  }
}));
var button_switch_default = ButtonSwitch;

// src/shared/ui/search-input/index.tsx
import { jsx as _jsx207, jsxs as _jsxs97 } from "react/jsx-runtime";
import { useState as useState16, useRef as useRef10, useEffect as useEffect19, useCallback as useCallback10 } from "react";

// src/shared/ui/search-input/shared/ui.ts
import styled37 from "styled-components";
var InputWrapper = styled37.div`
    position: relative;
`;
var SearchResultsContainer = styled37.div`
    position: absolute;
    margin-top: ${getSizeUnit(10)};
    border-radius: ${getSizeUnit(4)};
    background-color: ${getCssVar("grey", 900)};
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08), 0px 4px 16px 0px rgba(0, 0, 0, 0.40);
    width: 100%;
    z-index: 100;
    overflow: auto;
    padding: ${getSizeUnit(20)} ${getSizeUnit(10)} ${getSizeUnit(12)} ${getSizeUnit(16)};

    ${TINY_SCROLLBAR_STYLES};
    &:hover {
      &::-webkit-scrollbar-thumb {
        background: ${getCssVar("grey", 700)};
      }
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${getCssVar("grey", 500)};
    }
    scrollbar-gutter: stable;

    max-height: ${getSizeUnit(312)};
    height: ${(props) => props.empty ? getSizeUnit(312) : "auto"};
`;
var SearchResultsItem = styled37.div``;
var IconContainer = styled37.div`
    min-width: 24px;
    min-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
var EmptyContentContainer = styled37.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

// src/shared/ui/search-input/index.tsx
function _define_property176(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread176(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property176(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties151(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose151(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose151(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SearchInput = (_param) => {
  var { data = [], renderItem, onChange, onSelect, isDataLoading = false, placeholder = "", renderEmptyContent = () => /* @__PURE__ */ _jsx207("div", {
    children: "Не найдено"
  }) } = _param, props = _object_without_properties151(_param, [
    "data",
    "renderItem",
    "onChange",
    "onSelect",
    "isDataLoading",
    "placeholder",
    "renderEmptyContent"
  ]);
  const [searchValue, setSearchValue] = useState16("");
  const [focusedIndex, setFocusedIndex] = useState16(-1);
  const resultContainer = useRef10(null);
  const [showResults, setShowResults] = useState16(false);
  const emptySearchInput = useCallback10(() => {
    setSearchValue("");
  }, []);
  const handleUnfocus = useCallback10(() => {
    setFocusedIndex(-1);
    setShowResults(false);
  }, []);
  const handleFocus = useCallback10(() => {
    setShowResults(searchValue.trim().length > 0);
  }, [
    searchValue
  ]);
  const handleSelection = (selectedIndex) => {
    const selectedItem = data[selectedIndex];
    if (!selectedItem)
      return handleUnfocus();
    if (onSelect)
      onSelect(selectedItem);
    handleUnfocus();
    emptySearchInput();
  };
  const handleKeyDown = (event) => {
    const { key } = event;
    if (key === "ArrowDown") {
      event.preventDefault();
      const nextIndexCount = (focusedIndex + 1) % data.length;
      setFocusedIndex(nextIndexCount);
    }
    if (key === "ArrowUp") {
      event.preventDefault();
      const nextIndexCount = (focusedIndex + data.length - 1) % data.length;
      setFocusedIndex(nextIndexCount);
    }
    if (key === "Enter") {
      event.preventDefault();
      if (focusedIndex === -1)
        return;
      handleSelection(focusedIndex);
      emptySearchInput();
    }
  };
  useEffect19(() => {
    onChange(searchValue);
    setShowResults(searchValue.trim().length > 0);
  }, [
    searchValue
  ]);
  useEffect19(() => {
    if (!resultContainer.current)
      return;
    resultContainer.current.scrollIntoView({
      block: "center"
    });
  }, [
    focusedIndex
  ]);
  return /* @__PURE__ */ _jsx207("div", {
    children: /* @__PURE__ */ _jsxs97(InputWrapper, {
      tabIndex: 1,
      onKeyDown: handleKeyDown,
      children: [
        /* @__PURE__ */ _jsx207(textfield_default, _object_spread176({
          isFullWidth: true,
          isContrast: true,
          autoFocus: true,
          value: searchValue,
          placeholder,
          onChange: (e) => {
            var _e_target;
            return setSearchValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
          },
          onBlur: handleUnfocus,
          onFocus: handleFocus,
          InputProps: {
            startAdornment: /* @__PURE__ */ _jsx207(IconContainer, {
              style: {
                marginRight: getSizeUnit(4)
              },
              children: isDataLoading ? /* @__PURE__ */ _jsx207(spinner_default, {
                size: 24,
                fill: getCssVar("grey", 500)
              }) : /* @__PURE__ */ _jsx207(Plus_default, {
                fill: getCssVar("grey", 500)
              })
            }),
            endAdornment: searchValue ? /* @__PURE__ */ _jsx207("button", {
              onClick: emptySearchInput,
              children: /* @__PURE__ */ _jsx207(Cross_default, {
                height: getSizeUnit(23),
                width: getSizeUnit(23)
              })
            }) : null
          }
        }, props)),
        showResults && /* @__PURE__ */ _jsx207(SearchResultsContainer, {
          empty: data.length === 0,
          children: data.length > 0 ? data.map((item, index) => /* @__PURE__ */ _jsx207(SearchResultsItem, {
            ref: index === focusedIndex ? resultContainer : null,
            style: {
              backgroundColor: index === focusedIndex ? getCssVar("grey", 700) : ""
            },
            onMouseDown: () => handleSelection(index),
            children: renderItem(item)
          }, index)) : /* @__PURE__ */ _jsx207(EmptyContentContainer, {
            children: renderEmptyContent()
          })
        })
      ]
    })
  });
};
var search_input_default = SearchInput;

// src/shared/ui/text-field-copy/index.tsx
import { jsx as _jsx208, jsxs as _jsxs98 } from "react/jsx-runtime";

// src/shared/ui/text-field-copy/shared/ui.tsx
import styled38 from "styled-components";
var CopyField = styled38.div`
  background: #202124;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 7px 0 12px;
  .MuiTypography-root {
    font-size:${getCssVar("font", "large")};
  }
`;

// src/shared/ui/text-field-copy/index.tsx
var TextFieldCopy = ({ text, callback, className, children }) => {
  const onLinkCopy = () => {
    copy2Clipboard(text);
    callback();
  };
  return /* @__PURE__ */ _jsxs98(CopyField, {
    className,
    children: [
      children !== null && children !== void 0 ? children : /* @__PURE__ */ _jsx208(typography_default, {
        variant: "body2",
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        children: text
      }),
      /* @__PURE__ */ _jsx208(IconButton_default, {
        onClick: onLinkCopy,
        children: /* @__PURE__ */ _jsx208(Copy_default, {})
      })
    ]
  });
};
var text_field_copy_default = TextFieldCopy;

// src/shared/ui/incoming-call-modal/index.tsx
import { jsx as _jsx212, jsxs as _jsxs100 } from "react/jsx-runtime";
import { useCallback as useCallback11, useEffect as useEffect20, useMemo as useMemo11, useRef as useRef11, useState as useState17 } from "react";

// ../../node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
function formatMuiErrorMessage(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}

// ../../node_modules/@mui/system/node_modules/@mui/styled-engine/index.js
import emStyled from "@emotion/styled";
import { ThemeContext, keyframes, css } from "@emotion/react";
function styled39(tag, options) {
  const stylesFactory = emStyled(tag, options);
  if (process.env.NODE_ENV !== "production") {
    return (...styles) => {
      const component = typeof tag === "string" ? `"${tag}"` : "component";
      if (styles.length === 0) {
        console.error([
          `MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`,
          'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'
        ].join("\n"));
      } else if (styles.some((style4) => style4 === void 0)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}
var internal_processStyles = (tag, processor) => {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t)
        ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r2, e) {
  if (null == r2)
    return {};
  var t = {};
  for (var n in r2)
    if ({}.hasOwnProperty.call(r2, n)) {
      if (-1 !== e.indexOf(n))
        continue;
      t[n] = r2[n];
    }
  return t;
}

// ../../node_modules/@mui/utils/esm/deepmerge/deepmerge.js
import * as React107 from "react";
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (/* @__PURE__ */ React107.isValidElement(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (/* @__PURE__ */ React107.isValidElement(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

// ../../node_modules/@mui/system/esm/createTheme/createBreakpoints.js
var _excluded = [
  "values",
  "unit",
  "step"
];
var sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values2 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5
  } = breakpoints, other = _objectWithoutPropertiesLoose(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values2);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values2[start] === "number" ? values2[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys[endIndex]] === "number" ? values2[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

// ../../node_modules/@mui/system/esm/createTheme/shape.js
var shape = {
  borderRadius: 4
};
var shape_default = shape;

// ../../node_modules/@mui/system/esm/responsivePropType.js
var import_prop_types = __toESM(require_prop_types());
var responsivePropType = process.env.NODE_ENV !== "production" ? import_prop_types.default.oneOfType([
  import_prop_types.default.number,
  import_prop_types.default.string,
  import_prop_types.default.object,
  import_prop_types.default.array
]) : {};
var responsivePropType_default = responsivePropType;

// ../../node_modules/@mui/system/esm/merge.js
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
var merge_default = merge;

// ../../node_modules/@mui/system/esm/breakpoints.js
var values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
  ],
  up: (key) => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style4) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style4);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [
    emptyBreakpoints,
    ...styles
  ].reduce((prev, next) => deepmerge(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  if (typeof breakpointValues !== "object") {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach((breakpoint) => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === "object") {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}

// ../../node_modules/@mui/utils/esm/capitalize/capitalize.js
function capitalize(string9) {
  if (typeof string9 !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage(7));
  }
  return string9.charAt(0).toUpperCase() + string9.slice(1);
}

// ../../node_modules/@mui/system/esm/style.js
function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform3, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform3) {
    value = transform3(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const { prop, cssProperty = options.prop, themeKey, transform: transform3 } = options;
  const fn = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform3, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform3, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? {
    [prop]: responsivePropType_default
  } : {};
  fn.filterProps = [
    prop
  ];
  return fn;
}
var style_default = style;

// ../../node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return (arg) => {
    if (cache[arg] === void 0) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

// ../../node_modules/@mui/system/esm/spacing.js
var properties = {
  m: "margin",
  p: "padding"
};
var directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: [
    "Left",
    "Right"
  ],
  y: [
    "Top",
    "Bottom"
  ]
};
var aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
var getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [
        prop
      ];
    }
  }
  const [a, b] = prop.split("");
  const property = properties[a];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [
    property + direction
  ];
});
var marginKeys = [
  "m",
  "mt",
  "mr",
  "mb",
  "ml",
  "mx",
  "my",
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginX",
  "marginY",
  "marginInline",
  "marginInlineStart",
  "marginInlineEnd",
  "marginBlock",
  "marginBlockStart",
  "marginBlockEnd"
];
var paddingKeys = [
  "p",
  "pt",
  "pr",
  "pb",
  "pl",
  "px",
  "py",
  "padding",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "paddingX",
  "paddingY",
  "paddingInline",
  "paddingInlineStart",
  "paddingInlineEnd",
  "paddingBlock",
  "paddingBlockStart",
  "paddingBlockEnd"
];
var spacingKeys = [
  ...marginKeys,
  ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof abs !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs)) {
          console.error([
            `MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`
          ].join("\n"));
        } else if (abs > themeSpacing.length - 1) {
          console.error([
            `MUI: The value provided (${abs}) overflows.`,
            `The supported values are: ${JSON.stringify(themeSpacing)}.`,
            `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`
          ].join("\n"));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([
      `MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`,
      "It should be a number, an array or a function."
    ].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style2(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge_default, {});
}
function margin(props) {
  return style2(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType_default;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style2(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType_default;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
function spacing(props) {
  return style2(props, spacingKeys);
}
spacing.propTypes = process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType_default;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;

// ../../node_modules/@mui/system/esm/createTheme/createSpacing.js
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform3 = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing2 = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [
      1
    ] : argsInput;
    return args.map((argument) => {
      const output = transform3(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing2.mui = true;
  return spacing2;
}

// ../../node_modules/@mui/system/esm/compose.js
function compose(...styles) {
  const handlers = styles.reduce((acc, style4) => {
    style4.filterProps.forEach((prop) => {
      acc[prop] = style4;
    });
    return acc;
  }, {});
  const fn = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge_default(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? styles.reduce((acc, style4) => Object.assign(acc, style4.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style4) => acc.concat(style4.filterProps), []);
  return fn;
}
var compose_default = compose;

// ../../node_modules/@mui/system/esm/borders.js
function borderTransform(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform3) {
  return style_default({
    prop,
    themeKey: "borders",
    transform: transform3
  });
}
var border = createBorderStyle("border", borderTransform);
var borderTop = createBorderStyle("borderTop", borderTransform);
var borderRight = createBorderStyle("borderRight", borderTransform);
var borderBottom = createBorderStyle("borderBottom", borderTransform);
var borderLeft = createBorderStyle("borderLeft", borderTransform);
var borderColor = createBorderStyle("borderColor");
var borderTopColor = createBorderStyle("borderTopColor");
var borderRightColor = createBorderStyle("borderRightColor");
var borderBottomColor = createBorderStyle("borderBottomColor");
var borderLeftColor = createBorderStyle("borderLeftColor");
var outline = createBorderStyle("outline", borderTransform);
var outlineColor = createBorderStyle("outlineColor");
var borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4, "borderRadius");
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType_default
} : {};
borderRadius.filterProps = [
  "borderRadius"
];
var borders = compose_default(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);

// ../../node_modules/@mui/system/esm/cssGrid.js
var gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "gap");
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType_default
} : {};
gap.filterProps = [
  "gap"
];
var columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "columnGap");
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType_default
} : {};
columnGap.filterProps = [
  "columnGap"
];
var rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "rowGap");
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType_default
} : {};
rowGap.filterProps = [
  "rowGap"
];
var gridColumn = style_default({
  prop: "gridColumn"
});
var gridRow = style_default({
  prop: "gridRow"
});
var gridAutoFlow = style_default({
  prop: "gridAutoFlow"
});
var gridAutoColumns = style_default({
  prop: "gridAutoColumns"
});
var gridAutoRows = style_default({
  prop: "gridAutoRows"
});
var gridTemplateColumns = style_default({
  prop: "gridTemplateColumns"
});
var gridTemplateRows = style_default({
  prop: "gridTemplateRows"
});
var gridTemplateAreas = style_default({
  prop: "gridTemplateAreas"
});
var gridArea = style_default({
  prop: "gridArea"
});
var grid = compose_default(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

// ../../node_modules/@mui/system/esm/palette.js
function paletteTransform(value, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value;
}
var color = style_default({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
var bgcolor = style_default({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
var backgroundColor = style_default({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
var palette = compose_default(color, bgcolor, backgroundColor);

// ../../node_modules/@mui/system/esm/sizing.js
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
var width = style_default({
  prop: "width",
  transform: sizingTransform
});
var maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = [
  "maxWidth"
];
var minWidth = style_default({
  prop: "minWidth",
  transform: sizingTransform
});
var height = style_default({
  prop: "height",
  transform: sizingTransform
});
var maxHeight = style_default({
  prop: "maxHeight",
  transform: sizingTransform
});
var minHeight = style_default({
  prop: "minHeight",
  transform: sizingTransform
});
var sizeWidth = style_default({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
var sizeHeight = style_default({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
var boxSizing = style_default({
  prop: "boxSizing"
});
var sizing = compose_default(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

// ../../node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js
var defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value) => ({
      "@media print": {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
var defaultSxConfig_default = defaultSxConfig;

// ../../node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object9) => keys.concat(Object.keys(object9)), []);
  const union = new Set(allKeys);
  return objects.every((object9) => union.size === Object.keys(object9).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const { cssProperty = prop, themeKey, transform: transform3, style: style4 } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style4) {
      return style4(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform3, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform3, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    var _theme$unstable_sxCon;
    const { sx, theme = {} } = props || {};
    if (!sx) {
      return null;
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig_default;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css3 = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (config[styleKey]) {
              css3 = merge_default(css3, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css3[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme
                });
              } else {
                css3 = merge_default(css3, breakpointsValues);
              }
            }
          } else {
            css3 = merge_default(css3, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css3);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
var styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
  "sx"
];
var styleFunctionSx_default = styleFunctionSx;

// ../../node_modules/@mui/system/esm/createTheme/applyStyles.js
function applyStyles(key, styles) {
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

// ../../node_modules/@mui/system/esm/createTheme/createTheme.js
var _excluded2 = [
  "breakpoints",
  "palette",
  "spacing",
  "shape"
];
function createTheme3(options = {}, ...args) {
  const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = _objectWithoutPropertiesLoose(options, _excluded2);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing2 = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends({
      mode: "light"
    }, paletteInput),
    spacing: spacing2,
    shape: _extends({}, shape_default, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends({}, defaultSxConfig_default, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx_default({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
var createTheme_default = createTheme3;

// ../../node_modules/@mui/system/esm/useThemeWithoutDefault.js
import * as React108 from "react";
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme2 = null) {
  const contextTheme = React108.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme2 : contextTheme;
}
var useThemeWithoutDefault_default = useTheme;

// ../../node_modules/@mui/system/esm/useTheme.js
var systemDefaultTheme = createTheme_default();
function useTheme2(defaultTheme2 = systemDefaultTheme) {
  return useThemeWithoutDefault_default(defaultTheme2);
}
var useTheme_default = useTheme2;

// ../../node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var _excluded3 = [
  "sx"
];
var splitProps = (props) => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : defaultSxConfig_default;
  Object.keys(props).forEach((prop) => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const { sx: inSx } = props, other = _objectWithoutPropertiesLoose(props, _excluded3);
  const { systemProps, otherProps } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [
      systemProps,
      ...inSx
    ];
  } else if (typeof inSx === "function") {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject(result)) {
        return systemProps;
      }
      return _extends({}, systemProps, result);
    };
  } else {
    finalSx = _extends({}, systemProps, inSx);
  }
  return _extends({}, otherProps, {
    sx: finalSx
  });
}

// ../../node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var defaultGenerator = (componentName) => componentName;
var createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
var ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator_default = ClassNameGenerator;

// ../../node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    } else
      for (f in e)
        e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++)
    (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_default = clsx;

// ../../node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator_default.generate(componentName)}-${slot}`;
}

// ../../node_modules/@mui/utils/esm/getDisplayName/getDisplayName.js
var import_react_is = __toESM(require_react_is2());
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || "";
}
function getFunctionComponentName(Component, fallback = "") {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component) {
  if (Component == null) {
    return void 0;
  }
  if (typeof Component === "string") {
    return Component;
  }
  if (typeof Component === "function") {
    return getFunctionComponentName(Component, "Component");
  }
  if (typeof Component === "object") {
    switch (Component.$$typeof) {
      case import_react_is.ForwardRef:
        return getWrappedName(Component, Component.render, "ForwardRef");
      case import_react_is.Memo:
        return getWrappedName(Component, Component.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}

// ../../node_modules/@mui/system/esm/createStyled.js
var _excluded4 = [
  "ownerState"
];
var _excluded22 = [
  "variants"
];
var _excluded32 = [
  "name",
  "slot",
  "skipVariantsResolver",
  "skipSx",
  "overridesResolver"
];
function isEmpty2(obj) {
  return Object.keys(obj).length === 0;
}
function isStringTag(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var systemDefaultTheme2 = createTheme_default();
var lowercaseFirstLetter = (string9) => {
  if (!string9) {
    return string9;
  }
  return string9.charAt(0).toLowerCase() + string9.slice(1);
};
function resolveTheme({ defaultTheme: defaultTheme2, theme, themeId }) {
  return isEmpty2(theme) ? defaultTheme2 : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg(callableStyle, _ref) {
  let { ownerState } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded4);
  const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle(_extends({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap((resolvedStyle) => processStyleArg(resolvedStyle, _extends({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
    const { variants = [] } = resolvedStylesArg, otherStyles = _objectWithoutPropertiesLoose(resolvedStylesArg, _excluded22);
    let result = otherStyles;
    variants.forEach((variant) => {
      let isMatch = true;
      if (typeof variant.props === "function") {
        isMatch = variant.props(_extends({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach((key) => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [
            result
          ];
        }
        result.push(typeof variant.style === "function" ? variant.style(_extends({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled(input = {}) {
  const { themeId, defaultTheme: defaultTheme2 = systemDefaultTheme2, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
  const systemSx = (props) => {
    return styleFunctionSx_default(_extends({}, props, {
      theme: resolveTheme(_extends({}, props, {
        defaultTheme: defaultTheme2,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    internal_processStyles(tag, (styles) => styles.filter((style4) => !(style4 != null && style4.__mui_systemSx)));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
    } = inputOptions, options = _objectWithoutPropertiesLoose(inputOptions, _excluded32);
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false
    );
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== "production") {
      if (componentName) {
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || "Root")}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root" || componentSlot === "root") {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      shouldForwardPropOption = void 0;
    }
    const defaultStyledResolver = styled39(tag, _extends({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = (stylesArg) => {
      if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || isPlainObject(stylesArg)) {
        return (props) => processStyleArg(stylesArg, _extends({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme: defaultTheme2,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = resolveTheme(_extends({}, props, {
            defaultTheme: defaultTheme2,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, _extends({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push((props) => {
          var _theme$components;
          const theme = resolveTheme(_extends({}, props, {
            defaultTheme: defaultTheme2,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, _extends({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill("");
        transformedStyleArg = [
          ...styleArg,
          ...placeholders
        ];
        transformedStyleArg.raw = [
          ...styleArg.raw,
          ...placeholders
        ];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== "production") {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${capitalize(componentSlot || "")}`;
        }
        if (displayName === void 0) {
          displayName = `Styled(${getDisplayName(tag)})`;
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

// ../../node_modules/@mui/system/esm/styled.js
var styled40 = createStyled();
var styled_default = styled40;

// ../../node_modules/@mui/utils/esm/resolveProps/resolveProps.js
function resolveProps(defaultProps, props) {
  const output = _extends({}, props);
  Object.keys(defaultProps).forEach((propName) => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        output[propName] = slotProps;
      } else {
        output[propName] = _extends({}, slotProps);
        Object.keys(defaultSlotProps).forEach((slotPropName) => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === void 0) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

// ../../node_modules/@mui/system/esm/useThemeProps/getThemeProps.js
function getThemeProps(params) {
  const { theme, name, props } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

// ../../node_modules/@mui/system/esm/useThemeProps/useThemeProps.js
function useThemeProps({ props, name, defaultTheme: defaultTheme2, themeId }) {
  let theme = useTheme_default(defaultTheme2);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

// ../../node_modules/@mui/utils/esm/composeClasses/composeClasses.js
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  Object.keys(slots).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot) => {
      output[slot] = slots[slot].reduce((acc, key) => {
        if (key) {
          const utilityClass = getUtilityClass(key);
          if (utilityClass !== "") {
            acc.push(utilityClass);
          }
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }
        }
        return acc;
      }, []).join(" ");
    }
  );
  return output;
}

// ../../node_modules/@mui/system/esm/Stack/Stack.js
var import_prop_types3 = __toESM(require_prop_types());

// ../../node_modules/@mui/system/esm/Stack/createStack.js
var import_prop_types2 = __toESM(require_prop_types());
import * as React109 from "react";
import { jsx as _jsx209 } from "react/jsx-runtime";
var _excluded5 = [
  "component",
  "direction",
  "spacing",
  "divider",
  "children",
  "className",
  "useFlexGap"
];
var defaultTheme = createTheme_default();
var defaultCreateStyledComponent = styled_default("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
});
function useThemePropsDefault(props) {
  return useThemeProps({
    props,
    name: "MuiStack",
    defaultTheme
  });
}
function joinChildren(children, separator) {
  const childrenArray = React109.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push(/* @__PURE__ */ React109.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }
    return output;
  }, []);
}
var getSideFromDirection = (direction) => {
  return {
    row: "Left",
    "row-reverse": "Right",
    column: "Top",
    "column-reverse": "Bottom"
  }[direction];
};
var style3 = ({ ownerState, theme }) => {
  let styles = _extends({
    display: "flex",
    flexDirection: "column"
  }, handleBreakpoints({
    theme
  }, resolveBreakpointValues({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), (propValue) => ({
    flexDirection: propValue
  })));
  if (ownerState.spacing) {
    const transformer = createUnarySpacing(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    const directionValues = resolveBreakpointValues({
      values: ownerState.direction,
      base
    });
    const spacingValues = resolveBreakpointValues({
      values: ownerState.spacing,
      base
    });
    if (typeof directionValues === "object") {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];
        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    const styleFromPropValue = (propValue, breakpoint) => {
      if (ownerState.useFlexGap) {
        return {
          gap: getValue(transformer, propValue)
        };
      }
      return {
        // The useFlexGap={false} implement relies on each child to give up control of the margin.
        // We need to reset the margin to avoid double spacing.
        "& > :not(style):not(style)": {
          margin: 0
        },
        "& > :not(style) ~ :not(style)": {
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: getValue(transformer, propValue)
        }
      };
    };
    styles = deepmerge(styles, handleBreakpoints({
      theme
    }, spacingValues, styleFromPropValue));
  }
  styles = mergeBreakpointsInOrder(theme.breakpoints, styles);
  return styles;
};
function createStack(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps: useThemeProps2 = useThemePropsDefault,
    componentName = "MuiStack"
  } = options;
  const useUtilityClasses = () => {
    const slots = {
      root: [
        "root"
      ]
    };
    return composeClasses(slots, (slot) => generateUtilityClass(componentName, slot), {});
  };
  const StackRoot = createStyledComponent(style3);
  const Stack18 = /* @__PURE__ */ React109.forwardRef(function Grid4(inProps, ref3) {
    const themeProps = useThemeProps2(inProps);
    const props = extendSxProp(themeProps);
    const { component = "div", direction = "column", spacing: spacing2 = 0, divider, children, className, useFlexGap = false } = props, other = _objectWithoutPropertiesLoose(props, _excluded5);
    const ownerState = {
      direction,
      spacing: spacing2,
      useFlexGap
    };
    const classes = useUtilityClasses();
    return /* @__PURE__ */ _jsx209(StackRoot, _extends({
      as: component,
      ownerState,
      ref: ref3,
      className: clsx_default(classes.root, className)
    }, other, {
      children: divider ? joinChildren(children, divider) : children
    }));
  });
  process.env.NODE_ENV !== "production" ? Stack18.propTypes = {
    children: import_prop_types2.default.node,
    direction: import_prop_types2.default.oneOfType([
      import_prop_types2.default.oneOf([
        "column-reverse",
        "column",
        "row-reverse",
        "row"
      ]),
      import_prop_types2.default.arrayOf(import_prop_types2.default.oneOf([
        "column-reverse",
        "column",
        "row-reverse",
        "row"
      ])),
      import_prop_types2.default.object
    ]),
    divider: import_prop_types2.default.node,
    spacing: import_prop_types2.default.oneOfType([
      import_prop_types2.default.arrayOf(import_prop_types2.default.oneOfType([
        import_prop_types2.default.number,
        import_prop_types2.default.string
      ])),
      import_prop_types2.default.number,
      import_prop_types2.default.object,
      import_prop_types2.default.string
    ]),
    sx: import_prop_types2.default.oneOfType([
      import_prop_types2.default.arrayOf(import_prop_types2.default.oneOfType([
        import_prop_types2.default.func,
        import_prop_types2.default.object,
        import_prop_types2.default.bool
      ])),
      import_prop_types2.default.func,
      import_prop_types2.default.object
    ])
  } : void 0;
  return Stack18;
}

// ../../node_modules/@mui/system/esm/Stack/Stack.js
var Stack5 = createStack();
process.env.NODE_ENV !== "production" ? Stack5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
  * The content of the component.
  */
  children: import_prop_types3.default.node,
  /**
  * The component used for the root node.
  * Either a string to use a HTML element or a component.
  */
  component: import_prop_types3.default.elementType,
  /**
  * Defines the `flex-direction` style property.
  * It is applied for all screen sizes.
  * @default 'column'
  */
  direction: import_prop_types3.default.oneOfType([
    import_prop_types3.default.oneOf([
      "column-reverse",
      "column",
      "row-reverse",
      "row"
    ]),
    import_prop_types3.default.arrayOf(import_prop_types3.default.oneOf([
      "column-reverse",
      "column",
      "row-reverse",
      "row"
    ])),
    import_prop_types3.default.object
  ]),
  /**
  * Add an element between each child.
  */
  divider: import_prop_types3.default.node,
  /**
  * Defines the space between immediate children.
  * @default 0
  */
  spacing: import_prop_types3.default.oneOfType([
    import_prop_types3.default.arrayOf(import_prop_types3.default.oneOfType([
      import_prop_types3.default.number,
      import_prop_types3.default.string
    ])),
    import_prop_types3.default.number,
    import_prop_types3.default.object,
    import_prop_types3.default.string
  ]),
  /**
  * The system prop, which allows defining system overrides as well as additional CSS styles.
  */
  sx: import_prop_types3.default.oneOfType([
    import_prop_types3.default.arrayOf(import_prop_types3.default.oneOfType([
      import_prop_types3.default.func,
      import_prop_types3.default.object,
      import_prop_types3.default.bool
    ])),
    import_prop_types3.default.func,
    import_prop_types3.default.object
  ]),
  /**
  * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
  *
  * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
  * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
  *
  * To enable this flag globally, follow the theme's default props configuration.
  * @default false
  */
  useFlexGap: import_prop_types3.default.bool
} : void 0;
var Stack_default = Stack5;

// src/shared/ui/incoming-call-modal/index.tsx
import { uuid } from "uuidv4";

// src/shared/ui/incoming-call-modal/icon/phoneOff.tsx
import { jsx as _jsx210 } from "react/jsx-runtime";
function _define_property177(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread177(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property177(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys158(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props158(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys158(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PhoneOffIcon = (props) => /* @__PURE__ */ _jsx210("svg", _object_spread_props158(_object_spread177({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}, props), {
  children: /* @__PURE__ */ _jsx210("path", {
    d: "M24.7284 21.8141C25.7231 22.5355 27.1464 22.4804 27.9278 21.532L30.8797 17.9493C31.58 17.0993 31.5022 15.8417 30.6359 15.1617C22.2403 8.57131 10.3566 8.57109 1.96071 15.1611C1.0944 15.8411 1.01657 17.0987 1.71687 17.9487L4.66878 21.5314C5.45015 22.4798 6.87331 22.5349 7.86809 21.8136C8.61295 21.2735 9.39726 20.8141 10.2094 20.435C11.1374 20.0017 11.7467 19.0398 11.5882 18.028L11.2664 15.9732C14.9193 14.794 17.8045 14.794 21.4574 15.9732L21.0758 17.9794C20.8796 19.0108 21.4908 20.0122 22.4403 20.4603C23.2335 20.8346 23.9998 21.2857 24.7284 21.8141Z",
    fill: "currentColor"
  })
}));
var phoneOff_default = PhoneOffIcon;

// src/shared/ui/incoming-call-modal/icon/phoneOn.tsx
import { jsx as _jsx211, jsxs as _jsxs99 } from "react/jsx-runtime";
function _define_property178(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread178(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property178(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys159(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props159(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys159(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PhoneOnIcon = (props) => /* @__PURE__ */ _jsxs99("svg", _object_spread_props159(_object_spread178({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "currentColor"
}, props), {
  children: [
    /* @__PURE__ */ _jsx211("path", {
      d: "M13.3313 7.08747C12.9483 5.35868 11.4489 3.95715 9.68634 4.1273L6.50769 4.43416C4.92816 4.58664 3.72055 5.94925 3.96006 7.51795C5.56166 18.0079 13.8511 26.2976 24.3408 27.8997C25.9096 28.1393 27.2723 26.9316 27.4247 25.3521L27.7316 22.1733C27.9017 20.4109 26.5003 18.9115 24.7717 18.5284C24.3618 18.4376 23.9584 18.3301 23.5622 18.2067C22.1531 17.768 20.5523 18.1176 19.6828 19.31L18.8104 20.5064C15.2297 18.6733 13.0917 16.5353 11.2587 12.9546L12.4309 12.1571C13.6817 11.306 14.0694 9.66286 13.6279 8.21575C13.515 7.8456 13.4159 7.46932 13.3313 7.08747Z"
    }),
    /* @__PURE__ */ _jsx211("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.1027 14.8328C25.7161 14.8328 25.4058 14.5183 25.3734 14.1331C25.0377 10.1428 21.857 6.96211 17.8667 6.62639C17.4815 6.59398 17.167 6.28369 17.167 5.89709V4.79709C17.167 4.41049 17.4813 4.09472 17.8671 4.11955C23.2385 4.46533 27.5345 8.76128 27.8802 14.1327C27.9051 14.5185 27.5893 14.8328 27.2027 14.8328H26.1027Z"
    }),
    /* @__PURE__ */ _jsx211("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.6545 14.8328C20.2679 14.8328 19.9635 14.5145 19.8677 14.14C19.6164 13.1571 18.8426 12.3834 17.8598 12.132C17.4853 12.0363 17.167 11.7319 17.167 11.3453V10.2453C17.167 9.85867 17.4821 9.5404 17.8654 9.59098C20.227 9.90259 22.0972 11.7728 22.4088 14.1344C22.4594 14.5177 22.1411 14.8328 21.7545 14.8328H20.6545Z"
    })
  ]
}));
var phoneOn_default = PhoneOnIcon;

// src/shared/ui/incoming-call-modal/shared/ui.ts
import styled41 from "styled-components";
var Wrapper = styled41(box_default)`
  background-color: ${getCssVar("grey", 950)};
  width: 320px;
  border-radius: 8px;
  padding: 40px 18px;
  position: fixed;
  right: 24px;
  z-index: 2;
  bottom: ${({ bottom }) => typeof bottom === "number" ? bottom : 32}px;
`;
var StyledButtonIconStroke = styled41(button_icon_stroke_default)`
  background-color: ${getCssVar("red", 500)};
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${getCssVar("white", 100)};

  &:hover,
  &:focus {
    background-color: ${getCssVar("red", 600)};
    color: ${getCssVar("white", 90)};
  }
  &:disabled {
    background-color: ${getCssVar("white", 20)};
    color: ${getCssVar("grey", 900)};
  }
`;
var StyledApplyButtonIconStroke = styled41(button_icon_stroke_default)`
  background-color: ${getCssVar("green", 500)};
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${getCssVar("white", 100)};

  &:hover,
  &:focus {
    background-color: ${getCssVar("green", 600)};
    color: ${getCssVar("white", 90)};
  }
  &:disabled {
    background-color: ${getCssVar("white", 20)};
    color: ${getCssVar("grey", 900)};
  }
`;
var InitialCircle = styled41.div`
  max-width: 156px;
  max-height: 156px;
  width: 156px;
  height: 156px;
  background: #3a3c41;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: 400;
  font-size: 32px;
  line-height: 36px;
  color: rgba(255, 255, 255, 0.4);

`;

// src/shared/ui/incoming-call-modal/shared/constants.ts
var ACTIVE_TAB_ID = "active_tab_id";

// src/processes/store/audio-player/index.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";
function _define_property179(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread179(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property179(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys160(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props160(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys160(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var INITIAL_AUDIO_STATE = {
  audio: null,
  tempId: 0,
  assetName: "",
  playingAssets: null
};
var createAudioPlayer = ({ options, onChangeDynamicCb }) => create()(devtools((set, get3) => _object_spread_props160(_object_spread179({}, INITIAL_AUDIO_STATE), {
  changeAssets: (assets) => {
    if (typeof Audio !== "undefined") {
      set({
        tempId: 0,
        audio: new Audio(),
        playingAssets: assets.reduce((acc, asset) => {
          acc[asset] = false;
          return acc;
        }, {})
      });
    }
  },
  playSound: ({ name, loop = false, volume = 1 }) => {
    set(({ tempId, playingAssets }) => ({
      tempId: tempId + 1,
      assetName: name,
      playingAssets: _object_spread_props160(_object_spread179({}, playingAssets), {
        [name]: true
      })
    }));
    const src = name;
    try {
      const { audio: audio2 } = get3();
      if (!audio2)
        return;
      const sameSrc = new RegExp(src).test(audio2.src);
      if (!audio2.paused) {
        audio2.pause();
      }
      if (sameSrc) {
        audio2.currentTime = 0;
      } else {
        audio2.src = src;
      }
      audio2.autoplay = true;
      audio2.loop = loop;
      audio2.volume = volume;
      audio2.play();
    } catch (e) {
      console.error("playSound", name, e);
    }
  },
  playExistSound: (name) => {
    const { audio: audio2, assetName } = get3();
    if (!audio2 || assetName !== name) {
      return;
    }
    audio2.play();
  },
  stopSound: (name) => {
    const { audio: audio2, assetName } = get3();
    if (!audio2 || assetName !== name) {
      return;
    }
    audio2.pause();
    audio2.currentTime = 0;
  },
  toggleSound: ({ name, loop = false }) => {
    const { audio: audio2, playingAssets, playSound: playSound2, stopSound: stopSound2 } = get3();
    if (!playingAssets || !playingAssets.hasOwnProperty(name))
      return;
    playingAssets[name] = !playingAssets[name];
    if (playingAssets[name] || (audio2 === null || audio2 === void 0 ? void 0 : audio2.duration) === (audio2 === null || audio2 === void 0 ? void 0 : audio2.currentTime)) {
      playSound2({
        name,
        loop
      });
    } else {
      stopSound2(name);
    }
  },
  onChangeDynamic: (selectedDynamic) => {
    const { audio: audio2 } = get3();
    if (onChangeDynamicCb)
      onChangeDynamicCb({
        audio: audio2,
        selectedDynamic
      });
  },
  getCurrentPlaying: () => {
    const { audio: audio2, assetName } = get3();
    return audio2 && !audio2.paused ? assetName : null;
  }
}), options));

// src/shared/ui/incoming-call-modal/index.tsx
var { audio, changeAssets, stopSound, playSound, getCurrentPlaying } = createAudioPlayer({}).getState();
function IncomingCallPopover({ bottom, incomingCallData, onAcceptCall, onCancelCall, onAcceptedCall, callSound, accessToken, isInConference, setIsModalOpen }) {
  const localStorage2 = useMemo11(() => new LocalStorage_default(), []);
  const [open, setOpen] = useState17(true);
  const [isAvatarLoadingError, setIsAvatarLoadingError] = useState17(false);
  const timeoutRef = useRef11();
  const tabId = useRef11(null);
  const playCallSound = () => {
    if (!incomingCallData || incomingCallData.callStatus !== "active")
      return;
    const currentPlayingAsset = getCurrentPlaying();
    if (currentPlayingAsset === callSound)
      return;
    checkIsDesktopActive().then((isDesktopActive) => {
      if (!isDesktopActive) {
        if (document.visibilityState === "visible" || localStorage2.get(ACTIVE_TAB_ID) === tabId.current) {
          playSound({
            name: callSound,
            loop: true,
            volume: 1
          });
        }
      }
    });
  };
  const onDocumentVisibilityChange = () => {
    try {
      if (tabId.current) {
        localStorage2.set(ACTIVE_TAB_ID, tabId.current);
      }
      if (document.hidden) {
        stopSound(callSound);
        playCallSound();
        if (isInConference && setIsModalOpen) {
          setIsModalOpen(false);
        }
        return;
      }
      if (incomingCallData && incomingCallData.callStatus === "active") {
        playCallSound();
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect20(() => {
    document.addEventListener("visibilitychange", onDocumentVisibilityChange);
    window.onbeforeunload = null;
    tabId.current = uuid();
    changeAssets([
      callSound
    ]);
    return () => {
      document.removeEventListener("visibilitychange", onDocumentVisibilityChange);
      stopSound(callSound);
    };
  }, []);
  useEffect20(() => {
    if (!incomingCallData) {
      if (isInConference && setIsModalOpen) {
        setIsModalOpen(false);
      }
      return;
    }
    if (incomingCallData.callStatus === "active") {
      playCallSound();
      setOpen(true);
    }
    if (incomingCallData.callStatus !== "active") {
      timeoutRef.current = setTimeout(() => {
        setOpen(false);
      }, 1e3);
      stopSound(callSound);
      if (isInConference && setIsModalOpen) {
        setIsModalOpen(false);
      }
    }
    if (incomingCallData.callStatus === "accepted" && incomingCallData.slug) {
      onAcceptedCall(incomingCallData.slug);
    }
  }, [
    incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus,
    audio
  ]);
  const getStatusText = useCallback11(() => {
    if (!incomingCallData)
      return "";
    const { callStatus: callStatus2 } = incomingCallData;
    if (callStatus2 === "active")
      return incomingCallData.isConferenceCall ? Translate_default.get("calls.incomingCallConference") : Translate_default.get("calls.incomingCall");
    return callStatus2 && CallStatusText[callStatus2] ? CallStatusText[callStatus2]() : "";
  }, [
    incomingCallData === null || incomingCallData === void 0 ? void 0 : incomingCallData.callStatus
  ]);
  if (!incomingCallData || !open)
    return null;
  const { callId, user, callStatus } = incomingCallData;
  const onCallAccept = () => {
    if (isInConference && setIsModalOpen) {
      window.onbeforeunload = null;
      return setIsModalOpen(true);
    }
    onAcceptCall({
      callId
    });
  };
  const isShowAvatar = (user === null || user === void 0 ? void 0 : user.avatarPath) && !isAvatarLoadingError;
  const isDisableBtn = callStatus !== "active";
  return /* @__PURE__ */ _jsx212(Wrapper, {
    bottom,
    children: /* @__PURE__ */ _jsxs100(Stack_default, {
      alignItems: "center",
      children: [
        /* @__PURE__ */ _jsx212(box_default, {
          mb: 4,
          children: isShowAvatar ? /* @__PURE__ */ _jsx212(avatar_default, {
            sx: {
              background: "transparent",
              color: "inherit",
              fontSize: "inherit"
            },
            size: 156,
            src: (user === null || user === void 0 ? void 0 : user.avatarPath) && `${user.avatarPath}?authorization=${accessToken}` || "",
            alt: user === null || user === void 0 ? void 0 : user.initials,
            onError: ({ currentTarget }) => {
              currentTarget.onerror = null;
              setIsAvatarLoadingError(true);
            },
            children: user === null || user === void 0 ? void 0 : user.initials
          }) : /* @__PURE__ */ _jsx212(InitialCircle, {
            children: /* @__PURE__ */ _jsx212("span", {
              "data-testid": "initials",
              children: user === null || user === void 0 ? void 0 : user.initials
            })
          })
        }),
        /* @__PURE__ */ _jsx212(typography_default, {
          variant: "h5",
          noWrap: true,
          mb: 1,
          sx: {
            maxWidth: "100%"
          },
          "data-testid": "incoming-user-name",
          children: user === null || user === void 0 ? void 0 : user.name
        }),
        /* @__PURE__ */ _jsx212(typography_default, {
          variant: "body2",
          mb: 6,
          children: getStatusText()
        }),
        /* @__PURE__ */ _jsxs100(Stack_default, {
          direction: "row",
          alignItems: "center",
          mb: 1,
          gap: 5,
          children: [
            /* @__PURE__ */ _jsx212(StyledApplyButtonIconStroke, {
              onClick: onCallAccept,
              "data-testid": "accept-call",
              disabled: isDisableBtn,
              children: /* @__PURE__ */ _jsx212(phoneOn_default, {})
            }),
            /* @__PURE__ */ _jsx212(StyledButtonIconStroke, {
              onClick: () => {
                onCancelCall({
                  callId
                });
              },
              "data-testid": "decline-call",
              disabled: isDisableBtn,
              children: /* @__PURE__ */ _jsx212(phoneOff_default, {})
            })
          ]
        })
      ]
    })
  });
}
var incoming_call_modal_default = IncomingCallPopover;

// src/shared/ui/wrapper-settings/index.tsx
import { jsx as _jsx213 } from "react/jsx-runtime";
import { Fade as Fade3 } from "@mui/material";

// src/shared/ui/layouts/index.tsx
import { Box as Box6 } from "@mui/material";
import styled42 from "styled-components";
var Wrapper2 = styled42.div`
  display: flex;
  padding: 16px;
  overflow: hidden;
`;
var ShadowWrapper = styled42.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${getCssVar("black", 60)};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1301;
`;
var BoxWrapper = styled42(Box6)`
  background: #292a2e;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1302;
`;

// src/shared/ui/wrapper-settings/index.tsx
var WrapperSettings = ({ open, setOpen, children, boxStyle = {} }) => {
  const onClose = () => {
    setOpen(false);
  };
  return /* @__PURE__ */ _jsx213(Fade3, {
    in: open,
    children: /* @__PURE__ */ _jsx213(ShadowWrapper, {
      onClick: onClose,
      children: /* @__PURE__ */ _jsx213(BoxWrapper, {
        width: 341,
        height: 426,
        sx: {
          padding: 2
        },
        style: boxStyle,
        children
      })
    })
  });
};
var wrapper_settings_default = WrapperSettings;

// src/shared/ui/incoming-call-modal/shared/acceptance-modal/index.tsx
import { jsx as _jsx214, jsxs as _jsxs101, Fragment as _Fragment6 } from "react/jsx-runtime";
var AcceptanceModal = ({ isModalOpen, onAcceptCall, onClose, setIsModalOpen, isAdmin }) => {
  const handleClose = (_5, reason) => {
    if (reason && reason === "backdropClick")
      return;
    onClose();
  };
  const handleCloseIcon = () => setIsModalOpen(false);
  return /* @__PURE__ */ _jsx214(modal_default, {
    open: isModalOpen,
    title: /* @__PURE__ */ _jsxs101(_Fragment6, {
      children: [
        Translate_default.get("calls.widgets.toCallModal.title.0"),
        " ",
        /* @__PURE__ */ _jsx214("br", {}),
        " ",
        Translate_default.get("calls.widgets.toCallModal.title.1")
      ]
    }),
    actionButtonProps: {
      id: "go-to",
      title: "go-to",
      // @ts-ignore TODO check TS error
      onClick: onAcceptCall,
      children: Translate_default.get("calls.widgets.toCallModal.conferenceActions.acceptCall")
    },
    cancelButtonProps: {
      id: "cancel",
      title: "cancel",
      onClick: onClose,
      children: Translate_default.get("calls.widgets.toCallModal.conferenceActions.declineCall")
    },
    onClose: handleClose,
    onCloseIcon: handleCloseIcon,
    children: /* @__PURE__ */ _jsx214(Stack_default, {
      spacing: "16px",
      children: isAdmin ? /* @__PURE__ */ _jsxs101(typography_default, {
        children: [
          Translate_default.get("calls.widgets.toCallModal.textWhileModerator.0"),
          " ",
          /* @__PURE__ */ _jsx214("br", {}),
          " ",
          Translate_default.get("calls.widgets.toCallModal.textWhileModerator.1"),
          " ",
          /* @__PURE__ */ _jsx214("br", {}),
          " ",
          Translate_default.get("calls.widgets.toCallModal.textWhileModerator.2")
        ]
      }) : /* @__PURE__ */ _jsx214(typography_default, {
        children: Translate_default.get("calls.widgets.toCallModal.textDefault")
      })
    })
  });
};
var acceptance_modal_default = AcceptanceModal;

// src/shared/ui/date-picker/index.tsx
import { jsx as _jsx217, jsxs as _jsxs103 } from "react/jsx-runtime";
import React111 from "react";

// src/shared/ui/date-picker/shared/ui.ts
import { DatePicker, PickersDay } from "@mui/x-date-pickers";
import { styled as MuiStyled } from "@mui/material/styles";
import styled43 from "styled-components";
function _define_property180(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread180(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property180(target, key, source[key]);
    });
  }
  return target;
}
var DatePickerStyled = styled43(DatePicker)`
  width: 180px;
  .MuiInputBase-root {
    background-color: ${getCssVar("grey", 900)};
  }
  .MuiInputBase-input {
    padding: 7px 7px 7px 12px;
    box-sizing: border-box;
    height: 38px;
    font-size: ${getCssVar("font", "large")};
  }

  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }
  ${(props) => `
    ${props.$type === "week-date" && `
        width: 40px;
        height: 40px;

        .MuiInputBase-root {
          background: none;
          margin: 0;
          padding: 0;
          height: 100%;
          width: 100%
        }
       .MuiInputAdornment-root {
          height: 100%;
          width: 100%;
          max-height: none;
          margin: 0;
       }
       .MuiInputBase-root {
        border: 0;
       }
        .MuiOutlinedInput-notchedOutline {
        display: none;
        }
        .MuiInputBase-input {
        display: none;
        }
        .MuiButtonBase-root {
        color:#EBEDF0;
           margin: 0;
          padding: 0;
           width: 40px;
          height: 40px;
          border-radius: 8px;
        }
      `}
  
  
  `}
`;
var DatePickerHeader = styled43(stack_default)`
  padding: 0 3rem 1rem;
  justify-content: center;
`;
var HeaderButtonStyled = styled43(button_default)`
  padding: 4px 8px !important;
  border-radius: 16px;
  height: auto;
  &:hover {
    color: ${getCssVar("blue", 300)};
    background-color: rgba(255, 255, 255, 0.2);
  }
`;
var ArrowButton = styled43(IconButton_default)`
  padding: 0;
  background-color: none !important;
  opacity: 0.5;
  margin-right: auto;
  &:hover {
    opacity: 1;
    background-color: transparent;
  }
`;
var PickersDayWeekTypeStyled = MuiStyled(PickersDay, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isHovered"
})(({ theme, isSelected, isHovered, day }) => _object_spread180({
  padding: "0!important",
  position: "relative",
  zIndex: "1",
  "&:hover, &:focus": {
    background: "none!important"
  }
}, isSelected && _object_spread180({
  "&::before": _object_spread180({
    content: '""',
    zIndex: -2,
    backgroundColor: "rgba(255, 255, 255, 0.20)",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0"
  }, day.day() === 1 && {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%"
  }, day.day() === 0 && {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%"
  })
}, (day.day() === 0 || day.day() === 1) && {
  "&::after": {
    content: '""',
    zIndex: -1,
    backgroundColor: "#0062FF",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    borderRadius: "50%"
  }
}), isHovered && _object_spread180({
  "&::before": _object_spread180({
    content: '""',
    backgroundColor: "rgba(255, 255, 255, 0.20)",
    position: "absolute",
    zIndex: -2,
    top: "0",
    left: "0",
    right: "0",
    bottom: "0"
  }, day.day() === 1 && {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%"
  }, day.day() === 0 && {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%"
  })
}, (day.day() === 0 || day.day() === 1) && {
  "&::after": {
    content: '""',
    zIndex: -1,
    backgroundColor: "#0044B2",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    borderRadius: "50%"
  }
})));
var IconBtnWrapper = styled43.button`
  position: relative;
  width: 38px;
  min-width: 38px;
  height: 38px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  opacity: 1;
  cursor: pointer;
  &:hover {
    background-color: ${getCssVar("grey", 900)};
  }
`;

// src/shared/ui/date-picker/shared/DatePickerHeaderCustom.tsx
import { jsx as _jsx215, jsxs as _jsxs102 } from "react/jsx-runtime";
var DatePickerHeaderCustom = (props) => {
  const currentMonth = props.currentMonth;
  const handleViewChange = (view) => {
    if (!props.onViewChange) {
      console.log("onViewChange method undefined");
      return;
    }
    if (view === props.view)
      props.onViewChange("day");
    props.onViewChange(view);
  };
  return /* @__PURE__ */ _jsxs102(DatePickerHeader, {
    direction: "row",
    alignItems: "center",
    children: [
      props.view === "day" && /* @__PURE__ */ _jsx215(ArrowButton, {
        style: {
          marginRight: "auto"
        },
        "data-testid": "arrow-previous-month",
        onClick: () => props.onMonthChange(currentMonth.add(-1, "month"), "right"),
        children: /* @__PURE__ */ _jsx215(ChevronLeft_default, {
          width: 12,
          height: 20
        })
      }),
      /* @__PURE__ */ _jsxs102(stack_default, {
        direction: "row",
        alignItems: "center",
        children: [
          /* @__PURE__ */ _jsx215(HeaderButtonStyled, {
            size: "large",
            onClick: () => {
              if (props.view === "month" && !props.views.includes("day"))
                return;
              handleViewChange("month");
            },
            children: currentMonth.format("MMMM")
          }),
          /* @__PURE__ */ _jsx215(HeaderButtonStyled, {
            size: "large",
            onClick: () => {
              if (props.view === "year" && !props.views.includes("day"))
                return;
              handleViewChange("year");
            },
            children: currentMonth.year()
          })
        ]
      }),
      props.view === "day" && /* @__PURE__ */ _jsx215(ArrowButton, {
        style: {
          marginLeft: "auto"
        },
        "data-testid": "arrow-next-month",
        onClick: () => props.onMonthChange(currentMonth.add(1, "month"), "left"),
        children: /* @__PURE__ */ _jsx215(ChevronRight_default, {
          width: 12,
          height: 20
        })
      })
    ]
  });
};
var DatePickerHeaderCustom_default = DatePickerHeaderCustom;

// src/shared/ui/date-picker/shared/PickersDayWeekDate.tsx
import { jsx as _jsx216 } from "react/jsx-runtime";
function _define_property181(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread181(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property181(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys161(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props161(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys161(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties152(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose152(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose152(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var PickersDayWeekDate = (props) => {
  const { day, selectedDay, hoveredDay } = props, other = _object_without_properties152(props, [
    "day",
    "selectedDay",
    "hoveredDay"
  ]);
  const isInSameWeek = (dayA, dayB) => {
    if (dayB == null) {
      return false;
    }
    return dayA.isSame(dayB, "week");
  };
  return /* @__PURE__ */ _jsx216(PickersDayWeekTypeStyled, _object_spread_props161(_object_spread181({}, other), {
    day,
    disableMargin: true,
    selected: false,
    isSelected: isInSameWeek(day, selectedDay),
    isHovered: isInSameWeek(day, hoveredDay)
  }));
};

// src/shared/ui/date-picker/index.tsx
function _define_property182(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread182(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property182(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys162(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props162(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys162(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties153(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose153(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose153(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var DatePicker2 = (_param) => {
  var { className, header = Translate_default.get("components.datePicker.header"), type = "single-date" } = _param, props = _object_without_properties153(_param, [
    "className",
    "header",
    "type"
  ]);
  const [hoveredDay, setHoveredDay] = React111.useState(null);
  const renderDatePicker = () => {
    switch (type) {
      case "single-date":
        return /* @__PURE__ */ _jsxs103(stack_default, {
          className,
          children: [
            header && /* @__PURE__ */ _jsx217(typography_default, {
              marginBottom: 1,
              children: header
            }),
            /* @__PURE__ */ _jsx217(DatePickerStyled, _object_spread_props162(_object_spread182({
              $type: type,
              views: [
                "year",
                "month",
                "day"
              ],
              label: "",
              format: "DD.MM.YYYY",
              ampm: false
            }, props), {
              slots: _object_spread182({
                openPickerIcon: () => /* @__PURE__ */ _jsx217(Calendar_default, {
                  fill: "currentColor"
                }),
                calendarHeader: DatePickerHeaderCustom_default
              }, props.slots),
              slotProps: _object_spread182({
                textField: {
                  placeholder: "__.__.____",
                  "data-testid": "date"
                },
                openPickerButton: {
                  "data-testid": "arrow-select-date"
                }
              }, props.slotProps)
            }))
          ]
        });
      case "week-date":
        return /* @__PURE__ */ _jsxs103(stack_default, {
          className,
          children: [
            header && /* @__PURE__ */ _jsx217(typography_default, {
              marginBottom: 1,
              children: header
            }),
            /* @__PURE__ */ _jsx217(DatePickerStyled, _object_spread_props162(_object_spread182({
              $type: type,
              views: [
                "year",
                "month",
                "day"
              ],
              label: "",
              format: "DD.MM.YYYY",
              ampm: false
            }, props), {
              slots: _object_spread182({
                openPickerIcon: () => /* @__PURE__ */ _jsx217(Calendar_default, {
                  fill: "currentColor"
                }),
                calendarHeader: DatePickerHeaderCustom_default,
                // @ts-ignore
                day: PickersDayWeekDate
              }, props.slots),
              slotProps: _object_spread182({
                day: (ownerState) => ({
                  selectedDay: props.value,
                  hoveredDay,
                  // @ts-ignore
                  onPointerEnter: () => setHoveredDay(ownerState.day),
                  onPointerLeave: () => setHoveredDay(null)
                }),
                popper: {
                  disablePortal: true
                }
              }, props.slotProps)
            }))
          ]
        });
      default:
        notReachable(type);
    }
  };
  return renderDatePicker();
};
DatePicker2.displayName = "DatePicker";
var date_picker_default = DatePicker2;

// src/shared/ui/modal-confirm/index.tsx
import { jsx as _jsx218, jsxs as _jsxs104 } from "react/jsx-runtime";
import React112 from "react";

// src/shared/ui/modal-confirm/ui.tsx
import styled44 from "styled-components";
var ModalText = styled44(typography_default)`
  margin: 16px 0!important;
`;
var ModalBtn = styled44(button_default)`
  width: 150px;
`;
var ModalInner = styled44(stack_default)`
  min-height: 206px;
  max-width: 398px;
  margin-top: -20px;
`;

// src/shared/ui/modal-confirm/index.tsx
var ModalConfirm = ({ isOpen, title, text = "", buttons: { confirm, close, onClose, onConfirm } }) => /* @__PURE__ */ _jsx218(modal_default, {
  open: isOpen,
  onClose: () => onClose("close"),
  children: /* @__PURE__ */ _jsxs104(ModalInner, {
    direction: "column",
    justifyContent: "start",
    children: [
      /* @__PURE__ */ _jsx218(typography_default, {
        variant: "h4",
        children: title
      }),
      text && /* @__PURE__ */ _jsx218(ModalText, {
        children: text
      }),
      /* @__PURE__ */ _jsxs104(stack_default, {
        direction: "row",
        spacing: "16px",
        alignItems: "center",
        marginTop: "auto",
        children: [
          /* @__PURE__ */ _jsx218(ModalBtn, {
            color: "primary",
            variant: "contained",
            size: "medium",
            onClick: onConfirm,
            children: confirm
          }),
          /* @__PURE__ */ _jsx218(ModalBtn, {
            size: "medium",
            color: "secondary",
            variant: "contained",
            onClick: () => onClose("cancel"),
            children: close
          })
        ]
      })
    ]
  })
});
var modal_confirm_default = /* @__PURE__ */ React112.memo(ModalConfirm);

// src/shared/ui/custom-select/index.tsx
import { jsx as _jsx219 } from "react/jsx-runtime";
import { Select as SelectUnstyled } from "@mui/base/Select";
import React113 from "react";

// src/shared/ui/custom-select/ui.tsx
import { Option as OptionUnstyled, optionClasses } from "@mui/base/Option";
import { Popper as PopperUnstyled } from "@mui/base/Popper";
var Button2 = styled_default("button")`
  font-size: 16px;
  line-height: 22px;
  box-sizing: border-box;
  height: 38px;
  width: 398px;
  background: #3a3c41;
  border: none;
  border-radius: 4px;
  padding: 8px 22px 8px 12px;
  text-align: left;
  color: #ebedf0;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;

  &:hover {
    background: #3a3c41;
    color: #ebedf0;
  }

  &:disabled {
    opacity: 0.5;
  }



  &::after {
    content: '▾';
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
var Listbox = styled_default("ul")`
  font-size: 14px;
  box-sizing: border-box;
  padding: 16px;
  margin: 4px 0;
  min-width: 414px;
  background: #4e5158;
  border-radius: 4px;
  color: #ebedf0;
  overflow: auto;
  outline: 0px;
`;
var Option = styled_default(OptionUnstyled)`
  list-style: none;
  padding: 8px;
  font-size: 14px;
  color: #ebedf0;
  cursor: default;

  &:last-of-type {
    border-bottom: none;
  }

  &.${optionClasses.selected} {
    color: #2fc063;
  }

  &.${optionClasses.disabled} {
    opacity: 0.5;
  }

  &:hover:not(.${optionClasses.disabled}) {
    cursor: pointer;
  }
`;
var Popper3 = styled_default(PopperUnstyled)`
  z-index: 1307;
  max-width: 398px;
`;

// src/shared/ui/custom-select/index.tsx
function _define_property183(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread183(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property183(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys163(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props163(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys163(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var CustomSelect = (props) => {
  const slots = _object_spread183({
    root: Button2,
    listbox: Listbox,
    popper: Popper3
  }, props.slots);
  return /* @__PURE__ */ _jsx219(SelectUnstyled, _object_spread_props163(_object_spread183({}, props), {
    slots
  }));
};
var custom_select_default = /* @__PURE__ */ React113.memo(CustomSelect);

// src/shared/ui/accordion/index.tsx
import { jsx as _jsx220 } from "react/jsx-runtime";
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails } from "@mui/material";
function _define_property184(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread184(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property184(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys164(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props164(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys164(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties154(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose154(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose154(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Accordion = (_param) => {
  var { children } = _param, props = _object_without_properties154(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx220(MuiAccordion, _object_spread_props164(_object_spread184({}, props), {
    children
  }));
};
var AccordionSummary = (_param) => {
  var { children } = _param, props = _object_without_properties154(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx220(MuiAccordionSummary, _object_spread_props164(_object_spread184({}, props), {
    children
  }));
};
var AccordionDetails = (_param) => {
  var { children } = _param, props = _object_without_properties154(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx220(MuiAccordionDetails, _object_spread_props164(_object_spread184({}, props), {
    children
  }));
};

// src/shared/ui/list-unstyled/index.tsx
import { jsx as _jsx221 } from "react/jsx-runtime";
import { List as MuiList, ListItem as MuiListItem, ListItemText as MuiListItemText2 } from "@mui/material";
function _define_property185(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread185(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property185(target, key, source[key]);
    });
  }
  return target;
}
var ListUnstyled = (props) => /* @__PURE__ */ _jsx221(MuiList, _object_spread185({}, props));
var ListItemUnstyled = (props) => /* @__PURE__ */ _jsx221(MuiListItem, _object_spread185({}, props));
var ListItemTextUnstyled = (props) => /* @__PURE__ */ _jsx221(MuiListItemText2, _object_spread185({}, props));

// src/shared/ui/dialog/index.tsx
import { jsx as _jsx222 } from "react/jsx-runtime";
import { Dialog as MuiDialog, DialogTitle as MuiDialogTitle, DialogActions as MuiDialogActions, DialogContent as MuiDialogContent } from "@mui/material";
function _define_property186(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread186(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property186(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys165(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props165(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys165(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties155(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose155(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose155(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Dialog = (_param) => {
  var { children } = _param, props = _object_without_properties155(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx222(MuiDialog, _object_spread_props165(_object_spread186({}, props), {
    children
  }));
};
var DialogTitle = (props) => /* @__PURE__ */ _jsx222(MuiDialogTitle, _object_spread186({}, props));
var DialogActions = (props) => /* @__PURE__ */ _jsx222(MuiDialogActions, _object_spread186({}, props));
var DialogContent = (props) => /* @__PURE__ */ _jsx222(MuiDialogContent, _object_spread186({}, props));

// src/shared/ui/radio/index.tsx
import { jsx as _jsx223 } from "react/jsx-runtime";

// src/shared/ui/radio/shared/ui.tsx
import { styled as styledMui3 } from "@mui/material";
import { Radio, radioClasses } from "@mui/material";
var RadioButton = styledMui3(Radio)({
  margin: "11px",
  padding: 0,
  width: 20,
  height: 20,
  border: "2px solid rgba(256,256,256,0.6)",
  [`&:hover`]: {
    borderColor: "#fff"
  },
  [`&.Mui-disabled`]: {
    borderColor: "rgba(256,256,256,0.2)"
  },
  [`& .MuiSvgIcon-root`]: {
    display: "none"
  },
  [`&.${radioClasses.checked}`]: {
    background: getCssVar("blue", 500),
    border: 0,
    "&:before": {
      display: "block",
      width: 8,
      height: 8,
      background: getCssVar("white", 100),
      borderRadius: 50,
      content: '""'
    }
  },
  [`&.${radioClasses.checked}:hover`]: {
    background: getCssVar("blue", 700)
  },
  [`&.${radioClasses.checked}.Mui-disabled`]: {
    background: getCssVar("grey", 900),
    "&:before": {
      background: getCssVar("grey", 950)
    }
  }
});

// src/shared/ui/radio/index.tsx
import { RadioGroup as MuiRadioGroup, styled as styledMui4, FormControlLabel } from "@mui/material";
function _define_property187(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread187(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property187(target, key, source[key]);
    });
  }
  return target;
}
var Radio2 = (props) => /* @__PURE__ */ _jsx223(RadioButton, _object_spread187({}, props));
var RadioGroup = (props) => /* @__PURE__ */ _jsx223(MuiRadioGroup, _object_spread187({}, props));
var RadioLabel = styledMui4(FormControlLabel)({
  [`&:not(:last-child)`]: {
    marginRight: 24
  }
});

// src/shared/ui/avatar-unstyled/index.tsx
import { jsx as _jsx224 } from "react/jsx-runtime";
import { Avatar as MuiAvatar2 } from "@mui/material";
function _define_property188(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread188(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property188(target, key, source[key]);
    });
  }
  return target;
}
var AvatarUnstyled = (props) => /* @__PURE__ */ _jsx224(MuiAvatar2, _object_spread188({}, props));

// src/shared/ui/list-item-avatar/index.tsx
import { jsx as _jsx225 } from "react/jsx-runtime";
import { ListItemAvatar as MuiListItemAvatar } from "@mui/material";
function _define_property189(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread189(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property189(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys166(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props166(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys166(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties156(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose156(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose156(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ListItemAvatar = (_param) => {
  var { children } = _param, props = _object_without_properties156(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx225(MuiListItemAvatar, _object_spread_props166(_object_spread189({}, props), {
    children
  }));
};

// src/shared/ui/circular-progress/index.tsx
import { jsx as _jsx226 } from "react/jsx-runtime";
import { CircularProgress as MuiCircularProgress } from "@mui/material";
function _define_property190(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread190(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property190(target, key, source[key]);
    });
  }
  return target;
}
var CircularProgress = (props) => /* @__PURE__ */ _jsx226(MuiCircularProgress, _object_spread190({}, props));

// src/shared/model/useMenu/index.tsx
var useMenu = ({ list, transformOrigin, onButtonClick }, deps = []) => {
  const [anchorEl, setAnchorEl] = useState18(null);
  const [sharedData, setSharedData] = useState18(null);
  const open = useCallback12((e, sharedData2) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    if (sharedData2) {
      setSharedData(sharedData2);
    }
  }, []);
  const close = useCallback12((e) => {
    e.stopPropagation();
    setAnchorEl(null);
    if (sharedData) {
      setSharedData(null);
    }
  }, [
    sharedData
  ]);
  const onMenuButtonClick = useCallback12((e) => {
    if (onButtonClick) {
      onButtonClick(e, open);
      return;
    }
    open(e);
  }, [
    open,
    onButtonClick
  ]);
  const menu = useMemo12(() => /* @__PURE__ */ _jsx227(menu_default, {
    anchorEl,
    open: !!anchorEl,
    transformOrigin,
    onClose: close,
    children: list.map((item, i) => {
      const { render, isVisible: _isVisible, onClick: _onClick } = item;
      const isVisible = _isVisible ? _isVisible(sharedData) : true;
      const onClick = (e) => {
        if (_onClick) {
          _onClick(item, sharedData);
        }
        close(e);
      };
      if (!isVisible) {
        return null;
      }
      return /* @__PURE__ */ _jsx227(StyledMenuItem, {
        onClick,
        children: render(sharedData)
      }, i);
    })
  }), [
    list,
    transformOrigin,
    sharedData,
    anchorEl,
    close,
    ...deps
  ]);
  const MenuButton = useMemo12(() => ({ size = "small", onClick }) => /* @__PURE__ */ _jsx227(button_default, {
    className: "flex w-4 justify-center",
    size,
    style: {
      padding: "0 1rem",
      height: getSizeUnit(16)
    },
    onClick: (e) => {
      if (onClick) {
        onClick(e);
        return;
      }
      onMenuButtonClick(e);
    },
    children: /* @__PURE__ */ _jsx227("i", {
      children: /* @__PURE__ */ _jsx227(TriplePoints_default, {
        width: 3,
        height: 16
      })
    })
  }), [
    onMenuButtonClick
  ]);
  return {
    anchorEl,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MenuButton,
    menu,
    open,
    close
  };
};
var useMenu_default = useMenu;

// src/shared/model/useMetrics/index.tsx
import { useContext as useContext3 } from "react";

// src/shared/model/useMetrics/shared/context.ts
import React114 from "react";
var MetricsContext = React114.createContext({});
var context_default = MetricsContext;

// src/shared/model/useMetrics/shared/provider.tsx
var import_lodash13 = __toESM(require_lodash());
import { jsx as _jsx232 } from "react/jsx-runtime";
import React118, { useEffect as useEffect22, useState as useState20 } from "react";

// src/shared/model/useSession/index.tsx
import { useContext as useContext2 } from "react";

// src/shared/providers/commonProvider.tsx
import { jsx as _jsx231 } from "react/jsx-runtime";

// src/shared/providers/themeProvider.tsx
import { ThemeProvider } from "@mui/material";

// src/shared/providers/auth-provider/shared/authContext.ts
import React115 from "react";

// src/shared/providers/auth-provider/model/constants.ts
var DEFAULT_AUTH = {};
var ACCESS_TOKEN = "vc-access-token";
var REFRESH_TOKEN = "vc-refresh-token";
var REFERRER_TOKEN = "vc-referrer-token";

// src/shared/providers/auth-provider/shared/authContext.ts
var AuthContext = React115.createContext(DEFAULT_AUTH);
var authContext_default = AuthContext;

// src/shared/providers/auth-provider/authProvider.tsx
import { jsx as _jsx228 } from "react/jsx-runtime";
import React116, { useCallback as useCallback13, useEffect as useEffect21, useMemo as useMemo13, useState as useState19 } from "react";

// src/shared/providers/auth-provider/model/types.ts
var AuthCallbackType;
(function(AuthCallbackType2) {
  AuthCallbackType2["onUnauthorized"] = "onunauthorized";
  AuthCallbackType2["onAuthorized"] = "onauthorized";
})(AuthCallbackType || (AuthCallbackType = {}));

// src/shared/providers/auth-provider/authProvider.tsx
function _define_property191(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread191(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property191(target, key, source[key]);
    });
  }
  return target;
}
var buildQuery = (query) => Object.keys(query).map((key) => `${key}=${encodeURIComponent(query[key])}`).join("&");
var AuthProvider = ({
  children,
  fetch: fetch2,
  fetchProfile_,
  // refreshToken: _refreshToken,
  onAuthorized,
  onUnauthorized,
  isGuest,
  dionHost
}) => {
  const localStorage2 = useMemo13(() => new LocalStorage_default(), []);
  const [isReady, setIsReady] = useState19(false);
  const [isRefreshTokenExpired, setIsRefreshTokenExpired] = useState19(false);
  const [referrer, setReferrer] = useState19(localStorage2.get(REFERRER_TOKEN));
  const [accessToken, setAccessToken] = useState19("");
  const [user, setUser] = useState19(null);
  const _listeners = useMemo13(() => /* @__PURE__ */ new Map(), []);
  const isUserByInvite = !!((user === null || user === void 0 ? void 0 : user.roles) && (user === null || user === void 0 ? void 0 : user.roles.includes("user_by_invite")));
  const isAuthorized = !!accessToken || !!isGuest || isUserByInvite;
  const isAdmin = !!((user === null || user === void 0 ? void 0 : user.roles) && (user === null || user === void 0 ? void 0 : user.roles.includes("admin")));
  const referTo = useCallback13((newReferrer) => {
    if (referrer || !newReferrer) {
      return;
    }
    localStorage2.set(REFERRER_TOKEN, newReferrer);
    setReferrer(newReferrer);
  }, [
    referrer
  ]);
  const replace = useCallback13(() => {
    if (isAuthorized) {
      window.location.replace(referrer || "/");
      localStorage2.set(REFERRER_TOKEN, "");
      setReferrer("");
    }
  }, [
    isAuthorized,
    referrer
  ]);
  const onUnauthorizedCallback = useCallback13((callback) => {
    _listeners.set(AuthCallbackType.onUnauthorized, callback);
  }, [
    isReady
  ]);
  const onAuthorizedCallback = useCallback13((callback) => {
    _listeners.set(AuthCallbackType.onAuthorized, callback);
  }, [
    isReady
  ]);
  const refresh = (refreshOnly = false) => {
    if (!refreshOnly)
      setIsReady(false);
    fetch2.post("/v2/auth/refresh/web").then(({ data }) => {
      const { access_token: accessToken2, user: user2 } = data;
      localStorage2.set(ACCESS_TOKEN, accessToken2);
      localStorage2.set(REFERRER_TOKEN, "");
      setAccessToken(accessToken2);
      if (!refreshOnly)
        setIsReady(true);
      setUser(toCamelCase(user2));
    }).catch((err) => {
      localStorage2.set(ACCESS_TOKEN, "");
      localStorage2.set(REFERRER_TOKEN, "");
      setAccessToken("");
      if (!refreshOnly)
        setIsReady(true);
      setUser(null);
      if (+err.status === 401 || err.message.includes("401")) {
        setIsRefreshTokenExpired(true);
      }
    });
  };
  const fetchProfile = useCallback13(() => {
    const headers = {
      headers: {
        authorization: `Bearer ${accessToken}`,
        "Accept-Language": Translate_default.currentLang()
      },
      withCredentials: false
    };
    if (fetchProfile_)
      return fetchProfile_.get("/platform/v1/users/profile", headers);
    return fetch2.get("/v2/users/profile", headers);
  }, [
    accessToken
  ]);
  const logout = useCallback13(() => fetch2.post("/v2/users/logout/web"), []);
  useEffect21(() => {
    refresh();
  }, []);
  useEffect21(() => {
    const [, _referrer = document.referrer] = window.location.search.match(/referrer=(.*[^&=])/i) || [];
    referTo(_referrer);
  }, []);
  useEffect21(() => {
    if (isReady && isAuthorized) {
      fetchProfile().then(({ data }) => {
        setUser(_object_spread191({}, toCamelCase(data)));
      }).catch((e) => {
        var _e_response;
        const error = e === null || e === void 0 ? void 0 : (_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.data;
        setUser(null);
        setIsReady(false);
        setAccessToken("");
        if (error.code === 451) {
          const referrer2 = window.location.href;
          const URL2 = `${dionHost}?${buildQuery({
            referrer: referrer2
          })}`;
          window.location.replace(URL2);
        }
      });
    }
  }, [
    isReady,
    isAuthorized
  ]);
  useEffect21(() => {
    if (!isReady) {
      return;
    }
    if (isAuthorized && user && onAuthorized) {
      onAuthorized(user);
    }
    if (!isAuthorized && onUnauthorized && !user) {
      onUnauthorized();
    }
  }, [
    isReady,
    isAuthorized,
    user === null || user === void 0 ? void 0 : user.roles.join(",")
  ]);
  useEffect21(() => {
    if (!isReady) {
      return;
    }
    const referrerPath = referrer || "/";
    _listeners.forEach((callback, type) => {
      if (isAuthorized && type === AuthCallbackType.onAuthorized) {
        callback(user, referrerPath, replace);
        return;
      }
      if (!isAuthorized && type === AuthCallbackType.onUnauthorized) {
        callback(user, referrerPath, replace);
      }
    });
  }, [
    isReady,
    isAuthorized,
    user,
    referrer,
    _listeners,
    replace
  ]);
  const value = {
    isReady,
    isAuthorized,
    isAdmin,
    accessToken,
    referrer,
    user,
    isRefreshTokenExpired,
    replace,
    refresh,
    referTo,
    logout,
    onAuthorized: onAuthorizedCallback,
    onUnauthorized: onUnauthorizedCallback
  };
  return /* @__PURE__ */ _jsx228(authContext_default.Provider, {
    value,
    children
  });
};
var authProvider_default = /* @__PURE__ */ React116.memo(AuthProvider);

// src/shared/providers/localizationDatePickerProvider.tsx
import { jsx as _jsx229 } from "react/jsx-runtime";
import { LocalizationProvider as LocalizationProviderMui } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
function _define_property192(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread192(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property192(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys167(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props167(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys167(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties157(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose157(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose157(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var LocalizationDatePickerProvider = (_param) => {
  var { children } = _param, props = _object_without_properties157(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx229(LocalizationProviderMui, _object_spread_props167(_object_spread192({
    dateAdapter: AdapterDayjs,
    adapterLocale: Translate_default.currentLang()
  }, props), {
    children
  }));
};

// src/shared/providers/env-provider/envProvider.tsx
import { jsx as _jsx230 } from "react/jsx-runtime";

// src/shared/providers/env-provider/shared/envContext.tsx
import React117 from "react";
var DEFAULT_ENV = {};
var EnvContext = /* @__PURE__ */ React117.createContext(DEFAULT_ENV);

// src/shared/providers/env-provider/envProvider.tsx
function _object_without_properties158(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose158(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose158(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var EnvProvider = (_param) => {
  var { children } = _param, props = _object_without_properties158(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx230(EnvContext.Provider, {
    value: props,
    children
  });
};

// src/shared/providers/commonProvider.tsx
function _define_property193(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread193(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property193(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys168(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props168(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys168(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties159(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose159(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose159(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var CommonProvider = (_param) => {
  var { children } = _param, props = _object_without_properties159(_param, [
    "children"
  ]);
  return Object.keys(props).reduce((providers, propKey) => {
    if (propKey === "theme" && props.theme !== void 0)
      return /* @__PURE__ */ _jsx231(ThemeProvider, _object_spread_props168(_object_spread193({}, props.theme), {
        children: providers
      }));
    if (propKey === "auth" && props.auth !== void 0)
      return /* @__PURE__ */ _jsx231(authProvider_default, _object_spread_props168(_object_spread193({}, props.auth), {
        children: providers
      }));
    if (propKey === "env" && props.env !== void 0)
      return /* @__PURE__ */ _jsx231(EnvProvider, _object_spread_props168(_object_spread193({}, props.env), {
        children: providers
      }));
    if (propKey === "localizationDatePicker" && props.localizationDatePicker !== void 0)
      return /* @__PURE__ */ _jsx231(LocalizationDatePickerProvider, _object_spread_props168(_object_spread193({}, props.localizationDatePicker), {
        children: providers
      }));
    return providers;
  }, children);
};

// src/shared/model/useSession/index.tsx
function _define_property194(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread194(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property194(target, key, source[key]);
    });
  }
  return target;
}
var useSession = () => {
  const context = useContext2(authContext_default);
  return _object_spread194({}, context);
};

// src/shared/model/useMetrics/types.ts
var Events2;
(function(Events3) {
  Events3["PlayerClickPlay"] = "vd_player_click_play";
  Events3["PlayerClickPause"] = "vd_player_click_pause";
  Events3["PlayerClick10Fwd"] = "vd_player_click_10fwd";
  Events3["PlayerClick10Bwd"] = "vd_player_click_10bwd";
  Events3["PlayerClickWind"] = "vd_player_click_wind";
  Events3["PlayerClickSpeed"] = "vd_player_click_speed";
  Events3["PlayerClickQuality"] = "vd_player_click_quality";
  Events3["PlayerClickFullscreen"] = "vd_player_click_fullscreen";
  Events3["PlayerQuartile"] = "vd_player_quartile";
  Events3["PageView"] = "vd_pageview";
  Events3["SelectFilter"] = "vd_select_filter";
  Events3["SelectSorting"] = "vd_select_sorting";
  Events3["ClickSidebarElem"] = "click_sidebar_elem";
  Events3["ClickDownloadVideo"] = "vd_click_download_video";
  Events3["ClickShareUrl"] = "vd_click_share_url";
})(Events2 || (Events2 = {}));
var Screens;
(function(Screens2) {
  Screens2["Player"] = "vd_player";
  Screens2["Video"] = "vd_video";
  Screens2["History"] = "vd_history";
  Screens2["ChannelsAllVideo"] = "vd_channel_all_videos";
  Screens2["ChannelsAllChannels"] = "vd_channel_all_channels";
  Screens2["ChannelsMyChannels"] = "vd_channel_my_channels";
  Screens2["OldSchool"] = "vd_oldschool";
})(Screens || (Screens = {}));
var Quartile;
(function(Quartile2) {
  Quartile2[Quartile2["Begin"] = 0] = "Begin";
  Quartile2[Quartile2["First"] = 25] = "First";
  Quartile2[Quartile2["Second"] = 50] = "Second";
  Quartile2[Quartile2["Third"] = 75] = "Third";
  Quartile2[Quartile2["Fourth"] = 100] = "Fourth";
})(Quartile || (Quartile = {}));
var QuartilePoints;
(function(QuartilePoints2) {
  QuartilePoints2[QuartilePoints2["First"] = 0.25] = "First";
  QuartilePoints2[QuartilePoints2["Second"] = 0.5] = "Second";
  QuartilePoints2[QuartilePoints2["Third"] = 0.75] = "Third";
  QuartilePoints2[QuartilePoints2["Fourth"] = 1] = "Fourth";
})(QuartilePoints || (QuartilePoints = {}));

// src/shared/model/useMetrics/lib/sendPageView.ts
var sendPageView = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.Player,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendPageView_default = sendPageView;

// src/shared/model/useMetrics/lib/sendPageViewVideo.ts
var sendPageViewVideo = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.Video,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendPageViewVideo_default = sendPageViewVideo;

// src/shared/model/useMetrics/lib/sendPageViewHistory.ts
var sendPageViewHistory = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.History,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendPageViewHistory_default = sendPageViewHistory;

// src/shared/model/useMetrics/lib/sendPageViewChannelAllVideos.ts
var sendPageViewChannelAllVideos = (metrics, videoId, { source, ref: ref3, refUserId, sorting, filters }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.ChannelsAllVideo,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId,
  sorting,
  filters
});
var sendPageViewChannelAllVideos_default = sendPageViewChannelAllVideos;

// src/shared/model/useMetrics/lib/sendPageViewChannelAllChannels.ts
var sendPageViewChannelAllChannels = (metrics, videoId, { source, ref: ref3, refUserId, sorting, filters }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.ChannelsAllChannels,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId,
  sorting,
  filters
});
var sendPageViewChannelAllChannels_default = sendPageViewChannelAllChannels;

// src/shared/model/useMetrics/lib/sendPageViewChannelMyChannels.ts
var sendPageViewChannelMyChannels = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.ChannelsMyChannels,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendPageViewChannelMyChannels_default = sendPageViewChannelMyChannels;

// src/shared/model/useMetrics/lib/sendSelectFilter.ts
var sendSelectFilter = (metrics, videoId, { filters, refUserId }) => metrics.sendEvent(Events2.SelectFilter, {
  screen: Screens.ChannelsAllVideo,
  videoid: videoId,
  url: window.location.href,
  filter_array: filters,
  ref_user_id: refUserId
});
var sendSelectFilter_default = sendSelectFilter;

// src/shared/model/useMetrics/lib/sendSelectSorting.ts
var sendSelectSorting = (metrics, videoId, { sorting, refUserId }) => metrics.sendEvent(Events2.SelectSorting, {
  screen: Screens.ChannelsAllVideo,
  videoid: videoId,
  url: window.location.href,
  sorting_value: sorting,
  ref_user_id: refUserId
});
var sendSelectSorting_default = sendSelectSorting;

// src/shared/model/useMetrics/lib/sendClickDownloadVideo.ts
var sendClickDownloadVideo = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.ClickDownloadVideo, {
  screen: Screens.Player,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendClickDownloadVideo_default = sendClickDownloadVideo;

// src/shared/model/useMetrics/lib/sendClickShareUrl.ts
var sendClickShareUrl = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.ClickShareUrl, {
  screen: Screens.Player,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendClickShareUrl_default = sendClickShareUrl;

// src/shared/model/useMetrics/lib/sendClickSidebarElem.ts
var sendClickSidebarElem = (metrics, { sidebarElem }) => metrics.sendEvent(Events2.ClickSidebarElem, {
  screen: Screens.Video,
  sidebar_elem: sidebarElem
});
var sendClickSidebarElem_default = sendClickSidebarElem;

// src/shared/model/useMetrics/lib/sendPageViewOldSchool.ts
var sendPageView2 = (metrics, videoId, { source, ref: ref3, refUserId }) => metrics.sendEvent(Events2.PageView, {
  screen: Screens.OldSchool,
  videoid: videoId,
  url: window.location.href,
  source,
  ref: ref3,
  ref_user_id: refUserId
});
var sendPageViewOldSchool_default = sendPageView2;

// src/shared/model/useMetrics/lib/sendPlayerClickPlay.ts
var sendPlayerClickPlay = (metrics, videoId, { timing, quartile }) => metrics.sendEvent(Events2.PlayerClickPlay, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  quartile
});
var sendPlayerClickPlay_default = sendPlayerClickPlay;

// src/shared/model/useMetrics/lib/sendPlayerClickPause.ts
var sendPlayerClickPause = (metrics, videoId, { timing, quartile }) => metrics.sendEvent(Events2.PlayerClickPause, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  quartile
});
var sendPlayerClickPause_default = sendPlayerClickPause;

// src/shared/model/useMetrics/lib/sendPlayerClickWind.ts
var sendPlayerClickWind = (metrics, videoId, { timing, quartile }) => metrics.sendEvent(Events2.PlayerClickWind, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  quartile
});
var sendPlayerClickWind_default = sendPlayerClickWind;

// src/shared/model/useMetrics/lib/sendPlayerClick10Bwd.ts
var sendPlayerClick10Bwd = (metrics, videoId, { timing, quartile }) => metrics.sendEvent(Events2.PlayerClick10Bwd, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  quartile
});
var sendPlayerClick10Bwd_default = sendPlayerClick10Bwd;

// src/shared/model/useMetrics/lib/sendPlayerClick10Fwd.ts
var sendPlayerClick10Fwd = (metrics, videoId, { timing, quartile }) => metrics.sendEvent(Events2.PlayerClick10Fwd, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  quartile
});
var sendPlayerClick10Fwd_default = sendPlayerClick10Fwd;

// src/shared/model/useMetrics/lib/sendPlayerClickSpeed.ts
function _define_property195(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread195(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property195(target, key, source[key]);
    });
  }
  return target;
}
var sendPlayerClickSpeed = (metrics, videoId, payload) => metrics.sendEvent(Events2.PlayerClickSpeed, _object_spread195({
  screen: Screens.Player,
  videoid: videoId
}, payload));
var sendPlayerClickSpeed_default = sendPlayerClickSpeed;

// src/shared/model/useMetrics/lib/sendPlayerClickQuality.ts
function _define_property196(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread196(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property196(target, key, source[key]);
    });
  }
  return target;
}
var sendPlayerClickQuality = (metrics, videoId, payload) => metrics.sendEvent(Events2.PlayerClickQuality, _object_spread196({
  screen: Screens.Player,
  videoid: videoId
}, payload));
var sendPlayerClickQuality_default = sendPlayerClickQuality;

// src/shared/model/useMetrics/lib/sendPlayerClickFullscreen.ts
var sendPlayerClickFullscreen = (metrics, videoId, { timing, quartile }) => metrics.sendEvent(Events2.PlayerClickFullscreen, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  quartile
});
var sendPlayerClickFullscreen_default = sendPlayerClickFullscreen;

// src/shared/model/useMetrics/lib/sendPlayerQuartile.ts
var sendPlayerQuartile = (metrics, videoId, { timing, value }) => metrics.sendEvent(Events2.PlayerQuartile, {
  screen: Screens.Player,
  videoid: videoId,
  timing,
  value
});
var sendPlayerQuartile_default = sendPlayerQuartile;

// src/shared/model/useMetrics/shared/provider.tsx
var MetricsProvider = ({ metrics, children }) => {
  const { user } = useSession();
  const [isReady, setIsReady] = useState20(false);
  const context = {
    isReady,
    sendClickDownloadVideo: (0, import_lodash13.curry)(sendClickDownloadVideo_default)(metrics),
    sendClickShareUrl: (0, import_lodash13.curry)(sendClickShareUrl_default)(metrics),
    sendClickSidebarElem: (0, import_lodash13.curry)(sendClickSidebarElem_default)(metrics),
    sendPageView: (0, import_lodash13.curry)(sendPageView_default)(metrics),
    sendPageViewVideo: (0, import_lodash13.curry)(sendPageViewVideo_default)(metrics),
    sendPageViewHistory: (0, import_lodash13.curry)(sendPageViewHistory_default)(metrics),
    sendPageViewChannelAllVideos: (0, import_lodash13.curry)(sendPageViewChannelAllVideos_default)(metrics),
    sendPageViewChannelAllChannels: (0, import_lodash13.curry)(sendPageViewChannelAllChannels_default)(metrics),
    sendPageViewChannelMyChannels: (0, import_lodash13.curry)(sendPageViewChannelMyChannels_default)(metrics),
    sendSelectFilter: (0, import_lodash13.curry)(sendSelectFilter_default)(metrics),
    sendSelectSorting: (0, import_lodash13.curry)(sendSelectSorting_default)(metrics),
    sendPageViewOldSchool: (0, import_lodash13.curry)(sendPageViewOldSchool_default)(metrics),
    sendPlayerClick10Bwd: (0, import_lodash13.curry)(sendPlayerClick10Bwd_default)(metrics),
    sendPlayerClick10Fwd: (0, import_lodash13.curry)(sendPlayerClick10Fwd_default)(metrics),
    sendPlayerClickFullscreen: (0, import_lodash13.curry)(sendPlayerClickFullscreen_default)(metrics),
    sendPlayerClickPause: (0, import_lodash13.curry)(sendPlayerClickPause_default)(metrics),
    sendPlayerClickPlay: (0, import_lodash13.curry)(sendPlayerClickPlay_default)(metrics),
    sendPlayerClickQuality: (0, import_lodash13.curry)(sendPlayerClickQuality_default)(metrics),
    sendPlayerClickSpeed: (0, import_lodash13.curry)(sendPlayerClickSpeed_default)(metrics),
    sendPlayerClickWind: (0, import_lodash13.curry)(sendPlayerClickWind_default)(metrics),
    sendPlayerQuartile: (0, import_lodash13.curry)(sendPlayerQuartile_default)(metrics)
  };
  useEffect22(() => {
    if (!isReady && user) {
      metrics.userId = user === null || user === void 0 ? void 0 : user.id;
      setIsReady(true);
    }
    if (!user) {
      setIsReady(false);
    }
  }, [
    isReady,
    user
  ]);
  return /* @__PURE__ */ _jsx232(context_default.Provider, {
    value: context,
    children
  });
};
var provider_default = /* @__PURE__ */ React118.memo(MetricsProvider);

// src/shared/model/useMetrics/utils/index.ts
var getQuartile = (currentTime, durationTime) => {
  const percent = currentTime / durationTime;
  if (isNaN(percent)) {
    return Quartile.Begin;
  }
  if (percent < QuartilePoints.First) {
    return Quartile.Begin;
  }
  if (percent >= QuartilePoints.First && percent < QuartilePoints.Second) {
    return Quartile.First;
  }
  if (percent >= QuartilePoints.Second && percent < QuartilePoints.Third) {
    return Quartile.Second;
  }
  if (percent >= QuartilePoints.Third && percent < QuartilePoints.Fourth) {
    return Quartile.Third;
  }
  return Quartile.Fourth;
};

// src/shared/model/useMetrics/index.tsx
function _define_property197(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread197(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property197(target, key, source[key]);
    });
  }
  return target;
}
var useMetrics = () => {
  const context = useContext3(context_default);
  return _object_spread197({}, context);
};
var useMetrics_default = useMetrics;

// src/shared/model/useModal/index.tsx
var import_lodash14 = __toESM(require_lodash());
import { jsx as _jsx233 } from "react/jsx-runtime";
import { useCallback as useCallback14, useEffect as useEffect23, useMemo as useMemo14, useState as useState21 } from "react";
function _define_property198(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread198(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property198(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys169(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props169(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys169(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties160(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose160(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose160(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var useModal = (_param) => {
  var { id, children, onClose: _onClose, onOpen: _onOpen, onSubmit: _onSubmit, closeOnSubmit = true } = _param, props = _object_without_properties160(_param, [
    "id",
    "children",
    "onClose",
    "onOpen",
    "onSubmit",
    "closeOnSubmit"
  ]);
  const [isOpen, setIsOpen] = useState21(false);
  const [sharedItem, setSharedItem] = useState21(null);
  const open = useCallback14((sharedItem2) => {
    setIsOpen(true);
    if (sharedItem2) {
      setSharedItem(sharedItem2);
    }
  }, []);
  const close = useCallback14(() => {
    setIsOpen(false);
  }, []);
  const onClose = useCallback14(() => {
    close();
    if (_onClose) {
      _onClose();
    }
  }, [
    _onClose
  ]);
  const onOpen = useCallback14(() => {
    if (_onOpen) {
      _onOpen();
    }
  }, [
    _onOpen
  ]);
  const onSubmit = useCallback14((e) => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (_onSubmit) {
      _onSubmit(sharedItem, close);
    }
    if (closeOnSubmit) {
      onClose();
    }
  }, [
    sharedItem,
    onClose,
    _onSubmit
  ]);
  const modal = useMemo14(() => /* @__PURE__ */ _jsx233(modal_default, _object_spread_props169(_object_spread198({
    open: isOpen
  }, props), {
    children: (0, import_lodash14.isFunction)(children) && children({
      close,
      open,
      onSubmit
    }) || children,
    onClose,
    onSubmit
  })), [
    isOpen,
    children,
    props,
    close,
    onClose
  ]);
  useEffect23(() => {
    if (isOpen) {
      onOpen();
    }
  }, [
    isOpen
  ]);
  return {
    isOpen,
    modal,
    open,
    close,
    onSubmit
  };
};
var useModal_default = useModal;

// src/shared/model/usePortal/index.tsx
import { useCallback as useCallback15, useEffect as useEffect24, useRef as useRef12 } from "react";

// src/shared/model/usePortal/helpers.ts
var createRootElement = (id) => {
  const root = document.createElement("div");
  root.setAttribute("id", id);
  return root;
};
var addRootElement = (root) => {
  document.body.insertBefore(root, document.body.lastElementChild && document.body.lastElementChild.nextElementSibling);
};

// src/shared/model/usePortal/index.tsx
var usePortal = (id, type = "div") => {
  const ref3 = useRef12(null);
  const getRootElem = useCallback15(() => {
    if (!!ref3 && !ref3.current) {
      ref3.current = document.createElement(type);
    }
    return ref3.current;
  }, [
    type,
    ref3
  ]);
  useEffect24(() => {
    const exParentEl = document.querySelector(`#${id}`);
    const parentEl = exParentEl || createRootElement(id);
    if (!exParentEl) {
      addRootElement(parentEl);
    }
    parentEl.appendChild(ref3.current);
    return () => {
      var _ref_current;
      ref3 === null || ref3 === void 0 ? void 0 : (_ref_current = ref3.current) === null || _ref_current === void 0 ? void 0 : _ref_current.remove();
      if (!parentEl.childElementCount) {
        parentEl.remove();
      }
    };
  }, [
    id,
    ref3
  ]);
  return getRootElem();
};
var usePortal_default = usePortal;

// src/shared/model/usePortionView/index.ts
import { useCallback as useCallback16, useState as useState22 } from "react";
var usePortionView = (data, limit = 10) => {
  const [portionCount, setPortionCount] = useState22(1);
  const chunkedData = data && data.slice(0, portionCount * limit) || [];
  const next = useCallback16(() => setPortionCount(portionCount + 1), [
    portionCount
  ]);
  const isNext = useCallback16(() => Array.isArray(data) && data.length > portionCount * limit, [
    data,
    portionCount,
    limit
  ]);
  return {
    data: chunkedData,
    next,
    isNext
  };
};
var usePortionView_default = usePortionView;

// src/shared/model/usePrevious/index.ts
import { useEffect as useEffect25, useRef as useRef13 } from "react";
var usePrevious = (value) => {
  const ref3 = useRef13();
  useEffect25(() => {
    ref3.current = value;
  });
  return ref3.current;
};
var usePrevious_default = usePrevious;

// src/shared/model/useSteps/index.tsx
import { useCallback as useCallback17, useMemo as useMemo15, useState as useState23 } from "react";

// src/shared/model/useSteps/helpers.ts
var getNextStep = (step, steps) => Math.min(steps - 1, step + 1);
var getPrevStep = (step) => Math.max(0, step - 1);
var getIsStepsEnd = (step, steps) => step === steps - 1;
var getIsStepsStart = (step) => step === 0;

// src/shared/model/useSteps/index.tsx
var useSteps = ({ isNonLinear = false, defaultStep = -1, steps, onBackward, onForward, onSubmit: _onSubmit, onSubmitStep: _onSubmitStep, onReset, onError }) => {
  const [activeStep, setActiveStep] = useState23(defaultStep);
  const skippedSteps = useMemo15(() => /* @__PURE__ */ new Set(), []);
  const addSkippedStep = useCallback17((step) => {
    if (skippedSteps.has(step)) {
      return;
    }
    skippedSteps.add(step);
  }, [
    skippedSteps
  ]);
  const deleteSkippedStep = useCallback17((step) => {
    if (skippedSteps.has(step)) {
      skippedSteps.delete(step);
    }
  }, [
    skippedSteps
  ]);
  const onSubmit = useCallback17(() => {
    if (_onSubmit) {
      _onSubmit();
    }
  }, [
    _onSubmit
  ]);
  const onSubmitStep = useCallback17((step) => new Promise((resolve, reject) => {
    if (_onSubmitStep) {
      return _onSubmitStep(step).then(resolve).catch((err) => {
        if (isNonLinear) {
          resolve(null);
          return;
        }
        reject(err);
      });
    }
    if (isNonLinear) {
      resolve(null);
      return;
    }
    reject(new Error("Step can not be skipped"));
    return null;
  }), [
    isNonLinear,
    _onSubmitStep
  ]);
  const back = useCallback17(() => {
    const prevStep = getPrevStep(activeStep);
    const isStepStart = getIsStepsStart(prevStep);
    setActiveStep(prevStep);
    if (isStepStart && onReset) {
      onReset();
      return;
    }
    onBackward(prevStep);
  }, [
    isNonLinear,
    activeStep,
    steps,
    onReset,
    onBackward,
    onError
  ]);
  const next = useCallback17(() => {
    const nextStep = getNextStep(activeStep, steps);
    const isStepEnd = getIsStepsEnd(nextStep, steps);
    onSubmitStep(nextStep).then(() => {
      setActiveStep(nextStep);
      if (isStepEnd) {
        onSubmit();
        return;
      }
      onForward(nextStep);
    }).catch(onError);
  }, [
    isNonLinear,
    activeStep,
    steps,
    onSubmit,
    onSubmitStep,
    onForward,
    onError
  ]);
  return {
    activeStep,
    back,
    next
  };
};
var useSteps_default = useSteps;

// src/shared/model/useUniqueList/index.ts
import { useCallback as useCallback18, useRef as useRef14, useState as useState24 } from "react";
var useUniqueList = (keyExtractor) => {
  const listMap = useRef14(/* @__PURE__ */ new Map());
  const [list, setList] = useState24([]);
  const create6 = useCallback18((items) => {
    listMap.current = /* @__PURE__ */ new Map();
    items.forEach((item) => {
      const key = keyExtractor(item);
      listMap.current.set(key, item);
    });
    const newList = [
      ...listMap.current.values()
    ];
    setList(newList);
  }, [
    listMap.current
  ]);
  const update = useCallback18((items) => {
    items.forEach((item) => {
      const key = keyExtractor(item);
      if (listMap.current.get(key)) {
        listMap.current.delete(key);
        return;
      }
      listMap.current.set(key, item);
    });
    const newList = [
      ...listMap.current.values()
    ];
    setList(newList);
    return newList;
  }, [
    listMap.current
  ]);
  return [
    list,
    {
      create: create6,
      update
    }
  ];
};
var useUniqueList_default = useUniqueList;

// src/shared/model/useWindowDimensions/index.ts
import { useEffect as useEffect26, useState as useState25 } from "react";
function getWindowDimensions() {
  const { innerWidth: width2, innerHeight: height2 } = window;
  return {
    width: width2,
    height: height2
  };
}
function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState25(getWindowDimensions());
  useEffect26(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowDimensions;
}

// src/shared/model/useEnv/index.tsx
import { useContext as useContext4 } from "react";
function _define_property199(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread199(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property199(target, key, source[key]);
    });
  }
  return target;
}
var useEnv = () => {
  const context = useContext4(EnvContext);
  return _object_spread199({}, context);
};
var useEnv_default = useEnv;

// src/shared/utils/clientDetect.ts
import { detect as detect2 } from "detect-browser";
import { compare } from "compare-versions";
var isWinDevice = (ua) => {
  var _detect;
  return /^win/i.test(((_detect = detect2(ua)) === null || _detect === void 0 ? void 0 : _detect.os) || "");
};
var isAppleDevice = (ua) => {
  var _detect;
  return /^(ios|mac)/i.test(((_detect = detect2(ua)) === null || _detect === void 0 ? void 0 : _detect.os) || "");
};
var isAndroidDevice = (ua) => {
  var _detect;
  return /^android/i.test(((_detect = detect2(ua)) === null || _detect === void 0 ? void 0 : _detect.os) || "");
};
var isAllowedBrowser = (ua) => {
  var _detect;
  return /(ios|safari|chrom|yandex)/i.test(((_detect = detect2(ua)) === null || _detect === void 0 ? void 0 : _detect.name) || "");
};
var isDeviceOS = (ua) => {
  var _detect;
  return /(ios|mobile|android|blackberry|amazon)/i.test(((_detect = detect2(ua)) === null || _detect === void 0 ? void 0 : _detect.os) || "");
};
var isSafari = (ua) => {
  var _detect;
  return /(safari)/i.test(((_detect = detect2(ua)) === null || _detect === void 0 ? void 0 : _detect.name) || "");
};
var isAuroraOS = (ua) => /(aurora)/i.test(ua);
var isBrowserVersionSupported = (supportedBrowserVersions) => {
  const browser = detect2();
  const browserName2 = browser === null || browser === void 0 ? void 0 : browser.name;
  if (!(browser === null || browser === void 0 ? void 0 : browser.name) || !supportedBrowserVersions[browserName2])
    return false;
  return compare((browser === null || browser === void 0 ? void 0 : browser.version) || "", supportedBrowserVersions[browserName2] || "", ">=");
};

// src/shared/hooks/useDesktopCompareVersion.ts
import { useEffect as useEffect27, useState as useState26 } from "react";
function asyncGeneratorStep7(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator7(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep7(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep7(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var prepareVersion = (version) => Number(version.split(".").join(""));
var useDesktopCompareVersion = (versionRaw) => {
  const [value, setValue] = useState26(CompareVersion.Default);
  const getVersion = function() {
    var _ref = _async_to_generator7(function* () {
      try {
        var _window_electron, _window;
        const appVersionRaw = yield (_window = window) === null || _window === void 0 ? void 0 : (_window_electron = _window.electron) === null || _window_electron === void 0 ? void 0 : _window_electron.getVersion();
        const appVersion = prepareVersion(appVersionRaw);
        const version = prepareVersion(versionRaw);
        if (appVersion > version)
          setValue(CompareVersion.Above);
        if (appVersion < version)
          setValue(CompareVersion.Less);
        if (appVersion === version)
          setValue(CompareVersion.Equal);
      } catch (error) {
        setValue(CompareVersion.Error);
      }
    });
    return function getVersion2() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect27(() => {
    getVersion();
  }, []);
  return value;
};

// src/shared/hooks/scrollPagination.tsx
import { useCallback as useCallback19, useRef as useRef15, useState as useState27 } from "react";
function asyncGeneratorStep8(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator8(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep8(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep8(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var useScrollPagination = ({ isReady, allPages, request }) => {
  const listRef = useRef15(null);
  const [currentPage, setCurrentPage] = useState27(1);
  const onScroll = useCallback19(() => {
    if (!listRef.current || isReady) {
      return;
    }
    const endScroll = listRef.current.offsetHeight;
    if (listRef.current.scrollHeight - listRef.current.scrollTop - 20 < endScroll) {
      if (currentPage >= allPages) {
        return;
      }
      setTimeout(/* @__PURE__ */ _async_to_generator8(function* () {
        yield setCurrentPage((currentPage2) => currentPage2 + 1);
        request(`${currentPage + 1}`);
      }), 0);
    }
  }, [
    currentPage,
    allPages,
    request
  ]);
  return {
    listRef,
    onScroll,
    page: currentPage,
    setPage: setCurrentPage
  };
};

// src/shared/hooks/useMissedCalls.ts
import { useCallback as useCallback20, useEffect as useEffect28, useState as useState28 } from "react";
function asyncGeneratorStep9(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator9(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep9(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep9(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var useMissedCalls = ({ api, app, socket }) => {
  const [count, setCount] = useState28(0);
  const check = useCallback20(/* @__PURE__ */ _async_to_generator9(function* () {
    try {
      const response = yield api.get("/v1/calls/missed-calls-counter");
      const { missed_calls: missedCallsCount = 0 } = (response === null || response === void 0 ? void 0 : response.data) || response || {};
      setCount(missedCallsCount);
    } catch (e) {
      console.error("can not get missed calls count");
      setCount(0);
    }
  }), []);
  const clear = useCallback20(/* @__PURE__ */ _async_to_generator9(function* () {
    try {
      yield api.delete("/v1/calls/clear-missed-calls-counter");
    } catch (e) {
      console.error("can not request for clear missed calls");
    } finally {
      setCount(0);
    }
  }), []);
  useEffect28(() => {
    if (!api) {
      return;
    }
    const action = app === "calls" ? clear : check;
    action();
  }, []);
  useEffect28(() => {
    const wssMissedCallsCounterChanged = ({ params }) => {
      const { missedCalls: missedCallsCount } = params || {};
      if (Number.isInteger(missedCallsCount)) {
        setCount(missedCallsCount);
      }
    };
    socket.use(/server:notify:missed_calls_counter_changed/, wssMissedCallsCounterChanged);
  }, []);
  return {
    count,
    check,
    clear
  };
};

// src/widgets/drawer/index.tsx
import { jsx as _jsx234, jsxs as _jsxs105 } from "react/jsx-runtime";
import { Stack as Stack6, Typography as Typography6 } from "@mui/material";
import { isElectron as isElectron5 } from "react-device-detect";

// src/widgets/drawer/shared.tsx
import MuiDrawer2 from "@mui/material/Drawer";
import { styled as styled45 } from "@mui/material/styles";
function _define_property200(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread200(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property200(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys170(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props170(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys170(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DRAWER_WIDTH = 340;
var openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: "hidden",
  overflowY: "hidden",
  height: "100%",
  right: 0,
  marginLeft: "16px"
});
var closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: "hidden",
  height: "100%",
  width: 0,
  [theme.breakpoints.up("sm")]: {
    width: 0
  }
});
var DrawerHeader = styled45("div")(() => ({
  display: "flex",
  alignItems: "center",
  height: "66px",
  padding: "0 16px",
  flexShrink: 0
}));
var DrawerBody = styled45("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  overflowY: "hidden"
}));
var DrawerWrapper = styled45(MuiDrawer2, {
  shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => _object_spread200({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box"
}, open && _object_spread_props170(_object_spread200({}, openedMixin(theme)), {
  "& .MuiDrawer-paper": openedMixin(theme)
}), !open && _object_spread_props170(_object_spread200({}, closedMixin(theme)), {
  "& .MuiDrawer-paper": closedMixin(theme)
})));

// src/widgets/drawer/index.tsx
var Drawer2 = ({ isFullScreen, title, open, onClose, renderTitle, children, onShareClick }) => /* @__PURE__ */ _jsxs105(DrawerWrapper, {
  variant: "permanent",
  open,
  anchor: "right",
  PaperProps: {
    style: {
      height: isElectron5 ? "calc(100% - 160px)" : "calc(100% - 128px)",
      background: getCssVar("grey", 950),
      top: isElectron5 ? "96px" : "64px",
      right: "16px",
      borderRadius: "4px",
      border: "none",
      zIndex: 14
    }
  },
  sx: {
    position: isFullScreen ? "absolute" : "static"
  },
  children: [
    /* @__PURE__ */ _jsxs105(DrawerHeader, {
      sx: {
        margin: "13px 16px 32px 16px",
        padding: 0,
        maxHeight: "28px"
      },
      children: [
        /* @__PURE__ */ _jsx234("div", {
          style: {
            flexGrow: 1
          },
          children: renderTitle ? renderTitle() : /* @__PURE__ */ _jsx234(Typography6, {
            variant: "body2",
            children: /* @__PURE__ */ _jsx234("span", {
              children: title
            })
          })
        }),
        /* @__PURE__ */ _jsxs105(Stack6, {
          direction: "row",
          spacing: 0.5,
          children: [
            onShareClick && /* @__PURE__ */ _jsx234(tooltip_default, {
              title: Translate_default.get("event.chatBox.copylink"),
              placement: "bottom",
              arrow: true,
              children: /* @__PURE__ */ _jsx234("div", {
                children: /* @__PURE__ */ _jsx234(icon_button_wrapper_default, {
                  id: "action-copy-link",
                  className: "light",
                  onClick: onShareClick,
                  children: /* @__PURE__ */ _jsx234(DrawerShare_default, {})
                })
              })
            }),
            /* @__PURE__ */ _jsx234(icon_button_wrapper_default, {
              onClick: onClose,
              id: "btn-MuiDrawer-close",
              children: /* @__PURE__ */ _jsx234(Close_default, {})
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ _jsx234(DrawerBody, {
      children: open && children
    })
  ]
});
var drawer_default2 = Drawer2;

// src/widgets/forms/auth/sign-up-confirm/index.tsx
import { jsx as _jsx242, jsxs as _jsxs108, Fragment as _Fragment9 } from "react/jsx-runtime";
import React124, { useEffect as useEffect31 } from "react";

// src/widgets/forms/shared/model/provider.tsx
import { jsx as _jsx235 } from "react/jsx-runtime";
import React119 from "react";
import { Formik } from "formik";
function _define_property201(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread201(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property201(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys171(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props171(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys171(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties161(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose161(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose161(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var FormProvider = (_param) => {
  var { children } = _param, props = _object_without_properties161(_param, [
    "children"
  ]);
  return /* @__PURE__ */ _jsx235(Formik, _object_spread_props171(_object_spread201({}, props), {
    children
  }));
};
var provider_default2 = /* @__PURE__ */ React119.memo(FormProvider);

// src/widgets/forms/shared/ui/index.tsx
import { Form as FormikForm } from "formik";
import styled49 from "styled-components";

// src/widgets/forms/shared/ui/field.tsx
import { jsx as _jsx236 } from "react/jsx-runtime";
import React120 from "react";
import { Field as FormikField } from "formik";
import { TextField as TextField2 } from "formik-mui";
import styled46 from "styled-components";
function _define_property202(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread202(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property202(target, key, source[key]);
    });
  }
  return target;
}
var StyledTextField2 = styled46(TextField2)`
  position: relative;
  display: flex;
  margin: 1.6rem 0 0;

  & > div {
    padding: 0;
    background: ${getCssVar("grey", 900)};
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    transition: all var(--smooth-transition);

    &[class*=error] {
      border-color: ${getCssVar("red", 300)};
    }

    &:before, &:after {
      display: none;
    }

    &:hover, &[class*=focused] {
      background: ${getCssVar("grey", 900)};
    }
  }

  [type='text'],
  [type='email'],
  [type='password'],
  [type='search'],
  input, textarea {
    padding: 0 1.2rem;
    height: 3.8rem;
    background: ${getCssVar("grey", 900)};
    font-family: var(--font-family);
    font-size: ${getCssVar("font", "large")};
    font-weight: ${getCssVar("font", "semi-bold")};
    line-height: ${getCssVar("font", "line-height")};
    border: 0 solid transparent;
    border-radius: 0;
    outline: none;

    &::placeholder {
      color: ${getCssVar("grey", 500)};
    }

    &:-webkit-autofill,
    &:-internal-autofill-selected {
      background-color: transparent !important;
      box-shadow: 0 0 0 0;
      -webkit-text-fill-color: fieldtext !important;
      caret-color: currentColor;
    }

    & + div {
      padding: 0 1.6rem;
    }
  }

  textarea {
    padding: .8rem 1.2rem;
  }

  label {
    position: relative;
    margin-bottom: .8rem;
    font-size: ${getCssVar("font", "common")};
    font-weight: ${getCssVar("font", "semi-bold")};
    color: ${getCssVar("grey", 100)};
    line-height: 1;
    overflow: initial;
    transform: scale(1);
    transition: none;

    &[class*=focused],
    &[class*=error] {
      color: ${getCssVar("grey", 100)};
    }

    & > span {
      display: none;
    }
  }

  p {
    position: absolute;
    bottom: -2rem;
    margin: 0;
  }
`;
var Field = (props) => /* @__PURE__ */ _jsx236(FormikField, _object_spread202({
  variant: "filled",
  component: StyledTextField2
}, props));
var field_default = /* @__PURE__ */ React120.memo(Field);

// src/widgets/forms/shared/ui/icon-validity.tsx
import { jsx as _jsx237 } from "react/jsx-runtime";
function _define_property203(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread203(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property203(target, key, source[key]);
    });
  }
  return target;
}
var IconValidity = ({ isValid }) => {
  const props = {
    width: 14,
    height: 14
  };
  if (isValid) {
    props.fill = getCssVar("green", 500);
  }
  return /* @__PURE__ */ _jsx237(CheckRound_default, _object_spread203({}, props));
};
var icon_validity_default = IconValidity;

// src/widgets/forms/shared/ui/new-pin.tsx
import { jsx as _jsx238, Fragment as _Fragment7 } from "react/jsx-runtime";
import { useCallback as useCallback21, useEffect as useEffect29, useMemo as useMemo16, useState as useState29 } from "react";
var NewPin = ({ timeout = 2 * 60 * 1e3, children, variant = "contained", pinRequestedHandler, request }) => {
  const [timestamp, setTimestamp] = useState29(0);
  const onClick = useCallback21(() => {
    setTimestamp(+/* @__PURE__ */ new Date());
    pinRequestedHandler && pinRequestedHandler(true);
    request();
  }, []);
  const content = useMemo16(() => {
    if (children) {
      return children;
    }
    return /* @__PURE__ */ _jsx238(button_default, {
      fullWidth: true,
      id: "get-new-pin-button",
      variant,
      color: "secondary",
      disabled: !!timestamp,
      onClick,
      children: Translate_default.get("buttons.requestPinAgain")
    });
  }, [
    timestamp,
    children
  ]);
  useEffect29(() => {
    if (!timestamp) {
      return;
    }
    setTimeout(() => {
      setTimestamp(0);
      pinRequestedHandler && pinRequestedHandler(false);
    }, timeout);
  }, [
    timestamp,
    timeout
  ]);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ _jsx238(_Fragment7, {
      children: content
    })
  );
};
var new_pin_default = NewPin;

// src/widgets/forms/shared/ui/password-requirements.tsx
import { jsx as _jsx240, jsxs as _jsxs107 } from "react/jsx-runtime";
import React122, { useEffect as useEffect30, useMemo as useMemo17 } from "react";
import styled47 from "styled-components";

// src/widgets/forms/shared/constants.tsx
import { jsx as _jsx239, jsxs as _jsxs106, Fragment as _Fragment8 } from "react/jsx-runtime";
var PASSWORD_REQUIREMENTS = [];
PASSWORD_REQUIREMENTS = [
  {
    text: () => Translate_default.get("password-requirements.between8and20"),
    validate: (s) => (s === null || s === void 0 ? void 0 : s.length) > 7 && (s === null || s === void 0 ? void 0 : s.length) < 21
  },
  {
    text: () => Translate_default.get("password-requirements.minOneCapitalAndLowercase"),
    validate: (s) => /(?=.*[a-z])(?=.*[A-Z])/.test(s)
  },
  {
    text: () => Translate_default.get("password-requirements.minOneDigit"),
    validate: (s) => /(?=.*\d)/.test(s)
  },
  {
    text: () => Translate_default.get("password-requirements.noSpaces"),
    validate: (s) => !/ /.test(s)
  },
  {
    text: () => /* @__PURE__ */ _jsxs106(_Fragment8, {
      children: [
        Translate_default.get("password-requirements.special"),
        /* @__PURE__ */ _jsx239("br", {}),
        /* @__PURE__ */ _jsx239("span", {
          style: {
            letterSpacing: 2
          },
          children: `~!?@#$%^&*-_+()[]{}></\\|"'.,:;`
        })
      ]
    }),
    validate: (s) => /[-_~!^()[\]&%$#@?.*+,:;'"\\/|><{}&]/.test(s) && !/=/.test(s)
  }
];

// src/widgets/forms/shared/ui/password-requirements.tsx
function _define_property204(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread204(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property204(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys172(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props172(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys172(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties162(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose162(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose162(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var StyledDiv = styled47.div`
  margin-right: 0.8rem;
`;
var StyledStack2 = styled47(stack_default)`
  background: ${getCssVar("grey", 950)};
  position: absolute;
  border-radius: 0.375rem;
  top: 100%;
  padding: 1.6rem 0 2rem!important ;
  z-index: 10;
  margin-top: 0.8rem;
`;
var PasswordRequirements = (_param) => {
  var { isOpen = false, password, setPasswordValid } = _param, args = _object_without_properties162(_param, [
    "isOpen",
    "password",
    "setPasswordValid"
  ]);
  const requirements = useMemo17(() => PASSWORD_REQUIREMENTS.map(({ text, validate: validate2 }, i) => /* @__PURE__ */ _jsxs107(stack_default, {
    flexDirection: "row",
    alignItems: "center",
    padding: "0 0.8rem",
    children: [
      /* @__PURE__ */ _jsx240(StyledDiv, {
        children: /* @__PURE__ */ _jsx240(icon_validity_default, {
          isValid: validate2(password)
        })
      }),
      /* @__PURE__ */ _jsx240(typography_default, {
        variant: "caption",
        color: getCssVar("grey", 500),
        children: text()
      })
    ]
  }, `rq-${i}`)), [
    password
  ]);
  const validate = (s) => {
    if (setPasswordValid) {
      setPasswordValid(PASSWORD_REQUIREMENTS.every((r2) => r2.validate(s)));
    }
  };
  useEffect30(() => {
    validate(password);
  }, [
    password
  ]);
  if (!isOpen) {
    return null;
  }
  return /* @__PURE__ */ _jsxs107(StyledStack2, _object_spread_props172(_object_spread204({
    tabIndex: -1,
    spacing: 1
  }, args), {
    children: [
      requirements,
      /* @__PURE__ */ _jsxs107(stack_default, {
        padding: "0.8rem 0.8rem 0",
        borderTop: `1px solid ${getCssVar("grey", 700)}`,
        flexDirection: "row",
        alignItems: "center",
        children: [
          /* @__PURE__ */ _jsx240(StyledDiv, {
            children: /* @__PURE__ */ _jsx240(Info_default, {
              width: 12,
              height: 12,
              fill: getCssVar("yellow", 300)
            })
          }),
          /* @__PURE__ */ _jsx240(typography_default, {
            variant: "caption",
            color: `${getCssVar("yellow", 300)}!important`,
            children: Translate_default.get("password-requirements.info")
          })
        ]
      })
    ]
  }));
};
var password_requirements_default = /* @__PURE__ */ React122.memo(PasswordRequirements);

// src/widgets/forms/shared/ui/select.tsx
import { jsx as _jsx241 } from "react/jsx-runtime";
import React123 from "react";
import { Field as FormikField2 } from "formik";
import { Select as Select2 } from "formik-mui";
import styled48 from "styled-components";
function _define_property205(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread205(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property205(target, key, source[key]);
    });
  }
  return target;
}
var StyledSelect = styled48(Select2)`

  margin: 1.6rem 0 0;
  padding: 0;
  background: transparent;
  border-radius: 0;

  &[class*=error] {
    border-color: ${getCssVar("red", 300)};
  }

  &[class*=focused], &:hover {
    background: transparent;
  }

  &:before {
    content: ${({ placeholder = "" }) => `'${placeholder}'`};
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0 1.2rem;
    border: 0 solid transparent !important;
    transform: none;
  }

  &:after {
    display: none;
  }

  div, [class*=select] {
    display: flex;
    align-items: center;
    padding: 0 1.2rem;
    height: 3.8rem;
    background: ${getCssVar("grey", 900)};
    font-family: var(--font-family);
    font-size: ${getCssVar("font", "large")};
    font-weight: ${getCssVar("font", "esmi-bold")};
    line-height: ${getCssVar("font", "line-height")};
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    transition: all var(--smooth-transition);
    z-index: 1;
  }

  i, [class*=icon] {
    top: 50%;
    right: 1.6rem;
    z-index: 2;
    transform: translateY(-50%); // workaround for compatibility
    transition: all .27s;

    &[class*=iconOpen] {
      transform: translateY(-50%) rotate(180deg);
    }
  }
`;
var FieldSelect = (props) => /* @__PURE__ */ _jsx241(FormikField2, _object_spread205({
  variant: "filled",
  component: StyledSelect,
  IconComponent: ChevronDown_default
}, props));
var select_default = /* @__PURE__ */ React123.memo(FieldSelect);

// src/widgets/forms/shared/ui/index.tsx
var FormWrapper = styled49.div`
  display: flex;
  flex-direction: column;
  padding: 0 .8rem;
  width: 100%;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${breakpoints_default.md}px) {
    min-height: 460px;
    min-width: 340px;
    max-width: 355px;
    padding: 2.4rem;
    line-height: ${getCssVar("font", "line-height")};
    font-size: ${getCssVar("font", "common")};
    border: 1px solid ${getCssVar("grey", 950)};
    border-radius: 4px;
  }
`;
var FormSection = styled49.section`
  margin-top: 2.4rem;
`;
var FormComponent = getFormComponent(FormikForm);

// src/widgets/forms/auth/sign-up-confirm/index.tsx
var RegisterConfirmForm = ({ initialValues: initialValues2, timeout, sessionKey, email, validateOnBlur, validationSchema, dataPin, requestPin, onSubmit, onExit }) => {
  useEffect31(() => {
    if (!email && !sessionKey) {
      onExit();
    }
  }, [
    email,
    sessionKey
  ]);
  return /* @__PURE__ */ _jsx242(FormWrapper, {
    className: "flex justify-self-start",
    children: /* @__PURE__ */ _jsx242(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validateOnBlur,
      validationSchema,
      onSubmit,
      children: ({ dirty, isValid }) => /* @__PURE__ */ _jsxs108(_Fragment9, {
        children: [
          /* @__PURE__ */ _jsxs108(typography_default, {
            variant: "h5",
            align: "center",
            children: [
              "На почту",
              " ",
              /* @__PURE__ */ _jsx242("span", {
                style: {
                  wordBreak: "break-word"
                },
                children: email
              }),
              " ",
              "отправлено письмо с кодом подтверждения"
            ]
          }),
          /* @__PURE__ */ _jsx242("div", {
            className: "mt-14"
          }),
          /* @__PURE__ */ _jsxs108(FormSection, {
            children: [
              /* @__PURE__ */ _jsx242(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                label: "ПИН",
                id: "pin",
                name: "pin",
                type: "text",
                placeholder: "****",
                "data-pin": dataPin
              }),
              /* @__PURE__ */ _jsx242("div", {
                className: "mt-5"
              }),
              /* @__PURE__ */ _jsx242(typography_default, {
                variant: "caption",
                color: "#898e96",
                children: "Пин-код может приходить с задержкой - это зависит от производительности почтовой системы Вашей компании."
              })
            ]
          }),
          /* @__PURE__ */ _jsx242("div", {
            className: "mt-auto"
          }),
          /* @__PURE__ */ _jsx242(button_default, {
            fullWidth: true,
            id: "reset-confirm-button",
            type: "submit",
            color: "primary",
            variant: "contained",
            disabled: !(dirty && isValid),
            children: "Продолжить"
          }),
          /* @__PURE__ */ _jsx242("div", {
            className: "mt-2"
          }),
          /* @__PURE__ */ _jsx242(new_pin_default, {
            timeout,
            request: requestPin
          })
        ]
      })
    })
  });
};
var sign_up_confirm_default = /* @__PURE__ */ React124.memo(RegisterConfirmForm);

// src/widgets/forms/auth/reset-password/index.tsx
import { jsx as _jsx243, jsxs as _jsxs109, Fragment as _Fragment10 } from "react/jsx-runtime";
import React125 from "react";
var ResetPasswordForm = ({ initialValues: initialValues2, linkComponent: LinkComponent2, validateOnBlur, validationSchema, onSubmit }) => /* @__PURE__ */ _jsx243(FormWrapper, {
  children: /* @__PURE__ */ _jsx243(form_default, {
    initialValues: initialValues2,
    formProvider: provider_default2,
    formComponent: FormComponent,
    validateOnBlur,
    validationSchema,
    onSubmit,
    children: ({ values: values2 }) => /* @__PURE__ */ _jsxs109(_Fragment10, {
      children: [
        /* @__PURE__ */ _jsx243(typography_default, {
          variant: "h5",
          align: "center",
          children: "Сбросить пароль"
        }),
        /* @__PURE__ */ _jsx243("div", {
          className: "mt-14"
        }),
        /* @__PURE__ */ _jsx243(FormSection, {
          children: /* @__PURE__ */ _jsx243(field_default, {
            autoFocus: true,
            required: true,
            fullWidth: true,
            id: "email",
            label: "Корпоративная почта",
            name: "email",
            type: "email",
            placeholder: "example@company.ru"
          })
        }),
        /* @__PURE__ */ _jsx243("div", {
          className: "mt-auto"
        }),
        /* @__PURE__ */ _jsx243(button_default, {
          fullWidth: true,
          id: "reset-password-button",
          type: "submit",
          color: "primary",
          variant: "contained",
          disabled: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values2.email),
          sx: {
            marginTop: "32px"
          },
          children: "Получить ПИН-код"
        })
      ]
    })
  })
});
var reset_password_default = /* @__PURE__ */ React125.memo(ResetPasswordForm);

// src/widgets/forms/auth/reset-password-confirm/index.tsx
import { jsx as _jsx244, jsxs as _jsxs110, Fragment as _Fragment11 } from "react/jsx-runtime";
import React126, { useEffect as useEffect32, useState as useState30 } from "react";
var ResetPasswordConfirmForm = ({ initialValues: initialValues2, timeout = 2 * 60 * 1e3, sessionKey, email, validateOnBlur, validationSchema, dataPin, requestPin, onSubmit, onExit }) => {
  const [isPasswordFocused, setIsPasswordFocused] = useState30(false);
  const [isPasswordValid, setIsPasswordValid] = useState30(false);
  useEffect32(() => {
    if (!email && !sessionKey) {
      onExit();
    }
  }, [
    email,
    sessionKey
  ]);
  return /* @__PURE__ */ _jsx244(FormWrapper, {
    children: /* @__PURE__ */ _jsx244(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validateOnBlur,
      validationSchema,
      onSubmit,
      children: ({ dirty, isValid, values: values2, handleBlur }) => /* @__PURE__ */ _jsxs110(_Fragment11, {
        children: [
          /* @__PURE__ */ _jsxs110(typography_default, {
            variant: "h5",
            align: "center",
            children: [
              "На почту",
              " ",
              /* @__PURE__ */ _jsx244("span", {
                style: {
                  wordBreak: "break-word"
                },
                children: email
              }),
              " ",
              "отправлено письмо с кодом подтверждения"
            ]
          }),
          /* @__PURE__ */ _jsx244("div", {
            className: "mt-14"
          }),
          /* @__PURE__ */ _jsxs110(FormSection, {
            children: [
              /* @__PURE__ */ _jsx244(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                label: "ПИН",
                id: "pin",
                name: "pin",
                type: "text",
                placeholder: "****",
                "data-pin": dataPin
              }),
              /* @__PURE__ */ _jsx244("div", {
                className: "mt-5"
              }),
              /* @__PURE__ */ _jsx244(typography_default, {
                variant: "caption",
                color: "#898e96",
                children: "Пин-код может приходить с задержкой - это зависит от производительности почтовой системы Вашей компании."
              })
            ]
          }),
          /* @__PURE__ */ _jsx244(stack_default, {
            spacing: 1,
            position: "relative",
            children: /* @__PURE__ */ _jsxs110(FormSection, {
              children: [
                /* @__PURE__ */ _jsx244(field_default, {
                  required: true,
                  fullWidth: true,
                  id: "password",
                  label: "Новый пароль",
                  name: "password",
                  type: "password",
                  placeholder: "Введите пароль",
                  autoComplete: "new-password",
                  onFocus: () => setIsPasswordFocused(true),
                  onBlur: (e) => {
                    setIsPasswordFocused(false);
                    handleBlur(e);
                  }
                }),
                /* @__PURE__ */ _jsx244(password_requirements_default, {
                  isOpen: isPasswordFocused,
                  password: values2.password,
                  setPasswordValid: setIsPasswordValid
                })
              ]
            })
          }),
          /* @__PURE__ */ _jsx244(stack_default, {
            spacing: 1,
            position: "relative",
            children: /* @__PURE__ */ _jsx244(FormSection, {
              children: /* @__PURE__ */ _jsx244(field_default, {
                required: true,
                fullWidth: true,
                id: "password_confirm",
                label: "Подтвердите пароль",
                name: "password_confirm",
                type: "password",
                placeholder: "Подтвердите пароль",
                autoComplete: "new-password"
              })
            })
          }),
          /* @__PURE__ */ _jsx244("div", {
            className: "mt-8"
          }),
          /* @__PURE__ */ _jsx244(button_default, {
            fullWidth: true,
            id: "reset-confirm-button",
            type: "submit",
            color: "primary",
            variant: "contained",
            disabled: !(dirty && isValid),
            children: "Сменить пароль"
          }),
          /* @__PURE__ */ _jsx244("div", {
            className: "mt-2"
          }),
          /* @__PURE__ */ _jsx244(new_pin_default, {
            timeout,
            request: requestPin
          })
        ]
      })
    })
  });
};
var reset_password_confirm_default = /* @__PURE__ */ React126.memo(ResetPasswordConfirmForm);

// src/widgets/forms/auth/sign-in/index.tsx
import { jsx as _jsx246, jsxs as _jsxs111, Fragment as _Fragment12 } from "react/jsx-runtime";
import React127, { useState as useState31 } from "react";
import { useMediaQuery as useMediaQuery3 } from "@mui/material";

// src/widgets/forms/shared/ui/buttons.tsx
import { jsx as _jsx245 } from "react/jsx-runtime";
import { ButtonBase as ButtonBase2 } from "@mui/material";
function _define_property206(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread206(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property206(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys173(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props173(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys173(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties163(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose163(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose163(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var IconButtonWrapper3 = (_param) => {
  var { sx, children } = _param, props = _object_without_properties163(_param, [
    "sx",
    "children"
  ]);
  return /* @__PURE__ */ _jsx245(ButtonBase2, _object_spread_props173(_object_spread206({
    disableRipple: true,
    sx: _object_spread_props173(_object_spread206({}, sx), {
      width: "32px",
      height: "32px",
      display: "grid",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        opacity: "0.8"
      },
      "&:disabled": {
        opacity: "0.5"
      }
    })
  }, props), {
    children
  }));
};

// src/widgets/forms/auth/sign-in/index.tsx
var SignInForm = ({ initialValues: initialValues2, signUpHref, resetHref, linkComponent: LinkComponent2, validationSchema, validateOnBlur, onSubmit }) => {
  const isDesktop = useMediaQuery3(`(min-width: ${breakpoints_default.md}px)`);
  const isMobile = useMediaQuery3(`(max-width: ${breakpoints_default.md}px)`);
  const [passwordVisible, setPasswordVisible] = useState31(false);
  return /* @__PURE__ */ _jsx246(FormWrapper, {
    children: /* @__PURE__ */ _jsx246(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validationSchema,
      validateOnBlur,
      onSubmit,
      children: ({ dirty, isValid, values: values2 }) => /* @__PURE__ */ _jsxs111(_Fragment12, {
        children: [
          isMobile && /* @__PURE__ */ _jsx246("div", {
            className: "mb-2",
            children: /* @__PURE__ */ _jsx246(typography_default, {
              variant: "h5",
              align: "center",
              children: "Вход"
            })
          }),
          /* @__PURE__ */ _jsx246("div", {
            className: "flex justify-center",
            children: /* @__PURE__ */ _jsx246(typography_default, {
              variant: isDesktop ? "h5" : "body2",
              align: "center",
              maxWidth: 290,
              children: "Для просмотра записи, пожалуйста, авторизуйтесь"
            })
          }),
          isDesktop && /* @__PURE__ */ _jsx246("div", {
            className: "mt-14"
          }),
          isMobile && /* @__PURE__ */ _jsx246("div", {
            className: "mt-24"
          }),
          /* @__PURE__ */ _jsx246(FormSection, {
            children: /* @__PURE__ */ _jsx246(field_default, {
              autoFocus: true,
              required: true,
              fullWidth: true,
              id: "email",
              label: "Корпоративная почта",
              name: "email",
              type: "email",
              placeholder: "example@company.ru"
            })
          }),
          /* @__PURE__ */ _jsx246(FormSection, {
            children: /* @__PURE__ */ _jsxs111("div", {
              className: "relative",
              children: [
                /* @__PURE__ */ _jsx246(field_default, {
                  required: true,
                  fullWidth: true,
                  id: "password",
                  label: "Пароль",
                  name: "password",
                  type: passwordVisible ? "text" : "password",
                  placeholder: "Введите пароль",
                  autoComplete: "off"
                }),
                /* @__PURE__ */ _jsx246(IconButtonWrapper3, {
                  sx: {
                    position: "absolute",
                    right: 8,
                    top: 26
                  },
                  onClick: () => setPasswordVisible(!passwordVisible),
                  tabIndex: -1,
                  children: passwordVisible ? /* @__PURE__ */ _jsx246(EyeOpen_default, {}) : /* @__PURE__ */ _jsx246(EyeClose_default, {})
                })
              ]
            })
          }),
          /* @__PURE__ */ _jsx246("div", {
            className: "mt-3 text-right",
            children: /* @__PURE__ */ _jsx246(link_default, {
              color: "secondary",
              to: resetHref,
              component: LinkComponent2,
              children: "Сбросить пароль"
            })
          }),
          isDesktop && /* @__PURE__ */ _jsx246("div", {
            className: "mt-20"
          }),
          isMobile && /* @__PURE__ */ _jsx246("div", {
            className: "mt-10"
          }),
          /* @__PURE__ */ _jsx246(button_default, {
            fullWidth: true,
            id: "login-button",
            color: "primary",
            variant: "contained",
            type: "submit",
            disabled: !(dirty && isValid),
            children: "Войти"
          }),
          /* @__PURE__ */ _jsx246("div", {
            className: "mt-2"
          }),
          /* @__PURE__ */ _jsx246(button_default, {
            fullWidth: true,
            id: "go-to-register-link",
            variant: "text",
            color: "secondary",
            component: LinkComponent2,
            to: signUpHref,
            children: "Зарегистрироваться"
          })
        ]
      })
    })
  });
};
var sign_in_default = /* @__PURE__ */ React127.memo(SignInForm);

// src/widgets/forms/auth/sign-up/index.tsx
import { jsx as _jsx247, jsxs as _jsxs112, Fragment as _Fragment13 } from "react/jsx-runtime";
import React128, { useEffect as useEffect33, useState as useState32 } from "react";
import { useMediaQuery as useMediaQuery4 } from "@mui/material";
var SignUpForm = ({ initialValues: initialValues2, linkComponent: LinkComponent2, iconCaptchaComponent: IconCaptchaComponent, validationSchema, validateOnBlur, onSubmit, getCaptcha }) => {
  const [isPasswordFocused, setIsPasswordFocused] = useState32(false);
  const [captcha, setCaptcha] = useState32(null);
  const isDesktop = useMediaQuery4(`(min-width: ${breakpoints_default.md}px)`);
  const isMobile = useMediaQuery4(`(max-width: ${breakpoints_default.md}px)`);
  useEffect33(() => {
    getCaptcha().then(setCaptcha);
  }, []);
  return /* @__PURE__ */ _jsx247(FormWrapper, {
    children: /* @__PURE__ */ _jsx247(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validationSchema,
      validateOnBlur,
      onSubmit,
      children: ({ dirty, isValid, values: values2, handleBlur }) => /* @__PURE__ */ _jsxs112(_Fragment13, {
        children: [
          isMobile && /* @__PURE__ */ _jsx247("div", {
            className: "mb-2",
            children: /* @__PURE__ */ _jsx247(typography_default, {
              variant: "h5",
              align: "center",
              children: "Регистрация"
            })
          }),
          /* @__PURE__ */ _jsx247(stack_default, {
            position: "relative",
            spacing: 1,
            children: /* @__PURE__ */ _jsx247(FormSection, {
              children: /* @__PURE__ */ _jsx247(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                id: "name",
                label: "Имя Фамилия",
                name: "name",
                type: "text",
                placeholder: "Имя Фамилия"
              })
            })
          }),
          /* @__PURE__ */ _jsx247(stack_default, {
            spacing: 1,
            position: "relative",
            children: /* @__PURE__ */ _jsx247(FormSection, {
              children: /* @__PURE__ */ _jsx247(field_default, {
                required: true,
                fullWidth: true,
                id: "email",
                label: "Корпоративная почта",
                name: "email",
                type: "email",
                placeholder: "example@company.ru"
              })
            })
          }),
          /* @__PURE__ */ _jsx247(stack_default, {
            spacing: 1,
            position: "relative",
            children: /* @__PURE__ */ _jsxs112(FormSection, {
              children: [
                /* @__PURE__ */ _jsx247(field_default, {
                  required: true,
                  fullWidth: true,
                  id: "password",
                  label: "Пароль",
                  name: "password",
                  type: "password",
                  placeholder: "Введите пароль",
                  autoComplete: "off",
                  onFocus: () => setIsPasswordFocused(true),
                  onBlur: (e) => {
                    setIsPasswordFocused(false);
                    handleBlur(e);
                  }
                }),
                /* @__PURE__ */ _jsx247(password_requirements_default, {
                  isOpen: isPasswordFocused,
                  password: values2.password
                })
              ]
            })
          }),
          /* @__PURE__ */ _jsx247(stack_default, {
            spacing: 1,
            position: "relative",
            children: /* @__PURE__ */ _jsx247(FormSection, {
              children: /* @__PURE__ */ _jsx247(field_default, {
                required: true,
                fullWidth: true,
                id: "password2",
                label: "Повторите пароль",
                name: "password2",
                type: "password",
                placeholder: "Повторите пароль"
              })
            })
          }),
          (captcha === null || captcha === void 0 ? void 0 : captcha.code) && /* @__PURE__ */ _jsxs112(FormSection, {
            children: [
              /* @__PURE__ */ _jsx247(field_default, {
                required: true,
                id: "captcha_answer",
                label: "Введите код с картинки",
                name: "captcha_answer"
              }),
              /* @__PURE__ */ _jsxs112("div", {
                className: "flex items-center",
                children: [
                  /* @__PURE__ */ _jsx247("div", {
                    children: /* @__PURE__ */ _jsx247("img", {
                      alt: "",
                      className: "w-52 mx-auto mt-4",
                      id: "captcha-image",
                      src: captcha === null || captcha === void 0 ? void 0 : captcha.code,
                      "data-captcha": captcha === null || captcha === void 0 ? void 0 : captcha.answer
                    })
                  }),
                  /* @__PURE__ */ _jsx247("div", {
                    className: "mt-5",
                    children: /* @__PURE__ */ _jsx247(IconButton_default, {
                      // onClick={(): unknown => dispatch(getCaptchaAction())}
                      id: "Reload captcha",
                      "aria-label": "Reload captcha",
                      className: "mt-2",
                      color: "primary",
                      children: /* @__PURE__ */ _jsx247(IconCaptchaComponent, {})
                    })
                  })
                ]
              })
            ]
          }),
          isDesktop && /* @__PURE__ */ _jsx247("div", {
            className: "mt-16"
          }),
          /* @__PURE__ */ _jsxs112("div", {
            className: "flex",
            children: [
              /* @__PURE__ */ _jsx247("div", {
                children: /* @__PURE__ */ _jsx247(field_default, {
                  required: true,
                  id: "agreement",
                  name: "agreement",
                  type: "checkbox",
                  style: {
                    cursor: "pointer",
                    height: 20,
                    width: 20,
                    marginTop: 0
                  }
                })
              }),
              /* @__PURE__ */ _jsxs112(typography_default, {
                variant: "caption",
                sx: {
                  ml: "8px"
                },
                children: [
                  "Я принимаю условия",
                  " ",
                  /* @__PURE__ */ _jsx247(link_default, {
                    id: "go-to-user-agreement",
                    href: "https://dion.vc/agreement",
                    target: "_blank",
                    rel: "noreferrer",
                    component: LinkComponent2,
                    children: "Пользовательского соглашения"
                  }),
                  " ",
                  "и даю свое согласие на обработку моей персональной информации на условиях, определенных",
                  " ",
                  /* @__PURE__ */ _jsx247(link_default, {
                    id: "go-to-policy",
                    href: "https://dion.vc/policy",
                    target: "_blank",
                    rel: "noreferrer",
                    component: LinkComponent2,
                    children: "Политикой конфиденциальности"
                  })
                ]
              })
            ]
          }),
          isDesktop && /* @__PURE__ */ _jsx247("div", {
            className: "mt-3"
          }),
          isMobile && /* @__PURE__ */ _jsx247("div", {
            className: "mt-10"
          }),
          /* @__PURE__ */ _jsx247(button_default, {
            fullWidth: true,
            id: "register-button",
            type: "submit",
            variant: "contained",
            color: "primary",
            disabled: !(dirty && isValid),
            children: "Зарегистрироваться"
          })
        ]
      })
    })
  });
};
var sign_up_default = /* @__PURE__ */ React128.memo(SignUpForm);

// src/widgets/forms/auth/sign-up/shared/constants.ts
var NAME_REGEX_LETTERS = /^[[a-zа-яё\s-]+$/i;
var NAME_REGEX_WORDS_NUM = /^[a-zа-яё]+\s[a-zа-яё]+(?:-+[a-zа-яё]+)?$/i;
var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// src/widgets/layouts/book/index.tsx
import { jsx as _jsx249, jsxs as _jsxs113 } from "react/jsx-runtime";
import React130 from "react";
import { useMediaQuery as useMediaQuery5, Stack as Stack7 } from "@mui/material";

// src/widgets/layouts/shared/ui.ts
import styled50 from "styled-components";
var LayoutWrapper = styled50.div`
  display: flex;
  padding: 1.6rem;
  overflow: hidden;

  @media screen and (min-width: ${breakpoints_default.md}px) {
    margin: 0;
    height: calc(100vh - 7.2rem);
  }

  @media screen and (max-width: ${breakpoints_default.desktop}px) and (orientation: landscape) {
    margin: 7.2rem 0 0;
    height: auto;
  }
`;
var MainLayoutWrapper = styled50.div`
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  padding: 1.6rem 2.4rem;
`;
var ScreenLayoutWrapper = styled50.div`
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  /* max-width: 1200px; */
  min-height: 100%;
  margin: 0 0 7.2rem;
  padding: .8rem 2.4rem;

  @media screen and (min-width: ${breakpoints_default.desktop}px) {
    margin: 0 0 0 7.2rem;
    padding: 0 3.6rem;
  }
`;
var ScreenLayoutContent = styled50.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  /* max-width: ${breakpoints_default.desktop}px; */
`;

// src/widgets/layouts/book/shared/ui/Logo.tsx
import { jsx as _jsx248 } from "react/jsx-runtime";
import React129 from "react";

// src/widgets/layouts/book/shared/ui/constants.ts
var getLogoStyles = (isDesktop) => ({
  alignItems: "center",
  justifyContent: isDesktop ? "center" : "initial",
  width: "100%",
  height: "100%"
});

// src/widgets/layouts/book/shared/ui/Logo.tsx
function _define_property207(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread207(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property207(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys174(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props174(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys174(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Logo2 = ({ isDesktop = false }) => /* @__PURE__ */ _jsx248(stack_default, {
  style: _object_spread_props174(_object_spread207({}, getLogoStyles(isDesktop)), {
    justifyContent: "center",
    background: getCssVar("grey", 950),
    borderRadius: 4,
    minWidth: "50%"
  }),
  children: /* @__PURE__ */ _jsx248(LogoSymbol_default, {
    fill: getCssVar("black", 100),
    style: {
      maxWidth: "60%",
      maxHeight: "60%"
    }
  })
});
var Logo_default2 = /* @__PURE__ */ React129.memo(Logo2);

// src/widgets/layouts/book/index.tsx
var BookLayout = ({ children }) => {
  const isDesktop = useMediaQuery5(`(min-width: ${breakpoints_default.md}px)`);
  return /* @__PURE__ */ _jsxs113(LayoutWrapper, {
    children: [
      isDesktop && /* @__PURE__ */ _jsx249(Logo_default2, {}),
      /* @__PURE__ */ _jsx249(Stack7, {
        position: "relative",
        style: getLogoStyles(isDesktop),
        children
      })
    ]
  });
};
var book_default = /* @__PURE__ */ React130.memo(BookLayout);

// src/widgets/layouts/main/index.tsx
import { jsx as _jsx250 } from "react/jsx-runtime";
import React131 from "react";
var MainLayout = ({ children, style: style4 }) => /* @__PURE__ */ _jsx250(MainLayoutWrapper, {
  style: style4,
  children
});
var main_default = /* @__PURE__ */ React131.memo(MainLayout);

// src/widgets/layouts/screen/index.tsx
import { jsx as _jsx251 } from "react/jsx-runtime";
import React132 from "react";
var ScreenLayout = ({ children, style: style4 }) => /* @__PURE__ */ _jsx251(ScreenLayoutWrapper, {
  style: style4,
  children: /* @__PURE__ */ _jsx251(ScreenLayoutContent, {
    children
  })
});
var screen_default = /* @__PURE__ */ React132.memo(ScreenLayout);

// src/widgets/modal/select/index.tsx
import { jsx as _jsx252, jsxs as _jsxs114, Fragment as _Fragment14 } from "react/jsx-runtime";
import { useCallback as useCallback22, useEffect as useEffect34, useMemo as useMemo18, useRef as useRef16, useState as useState33 } from "react";

// src/widgets/modal/select/shared/ui.ts
import styled51 from "styled-components";
var SelectWrapper = styled51.section`
  margin: 1.6rem 0;
  max-width: 80vh;
  max-height: 60vh;
  overflow: auto;
`;

// src/widgets/modal/select/index.tsx
function _define_property208(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread208(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property208(target, key, source[key]);
    });
  }
  return target;
}
var useModalSelect = ({ isReady = false, searchQuery, accessToken, title, checked = [], actionButtonProps, cancelButtonProps, children, placeholder = null, filter, onOpen: _onOpen, onChange: _onChange, onSubmit: _onSubmit, onClose: _onClose, renderItem, refresh, keyExtractor }) => {
  const scrollerRef = useRef16(null);
  const dataMap = useRef16(/* @__PURE__ */ new Map());
  const [isOpen, setIsOpen] = useState33(false);
  const [data, setData] = useState33([]);
  const [page, setPage] = useState33(0);
  const [allPages, setAllPages] = useState33(0);
  const [, setAllRecords] = useState33(0);
  const [limit] = useState33(10);
  const selectQuery = useCallback22((queryPage = page) => {
    const payload = {
      accessToken,
      page: +queryPage,
      limit: +limit
    };
    if (searchQuery) {
      payload.search = searchQuery;
      payload.page = 0;
    }
    return refresh(payload).then(({ data: newData, pagination }) => {
      setData([]);
      if (pagination) {
        const { currentPage, allPages: allPages2, allRecords } = pagination;
        setPage(currentPage);
        setAllPages(allPages2);
        setAllRecords(allRecords);
      }
      if (Array.isArray(newData)) {
        var _dataMap_current;
        if (searchQuery) {
          dataMap.current = /* @__PURE__ */ new Map();
        }
        newData.forEach((item) => {
          const key = keyExtractor(item);
          dataMap.current.set(key, item);
        });
        setData([
          ...dataMap === null || dataMap === void 0 ? void 0 : (_dataMap_current = dataMap.current) === null || _dataMap_current === void 0 ? void 0 : _dataMap_current.values()
        ]);
      }
      return newData;
    });
  }, [
    refresh,
    searchQuery,
    page
  ]);
  useEffect34(() => {
    selectQuery();
  }, [
    searchQuery
  ]);
  const onOpen = useCallback22(() => {
    setPage(0);
    setIsOpen(true);
    selectQuery();
    if (_onOpen) {
      _onOpen();
    }
  }, [
    selectQuery,
    _onOpen
  ]);
  const onClose = useCallback22(() => {
    setIsOpen(false);
    if (_onClose) {
      _onClose();
    }
  }, [
    _onClose
  ]);
  const onChange = useCallback22((key) => {
    if (_onChange) {
      _onChange(key, data.find((item) => keyExtractor(item) === key));
    }
  }, [
    data,
    keyExtractor,
    _onChange
  ]);
  const onSubmit = useCallback22(() => {
    _onSubmit();
  }, [
    data,
    _onSubmit
  ]);
  const onClickItem = useCallback22((key) => {
    onChange(key);
  }, [
    onChange
  ]);
  const onScroll = useCallback22(() => {
    if (!scrollerRef.current) {
      return;
    }
    const { scrollTop, scrollHeight } = scrollerRef.current;
    const bounds = scrollerRef.current.getBoundingClientRect();
    const scrollTopHeight = scrollHeight - bounds.height;
    if (Math.abs(scrollTop - scrollTopHeight) <= 1) {
      if (page === allPages) {
        return;
      }
      const newPage = Math.min(allPages, page + 1);
      setPage(newPage);
      selectQuery(newPage);
    }
  }, [
    page,
    allPages,
    scrollerRef.current
  ]);
  const content = useMemo18(() => {
    const filteredData = filter && data.filter(filter) || data;
    return /* @__PURE__ */ _jsxs114(_Fragment14, {
      children: [
        children,
        (data === null || data === void 0 ? void 0 : data.length) && /* @__PURE__ */ _jsx252(SelectWrapper, {
          ref: scrollerRef,
          onScroll,
          children: filteredData.map((item, index) => {
            const key = keyExtractor(item);
            const isChecked = checked.indexOf(key) >= 0;
            const propsToPass = {
              isChecked,
              data: item,
              onClick: () => onClickItem(key)
            };
            return renderItem(propsToPass, index, data);
          })
        }) || placeholder
      ]
    });
  }, [
    scrollerRef,
    checked,
    data,
    renderItem,
    onScroll,
    onClickItem
  ]);
  const { debounce: debounceSelectQuery } = useDebounce_default(selectQuery, 750);
  useEffect34(() => {
    if (!isReady || !isOpen) {
      return;
    }
    debounceSelectQuery();
  }, [
    isReady,
    isOpen,
    searchQuery,
    selectQuery,
    debounceSelectQuery
  ]);
  const modal = useModal_default({
    title,
    children: content,
    actionButtonProps: _object_spread208({
      children: Translate_default.get("buttons.add"),
      color: "secondary",
      disabled: checked.length === 0
    }, actionButtonProps),
    cancelButtonProps: _object_spread208({
      children: Translate_default.get("buttons.cancel")
    }, cancelButtonProps),
    onOpen,
    onClose,
    onSubmit
  });
  return _object_spread208({}, modal);
};
var select_default2 = useModalSelect;

// src/widgets/navigation/index.tsx
import { jsx as _jsx253, jsxs as _jsxs115 } from "react/jsx-runtime";
import React133, { useMemo as useMemo19 } from "react";
import { useMediaQuery as useMediaQuery6 } from "@mui/material";

// src/widgets/navigation/shared/ui.tsx
import styled52 from "styled-components";
var StyledNavigation = styled52.nav`
  display: flex;
  flex-direction: column;
  margin: 1.6rem 0 0;
  color: ${getCssVar("grey", 500)};

  @media screen and (min-width: ${breakpoints_default.desktop}px) {
    margin-top: 0;
  }
`;
var StyledLinkComponent = styled52.a`

`;

// src/widgets/navigation/index.tsx
var Navigation = ({ pathname, prevPathname, children, linkComponent: LinkComponent2 = StyledLinkComponent, renderStack, renderRoot }) => {
  const stack = useMemo19(() => pathname === null || pathname === void 0 ? void 0 : pathname.split("/").filter((p) => !!p), [
    pathname
  ]);
  const isTablet = useMediaQuery6(`(min-width: ${breakpoints_default.tablet}px)`);
  const breadcrumbs = useMemo19(() => stack === null || stack === void 0 ? void 0 : stack.map((value, i, stack2) => {
    const isLast = i === stack2.length - 1;
    const prevValues = stack2.slice(0, i);
    if (renderStack) {
      return renderStack(value, isLast, prevValues);
    }
    if (isLast) {
      return /* @__PURE__ */ _jsx253(typography_default, {
        children: value
      });
    }
    return /* @__PURE__ */ _jsx253(link_default, {
      to: `/${value}`,
      children: value
    }, i);
  }), [
    stack,
    renderStack
  ]);
  const withBreadcrumbs = useMemo19(() => isTablet && breadcrumbs && breadcrumbs.length > 1, [
    isTablet,
    breadcrumbs
  ]);
  const root = useMemo19(() => {
    if (renderRoot) {
      return renderRoot();
    }
    return /* @__PURE__ */ _jsx253(link_default, {
      to: "/",
      children: "Home"
    });
  }, [
    renderRoot
  ]);
  return /* @__PURE__ */ _jsxs115(StyledNavigation, {
    children: [
      withBreadcrumbs && /* @__PURE__ */ _jsxs115(breadcrumbs_default, {
        "aria-label": "breadcrumbs",
        sx: {
          fontWeight: fonts_default.bold
        },
        children: [
          root,
          breadcrumbs
        ]
      }),
      children && /* @__PURE__ */ _jsxs115(typography_default, {
        variant: "h5",
        color: "text.primary",
        sx: {
          display: "flex",
          marginTop: withBreadcrumbs && 3 || 0,
          fontWeight: fonts_default.bold
        },
        children: [
          !isTablet && prevPathname && /* @__PURE__ */ _jsx253(link_default, {
            to: prevPathname,
            component: LinkComponent2,
            sx: {
              display: "flex",
              alignItems: "center",
              marginRight: "2.4rem"
            },
            children: /* @__PURE__ */ _jsx253(ArrowBack_default, {})
          }),
          children
        ]
      })
    ]
  });
};
var navigation_default = /* @__PURE__ */ React133.memo(Navigation);

// src/widgets/search-list/index.tsx
import { jsx as _jsx256, jsxs as _jsxs118 } from "react/jsx-runtime";
import { useCallback as useCallback24, useEffect as useEffect35, useState as useState34 } from "react";

// src/widgets/search-list/shared/ui.ts
import styled53 from "styled-components";
var SearchListActions = styled53.div`
  display: flex;
  align-items: center;
  gap: ${getSizeUnit(12)};
`;

// src/widgets/user/list/index.tsx
import { jsx as _jsx255, jsxs as _jsxs117, Fragment as _Fragment15 } from "react/jsx-runtime";
import { useCallback as useCallback23 } from "react";

// src/widgets/user/item/index.tsx
import { jsx as _jsx254, jsxs as _jsxs116 } from "react/jsx-runtime";
import { useMemo as useMemo20 } from "react";

// src/widgets/user/item/shared/ui.ts
import styled54 from "styled-components";
var ItemWrapper = styled54.div`
  display: flex;
  padding: .8rem 0;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.accentColor ? props.accentColor : getCssVar("grey", 950)};
  transition: all .27s;

  ${(props) => props.disableHover ? "" : `&:hover {
      background: ${props.accentColor ? props.accentColor : getCssVar("grey", 950)};
      cursor: pointer;
    }`}
`;
var UserName = styled54(typography_default)`
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
var EmailWrapper = styled54.div`
  display: flex;
  align-items: center;
  gap: ${getSizeUnit(2)};
  margin-top: ${getSizeUnit(2)};
`;
var UserEmail = styled54(typography_default)`
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  text-transform: lowercase;
`;

// src/widgets/user/item/index.tsx
var WidgetUserItem = ({ user, beforeChildren, buttons, onClick, accentColor, disableHover, className }) => {
  const { id, name, avatarHttpPath, initials, email } = user;
  const localStorage2 = useMemo20(() => new LocalStorage_default(), []);
  const { accessToken } = useSession();
  return /* @__PURE__ */ _jsxs116(ItemWrapper, {
    className,
    accentColor,
    disableHover,
    onClick,
    children: [
      beforeChildren,
      /* @__PURE__ */ _jsxs116(row_default, {
        alignItems: "center",
        wrap: "nowrap",
        children: [
          /* @__PURE__ */ _jsx254(col_default, {
            mobile: "auto",
            children: /* @__PURE__ */ _jsx254(avatar_default, {
              size: 38,
              src: avatarHttpPath && `${avatarHttpPath}?authorization=${accessToken || localStorage2.get("vc-access-token") || ""}` || "",
              alt: initials,
              style: {
                marginRight: getSizeUnit(16)
              },
              onError: ({ currentTarget }) => {
                currentTarget.onerror = null;
              },
              children: initials
            })
          }),
          /* @__PURE__ */ _jsxs116(col_default, {
            children: [
              /* @__PURE__ */ _jsx254(UserName, {
                variant: "body1",
                children: name
              }),
              /* @__PURE__ */ _jsxs116(EmailWrapper, {
                children: [
                  /* @__PURE__ */ _jsx254(Email_default, {}),
                  /* @__PURE__ */ _jsx254(UserEmail, {
                    variant: "caption",
                    children: email
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ _jsx254(col_default, {
            mobile: "auto",
            children: buttons
          })
        ]
      })
    ]
  }, id);
};
var item_default = WidgetUserItem;

// src/widgets/user/list/index.tsx
var WidgetUserList = ({ isReady = false, isError = false, id = "", data, title, itemClassName, listClassName, emptyContent, errorContent, onItemClick, renderItemButtons, renderItem }) => {
  const renderUserItem = useCallback23((user) => /* @__PURE__ */ _jsx255(item_default, {
    user,
    buttons: renderItemButtons && renderItemButtons(user),
    onClick: () => onItemClick(user)
  }), [
    renderItemButtons,
    onItemClick
  ]);
  return /* @__PURE__ */ _jsxs117(_Fragment15, {
    children: [
      title && /* @__PURE__ */ _jsxs117(_Fragment15, {
        children: [
          /* @__PURE__ */ _jsx255(typography_default, {
            variant: "h5",
            display: "flex",
            marginTop: getSizeUnit(12),
            justifyContent: "space-between",
            children: title
          }),
          /* @__PURE__ */ _jsx255("div", {
            className: "mt-6"
          })
        ]
      }),
      /* @__PURE__ */ _jsx255(list_default, {
        id,
        isReady,
        isError,
        data,
        emptyContent,
        errorContent,
        itemClassName,
        listClassName,
        renderItem: renderItem !== null && renderItem !== void 0 ? renderItem : renderUserItem
      })
    ]
  });
};
var list_default2 = WidgetUserList;

// src/widgets/search-list/index.tsx
var WidgetSearchList = ({ isContrast = false, placeholder, value = "", emptyContent, emptyUsersContent, errorContent, userList = [], list = [], searchButtons, renderItem, renderUserItem, apiGetUsers, apiGetData, onUserItemClick, onChange }) => {
  const [isLoading, setIsLoading] = useState34(false);
  const [isSearching, setIsSearching] = useState34(false);
  const [isGetUsersError, setIsGetUsersError] = useState34(false);
  const [isGetDataError, setGetDataError] = useState34(false);
  const isUserSearchQueryLongEnough = value.trim().length >= 2;
  const getDataQuery = useCallback24(() => {
    setIsLoading(true);
    setGetDataError(false);
    apiGetData().catch((error) => {
      setGetDataError(true);
      console.log("getDataQuery [error]", error);
    }).finally(() => setIsLoading(false));
  }, []);
  const getUsersQuery = useCallback24(() => {
    setIsSearching(true);
    setIsGetUsersError(false);
    apiGetUsers({
      searchString: value.trim()
    }).catch((error) => {
      setIsGetUsersError(true);
      console.log("getUsersQuery [error]", error);
    }).finally(() => setIsSearching(false));
  }, [
    value
  ]);
  const { debounce: debouncedRefetchGetUsersQuery } = useDebounce_default(getUsersQuery, 540);
  useEffect35(() => {
    if (!isUserSearchQueryLongEnough) {
      return;
    }
    debouncedRefetchGetUsersQuery();
  }, [
    value
  ]);
  useEffect35(() => {
    getDataQuery();
  }, []);
  return /* @__PURE__ */ _jsxs118("div", {
    children: [
      /* @__PURE__ */ _jsxs118(SearchListActions, {
        children: [
          /* @__PURE__ */ _jsx256(textfield_default, {
            isFullWidth: true,
            isContrast,
            value,
            placeholder,
            InputProps: {
              startAdornment: /* @__PURE__ */ _jsx256("div", {
                children: /* @__PURE__ */ _jsx256(Search_default, {
                  style: {
                    marginRight: getSizeUnit(8)
                  }
                })
              }),
              endAdornment: value && /* @__PURE__ */ _jsx256("button", {
                onClick: () => onChange(""),
                children: /* @__PURE__ */ _jsx256(Cross_default, {
                  height: getSizeUnit(23),
                  width: getSizeUnit(23)
                })
              }) || null
            },
            onChange: (e) => {
              var _e_target;
              return onChange(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
            }
          }),
          searchButtons
        ]
      }),
      /* @__PURE__ */ _jsx256("div", {
        style: {
          marginTop: getSizeUnit(24)
        }
      }),
      !isUserSearchQueryLongEnough && /* @__PURE__ */ _jsx256(list_default, {
        id: "",
        isReady: !isLoading,
        isError: isGetDataError,
        emptyContent,
        errorContent,
        data: list,
        renderItem
      }),
      isUserSearchQueryLongEnough && /* @__PURE__ */ _jsx256(list_default2, {
        id: "",
        isReady: !isSearching,
        isError: isGetUsersError,
        emptyContent: emptyUsersContent,
        data: userList,
        onItemClick: onUserItemClick,
        onRefresh: getUsersQuery,
        renderItem: renderUserItem
      })
    ]
  });
};
var search_list_default = WidgetSearchList;

// src/widgets/sidebar/index.tsx
import { jsx as _jsx260 } from "react/jsx-runtime";
import React136, { useMemo as useMemo21 } from "react";

// src/widgets/sidebar/shared/constants.tsx
import { jsx as _jsx259 } from "react/jsx-runtime";

// src/widgets/sidebar/types.ts
var SidebarLabel;
(function(SidebarLabel2) {
  SidebarLabel2["Rooms"] = "rooms";
  SidebarLabel2["Calls"] = "calls";
  SidebarLabel2["Chats"] = "chats";
  SidebarLabel2["Video"] = "video";
  SidebarLabel2["SuperuserDashboard"] = "superuserDashboard";
})(SidebarLabel || (SidebarLabel = {}));

// src/widgets/sidebar/shared/call-icon.tsx
import { jsx as _jsx257, jsxs as _jsxs119 } from "react/jsx-runtime";
import { useEffect as useEffect36, useRef as useRef17, useState as useState35 } from "react";

// src/widgets/sidebar/shared/ui.ts
import styled55 from "styled-components";
var StyledButton2 = styled55(button_default)`
  && {
    color: ${getCssVar("black", 100)};
    background-color: ${getCssVar("white", 100)};
    align-self: self-start;
    margin-top: 24px;

    &:hover {
      background-color: ${getCssVar("white", 100)};
    }
  }
`;
var StyledNotificationsBadge = styled55.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  background: #0D69F2;
  padding: 0 ${getSizeUnit(4)};
  border-radius: ${getSizeUnit(10)};
  font-size: ${getSizeUnit(14)};
  line-height: ${getSizeUnit(18)};
  color: ${getCssVar("white", 100)};
  z-index: 1;
`;

// src/widgets/sidebar/shared/call-icon.tsx
import { dionCookieService } from "@dion-web/cookie";
var CallIcon = () => {
  const ref3 = useRef17(null);
  const [open, setOpen] = useState35(false);
  const [anchorEl, setAnchorEl] = useState35(null);
  const showPopper = dionCookieService.get(CALLS_ICON_POPPER_SHOW) !== "false";
  useEffect36(() => {
    if (showPopper && ref3.current) {
      setOpen(true);
      setAnchorEl(ref3.current);
    }
  }, [
    ref3.current,
    showPopper
  ]);
  const onClosePopper = (event) => {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    dionCookieService.set(CALLS_ICON_POPPER_SHOW, "false");
    setOpen(false);
  };
  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClosePopper();
  };
  return /* @__PURE__ */ _jsxs119("div", {
    style: {
      position: "relative"
    },
    id: "call-icon-container",
    ref: ref3,
    children: [
      /* @__PURE__ */ _jsx257(NavCalls_default, {
        fill: "currentColor"
      }),
      /* @__PURE__ */ _jsx257(popper_default, {
        id: "calls-popper",
        open,
        anchorEl,
        onClose: onClosePopper,
        title: Translate_default.get("sidebar.callsPopper.title"),
        subtitle: Translate_default.get("sidebar.callsPopper.subtitle"),
        placement: "right-start",
        transitionProps: {
          timeout: 500
        },
        sx: {
          zIndex: 12
        },
        children: /* @__PURE__ */ _jsx257(StyledButton2, {
          variant: "contained",
          color: "secondary",
          onClick,
          size: "small",
          children: Translate_default.get("sidebar.callsPopper.button")
        })
      })
    ]
  });
};

// src/widgets/sidebar/shared/chats-icon.tsx
import { jsx as _jsx258, jsxs as _jsxs120 } from "react/jsx-runtime";
import { memo as memo3 } from "react";

// src/processes/store/chats-notifications/index.ts
var import_lodash15 = __toESM(require_lodash());
import { create as create2 } from "zustand";
import { devtools as devtools2 } from "zustand/middleware";
var useChatsNotifications = create2(devtools2((set) => ({
  notificationsCount: 0,
  setNotificationsCount: (newCount) => {
    if (!(0, import_lodash15.isInteger)(newCount))
      return;
    set({
      notificationsCount: newCount
    });
  }
}), {
  name: "DION.CHATS - Notifications Badge"
}));

// src/widgets/sidebar/shared/chats-icon.tsx
var ChatsIcon = () => {
  const notificationsCount = useChatsNotifications((state) => state.notificationsCount);
  return /* @__PURE__ */ _jsxs120("div", {
    style: {
      position: "relative"
    },
    id: "chats-icon-container",
    children: [
      /* @__PURE__ */ _jsx258(NavChats_default, {
        fill: "currentColor"
      }),
      notificationsCount ? /* @__PURE__ */ _jsx258(StyledNotificationsBadge, {
        children: notificationsCount > 99 ? "99+" : notificationsCount
      }) : null
    ]
  });
};
var chats_icon_default = /* @__PURE__ */ memo3(ChatsIcon);

// src/widgets/sidebar/shared/constants.tsx
var SIDEBAR_ITEMS = [];
var SIDEBAR_ITEMS_MAP = {};
SIDEBAR_ITEMS_MAP = {
  [SidebarLabel.Rooms]: {
    key: SidebarLabel.Rooms,
    label: () => Translate_default.get("sidebar.items.rooms"),
    renderIcon: () => /* @__PURE__ */ _jsx259(NavRooms_default, {
      fill: "currentColor"
    })
  },
  [SidebarLabel.Video]: {
    key: SidebarLabel.Video,
    label: () => Translate_default.get("sidebar.items.video"),
    renderIcon: () => /* @__PURE__ */ _jsx259(NavVideo_default, {
      fill: "currentColor"
    })
  },
  [SidebarLabel.Calls]: {
    key: SidebarLabel.Calls,
    label: () => Translate_default.get("sidebar.items.calls"),
    renderIcon: () => /* @__PURE__ */ _jsx259(CallIcon, {})
  },
  [SidebarLabel.SuperuserDashboard]: {
    key: SidebarLabel.SuperuserDashboard,
    label: () => Translate_default.get("sidebar.items.admin-panel"),
    renderIcon: () => /* @__PURE__ */ _jsx259(NavSuperuserDashboard_default, {
      fill: "currentColor"
    })
  },
  [SidebarLabel.Chats]: {
    key: SidebarLabel.Chats,
    label: () => Translate_default.get("sidebar.items.chats"),
    renderIcon: () => /* @__PURE__ */ _jsx259(chats_icon_default, {})
  }
};
SIDEBAR_ITEMS = Object.values(SidebarLabel).map((sidebarLabel) => SIDEBAR_ITEMS_MAP[sidebarLabel]);
var SIDEBAR_WHITELIST_LABELS = [
  SidebarLabel.Rooms,
  SidebarLabel.Video
];

// src/widgets/sidebar/index.tsx
function _define_property209(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread209(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property209(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys175(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props175(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys175(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties164(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose164(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose164(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Sidebar = ({ isVisible = false, isPinned = false, className, data, whitelistLabels = SIDEBAR_WHITELIST_LABELS, onChange, resolveActiveKey }) => {
  const children = useMemo21(() => data.filter(({ key }) => whitelistLabels === null || whitelistLabels === void 0 ? void 0 : whitelistLabels.includes(key)).map((_param) => {
    var { key, renderIcon, onClick } = _param, props = _object_without_properties164(_param, [
      "key",
      "renderIcon",
      "onClick"
    ]);
    const activeKey = resolveActiveKey && resolveActiveKey(key);
    const isActive = activeKey === key;
    const onClickItem = (e) => {
      if (onClick) {
        onClick(e);
      }
    };
    return /* @__PURE__ */ _jsx260(Action_default, _object_spread_props175(_object_spread209({}, props), {
      isActive,
      icon: renderIcon(props),
      onClick: onClickItem
    }), key);
  }), [
    data,
    whitelistLabels,
    resolveActiveKey
  ]);
  return /* @__PURE__ */ _jsx260(side_navigation_default, {
    isHovered: isVisible,
    isHoverDisabled: isPinned,
    className,
    onChange,
    children
  });
};
var sidebar_default = /* @__PURE__ */ React136.memo(Sidebar);

// src/widgets/settings/modes-settings/index.tsx
import { jsx as _jsx261, jsxs as _jsxs121 } from "react/jsx-runtime";
import { Stack as Stack8 } from "@mui/material";
import React137, { Fragment } from "react";

// src/widgets/settings/modes-settings/ui.tsx
import styled56 from "styled-components";
var LoaderWrap = styled56.div`
  align-items: 'center';
  justify-content: 'center';
  display: 'flex';
  flex-grow: 1;
`;

// src/widgets/settings/modes-settings/index.tsx
var ModesSettings = ({ settings, isLoading = false, isTooltip = false }) => {
  if (isLoading)
    return /* @__PURE__ */ _jsx261(LoaderWrap, {
      children: /* @__PURE__ */ _jsx261(loader_default, {})
    });
  return /* @__PURE__ */ _jsx261(Stack8, {
    spacing: "24px",
    children: settings.map(({ label, onToggle, description, state, id, isLoading: isLoading2, disabled, children }) => /* @__PURE__ */ _jsxs121(Fragment, {
      children: [
        /* @__PURE__ */ _jsx261(toggle_setting_default, {
          id,
          description,
          label,
          isTooltip,
          buttonSwitch: /* @__PURE__ */ _jsx261(button_switch_default, {
            sx: {
              ml: "auto"
            },
            checked: state,
            onChange: onToggle,
            id: `${id}-switch`,
            disabled: disabled || isLoading2
          })
        }),
        children
      ]
    }, id))
  });
};
var modes_settings_default = /* @__PURE__ */ React137.memo(ModesSettings);

// src/widgets/settings/security-settings/index.tsx
import { jsx as _jsx262 } from "react/jsx-runtime";
import { Stack as Stack9 } from "@mui/material";
import React138, { Fragment as Fragment2 } from "react";

// src/widgets/settings/security-settings/ui.tsx
import styled57 from "styled-components";
var LoaderWrap2 = styled57.div`
  align-items: 'center';
  justify-content: 'center';
  display: 'flex';
  flex-grow: 1;
`;

// src/widgets/settings/security-settings/index.tsx
var SecuritySettings = ({ settings, isLoading = false, isTooltip = false }) => {
  if (isLoading)
    return /* @__PURE__ */ _jsx262(LoaderWrap2, {
      children: /* @__PURE__ */ _jsx262(loader_default, {})
    });
  return /* @__PURE__ */ _jsx262(Stack9, {
    spacing: "24px",
    children: settings.map(({ label, onToggle, description, state, id, isLoading: isLoading2, disabled, children }) => /* @__PURE__ */ _jsx262(Fragment2, {
      children: /* @__PURE__ */ _jsx262(toggle_setting_default, {
        id,
        description,
        label,
        isTooltip,
        buttonSwitch: /* @__PURE__ */ _jsx262(button_switch_default, {
          sx: {
            ml: "auto"
          },
          checked: state,
          onChange: onToggle,
          id: `${id}-switch`,
          disabled: disabled || isLoading2
        }),
        children
      })
    }, id))
  });
};
var security_settings_default = /* @__PURE__ */ React138.memo(SecuritySettings);

// src/widgets/settings/room-info/room-info-report/index.tsx
import { jsx as _jsx264, jsxs as _jsxs123 } from "react/jsx-runtime";
import { useState as useState37, useMemo as useMemo23, useCallback as useCallback25, useRef as useRef18 } from "react";
import { Skeleton } from "@mui/material";

// src/widgets/settings/room-info/room-info-report/shared/ui.tsx
import { styled as styled58, Stack as StackMui } from "@mui/material";
var ReportButtonStyled = styled58(button_default)`
  flex: 1 0 calc(50% - 8px);
  min-height: 3.8rem;
  &.MuiButtonBase-root {
    justify-content: center;
  };
  > span {
    margin-left: 0;
    width: 1.8rem;
  }
  & path {
    fill: currentColor;
  }
`;
var DatePickerStyled2 = styled58(date_picker_default)`
  flex: 1 0 calc(50% - 8px);
  .MuiFormControl-root {
    width: 100%
  }
`;
var IconAnimateLoader = styled58(ButtonLoader_default)`
  animation: rotateAnimation 1.2s linear infinite;
  
  @keyframes rotateAnimation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
var ReportEmptyText = styled58(typography_default)`
  color: ${getCssVar("grey", 500)};
  max-width: 330px;
  text-align: center;
`;
var ReportWrapper = styled58(stack_default)` 
  height: 100%;
  overflow: hidden
`;
var ReportInner = styled58(StackMui)`
  height: 100%;
  position: relative;
  flex-grow: 1;
  width: calc(100% + 4px);
  white-space: normal;
  overflow-y: scroll;
  ::-webkit-scrollbar-thumb {
    background: #898E9600;
    border-radius: 4px;
    transition: background 0.4s;
  };
  ::-webkit-scrollbar {
      background: #00000000;
      width: 4px;
      opacity: 0;
    };
  &:hover::-webkit-scrollbar-thumb { background: #898E96 };
  &::-webkit-scrollbar-track-piece:end { background: transparent };
  &::-webkit-scrollbar-track-piece:start { background: transparent };

`;
var ReportEmpty = styled58(stack_default)`
  width:100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
var ReportItemWrapper = styled58(stack_default)`
  align-items: center;
  justify-content: flex-start ;
  border-radius: 1rem;
  gap: 1rem;
  background-color: ${getCssVar("grey", 900)};
  padding: 1rem;
  height: 64px;
  box-sizing: border-box;
`;
var ReportItemButtonStyled = styled58(button_default)`
  margin-left: auto;
  min-height: 3.8rem;
  border-radius: 1rem; 
  &.MuiButtonBase-root {
    justify-content: center;
  };
  > span {
    margin-left: 0;
    width: 1.8rem;
  }
  & path {
    fill: currentColor;
  }
`;
var ReportItemDownloadButton = styled58(button_default)`
  min-height: 2rem;
  height: 2rem;
  padding: 0 1rem!important;
`;
var ReportItemIcon = styled58(box_default)`
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
var IconDownload = styled58(ArrowBack_default)`
  transform:rotate(-90deg)
`;

// src/widgets/settings/room-info/room-info-report/shared/RoomInfoReportItem.tsx
import { jsx as _jsx263, jsxs as _jsxs122, Fragment as _Fragment16 } from "react/jsx-runtime";
import { useMemo as useMemo22, useState as useState36 } from "react";
function asyncGeneratorStep10(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator10(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep10(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep10(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var RoomInfoReportItem = ({ className, report, isDownloaded, updateDownloaded, handleGetReports, metrics }) => {
  const { accessToken } = useSession();
  const localStorage2 = useMemo22(() => new LocalStorage_default(), []);
  const [isLoading, setIsLoading] = useState36(false);
  const downloadFile = function() {
    var _ref = _async_to_generator10(function* () {
      setIsLoading(true);
      metrics === null || metrics === void 0 ? void 0 : metrics.download();
      try {
        const response = yield fetch(`${report.downloadFile}?authorization=${accessToken || localStorage2.get("vc-access-token")}`);
        const blob = yield response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = report.fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        if (!isDownloaded)
          updateDownloaded(report.id);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    });
    return function downloadFile2() {
      return _ref.apply(this, arguments);
    };
  }();
  const IconJSX = useMemo22(() => {
    if (isLoading)
      return /* @__PURE__ */ _jsx263(IconAnimateLoader, {
        fill: getCssVar("grey", 400)
      });
    if (isDownloaded)
      return /* @__PURE__ */ _jsx263(File_default, {
        fill: getCssVar("blue", 300)
      });
    switch (report.status) {
      case "in_progress":
        return /* @__PURE__ */ _jsx263(File_default, {});
      case "completed":
        return /* @__PURE__ */ _jsx263(IconDownload, {
          fill: getCssVar("blue", 300),
          width: 22,
          height: 22
        });
      case "error":
        return /* @__PURE__ */ _jsx263(ErrorTriangle_default, {});
      default:
        console.error("not reachable");
        return /* @__PURE__ */ _jsx263(File_default, {});
    }
  }, [
    report.status,
    isDownloaded,
    isLoading
  ]);
  return /* @__PURE__ */ _jsxs122(ReportItemWrapper, {
    className,
    direction: "row",
    children: [
      /* @__PURE__ */ _jsx263(ReportItemIcon, {
        children: IconJSX
      }),
      /* @__PURE__ */ _jsxs122(stack_default, {
        spacing: 0.5,
        children: [
          /* @__PURE__ */ _jsx263(typography_default, {
            variant: "body2",
            children: report.fileName
          }),
          /* @__PURE__ */ _jsx263(stack_default, {
            direction: "row",
            alignItems: "center",
            children: report.status !== "error" ? /* @__PURE__ */ _jsxs122(_Fragment16, {
              children: [
                /* @__PURE__ */ _jsx263(typography_default, {
                  variant: "caption",
                  children: report.status === "in_progress" ? `${Translate_default.get("settings.room.reports.reportInProcess")}` : report.fileSize
                }),
                report.status === "completed" && !isLoading && /* @__PURE__ */ _jsx263(ReportItemDownloadButton, {
                  size: "small",
                  variant: "text",
                  onClick: downloadFile,
                  children: Translate_default.get("settings.room.reports.downloadBtn")
                })
              ]
            }) : /* @__PURE__ */ _jsx263(typography_default, {
              variant: "caption",
              color: getCssVar("red", 300),
              children: Translate_default.get("settings.room.reports.downloadErrors")
            })
          })
        ]
      }),
      report.status === "in_progress" && /* @__PURE__ */ _jsx263(ReportItemButtonStyled, {
        color: "secondary",
        disabled: false,
        variant: "text",
        startIcon: /* @__PURE__ */ _jsx263(Update_default, {}),
        onClick: handleGetReports,
        children: Translate_default.get("settings.room.reports.getReportsBtn")
      })
    ]
  });
};
var RoomInfoReportItem_default = RoomInfoReportItem;

// src/widgets/settings/room-info/room-info-report/index.tsx
function asyncGeneratorStep11(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator11(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep11(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep11(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var RoomInfoReport = ({ className, reports, isLoading, onGetReports, onCreateReports, metrics }) => {
  const reportsList = (reports === null || reports === void 0 ? void 0 : reports.reports) || [];
  const localStorage2 = useMemo23(() => new LocalStorage_default(), []);
  const [date, setDate] = useState37("");
  const [downloaded, setDownloaded] = useState37(JSON.parse(localStorage2.get("reports") || "[]"));
  const listRef = useRef18(null);
  const [currentPage, setCurrentPage] = useState37(1);
  const handleChangeDate = (val) => {
    setDate(val.format("YYYY-MM-DD"));
  };
  const handleCreateReports = () => {
    onCreateReports(date);
  };
  const handleGetReports = () => {
    onGetReports(`${currentPage + 1}`);
  };
  const handleUpdateDownloaded = (id) => {
    const removeCount = 90;
    const updateReports = [
      ...downloaded.length < 100 ? downloaded : downloaded.slice(removeCount),
      ...[
        id
      ]
    ];
    setDownloaded(updateReports);
    localStorage2.set("reports", JSON.stringify(updateReports));
  };
  const onScroll = useCallback25(() => {
    if (!listRef.current || !reports || isLoading) {
      return;
    }
    const endScroll = listRef.current.offsetHeight;
    if (listRef.current.scrollHeight - listRef.current.scrollTop - 20 < endScroll) {
      if (currentPage >= reports.pagination.allPages) {
        return;
      }
      setTimeout(/* @__PURE__ */ _async_to_generator11(function* () {
        yield setCurrentPage((currentPage2) => currentPage2 + 1);
        handleGetReports();
      }), 0);
    }
  }, [
    currentPage,
    reportsList.length
  ]);
  return /* @__PURE__ */ _jsx264(ReportWrapper, {
    className,
    children: /* @__PURE__ */ _jsxs123(ReportInner, {
      ref: listRef,
      onScroll,
      className,
      spacing: 4,
      children: [
        /* @__PURE__ */ _jsxs123(stack_default, {
          direction: "row",
          alignItems: "flex-end",
          gap: 2,
          children: [
            /* @__PURE__ */ _jsx264(DatePickerStyled2, {
              minDate: dayjs("2022-01-01"),
              maxDate: dayjs(),
              onChange: handleChangeDate
            }),
            /* @__PURE__ */ _jsx264(ReportButtonStyled, {
              color: "secondary",
              disabled: !date || isLoading,
              variant: "contained",
              startIcon: /* @__PURE__ */ _jsx264(Download_default, {}),
              onClick: handleCreateReports,
              children: Translate_default.get("settings.room.reports.createReportBtn")
            })
          ]
        }),
        !reportsList.length && !isLoading && /* @__PURE__ */ _jsxs123(ReportEmpty, {
          spacing: 2,
          children: [
            /* @__PURE__ */ _jsx264(Report_default, {}),
            /* @__PURE__ */ _jsx264(ReportEmptyText, {
              variant: "body2",
              children: Translate_default.get("settings.room.reports.emptyList")
            })
          ]
        }),
        isLoading && /* @__PURE__ */ _jsx264(stack_default, {
          spacing: 0.5,
          children: [
            1,
            2,
            3,
            4
          ].map((idx) => /* @__PURE__ */ _jsx264(Skeleton, {
            variant: "rounded",
            width: "100%",
            height: 64
          }, idx))
        }),
        !!reportsList.length && !isLoading && /* @__PURE__ */ _jsx264(stack_default, {
          spacing: 0.5,
          children: reportsList.map((report) => /* @__PURE__ */ _jsx264(RoomInfoReportItem_default, {
            report,
            isDownloaded: downloaded === null || downloaded === void 0 ? void 0 : downloaded.includes(report.id),
            handleGetReports,
            updateDownloaded: handleUpdateDownloaded,
            metrics
          }, report.id))
        })
      ]
    })
  });
};
var room_info_report_default = RoomInfoReport;

// src/widgets/settings/access-settings/index.tsx
import { jsx as _jsx275, jsxs as _jsxs130, Fragment as _Fragment20 } from "react/jsx-runtime";
import { Stack as Stack11, Typography as Typography8 } from "@mui/material";

// src/widgets/settings/access-settings/shared/ui.tsx
import styled59 from "styled-components";
var StretchButton = styled59(button_default)` 
  &.MuiButtonBase-root {
     border-radius: 4px;
    background: ${getCssVar("grey", 900)};
    justify-content: space-between;
    padding: 7px 7px 7px 12px;
    align-items: center;
    gap: 8px;
  };
  > span {
    margin-left: 0;
    width: 1.8rem;
  }
`;

// src/widgets/settings/access-settings/shared/moderator-management/index.tsx
import { jsx as _jsx274, jsxs as _jsxs129, Fragment as _Fragment19 } from "react/jsx-runtime";
import { Stack as Stack10, Skeleton as Skeleton2 } from "@mui/material";
import { useState as useState39, useRef as useRef19 } from "react";

// src/widgets/settings/access-settings/shared/moderator-management/shared/ui.tsx
import { styled as styled60, Stack as StackMui2, Button as Button3 } from "@mui/material";
var StretchButton2 = styled60(Button3)` 
  &.MuiButtonBase-root {
    justify-content: flex-start;
    padding: 0;
    align-items: center;
    gap: 2rem;
    padding: 1rem;
    border-bottom: 1px solid  ${getCssVar("grey", 900)};
  };
  > span {
    margin-right: 0;
    margin-left: 0;
    width: 2.4rem;
  }
`;
var UserListWrapper = styled60(StackMui2)` 
  height: 100%;
  overflow: hidden;
  margin-top:0 !important;
`;
var UserList = styled60(StackMui2)`
  height: 100%;
  position: relative;
  flex-grow: 1;
  white-space: normal;
  overflow-y: scroll;
  ::-webkit-scrollbar-thumb {
    background: #898E9600;
    border-radius: 4px;
    transition: background 0.4s;
  };
  ::-webkit-scrollbar {
      background: #00000000;
      width: 4px;
      opacity: 0;
    };
  &:hover::-webkit-scrollbar-thumb { background: #898E96 };
  &::-webkit-scrollbar-track-piece:end { background: transparent };
  &::-webkit-scrollbar-track-piece:start { background: transparent };

`;
var WidgetUserItemStyled = styled60(WidgetUserItem)`
  border-color:  ${getCssVar("grey", 900)};
`;

// src/widgets/settings/access-settings/shared/moderator-management/shared/UserItem.tsx
import { jsx as _jsx273, Fragment as _Fragment18 } from "react/jsx-runtime";
import { useMemo as useMemo25 } from "react";

// src/widgets/user/user-select/index.tsx
import { jsx as _jsx272, jsxs as _jsxs128 } from "react/jsx-runtime";
import { useCallback as useCallback28, useEffect as useEffect37, useState as useState38 } from "react";
import { Typography as Typography7 } from "@mui/material";

// src/widgets/user/user-select/shared/ui.tsx
import styled61 from "styled-components";
var ContentWrapper = styled61(stack_default)`
  width: 100%;
  height: 100%;
`;
var SelectedUsersContainer = styled61.div`
  display: flex;
  min-height: 92px;
  padding: ${getSizeUnit(16)} 0 ${getSizeUnit(10)};
  gap: ${getSizeUnit(20)};
  overflow-x: auto;
  overflow-y: hidden;
  ::-webkit-scrollbar-thumb {
    background: #898E9600;
    border-radius: 4px;
    transition: background 0.4s;
  };
  ::-webkit-scrollbar {
      background: #00000000;
      width: 4px;
      height: 4px;
      opacity: 0;
    };
  &:hover::-webkit-scrollbar-thumb { background: #898E96 };
  &::-webkit-scrollbar-track-piece:end { background: transparent };
  &::-webkit-scrollbar-track-piece:start { background: transparent };
`;
var SearchedUsersContainer = styled61.div`
    margin-top: ${getSizeUnit(8)};
    height: 100%;
    overflow-y: auto;
    padding: 0 0rem 0 2rem;
    scrollbar-gutter: stable;
`;
var ButtonsWrapper2 = styled61(stack_default)`
  margin-top: auto;
  gap: 2rem;
  align-items: center;
  padding: 3rem 0;
  
`;

// src/widgets/user/user-select/shared/selected-users/SelectedUsers.tsx
import { jsx as _jsx266, Fragment as _Fragment17 } from "react/jsx-runtime";
import { useMemo as useMemo24 } from "react";

// src/widgets/user/user-select/shared/selected-users/shared/SelectedUser.tsx
import { jsx as _jsx265, jsxs as _jsxs124 } from "react/jsx-runtime";
import { useCallback as useCallback26 } from "react";

// src/widgets/user/user-select/shared/selected-users/shared/ui.tsx
import styled62 from "styled-components";
var SelectedUserName = styled62(typography_default)`
      display: -webkit-box;
      word-break: break-all;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      align-self: start;
      width: 100%;
      text-align: center;
      color: ${getCssVar("grey", 500)};
  `;
var SelectedUserWrapper = styled62.div`
      min-width: ${getSizeUnit(72)};
      max-width: ${getSizeUnit(72)};
      display: flex;
      flex-direction: column;
      align-items: center;
  
      ${SelectedUserName} {
          margin-top: ${getSizeUnit(2)};
      }
      .MuiAvatar-root {
        background-color: ${getCssVar("grey", 900)};
      }
  `;
var SelectedUserAvatarContainer = styled62.div`
      padding: 0 ${getSizeUnit(8)};
      position: relative;
  `;
var RemoveSelectedUserButton = styled62.button`
      position: absolute;
      width: ${getSizeUnit(20)};
      height: ${getSizeUnit(20)};
      background-color: ${getCssVar("grey", 900)};
      border: 1px solid ${getCssVar("grey", 900)};
      color: ${({ theme }) => theme["color/text/contrast"]};
      border-radius: 50%;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
  `;

// src/widgets/user/user-select/shared/selected-users/shared/SelectedUser.tsx
var SelectedUser = ({ user, accessToken, onRemove }) => {
  const { initials = "", avatarHttpPath = "", name = "" } = user;
  const onClick = useCallback26(() => {
    onRemove(user.id);
  }, [
    user,
    onRemove
  ]);
  return /* @__PURE__ */ _jsxs124(SelectedUserWrapper, {
    children: [
      /* @__PURE__ */ _jsxs124(SelectedUserAvatarContainer, {
        children: [
          /* @__PURE__ */ _jsx265(avatar_default, {
            size: 48,
            src: getImageUrl(avatarHttpPath, accessToken),
            children: initials
          }),
          /* @__PURE__ */ _jsx265(RemoveSelectedUserButton, {
            onClick,
            children: /* @__PURE__ */ _jsx265(Cross_default, {
              width: 10,
              height: 10,
              fill: "currentColor"
            })
          })
        ]
      }),
      /* @__PURE__ */ _jsx265(SelectedUserName, {
        variant: "caption",
        title: name,
        children: name
      })
    ]
  });
};

// src/widgets/user/user-select/shared/selected-users/SelectedUsers.tsx
var SelectedUsers = ({ userList, onRemoveUser }) => {
  const { accessToken } = useSession();
  const localStorage2 = useMemo24(() => new LocalStorage_default(), []);
  return /* @__PURE__ */ _jsx266(_Fragment17, {
    children: userList.map((user) => /* @__PURE__ */ _jsx266(SelectedUser, {
      user,
      accessToken: accessToken || localStorage2.get("vc-access-token") || "",
      onRemove: onRemoveUser
    }, user.id))
  });
};

// src/widgets/user/user-select/shared/search-input/SearchInput.tsx
import { jsx as _jsx267 } from "react/jsx-runtime";

// src/widgets/user/user-select/shared/search-input/ui.tsx
import styled63 from "styled-components";
var IconContainer2 = styled63.div`
    min-width: ${getSizeUnit(24)};
    min-height: ${getSizeUnit(24)};
    display: flex;
    justify-content: center;
    align-items: center;
`;

// src/widgets/user/user-select/shared/search-input/SearchInput.tsx
var SearchInput2 = ({ searchValue, isSearching, clearSearchValue, onChange }) => /* @__PURE__ */ _jsx267(textfield_default, {
  isFullWidth: true,
  isContrast: true,
  autoFocus: true,
  value: searchValue,
  placeholder: Translate_default.get("components.userList.searchPlaceholder"),
  onChange,
  InputProps: {
    startAdornment: /* @__PURE__ */ _jsx267(IconContainer2, {
      style: {
        marginRight: getSizeUnit(4)
      },
      children: isSearching ? /* @__PURE__ */ _jsx267(spinner_default, {
        size: 24,
        fill: getCssVar("grey", 500)
      }) : /* @__PURE__ */ _jsx267(Search_default, {
        fill: getCssVar("grey", 500)
      })
    }),
    endAdornment: searchValue ? /* @__PURE__ */ _jsx267("button", {
      onClick: clearSearchValue,
      children: /* @__PURE__ */ _jsx267(Cross_default, {
        height: getSizeUnit(23),
        width: getSizeUnit(23)
      })
    }) : null
  }
});

// src/widgets/user/user-select/shared/searched-users/SearchedUsers.tsx
import { jsx as _jsx271 } from "react/jsx-runtime";
import { useCallback as useCallback27, forwardRef as forwardRef2 } from "react";
import "@mui/material";

// src/widgets/user/user-select/shared/searched-users/shared/PlaceholderError.tsx
import { jsx as _jsx268, jsxs as _jsxs125 } from "react/jsx-runtime";

// src/widgets/user/user-select/shared/searched-users/shared/ui.tsx
import { Stack as StackMui3 } from "@mui/material";
import styled64 from "styled-components";
var WidgetUserItemStyled2 = styled64(WidgetUserItem)`
  border-color:  ${getCssVar("grey", 900)};
`;
var PlaceholderWrapper = styled64.div`
    height: 100%!important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: ${getSizeUnit(16)};
    overflow: hidden;
    height: fit-content;

    && {
        .MuiButton-containedSecondary {
            background-color: ${({ theme }) => theme["color/common/press"]};
            color: ${({ theme }) => theme["color/text/contrast"]};
            box-shadow: none;
            
            &:hover, &:focus, &:active {
                background-color: ${({ theme }) => theme["color/common/hover"]};
                box-shadow: none;
            }
        }
    }
`;
var PlaceholderImageContainer = styled64.div`
    height: ${getSizeUnit(96)};
`;
var PlaceholderContent = styled64.div`
    color: ${({ theme }) => theme["color/text/low-contrast"]};
    font-size: ${getSizeUnit(16)};
    line-height: ${getSizeUnit(22)};
    padding-bottom: ${getSizeUnit(32)};
    white-space: pre-line;
    text-align: center;
`;
var EmptyPlaceholderCaption = styled64(typography_default)``;
var EmptyPlaceholderWrapper = styled64.div`
    height: 100%;
    max-width: 260px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${getSizeUnit(16)};

    ${EmptyPlaceholderCaption} {
        color: ${getCssVar("grey", 500)};
        text-align: center;
    }
`;
var SearchedUsersWrapper = styled64(stack_default)` 
  height: 100%;
  overflow: hidden;
`;
var SearchedUsersInner = styled64(StackMui3)`
  height: 100%;
  position: relative;
  flex-grow: 1;
  white-space: normal;
  overflow-y: scroll;
  ::-webkit-scrollbar-thumb {
    background: #898E9600;
    border-radius: 4px;
    transition: background 0.4s;
  };
  ::-webkit-scrollbar {
      background: #00000000;
      width: 4px;
      opacity: 0;
    };
  &:hover::-webkit-scrollbar-thumb { background: #898E96 };
  &::-webkit-scrollbar-track-piece:end { background: transparent };
  &::-webkit-scrollbar-track-piece:start { background: transparent };
`;

// src/widgets/user/user-select/shared/searched-users/shared/PlaceholderError.tsx
function _define_property210(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread210(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property210(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys176(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props176(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys176(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties165(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose165(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose165(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var PlaceholderError = (_param) => {
  var { onRefresh } = _param, props = _object_without_properties165(_param, [
    "onRefresh"
  ]);
  return /* @__PURE__ */ _jsxs125(PlaceholderWrapper, _object_spread_props176(_object_spread210({}, props), {
    children: [
      /* @__PURE__ */ _jsx268(PlaceholderImageContainer, {
        children: /* @__PURE__ */ _jsx268(SearchError_default, {})
      }),
      /* @__PURE__ */ _jsx268(PlaceholderContent, {
        children: Translate_default.get("components.userList.searchError.title")
      }),
      /* @__PURE__ */ _jsx268(button_default, {
        variant: "contained",
        color: "secondary",
        onClick: onRefresh,
        children: Translate_default.get("components.userList.searchError.refreshBtn")
      })
    ]
  }));
};

// src/widgets/user/user-select/shared/searched-users/shared/SearchEmptyContent.tsx
import { jsx as _jsx269, jsxs as _jsxs126 } from "react/jsx-runtime";
var SearchEmptyContent = () => /* @__PURE__ */ _jsxs126(EmptyPlaceholderWrapper, {
  children: [
    /* @__PURE__ */ _jsx269(SearchEmpty_default, {}),
    /* @__PURE__ */ _jsx269(EmptyPlaceholderCaption, {
      children: Translate_default.get("components.userList.searchEmpty")
    })
  ]
});

// src/widgets/user/user-select/shared/searched-users/shared/NoSearchValue.tsx
import { jsx as _jsx270, jsxs as _jsxs127 } from "react/jsx-runtime";
var NoSearchValue = () => /* @__PURE__ */ _jsxs127(EmptyPlaceholderWrapper, {
  children: [
    /* @__PURE__ */ _jsx270(SearchPeople_default, {}),
    /* @__PURE__ */ _jsx270(EmptyPlaceholderCaption, {
      children: Translate_default.get("components.userList.searchNoValue")
    })
  ]
});

// src/widgets/user/user-select/shared/types.ts
var UserActions;
(function(UserActions2) {
  UserActions2["ADD_MODERATORS"] = "add_moderators";
  UserActions2["ADD_TO_WHITELIST"] = "add_to_whitelist";
  UserActions2["DELETE"] = "delete";
  UserActions2["DELETE_FROM_WHITELIST"] = "delete_from_whitelist";
})(UserActions || (UserActions = {}));

// src/widgets/user/user-select/shared/searched-users/SearchedUsers.tsx
var ADD_ACTIONS = [
  UserActions.ADD_MODERATORS,
  UserActions.ADD_TO_WHITELIST
];
var SearchedUsers = /* @__PURE__ */ forwardRef2(({ userList, userListSelected, maxUserToSave, isSearchEnabled, isSearchError, onScroll, onChangeUserListSelected, onGetUserList }, ref3) => {
  const users = (userList === null || userList === void 0 ? void 0 : userList.items) || [];
  const onSelectUser = useCallback27((user) => {
    onChangeUserListSelected((prevState) => {
      if (prevState.find((el) => el.id === user.id))
        return prevState.filter((el) => el.id !== user.id);
      return [
        ...prevState,
        user
      ];
    });
  }, []);
  if (!isSearchEnabled)
    return /* @__PURE__ */ _jsx271(NoSearchValue, {});
  if (isSearchError)
    return /* @__PURE__ */ _jsx271(PlaceholderError, {
      onRefresh: onGetUserList
    });
  if (users.length === 0)
    return /* @__PURE__ */ _jsx271(SearchEmptyContent, {});
  return /* @__PURE__ */ _jsx271(SearchedUsersWrapper, {
    children: /* @__PURE__ */ _jsx271(SearchedUsersInner, {
      ref: ref3,
      onScroll,
      children: users.map((user) => {
        const isAddAction = user.actions.find((action) => ADD_ACTIONS.includes(action));
        const disabled = !isAddAction || !userListSelected.some((el) => el.id === user.id) && userListSelected.length >= maxUserToSave;
        return /* @__PURE__ */ _jsx271(WidgetUserItemStyled2, {
          user,
          beforeChildren: /* @__PURE__ */ _jsx271(checkbox_default, {
            onClick: onSelectUser.bind(null, user),
            name: "user-select",
            isChecked: userListSelected.some((el) => el.id === user.id),
            disabled,
            style: {
              marginRight: getSizeUnit(18)
            }
          })
        }, user.id);
      })
    })
  });
});
SearchedUsers.displayName = "SearchedUsers";

// src/widgets/user/user-select/index.tsx
var UserSelect = ({ userList, isSearchError, isLoading, maxUserToSave = 50, onGetUserList, onUpdateUserList }) => {
  const [searchValue, setSearchValue] = useState38("");
  const [isSearchEnabled, setIsSearchEnabled] = useState38(false);
  const [userListSelected, setUserListSelected] = useState38([]);
  const { debounce: setIsSearchEnabledDebounced } = useDebounce_default(() => {
    const isSearchEnabled2 = searchValue.trim().length > 2;
    setIsSearchEnabled(isSearchEnabled2);
    if (isSearchEnabled2)
      onGetUserList({
        search: searchValue,
        page: "1"
      });
  }, 300);
  const { listRef, onScroll, page } = useScrollPagination({
    isReady: !userList || isLoading,
    allPages: (userList === null || userList === void 0 ? void 0 : userList.pagination.allPages) || 1,
    request: (page2) => onGetUserList({
      search: searchValue,
      page: page2
    })
  });
  const clearSearchValue = useCallback28(() => {
    setSearchValue("");
  }, []);
  const onChange = useCallback28((event) => {
    var _event_target;
    setSearchValue(event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value);
  }, []);
  const handleRemoveUser = useCallback28((id) => {
    setUserListSelected((prevState) => prevState.filter((el) => el.id !== id));
  }, []);
  useEffect37(() => {
    setIsSearchEnabledDebounced();
  }, [
    searchValue
  ]);
  return /* @__PURE__ */ _jsxs128(ContentWrapper, {
    children: [
      /* @__PURE__ */ _jsx272(SearchInput2, {
        searchValue,
        isSearching: isLoading,
        clearSearchValue,
        onChange
      }),
      userListSelected.length > 0 ? /* @__PURE__ */ _jsx272(SelectedUsersContainer, {
        children: /* @__PURE__ */ _jsx272(SelectedUsers, {
          userList: userListSelected,
          onRemoveUser: handleRemoveUser
        })
      }) : null,
      /* @__PURE__ */ _jsx272(SearchedUsersContainer, {
        children: /* @__PURE__ */ _jsx272(SearchedUsers, {
          ref: listRef,
          userList,
          userListSelected,
          isSearchEnabled,
          isSearchError,
          maxUserToSave,
          onChangeUserListSelected: setUserListSelected,
          onScroll,
          onGetUserList: () => onGetUserList({
            search: searchValue,
            page: `${page}`
          })
        })
      }),
      /* @__PURE__ */ _jsxs128(ButtonsWrapper2, {
        direction: "row",
        children: [
          /* @__PURE__ */ _jsx272(button_default, {
            size: "large",
            color: "primary",
            variant: "contained",
            disabled: isLoading || !userListSelected.length,
            onClick: () => onUpdateUserList(userListSelected.map(({ id }) => id)),
            children: Translate_default.get("components.userList.confirmBtn")
          }),
          /* @__PURE__ */ _jsx272(button_default, {
            size: "large",
            color: "secondary",
            variant: "contained",
            onClick: () => setUserListSelected([]),
            children: Translate_default.get("components.userList.cancelBtn")
          }),
          /* @__PURE__ */ _jsxs128(Typography7, {
            variant: "body2",
            marginLeft: 1,
            children: [
              `${Translate_default.get("components.userList.selected")}:`,
              " ",
              `${userListSelected.length} ${Translate_default.get("misc.from")} ${maxUserToSave}`
            ]
          })
        ]
      })
    ]
  });
};

// src/widgets/settings/access-settings/shared/moderator-management/shared/UserItem.tsx
var DELETE_ACTIONS = [
  UserActions.DELETE,
  UserActions.DELETE_FROM_WHITELIST
];
var UserItem = ({ user, onRemoveUser }) => {
  const renderItemButtons = useMemo25(() => {
    if (user.moderatorRole === "owner")
      return /* @__PURE__ */ _jsx273(typography_default, {
        paddingRight: 1,
        color: getCssVar("green", 500),
        children: Translate_default.get("settings.access.moderatorsManagement.owner")
      });
    const showDeleteButton = user.actions.find((action) => DELETE_ACTIONS.includes(action));
    if (showDeleteButton)
      return /* @__PURE__ */ _jsx273(icon_button_wrapper_default, {
        onClick: () => {
          onRemoveUser(user.id);
        },
        children: /* @__PURE__ */ _jsx273(Trash_default, {
          fill: getCssVar("grey", 500)
        })
      });
    return /* @__PURE__ */ _jsx273(_Fragment18, {});
  }, [
    user
  ]);
  return /* @__PURE__ */ _jsx273(WidgetUserItemStyled, {
    user,
    buttons: renderItemButtons
  }, user.id);
};

// src/widgets/settings/access-settings/shared/moderator-management/index.tsx
var ModeratorManagement = ({ onOpenModeratorAdd, onRemoveModerator, onGetModerators, moderators, isLoading, addBtnText, modalTitleText, modalText }) => {
  const moderatorList = (moderators === null || moderators === void 0 ? void 0 : moderators.items) || [];
  const [isOpenModal, setIsOpenModal] = useState39(false);
  const moderatorIdToRemove = useRef19("");
  const { listRef, onScroll } = useScrollPagination({
    isReady: !moderators || isLoading,
    allPages: (moderators === null || moderators === void 0 ? void 0 : moderators.pagination.allPages) || 1,
    request: onGetModerators
  });
  const handleRemoveUser = (userId) => {
    moderatorIdToRemove.current = userId;
    setIsOpenModal(true);
  };
  return /* @__PURE__ */ _jsxs129(_Fragment19, {
    children: [
      /* @__PURE__ */ _jsxs129(Stack10, {
        spacing: "24px",
        height: "100%",
        children: [
          /* @__PURE__ */ _jsx274(StretchButton2, {
            size: "large",
            variant: "text",
            color: "secondary",
            startIcon: /* @__PURE__ */ _jsx274(AddRound_default, {
              width: 30,
              height: 28
            }),
            onClick: onOpenModeratorAdd,
            children: addBtnText !== null && addBtnText !== void 0 ? addBtnText : Translate_default.get("settings.access.moderatorsManagement.addButton")
          }),
          (isLoading || !moderators) && /* @__PURE__ */ _jsx274(Stack10, {
            spacing: 0.5,
            children: [
              1,
              2,
              3,
              4,
              5
            ].map((idx) => /* @__PURE__ */ _jsx274(Skeleton2, {
              variant: "rounded",
              width: "100%",
              height: 55
            }, idx))
          }),
          !isLoading && !!moderators && /* @__PURE__ */ _jsx274(UserListWrapper, {
            children: /* @__PURE__ */ _jsx274(UserList, {
              ref: listRef,
              onScroll,
              children: moderatorList.map((user) => /* @__PURE__ */ _jsx274(UserItem, {
                user,
                onRemoveUser: handleRemoveUser
              }, user.id))
            })
          })
        ]
      }),
      isOpenModal && /* @__PURE__ */ _jsx274(modal_confirm_default, {
        isOpen: isOpenModal,
        title: modalTitleText !== null && modalTitleText !== void 0 ? modalTitleText : Translate_default.get("settings.access.moderatorsManagement.modalConfirm.title"),
        text: modalText !== null && modalText !== void 0 ? modalText : Translate_default.get("settings.access.moderatorsManagement.modalConfirm.text"),
        buttons: {
          confirm: Translate_default.get("settings.access.moderatorsManagement.modalConfirm.confirmBtn"),
          onConfirm: () => {
            setIsOpenModal(false);
            onRemoveModerator(moderatorIdToRemove.current);
          },
          close: Translate_default.get("settings.access.moderatorsManagement.modalConfirm.closeBtn"),
          onClose: () => setIsOpenModal(false)
        }
      })
    ]
  });
};

// src/widgets/settings/access-settings/index.tsx
var AccessSettings = ({ settings }) => /* @__PURE__ */ _jsx275(Stack11, {
  spacing: "24px",
  children: settings.map((setting, idx) => {
    if (setting.type === "stretchButton")
      return /* @__PURE__ */ _jsxs130(Stack11, {
        children: [
          /* @__PURE__ */ _jsx275(StretchButton, {
            size: "large",
            variant: "text",
            color: "secondary",
            endIcon: /* @__PURE__ */ _jsx275(ChevronRight_default, {}),
            onClick: setting.data.onClick,
            children: setting.data.title
          }),
          /* @__PURE__ */ _jsx275(Typography8, {
            marginTop: 2,
            variant: "caption",
            children: setting.data.caption
          })
        ]
      }, idx);
    return /* @__PURE__ */ _jsx275(_Fragment20, {});
  })
});

// src/forms/connect-error/index.tsx
import { jsx as _jsx277, jsxs as _jsxs132 } from "react/jsx-runtime";
import React144 from "react";

// src/forms/form-wrapper/index.tsx
import { jsx as _jsx276, jsxs as _jsxs131 } from "react/jsx-runtime";
import React143 from "react";

// src/forms/shared/ui.ts
import { Stack as BaseStack, Typography as Typography9 } from "@mui/material";
import styled65, { css as css2 } from "styled-components";
var verySmall = css2`
  @media screen and (max-width: ${breakpoints_default.mobile}px) {
    p,
    a {
      text-align: center;
      font-size: ${getCssVar("font", "small")};
    }
  }
`;
var StyledTypography2 = styled65(Typography9)`
  color: ${getCssVar("grey", 700)};
  a {
    color: ${getCssVar("grey", 500)};
    :hover {
      color: ${getCssVar("grey", 600)};
    }
  }
`;
var Wrapper3 = styled65.div`
  display: flex;
  flex-direction: column;
  max-width: 404px;
  width: 100%;
  position: relative;
  & p.Mui-error {
    position: initial;
  }
`;
var AgreementSection = styled65.section`
  width: 100%;
  text-align: center;
  margin: auto;
  position: absolute;
  bottom: -6.4rem;
  padding: 0px 3.2rem;
  & .MuiTypography-root {
    text-align: center;
    color: ${getCssVar("grey", 700)};
    font-family: 'VTBGroupUIWebBook', sans-serif;
    a {
      color: ${getCssVar("grey", 500)};
      font-size: inherit;
      :hover {
        color: ${getCssVar("grey", 600)};
      }
    }
  }
  @media screen and (max-width: ${breakpoints_default.xs}px) {
    padding: 0;
    span {
      font-size: 2.6vw;
      line-height: 1.4vw;
    }
  }
`;
var FormContainer = styled65.section`
  padding: 2.4rem 3.2rem;
  scrollbar-width: none;
  min-height: 420px;

  &::-webkit-scrollbar {
    display: none;
  }

  width: 100%;
  border: 1px solid ${getCssVar("grey", 950)};
  border-radius: 8px;

  box-shadow: 0 0 250px ${getCssVar("black", 100)}, 0 0 250px #101213;

  background-color: ${getCssVar("grey", 950)};

  @media screen and (max-width: ${breakpoints_default.md}px) {
    padding: 2.4rem;
    border-radius: unset;
  }
`;
var BackButtonSection = styled65.section`
  top: -3.2rem;
  position: absolute;
`;
var StorySubstrate3 = styled65.div`
  height: 800px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var ButtonSeparator = styled65.div`
  height: 3.8rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
`;
var Line = styled65.div`
  height: 1px;
  background-color: ${getCssVar("grey", 900)};
  width: 100%;
`;
var TitleSection = styled65.section`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  > .MuiTypography-root {
    letter-spacing: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  @media screen and (max-width: ${breakpoints_default.desktop}px) {
    align-items: center;
    > .MuiTypography-root {
      text-align: center;
      justify-content: center;
    }
  }
  ${verySmall}
`;
var TitleSectionWideGap = styled65(TitleSection)`
  gap: 4rem;
`;
var ButtonsSection = styled65.section`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
var FooterSection = styled65.section`
  display: flex;
  justify-content: center;
  min-height: 1.8rem;
  ${verySmall}
`;
var IconWrapper = styled65.div`
  display: flex;
  align-items: center;
  margin-right: 1.2rem;
`;
var InnerWrapper = styled65.div`
  display: flex;
  flex-direction: column;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  width: 100%;
  min-height: 476px;
  line-height: ${getCssVar("font", "line-height")};
  font-size: ${getCssVar("font", "common")};

  justify-content: space-between;

  @media screen and (max-width: ${breakpoints_default.mobile}px) {
    min-height: 340px;
  }
`;
var InnerWrapperWithPadding = styled65(InnerWrapper)`
  padding: 0.8rem 0;
`;
var PasswordWrapper = styled65.div`
  position: relative;
  > button.MuiButtonBase-root {
    position: absolute;
  }
  > div.MuiFormControl-root {
    position: relative;
    margin: 1.6rem 0 0;
    display: flex;
  }
`;
var FormSection2 = styled65(FormSection)`
  margin-top: 0;
  margin-bottom: 2.4rem;
  > div.MuiFormControl-root {
    position: relative;
    margin: 1.6rem 0 0;
    display: flex;
  }
`;
var IconButtonWrapper4 = styled65(IconButtonWrapper3)`
  position: absolute;
  right: 8px;
  top: 26px;
`;
var ErrorText = styled65(Typography9)`
  color: ${getCssVar("red", 300)};
  position: absolute;
  left: 0;
  bottom: -2rem;
`;
var ChipLink = styled65(chip_default)`
  border-color: ${getCssVar("grey", 900)};
  cursor: pointer;
`;
var PasswordRequirements2 = styled65(password_requirements_default)`
  background-color: ${getCssVar("grey", 900)};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.4), 0px 0px 6px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  width: 100%;
  padding: 1.6rem 1rem;
  gap: 0.8rem;
  & .MuiTypography-root {
    color: ${getCssVar("grey", 100)};
    font-family: VTBGroupUIWebBook, sans-serif;
  }
`;
var WordBreakSpan = styled65.span`
  word-break: break-word;
`;
var Stack12 = styled65(BaseStack)`
  margin: 1.5rem 0;
  > div {
    margin-top: 0.2rem;
  }
  > span.MuiTypography-root {
    margin-left: 1.2rem;
    padding-right: 2rem;
    color: ${getCssVar("grey", 500)};
    & .MuiLink-root {
      font-size: inherit;
      color: ${getCssVar("grey", 100)};
    }
  }
  span.MuiCheckbox-root {
    display: flex;
    position: relative;
    padding: 0;
    width: 2rem;
    height: 2rem;
    border: 1px solid transparent;
    border-radius: 0.4rem;
    border-color: ${getCssVar("grey", 500)};
    border-radius: 0.4rem;
    transition: all 0.27s;
  }
  span.Mui-checked {
    border-color: transparent;
    background: ${getCssVar("blue", 500)};
  }
`;
var InfoPlate = styled65.div`
  background-color: ${getCssVar("grey", 900)};
  border-radius: 4px;
  padding: 1.4rem;
  display: flex;
  gap: 1rem;
  > svg {
    flex: 0 0 1.2rem;
    margin-top: 0.2rem;
  }
`;
var JoinButtonWrapper = styled65.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  button:last-child {
    min-width: 3.8rem;
    padding: 0;
  }
`;
var QRModal = styled65.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 41.6rem;
`;
var QRWrapper = styled65.div`
  display: flex;
  width: 19rem;
  height: 19rem;
  justify-content: center;
  align-items: center;
  background-color: ${({ isURLValid }) => isURLValid ? "#fff" : getCssVar("grey", 900)};
  border-radius: 0.8rem;
  padding: 1.6rem;
  margin: 1.6rem 0;
  flex-direction: column;
`;

// src/forms/form-wrapper/index.tsx
var WrapperForm = ({ linkComponent: LinkComponent2, children, backButton, hideAgreement = true, className }) => /* @__PURE__ */ _jsxs131(Wrapper3, {
  className,
  children: [
    Boolean(backButton) && /* @__PURE__ */ _jsx276(BackButtonSection, {
      children: /* @__PURE__ */ _jsx276(StyledTypography2, {
        variant: "body1",
        children: /* @__PURE__ */ _jsx276(link_default, {
          id: "back-link",
          href: backButton === null || backButton === void 0 ? void 0 : backButton.href,
          rel: "noreferrer",
          component: LinkComponent2,
          onClick: () => {
            proxyMessage.send({
              // TODO: Events
              // @ts-ignore
              type: "events",
              data: {
                // @ts-ignore
                action: {
                  close: "allow",
                  show: "main-window"
                }
              }
            });
            if (backButton === null || backButton === void 0 ? void 0 : backButton.callback) {
              backButton === null || backButton === void 0 ? void 0 : backButton.callback();
            }
          },
          children: Translate_default.get("buttons.goBack")
        })
      })
    }),
    /* @__PURE__ */ _jsx276(FormContainer, {
      children
    }),
    !hideAgreement && LinkComponent2 && /* @__PURE__ */ _jsx276(AgreementSection, {
      children: /* @__PURE__ */ _jsx276(user_agreement_default, {
        linkComponent: LinkComponent2
      })
    })
  ]
});
var form_wrapper_default = /* @__PURE__ */ React143.memo(WrapperForm);

// src/forms/connect-error/shared/ui.ts
import styled66 from "styled-components";
var FormSection3 = styled66(FormSection2)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  justify-content: center;
  gap: 2.4rem;
`;

// src/forms/connect-error/index.tsx
var FormConnectError = ({ backHref, isMobile = false, linkComponent: LinkComponent2 }) => /* @__PURE__ */ _jsx277(form_wrapper_default, {
  children: /* @__PURE__ */ _jsxs132(InnerWrapperWithPadding, {
    children: [
      /* @__PURE__ */ _jsxs132(FormSection3, {
        children: [
          /* @__PURE__ */ _jsx277(Error_default, {}),
          /* @__PURE__ */ _jsxs132(typography_default, {
            align: "center",
            variant: "h4",
            children: [
              Translate_default.get("forms.connect.errorTitle.1"),
              /* @__PURE__ */ _jsx277("br", {}),
              Translate_default.get("forms.connect.errorTitle.2")
            ]
          })
        ]
      }),
      /* @__PURE__ */ _jsx277(ButtonsSection, {
        children: isMobile ? /* @__PURE__ */ _jsx277(button_default, {
          fullWidth: true,
          id: "back-button",
          color: "primary",
          variant: "contained",
          onClick: () => window.location.replace(backHref),
          children: Translate_default.get("buttons.repeat")
        }) : /* @__PURE__ */ _jsx277(button_default, {
          fullWidth: true,
          id: "back-button",
          color: "primary",
          variant: "contained",
          component: LinkComponent2,
          to: backHref,
          children: Translate_default.get("buttons.toMain")
        })
      })
    ]
  })
});
var connect_error_default = /* @__PURE__ */ React144.memo(FormConnectError);

// src/forms/general/index.tsx
import { jsx as _jsx278, jsxs as _jsxs133 } from "react/jsx-runtime";
import React145 from "react";
var FormGeneral = ({ signInHref, signInSSOHref, registerHref, downloadLink, joinEventHref, isElectron: isElectron6 = false, linkComponent: LinkComponent2 }) => /* @__PURE__ */ _jsx278(form_wrapper_default, {
  hideAgreement: false,
  linkComponent: LinkComponent2,
  children: /* @__PURE__ */ _jsxs133(InnerWrapper, {
    children: [
      /* @__PURE__ */ _jsxs133(TitleSection, {
        children: [
          /* @__PURE__ */ _jsx278(typography_default, {
            variant: "h4",
            children: `${Translate_default.get("forms.general.title")}`
          }),
          /* @__PURE__ */ _jsxs133(typography_default, {
            variant: "body1",
            children: [
              Translate_default.get("forms.general.subtitle"),
              " ",
              /* @__PURE__ */ _jsx278(link_default, {
                color: "primary",
                to: registerHref,
                component: LinkComponent2,
                children: Translate_default.get("links.register")
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ _jsxs133(ButtonsSection, {
        children: [
          /* @__PURE__ */ _jsx278(button_default, {
            fullWidth: true,
            id: "go-to-signin-link",
            variant: "contained",
            color: "primary",
            component: LinkComponent2,
            to: signInHref,
            children: Translate_default.get("buttons.signIn")
          }),
          /* @__PURE__ */ _jsxs133(button_default, {
            fullWidth: true,
            id: "go-to-signin-sso-link",
            variant: "contained",
            color: "secondary",
            component: LinkComponent2,
            to: signInSSOHref,
            children: [
              /* @__PURE__ */ _jsx278(IconWrapper, {
                children: /* @__PURE__ */ _jsx278(Key_default, {})
              }),
              " ",
              Translate_default.get("buttons.signInSSO")
            ]
          }),
          /* @__PURE__ */ _jsxs133(ButtonSeparator, {
            children: [
              /* @__PURE__ */ _jsx278(Line, {}),
              /* @__PURE__ */ _jsx278(typography_default, {
                variant: "body1",
                align: "center",
                children: Translate_default.get("misc.or")
              }),
              /* @__PURE__ */ _jsx278(Line, {})
            ]
          }),
          /* @__PURE__ */ _jsx278(button_default, {
            fullWidth: true,
            id: "go-to-event-link",
            variant: "contained",
            color: "secondary",
            component: LinkComponent2,
            to: joinEventHref,
            children: Translate_default.get("buttons.joinEvent")
          })
        ]
      }),
      /* @__PURE__ */ _jsx278(FooterSection, {
        children: !isElectron6 && /* @__PURE__ */ _jsx278(download_app_link_default, {
          linkComponent: LinkComponent2,
          callback: downloadLink.callback,
          to: downloadLink.href
        })
      })
    ]
  })
});
var general_default = /* @__PURE__ */ React145.memo(FormGeneral);

// src/forms/reset-password/index.tsx
import { jsx as _jsx279, jsxs as _jsxs134 } from "react/jsx-runtime";
import React146 from "react";
var FormResetPassword = ({ initialValues: initialValues2, linkComponent: LinkComponent2, validateOnBlur, validationSchema, onSubmit }) => /* @__PURE__ */ _jsx279(form_wrapper_default, {
  backButton: {
    href: "/auth"
  },
  linkComponent: LinkComponent2,
  children: /* @__PURE__ */ _jsx279(form_default, {
    initialValues: initialValues2,
    formProvider: provider_default2,
    formComponent: FormComponent,
    validateOnBlur,
    validationSchema,
    onSubmit,
    children: ({ values: values2 }) => /* @__PURE__ */ _jsxs134(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsxs134(TitleSectionWideGap, {
          children: [
            /* @__PURE__ */ _jsx279(typography_default, {
              variant: "h4",
              children: Translate_default.get("forms.reset-password.title")
            }),
            /* @__PURE__ */ _jsx279(field_default, {
              autoFocus: true,
              required: true,
              fullWidth: true,
              id: "email",
              label: Translate_default.get("fields.email.label"),
              name: "email",
              type: "email",
              placeholder: "example@company.ru"
            })
          ]
        }),
        /* @__PURE__ */ _jsx279(ButtonsSection, {
          children: /* @__PURE__ */ _jsx279(button_default, {
            fullWidth: true,
            id: "reset-password-button",
            type: "submit",
            color: "primary",
            variant: "contained",
            disabled: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values2.email),
            sx: {
              marginTop: "32px"
            },
            children: Translate_default.get("buttons.getPin")
          })
        })
      ]
    })
  })
});
var reset_password_default2 = /* @__PURE__ */ React146.memo(FormResetPassword);

// src/forms/reset-password-confirm/index.tsx
import { jsx as _jsx280, jsxs as _jsxs135 } from "react/jsx-runtime";
import React147, { useEffect as useEffect38, useState as useState40 } from "react";
import * as Yup from "yup";

// src/forms/reset-password-confirm/shared/ui.ts
import styled67 from "styled-components";
var FormSection4 = styled67(FormSection2)`
    > button {
        font-size: ${getCssVar("font", "small")};
        font-weight: normal;
        color: ${getCssVar("blue", "300")};
    }
`;

// src/forms/reset-password-confirm/index.tsx
var ResetPasswordConfirmSchema = Yup.object().shape({
  pin: Yup.string().min(4, () => Translate_default.get("errors.yupValidation.incorrectPin")).max(4, () => Translate_default.get("errors.yupValidation.incorrectPin")).required(() => Translate_default.get("errors.yupValidation.setPin")),
  password: Yup.string().min(8, () => Translate_default.get("errors.yupValidation.invalidPass")).max(20, () => Translate_default.get("errors.yupValidation.invalidPass")).required(() => Translate_default.get("errors.yupValidation.requiredField")).matches(/(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-_~!^()[\]&%$#@?.*+,:;'"\\/|><{}&]).{8,}$)/, () => Translate_default.get("errors.yupValidation.badPass")),
  password_confirm: Yup.string().required(() => Translate_default.get("errors.yupValidation.passNotEquals")).oneOf([
    Yup.ref("password"),
    null
  ], () => Translate_default.get("errors.yupValidation.passNotEquals"))
});
var FormResetPasswordConfirm = ({ initialValues: initialValues2, timeout = 2 * 60 * 1e3, sessionKey, email, validateOnBlur, validationSchema = ResetPasswordConfirmSchema, linkComponent: LinkComponent2, dataPin, requestPin, onSubmit, onExit }) => {
  const [isPasswordFocused, setIsPasswordFocused] = useState40(false);
  const [passwordVisible, setPasswordVisible] = useState40(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState40(false);
  useEffect38(() => {
    if (!email && !sessionKey) {
      onExit && onExit();
    }
  }, [
    email,
    sessionKey
  ]);
  return /* @__PURE__ */ _jsx280(form_wrapper_default, {
    backButton: {
      href: "/reset-password"
    },
    linkComponent: LinkComponent2,
    children: /* @__PURE__ */ _jsx280(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validateOnBlur,
      validationSchema,
      onSubmit,
      children: ({ dirty, isValid, values: values2, handleBlur }) => /* @__PURE__ */ _jsxs135(InnerWrapperWithPadding, {
        children: [
          /* @__PURE__ */ _jsx280(TitleSectionWideGap, {
            children: /* @__PURE__ */ _jsxs135(typography_default, {
              variant: "h4",
              children: [
                Translate_default.get("forms.reset-password.confirmTitle.1"),
                /* @__PURE__ */ _jsx280(WordBreakSpan, {
                  children: email
                }),
                Translate_default.get("forms.reset-password.confirmTitle.2")
              ]
            })
          }),
          /* @__PURE__ */ _jsxs135(FormSection4, {
            children: [
              /* @__PURE__ */ _jsx280(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                label: Translate_default.get("fields.pin.label"),
                id: "pin",
                name: "pin",
                type: "text",
                placeholder: "****",
                "data-pin": dataPin
              }),
              /* @__PURE__ */ _jsxs135(typography_default, {
                variant: "caption",
                color: "#4E5158",
                children: [
                  Translate_default.get("forms.reset-password.confirmMessage.1"),
                  /* @__PURE__ */ _jsx280("br", {}),
                  Translate_default.get("forms.reset-password.confirmMessage.2"),
                  /* @__PURE__ */ _jsx280("br", {}),
                  Translate_default.get("forms.reset-password.confirmMessage.3")
                ]
              }),
              /* @__PURE__ */ _jsx280(new_pin_default, {
                timeout,
                request: requestPin,
                variant: "text"
              }),
              /* @__PURE__ */ _jsxs135(PasswordWrapper, {
                children: [
                  /* @__PURE__ */ _jsx280(field_default, {
                    required: true,
                    fullWidth: true,
                    id: "password",
                    label: Translate_default.get("fields.newPassword.label"),
                    name: "password",
                    type: passwordVisible ? "text" : "password",
                    placeholder: Translate_default.get("fields.newPassword.placeholder"),
                    autoComplete: "new-password",
                    onFocus: () => setIsPasswordFocused(true),
                    onBlur: (e) => {
                      setIsPasswordFocused(false);
                      handleBlur(e);
                    }
                  }),
                  /* @__PURE__ */ _jsx280(IconButtonWrapper4, {
                    onClick: () => setPasswordVisible(!passwordVisible),
                    tabIndex: -1,
                    children: passwordVisible ? /* @__PURE__ */ _jsx280(EyeOpen_default, {}) : /* @__PURE__ */ _jsx280(EyeClose_default, {})
                  }),
                  /* @__PURE__ */ _jsx280(PasswordRequirements2, {
                    isOpen: isPasswordFocused,
                    password: values2.password
                  })
                ]
              }),
              /* @__PURE__ */ _jsxs135(PasswordWrapper, {
                children: [
                  /* @__PURE__ */ _jsx280(field_default, {
                    required: true,
                    fullWidth: true,
                    id: "password_confirm",
                    label: Translate_default.get("fields.confirmPassword.label"),
                    name: "password_confirm",
                    type: repeatPasswordVisible ? "text" : "password",
                    placeholder: Translate_default.get("fields.confirmPassword.placeholder"),
                    autoComplete: "new-password"
                  }),
                  /* @__PURE__ */ _jsx280(IconButtonWrapper4, {
                    onClick: () => setRepeatPasswordVisible(!repeatPasswordVisible),
                    tabIndex: -1,
                    children: repeatPasswordVisible ? /* @__PURE__ */ _jsx280(EyeOpen_default, {}) : /* @__PURE__ */ _jsx280(EyeClose_default, {})
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ _jsx280(ButtonsSection, {
            children: /* @__PURE__ */ _jsx280(button_default, {
              fullWidth: true,
              id: "reset-confirm-button",
              type: "submit",
              color: "primary",
              variant: "contained",
              disabled: !(dirty && isValid),
              children: Translate_default.get("buttons.changePass")
            })
          })
        ]
      })
    })
  });
};
var reset_password_confirm_default2 = /* @__PURE__ */ React147.memo(FormResetPasswordConfirm);

// src/forms/sign-in-guest/index.tsx
import { jsx as _jsx281, jsxs as _jsxs136 } from "react/jsx-runtime";
import React148 from "react";
import * as Yup2 from "yup";

// src/forms/sign-in-guest/shared/ui.ts
import styled68 from "styled-components";
var ButtonsSection2 = styled68(ButtonsSection)`
    margin-bottom: 3.6rem;
`;

// src/forms/sign-in-guest/index.tsx
var initialValues = {
  email: ""
};
var signInGuestSchema = Yup2.object().shape({
  name: Yup2.string().required("").min(3, "")
});
var FormSignInGuest = ({ accountHref, downloadLink, linkComponent: LinkComponent2, validateOnBlur, onSubmit, slug, isElectron: isElectron6 = false }) => /* @__PURE__ */ _jsx281(form_wrapper_default, {
  hideAgreement: false,
  backButton: {
    href: "/connect"
  },
  linkComponent: LinkComponent2,
  children: /* @__PURE__ */ _jsx281(form_default, {
    initialValues,
    formProvider: provider_default2,
    formComponent: FormComponent,
    validationSchema: signInGuestSchema,
    validateOnBlur,
    onSubmit,
    children: ({ dirty, isValid }) => /* @__PURE__ */ _jsxs136(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsx281(TitleSection, {
          children: /* @__PURE__ */ _jsx281(typography_default, {
            variant: "h4",
            fontWeight: "500",
            children: Translate_default.get("forms.sign-in.guestTitle", {
              slug
            })
          })
        }),
        /* @__PURE__ */ _jsxs136(ButtonsSection2, {
          children: [
            /* @__PURE__ */ _jsx281(field_default, {
              autoFocus: true,
              required: true,
              fullWidth: true,
              id: "name",
              label: Translate_default.get("fields.name.label"),
              name: "name",
              type: "text",
              placeholder: Translate_default.get("fields.name.placeholder")
            }),
            /* @__PURE__ */ _jsx281(button_default, {
              fullWidth: true,
              id: "login-guest-button",
              color: "primary",
              variant: "contained",
              type: "submit",
              disabled: !(dirty && isValid),
              children: Translate_default.get("buttons.signInGuest")
            }),
            /* @__PURE__ */ _jsxs136(ButtonSeparator, {
              children: [
                /* @__PURE__ */ _jsx281(Line, {}),
                /* @__PURE__ */ _jsx281(typography_default, {
                  variant: "body1",
                  align: "center",
                  children: Translate_default.get("misc.or")
                }),
                /* @__PURE__ */ _jsx281(Line, {})
              ]
            }),
            /* @__PURE__ */ _jsx281(button_default, {
              fullWidth: true,
              id: "go-to-account",
              variant: "contained",
              color: "primary",
              component: LinkComponent2,
              to: accountHref,
              children: Translate_default.get("buttons.enterAccount")
            })
          ]
        }),
        /* @__PURE__ */ _jsx281(FooterSection, {
          children: !isElectron6 && downloadLink && /* @__PURE__ */ _jsx281(download_app_link_default, {
            linkComponent: LinkComponent2,
            callback: downloadLink.callback,
            to: downloadLink.href
          })
        })
      ]
    })
  })
});
var sign_in_guest_default = /* @__PURE__ */ React148.memo(FormSignInGuest);

// src/forms/sign-in/index.tsx
import { jsx as _jsx282, jsxs as _jsxs137 } from "react/jsx-runtime";
import React149, { useState as useState41 } from "react";
import * as Yup3 from "yup";
var signInSchema = Yup3.object().shape({
  email: Yup3.string().email(() => Translate_default.get("errors.yupValidation.requiredField")).required(() => Translate_default.get("errors.yupValidation.requiredField")),
  password: Yup3.string().required(() => Translate_default.get("errors.yupValidation.requiredField"))
});
var FormSignIn = ({ initialValues: initialValues2, signInSSOHref, resetHref, downloadLink, isElectron: isElectron6 = false, linkComponent: LinkComponent2, validationSchema = signInSchema, validateOnBlur, hideAgreement, backButton, onSubmit }) => {
  const [passwordVisible, setPasswordVisible] = useState41(false);
  var _backButton_href;
  return /* @__PURE__ */ _jsx282(form_wrapper_default, {
    backButton: {
      href: (_backButton_href = backButton === null || backButton === void 0 ? void 0 : backButton.href) !== null && _backButton_href !== void 0 ? _backButton_href : "/"
    },
    linkComponent: LinkComponent2,
    hideAgreement,
    children: /* @__PURE__ */ _jsx282(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validationSchema,
      validateOnBlur,
      onSubmit,
      children: ({ dirty, isValid }) => /* @__PURE__ */ _jsxs137(InnerWrapper, {
        children: [
          /* @__PURE__ */ _jsx282(TitleSection, {
            children: /* @__PURE__ */ _jsx282(typography_default, {
              variant: "h4",
              children: Translate_default.get("forms.sign-in.title")
            })
          }),
          /* @__PURE__ */ _jsxs137(FormSection2, {
            children: [
              /* @__PURE__ */ _jsx282(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                id: "email",
                label: Translate_default.get("fields.email.label"),
                name: "email",
                type: "email",
                placeholder: "example@company.ru"
              }),
              /* @__PURE__ */ _jsxs137(PasswordWrapper, {
                children: [
                  /* @__PURE__ */ _jsx282(field_default, {
                    required: true,
                    fullWidth: true,
                    id: "password",
                    label: Translate_default.get("fields.password.label"),
                    name: "password",
                    type: passwordVisible ? "text" : "password",
                    placeholder: Translate_default.get("fields.password.placeholder"),
                    autoComplete: "off"
                  }),
                  /* @__PURE__ */ _jsx282(IconButtonWrapper4, {
                    onClick: () => setPasswordVisible(!passwordVisible),
                    tabIndex: -1,
                    children: passwordVisible ? /* @__PURE__ */ _jsx282(EyeOpen_default, {}) : /* @__PURE__ */ _jsx282(EyeClose_default, {})
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ _jsxs137(ButtonsSection, {
            children: [
              /* @__PURE__ */ _jsx282(button_default, {
                fullWidth: true,
                id: "login-button",
                color: "primary",
                variant: "contained",
                type: "submit",
                disabled: !(dirty && isValid),
                children: Translate_default.get("buttons.signIn")
              }),
              /* @__PURE__ */ _jsxs137(button_default, {
                fullWidth: true,
                id: "go-to-signin-sso-link",
                variant: "contained",
                color: "secondary",
                component: LinkComponent2,
                to: signInSSOHref,
                children: [
                  /* @__PURE__ */ _jsx282(IconWrapper, {
                    children: /* @__PURE__ */ _jsx282(Key_default, {})
                  }),
                  " ",
                  Translate_default.get("buttons.signInSSO")
                ]
              }),
              /* @__PURE__ */ _jsx282(button_default, {
                fullWidth: true,
                id: "restore-password-link",
                variant: "text",
                color: "secondary",
                component: LinkComponent2,
                to: resetHref,
                children: Translate_default.get("buttons.resetPass")
              })
            ]
          }),
          /* @__PURE__ */ _jsx282(FooterSection, {
            children: !isElectron6 && /* @__PURE__ */ _jsx282(download_app_link_default, {
              linkComponent: LinkComponent2,
              callback: downloadLink.callback,
              to: downloadLink.href
            })
          })
        ]
      })
    })
  });
};
var sign_in_default2 = /* @__PURE__ */ React149.memo(FormSignIn);

// src/forms/sign-up/index.tsx
import { jsx as _jsx283, jsxs as _jsxs138 } from "react/jsx-runtime";
import React150, { useState as useState42 } from "react";
import * as Yup4 from "yup";

// src/forms/sign-up/shared/ui.ts
import styled69 from "styled-components";
import { Stack as BaseStack2 } from "@mui/material";
var Stack13 = styled69(BaseStack2)`
  margin: 1.5rem 0;
  > div {
    margin-top: 0.2rem;
  }
  > span.MuiTypography-root {
    margin-left: 1.2rem;
    padding-right: 2rem;
    color: ${getCssVar("grey", 500)};
    & .MuiLink-root {
      font-size: inherit;
      color: ${getCssVar("grey", 100)};
    }
  }
  span.MuiCheckbox-root {
    display: flex;
    position: relative;
    padding: 0;
    width: 2rem;
    height: 2rem;
    border: 1px solid transparent;
    border-radius: 0.4rem;
    border-color: ${getCssVar("grey", 500)};
    border-radius: 0.4rem;
    transition: all 0.27s;
  }
  span.Mui-checked {
    border-color: transparent;
    background: ${getCssVar("blue", 500)};
  } 
`;

// src/forms/sign-up/index.tsx
var signUpSchema = Yup4.object().shape({
  name: Yup4.string().min(3, () => Translate_default.get("errors.yupValidation.min3")).max(64, () => Translate_default.get("errors.yupValidation.max64")).required(() => Translate_default.get("errors.yupValidation.requiredFieldVaried")).matches(NAME_REGEX_WORDS_NUM, () => Translate_default.get("errors.yupValidation.firstAndLastName")).matches(NAME_REGEX_LETTERS, () => Translate_default.get("errors.yupValidation.onlyLetters")),
  email: Yup4.string().email(() => Translate_default.get("errors.yupValidation.invalidEmail")).required(() => Translate_default.get("errors.yupValidation.requiredFieldVaried")),
  password: Yup4.string().min(8, () => Translate_default.get("errors.yupValidation.invalidPass")).max(20, () => Translate_default.get("errors.yupValidation.invalidPass")).required(() => Translate_default.get("errors.yupValidation.requiredFieldVaried")).matches(/(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-_~!^()[\]&%$#@?.*+,:;'"\\/|><{}&]).{8,}$)/, () => Translate_default.get("errors.yupValidation.badPass")),
  password2: Yup4.string().required(() => Translate_default.get("errors.yupValidation.requiredFieldVaried")).oneOf([
    Yup4.ref("password"),
    null
  ], () => Translate_default.get("errors.yupValidation.passNotEquals"))
});
var FormSignUp = ({ initialValues: initialValues2, linkComponent: LinkComponent2, validationSchema = signUpSchema, validateOnBlur, backButton, hideAgreement, onSubmit }) => {
  const [passwordVisible, setPasswordVisible] = useState42(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState42(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState42(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState42(false);
  var _backButton_href;
  return /* @__PURE__ */ _jsx283(form_wrapper_default, {
    backButton: {
      href: (_backButton_href = backButton === null || backButton === void 0 ? void 0 : backButton.href) !== null && _backButton_href !== void 0 ? _backButton_href : "/"
    },
    linkComponent: LinkComponent2,
    hideAgreement,
    children: /* @__PURE__ */ _jsx283(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validationSchema,
      validateOnBlur,
      onSubmit,
      children: ({ dirty, isValid, values: values2, handleBlur }) => /* @__PURE__ */ _jsxs138(InnerWrapper, {
        children: [
          /* @__PURE__ */ _jsx283(TitleSection, {
            children: /* @__PURE__ */ _jsx283(typography_default, {
              variant: "h4",
              children: Translate_default.get("forms.sign-up.title")
            })
          }),
          /* @__PURE__ */ _jsxs138(FormSection2, {
            children: [
              /* @__PURE__ */ _jsx283(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                id: "name",
                label: Translate_default.get("fields.fio.label"),
                name: "name",
                type: "text",
                placeholder: Translate_default.get("fields.fio.placeholder")
              }),
              /* @__PURE__ */ _jsx283(field_default, {
                required: true,
                fullWidth: true,
                id: "email",
                label: Translate_default.get("fields.email.label"),
                name: "email",
                type: "email",
                placeholder: "example@company.ru"
              }),
              /* @__PURE__ */ _jsxs138(PasswordWrapper, {
                children: [
                  /* @__PURE__ */ _jsx283(field_default, {
                    required: true,
                    fullWidth: true,
                    id: "password",
                    label: Translate_default.get("fields.password.label"),
                    name: "password",
                    type: passwordVisible ? "text" : "password",
                    placeholder: Translate_default.get("fields.password.placeholder"),
                    autoComplete: "off",
                    onFocus: () => setIsPasswordFocused(true),
                    onBlur: (e) => {
                      setIsPasswordFocused(false);
                      handleBlur(e);
                    }
                  }),
                  /* @__PURE__ */ _jsx283(IconButtonWrapper4, {
                    onClick: () => setPasswordVisible(!passwordVisible),
                    tabIndex: -1,
                    children: passwordVisible ? /* @__PURE__ */ _jsx283(EyeOpen_default, {}) : /* @__PURE__ */ _jsx283(EyeClose_default, {})
                  }),
                  /* @__PURE__ */ _jsx283(PasswordRequirements2, {
                    isOpen: isPasswordFocused,
                    password: values2.password
                  })
                ]
              }),
              /* @__PURE__ */ _jsxs138(PasswordWrapper, {
                children: [
                  /* @__PURE__ */ _jsx283(field_default, {
                    required: true,
                    fullWidth: true,
                    id: "password2",
                    label: Translate_default.get("fields.repeatPassword.label"),
                    name: "password2",
                    type: repeatPasswordVisible ? "text" : "password",
                    placeholder: Translate_default.get("fields.repeatPassword.placeholder")
                  }),
                  /* @__PURE__ */ _jsx283(IconButtonWrapper4, {
                    onClick: () => setRepeatPasswordVisible(!repeatPasswordVisible),
                    tabIndex: -1,
                    children: repeatPasswordVisible ? /* @__PURE__ */ _jsx283(EyeOpen_default, {}) : /* @__PURE__ */ _jsx283(EyeClose_default, {})
                  })
                ]
              }),
              /* @__PURE__ */ _jsxs138(Stack13, {
                direction: "row",
                alignItems: "start",
                children: [
                  /* @__PURE__ */ _jsx283(checkbox_default, {
                    name: "agreement",
                    isChecked: isAgreementChecked,
                    onChange: () => setIsAgreementChecked(!isAgreementChecked)
                  }),
                  /* @__PURE__ */ _jsxs138(typography_default, {
                    variant: "caption",
                    children: [
                      Translate_default.get("forms.sign-up.agreement.1"),
                      /* @__PURE__ */ _jsx283(link_default, {
                        id: "go-to-user-agreement",
                        component: LinkComponent2,
                        to: "/agreement",
                        color: "secondary",
                        target: "_blank",
                        rel: "noreferrer",
                        children: Translate_default.get("links.userAgreement.1")
                      }),
                      Translate_default.get("forms.sign-up.agreement.2"),
                      /* @__PURE__ */ _jsx283(link_default, {
                        id: "go-to-policy",
                        component: LinkComponent2,
                        to: "/policy",
                        color: "secondary",
                        target: "_blank",
                        rel: "noreferrer",
                        children: Translate_default.get("links.privacyPolicy")
                      })
                    ]
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ _jsx283(ButtonsSection, {
            children: /* @__PURE__ */ _jsx283(button_default, {
              fullWidth: true,
              id: "login-button",
              color: "primary",
              variant: "contained",
              type: "submit",
              disabled: !(dirty && isValid && isAgreementChecked),
              children: Translate_default.get("buttons.continue")
            })
          })
        ]
      })
    })
  });
};
var sign_up_default2 = /* @__PURE__ */ React150.memo(FormSignUp);

// src/forms/sign-up-confirm/index.tsx
var import_lodash16 = __toESM(require_lodash());
import { jsx as _jsx285, jsxs as _jsxs139 } from "react/jsx-runtime";
import React152, { useEffect as useEffect39, useState as useState43 } from "react";
import * as Yup5 from "yup";

// src/forms/sign-up-confirm/shared/ui.ts
import styled70 from "styled-components";
import { Stack as BaseStack3 } from "@mui/material";
var StyledTypography3 = styled70(typography_default)`
  margin-left: 1.2rem;
  padding-right: 2rem;
  color: ${getCssVar("grey", 500)};
  > .MuiLink-root {
    font-size: inherit;
    color: ${getCssVar("grey", 100)};
  }
`;
var Stack14 = styled70(BaseStack3)`
  margin: 1.6rem 0;
  > div {
    margin-top: 0.2rem;
  }
`;
var FormSection5 = styled70(FormSection2)`
  display: flex;
  flex-direction: column;

`;
var FieldWrapper = styled70.div`
  position: relative;
  & span.MuiTypography-root {
    bottom: -1.4rem;
    color: ${getCssVar("red", 300)};
  }
`;

// src/forms/sign-up-confirm/PinField.tsx
import { jsx as _jsx284 } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import React151 from "react";
var PinField = ({ incorrectPin, dataPin, resetIncorrectPin }) => {
  const { setFieldValue } = useFormikContext();
  const fieldName = "pin";
  return /* @__PURE__ */ _jsx284(field_default, {
    autoFocus: true,
    required: true,
    fullWidth: true,
    label: Translate_default.get("fields.pin.label"),
    id: fieldName,
    name: fieldName,
    type: "text",
    placeholder: "****",
    "data-pin": dataPin,
    onChange: (e) => {
      incorrectPin && resetIncorrectPin && resetIncorrectPin();
      setFieldValue(fieldName, e.target.value);
    }
  });
};
var PinField_default = /* @__PURE__ */ React151.memo(PinField);

// src/forms/sign-up-confirm/index.tsx
var signUpConfirmSchema = Yup5.object().shape({
  pin: Yup5.string().min(4, () => Translate_default.get("errors.yupValidation.incorrectPinVaried")).max(4, () => Translate_default.get("errors.yupValidation.incorrectPinVaried")).required(() => Translate_default.get("errors.yupValidation.setPinVaried"))
});
var FormSignUpConfirm = ({ initialValues: initialValues2, timeout = 2 * 60 * 1e3, sessionKey, email, validateOnBlur, validationSchema = signUpConfirmSchema, linkComponent: LinkComponent2, incorrectPin = false, dataPin, resetIncorrectPin, requestPin, onSubmit, onExit }) => {
  const [pinRequested, setPinRequested] = useState43(false);
  const [timeLeft, setTimeLeft] = useState43(0);
  const ms = 1e3;
  const minutes = ~~(timeLeft / ms / 60);
  const seconds = timeLeft / ms % 60;
  useEffect39(() => {
    if (!timeLeft)
      return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - ms);
    }, ms);
    return () => clearInterval(intervalId);
  }, [
    timeLeft
  ]);
  useEffect39(() => {
    pinRequested ? setTimeLeft(timeout) : setTimeLeft(0);
  }, [
    pinRequested
  ]);
  useEffect39(() => {
    if (!email && !sessionKey) {
      onExit && onExit();
    }
  }, [
    email,
    sessionKey
  ]);
  return /* @__PURE__ */ _jsx285(form_wrapper_default, {
    backButton: {
      href: "/register"
    },
    linkComponent: LinkComponent2,
    children: /* @__PURE__ */ _jsx285(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validateOnBlur,
      validationSchema,
      onSubmit,
      children: ({ dirty, isValid, errors }) => /* @__PURE__ */ _jsxs139(InnerWrapperWithPadding, {
        children: [
          /* @__PURE__ */ _jsxs139(TitleSectionWideGap, {
            children: [
              /* @__PURE__ */ _jsx285(typography_default, {
                variant: "h4",
                children: Translate_default.get("forms.sign-up.title")
              }),
              /* @__PURE__ */ _jsxs139(typography_default, {
                variant: "body2",
                children: [
                  Translate_default.get("forms.sign-up.confirmSubtitle.1"),
                  /* @__PURE__ */ _jsx285(WordBreakSpan, {
                    children: ` ${email} `
                  }),
                  Translate_default.get("forms.sign-up.confirmSubtitle.2")
                ]
              })
            ]
          }),
          /* @__PURE__ */ _jsx285(FormSection2, {
            children: /* @__PURE__ */ _jsxs139(Stack14, {
              minHeight: 120,
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _jsxs139(FieldWrapper, {
                  children: [
                    /* @__PURE__ */ _jsx285(PinField_default, {
                      incorrectPin,
                      resetIncorrectPin,
                      dataPin
                    }),
                    incorrectPin && (0, import_lodash16.isEmpty)(errors) && /* @__PURE__ */ _jsx285(ErrorText, {
                      variant: "caption",
                      children: Translate_default.get("errors.yupValidation.incorrectPinVaried")
                    })
                  ]
                }),
                pinRequested && /* @__PURE__ */ _jsxs139(typography_default, {
                  variant: "caption",
                  align: "center",
                  width: "100%",
                  children: [
                    Translate_default.get("forms.sign-up.repeatRequest"),
                    minutes >= 10 ? minutes : `0${minutes}`,
                    ":",
                    seconds >= 10 ? seconds : `0${seconds}`
                  ]
                })
              ]
            })
          }),
          /* @__PURE__ */ _jsxs139(ButtonsSection, {
            children: [
              /* @__PURE__ */ _jsx285(button_default, {
                fullWidth: true,
                id: "reset-confirm-button",
                type: "submit",
                color: "primary",
                variant: "contained",
                disabled: !(dirty && isValid),
                children: Translate_default.get("buttons.continue")
              }),
              /* @__PURE__ */ _jsx285(new_pin_default, {
                timeout,
                request: requestPin,
                pinRequestedHandler: setPinRequested
              })
            ]
          })
        ]
      })
    })
  });
};
var sign_up_confirm_default2 = /* @__PURE__ */ React152.memo(FormSignUpConfirm);

// src/forms/SSO-forbidden/index.tsx
import { jsx as _jsx286, jsxs as _jsxs140 } from "react/jsx-runtime";
import React153 from "react";
var FormSSOForbidden = ({ backHref, linkComponent: LinkComponent2 }) => /* @__PURE__ */ _jsx286(form_wrapper_default, {
  linkComponent: LinkComponent2,
  children: /* @__PURE__ */ _jsxs140(InnerWrapperWithPadding, {
    children: [
      /* @__PURE__ */ _jsxs140(TitleSection, {
        children: [
          /* @__PURE__ */ _jsx286(typography_default, {
            variant: "h4",
            children: Translate_default.get("forms.sso.forbidden.title")
          }),
          /* @__PURE__ */ _jsx286(typography_default, {
            variant: "body2",
            style: {
              marginTop: getSizeUnit(24),
              fontWeight: "normal"
            },
            children: Translate_default.get("forms.sso.forbidden.subtitle")
          })
        ]
      }),
      /* @__PURE__ */ _jsx286(ButtonsSection, {
        style: {
          marginTop: "auto"
        },
        children: /* @__PURE__ */ _jsx286(button_default, {
          fullWidth: true,
          id: "back-button",
          color: "primary",
          variant: "contained",
          component: LinkComponent2,
          to: backHref,
          children: Translate_default.get("buttons.toMain")
        })
      })
    ]
  })
});
var SSO_forbidden_default = /* @__PURE__ */ React153.memo(FormSSOForbidden);

// src/forms/SSO-general/index.tsx
import { jsx as _jsx287, jsxs as _jsxs141 } from "react/jsx-runtime";
import React154 from "react";
import * as Yup6 from "yup";
var SSOGeneralSchema = Yup6.object().shape({
  email: Yup6.string().email(() => Translate_default.get("errors.yupValidation.setEmail")).required(() => Translate_default.get("errors.yupValidation.ssoBad"))
});
var FormSSOGeneral = ({ initialValues: initialValues2, linkComponent: LinkComponent2, validationSchema = SSOGeneralSchema, validateOnBlur, backHref, onSubmit }) => /* @__PURE__ */ _jsx287(form_wrapper_default, {
  linkComponent: LinkComponent2,
  backButton: {
    href: backHref
  },
  children: /* @__PURE__ */ _jsx287(form_default, {
    initialValues: initialValues2,
    formProvider: provider_default2,
    formComponent: FormComponent,
    validationSchema,
    validateOnBlur,
    onSubmit,
    children: ({ dirty, isValid }) => /* @__PURE__ */ _jsxs141(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsxs141(TitleSection, {
          children: [
            /* @__PURE__ */ _jsxs141(typography_default, {
              display: "flex",
              variant: "h4",
              children: [
                /* @__PURE__ */ _jsx287(IconWrapper, {
                  children: /* @__PURE__ */ _jsx287(Key_default, {})
                }),
                Translate_default.get("forms.sso.general.title")
              ]
            }),
            /* @__PURE__ */ _jsxs141(typography_default, {
              variant: "body1",
              style: {
                marginTop: getSizeUnit(24)
              },
              children: [
                Translate_default.get("forms.sso.general.subtitle.1"),
                /* @__PURE__ */ _jsx287("br", {}),
                Translate_default.get("forms.sso.general.subtitle.2")
              ]
            })
          ]
        }),
        /* @__PURE__ */ _jsx287(FormSection2, {
          style: {
            marginTop: getSizeUnit(40)
          },
          children: /* @__PURE__ */ _jsx287(field_default, {
            autoFocus: true,
            required: true,
            fullWidth: true,
            id: "email",
            label: Translate_default.get("fields.email.label"),
            name: "email",
            type: "email",
            placeholder: "example@company.ru"
          })
        }),
        /* @__PURE__ */ _jsx287(ButtonsSection, {
          style: {
            marginTop: "auto"
          },
          children: /* @__PURE__ */ _jsx287(button_default, {
            fullWidth: true,
            id: "general-SSO-button",
            color: "primary",
            variant: "contained",
            type: "submit",
            disabled: !(dirty && isValid),
            children: Translate_default.get("buttons.signIn")
          })
        })
      ]
    })
  })
});
var SSO_general_default = /* @__PURE__ */ React154.memo(FormSSOGeneral);

// src/forms/SSO-register/index.tsx
import { jsx as _jsx288, jsxs as _jsxs142 } from "react/jsx-runtime";
import React155, { useState as useState44 } from "react";
var FormSSORegister = ({ email = "example@company.com", linkComponent: LinkComponent2, backHref, onSubmit }) => {
  const [isAgreementChecked, setIsAgreementChecked] = useState44(false);
  return /* @__PURE__ */ _jsx288(form_wrapper_default, {
    linkComponent: LinkComponent2,
    backButton: {
      href: backHref
    },
    children: /* @__PURE__ */ _jsxs142(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsxs142(TitleSection, {
          children: [
            /* @__PURE__ */ _jsx288(typography_default, {
              variant: "h4",
              children: Translate_default.get("forms.sso.register.title")
            }),
            /* @__PURE__ */ _jsxs142(typography_default, {
              variant: "body2",
              style: {
                marginTop: getSizeUnit(24),
                fontWeight: "normal"
              },
              children: [
                Translate_default.get("forms.sso.register.subtitle.1"),
                /* @__PURE__ */ _jsx288("b", {
                  children: email
                })
              ]
            }),
            /* @__PURE__ */ _jsx288(typography_default, {
              variant: "body2",
              style: {
                marginTop: getSizeUnit(24),
                fontWeight: "normal"
              },
              children: Translate_default.get("forms.sso.register.subtitle.2")
            })
          ]
        }),
        /* @__PURE__ */ _jsx288(FormSection2, {
          style: {
            marginTop: "auto"
          },
          children: /* @__PURE__ */ _jsxs142(Stack12, {
            direction: "row",
            alignItems: "start",
            children: [
              /* @__PURE__ */ _jsx288(checkbox_default, {
                name: "agreement",
                isChecked: isAgreementChecked,
                onChange: () => setIsAgreementChecked(!isAgreementChecked)
              }),
              /* @__PURE__ */ _jsxs142(typography_default, {
                variant: "caption",
                children: [
                  Translate_default.get("forms.sso.register.agreement.1"),
                  /* @__PURE__ */ _jsx288(link_default, {
                    id: "go-to-user-agreement",
                    component: LinkComponent2,
                    to: "/agreement",
                    color: "secondary",
                    target: "_blank",
                    rel: "noreferrer",
                    children: Translate_default.get("links.userAgreement.1")
                  }),
                  Translate_default.get("forms.sso.register.agreement.2"),
                  /* @__PURE__ */ _jsx288(link_default, {
                    id: "go-to-policy",
                    component: LinkComponent2,
                    to: "/policy",
                    color: "secondary",
                    target: "_blank",
                    rel: "noreferrer",
                    children: Translate_default.get("links.privacyPolicy")
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ _jsx288(ButtonsSection, {
          children: /* @__PURE__ */ _jsx288(button_default, {
            fullWidth: true,
            id: "register-SSO-button",
            color: "primary",
            variant: "contained",
            type: "submit",
            disabled: !isAgreementChecked,
            onClick: onSubmit,
            children: Translate_default.get("buttons.createAccount")
          })
        })
      ]
    })
  });
};
var SSO_register_default = /* @__PURE__ */ React155.memo(FormSSORegister);

// src/forms/unregistered/index.tsx
import { jsx as _jsx289, jsxs as _jsxs143 } from "react/jsx-runtime";
import React156 from "react";

// src/forms/unregistered/shared/ui.ts
import styled71 from "styled-components";
var IconButtonSquare = styled71.button`
  cursor: pointer;
  background: none;
`;
var CopyText2 = styled71.div`
  display: flex;
  gap: 1.4rem;
  align-items: center;
`;
var TitleSectionWideGap2 = styled71(TitleSection)`
  gap: 1.6rem;
`;

// src/forms/unregistered/index.tsx
var FormUnregistered = ({ linkComponent: LinkComponent2, supportEmail = "mail@diongo.ru", backHref, joinEventHref, copyTextCallback, resetRegisterError }) => {
  const copyTextHandler = () => navigator.clipboard.writeText(supportEmail).then(() => {
    copyTextCallback && copyTextCallback();
  });
  return /* @__PURE__ */ _jsx289(form_wrapper_default, {
    backButton: {
      href: backHref,
      callback: resetRegisterError
    },
    linkComponent: LinkComponent2,
    children: /* @__PURE__ */ _jsxs143(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsxs143(TitleSectionWideGap2, {
          style: {
            gap: 16
          },
          children: [
            /* @__PURE__ */ _jsx289(typography_default, {
              variant: "h4",
              children: Translate_default.get("forms.unregistered.title")
            }),
            /* @__PURE__ */ _jsx289(typography_default, {
              variant: "body2",
              style: {
                fontWeight: "normal"
              },
              children: Translate_default.get("forms.unregistered.subtitle")
            }),
            /* @__PURE__ */ _jsxs143(CopyText2, {
              children: [
                /* @__PURE__ */ _jsx289(typography_default, {
                  variant: "h5",
                  children: supportEmail
                }),
                /* @__PURE__ */ _jsx289(IconButtonSquare, {
                  onClick: copyTextHandler,
                  children: /* @__PURE__ */ _jsx289(Copy_default, {})
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ _jsxs143(ButtonsSection, {
          children: [
            /* @__PURE__ */ _jsx289(button_default, {
              fullWidth: true,
              id: "go-to-start-page",
              variant: "contained",
              color: "primary",
              component: LinkComponent2,
              to: "/",
              children: Translate_default.get("buttons.toMain")
            }),
            /* @__PURE__ */ _jsx289(button_default, {
              fullWidth: true,
              id: "go-to-event-link",
              variant: "contained",
              color: "secondary",
              component: LinkComponent2,
              to: joinEventHref,
              children: Translate_default.get("buttons.joinEvent")
            })
          ]
        })
      ]
    })
  });
};
var unregistered_default = /* @__PURE__ */ React156.memo(FormUnregistered);

// src/forms/unsupported/index.tsx
import { jsx as _jsx290, jsxs as _jsxs144 } from "react/jsx-runtime";
import React157 from "react";

// src/forms/unsupported/shared/ui.ts
import styled72 from "styled-components";
var ButtonsSection3 = styled72(ButtonsSection)`
  flex-direction: row;
  flex-wrap:wrap;
  gap: 1.6rem;
  margin-top: 24px;
  margin-bottom: 16rem;
  & .MuiChip-root {
    border-color: ${getCssVar("grey", 900)};
    cursor: pointer;
    padding: .8rem;
    height: auto;
    font-family: ${FONT_FAMILY};
    font-size: ${getCssVar("font", "small")};
    border-radius: 100px;
  }
`;

// src/forms/unsupported/index.tsx
var FormUnsupported = ({ isElectron: isElectron6 = false, downloadLink, linkComponent: LinkComponent2 }) => /* @__PURE__ */ _jsx290(form_wrapper_default, {
  children: /* @__PURE__ */ _jsxs144(InnerWrapperWithPadding, {
    children: [
      /* @__PURE__ */ _jsxs144(TitleSectionWideGap, {
        children: [
          /* @__PURE__ */ _jsx290(typography_default, {
            variant: "h4",
            children: Translate_default.get("forms.unsupported.title")
          }),
          /* @__PURE__ */ _jsx290(typography_default, {
            variant: "body2",
            children: Translate_default.get("forms.unsupported.subtitle")
          })
        ]
      }),
      /* @__PURE__ */ _jsxs144(ButtonsSection3, {
        children: [
          /* @__PURE__ */ _jsx290("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "https://www.google.com/intl/ru_ru/chrome/",
            children: /* @__PURE__ */ _jsx290(ChipLink, {
              variant: "outlined",
              avatar: /* @__PURE__ */ _jsx290(BrowserChrome_default, {}),
              label: /* @__PURE__ */ _jsx290(typography_default, {
                fontSize: fonts_default.small,
                variant: "caption",
                color: getCssVar("grey", 500),
                children: "CHROME | 90+"
              })
            })
          }),
          /* @__PURE__ */ _jsx290("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "https://browser.yandex.ru/",
            children: /* @__PURE__ */ _jsx290(ChipLink, {
              variant: "outlined",
              avatar: /* @__PURE__ */ _jsx290(BrowserYandex_default, {}),
              label: /* @__PURE__ */ _jsx290(typography_default, {
                fontSize: fonts_default.small,
                variant: "caption",
                color: getCssVar("grey", 500),
                children: "YANDEX | 21+"
              })
            })
          }),
          /* @__PURE__ */ _jsx290("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "https://www.microsoft.com/ru-ru/edge/download?form=MA13FJ",
            children: /* @__PURE__ */ _jsx290(ChipLink, {
              variant: "outlined",
              avatar: /* @__PURE__ */ _jsx290(BrowserEdge_default, {}),
              label: /* @__PURE__ */ _jsx290(typography_default, {
                fontSize: fonts_default.small,
                variant: "caption",
                color: getCssVar("grey", 500),
                children: "EDGE | 90+"
              })
            })
          })
        ]
      }),
      /* @__PURE__ */ _jsx290(FooterSection, {
        children: !isElectron6 && /* @__PURE__ */ _jsx290(button_default, {
          fullWidth: true,
          id: "dowload-link",
          variant: "contained",
          color: "primary",
          component: LinkComponent2,
          to: downloadLink.href,
          onClick: downloadLink.callback,
          children: Translate_default.get("buttons.downloadApp")
        })
      })
    ]
  })
});
var unsupported_default = /* @__PURE__ */ React157.memo(FormUnsupported);

// src/forms/conference-restrictions/index.tsx
import { jsx as _jsx291, jsxs as _jsxs145, Fragment as _Fragment21 } from "react/jsx-runtime";
import React158 from "react";

// src/forms/shared/helpers.ts
var getTitle = (type, slug = "") => {
  switch (type) {
    case "disconnected":
      return Translate_default.get("forms.conference-restrictions.disconnected.title", {
        slug
      });
    case "denied":
      return Translate_default.get("forms.conference-restrictions.denied.title", {
        slug
      });
    case "restricted":
      return Translate_default.get("forms.conference-restrictions.restricted.title", {
        slug
      });
    case "non-existent":
      return Translate_default.get("forms.conference-restrictions.non-existent.title", {
        slug
      });
    case "invite-not-active":
      return Translate_default.get("forms.conference-restrictions.by-invite.not-active");
    case "invite-not-found":
      return Translate_default.get("forms.conference-restrictions.by-invite.not-found");
    case "waiting":
    case "waiting-organizer":
    case "waiting-expired":
    case "to-much-users":
      return Translate_default.get("forms.conference-restrictions.waiting.title", {
        slug
      });
    case "strict-mode":
      return Translate_default.get("forms.conference-restrictions.strict-mode.title");
    case "ended":
      return Translate_default.get("forms.conference-restrictions.ended.title");
    case "guests-disabled":
      return Translate_default.get("forms.conference-restrictions.guests-disabled.title", {
        slug
      });
    case "conference-error":
      return Translate_default.get("forms.conference-error.title", {
        slug
      });
    default:
      return "";
  }
};
var getSubtitle = (type, message) => {
  switch (type) {
    case "strict-mode":
      return message !== null && message !== void 0 ? message : "";
    case "ended":
      return Translate_default.get("forms.conference-restrictions.ended.subtitle");
    case "waiting":
      return Translate_default.get("forms.conference-restrictions.waiting.subtitle");
    case "waiting-organizer":
      return Translate_default.get("forms.conference-restrictions.waiting.organizer");
    case "waiting-expired":
      return Translate_default.get("forms.conference-restrictions.waiting.expired");
    case "to-much-users":
      return Translate_default.get("forms.conference-restrictions.to-much-users.subtitle");
    default:
      return "";
  }
};

// src/forms/conference-restrictions/shared/ui.ts
import styled73 from "styled-components";
var FormSection6 = styled73(FormSection2)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  justify-content: center;
  gap: 2.4rem;
  > .MuiTypography-root {
    letter-spacing: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;

// src/forms/conference-restrictions/shared/constants.ts
var DISCONNECTED = "disconnected";
var DENIED = "denied";
var RESTRICTED = "restricted";
var NON_EXISTENT = "non-existent";
var GUEST_DISABLED = "guests-disabled";
var INVITE_NOT_FOUND = "invite-not-found";
var INVITE_NOT_ACTIVE = "invite-not-active";
var STRICT_MODE = "strict-mode";
var ENDED = "ended";

// src/forms/conference-restrictions/types.ts
var iconStyle = [
  DISCONNECTED,
  DENIED,
  RESTRICTED,
  NON_EXISTENT,
  GUEST_DISABLED,
  INVITE_NOT_FOUND,
  INVITE_NOT_ACTIVE
];
var titleStyle = [
  STRICT_MODE,
  ENDED
];

// src/forms/conference-restrictions/index.tsx
var FormConferenceRestrictions = ({ slug, type, buttonProps, isGuest = false, strictModeErrorMessage, guestDisabledButtonProps, linkComponent: LinkComponent2, additionalMessage }) => {
  const title = getTitle(type, slug);
  const subtitle = getSubtitle(type, strictModeErrorMessage);
  const isIconStyle = (x) => iconStyle.includes(x);
  const isTitleStyle = (x) => titleStyle.includes(x);
  const closeElectronWindow = () => {
    proxyMessage.send({
      type: "events",
      data: {
        action: {
          close: "allow",
          show: "main-window"
        }
      }
    });
  };
  var _guestDisabledButtonProps_href, _buttonProps_href, _buttonProps_href1;
  return /* @__PURE__ */ _jsx291(form_wrapper_default, {
    children: /* @__PURE__ */ _jsxs145(InnerWrapperWithPadding, {
      children: [
        isIconStyle(type) && /* @__PURE__ */ _jsxs145(_Fragment21, {
          children: [
            /* @__PURE__ */ _jsxs145(FormSection6, {
              children: [
                /* @__PURE__ */ _jsx291(Error_default, {}),
                /* @__PURE__ */ _jsx291(typography_default, {
                  align: "center",
                  variant: "h4",
                  children: title
                }),
                additionalMessage && /* @__PURE__ */ _jsx291(typography_default, {
                  align: "center",
                  variant: "body2",
                  fontWeight: "normal",
                  children: additionalMessage
                })
              ]
            }),
            /* @__PURE__ */ _jsxs145(ButtonsSection, {
              children: [
                type === "guests-disabled" && /* @__PURE__ */ _jsx291(button_default, {
                  fullWidth: true,
                  color: "primary",
                  variant: "contained",
                  LinkComponent: LinkComponent2,
                  href: (_guestDisabledButtonProps_href = guestDisabledButtonProps === null || guestDisabledButtonProps === void 0 ? void 0 : guestDisabledButtonProps.href) !== null && _guestDisabledButtonProps_href !== void 0 ? _guestDisabledButtonProps_href : "/auth",
                  onClick: guestDisabledButtonProps === null || guestDisabledButtonProps === void 0 ? void 0 : guestDisabledButtonProps.callback,
                  children: Translate_default.get("buttons.auth")
                }),
                /* @__PURE__ */ _jsx291(button_default, {
                  fullWidth: true,
                  "data-testid": isGuest ? "btn-go-to-main" : "btn-go-to-personal",
                  color: type === "guests-disabled" ? "secondary" : "primary",
                  variant: "contained",
                  LinkComponent: LinkComponent2,
                  href: (_buttonProps_href = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href) !== null && _buttonProps_href !== void 0 ? _buttonProps_href : "/",
                  onClick: (event) => {
                    closeElectronWindow();
                    if (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.callback) {
                      buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.callback(event);
                    }
                  },
                  children: Translate_default.get(isGuest ? "buttons.toMain" : "buttons.toPersonal")
                })
              ]
            })
          ]
        }),
        isTitleStyle(type) && /* @__PURE__ */ _jsxs145(_Fragment21, {
          children: [
            /* @__PURE__ */ _jsxs145(TitleSectionWideGap, {
              children: [
                /* @__PURE__ */ _jsx291(typography_default, {
                  variant: "h4",
                  children: title
                }),
                /* @__PURE__ */ _jsx291(typography_default, {
                  variant: "body1",
                  children: subtitle
                })
              ]
            }),
            /* @__PURE__ */ _jsx291(ButtonsSection, {
              children: /* @__PURE__ */ _jsx291(button_default, {
                fullWidth: true,
                color: type === "ended" ? "primary" : "secondary",
                variant: "contained",
                LinkComponent: LinkComponent2,
                href: (_buttonProps_href1 = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href) !== null && _buttonProps_href1 !== void 0 ? _buttonProps_href1 : "/",
                onClick: (event) => {
                  closeElectronWindow();
                  if (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.callback) {
                    buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.callback(event);
                  }
                },
                children: Translate_default.get(type !== "ended" ? "buttons.cancel" : isGuest ? "buttons.toMain" : "buttons.toPersonal")
              })
            })
          ]
        })
      ]
    })
  });
};
var conference_restrictions_default = /* @__PURE__ */ React158.memo(FormConferenceRestrictions);

// src/forms/enter-conference/index.tsx
import { jsx as _jsx293, jsxs as _jsxs147, Fragment as _Fragment23 } from "react/jsx-runtime";
import React159, { useState as useState45 } from "react";
import { Stack as Stack15 } from "@mui/material";

// src/forms/enter-conference/shared/ui.ts
import styled74 from "styled-components";
var ButtonsSectionWrapper = styled74.div`
  flex: 1 1 auto;
  justify-content: space-between;
  padding: 3.2rem 0;
  display: flex;
  flex-direction: column;
`;
var StyledButton3 = styled74(button_default)`
  min-height: unset;
  height: auto;
  padding: 0;
  margin: 0;
  font-weight: normal;
`;
var FormSection7 = styled74(FormSection2)`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  justify-content: center;
`;

// src/forms/shared/QRModalWindow.tsx
import { jsx as _jsx292, jsxs as _jsxs146, Fragment as _Fragment22 } from "react/jsx-runtime";
import QRCode from "react-qr-code";
var QRModalWindow = ({ qrCodeValue, slug, onOpen, onClose }) => {
  const isURLValid = validURL(qrCodeValue);
  return /* @__PURE__ */ _jsx292(modal_default, {
    open: onOpen,
    onClose,
    children: /* @__PURE__ */ _jsxs146(QRModal, {
      children: [
        /* @__PURE__ */ _jsx292(typography_default, {
          variant: "h4",
          children: Translate_default.get("modals.qrCode.title", {
            slug
          })
        }),
        /* @__PURE__ */ _jsx292(typography_default, {
          variant: "body1",
          children: Translate_default.get("modals.qrCode.subtitle")
        }),
        /* @__PURE__ */ _jsx292(QRWrapper, {
          isURLValid,
          children: isURLValid ? /* @__PURE__ */ _jsx292(QRCode, {
            size: 158,
            value: qrCodeValue
          }) : /* @__PURE__ */ _jsxs146(_Fragment22, {
            children: [
              /* @__PURE__ */ _jsx292(Attention_default, {}),
              /* @__PURE__ */ _jsx292(typography_default, {
                variant: "caption",
                color: "text.secondary",
                fontWeight: "normal",
                textAlign: "center",
                children: Translate_default.get("modals.qrCode.error")
              })
            ]
          })
        }),
        /* @__PURE__ */ _jsx292(button_default, {
          id: "close-qr-code-modal",
          variant: "contained",
          color: "secondary",
          onClick: onClose,
          style: {
            width: "fit-content"
          },
          children: Translate_default.get("modals.qrCode.cancelBtn")
        })
      ]
    })
  });
};
var QRModalWindow_default = QRModalWindow;

// src/forms/enter-conference/index.tsx
var FormEnterConference = ({ isEventReady = false, isElectron: isElectron6 = false, slug, cameraPermission = true, micPermission = true, isLoading = false, recordMode = false, userNotRecorder = true, undefinedPermissions = false, downloadLink, linkComponent: LinkComponent2, backButton, hideAgreement, qrCodeValue, enterConferenceCallback, checkDevicesCallback, setupDevicesCallback }) => {
  const [openQRModal, setOpenQRModal] = useState45(false);
  var _backButton_href;
  return /* @__PURE__ */ _jsxs147(_Fragment23, {
    children: [
      /* @__PURE__ */ _jsx293(form_wrapper_default, {
        backButton: {
          href: (_backButton_href = backButton === null || backButton === void 0 ? void 0 : backButton.href) !== null && _backButton_href !== void 0 ? _backButton_href : "/"
        },
        linkComponent: LinkComponent2,
        hideAgreement,
        children: /* @__PURE__ */ _jsx293(InnerWrapperWithPadding, {
          children: (() => {
            if (undefinedPermissions) {
              return /* @__PURE__ */ _jsxs147(_Fragment23, {
                children: [
                  /* @__PURE__ */ _jsx293(TitleSection, {
                    children: /* @__PURE__ */ _jsxs147(typography_default, {
                      variant: "h4",
                      children: [
                        Translate_default.get("forms.enter-conference.title"),
                        ` ${slug}`
                      ]
                    })
                  }),
                  /* @__PURE__ */ _jsx293(FormSection7, {
                    children: /* @__PURE__ */ _jsx293(spinner_default, {
                      size: 24,
                      fill: "white"
                    })
                  })
                ]
              });
            }
            if (recordMode) {
              if (micPermission) {
                return /* @__PURE__ */ _jsx293(ButtonsSection, {
                  children: /* @__PURE__ */ _jsx293(button_default, {
                    fullWidth: true,
                    id: "connect-to-call",
                    variant: "contained",
                    color: "primary",
                    onClick: enterConferenceCallback,
                    children: Translate_default.get("forms.enter-conference.joinBtn")
                  })
                });
              }
              return /* @__PURE__ */ _jsx293(button_default, {
                fullWidth: true,
                id: "open-settings-button",
                variant: "contained",
                color: "secondary",
                onClick: checkDevicesCallback,
                children: Translate_default.get("forms.enter-conference.checkAudio")
              });
            }
            if (userNotRecorder) {
              return /* @__PURE__ */ _jsxs147(_Fragment23, {
                children: [
                  /* @__PURE__ */ _jsxs147(TitleSection, {
                    children: [
                      /* @__PURE__ */ _jsxs147(typography_default, {
                        variant: "h4",
                        children: [
                          Translate_default.get("forms.enter-conference.title"),
                          ` ${slug}`
                        ]
                      }),
                      micPermission && /* @__PURE__ */ _jsx293(typography_default, {
                        variant: "body2",
                        color: "text.secondary",
                        fontWeight: "normal",
                        children: Translate_default.get("forms.enter-conference.subtitle")
                      })
                    ]
                  }),
                  /* @__PURE__ */ _jsxs147(ButtonsSectionWrapper, {
                    children: [
                      /* @__PURE__ */ _jsx293("div", {
                        children: (!cameraPermission || !micPermission) && /* @__PURE__ */ _jsxs147(InfoPlate, {
                          children: [
                            /* @__PURE__ */ _jsx293(Info_default, {
                              fill: getCssVar("red", 300)
                            }),
                            /* @__PURE__ */ _jsx293(Stack15, {
                              gap: "1rem",
                              alignItems: "start",
                              children: !cameraPermission ? /* @__PURE__ */ _jsxs147(_Fragment23, {
                                children: [
                                  /* @__PURE__ */ _jsx293(typography_default, {
                                    variant: "body1",
                                    children: Translate_default.get("forms.enter-conference.noCamera")
                                  }),
                                  /* @__PURE__ */ _jsx293(StyledButton3, {
                                    variant: "text",
                                    color: "primary",
                                    size: "small",
                                    onClick: setupDevicesCallback,
                                    children: Translate_default.get("forms.enter-conference.setup")
                                  })
                                ]
                              }) : /* @__PURE__ */ _jsx293(typography_default, {
                                variant: "body1",
                                children: Translate_default.get("forms.enter-conference.noMicrophone")
                              })
                            })
                          ]
                        })
                      }),
                      /* @__PURE__ */ _jsxs147(ButtonsSection, {
                        children: [
                          /* @__PURE__ */ _jsxs147(JoinButtonWrapper, {
                            children: [
                              /* @__PURE__ */ _jsx293(button_default, {
                                fullWidth: true,
                                id: "connect-to-call",
                                variant: "contained",
                                color: "primary",
                                disabled: !isEventReady,
                                onClick: !isLoading ? enterConferenceCallback : void 0,
                                children: isLoading ? /* @__PURE__ */ _jsx293(spinner_default, {
                                  size: 24,
                                  fill: "white"
                                }) : micPermission ? Translate_default.get("forms.enter-conference.joinBtn") : Translate_default.get("buttons.signInWithoutMicrophone")
                              }),
                              /* @__PURE__ */ _jsx293(button_default, {
                                id: "open-qr-code",
                                variant: "contained",
                                color: "primary",
                                onClick: () => setOpenQRModal(true),
                                children: /* @__PURE__ */ _jsx293(QRScan_default, {})
                              })
                            ]
                          }),
                          micPermission ? /* @__PURE__ */ _jsx293(button_default, {
                            fullWidth: true,
                            id: "open-settings-button",
                            variant: "contained",
                            color: "secondary",
                            onClick: checkDevicesCallback,
                            children: Translate_default.get("forms.enter-conference.checkout")
                          }) : /* @__PURE__ */ _jsx293(button_default, {
                            fullWidth: true,
                            id: "connect-to-call",
                            variant: "contained",
                            color: "secondary",
                            onClick: setupDevicesCallback,
                            children: Translate_default.get("forms.enter-conference.setup")
                          })
                        ]
                      })
                    ]
                  }),
                  /* @__PURE__ */ _jsx293(FooterSection, {
                    children: !isElectron6 && downloadLink && /* @__PURE__ */ _jsx293(download_app_link_default, {
                      linkComponent: LinkComponent2,
                      callback: downloadLink.callback,
                      to: downloadLink.href
                    })
                  })
                ]
              });
            }
            return /* @__PURE__ */ _jsxs147(_Fragment23, {
              children: [
                /* @__PURE__ */ _jsxs147(TitleSection, {
                  children: [
                    /* @__PURE__ */ _jsxs147(typography_default, {
                      variant: "h4",
                      children: [
                        Translate_default.get("forms.enter-conference.title"),
                        ` ${slug}`
                      ]
                    }),
                    micPermission && /* @__PURE__ */ _jsx293(typography_default, {
                      variant: "body2",
                      color: "text.secondary",
                      fontWeight: "normal",
                      children: Translate_default.get("forms.enter-conference.subtitle")
                    })
                  ]
                }),
                micPermission && /* @__PURE__ */ _jsxs147(ButtonsSection, {
                  children: [
                    /* @__PURE__ */ _jsx293(button_default, {
                      fullWidth: true,
                      id: "connect-to-call",
                      variant: "contained",
                      color: "primary",
                      onClick: !isLoading ? enterConferenceCallback : void 0,
                      children: isLoading ? /* @__PURE__ */ _jsx293(spinner_default, {
                        size: 24,
                        fill: "white"
                      }) : Translate_default.get("forms.enter-conference.joinBtn")
                    }),
                    /* @__PURE__ */ _jsx293(button_default, {
                      fullWidth: true,
                      id: "open-settings-button",
                      variant: "contained",
                      color: "secondary",
                      onClick: checkDevicesCallback,
                      children: Translate_default.get("forms.enter-conference.checkout")
                    })
                  ]
                })
              ]
            });
          })()
        })
      }),
      /* @__PURE__ */ _jsx293(QRModalWindow_default, {
        slug,
        qrCodeValue,
        onOpen: openQRModal,
        onClose: () => setOpenQRModal(false)
      })
    ]
  });
};
var enter_conference_default = /* @__PURE__ */ React159.memo(FormEnterConference);

// src/forms/enter-conference-error/index.tsx
import { jsx as _jsx294, jsxs as _jsxs148, Fragment as _Fragment24 } from "react/jsx-runtime";
import React160, { useState as useState46 } from "react";
import { Stack as Stack16 } from "@mui/material";

// src/forms/enter-conference-error/shared/ui.ts
import styled75 from "styled-components";
var ButtonsSectionWrapper2 = styled75.div`
  flex: 1 1 auto;
  justify-content: space-between;
  padding: 3.2rem 0;
  display: flex;
  flex-direction: column;
`;

// src/forms/enter-conference-error/index.tsx
var FormEnterConferenceError = ({ isElectron: isElectron6 = false, isGuest, slug, backToLKLink, downloadLink, linkComponent: LinkComponent2, backButton, hideAgreement, qrCodeValue }) => {
  const [openQRModal, setOpenQRModal] = useState46(false);
  var _backButton_href;
  return /* @__PURE__ */ _jsxs148(_Fragment24, {
    children: [
      /* @__PURE__ */ _jsx294(form_wrapper_default, {
        backButton: {
          href: (_backButton_href = backButton === null || backButton === void 0 ? void 0 : backButton.href) !== null && _backButton_href !== void 0 ? _backButton_href : "/"
        },
        linkComponent: LinkComponent2,
        hideAgreement,
        children: /* @__PURE__ */ _jsxs148(InnerWrapperWithPadding, {
          children: [
            /* @__PURE__ */ _jsx294(TitleSection, {
              children: /* @__PURE__ */ _jsxs148(typography_default, {
                variant: "h4",
                children: [
                  Translate_default.get("forms.enter-conference.title"),
                  ` ${slug}`
                ]
              })
            }),
            /* @__PURE__ */ _jsxs148(ButtonsSectionWrapper2, {
              children: [
                /* @__PURE__ */ _jsx294("div", {
                  children: /* @__PURE__ */ _jsxs148(InfoPlate, {
                    children: [
                      /* @__PURE__ */ _jsx294(Info_default, {
                        fill: getCssVar("red", 300)
                      }),
                      /* @__PURE__ */ _jsx294(Stack16, {
                        gap: "1rem",
                        alignItems: "start",
                        children: /* @__PURE__ */ _jsxs148(typography_default, {
                          variant: "body1",
                          children: [
                            Translate_default.get("forms.enter-conference.errorSubtitle.1"),
                            /* @__PURE__ */ _jsx294("br", {}),
                            Translate_default.get("forms.enter-conference.errorSubtitle.2"),
                            /* @__PURE__ */ _jsx294("br", {}),
                            Translate_default.get("forms.enter-conference.errorSubtitle.3")
                          ]
                        })
                      })
                    ]
                  })
                }),
                /* @__PURE__ */ _jsx294(ButtonsSection, {
                  children: /* @__PURE__ */ _jsxs148(JoinButtonWrapper, {
                    children: [
                      /* @__PURE__ */ _jsx294(button_default, {
                        fullWidth: true,
                        id: "go-to-lk-link",
                        variant: "contained",
                        color: "primary",
                        onClick: backToLKLink === null || backToLKLink === void 0 ? void 0 : backToLKLink.callback,
                        children: Translate_default.get(isGuest ? "buttons.toMain" : "buttons.toPersonal")
                      }),
                      /* @__PURE__ */ _jsx294(button_default, {
                        id: "open-qr-code",
                        variant: "contained",
                        color: "primary",
                        onClick: () => setOpenQRModal(true),
                        children: /* @__PURE__ */ _jsx294(QRScan_default, {})
                      })
                    ]
                  })
                })
              ]
            }),
            /* @__PURE__ */ _jsx294(FooterSection, {
              children: !isElectron6 && downloadLink && /* @__PURE__ */ _jsx294(download_app_link_default, {
                linkComponent: LinkComponent2,
                callback: downloadLink.callback,
                to: downloadLink.href
              })
            })
          ]
        })
      }),
      /* @__PURE__ */ _jsx294(QRModalWindow_default, {
        slug,
        qrCodeValue,
        onOpen: openQRModal,
        onClose: () => setOpenQRModal(false)
      })
    ]
  });
};
var enter_conference_error_default = /* @__PURE__ */ React160.memo(FormEnterConferenceError);

// src/forms/enter-conference-by-link/index.tsx
import { jsx as _jsx295, jsxs as _jsxs149 } from "react/jsx-runtime";
import React161, { useState as useState47 } from "react";
import * as Yup7 from "yup";
import { Stack as Stack17 } from "@mui/material";

// src/forms/enter-conference-by-link/shared/ui.ts
import styled76 from "styled-components";
var ButtonsSection4 = styled76(ButtonsSection)`
  flex-direction: row;
  flex-wrap: wrap;
  button {
    font-weight: normal;
  }
`;
var ButtonWrapper = styled76.div`
  flex: 0 1 calc(50% - 0.4rem);
  & button {
    font-size: 1.3rem;
    font-weight: normal;
    padding: 0 1rem;
  }
`;
var ResetPasswordWrapper = styled76.div`
  width: 100%;
  padding: 1.6rem 0;
  text-align: right;
`;

// src/forms/enter-conference-by-link/index.tsx
var signInSchema2 = Yup7.object().shape({
  email: Yup7.string().email("Укажите Корпоративную почту").required("Укажите Корпоративную почту"),
  password: Yup7.string().required("Поле не может быть пустым")
});
var FormEnterConferenceByLink = ({ isElectron: isElectron6 = false, slug, downloadLink, linkComponent: LinkComponent2, initialValues: initialValues2, signInSSOHref, resetHref, registerHref, validationSchema = signInSchema2, validateOnBlur, onSubmit, backButton, hideAgreement }) => {
  const [passwordVisible, setPasswordVisible] = useState47(false);
  var _backButton_href;
  return /* @__PURE__ */ _jsx295(form_wrapper_default, {
    backButton: {
      href: (_backButton_href = backButton === null || backButton === void 0 ? void 0 : backButton.href) !== null && _backButton_href !== void 0 ? _backButton_href : "/"
    },
    linkComponent: LinkComponent2,
    hideAgreement,
    children: /* @__PURE__ */ _jsx295(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validationSchema,
      validateOnBlur,
      onSubmit,
      children: ({ dirty, isValid }) => /* @__PURE__ */ _jsxs149(InnerWrapperWithPadding, {
        style: {
          gap: "1.6rem"
        },
        children: [
          /* @__PURE__ */ _jsxs149(TitleSection, {
            children: [
              /* @__PURE__ */ _jsxs149(typography_default, {
                variant: "h4",
                children: [
                  Translate_default.get("forms.enter-conference.title"),
                  ` ${slug}`
                ]
              }),
              /* @__PURE__ */ _jsxs149(InfoPlate, {
                children: [
                  /* @__PURE__ */ _jsx295(Info_default, {
                    fill: getCssVar("red", 300)
                  }),
                  /* @__PURE__ */ _jsx295(Stack17, {
                    gap: "1rem",
                    alignItems: "start",
                    children: /* @__PURE__ */ _jsx295(typography_default, {
                      variant: "body1",
                      children: Translate_default.get("forms.enter-conference.noGuest")
                    })
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ _jsxs149(FormSection2, {
            style: {
              marginBottom: 0
            },
            children: [
              /* @__PURE__ */ _jsx295(field_default, {
                autoFocus: true,
                required: true,
                fullWidth: true,
                id: "email",
                label: Translate_default.get("fields.email.label"),
                name: "email",
                type: "email",
                placeholder: "example@company.ru"
              }),
              /* @__PURE__ */ _jsxs149(PasswordWrapper, {
                children: [
                  /* @__PURE__ */ _jsx295(field_default, {
                    required: true,
                    fullWidth: true,
                    id: "password",
                    label: Translate_default.get("fields.password.label"),
                    name: "password",
                    type: passwordVisible ? "text" : "password",
                    placeholder: Translate_default.get("fields.password.placeholder"),
                    autoComplete: "off"
                  }),
                  /* @__PURE__ */ _jsx295(IconButtonWrapper4, {
                    onClick: () => setPasswordVisible(!passwordVisible),
                    tabIndex: -1,
                    children: passwordVisible ? /* @__PURE__ */ _jsx295(EyeOpen_default, {}) : /* @__PURE__ */ _jsx295(EyeClose_default, {})
                  })
                ]
              }),
              /* @__PURE__ */ _jsx295(ResetPasswordWrapper, {
                children: /* @__PURE__ */ _jsx295(link_default, {
                  color: "text.secondary",
                  to: resetHref,
                  component: LinkComponent2,
                  children: Translate_default.get("buttons.resetPass")
                })
              })
            ]
          }),
          /* @__PURE__ */ _jsxs149(ButtonsSection4, {
            children: [
              /* @__PURE__ */ _jsx295(button_default, {
                fullWidth: true,
                id: "login-button",
                color: "primary",
                variant: "contained",
                type: "submit",
                disabled: !(dirty && isValid),
                children: Translate_default.get("buttons.signIn")
              }),
              /* @__PURE__ */ _jsx295(ButtonWrapper, {
                children: /* @__PURE__ */ _jsxs149(button_default, {
                  fullWidth: true,
                  id: "go-to-signin-sso-link",
                  variant: "contained",
                  color: "secondary",
                  component: LinkComponent2,
                  to: signInSSOHref,
                  children: [
                    /* @__PURE__ */ _jsx295(IconWrapper, {
                      children: /* @__PURE__ */ _jsx295(Shield_default, {})
                    }),
                    " ",
                    Translate_default.get("buttons.signInSSO")
                  ]
                })
              }),
              /* @__PURE__ */ _jsx295(ButtonWrapper, {
                children: /* @__PURE__ */ _jsx295(button_default, {
                  fullWidth: true,
                  id: "go-to-register-link",
                  variant: "contained",
                  color: "secondary",
                  component: LinkComponent2,
                  to: registerHref,
                  children: Translate_default.get("buttons.register")
                })
              })
            ]
          }),
          /* @__PURE__ */ _jsx295(FooterSection, {
            style: {
              marginTop: "1.2rem"
            },
            children: !isElectron6 && downloadLink && /* @__PURE__ */ _jsx295(download_app_link_default, {
              linkComponent: LinkComponent2,
              callback: downloadLink.callback,
              to: downloadLink.href
            })
          })
        ]
      })
    })
  });
};
var enter_conference_by_link_default = /* @__PURE__ */ React161.memo(FormEnterConferenceByLink);

// src/forms/conference-waiting/index.tsx
import { jsx as _jsx296, jsxs as _jsxs150 } from "react/jsx-runtime";
import React162 from "react";
var FormConferenceWaiting = ({ slug, type, buttonProps, isGuest = false, linkComponent: LinkComponent2 }) => {
  const title = getTitle(type, slug);
  const subtitle = getSubtitle(type);
  return /* @__PURE__ */ _jsx296(form_wrapper_default, {
    children: /* @__PURE__ */ _jsxs150(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsxs150(TitleSectionWideGap, {
          children: [
            /* @__PURE__ */ _jsx296(typography_default, {
              variant: "h4",
              children: title
            }),
            /* @__PURE__ */ _jsx296(typography_default, {
              variant: "body1",
              children: subtitle
            })
          ]
        }),
        /* @__PURE__ */ _jsx296(ButtonsSection, {
          children: /* @__PURE__ */ _jsx296(button_default, {
            fullWidth: true,
            color: "secondary",
            variant: "contained",
            onClick: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.callback,
            children: Translate_default.get(isGuest ? "buttons.toMain" : "buttons.toPersonal")
          })
        })
      ]
    })
  });
};
var conference_waiting_default = /* @__PURE__ */ React162.memo(FormConferenceWaiting);

// src/forms/form-with-back-button/index.tsx
import { jsx as _jsx297, jsxs as _jsxs151 } from "react/jsx-runtime";
import React163 from "react";
var FormWithBackButton = ({ backHref, linkComponent: LinkComponent2, title, description, linkText = Translate_default.get("buttons.toMain") }) => /* @__PURE__ */ _jsx297(form_wrapper_default, {
  linkComponent: LinkComponent2,
  children: /* @__PURE__ */ _jsxs151(InnerWrapperWithPadding, {
    children: [
      /* @__PURE__ */ _jsxs151(TitleSection, {
        children: [
          /* @__PURE__ */ _jsx297(typography_default, {
            variant: "h4",
            children: title
          }),
          /* @__PURE__ */ _jsx297(typography_default, {
            variant: "body2",
            style: {
              marginTop: getSizeUnit(24),
              fontWeight: "normal"
            },
            children: description
          })
        ]
      }),
      /* @__PURE__ */ _jsx297(ButtonsSection, {
        style: {
          marginTop: "auto"
        },
        children: /* @__PURE__ */ _jsx297(button_default, {
          fullWidth: true,
          id: "back-button",
          color: "primary",
          variant: "contained",
          component: LinkComponent2,
          to: backHref,
          children: linkText
        })
      })
    ]
  })
});
var form_with_back_button_default = /* @__PURE__ */ React163.memo(FormWithBackButton);

// src/forms/access-code/index.tsx
var import_lodash17 = __toESM(require_lodash());
import { jsx as _jsx299, jsxs as _jsxs152, Fragment as _Fragment25 } from "react/jsx-runtime";
import React165 from "react";
import * as Yup8 from "yup";

// src/forms/access-code/shared/ui.ts
import styled77 from "styled-components";
var ErrorText2 = styled77(typography_default)`
 
  color: ${getCssVar("red", 300)};
  display: block;
  height: 1.4rem;
`;
var FieldWrapper2 = styled77.div`
  width: 100%;
  margin-top: 2.4rem;
  & span.MuiTypography-root {
    color: ${getCssVar("red", 300)};
  }
`;

// src/forms/access-code/shared/AccessCodeField.tsx
import { jsx as _jsx298 } from "react/jsx-runtime";
import { useFormikContext as useFormikContext2 } from "formik";
import React164 from "react";
var AccessCodeField = ({ accessCodeError, resetAccessCodeError }) => {
  const { setFieldValue } = useFormikContext2();
  const fieldName = "accessCode";
  return /* @__PURE__ */ _jsx298(field_default, {
    autoFocus: true,
    required: true,
    fullWidth: true,
    label: Translate_default.get("fields.accessCode.label"),
    id: fieldName,
    name: fieldName,
    type: "text",
    placeholder: "******",
    sx: accessCodeError && {
      ">.MuiInputBase-root": {
        border: `1px solid ${getCssVar("red", 300)}`
      }
    },
    onChange: (e) => {
      accessCodeError && resetAccessCodeError && resetAccessCodeError();
      setFieldValue(fieldName, e.target.value);
    }
  });
};
var AccessCodeField_default = /* @__PURE__ */ React164.memo(AccessCodeField);

// src/forms/access-code/index.tsx
var FormAccessCodeSchema = Yup8.object().shape({
  accessCode: Yup8.string().min(6, () => Translate_default.get("errors.yupValidation.incorrectPin")).max(6, () => Translate_default.get("errors.yupValidation.incorrectPin")).required(() => Translate_default.get("errors.yupValidation.setPin"))
});
var FormAccessCode = ({ slug, isLoading = false, resetAccessCodeError, accessCodeError, backButton, initialValues: initialValues2, validateOnBlur, validationSchema = FormAccessCodeSchema, onSubmit }) => {
  var _backButton_href;
  return /* @__PURE__ */ _jsx299(form_wrapper_default, {
    backButton: {
      href: (_backButton_href = backButton === null || backButton === void 0 ? void 0 : backButton.href) !== null && _backButton_href !== void 0 ? _backButton_href : "/"
    },
    children: /* @__PURE__ */ _jsx299(form_default, {
      initialValues: initialValues2,
      formProvider: provider_default2,
      formComponent: FormComponent,
      validateOnBlur,
      validationSchema,
      onSubmit,
      children: ({ dirty, errors, isValid }) => /* @__PURE__ */ _jsx299(InnerWrapperWithPadding, {
        children: (() => /* @__PURE__ */ _jsxs152(_Fragment25, {
          children: [
            /* @__PURE__ */ _jsxs152(TitleSection, {
              children: [
                /* @__PURE__ */ _jsxs152(typography_default, {
                  variant: "h4",
                  children: [
                    Translate_default.get("forms.enter-conference.title"),
                    ` ${slug}`
                  ]
                }),
                /* @__PURE__ */ _jsxs152(FieldWrapper2, {
                  children: [
                    /* @__PURE__ */ _jsx299(AccessCodeField_default, {
                      accessCodeError,
                      resetAccessCodeError
                    }),
                    accessCodeError && (0, import_lodash17.isEmpty)(errors) && /* @__PURE__ */ _jsx299(ErrorText2, {
                      marginTop: 1,
                      variant: "caption",
                      children: accessCodeError
                    })
                  ]
                })
              ]
            }),
            /* @__PURE__ */ _jsx299(ButtonsSection, {
              children: /* @__PURE__ */ _jsx299(button_default, {
                fullWidth: true,
                id: "connect-to-call",
                variant: "contained",
                color: "primary",
                type: "submit",
                disabled: !(dirty && isValid) || Boolean(accessCodeError),
                children: isLoading ? /* @__PURE__ */ _jsx299(spinner_default, {
                  size: 24,
                  fill: "white"
                }) : Translate_default.get("forms.enter-conference.joinBtn")
              })
            })
          ]
        }))()
      })
    })
  });
};
var access_code_default = /* @__PURE__ */ React165.memo(FormAccessCode);

// src/forms/conference-error/index.tsx
import { jsx as _jsx300, jsxs as _jsxs153 } from "react/jsx-runtime";
import React166 from "react";

// src/forms/conference-error/shared/ui.ts
import styled78 from "styled-components";
var FormSection8 = styled78(FormSection2)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  justify-content: center;
  gap: 2.4rem;
`;

// src/forms/conference-error/index.tsx
var FormConferenceError = ({ slug, type, reloadCallback }) => {
  const title = getTitle(type, slug);
  return /* @__PURE__ */ _jsx300(form_wrapper_default, {
    children: /* @__PURE__ */ _jsxs153(InnerWrapperWithPadding, {
      children: [
        /* @__PURE__ */ _jsxs153(FormSection8, {
          children: [
            /* @__PURE__ */ _jsx300(Error_default, {}),
            /* @__PURE__ */ _jsx300(typography_default, {
              align: "center",
              variant: "h4",
              children: title
            })
          ]
        }),
        /* @__PURE__ */ _jsx300(ButtonsSection, {
          children: /* @__PURE__ */ _jsx300(button_default, {
            fullWidth: true,
            color: "primary",
            variant: "contained",
            onClick: reloadCallback,
            children: Translate_default.get("forms.conference-error.btn")
          })
        })
      ]
    })
  });
};
var conference_error_default = /* @__PURE__ */ React166.memo(FormConferenceError);

// src/processes/store/policy/index.ts
import { create as create3 } from "zustand";
import { devtools as devtools3 } from "zustand/middleware";
function asyncGeneratorStep12(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator12(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep12(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep12(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _define_property211(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread211(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property211(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys177(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props177(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys177(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var INITIAL_POLICY_STATE = {
  policy: null,
  eventPolicy: null,
  loading: {
    policy: false,
    eventPolicy: false
  },
  errors: {
    policy: null,
    eventPolicy: null
  }
};
var createPolicyStore = (options, apiGetPolicy) => create3()(devtools3((set) => _object_spread_props177(_object_spread211({}, INITIAL_POLICY_STATE), {
  setPolicyState: (newState) => {
    set((state) => _object_spread211({}, state, newState));
  },
  getPolicy: /* @__PURE__ */ _async_to_generator12(function* () {
    try {
      set((state) => ({
        errors: _object_spread_props177(_object_spread211({}, state.errors), {
          policy: null
        }),
        loading: _object_spread_props177(_object_spread211({}, state.loading), {
          policy: true
        })
      }));
      const policy = yield apiGetPolicy();
      set((state) => ({
        policy,
        loading: _object_spread_props177(_object_spread211({}, state.loading), {
          policy: false
        })
      }));
    } catch (error) {
      set((state) => ({
        errors: _object_spread_props177(_object_spread211({}, state.errors), {
          policy: error
        }),
        loading: _object_spread_props177(_object_spread211({}, state.loading), {
          policy: false
        })
      }));
    }
  })
}), options));

// src/processes/store/sidebar/index.ts
import { create as create4 } from "zustand";
import { devtools as devtools4 } from "zustand/middleware";
function _define_property212(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread212(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property212(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys178(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props178(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys178(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var initialState = {
  isVisible: true,
  isPinned: true,
  isHovered: false
};
var createSidebarStore = (options) => create4()(devtools4((set) => _object_spread_props178(_object_spread212({}, initialState), {
  setSidebarState: (newState) => {
    set((state) => _object_spread212({}, state, newState));
  }
}), options));

// src/processes/store/calls/index.ts
import { create as create5 } from "zustand";
import { devtools as devtools5, subscribeWithSelector } from "zustand/middleware";
function asyncGeneratorStep13(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator13(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep13(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep13(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _define_property213(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread213(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys180 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys180 = ownKeys180.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys180.forEach(function(key) {
      _define_property213(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys179(object9, enumerableOnly) {
  var keys = Object.keys(object9);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object9);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object9, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props179(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys179(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var getStoreOptions = (name) => ({
  name,
  // @ts-ignore
  enabled: process.env.NODE_ENV !== "production"
});
var EMPTY_USER = {
  initials: "",
  name: "",
  avatarPath: "",
  userId: ""
};
var EMPTY_CALL = {
  callDatetime: "",
  callId: "",
  callStatus: null,
  eventId: "",
  slug: "",
  user: EMPTY_USER,
  loading: false,
  error: null
};
var EMPTY_OUT_CALL = _object_spread_props179(_object_spread213({}, EMPTY_CALL), {
  callDirection: "out"
});
var EMPTY_IN_CALL = _object_spread_props179(_object_spread213({}, EMPTY_CALL), {
  callDirection: "in"
});
var INITIAL_STATE = {
  outgoingCalls: [],
  incomingCallData: null
};
var createCallsStore = ({ apiCallsOutgoingRequest, apiAcceptIncomingCallRequest, apiCancelOutgoingCallRequest, apiCancelIncomingCallRequest, apiIncomingCallPushRequest }) => create5()(devtools5(subscribeWithSelector((set, get3) => _object_spread_props179(_object_spread213({}, INITIAL_STATE), {
  sendOutgoingCall: function() {
    var _ref = _async_to_generator13(function* (payload) {
      set((state) => ({
        outgoingCalls: [
          ...state.outgoingCalls,
          _object_spread_props179(_object_spread213({}, EMPTY_OUT_CALL), {
            slug: payload.slug,
            eventId: payload.eventId,
            callStatus: "active",
            loading: true,
            error: null,
            metrics: payload.metrics,
            user: _object_spread_props179(_object_spread213({}, EMPTY_USER), {
              initials: payload.initials,
              name: payload.name,
              avatarPath: payload.avatarHttpPath,
              userId: payload.userId
            })
          })
        ]
      }));
      try {
        const callResponseData = yield apiCallsOutgoingRequest(payload);
        set((state) => {
          const modifiedCalls = [
            ...state.outgoingCalls
          ].map((c) => {
            var _c_user, _callResponseData_user;
            if (((_c_user = c.user) === null || _c_user === void 0 ? void 0 : _c_user.userId) === ((_callResponseData_user = callResponseData.user) === null || _callResponseData_user === void 0 ? void 0 : _callResponseData_user.userId)) {
              if ((c === null || c === void 0 ? void 0 : c.callStatus) === CALL_STATUS.active)
                return _object_spread_props179(_object_spread213({}, c, callResponseData), {
                  loading: false
                });
              else
                return null;
            } else
              return c;
          }).filter((c) => c !== null);
          return {
            outgoingCalls: [
              ...modifiedCalls
            ]
          };
        });
      } catch (err) {
        const errorResponseData = yield err.json();
        set((state) => ({
          outgoingCalls: [
            ...state.outgoingCalls.map((c) => (c === null || c === void 0 ? void 0 : c.callStatus) === CALL_STATUS.active && c.loading === true ? _object_spread_props179(_object_spread213({}, c), {
              loading: false,
              error: {
                response: {
                  status: err.status,
                  data: errorResponseData
                }
              }
            }) : c)
          ]
        }));
      }
    });
    return function(payload) {
      return _ref.apply(this, arguments);
    };
  }(),
  cancelOutgoingCall: function() {
    var _ref = _async_to_generator13(function* (callId) {
      const { outgoingCalls, resetOutgoingCallData } = get3();
      const thisCall = outgoingCalls.find((c) => c.callId === callId);
      if (!thisCall)
        return;
      if ((thisCall === null || thisCall === void 0 ? void 0 : thisCall.callStatus) !== CALL_STATUS.active)
        return;
      if (!(thisCall === null || thisCall === void 0 ? void 0 : thisCall.callId))
        return;
      try {
        yield apiCancelOutgoingCallRequest({
          callId
        });
        thisCall.callStatus = "declinedByCaller";
        thisCall.loading = false;
        set((state) => ({
          outgoingCalls: [
            ...state.outgoingCalls.map((c) => (c === null || c === void 0 ? void 0 : c.callId) === callId ? _object_spread213({}, thisCall) : c)
          ]
        }));
        resetOutgoingCallData(thisCall.callId);
      } catch (err) {
        const errorResponseData = yield err.json();
        thisCall.callStatus = null;
        thisCall.loading = false;
        thisCall.error = {
          response: {
            status: err.status,
            data: errorResponseData
          }
        };
        thisCall.metrics = void 0;
        set((state) => ({
          outgoingCalls: [
            ...state.outgoingCalls.map((c) => c.callId === thisCall.callId ? _object_spread213({}, thisCall) : c)
          ]
        }));
      }
    });
    return function(callId) {
      return _ref.apply(this, arguments);
    };
  }(),
  setOutgoingCallData(callData) {
    set((state) => ({
      outgoingCalls: [
        ...state.outgoingCalls.map((c) => c.callId === callData.id || c.callId === callData.callId ? _object_spread213({}, c, callData) : c)
      ]
    }));
    if (callData === null || callData === void 0 ? void 0 : callData.userId) {
      get3().sendOutgoingCall({
        userId: callData.userId,
        metrics: callData === null || callData === void 0 ? void 0 : callData.metrics,
        initials: callData.initials,
        name: callData.name,
        avatarHttpPath: callData.avatarHttpPath
      });
    }
  },
  setOutgoingCallStatus({ callId, status }) {
    const { outgoingCalls, resetOutgoingCallData } = get3();
    if (!outgoingCalls)
      return;
    set((state) => ({
      outgoingCalls: [
        ...state.outgoingCalls.map((c) => c.callId === callId ? _object_spread_props179(_object_spread213({}, c), {
          callStatus: status
        }) : c)
      ]
    }));
    if (status !== CALL_STATUS.active) {
      resetOutgoingCallData(callId);
    }
  },
  resetOutgoingCallData(callId) {
    setTimeout(() => {
      const { removeOutgoingCallData } = get3();
      removeOutgoingCallData({
        callId
      });
    }, 1e3);
  },
  setIncomingCallData: function() {
    var _ref = _async_to_generator13(function* (callData) {
      set({
        incomingCallData: _object_spread_props179(_object_spread213({}, callData), {
          loading: false,
          error: null
        })
      });
      if (callData === null || callData === void 0 ? void 0 : callData.callId) {
        try {
          yield apiIncomingCallPushRequest({
            callId: callData.callId
          });
        } catch (error) {
          console.error(error);
        }
      }
    });
    return function(callData) {
      return _ref.apply(this, arguments);
    };
  }(),
  acceptIncomingCall: function() {
    var _ref = _async_to_generator13(function* ({ callId }) {
      const { incomingCallData, resetIncomingCallData } = get3();
      if (!incomingCallData)
        return;
      try {
        const callResponseData = yield apiAcceptIncomingCallRequest({
          callId
        });
        set((state) => ({
          incomingCallData: _object_spread_props179(_object_spread213({}, incomingCallData, callResponseData), {
            callStatus: "accepted",
            loading: false
          })
        }));
        resetIncomingCallData();
      } catch (err) {
        set((state) => ({
          incomingCallData: _object_spread_props179(_object_spread213({}, incomingCallData), {
            loading: false,
            error: true
          })
        }));
      }
    });
    return function(_5) {
      return _ref.apply(this, arguments);
    };
  }(),
  cancelIncomingCall: function() {
    var _ref = _async_to_generator13(function* ({ callId }) {
      const { incomingCallData, resetIncomingCallData } = get3();
      if (!incomingCallData)
        return;
      try {
        yield apiCancelIncomingCallRequest({
          callId
        });
        resetIncomingCallData();
      } catch (error) {
        set((state) => ({
          incomingCallData: null
        }));
      }
    });
    return function(_5) {
      return _ref.apply(this, arguments);
    };
  }(),
  setIncomingCallStatus(params) {
    const { status, declineReason } = params;
    const { incomingCallData, resetIncomingCallData } = get3();
    if (!incomingCallData)
      return;
    set({
      incomingCallData: _object_spread_props179(_object_spread213({}, incomingCallData), {
        callStatus: status,
        declineReason
      })
    });
    if (status !== CALL_STATUS.active) {
      resetIncomingCallData();
    }
  },
  resetIncomingCallData() {
    setTimeout(() => {
      set({
        incomingCallData: null
      });
    }, 1e3);
  },
  getOutgoingCallData(params) {
    const { outgoingCalls } = get3();
    if (!params)
      return;
    const { callId, userId, status } = params;
    if (callId)
      return outgoingCalls.find((c) => (c === null || c === void 0 ? void 0 : c.callId) === callId);
    if (userId)
      return outgoingCalls.find((c) => {
        var _c_user;
        return (c === null || c === void 0 ? void 0 : (_c_user = c.user) === null || _c_user === void 0 ? void 0 : _c_user.userId) === userId;
      });
    if (status)
      return outgoingCalls.find((c) => (c === null || c === void 0 ? void 0 : c.callStatus) === status);
    return;
  },
  removeOutgoingCallData(params) {
    if (!params)
      return;
    const { callId, userId } = params;
    if (callId) {
      set((state) => ({
        outgoingCalls: [
          ...state.outgoingCalls.filter((c) => c.callId !== callId)
        ]
      }));
    }
    if (userId) {
      set((state) => ({
        outgoingCalls: [
          ...state.outgoingCalls.filter((c) => {
            var _c_user;
            return ((_c_user = c.user) === null || _c_user === void 0 ? void 0 : _c_user.userId) !== userId;
          })
        ]
      }));
    }
  },
  resetOutgoingCallStatusAndError(params) {
    const { callId, userId, status } = params;
    if (!callId && !userId)
      return;
    if (callId) {
      set((state) => ({
        outgoingCalls: state.outgoingCalls.map((c) => c.callId === callId ? _object_spread_props179(_object_spread213({}, c), {
          status,
          error: null
        }) : c)
      }));
    }
    if (userId) {
      set((state) => ({
        outgoingCalls: state.outgoingCalls.map((c) => {
          var _c_user;
          return ((_c_user = c.user) === null || _c_user === void 0 ? void 0 : _c_user.userId) === userId ? _object_spread_props179(_object_spread213({}, c), {
            callStatus: status ? status : c.callStatus,
            error: null
          }) : c;
        })
      }));
    }
  }
})), getStoreOptions("useCalls")));

// src/processes/store/calls/types.ts
var DECLINE_REASON;
(function(DECLINE_REASON2) {
  DECLINE_REASON2["TIMEOUT_REACHED"] = "timeout_reached";
  DECLINE_REASON2["CONFIRMED_ON_OTHER_DEVICE"] = "confirmed_on_other_device";
  DECLINE_REASON2["CANCELLED"] = "cancelled";
})(DECLINE_REASON || (DECLINE_REASON = {}));
export {
  ACCESS_TOKEN,
  acceptance_modal_default as AcceptanceModal,
  AccessSettings,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AuthCallbackType,
  authContext_default as AuthContext,
  authProvider_default as AuthProvider,
  avatar_default as Avatar,
  AvatarUnstyled,
  BACKGROUND_DELETE_IMMEDIATELY,
  BACKGROUND_POPUP_CLOSED,
  BACKGROUND_SETTINGS_VISITED,
  breakpoints_default as BREAKPOINTS,
  BaseSocketController,
  book_default as BookLayout,
  bottom_navigation_default as BottomNavigation,
  box_default as Box,
  breadcrumbs_default as Breadcrumbs,
  button_default as Button,
  button_icon_stroke_default as ButtonIconStroke,
  button_switch_default as ButtonSwitch,
  ButtonsWrapper,
  CALLS_ICON_POPPER_SHOW,
  CALL_DIRECTION,
  CALL_STATUS,
  CAMERA_ITEM,
  CallStatusText,
  card_default as Card,
  center_layout_default as CenterLayout,
  checkbox_default as Checkbox,
  ChildrenContainer,
  chip_default as Chip,
  CircleLoader,
  CircularProgress,
  col_default as Col,
  CollapseButton,
  CommonProvider,
  CompareVersion,
  custom_select_default as CustomSelect,
  dark_default as DARK_THEME,
  DECLINE_REASON,
  DEFAULT_AUTH,
  DRAWER_WIDTH,
  DYNAMIC_ITEM,
  date_picker_default as DatePicker,
  Dayjs,
  desktop_calls_default as DesktopCalls,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  divider_default as Divider,
  download_app_link_default as DownloadAppLink,
  drawer_default2 as Drawer,
  DrawerBody,
  DrawerHeader,
  drawer_default as DrawerMui,
  DrawerWrapper,
  EMAIL_REGEX,
  AstonishedFace_default as EmojiAstonishedFace,
  Fire_default as EmojiFire,
  HeartEyes_default as EmojiHeartEyes,
  TearsOfJoy_default as EmojiTearsOfJoy,
  ThinkingFace_default as EmojiThinkingFace,
  ThumbsDown_default as EmojiThumbsDown,
  ThumbsUp_default as EmojiThumbsUp,
  EnvContext,
  EnvProvider,
  Events2 as Events,
  fonts_default as FONTS,
  FONT_FAMILY,
  Fetch_default as Fetch,
  field_default as Field,
  select_default as FieldSelect,
  form_default as Form,
  access_code_default as FormAccessCode,
  FormComponent,
  conference_error_default as FormConferenceError,
  conference_restrictions_default as FormConferenceRestrictions,
  conference_waiting_default as FormConferenceWaiting,
  connect_error_default as FormConnectError,
  enter_conference_default as FormEnterConference,
  enter_conference_by_link_default as FormEnterConferenceByLink,
  enter_conference_error_default as FormEnterConferenceError,
  general_default as FormGeneral,
  provider_default2 as FormProvider,
  reset_password_default2 as FormResetPassword,
  reset_password_confirm_default2 as FormResetPasswordConfirm,
  SSO_forbidden_default as FormSSOForbidden,
  SSO_general_default as FormSSOGeneral,
  SSO_register_default as FormSSORegister,
  FormSection,
  sign_in_default2 as FormSignIn,
  sign_in_guest_default as FormSignInGuest,
  sign_up_default2 as FormSignUp,
  sign_up_confirm_default2 as FormSignUpConfirm,
  unregistered_default as FormUnregistered,
  unsupported_default as FormUnsupported,
  form_with_back_button_default as FormWithBackButton,
  FormWrapper,
  global_default as GlobalStyle,
  grid_default as Grid,
  INPUT_VIDEO_QUALITY,
  AccessDenied_default as IconAccessDenied,
  AddGroup_default as IconAddGroup,
  AddRound_default as IconAddRound,
  Apk_default as IconApk,
  ArrowBack_default as IconArrowBack,
  Attach_default as IconAttach,
  Attention_default as IconAttention,
  Book_default as IconBook,
  BreakoutRoomMain_default as IconBreakoutRoomMain,
  BreakoutRooms_default as IconBreakoutRooms,
  BrowserChrome_default as IconBrowserChrome,
  BrowserEdge_default as IconBrowserEdge,
  BrowserSafari_default as IconBrowserSafari,
  BrowserYandex_default as IconBrowserYandex,
  IconButton_default as IconButton,
  icon_button_copy_default as IconButtonCopy,
  ButtonLoader_default as IconButtonLoader,
  ButtonPip_default as IconButtonPip,
  icon_button_wrapper_default as IconButtonWrapper,
  Calendar_default as IconCalendar,
  Call_default as IconCall,
  CameraLoading_default as IconCameraLoading,
  CameraOff_default as IconCameraOff,
  CameraOn_default as IconCameraOn,
  CameraUnavailable_default as IconCameraUnavailable,
  Caution_default as IconCaution,
  Channel_default as IconChannel,
  Chat_default as IconChat,
  ChatBubbles_default as IconChatBubbles,
  ChatError_default as IconChatError,
  ChatNoMessages_default as IconChatNoMessages,
  ChatUnread_default as IconChatUnread,
  CheckRound_default as IconCheckRound,
  ChevronDown_default as IconChevronDown,
  ChevronLeft_default as IconChevronLeft,
  ChevronRight_default as IconChevronRight,
  ChevronUp_default as IconChevronUp,
  Clock_default as IconClock,
  Close_default as IconClose,
  CloseRound_default as IconCloseRound,
  Comments_default as IconComments,
  Copy_default as IconCopy,
  CopySuccess_default as IconCopySuccess,
  CopyText_default as IconCopyText,
  Cross_default as IconCross,
  Customize_default as IconCustomize,
  Delete_default as IconDelete,
  DeleteUser_default as IconDeleteUser,
  DesktopClose_default as IconDesktopClose,
  DesktopMaximize_default as IconDesktopMaximize,
  DesktopMenu_default as IconDesktopMenu,
  DesktopMinimize_default as IconDesktopMinimize,
  DesktopPIPHide_default as IconDesktopPIPHide,
  DesktopPIPShow_default as IconDesktopPIPShow,
  DesktopUnmaximize_default as IconDesktopUnmaximize,
  Dislike_default as IconDislike,
  Document_default as IconDocument,
  Download_default as IconDownload,
  DrawerShare_default as IconDrawerShare,
  Edit_default as IconEdit,
  Email_default as IconEmail,
  EmailSecond_default as IconEmailSecond,
  Error_default as IconError,
  ErrorTriangle_default as IconErrorTriangle,
  Exit_default as IconExit,
  Eye_default as IconEye,
  EyeClose_default as IconEyeClose,
  EyeOpen_default as IconEyeOpen,
  File_default as IconFile,
  Hand_default as IconHand,
  Image_default as IconImage,
  Info_default as IconInfo,
  InfoFill_default as IconInfoFill,
  InfoOutline_default as IconInfoOutline,
  InfoRound_default as IconInfoRound,
  Key_default as IconKey,
  Leave_default as IconLeave,
  Like_default as IconLike,
  Link_default as IconLink,
  LogoSymbol_default as IconLogoSymbol,
  MicLoading_default as IconMicLoading,
  MicOff_default as IconMicOff,
  MicOn_default as IconMicOn,
  MicUnavailable_default as IconMicUnavailable,
  MicVad_default as IconMicVad,
  MoreVertical_default as IconMoreVertical,
  NavCalls_default as IconNavCalls,
  NavChats_default as IconNavChats,
  NavRooms_default as IconNavRooms,
  NavSuperuserDashboard_default as IconNavSuperuserDashboard,
  NavVideo_default as IconNavVideo,
  NoDocument_default as IconNoDocument,
  People_default as IconPeople,
  Phone_default as IconPhone,
  Pin_default as IconPin,
  PinWhite_default as IconPinWhite,
  Play_default as IconPlay,
  PlayOutline_default as IconPlayOutline,
  Playlist_default as IconPlaylist,
  Plus_default as IconPlus,
  QRScan_default as IconQRScan,
  Question_default as IconQuestion,
  Random_default as IconRandom,
  Reactions_default as IconReactions,
  RecordRedCircle_default as IconRecordRedCircle,
  RecordStart_default as IconRecordStart,
  RecordStop_default as IconRecordStop,
  Report_default as IconReport,
  Review_default as IconReview,
  ScreenSharing_default as IconScreenSharing,
  ScreenSharingLoading_default as IconScreenSharingLoading,
  ScreenSharingUnavailable_default as IconScreenSharingUnavailable,
  Search_default as IconSearch,
  SecurityOnPermise_default as IconSecurityOnPermise,
  Send_default as IconSend,
  SendMessage_default as IconSendMessage,
  Settings_default as IconSettings,
  Share_default as IconShare,
  Shield_default as IconShield,
  SidebarPin_default as IconSidebarPin,
  SidebarUnpin_default as IconSidebarUnpin,
  Sorting_default as IconSorting,
  Speaker_default as IconSpeaker,
  Spinner_default as IconSpinner,
  SpinnerSmall_default as IconSpinnerSmall,
  Star_default as IconStar,
  StarOutline_default as IconStarOutline,
  StopCall_default as IconStopCall,
  Success_default as IconSuccess,
  Tick_default as IconTick,
  Trash_default as IconTrash,
  TriplePoints_default as IconTriplePoints,
  Update_default as IconUpdate,
  Upload_default as IconUpload,
  User_default as IconUser,
  Users_default as IconUsers,
  icon_validity_default as IconValidity,
  DataError_default as ImageDataError,
  EmptyChat_default as ImageEmptyChat,
  EmptyChatsList_default as ImageEmptyChatsList,
  EmptyConversation_default as ImageEmptyConversation,
  EmptyList_default as ImageEmptyList,
  EmptySearchList_default as ImageEmptySearchlist,
  EmptySelectedUsers_default as ImageEmptySelectedUsers,
  Logo_default as ImageLogo,
  PictureBulk_default as ImagePictureBulk,
  incoming_call_modal_default as IncomingCallPopover,
  InitSocket_default as InitSocket,
  light_default as LIGHT_THEME,
  link_default as Link,
  list_default as List,
  ListItemAvatar,
  ListItemTextUnstyled,
  ListItemUnstyled,
  ListScroller,
  ListUnstyled,
  ListWrapper,
  Listbox,
  loader_default as Loader,
  LoaderElement,
  LoadingElement,
  LocalStorage_default as LocalStorage,
  LocalizationDatePickerProvider,
  MIC_ITEM,
  main_default as MainLayout,
  menu_default as Menu,
  Metrics_default as Metrics,
  context_default as MetricsContext,
  provider_default as MetricsProvider,
  modal_default as Modal,
  ModalButtonsCaption,
  ModalCloseButton,
  modal_confirm_default as ModalConfirm,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalTitle,
  ModeratorManagement,
  modes_settings_default as ModesSettings,
  NAME_REGEX_LETTERS,
  NAME_REGEX_WORDS_NUM,
  NOISE_SUPRESSION,
  navigation_default as Navigation,
  new_pin_default as NewPin,
  Option,
  PASSWORD_REQUIREMENTS,
  pagination_default as Pagination,
  PascalCase,
  password_requirements_default as PasswordRequirements,
  popper_default as Popper,
  Quartile,
  QuartilePoints,
  REFERRER_TOKEN,
  REFRESH_TOKEN,
  Radio2 as Radio,
  RadioGroup,
  RadioLabel,
  reset_password_confirm_default as ResetPasswordConfirmForm,
  reset_password_default as ResetPasswordForm,
  room_info_report_default as RoomInfoReport,
  row_default as Row,
  SCREENSHARING_QUALITY,
  SIDEBAR_ITEMS,
  SIDEBAR_ITEMS_MAP,
  SIDEBAR_WHITELIST_LABELS,
  SUPPORT_MAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_WITH_SPACES,
  screen_default as ScreenLayout,
  ScreenShareBorder,
  ScreenShareControls,
  Screens,
  scroll_view_default as ScrollView,
  SearchEmpty_default as SearchEmpty,
  SearchError_default as SearchError,
  search_input_default as SearchInput,
  search_list_default as SearchList,
  SearchPeople_default as SearchPeople,
  section_list_default as SectionList,
  security_settings_default as SecuritySettings,
  Select,
  SelectField,
  SelectList,
  SelectOption,
  side_navigation_default as SideNavigation,
  Action_default as SideNavigationAction,
  SideNavigationCTA,
  SideNavigationCTAWrapper,
  PinButton_default as SideNavigationPinButton,
  SideNavigationWrapper,
  sidebar_default as Sidebar,
  SidebarLabel,
  sign_in_default as SignInForm,
  sign_up_confirm_default as SignUpConfirmForm,
  sign_up_default as SignUpForm,
  slider_default as Slider,
  spinner_default as Spinner,
  stack_default as Stack,
  StepBullet,
  StepContainer,
  StepInlineConnector,
  StepStuff,
  stepper_default as Stepper,
  StorySubstrate,
  StyledAction,
  StyledActionLabel,
  StyledBottomNavigation,
  StyledBottomNavigationAction,
  StyledForm,
  StyledFormWrapper,
  StyledGrid,
  StyledList,
  StyledListItem,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
  StyledMenu,
  StyledMenuItem,
  StyledModal,
  StyledPinButton,
  StyledStep,
  StyledStepper,
  StyledTextField,
  StyledVirtualizedList,
  TINY_SCROLLBAR_STYLES,
  tab_default as Tab,
  tabs_default as Tabs,
  textfield_default as TextField,
  text_field_copy_default as TextFieldCopy,
  ThemeProvider,
  TitleBar,
  toggle_setting_default as ToggleSetting,
  tooltip_default as Tooltip,
  Translate_default as Translate,
  typography_default as Typography,
  UserActions,
  user_agreement_default as UserAgreement,
  UserSelect,
  VIDEO_QUALITY,
  VIRTUAL_BACKGROUND,
  Item_default as VirtualizedItem,
  VirtualizedItemWrapper,
  virtualized_list_default as VirtualizedList,
  VirtualizedListScroller,
  VirtualizedListWrapper,
  item_default as WidgetUserItem,
  list_default2 as WidgetUserList,
  form_wrapper_default as WrapperForm,
  wrapper_settings_default as WrapperSettings,
  black,
  blue,
  browserName,
  checkIsDesktopActive,
  copy2Clipboard,
  createAudioPlayer,
  createCallsStore,
  createPolicyStore,
  createSidebarStore,
  dayjs,
  desktop,
  detect,
  detectOS,
  formatDate,
  formatDayTime,
  formatFileSize,
  formatHumanDayTimeline,
  formatHumanTime,
  formatHumanTimeline,
  formatMonthNameAndDate,
  formatRecordTime,
  formatUserPresense,
  genUUID,
  getCssVar,
  getFormComponent,
  getHumanTime,
  getImageUrl,
  getIsStepsEnd,
  getIsStepsStart,
  getNextStep,
  getNodeVersion,
  getPrevStep,
  getQuartile,
  getSizeUnit,
  getTheme,
  green,
  grey,
  hexToRgb,
  isAllowedBrowser,
  isAndroidDevice,
  isAppleDevice,
  isAuroraOS,
  isBrowserVersionSupported,
  isDeviceOS,
  isSafari,
  isWinDevice,
  map2CssVars,
  notReachable,
  parseApiError,
  parseUserAgent,
  pluralize,
  proxyMessage,
  red,
  sendClickDownloadVideo_default as sendClickDownloadVideo,
  sendClickShareUrl_default as sendClickShareUrl,
  sendClickSidebarElem_default as sendClickSidebarElem,
  sendPageView_default as sendPageView,
  sendPageViewChannelAllChannels_default as sendPageViewChannelAllChannels,
  sendPageViewChannelAllVideos_default as sendPageViewChannelAllVideos,
  sendPageViewChannelMyChannels_default as sendPageViewChannelMyChannels,
  sendPageViewHistory_default as sendPageViewHistory,
  sendPageViewOldSchool_default as sendPageViewOldSchool,
  sendPageViewVideo_default as sendPageViewVideo,
  sendPlayerClick10Bwd_default as sendPlayerClick10Bwd,
  sendPlayerClick10Fwd_default as sendPlayerClick10Fwd,
  sendPlayerClickFullscreen_default as sendPlayerClickFullscreen,
  sendPlayerClickPause_default as sendPlayerClickPause,
  sendPlayerClickPlay_default as sendPlayerClickPlay,
  sendPlayerClickQuality_default as sendPlayerClickQuality,
  sendPlayerClickSpeed_default as sendPlayerClickSpeed,
  sendPlayerClickWind_default as sendPlayerClickWind,
  sendPlayerQuartile_default as sendPlayerQuartile,
  sendSelectFilter_default as sendSelectFilter,
  sendSelectSorting_default as sendSelectSorting,
  sortDateDescending,
  sortDatesAscending,
  toCamelCase,
  toKebabCase,
  toSnakeCase,
  transform2CamelCase2 as transform2CamelCase,
  useChatsNotifications,
  useDebounce_default as useDebounce,
  useDesktopCompareVersion,
  useEnv_default as useEnv,
  useMenu_default as useMenu,
  useMetrics_default as useMetrics,
  useMissedCalls,
  useModal_default as useModal,
  select_default2 as useModalSelect,
  usePortal_default as usePortal,
  usePortionView_default as usePortionView,
  usePrevious_default as usePrevious,
  useScrollPagination,
  useSession,
  useSteps_default as useSteps,
  useUniqueList_default as useUniqueList,
  useWindowDimensions,
  validURL,
  white,
  yellow
};
/*! Bundled license information:

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

react-is/cjs/react-is.production.js:
  (**
   * @license React
   * react-is.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

@mui/styled-engine/index.js:
  (**
   * @mui/styled-engine v5.16.14
   *
   * @license MIT
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
